import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTimeType: any;
  DateType: any;
  DraftJsTextType: any;
  JSON: any;
  PropertyValue: any;
}

/** Enum for the possible statuses */
export enum ActionItemStatusEnumType {
  /** done */
  Done = 'DONE',
  /** not_started */
  NotStarted = 'NOT_STARTED',
  /** working_on_it */
  WorkingOnIt = 'WORKING_ON_IT'
}

/** An ActionItem */
export interface ActionItemType {
  __typename?: 'ActionItemType';
  assignee?: Maybe<UserType>;
  createdOn?: Maybe<Scalars['DateType']>;
  description?: Maybe<Scalars['DraftJsTextType']>;
  dueOn?: Maybe<Scalars['DateType']>;
  id: Scalars['ID'];
  internalNotesCount: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Array<NoteType>>;
  priority: PriorityEnumType;
  project?: Maybe<ProjectType>;
  relatedTask?: Maybe<TaskType>;
  startOn?: Maybe<Scalars['DateType']>;
  status: ActionItemStatusEnumType;
  tags?: Maybe<Array<TagType>>;
  visibility?: Maybe<ActionItemVisibilityEnumType>;
}

/** Enum for the possible ActionItem visibilities */
export enum ActionItemVisibilityEnumType {
  /** hidden */
  Hidden = 'HIDDEN',
  /** visible */
  Visible = 'VISIBLE'
}

/** A connection of activities */
export interface ActivityConnectionType {
  __typename?: 'ActivityConnectionType';
  activities?: Maybe<Array<ActivityType>>;
  pageInfo?: Maybe<PageInfoType>;
}

/** An activity */
export interface ActivityType {
  __typename?: 'ActivityType';
  createdAt?: Maybe<Scalars['DateType']>;
  id: Scalars['ID'];
  internalOnly?: Maybe<Scalars['Boolean']>;
  notificationType?: Maybe<NotificationTypeEnumType>;
  path?: Maybe<Scalars['String']>;
  project?: Maybe<ProjectType>;
  readAt?: Maybe<Scalars['DateType']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  user?: Maybe<ActivityUserType>;
  userNotRelevant?: Maybe<Scalars['Boolean']>;
}

/** Activity owner */
export type ActivityUserType = DefaultActivityOwnerType | SignerType | UserType;

/** Admin Team */
export interface AdminTeamType {
  checked?: InputMaybe<Scalars['Boolean']>;
  projectManagerId?: InputMaybe<Scalars['ID']>;
}

/** An AgentUser */
export interface AgentUserType {
  __typename?: 'AgentUserType';
  apiToken: Scalars['String'];
  id: Scalars['ID'];
  userId: Scalars['ID'];
}

export interface AnswerSurveyInput {
  answer?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  questionId: Scalars['ID'];
}

export interface AppliedProjectFilters {
  __typename?: 'AppliedProjectFilters';
  activeMilestoneNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  brandNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  cashValueRange?: Maybe<Array<Maybe<Scalars['Int']>>>;
  context?: Maybe<UserProjectOrganizationTypeEnumType>;
  customerIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  endOn?: Maybe<Scalars['DateType']>;
  filterDateBy?: Maybe<Scalars['String']>;
  lastUpdatedDays?: Maybe<Scalars['Int']>;
  projectFiltersOperator?: Maybe<ProjectFiltersOperators>;
  projectId?: Maybe<Scalars['ID']>;
  projectLateDays?: Maybe<Scalars['Int']>;
  projectManagerIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  startOn?: Maybe<Scalars['DateType']>;
  statuses?: Maybe<Array<Maybe<StatusEnumType>>>;
  strict?: Maybe<Scalars['Boolean']>;
  tags?: Maybe<Array<Maybe<Scalars['ID']>>>;
  templateIds?: Maybe<Array<Maybe<Scalars['String']>>>;
}

/** Enum for the possible Archive projects permissions */
export enum ArchiveProjectsPermissionsEnumType {
  /** admin_only */
  AdminOnly = 'ADMIN_ONLY',
  /** admin_or_pm */
  AdminOrPm = 'ADMIN_OR_PM',
  /** everyone */
  Everyone = 'EVERYONE'
}

/** A connection of assets */
export interface AssetConnectionType {
  __typename?: 'AssetConnectionType';
  assets?: Maybe<Array<FileType>>;
  pageInfo?: Maybe<PageInfoType>;
}

/** Enum for the possible assetable types */
export enum AssetableEnumType {
  /** blueprint_template */
  BlueprintTemplate = 'BLUEPRINT_TEMPLATE',
  /** milestone */
  Milestone = 'MILESTONE',
  /** project */
  Project = 'PROJECT',
  /** task */
  Task = 'TASK'
}

/** The parent of an asset is polymorphic */
export type AssetableType = MilestoneType | ProjectType | TaskType | TemplateType;

/** Autogenerated return type of AssignMessagingTokenToUser. */
export interface AssignMessagingTokenToUserPayload {
  __typename?: 'AssignMessagingTokenToUserPayload';
  user?: Maybe<UserType>;
}

/** a customer csat type */
export interface AverageMilestoneCsatType {
  __typename?: 'AverageMilestoneCsatType';
  averageMilestone?: Maybe<Scalars['Float']>;
}

/** A connection of billing_profiles */
export interface BillingProfileConnectionType {
  __typename?: 'BillingProfileConnectionType';
  billingProfiles?: Maybe<Array<BillingProfileType>>;
  pageInfo?: Maybe<PageInfoType>;
}

/** Whether a billing_profile name already exists in the database */
export interface BillingProfileNameExistsType {
  __typename?: 'BillingProfileNameExistsType';
  exists: Scalars['Boolean'];
}

/** A Billing Profile */
export interface BillingProfileType {
  __typename?: 'BillingProfileType';
  allottedHours?: Maybe<Scalars['Float']>;
  allowOverages?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  dollars?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationType>;
  organizationId?: Maybe<Scalars['ID']>;
  rateType?: Maybe<RateTypeEnum>;
  secondaryDollars?: Maybe<Scalars['Float']>;
  secondaryRateType?: Maybe<RateTypeEnum>;
}

/** A Brand */
export interface BrandType {
  __typename?: 'BrandType';
  headerLogo?: Maybe<ImageType>;
  id: Scalars['ID'];
  logo?: Maybe<ImageType>;
  name?: Maybe<Scalars['String']>;
  primaryColor?: Maybe<Scalars['String']>;
}

/**
 * The results of checking to see if a user can be deactivated.
 * User is safe to deactivate when task and project data is null.
 *
 */
export interface CanDeactivateUserResults {
  __typename?: 'CanDeactivateUserResults';
  projectData?: Maybe<ReassignData>;
  taskData?: Maybe<ReassignData>;
}

/** Filters for users capacity */
export interface CapacityFilterInput {
  endDate: Scalars['DateType'];
  myProjectsOnly?: InputMaybe<Scalars['Boolean']>;
  orderByDate?: InputMaybe<Scalars['DateType']>;
  pmItemsOnly?: InputMaybe<Scalars['Boolean']>;
  projectStatuses?: InputMaybe<Array<InputMaybe<ProjectStatusEnum>>>;
  startDate: Scalars['DateType'];
  taskStatuses?: InputMaybe<Array<InputMaybe<TaskStatusEnum>>>;
  /** This now functions the same as pm_items_only to filter the output in the TimeCapacityUsersScope */
  teamItemsOnly?: InputMaybe<Scalars['Boolean']>;
  userCapacities?: InputMaybe<Array<InputMaybe<UserCapacityEnum>>>;
  userSkills?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
}

/** Enum for the possible capacity group by */
export enum CapacityGroupByEnum {
  /** day */
  Day = 'DAY',
  /** week */
  Week = 'WEEK'
}

/** A user capacity hours */
export interface CapacityHoursInput {
  capacityHours: Scalars['Float'];
  userId: Scalars['ID'];
}

/** User capacity in a date period */
export interface CapacityType {
  __typename?: 'CapacityType';
  actualHours: Scalars['Float'];
  capacityHours: Scalars['Float'];
  endDate: Scalars['DateType'];
  indeterminate: Scalars['Boolean'];
  percentage?: Maybe<Scalars['Float']>;
  projectCount: Scalars['Float'];
  startDate: Scalars['DateType'];
  taskCount: Scalars['Float'];
}

/** Return value for checking the validation of an invitation token for a user. */
export interface CheckInvitationTokenType {
  __typename?: 'CheckInvitationTokenType';
  newToken?: Maybe<Scalars['Boolean']>;
  organization?: Maybe<OrganizationType>;
  project?: Maybe<ProjectType>;
  valid?: Maybe<Scalars['Boolean']>;
}

/** Arrays with completed and incomplete tasks */
export interface CompassProviderTasksByProjectType {
  __typename?: 'CompassProviderTasksByProjectType';
  completedTasks?: Maybe<TaskConnectionType>;
  incompleteTasks?: Maybe<TaskConnectionType>;
}

/** Templates by organization with pagination */
export interface Connections {
  __typename?: 'Connections';
  pageInfo?: Maybe<PageInfoType>;
  templates?: Maybe<Array<TemplateType>>;
}

/** Integration connector */
export interface Connector {
  __typename?: 'Connector';
  categories: Array<Scalars['String']>;
  connected: Scalars['Boolean'];
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  isNative?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
}

/** A user cost rate history */
export interface CostRateHistoryType {
  __typename?: 'CostRateHistoryType';
  costRate: Scalars['Float'];
  date: Scalars['DateType'];
}

/** Enum for the possible country code */
export enum CountryCodeEnumType {
  /** de */
  De = 'de',
  /** en */
  En = 'en',
  /** hi */
  Hi = 'hi',
  /** ja */
  Ja = 'ja',
  /** pt */
  Pt = 'pt',
  /** sv */
  Sv = 'sv',
  /** zh */
  Zh = 'zh'
}

export interface CreateEmailAnswerSurveyInput {
  answer?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  questionId: Scalars['ID'];
  surveyInviteId: Scalars['ID'];
}

/** Autogenerated return type of Create. */
export interface CreatePayload {
  __typename?: 'CreatePayload';
  note?: Maybe<NoteType>;
}

/** createProject's response containing created project and blueprints */
export interface CreateProjectResponseType {
  __typename?: 'CreateProjectResponseType';
  project?: Maybe<ProjectType>;
  templates?: Maybe<Array<TemplateType>>;
}

/** Enum for the possible currency code */
export enum CurrencyCodeEnumType {
  /** AUD */
  Aud = 'AUD',
  /** BRL */
  Brl = 'BRL',
  /** CAD */
  Cad = 'CAD',
  /** CHF */
  Chf = 'CHF',
  /** EUR */
  Eur = 'EUR',
  /** GBP */
  Gbp = 'GBP',
  /** INR */
  Inr = 'INR',
  /** JPY */
  Jpy = 'JPY',
  /** NZD */
  Nzd = 'NZD',
  /** RMB */
  Rmb = 'RMB',
  /** USD */
  Usd = 'USD'
}

/** Enum for the possible user task contexts */
export enum CurrentUserTaskContextEnumType {
  /** assignee */
  Assignee = 'ASSIGNEE',
  /** participant */
  Participant = 'PARTICIPANT'
}

/** A connection of custom_configurations */
export interface CustomConfigurationConnectionType {
  __typename?: 'CustomConfigurationConnectionType';
  customConfigurations?: Maybe<Array<CustomConfigurationType>>;
}

/** A Custom Configuration */
export interface CustomConfigurationType {
  __typename?: 'CustomConfigurationType';
  /** The custom configuration */
  configuration: Scalars['String'];
  /** The unique identifier for the layout */
  layoutIdentifier: Scalars['String'];
  /** The owner of the custom configuration */
  user?: Maybe<UserType>;
  /** The owner's ID of the custom configuration */
  userId?: Maybe<Scalars['ID']>;
}

/** A customer active project by status type for the widget in the customer dashboard */
export interface CustomerActiveProjectStatusType {
  __typename?: 'CustomerActiveProjectStatusType';
  activeProjects?: Maybe<Scalars['Int']>;
  projectManagerId?: Maybe<Scalars['ID']>;
  projectsDone?: Maybe<Scalars['Int']>;
  projectsLate?: Maybe<Scalars['Int']>;
  projectsOnHold?: Maybe<Scalars['Int']>;
  projectsOnTime?: Maybe<Scalars['Int']>;
  projectsTotalValue?: Maybe<Scalars['Int']>;
  v2CustomerId?: Maybe<Scalars['ID']>;
}

/** customer dashboard statuses enum type */
export enum CustomerDashboardStatusesEnumType {
  /** done */
  Done = 'DONE',
  /** late */
  Late = 'LATE',
  /** remaining */
  Remaining = 'REMAINING'
}

/** a customer in the global note view */
export interface CustomerNoteType {
  __typename?: 'CustomerNoteType';
  customer?: Maybe<OrganizationType>;
  customerV2?: Maybe<CustomerType>;
  note: NoteType;
  organization: OrganizationType;
}

/** A connection of projects from a customer */
export interface CustomerProjectConnectionType {
  __typename?: 'CustomerProjectConnectionType';
  pageInfo?: Maybe<PageInfoType>;
  paginatedProjects?: Maybe<Array<CustomerProjectType>>;
}

/** A project from a customer */
export interface CustomerProjectType {
  __typename?: 'CustomerProjectType';
  averageMilestone?: Maybe<Scalars['Float']>;
  endOn?: Maybe<Scalars['DateType']>;
  /** Dynamic date calculated from project plan dates and dependencies */
  forecastedEndOn?: Maybe<Scalars['DateType']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  projectManager?: Maybe<UserType>;
  startOn?: Maybe<Scalars['DateType']>;
  status?: Maybe<StatusEnumType>;
}

/** Customer task status type for the widget in the customer dashboard */
export interface CustomerTaskStatusType {
  __typename?: 'CustomerTaskStatusType';
  done: Scalars['Float'];
  late: Scalars['Float'];
  remaining: Scalars['Float'];
  total: Scalars['Float'];
}

/** A customer type object */
export interface CustomerType {
  __typename?: 'CustomerType';
  activeProjects?: Maybe<Scalars['Int']>;
  averageCsat?: Maybe<AverageMilestoneCsatType>;
  cashValue?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  forecastedEndDate?: Maybe<ForecasteEndDate>;
  id: Scalars['ID'];
  lateProjects?: Maybe<Scalars['Int']>;
  logo?: Maybe<ImageType>;
  name: Scalars['String'];
  /** Resolver to get all the team members for a customer */
  paginatedTeamMembers?: Maybe<PaginatedUsersType>;
  phone?: Maybe<Scalars['String']>;
  primaryContactName?: Maybe<Scalars['String']>;
}


/** A customer type object */
export interface CustomerTypePaginatedTeamMembersArgs {
  listInput?: InputMaybe<ListInput>;
}

/** a customer user in the global note view */
export interface CustomerUserNoteType {
  __typename?: 'CustomerUserNoteType';
  note: NoteType;
  organization: OrganizationType;
}

/** Dashboard values for different charts */
export interface DashboardType {
  __typename?: 'DashboardType';
  activeProjects?: Maybe<Scalars['Int']>;
  blueprintTemplateId?: Maybe<Scalars['ID']>;
  lastUpdateBetween1and3Days?: Maybe<Scalars['Int']>;
  lastUpdateBetween4and7Days?: Maybe<Scalars['Int']>;
  lastUpdateGreaterThan8Days?: Maybe<Scalars['Int']>;
  /** returns the max amount of cash value on the whole project set */
  maxCashValue?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['ID']>;
  projectCashValue?: Maybe<Scalars['Int']>;
  projectDoneTasks?: Maybe<Scalars['Int']>;
  projectEndOnMonth?: Maybe<Scalars['String']>;
  projectId?: Maybe<Scalars['ID']>;
  projectManagerAvatar?: Maybe<ImageType>;
  projectManagerCapacity?: Maybe<Scalars['Int']>;
  projectManagerFirstName?: Maybe<Scalars['String']>;
  projectManagerId?: Maybe<Scalars['ID']>;
  projectManagerLastName?: Maybe<Scalars['String']>;
  projectName?: Maybe<Scalars['String']>;
  projectProjectedEndOnMonth?: Maybe<Scalars['String']>;
  projectStatus?: Maybe<StatusEnumType>;
  projectTotalTasks?: Maybe<Scalars['Int']>;
  projectsLate?: Maybe<Scalars['Int']>;
  projectsOnHold?: Maybe<Scalars['Int']>;
  projectsOnTime?: Maybe<Scalars['Int']>;
  projectsTotalValue?: Maybe<Scalars['Int']>;
  templateName?: Maybe<Scalars['String']>;
  totalProjects?: Maybe<Scalars['Int']>;
}

/** The results of reassigning tasks and/or projects, and deactivating user. */
export interface DeactivateUserResults {
  __typename?: 'DeactivateUserResults';
  deactivating: Scalars['Boolean'];
  user?: Maybe<UserType>;
}

/** The default activity performer - not an actual user */
export interface DefaultActivityOwnerType {
  __typename?: 'DefaultActivityOwnerType';
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
}

/** delete file from object input */
export interface DeleteFileFromObjectInput {
  id: Scalars['ID'];
}

/** Autogenerated return type of DeleteFileFromObject. */
export interface DeleteFileFromObjectPayload {
  __typename?: 'DeleteFileFromObjectPayload';
  files?: Maybe<Array<Maybe<FileType>>>;
}

/** delete file input */
export interface DeleteFileInput {
  id: Scalars['ID'];
}

/** Autogenerated return type of DeleteFile. */
export interface DeleteFilePayload {
  __typename?: 'DeleteFilePayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** Autogenerated return type of DeleteFileS3. */
export interface DeleteFileS3Payload {
  __typename?: 'DeleteFileS3Payload';
  success?: Maybe<Scalars['Boolean']>;
}

/** What you get when you delete a milestone */
export interface DeleteMilestoneReturnType {
  __typename?: 'DeleteMilestoneReturnType';
  milestones?: Maybe<Array<MilestoneType>>;
  projectStats?: Maybe<ProjectStats>;
  templateStats?: Maybe<TemplateStats>;
}

/** What you get when you delete a task group */
export interface DeleteTaskGroupReturnType {
  __typename?: 'DeleteTaskGroupReturnType';
  milestone?: Maybe<MilestoneType>;
  projectStats?: Maybe<ProjectStats>;
  taskGroups?: Maybe<Array<TaskGroupType>>;
  tasks?: Maybe<Array<TaskType>>;
  templateStats?: Maybe<TemplateStats>;
}

/** A summary of the dependency violations found after a drag and drop movement */
export interface DependencyCheckResponseType {
  __typename?: 'DependencyCheckResponseType';
  /** whether one or more tasks have a dependency violation */
  hasViolations: Scalars['Boolean'];
  /** The new sort_order value of the entity to be moved */
  newSortOrder: Scalars['Float'];
  /** An list of task's that have a dependency violation */
  taskDependencyViolationList: Array<DependencyViolationItemType>;
  /** the number of tasks with a dependency violation */
  violationCount: Scalars['Float'];
}

/** Enum for the possible dependency types */
export enum DependencyEnumType {
  /** milestone */
  Milestone = 'MILESTONE',
  /** task */
  Task = 'TASK',
  /** task_group */
  TaskGroup = 'TASK_GROUP',
  /** template */
  Template = 'TEMPLATE'
}

/** Enum for the possible dependency */
export enum DependencyStatusEnumType {
  /** complete */
  Complete = 'COMPLETE',
  /** incomplete */
  Incomplete = 'INCOMPLETE',
  /** no_depedency */
  NoDependency = 'NO_DEPENDENCY'
}

/** A return type for a task dependency */
export type DependencyType = MilestoneType | TaskGroupType | TaskType | TemplateType;

/** A single dependency violation summary item */
export interface DependencyViolationItemType {
  __typename?: 'DependencyViolationItemType';
  /** A task id that had a dependency removed */
  id: Scalars['ID'];
  /** The name of a task that had a dependency removed */
  name?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of DestroyAttachment. */
export interface DestroyAttachmentPayload {
  __typename?: 'DestroyAttachmentPayload';
  note?: Maybe<NoteType>;
}

/** Autogenerated return type of Destroy. */
export interface DestroyPayload {
  __typename?: 'DestroyPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** An display organization for reppin other brands */
export interface DisplayOrganizationType {
  __typename?: 'DisplayOrganizationType';
  logo?: Maybe<ImageType>;
  name: Scalars['String'];
}

/** An additional dollars history */
export interface DollarsHistory {
  __typename?: 'DollarsHistory';
  date: Scalars['DateType'];
  dollars: Scalars['Float'];
}

/** Organization domain verification record */
export interface DomainVerificationRecordsType {
  __typename?: 'DomainVerificationRecordsType';
  domain?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  record1?: Maybe<Scalars['String']>;
  record2?: Maybe<Scalars['String']>;
  record3?: Maybe<Scalars['String']>;
  sendgridWhitelabelId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
}

/** Check for whether task or milestone can be dropped with a message */
export interface DropEligibilityType {
  __typename?: 'DropEligibilityType';
  eligibility?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
}

export interface DropInput {
  destinationDroppableId?: InputMaybe<Scalars['ID']>;
  destinationDroppableIndex?: InputMaybe<Scalars['ID']>;
  destinationIndex: Scalars['ID'];
  draggableId: Scalars['ID'];
  type: Scalars['String'];
}

/** A search from admin panel */
export interface ElasticCustomerType {
  __typename?: 'ElasticCustomerType';
  logoUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
}

/** A global search dependency */
export interface ElasticDependencyType {
  __typename?: 'ElasticDependencyType';
  completed?: Maybe<Scalars['Boolean']>;
  dependencyType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
}

/** A global search note */
export interface ElasticNoteType {
  __typename?: 'ElasticNoteType';
  createdAt?: Maybe<Scalars['Int']>;
  noteable?: Maybe<ElasticNoteableType>;
  organizationId?: Maybe<Scalars['Int']>;
  project?: Maybe<ElasticProjectType>;
  projectId?: Maybe<Scalars['Int']>;
  projectWebPath?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
}

/** The parent of a note is polymorphic */
export type ElasticNoteableType = ElasticProjectType | ElasticTaskType;

/** A global search project */
export interface ElasticProjectType {
  __typename?: 'ElasticProjectType';
  createdAt?: Maybe<Scalars['Int']>;
  customer?: Maybe<ElasticCustomerType>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  projectId?: Maybe<Scalars['Int']>;
  projectManagerFullName?: Maybe<Scalars['String']>;
  status?: Maybe<StatusEnumType>;
  webPath?: Maybe<Scalars['String']>;
}

/** A global search task */
export interface ElasticTaskType {
  __typename?: 'ElasticTaskType';
  assigneeFullName?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateType']>;
  dependency?: Maybe<ElasticDependencyType>;
  dependencyRate?: Maybe<Scalars['Int']>;
  dueOn?: Maybe<Scalars['DateType']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  overdue?: Maybe<Scalars['Int']>;
  project?: Maybe<ElasticProjectType>;
  projectId?: Maybe<Scalars['Int']>;
  projectWebPath?: Maybe<Scalars['String']>;
  status?: Maybe<StatusEnumType>;
}

/** Input to update an entity for a Gantt chart */
export interface EntityData {
  __typename?: 'EntityData';
  assigneeId?: Maybe<Scalars['ID']>;
  dueOn?: Maybe<Scalars['DateType']>;
  duration?: Maybe<Scalars['Int']>;
  estimatedHours?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  priority?: Maybe<PriorityEnumType>;
  responsibility?: Maybe<TaskResponsibilityEnumType>;
  startOn?: Maybe<Scalars['DateType']>;
  status?: Maybe<StatusEnumType>;
  visibility?: Maybe<TaskVisibilityEnumType>;
}

/** Expected return when updating a Gantt entity */
export interface EntityReturnType {
  __typename?: 'EntityReturnType';
  data?: Maybe<EntityData>;
  entity?: Maybe<GanttEntity>;
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
}

export interface FileInput {
  /** This can be an hyperlink or a reference to our CDN */
  externalLink?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  internalOnly?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Scalars['Float']>;
}

/** A file */
export interface FileType {
  __typename?: 'FileType';
  assetable?: Maybe<AssetableType>;
  createdAt?: Maybe<Scalars['DateType']>;
  deletable?: Maybe<Scalars['Boolean']>;
  externalLink?: Maybe<Scalars['String']>;
  fileName: Scalars['String'];
  id: Scalars['ID'];
  internalOnly: Scalars['Boolean'];
  isExternalHyperlink?: Maybe<Scalars['Boolean']>;
  milestoneName?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  sortOrder?: Maybe<Scalars['Float']>;
  taskName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateType']>;
  uploader?: Maybe<UserType>;
  /** @deprecated Use uploader instead */
  uploaderUser?: Maybe<UserType>;
  url?: Maybe<Scalars['String']>;
}

/** Input type for filter Action Items */
export interface FiltersInput {
  assigneeIds?: InputMaybe<Array<Scalars['ID']>>;
  endOn?: InputMaybe<Scalars['DateType']>;
  filterDateBy?: InputMaybe<Scalars['String']>;
  hasNotes?: InputMaybe<Scalars['Boolean']>;
  priority?: InputMaybe<Array<PriorityEnumType>>;
  relatedTaskIds?: InputMaybe<Array<Scalars['ID']>>;
  startOn?: InputMaybe<Scalars['DateType']>;
  statuses?: InputMaybe<Array<StatusEnumType>>;
  visibility?: InputMaybe<Array<ActionItemVisibilityEnumType>>;
}

/** Filter Operator */
export interface FiltersOperatorType {
  milestoneOperator?: InputMaybe<OperatorEnumType>;
  tagOperator?: InputMaybe<OperatorEnumType>;
  templateOperator?: InputMaybe<OperatorEnumType>;
}

/** latest forecasted end date for in flight customer projects */
export interface ForecasteEndDate {
  __typename?: 'ForecasteEndDate';
  projectedEndOn?: Maybe<Scalars['DateType']>;
}

/** Global settings for Gainsight integration */
export interface GainsightSettings {
  __typename?: 'GainsightSettings';
  id?: Maybe<Scalars['ID']>;
  syncProjectNotesToActivityTimeline?: Maybe<Scalars['Boolean']>;
  syncTaskToCta?: Maybe<Scalars['Boolean']>;
}

/** a connection to the Gantt Chart Timeline View */
export interface GanttChartConnectionType {
  __typename?: 'GanttChartConnectionType';
  dependency?: Maybe<DependencyType>;
  dueOn?: Maybe<Scalars['DateType']>;
  duration?: Maybe<Scalars['Int']>;
  endDate?: Maybe<Scalars['DateType']>;
  expanded: Scalars['Boolean'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  percentDone?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['DateType']>;
  taskGroups?: Maybe<Array<TaskGroupType>>;
  tasksAndGroups?: Maybe<Array<TaskAndGroupType>>;
  tasksWithoutGroups?: Maybe<Array<TaskType>>;
}

/** The return type can be a Task, Milestone, or Task Group */
export type GanttEntity = MilestoneType | TaskGroupType | TaskType;

export interface GlobalSearchModelInput {
  from: Scalars['Int'];
  modelName: Scalars['String'];
  size: Scalars['Int'];
}

/** An array of nodes of different types for global search results */
export type GlobalSearchResultNodeType = ElasticNoteType | ElasticProjectType | ElasticTaskType;

/** A global search result object */
export interface GlobalSearchResultType {
  __typename?: 'GlobalSearchResultType';
  nodes?: Maybe<Array<GlobalSearchResultNodeType>>;
  total?: Maybe<Scalars['Int']>;
}

/** A search from admin panel */
export interface GlobalSearchType {
  __typename?: 'GlobalSearchType';
  keyword?: Maybe<Scalars['String']>;
  notes?: Maybe<GlobalSearchResultType>;
  projects?: Maybe<GlobalSearchResultType>;
  tasks?: Maybe<GlobalSearchResultType>;
}

/** A hubSpot Integration object */
export interface HubspotIntegrationType {
  __typename?: 'HubspotIntegrationType';
  hubSpotPortalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
}

/** Identity Provider */
export interface IdentityProviderType {
  __typename?: 'IdentityProviderType';
  active: Scalars['Boolean'];
  attributeConsumeServiceEndpoint: Scalars['String'];
  certificate?: Maybe<Scalars['String']>;
  entityId: Scalars['String'];
  id: Scalars['ID'];
  issuer?: Maybe<Scalars['String']>;
  jitProvisioning: Scalars['Boolean'];
  strictMode: Scalars['Boolean'];
  targetUrl?: Maybe<Scalars['String']>;
}

/** An image */
export interface ImageType {
  __typename?: 'ImageType';
  originalUrl?: Maybe<Scalars['String']>;
}

/** ImporterHistory. */
export interface ImporterHistory {
  __typename?: 'ImporterHistory';
  createdAt?: Maybe<Scalars['DateType']>;
  fileName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  organization?: Maybe<OrganizationType>;
  status?: Maybe<ImporterHistoryStatusType>;
  uploadType?: Maybe<ImporterHistoryUploadType>;
  user?: Maybe<UserType>;
}

/** Enum for the possible importer history status type */
export enum ImporterHistoryStatusType {
  /** creating */
  Creating = 'CREATING',
  /** done */
  Done = 'DONE',
  /** failed */
  Failed = 'FAILED'
}

/** Enum for the possible importer history upload type */
export enum ImporterHistoryUploadType {
  /** project */
  Project = 'PROJECT',
  /** template */
  Template = 'TEMPLATE'
}

/** Enum for the possible info fields types */
export enum InfoFieldsEnum {
  /** merge_tag */
  MergeTag = 'MERGE_TAG'
}

/** Enum for the possible device types */
export enum InstallationDeviceTypeEnum {
  /** android */
  Android = 'ANDROID',
  /** ios */
  Ios = 'IOS'
}

/** An Installation */
export interface InstallationType {
  __typename?: 'InstallationType';
  deviceToken?: Maybe<Scalars['String']>;
  deviceType?: Maybe<InstallationDeviceTypeEnum>;
  id: Scalars['ID'];
}

/** Return value for checking on a user invitation acceptance. */
export interface InvitationCheckType {
  __typename?: 'InvitationCheckType';
  hasAccepted?: Maybe<Scalars['Boolean']>;
}

/** Paginated projects from the Jira API */
export interface JiraApiPaginatedProjectType {
  __typename?: 'JiraAPIPaginatedProjectType';
  defaultProject?: Maybe<JiraApiProjectType>;
  pageInfo: PaginatedProjectsPageInfoType;
  projects: Array<JiraApiProjectType>;
}

/** Issue priorities from Jira API */
export interface JiraApiPriorityType {
  __typename?: 'JiraAPIPriorityType';
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
}

/** Projects from the Jira API */
export interface JiraApiProjectType {
  __typename?: 'JiraAPIProjectType';
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  issueTypes: Array<JiraApiIssueType>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
}

/** Statuses from Jira API */
export interface JiraApiStatusType {
  __typename?: 'JiraAPIStatusType';
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
}

/** Component from Jira API */
export interface JiraApiComponentType {
  __typename?: 'JiraApiComponentType';
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
}

/** Issue types from Jira API */
export interface JiraApiIssueType {
  __typename?: 'JiraApiIssueType';
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
}

/** A Jira Epic available to this integration */
export interface JiraEpic {
  __typename?: 'JiraEpic';
  id: Scalars['String'];
  key: Scalars['String'];
}

/** Enum for formatting jira epic names */
export enum JiraEpicFormatEnumType {
  /** postfix */
  Postfix = 'POSTFIX',
  /** prefix */
  Prefix = 'PREFIX',
  /** project_name */
  ProjectName = 'PROJECT_NAME'
}

/** Jira integration */
export interface JiraIntegrationType {
  __typename?: 'JiraIntegrationType';
  /** Fetches all issue types from jira API */
  apiIssueTypes?: Maybe<Array<JiraApiIssueType>>;
  /** Fetches paginated projects from the Jira API */
  apiPaginatedProjects?: Maybe<JiraApiPaginatedProjectType>;
  /** Fetches all issue priorities from jira API */
  apiPriorities?: Maybe<Array<JiraApiPriorityType>>;
  /** Fetches all project components from jira API */
  apiProjectComponents?: Maybe<Array<JiraApiComponentType>>;
  /** Fetches all issue statuses from jira API */
  apiProjectStatuses?: Maybe<Array<JiraApiStatusType>>;
  /** Fetches all projects from the Jira API */
  apiProjects?: Maybe<Array<JiraApiProjectType>>;
  defaultIssueTypeId?: Maybe<Scalars['String']>;
  defaultProjectId?: Maybe<Scalars['String']>;
  epicFormat?: Maybe<JiraEpicFormatEnumType>;
  epicFormatValue?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  issueFormat?: Maybe<JiraIssueFormatEnumType>;
  priorities?: Maybe<Array<JiraPriorityType>>;
  siteId: Scalars['String'];
  siteName: Scalars['String'];
  siteUrl: Scalars['String'];
  /** Fetches configured status settings for a given jira project */
  statuses?: Maybe<Array<JiraStatusType>>;
}


/** Jira integration */
export interface JiraIntegrationTypeApiPaginatedProjectsArgs {
  listInput?: InputMaybe<ListPaginatedProjectsInput>;
}


/** Jira integration */
export interface JiraIntegrationTypeApiProjectComponentsArgs {
  projectId: Scalars['String'];
}


/** Jira integration */
export interface JiraIntegrationTypeApiProjectStatusesArgs {
  projectId: Scalars['String'];
}


/** Jira integration */
export interface JiraIntegrationTypeStatusesArgs {
  projectId?: InputMaybe<Scalars['String']>;
}

/** Enum for formatting jira issue names */
export enum JiraIssueFormatEnumType {
  /** brand_prefix */
  BrandPrefix = 'BRAND_PREFIX',
  /** name_only */
  NameOnly = 'NAME_ONLY',
  /** project_prefix */
  ProjectPrefix = 'PROJECT_PREFIX'
}

export interface JiraIssueInputType {
  components?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalId?: InputMaybe<Scalars['String']>;
  externalProjectId?: InputMaybe<Scalars['String']>;
  externalTypeId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
}

/** Jira issue */
export interface JiraIssueType {
  __typename?: 'JiraIssueType';
  components?: Maybe<Array<Scalars['String']>>;
  createdInJira?: Maybe<Scalars['DateType']>;
  externalId?: Maybe<Scalars['String']>;
  externalProjectId?: Maybe<Scalars['String']>;
  externalTypeId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  key?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
}

/** Paginated Jira projects */
export interface JiraPaginatedProjectType {
  __typename?: 'JiraPaginatedProjectType';
  pageInfo: PaginatedProjectsPageInfoType;
  projects: Array<JiraProject>;
}

/** A priority that a Jira issue can have */
export interface JiraPriority {
  __typename?: 'JiraPriority';
  id: Scalars['String'];
  name: Scalars['String'];
}

export interface JiraPriorityInput {
  high?: InputMaybe<Scalars['String']>;
  low?: InputMaybe<Scalars['String']>;
  medium?: InputMaybe<Scalars['String']>;
}

export interface JiraPriorityInputType {
  externalId: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  value: PriorityEnumType;
}

/** Map of GuideCX priorities to Jira priority IDs */
export interface JiraPriorityMap {
  __typename?: 'JiraPriorityMap';
  high?: Maybe<Scalars['String']>;
  low?: Maybe<Scalars['String']>;
  medium?: Maybe<Scalars['String']>;
}

/** Jira priority setting type for Jira integrations */
export interface JiraPriorityType {
  __typename?: 'JiraPriorityType';
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  value?: Maybe<PriorityEnumType>;
}

/** A Jira project available to this integration */
export interface JiraProject {
  __typename?: 'JiraProject';
  id: Scalars['String'];
  key: Scalars['String'];
  name: Scalars['String'];
}

/** Enum for pushing a GuideCX project as a Jira project or a Jira epic */
export enum JiraPushAsEnumType {
  /** epic */
  Epic = 'EPIC',
  /** project */
  Project = 'PROJECT'
}

/** Global settings for Jira integration */
export interface JiraSettings {
  __typename?: 'JiraSettings';
  epicFormat?: Maybe<JiraEpicFormatEnumType>;
  epicFormatValue?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  issueFormat?: Maybe<JiraIssueFormatEnumType>;
  issueTypeId?: Maybe<Scalars['String']>;
  issueTypeName?: Maybe<Scalars['String']>;
  priorities?: Maybe<JiraPriorityMap>;
  projectId?: Maybe<Scalars['String']>;
  projectKey?: Maybe<Scalars['String']>;
  projectName?: Maybe<Scalars['String']>;
  pushAs?: Maybe<JiraPushAsEnumType>;
  statuses?: Maybe<JiraStatusMap>;
}

/** A status that a Jira issue can have */
export interface JiraStatus {
  __typename?: 'JiraStatus';
  name: Scalars['String'];
}

export interface JiraStatusInput {
  done?: InputMaybe<Scalars['String']>;
  notStarted?: InputMaybe<Scalars['String']>;
  stuck?: InputMaybe<Scalars['String']>;
  workingOnIt?: InputMaybe<Scalars['String']>;
}

export interface JiraStatusInputType {
  externalId: Scalars['String'];
  externalProjectId: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  value: StatusEnumType;
}

/** Map of GuideCX statuses to Jira status IDs */
export interface JiraStatusMap {
  __typename?: 'JiraStatusMap';
  done?: Maybe<Scalars['String']>;
  notStarted?: Maybe<Scalars['String']>;
  stuck?: Maybe<Scalars['String']>;
  workingOnIt?: Maybe<Scalars['String']>;
}

/** Status setting type for Jira integrations */
export interface JiraStatusType {
  __typename?: 'JiraStatusType';
  externalId?: Maybe<Scalars['String']>;
  externalProjectId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  value?: Maybe<StatusEnumType>;
}

/** A SharePoint list */
export interface List {
  __typename?: 'List';
  id: Scalars['ID'];
  name: Scalars['String'];
}

export interface ListInput {
  allMessages?: InputMaybe<Scalars['Boolean']>;
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  paginated?: InputMaybe<Scalars['Boolean']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<SortByEnumType>;
  sortDirection?: InputMaybe<SortDirectionEnumType>;
  startFromId?: InputMaybe<Scalars['ID']>;
}

/** List Input type v2 */
export interface ListInputTypeV2 {
  allMessages?: InputMaybe<Scalars['Boolean']>;
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  paginated?: InputMaybe<Scalars['Boolean']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<SortByEnumType>;
  sortDirection?: InputMaybe<SortDirectionEnumType>;
}

export interface ListPaginatedProjectsInput {
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<SortByEnumType>;
}

/** The input type for merging customers in Customer Dashboard */
export interface MergeCustomersInputType {
  /** ID of the customer to delete/merge from */
  customerToDeleteId: Scalars['ID'];
  /** ID of the customer to reassign projects to */
  reassignToCustomerId: Scalars['ID'];
}

/** A merge tag */
export interface MergeTag {
  __typename?: 'MergeTag';
  external?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
  sortOrder: Scalars['Float'];
}

/** Merge Tags for templates, projects or tasks */
export interface MergeTagType {
  __typename?: 'MergeTagType';
  external: Scalars['Boolean'];
  key: Scalars['String'];
  name: Scalars['String'];
  value?: Maybe<Scalars['String']>;
}

/** Enum for the merge taggables */
export enum MergeTaggable {
  /** action_item */
  ActionItem = 'ACTION_ITEM',
  /** project */
  Project = 'PROJECT',
  /** task */
  Task = 'TASK',
  /** template */
  Template = 'TEMPLATE'
}

/** Enum for the merge taggables */
export enum MergeTaggableType {
  /** action_item */
  ActionItem = 'ACTION_ITEM',
  /** task */
  Task = 'TASK',
  /** template */
  Template = 'TEMPLATE'
}

/** A milestone summary bank */
export interface MilestoneStats {
  __typename?: 'MilestoneStats';
  /** The number of whole days it will take for the milestone to be complete calculating based on the lowest start date and highest due date, only accounting for business days. NOTE: This is a direct pull from the milestone.duration, check there for calculation details */
  duration?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  /** This is value is true when a milestone has 0 incomplete tasks that are not marked as irrelevant (and not deleted) and at least 1 not-deleted task (regardless of relevance status) */
  milestoneIsComplete?: Maybe<Scalars['Boolean']>;
  /** Whether the milestone has any late-tasks */
  milestoneIsLate?: Maybe<Scalars['Boolean']>;
  /** Total, not-deleted, tasks with a status of "Complete" */
  totalCompleteTasks?: Maybe<Scalars['Int']>;
  /** Total, not-deleted, tasks without a status of "Not Applicable" or "Complete" that have a due date, and the due-date is before today's date */
  totalLateTasks?: Maybe<Scalars['Int']>;
  /** Total, not-deleted, tasks without a status of "Not Applicable" or "Complete" */
  totalRemainingTasks?: Maybe<Scalars['Int']>;
  /** Total, not-deleted, tasks without a status of "Not Applicable" */
  totalTasks?: Maybe<Scalars['Int']>;
}

/** Enum for the possible milestones statuses */
export enum MilestoneStatusEnumType {
  /** complete */
  Complete = 'COMPLETE',
  /** in_progress */
  InProgress = 'IN_PROGRESS',
  /** not_started */
  NotStarted = 'NOT_STARTED'
}

/** A milestone */
export interface MilestoneType {
  __typename?: 'MilestoneType';
  active: Scalars['Boolean'];
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateType']>;
  completionMessage?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateType']>;
  dependentTasks?: Maybe<Array<TaskType>>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  enableCompletionNotification?: Maybe<Scalars['Boolean']>;
  enableSendSurvey?: Maybe<Scalars['Boolean']>;
  files?: Maybe<Array<FileType>>;
  forecastedEndOn?: Maybe<Scalars['DateType']>;
  id: Scalars['ID'];
  isFirstOfProject: Scalars['Boolean'];
  isFirstOfTemplate: Scalars['Boolean'];
  name: Scalars['String'];
  /** Get your paginated tasks here */
  paginatedTasks: PaginatedTasks;
  project?: Maybe<ProjectType>;
  projectName?: Maybe<Scalars['String']>;
  sortOrder: Scalars['Float'];
  startedOn?: Maybe<Scalars['DateType']>;
  status: MilestoneStatusEnumType;
  summaryBank: MilestoneStats;
  taskCount: Scalars['Int'];
  taskGroups?: Maybe<Array<TaskGroupType>>;
  tasks?: Maybe<Array<TaskType>>;
  tasksAndGroups?: Maybe<Array<TaskAndGroupType>>;
  tasksWithoutGroups?: Maybe<Array<TaskType>>;
  template: TemplateType;
  timeReport: TimeReport;
  updatedAt?: Maybe<Scalars['DateType']>;
}


/** A milestone */
export interface MilestoneTypePaginatedTasksArgs {
  endDate?: InputMaybe<Scalars['DateType']>;
  filters?: InputMaybe<TimeReportFiltersInput>;
  listInputs: ListInput;
  startDate?: InputMaybe<Scalars['DateType']>;
}


/** A milestone */
export interface MilestoneTypeTaskCountArgs {
  taskResponsibilities?: InputMaybe<Array<TaskResponsibilityEnumType>>;
}


/** A milestone */
export interface MilestoneTypeTimeReportArgs {
  endDate: Scalars['DateType'];
  filters?: InputMaybe<TimeReportFiltersInput>;
  startDate: Scalars['DateType'];
}

/** Milestone subscription payload, includes stats as well */
export interface MilestoneUpdatePayloadType {
  __typename?: 'MilestoneUpdatePayloadType';
  milestone?: Maybe<MilestoneType>;
  milestoneStats?: Maybe<MilestoneStats>;
}

/** Monthly completed project data used in Project Trends */
export interface MonthlyCompletedProjectDurationData {
  __typename?: 'MonthlyCompletedProjectDurationData';
  averageDays?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['String']>;
  projectCount?: Maybe<Scalars['Int']>;
}

/** Monthly revenue data used in Project Trends */
export interface MonthlyProjectCompletionDataType {
  __typename?: 'MonthlyProjectCompletionDataType';
  month?: Maybe<Scalars['String']>;
  projectCount?: Maybe<Scalars['Int']>;
  revenue?: Maybe<Scalars['Int']>;
}

/** Monthly amount data generated by time entries */
export interface MonthlyTimeTrackedDataType {
  __typename?: 'MonthlyTimeTrackedDataType';
  billableAmount: Scalars['Float'];
  month?: Maybe<Scalars['String']>;
  totalHours: Scalars['Float'];
}

/** The inputs required to move a milestone */
export interface MoveMilestoneInput {
  /** The public id of the closest milestone to be moved near */
  closestMilestoneId: Scalars['ID'];
  /** The public id of the milestone to be moved */
  milestoneIdToMove: Scalars['ID'];
  /** a qualifier of "before" or "after" */
  positionQualifier: PositionQualifierEnum;
}

export interface Mutation {
  __typename?: 'Mutation';
  /** Accept invite by completing user profile */
  acceptInvitation?: Maybe<AcceptInvitationPayload>;
  /** Export all the action items for a company */
  actionItemsExport?: Maybe<ActionItemsExportPayload>;
  /** Adds a new customer user without an organization or project */
  addBasicCustomerUser?: Maybe<AddBasicCustomerUserPayload>;
  /** Adds a new or existing customer user to a project */
  addCustomerUsersToProject?: Maybe<AddCustomerUsersToProjectPayload>;
  /** Adds a customer users to a project */
  addCustomerUsersV2?: Maybe<AddCustomerUsersV2Payload>;
  /** Adds internal users to a project */
  addInternalUsersToProject?: Maybe<AddInternalUsersToProjectPayload>;
  /** Adds a new report for an organization */
  addReport?: Maybe<AddReportPayload>;
  /** Adds a tag to a Project, Task or ActionItem */
  addTag?: Maybe<AddTagPayload>;
  /** Adds templates to a project */
  addTemplatesToProject?: Maybe<AddTemplatesToProjectPayload>;
  /** Adds third party users to a project */
  addThirdPartyUsersToProject?: Maybe<AddThirdPartyUsersToProjectPayload>;
  /** Connects a third party user with an org */
  addUserConnection?: Maybe<AddUserConnectionPayload>;
  /** Internal integration for CX team create contacts in the qualtrics app */
  addUserToQualtrics?: Maybe<AddUserToQualtricsPayload>;
  /** Bulk add users to projects */
  addUsersToProjects?: Maybe<AddUsersToProjectsPayload>;
  /** Add watcher to task */
  addWatcher?: Maybe<AddWatcherPayload>;
  answerSurvey?: Maybe<AnswerSurveyPayload>;
  /** Archives a project */
  archiveProject?: Maybe<ArchiveProjectPayload>;
  assignFirebaseMessagingToken?: Maybe<AssignMessagingTokenToUserPayload>;
  /** assign user to role */
  assignUserToRole?: Maybe<AssignUserToRolePayload>;
  /** assign user to roles */
  assignUserToRoles?: Maybe<AssignUserToRolesPayload>;
  /** Updates the assignee user in a group of projects */
  bulkAssignProjects?: Maybe<BulkAssignProjectsPayload>;
  /** Deletes many pending projects */
  bulkDeletePendingProjects?: Maybe<BulkDeletePendingProjectsPayload>;
  /** Deletes projects in bulk */
  bulkDeleteProjects?: Maybe<BulkDeleteProjectsPayload>;
  /** Edit common project attributes in bulk */
  bulkEditProjects?: Maybe<BulkEditProjectsPayload>;
  /** Updates select fields for a group of tasks */
  bulkEditTasks?: Maybe<BulkEditTasksPayload>;
  /** Creates projects in bulk for a single organization */
  bulkProjectImport?: Maybe<BulkProjectImportPayload>;
  /** Reassigns the project manager of a project in bulk */
  bulkReassignProjectManager?: Maybe<BulkReassignProjectManagerPayload>;
  /** Creates a template for an organization in bulk (Deprecated use createTemplateByImport instead) */
  bulkTemplateImport?: Maybe<BulkTemplateImportPayload>;
  /** Invite users to register - creates pending users */
  bulkUserImport?: Maybe<BulkUserImportPayload>;
  /** Changes the default filter view for a user */
  changeDefaultUserFilter?: Maybe<ChangeDefaultUserFilterPayload>;
  /** Update a tasks status from an email */
  changeStatus?: Maybe<ChangeStatusPayload>;
  /** Clones a template into a given organization */
  cloneTemplateIntoOrganization?: Maybe<CloneTemplateIntoOrganizationPayload>;
  /** Connect to HubSpot */
  connectHubSpot?: Maybe<ConnectHubSpotPayload>;
  /** Completes the OAuth Authorization flow and starts the managed-package installation */
  connectSalesforce?: Maybe<ConnectSalesforcePayload>;
  /** Create a new action item */
  createActionItem?: Maybe<CreateActionItemPayload>;
  /** Creates a new tag available to all Projects, Tasks or ActionItems of an organization */
  createAvailableTag?: Maybe<CreateAvailableTagPayload>;
  /** Create a new billing profile */
  createBillingProfile?: Maybe<CreateBillingProfilePayload>;
  /** Creates a brand */
  createBrand?: Maybe<CreateBrandPayload>;
  /** Creates a customer */
  createCustomer?: Maybe<CreateCustomerPayload>;
  /** creates customer roles for a given project */
  createCustomerRole?: Maybe<CreateCustomerRolePayload>;
  createEmailAnswerSurvey?: Maybe<CreateEmailAnswerSurveyPayload>;
  /** Creates a template, project, or users by csv import */
  createEntityByImport?: Maybe<CreateEntityByImportPayload>;
  /** Create an Installation. */
  createInstallation?: Maybe<CreateInstallationPayload>;
  /** Provision ipaas account for provider organization */
  createIpaasAccount?: Maybe<CreateIpaasAccountPayload>;
  createNote?: Maybe<CreatePayload>;
  /** Creates an organization by domain */
  createOrganization?: Maybe<CreateOrganizationPayload>;
  /** Creates a project */
  createProject?: Maybe<CreateProjectPayload>;
  /** Creates a new ProjectStatusChangeReason */
  createProjectStatusChangeReason?: Maybe<CreateProjectStatusChangeReasonPayload>;
  /** Creates Task Group in project plan */
  createProjectTaskGroup?: Maybe<CreateProjectTaskGroupPayload>;
  /** Creates a project V2 */
  createProjectV2?: Maybe<CreateProjectV2Payload>;
  /** Creates a skill category */
  createSkillCategory?: Maybe<CreateSkillCategoryPayload>;
  /** Creates a new StatusChangeReason */
  createStatusChangeReason?: Maybe<CreateStatusChangeReasonPayload>;
  /** Creates a new StatusChangeReasonGroup */
  createStatusChangeReasonGroup?: Maybe<CreateStatusChangeReasonGroupPayload>;
  /** Creates a subtask */
  createSubtask?: Maybe<CreateSubtaskPayload>;
  /** Creates a subtask group */
  createSubtasksGroup?: Maybe<CreateSubtaskGroupPayload>;
  /** Creates a task */
  createTask?: Maybe<CreateTaskPayload>;
  /** Creates Task Group */
  createTaskGroup?: Maybe<CreateTaskGroupPayload>;
  /** Creates a template for an organization */
  createTemplate?: Maybe<CreateTemplatePayload>;
  /** Creates a template by import */
  createTemplateByImport?: Maybe<CreateTemplateByImportPayload>;
  /** Creates a milestone */
  createTemplateMilestone?: Maybe<CreateTemplateMilestonePayload>;
  /** Create a new time record */
  createTimeRecord?: Maybe<CreateTimeRecordPayload>;
  /** Creates a filter view for a user */
  createUserFilterView?: Maybe<CreateUserFilterViewPayload>;
  /** Creates a filter view for a user and returns all the user filter views */
  createUserFilterViewV2?: Maybe<CreateUserFilterViewV2Payload>;
  /** Create a Webhook for a given org */
  createWebhook?: Maybe<CreateWebhookPayload>;
  /** Allows a super admin to deactivate a provider organization */
  deactivateOrganization?: Maybe<DeactivateOrganizationPayload>;
  /** Reassigns user owned tasks and/or projects before deactivating the user. */
  deactivateUserWithReassignment?: Maybe<DeactivateUserWithReassignmentPayload>;
  /** Delete an Action Item */
  deleteActionItem?: Maybe<DeleteActionItemPayload>;
  /** Deletes an available tag */
  deleteAvailableTag?: Maybe<DeleteAvailableTagPayload>;
  /** Delete a billing profile */
  deleteBillingProfile?: Maybe<DeleteBillingProfilePayload>;
  /** Deletes a brand */
  deleteBrand?: Maybe<DeleteBrandPayload>;
  /** Deletes a file that has been saved to the GuideCX resource */
  deleteFile?: Maybe<DeleteFilePayload>;
  /** Deletes a file from a parent object, returns just that parent's files */
  deleteFileFromObject?: Maybe<DeleteFileFromObjectPayload>;
  /** Deletes a direct upload that hasn't been saved yet. Use `DeleteFile` for persisted assets */
  deleteFileS3?: Maybe<DeleteFileS3Payload>;
  /** Deletes a filter view from a user */
  deleteFilterView?: Maybe<DeleteUserFilterViewPayload>;
  /** Deletes a filter view from a user and returns all the users filter views */
  deleteFilterViewV2?: Maybe<DeleteUserFilterViewV2Payload>;
  /** Delete an Identity Provider for a given org */
  deleteIdentityProvider?: Maybe<DeleteIdentityProviderPayload>;
  /** Deletes an Installation */
  deleteInstallation?: Maybe<DeleteInstallationPayload>;
  /**
   * Deletes jira integration settings
   * @deprecated v2 uses upsertJiraSettings
   */
  deleteJiraSettings?: Maybe<DeleteJiraSettingsPayload>;
  /** Delete a merge tag */
  deleteMergeTag?: Maybe<DeleteMergeTagPayload>;
  /** Deletes a milestone */
  deleteMilestone?: Maybe<DeleteMilestonePayload>;
  deleteNote?: Maybe<DestroyPayload>;
  deleteNoteAttachment?: Maybe<DestroyAttachmentPayload>;
  /** Deletes a pending project */
  deletePendingProject?: Maybe<DeletePendingProjectPayload>;
  /** Deletes a project */
  deleteProject?: Maybe<DeleteProjectPayload>;
  /** Deletes a project-level time tracking category */
  deleteProjectLevelTimeTrackingCategory?: Maybe<DeleteProjectLevelTimeTrackingCategoryPayload>;
  /** Deletes a task group in a project plan */
  deleteProjectTaskGroup?: Maybe<DeleteProjectTaskGroupPayload>;
  /** deletes a report */
  deleteReport?: Maybe<DeleteReportPayload>;
  /** Deletes a skill */
  deleteSkill?: Maybe<DeleteSkillPayload>;
  /** Deletes a skill category */
  deleteSkillCategory?: Maybe<DeleteSkillCategoryPayload>;
  /** Deletes a subtask */
  deleteSubtask?: Maybe<DeleteSubtaskPayload>;
  /** Deletes a subtask group */
  deleteSubtasksGroup?: Maybe<DeleteSubtaskGroupPayload>;
  /** Deletes a task */
  deleteTask?: Maybe<DeleteTaskPayload>;
  /** Deletes a task group */
  deleteTaskGroup?: Maybe<DeleteTaskGroupPayload>;
  /** Deletes a template */
  deleteTemplate?: Maybe<DeleteTemplatePayload>;
  /** Delete a Time Record */
  deleteTimeRecord?: Maybe<DeleteTimeRecordPayload>;
  /** Deletes a time tracking category */
  deleteTimeTrackingCategory?: Maybe<DeleteTimeTrackingCategoryPayload>;
  /** Delete a given Webhook */
  deleteWebhook?: Maybe<DeleteWebhookPayload>;
  /** Disconnects an org from Hubspot */
  disconnectHubSpot?: Maybe<DisconnectHubspotPayload>;
  /** Disconnect Jira on a org */
  disconnectJira?: Maybe<DisconnectJiraPayload>;
  /** Disconnects an org from Salesforce */
  disconnectSalesforce?: Maybe<DisconnectSalesforcePayload>;
  /** Disconnect slack on a org */
  disconnectSlack?: Maybe<DisconnectSlackPayload>;
  /** Disconnect slack on a specific channel */
  disconnectSlackChannel?: Maybe<DisconnectSlackChannelPayload>;
  /** Send the domain setup instructions to someone else */
  domainVerificationInstructions?: Maybe<DomainVerificationInstructionsPayload>;
  /**
   * Enqueues an email containing a download url for a csv of archived activities for a project
   * @deprecated This was never fully implemented or rolled out
   */
  downloadArchivedActivities?: Maybe<DownloadArchivedActivitiesPayload>;
  /** Duplicate a billing profile */
  duplicateBillingProfile?: Maybe<DuplicateBillingProfilePayload>;
  /** Duplicates a template milestone */
  duplicateMilestone?: Maybe<DuplicateMilestonePayload>;
  /** Duplicates a task group */
  duplicateProjectTaskGroup?: Maybe<DuplicateProjectTaskGroupPayload>;
  /** Duplicates a Task */
  duplicateTask?: Maybe<DuplicateTaskPayload>;
  /** Duplicates a task group */
  duplicateTaskGroup?: Maybe<DuplicateTaskGroupPayload>;
  /** Duplicates a template */
  duplicateTemplate?: Maybe<DuplicateTemplatePayload>;
  /** Enables integration for provider organization */
  enableIntegration?: Maybe<EnableIntegrationPayload>;
  /** Creates and sends a CSV file containing a summary of filtered global tasks */
  exportGlobalTasksList?: Maybe<ExportGlobalTasksListPayload>;
  /** Creates and sends a CSV file containing a summary of filtered projects */
  exportProjectList?: Maybe<ExportProjectListPayload>;
  /** Impersonates a user */
  impersonateUser?: Maybe<ImpersonateUserPayload>;
  /** Invite a user to register - creates a pending user */
  inviteUserToOrganization?: Maybe<InviteUserToOrganizationPayload>;
  /** Create or update Jira-related user account properties */
  jiraUpsertUserAccountProperties?: Maybe<UpsertUserAccountPropertiesPayload>;
  /** manage watchers per role to tasks */
  manageWatchersPerRole?: Maybe<ManageWatchersPerRolePayload>;
  /** Read all error notifications for a project */
  markAllErrorsRead?: Maybe<MarkAllErrorsReadPayload>;
  /** Merges a customer into another */
  mergeCustomer?: Maybe<MergeCustomerPayload>;
  /** move a milestone to a new position */
  moveMilestone?: Maybe<MoveMilestonePayload>;
  /** moves templates to a given organization */
  moveTemplatesToOrganization?: Maybe<MoveTemplatesToOrganizationPayload>;
  /** Move a task group to another milestone in blueprint templates */
  moveToAnotherMilestone?: Maybe<MoveToAnotherMilestonePayload>;
  /** Move a task group to another milestone in projects */
  moveToAnotherProjectMilestone?: Maybe<MoveToAnotherProjectMilestonePayload>;
  /** Productboard token */
  productboardToken?: Maybe<ProductboardTokenPayload>;
  /** Toggles a notification (on the activity table) between read/unread and returns the notification */
  readNotification?: Maybe<ReadNotificationPayload>;
  /** Read a notification error */
  readNotificationError?: Maybe<ReadNotificationErrorPayload>;
  /** Marks all notifications for a user as read */
  readNotifications?: Maybe<ReadNotificationsPayload>;
  /** Refresh expired access token */
  refreshAccessToken?: Maybe<RefreshAccessTokenPayload>;
  /** Remove an organization custom field */
  removeCustomField?: Maybe<RemoveCustomFieldPayload>;
  /** removes a customer from a project customer role */
  removeCustomerFromRole?: Maybe<RemoveCustomerFromRolePayload>;
  /** Disconnects an organization and all its connected users from another org */
  removeOrgConnection?: Maybe<RemoveOrgConnectionPayload>;
  /** Removes a status change reason */
  removeStatusChangeReason?: Maybe<RemoveStatusChangeReasonPayload>;
  /** Removes a status change reason */
  removeStatusChangeReasonGroup?: Maybe<RemoveStatusChangeReasonGroupPayload>;
  /** Removes a tag from a Project, Task or ActionItem */
  removeTag?: Maybe<RemoveTagPayload>;
  /** removes a task from a Task Group */
  removeTaskFromProjectTaskGroup?: Maybe<RemoveTaskFromProjectTaskGroupPayload>;
  /** removes a task from a Task Group */
  removeTaskFromTaskGroup?: Maybe<RemoveTaskFromTaskGroupPayload>;
  /** Removes a template from a project */
  removeTemplateFromProject?: Maybe<RemoveTemplateFromProjectPayload>;
  /** Remove user assigned from project */
  removeUserAssignedFromProject?: Maybe<RemoveUserAssignedFromProjectPayload>;
  /** Removes user by role from project */
  removeUserByRoleFromProject?: Maybe<RemoveUserByRoleFromProjectPayload>;
  /** Disconnects a third party user from an org */
  removeUserConnection?: Maybe<RemoveUserConnectionPayload>;
  /** Removes user from project */
  removeUserFromProject?: Maybe<RemoveUserFromProjectPayload>;
  /** Remove watcher from task */
  removeWatcher?: Maybe<RemoveWatcherPayload>;
  /** Update the sort order of a custom merge tag */
  reorderInfoField?: Maybe<ReorderInfoFieldPayload>;
  /** Resend an invite link for an existing user */
  resendInviteToUser?: Maybe<ResendInviteToUserPayload>;
  /** Restores a previously destroyed project */
  restoreProject?: Maybe<RestoreProjectPayload>;
  /** Save custom field value project related */
  saveProjectCustomFieldsValues?: Maybe<SaveProjectCustomFieldsValuesPayload>;
  /** Save a user as an agent for an organization with a token */
  saveUserAsAgent?: Maybe<SaveUserAsAgentPayload>;
  /** Send assignment email to user */
  sendAssignmentEmail?: Maybe<SendAssignmentEmailPayload>;
  /** Send invite to event task */
  sendEventInvite?: Maybe<SendEventInvitePayload>;
  /** Sends an email with a compressed file containing all project attachments */
  sendProjectAttachments?: Maybe<SendProjectAttachmentsPayload>;
  /**
   * Project managers can send an overview email, manually, to the entire project team.
   * This will ignore any customers who have been restricted to "My Tasks".
   *
   * Note: this is intended to be used for projects where the scheduled overview emails have
   * been disabled, but there isn't anything that prevents a project from having automated
   * overview emails and still sending a manual update to the whole team.
   *
   */
  sendProjectOverview?: Maybe<SendProjectOverviewPayload>;
  /** send an email with the invitation token to an existing user */
  sendSetupEmail?: Maybe<SendSetupEmailPayload>;
  /** Send sign off to task signer */
  sendSignOff?: Maybe<SendSignOffPayload>;
  /** Sends a preview of the welcome email */
  sendWelcomeEmailPreview?: Maybe<SendWelcomeEmailPreviewPayload>;
  /** Sets deactivated field for a user */
  setDeactivatedOnUser?: Maybe<SetDeactivatedOnUserPayload>;
  /** changes sort order of a task or a task group in a milestone in a project plan */
  sortProjectTaskTaskGroup?: Maybe<SortProjectTaskTaskGroupPayload>;
  /** changes sort order of a task or a task group in a milestone */
  sortTaskTaskGroup?: Maybe<SortTaskTaskGroupPayload>;
  /** Start connection flows in ipaas solution */
  startConnectionFlows?: Maybe<StartConnectionFlowsPayload>;
  /** Stops impersonating a user */
  stopImpersonatingUser?: Maybe<StopImpersonatingUserPayload>;
  /** Send an email with the user request access to the project */
  submitRequestAccess?: Maybe<SubmitRequestAccessPayload>;
  /** Export all the items in the time reporting */
  timeReportExport?: Maybe<TimeReportExportPayload>;
  /** Complete a Participant Task */
  toggleGroupTaskCompleted?: Maybe<ToggleGroupTaskCompletedPayload>;
  /** Toggles active value of an identity provider */
  toggleIdentityProvider?: Maybe<ToggleIdentityProviderPayload>;
  /** Toggles a subtasks done value */
  toggleSubtask?: Maybe<ToggleSubtaskDonePayload>;
  /** Trigger a Webhook with test data */
  triggerWebhook?: Maybe<TriggerWebhookPayload>;
  /** Ungroup a Task Group in project plan */
  ungroupProjectTaskGroup?: Maybe<UngroupProjectTaskGroupPayload>;
  /** Ungroup a Task Group */
  ungroupTaskGroup?: Maybe<UngroupTaskGroupPayload>;
  /** Update an action item */
  updateActionItem?: Maybe<UpdateActionItemPayload>;
  /** Update Admin Team removing or adding new project managers */
  updateAdminTeam?: Maybe<UpdateAdminTeamPayload>;
  /** Update the sort order of an attachment */
  updateAttachmentSortOrder?: Maybe<UpdateAttachmentSortOrderPayload>;
  /** Updates an available tag for all Projects, Tasks or ActionItems of an organization */
  updateAvailableTag?: Maybe<UpdateAvailableTagPayload>;
  /** Update a task skill billable override */
  updateBillableOverride?: Maybe<UpdateBillableOverridePayload>;
  /** Update a billing profile */
  updateBillingProfile?: Maybe<UpdateBillingProfilePayload>;
  /** Updates a brand */
  updateBrand?: Maybe<UpdateBrandPayload>;
  /** update resources capacities */
  updateCapacities?: Maybe<UpdateCapacitiesPayload>;
  updateCustomField?: Maybe<UpdateCustomFieldPayload>;
  /** Updates a customer */
  updateCustomer?: Maybe<UpdateCustomerPayload>;
  /** Add or Update organization domain authentication records */
  updateDomainAuthRecords?: Maybe<UpdateDomainAuthRecordsPayload>;
  updateEmailAnswerSurvey?: Maybe<UpdateEmailAnswerSurveyPayload>;
  /** Updates the file */
  updateFile?: Maybe<UpdateFilePayload>;
  /** Updates an entity in the Gantt chart */
  updateGanttEntity?: Maybe<UpdateGanttEntityPayload>;
  /** Create or Update an Identity Provider for a given org */
  updateIdentityProvider?: Maybe<UpdateIdentityProviderPayload>;
  /**
   * Updates a Jira integration
   * @deprecated v2 uses upsertJiraSettings
   */
  updateJiraIntegration?: Maybe<UpdateJiraIntegrationPayload>;
  updateNote?: Maybe<UpdatePayload>;
  /** Updates status for a generic object */
  updateObjectStatus?: Maybe<UpdateObjectStatusPayload>;
  /** Updates an organization */
  updateOrganization?: Maybe<UpdateOrganizationPayload>;
  /** Updates a project */
  updateProject?: Maybe<UpdateProjectPayload>;
  /** updates the generic properties of a project */
  updateProjectProperties?: Maybe<UpdateProjectPropertiesPayload>;
  /** Updates an existing ProjectStatusChangeReason */
  updateProjectStatusChangeReason?: Maybe<UpdateProjectStatusChangeReasonPayload>;
  /** Updates a Task group in project plan */
  updateProjectTaskGroup?: Maybe<UpdateProjectTaskGroupPayload>;
  /** Updates a project task group task */
  updateProjectTaskGroupTask?: Maybe<UpdateProjectTaskGroupTaskPayload>;
  /** update a resource user */
  updateResource?: Maybe<UpdateResourcePayload>;
  /** Approve or reject a task sign-off request */
  updateSignOff?: Maybe<UpdateSignOffPayload>;
  /** Updates a skill category */
  updateSkillCategory?: Maybe<UpdateSkillCategoryPayload>;
  /** Update the sort order of an organization custom field. */
  updateSortOrderCustomField?: Maybe<UpdateSortOrderCustomFieldPayload>;
  /** Updates a new StatusChangeReason */
  updateStatusChangeReason?: Maybe<UpdateStatusChangeReasonPayload>;
  /** Updates a new StatusChangeReasonGroup */
  updateStatusChangeReasonGroup?: Maybe<UpdateStatusChangeReasonGroupPayload>;
  /** updates a subtask name */
  updateSubTaskName?: Maybe<UpdateSubTaskNamePayload>;
  /** updates a subtask */
  updateSubtask?: Maybe<UpdateSubtaskPayload>;
  /** updates a subtask group */
  updateSubtasksGroup?: Maybe<UpdateSubtaskGroupPayload>;
  /** Updates a task */
  updateTask?: Maybe<UpdateTaskPayload>;
  /** Updates a Task group in templates */
  updateTaskGroup?: Maybe<UpdateTaskGroupPayload>;
  /** Updates a template task group task */
  updateTaskGroupTask?: Maybe<UpdateTaskGroupTaskPayload>;
  /** Updates a template */
  updateTemplate?: Maybe<UpdateTemplatePayload>;
  /** Updates a milestone */
  updateTemplateMilestone?: Maybe<UpdateTemplateMilestonePayload>;
  /** Update a time record */
  updateTimeRecord?: Maybe<UpdateTimeRecordPayload>;
  /** Updates an organization's time-tracking settings */
  updateTimeTrackingSettings?: Maybe<UpdateTimeTrackingSettingsPayload>;
  /** Updates a user */
  updateUser?: Maybe<UpdateUserPayload>;
  /** Updates a User notification preferences (No Auth Required) */
  updateUserNotificationPreferences?: Maybe<UpdateUserNotificationPreferencesPayload>;
  /** Updates a user project */
  updateUserProject?: Maybe<UpdateUserProjectPayload>;
  /** Update a Webhook */
  updateWebhook?: Maybe<UpdateWebhookPayload>;
  /** Update or create a custom configuration */
  upsert?: Maybe<UpsertCustomConfigurationPayload>;
  /** Update customer role, create if not exists */
  upsertCustomerRole?: Maybe<UpsertCustomerRolePayload>;
  /** Upserts global Gainsight settings */
  upsertGainsightSettings?: Maybe<UpsertGainsightSettingsPayload>;
  /** Create or update a custom merge tag */
  upsertInfoField?: Maybe<UpsertInfoFieldPayload>;
  /** Upserts global Jira settings */
  upsertJiraSettings?: Maybe<UpsertJiraSettingsPayload>;
  /** Create or update a organization setting */
  upsertOrganizationSettings?: Maybe<UpsertOrganizationSettingsPayload>;
  /** Create or Update a project info field. */
  upsertProjectInfoField?: Maybe<UpsertProjectInfoFieldsPayload>;
  /** Create or update a project-level time tracking category */
  upsertProjectLevelTimeTrackingCategory?: Maybe<UpsertProjectLevelTimeTrackingCategoryPayload>;
  /** Create or update a skill */
  upsertSkill?: Maybe<UpsertSkillPayload>;
  /** Create or update a time tracking category */
  upsertTimeTrackingCategory?: Maybe<UpsertTimeTrackingCategoryPayload>;
}


export interface MutationAcceptInvitationArgs {
  input: AcceptInvitationInput;
}


export interface MutationActionItemsExportArgs {
  input: ActionItemsExportInput;
}


export interface MutationAddBasicCustomerUserArgs {
  input: AddBasicCustomerUserInput;
}


export interface MutationAddCustomerUsersToProjectArgs {
  input: AddCustomerUsersToProjectInput;
}


export interface MutationAddCustomerUsersV2Args {
  input: AddCustomerUserInput;
}


export interface MutationAddInternalUsersToProjectArgs {
  input: AddInternalUsersToProjectInput;
}


export interface MutationAddReportArgs {
  input: AddReportInput;
}


export interface MutationAddTagArgs {
  input: AddTagInput;
}


export interface MutationAddTemplatesToProjectArgs {
  input: AddTemplatesToProjectInput;
}


export interface MutationAddThirdPartyUsersToProjectArgs {
  input: AddThirdPartyUsersToProjectInput;
}


export interface MutationAddUserConnectionArgs {
  input: AddUserConnectionInput;
}


export interface MutationAddUserToQualtricsArgs {
  input: AddUserToQualtricsInput;
}


export interface MutationAddUsersToProjectsArgs {
  input: AddUsersToProjectsInput;
}


export interface MutationAddWatcherArgs {
  input: AddWatcherInput;
}


export interface MutationAnswerSurveyArgs {
  input: AnswerSurveyInput;
}


export interface MutationArchiveProjectArgs {
  input: ArchiveProjectInput;
}


export interface MutationAssignFirebaseMessagingTokenArgs {
  input: AssignFirebaseMessagingTokenInput;
}


export interface MutationAssignUserToRoleArgs {
  input: AssignUserToRoleInput;
}


export interface MutationAssignUserToRolesArgs {
  input: AssignUserToRolesInput;
}


export interface MutationBulkAssignProjectsArgs {
  input: BulkAssignProjectsInput;
}


export interface MutationBulkDeletePendingProjectsArgs {
  input: BulkDeletePendingProjectsInput;
}


export interface MutationBulkDeleteProjectsArgs {
  input: BulkDeleteProjectInput;
}


export interface MutationBulkEditProjectsArgs {
  input: BulkEditProjectsInput;
}


export interface MutationBulkEditTasksArgs {
  input: BulkEditTasksInput;
}


export interface MutationBulkProjectImportArgs {
  organizationId: Scalars['ID'];
  projects: Array<BulkProjectImportInput>;
}


export interface MutationBulkReassignProjectManagerArgs {
  input: BulkReassignPmInput;
}


export interface MutationBulkTemplateImportArgs {
  input: BulkTemplateImportInput;
}


export interface MutationBulkUserImportArgs {
  input: BulkUserImportInput;
}


export interface MutationChangeDefaultUserFilterArgs {
  input: ChangeDefaultUserFilterInput;
}


export interface MutationChangeStatusArgs {
  input: ChangeStatusInput;
}


export interface MutationCloneTemplateIntoOrganizationArgs {
  input: CloneTemplateIntoOrganizationInput;
}


export interface MutationConnectHubSpotArgs {
  input: ConnectHubSpotInput;
}


export interface MutationConnectSalesforceArgs {
  input: ConnectSalesforceInput;
}


export interface MutationCreateActionItemArgs {
  input: CreateActionItemInput;
}


export interface MutationCreateAvailableTagArgs {
  input: CreateAvailableTagInput;
}


export interface MutationCreateBillingProfileArgs {
  input: CreateBillingProfileInput;
}


export interface MutationCreateBrandArgs {
  input: CreateBrandInput;
}


export interface MutationCreateCustomerArgs {
  input: CustomerInputType;
}


export interface MutationCreateCustomerRoleArgs {
  projectId: Scalars['ID'];
}


export interface MutationCreateEmailAnswerSurveyArgs {
  input: CreateEmailAnswerSurveyInput;
}


export interface MutationCreateEntityByImportArgs {
  input: CreateEntityByImportInput;
}


export interface MutationCreateInstallationArgs {
  input: CreateInstallationInput;
}


export interface MutationCreateIpaasAccountArgs {
  organizationId: Scalars['ID'];
}


export interface MutationCreateNoteArgs {
  input: CreateNoteInput;
}


export interface MutationCreateOrganizationArgs {
  input: CreateOrganizationInput;
}


export interface MutationCreateProjectArgs {
  input: CreateProjectInput;
}


export interface MutationCreateProjectStatusChangeReasonArgs {
  input: CreateProjectStatusChangeReasonInput;
}


export interface MutationCreateProjectTaskGroupArgs {
  input: CreateTaskGroupInput;
}


export interface MutationCreateProjectV2Args {
  input: CreateProjectV2Input;
}


export interface MutationCreateSkillCategoryArgs {
  input: CreateSkillCategoryInput;
}


export interface MutationCreateStatusChangeReasonArgs {
  input: CreateStatusChangeReasonInput;
}


export interface MutationCreateStatusChangeReasonGroupArgs {
  input: CreateStatusChangeReasonGroupInput;
}


export interface MutationCreateSubtaskArgs {
  input: CreateSubtaskInput;
}


export interface MutationCreateSubtasksGroupArgs {
  input: CreateSubtaskGroupInput;
}


export interface MutationCreateTaskArgs {
  input: CreateTaskInput;
}


export interface MutationCreateTaskGroupArgs {
  input: CreateTaskGroupInput;
}


export interface MutationCreateTemplateArgs {
  input: CreateTemplateInput;
}


export interface MutationCreateTemplateByImportArgs {
  input: CreateByImportInput;
}


export interface MutationCreateTemplateMilestoneArgs {
  input: CreateTemplateMilestoneInput;
}


export interface MutationCreateTimeRecordArgs {
  input: CreateTimeRecordInput;
}


export interface MutationCreateUserFilterViewArgs {
  input: CreateUserFilterViewInput;
}


export interface MutationCreateUserFilterViewV2Args {
  input: CreateUserFilterViewInput;
}


export interface MutationCreateWebhookArgs {
  input: CreateWebhookInput;
}


export interface MutationDeactivateOrganizationArgs {
  input: DeactivateOrganizationInput;
}


export interface MutationDeactivateUserWithReassignmentArgs {
  input: ReassignmentInput;
}


export interface MutationDeleteActionItemArgs {
  input: DeleteActionItemInput;
}


export interface MutationDeleteAvailableTagArgs {
  input: DeleteAvailableTagInput;
}


export interface MutationDeleteBillingProfileArgs {
  input: DeleteBillingProfileInput;
}


export interface MutationDeleteBrandArgs {
  input: DeleteBrandInput;
}


export interface MutationDeleteFileArgs {
  input: DeleteFileInput;
}


export interface MutationDeleteFileFromObjectArgs {
  input: DeleteFileFromObjectInput;
}


export interface MutationDeleteFileS3Args {
  input: DeleteFileS3Input;
}


export interface MutationDeleteFilterViewArgs {
  input: DeleteUserFilterViewInput;
}


export interface MutationDeleteFilterViewV2Args {
  input: DeleteUserFilterViewInput;
}


export interface MutationDeleteIdentityProviderArgs {
  input: DeleteIdentityProviderInput;
}


export interface MutationDeleteInstallationArgs {
  input: DeleteInstallationInput;
}


export interface MutationDeleteJiraSettingsArgs {
  input: DeleteJiraSettingsInput;
}


export interface MutationDeleteMergeTagArgs {
  id: Scalars['ID'];
}


export interface MutationDeleteMilestoneArgs {
  input: DeleteMilestoneInput;
}


export interface MutationDeleteNoteArgs {
  id: Scalars['ID'];
}


export interface MutationDeleteNoteAttachmentArgs {
  id: Scalars['ID'];
}


export interface MutationDeletePendingProjectArgs {
  input: DeletePendingProjectInput;
}


export interface MutationDeleteProjectArgs {
  input: DeleteProjectInput;
}


export interface MutationDeleteProjectLevelTimeTrackingCategoryArgs {
  input: DeleteProjectLevelTimeTrackingCategoryInput;
}


export interface MutationDeleteProjectTaskGroupArgs {
  input: DeleteTaskGroupInput;
}


export interface MutationDeleteReportArgs {
  input: DeleteReportInput;
}


export interface MutationDeleteSkillArgs {
  id: Scalars['ID'];
}


export interface MutationDeleteSkillCategoryArgs {
  id: Scalars['ID'];
}


export interface MutationDeleteSubtaskArgs {
  input: DeleteSubtaskInput;
}


export interface MutationDeleteSubtasksGroupArgs {
  input: DeleteSubtaskGroupInput;
}


export interface MutationDeleteTaskArgs {
  input: DeleteTaskInput;
}


export interface MutationDeleteTaskGroupArgs {
  input: DeleteTaskGroupInput;
}


export interface MutationDeleteTemplateArgs {
  input: DeleteTemplateInput;
}


export interface MutationDeleteTimeRecordArgs {
  input: DeleteTimeRecordInput;
}


export interface MutationDeleteTimeTrackingCategoryArgs {
  id: Scalars['ID'];
}


export interface MutationDeleteWebhookArgs {
  input: DeleteWebhookInput;
}


export interface MutationDisconnectHubSpotArgs {
  input: DisconnectHubspotInput;
}


export interface MutationDisconnectJiraArgs {
  input: DisconnectJiraInput;
}


export interface MutationDisconnectSalesforceArgs {
  input: DisconnectSalesforceInput;
}


export interface MutationDisconnectSlackArgs {
  input: DisconnectSlackInput;
}


export interface MutationDisconnectSlackChannelArgs {
  input: DisconnectSlackChannelInput;
}


export interface MutationDomainVerificationInstructionsArgs {
  input: DomainVerificationInstructionsInput;
}


export interface MutationDownloadArchivedActivitiesArgs {
  input: DownloadArchivedActivitiesInput;
}


export interface MutationDuplicateBillingProfileArgs {
  input: DuplicateBillingProfileInput;
}


export interface MutationDuplicateMilestoneArgs {
  input: DuplicateMilestoneInput;
}


export interface MutationDuplicateProjectTaskGroupArgs {
  input: DuplicateTaskGroupInput;
}


export interface MutationDuplicateTaskArgs {
  input: DuplicateTaskInput;
}


export interface MutationDuplicateTaskGroupArgs {
  input: DuplicateTaskGroupInput;
}


export interface MutationDuplicateTemplateArgs {
  input: DuplicateTemplateInput;
}


export interface MutationEnableIntegrationArgs {
  integrationName: Scalars['String'];
  organizationId: Scalars['ID'];
}


export interface MutationExportGlobalTasksListArgs {
  input: ExportGlobalTasksListInput;
}


export interface MutationExportProjectListArgs {
  input: ExportProjectListInput;
}


export interface MutationImpersonateUserArgs {
  input: ImpersonateUserInput;
}


export interface MutationInviteUserToOrganizationArgs {
  input: InviteUserToOrganizationInput;
}


export interface MutationJiraUpsertUserAccountPropertiesArgs {
  properties: UpsertUserAccountPropertiesInput;
}


export interface MutationManageWatchersPerRoleArgs {
  input: ManageWatchersPerRoleInput;
}


export interface MutationMarkAllErrorsReadArgs {
  id: Scalars['ID'];
}


export interface MutationMergeCustomerArgs {
  input: MergeCustomersInputType;
}


export interface MutationMoveMilestoneArgs {
  inputs: MoveMilestoneInput;
}


export interface MutationMoveTemplatesToOrganizationArgs {
  input: MoveTemplatesToOrganizationInput;
}


export interface MutationMoveToAnotherMilestoneArgs {
  input: MoveTaskGroupInput;
}


export interface MutationMoveToAnotherProjectMilestoneArgs {
  input: MoveTaskGroupInput;
}


export interface MutationReadNotificationArgs {
  id: Scalars['ID'];
}


export interface MutationReadNotificationErrorArgs {
  id: Scalars['ID'];
}


export interface MutationReadNotificationsArgs {
  types: Array<NotificationTypeEnumType>;
  userId: Scalars['ID'];
}


export interface MutationRefreshAccessTokenArgs {
  refreshToken?: InputMaybe<Scalars['String']>;
}


export interface MutationRemoveCustomFieldArgs {
  input: RemoveCustomFieldInput;
}


export interface MutationRemoveCustomerFromRoleArgs {
  input: RemoveCustomerFromRoleInput;
}


export interface MutationRemoveOrgConnectionArgs {
  input: RemoveOrgConnectionInput;
}


export interface MutationRemoveStatusChangeReasonArgs {
  input: RemoveStatusChangeReasonInput;
}


export interface MutationRemoveStatusChangeReasonGroupArgs {
  input: RemoveStatusChangeReasonGroupInput;
}


export interface MutationRemoveTagArgs {
  input: RemoveTagInput;
}


export interface MutationRemoveTaskFromProjectTaskGroupArgs {
  input: RemoveTaskFromTaskGroupInput;
}


export interface MutationRemoveTaskFromTaskGroupArgs {
  input: RemoveTaskFromTaskGroupInput;
}


export interface MutationRemoveTemplateFromProjectArgs {
  input: RemoveTemplateFromProjectInput;
}


export interface MutationRemoveUserAssignedFromProjectArgs {
  input: RemoveUserAssignedFromProjectInput;
}


export interface MutationRemoveUserByRoleFromProjectArgs {
  input: RemoveUserByRoleFromProjectInput;
}


export interface MutationRemoveUserConnectionArgs {
  input: RemoveUserConnectionInput;
}


export interface MutationRemoveUserFromProjectArgs {
  input: RemoveUserFromProjectInput;
}


export interface MutationRemoveWatcherArgs {
  input: RemoveWatcherInput;
}


export interface MutationReorderInfoFieldArgs {
  input: ReorderInfoFieldInput;
}


export interface MutationResendInviteToUserArgs {
  input: ResendInviteToUserInput;
}


export interface MutationRestoreProjectArgs {
  input: RestoreProjectInput;
}


export interface MutationSaveProjectCustomFieldsValuesArgs {
  input: SaveProjectCustomFieldsValuesInput;
}


export interface MutationSaveUserAsAgentArgs {
  apiToken: Scalars['String'];
  userId: Scalars['ID'];
}


export interface MutationSendAssignmentEmailArgs {
  input: SendAssignmentEmailInput;
}


export interface MutationSendEventInviteArgs {
  input: SendEventInviteInput;
}


export interface MutationSendProjectAttachmentsArgs {
  input: SendProjectAttachmentsInput;
}


export interface MutationSendProjectOverviewArgs {
  projectId: Scalars['ID'];
}


export interface MutationSendSetupEmailArgs {
  input: SendSetupEmailInput;
}


export interface MutationSendSignOffArgs {
  input: SendSignOffInput;
}


export interface MutationSendWelcomeEmailPreviewArgs {
  input: SendWelcomeEmailPreviewInput;
}


export interface MutationSetDeactivatedOnUserArgs {
  input: SetDeactivatedOnUserInput;
}


export interface MutationSortProjectTaskTaskGroupArgs {
  input: SortTaskTaskGroupInput;
}


export interface MutationSortTaskTaskGroupArgs {
  input: SortTaskTaskGroupInput;
}


export interface MutationStartConnectionFlowsArgs {
  connectionId: Scalars['Int'];
  integrationProvider: Scalars['String'];
}


export interface MutationStopImpersonatingUserArgs {
  refreshToken: Scalars['String'];
}


export interface MutationSubmitRequestAccessArgs {
  input: SubmitRequestAccessInput;
}


export interface MutationTimeReportExportArgs {
  input: TimeReportExportInput;
}


export interface MutationToggleGroupTaskCompletedArgs {
  input: ToggleGroupTaskCompletedInput;
}


export interface MutationToggleIdentityProviderArgs {
  input: ToggleIdentityProviderInput;
}


export interface MutationToggleSubtaskArgs {
  input: ToggleSubtaskDoneInput;
}


export interface MutationTriggerWebhookArgs {
  input: TriggerWebhookInput;
}


export interface MutationUngroupProjectTaskGroupArgs {
  input: UngroupTaskGroupInput;
}


export interface MutationUngroupTaskGroupArgs {
  input: UngroupTaskGroupInput;
}


export interface MutationUpdateActionItemArgs {
  input: UpdateActionItemInput;
}


export interface MutationUpdateAdminTeamArgs {
  input: UpdateAdminTeamInput;
}


export interface MutationUpdateAttachmentSortOrderArgs {
  input: UpdateAttachmentSortOrderInput;
}


export interface MutationUpdateAvailableTagArgs {
  input: UpdateAvailableTagInput;
}


export interface MutationUpdateBillableOverrideArgs {
  input: UpdateBillableOverrideInput;
}


export interface MutationUpdateBillingProfileArgs {
  input: UpdateBillingProfileInput;
}


export interface MutationUpdateBrandArgs {
  input: UpdateBrandInput;
}


export interface MutationUpdateCapacitiesArgs {
  input: UpdateCapacitiesInput;
}


export interface MutationUpdateCustomFieldArgs {
  input: UpdateCustomFieldInput;
}


export interface MutationUpdateCustomerArgs {
  input: CustomerInputType;
}


export interface MutationUpdateDomainAuthRecordsArgs {
  input: UpdateDomainAuthRecordsInput;
}


export interface MutationUpdateEmailAnswerSurveyArgs {
  input: UpdateEmailAnswerSurveyInput;
}


export interface MutationUpdateFileArgs {
  input: UpdateFileInput;
}


export interface MutationUpdateGanttEntityArgs {
  input: UpdateGanttEntityInput;
}


export interface MutationUpdateIdentityProviderArgs {
  input: UpdateIdentityProviderInput;
}


export interface MutationUpdateJiraIntegrationArgs {
  input: UpdateJiraIntegrationInput;
}


export interface MutationUpdateNoteArgs {
  input: UpdateNoteInput;
}


export interface MutationUpdateObjectStatusArgs {
  input: UpdateStatusInputV2;
}


export interface MutationUpdateOrganizationArgs {
  input: UpdateOrganizationInput;
}


export interface MutationUpdateProjectArgs {
  input: UpdateProjectInput;
}


export interface MutationUpdateProjectPropertiesArgs {
  input: UpdateProjectPropertiesInput;
}


export interface MutationUpdateProjectStatusChangeReasonArgs {
  input: UpdateProjectStatusChangeReasonInput;
}


export interface MutationUpdateProjectTaskGroupArgs {
  input: UpdateTaskGroupInput;
}


export interface MutationUpdateProjectTaskGroupTaskArgs {
  input: UpdateTaskInput;
}


export interface MutationUpdateResourceArgs {
  input: UpdateResourceInput;
}


export interface MutationUpdateSignOffArgs {
  input: UpdateSignOffInput;
}


export interface MutationUpdateSkillCategoryArgs {
  input: UpdateSkillCategoryInput;
}


export interface MutationUpdateSortOrderCustomFieldArgs {
  input: UpdateSortOrderCustomFieldInput;
}


export interface MutationUpdateStatusChangeReasonArgs {
  input: UpdateStatusChangeReasonInput;
}


export interface MutationUpdateStatusChangeReasonGroupArgs {
  input: UpdateStatusChangeReasonGroupInput;
}


export interface MutationUpdateSubTaskNameArgs {
  input: UpdateSubTaskNameInput;
}


export interface MutationUpdateSubtaskArgs {
  input: UpdateSubtaskInput;
}


export interface MutationUpdateSubtasksGroupArgs {
  input: UpdateSubtaskGroupInput;
}


export interface MutationUpdateTaskArgs {
  input: UpdateTaskInput;
}


export interface MutationUpdateTaskGroupArgs {
  input: UpdateTaskGroupInput;
}


export interface MutationUpdateTaskGroupTaskArgs {
  input: UpdateTaskInput;
}


export interface MutationUpdateTemplateArgs {
  input: UpdateTemplateInput;
}


export interface MutationUpdateTemplateMilestoneArgs {
  input: UpdateTemplateMilestoneInput;
}


export interface MutationUpdateTimeRecordArgs {
  input: UpdateTimeRecordInput;
}


export interface MutationUpdateTimeTrackingSettingsArgs {
  input: UpdateTimeTrackingSettingsInput;
}


export interface MutationUpdateUserArgs {
  input: UpdateUserInput;
}


export interface MutationUpdateUserNotificationPreferencesArgs {
  input: UpdateUserNotificationPreferencesInput;
}


export interface MutationUpdateUserProjectArgs {
  arguments: UpdateUserProjectArguments;
  projectId: Scalars['ID'];
  userId: Scalars['ID'];
}


export interface MutationUpdateWebhookArgs {
  input: UpdateWebhookInput;
}


export interface MutationUpsertArgs {
  input: UpsertCustomConfigurationInputType;
}


export interface MutationUpsertCustomerRoleArgs {
  input: UpsertCustomerRoleInput;
}


export interface MutationUpsertGainsightSettingsArgs {
  input: UpsertGainsightSettingsInput;
}


export interface MutationUpsertInfoFieldArgs {
  input: UpsertInfoFieldInput;
}


export interface MutationUpsertJiraSettingsArgs {
  input: UpsertJiraSettingsInput;
}


export interface MutationUpsertOrganizationSettingsArgs {
  input: UpsertOrganizationSettingsInput;
}


export interface MutationUpsertProjectInfoFieldArgs {
  input: UpsertProjectInfoFieldInput;
}


export interface MutationUpsertProjectLevelTimeTrackingCategoryArgs {
  input: UpsertProjectLevelTimeTrackingCategoryInput;
}


export interface MutationUpsertSkillArgs {
  input: UpsertSkillInput;
}


export interface MutationUpsertTimeTrackingCategoryArgs {
  input: UpsertTimeTrackingCategoryInput;
}

/** A note */
export interface NoteType {
  __typename?: 'NoteType';
  attachments: Array<FileType>;
  createdAt: Scalars['DateType'];
  deletable?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  internalOnly: Scalars['Boolean'];
  noteable: NoteableType;
  plainText: Scalars['String'];
  project: ProjectType;
  raw: Scalars['String'];
  updatedAt: Scalars['DateType'];
  user: UserType;
}

/** Enum for the possible note visibility types */
export enum NoteVisibilityEnumType {
  /** internal */
  Internal = 'INTERNAL',
  /** public */
  Public = 'PUBLIC'
}

/** Enum for the possible noteable types */
export enum NoteableEnumType {
  /** action_item */
  ActionItem = 'ACTION_ITEM',
  /** project */
  Project = 'PROJECT',
  /** task */
  Task = 'TASK'
}

/** The parent of a note is polymorphic */
export type NoteableType = ProjectType | TaskType;

/** a connection of all the notes for any noteable for a given customer user */
export interface NotesByCustomerUserConnectionType {
  __typename?: 'NotesByCustomerUserConnectionType';
  notes?: Maybe<Array<CustomerUserNoteType>>;
  pageInfo?: Maybe<PageInfoType>;
}

/** A user notification */
export interface Notification {
  __typename?: 'Notification';
  createdAt?: Maybe<Scalars['DateType']>;
  id: Scalars['ID'];
  notificationType?: Maybe<NotificationTypeEnumType>;
  path?: Maybe<Scalars['String']>;
  readAt?: Maybe<Scalars['DateType']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
}

/** A connection of notifications */
export interface NotificationConnections {
  __typename?: 'NotificationConnections';
  notifications: Array<Notification>;
  pageInfo: PageInfoType;
}

/** Notification errors */
export interface NotificationError {
  __typename?: 'NotificationError';
  notifications: Array<Notification>;
  totalErrors: Scalars['Int'];
}

export interface NotificationPreferenceInputType {
  allTasksCompletedEmailPref?: InputMaybe<Scalars['Boolean']>;
  allTasksCompletedPref?: InputMaybe<Scalars['Boolean']>;
  doneEmailPref?: InputMaybe<Scalars['Boolean']>;
  donePref?: InputMaybe<Scalars['Boolean']>;
  groupedTaskCompletedEmailPref?: InputMaybe<Scalars['Boolean']>;
  groupedTaskCompletedPref?: InputMaybe<Scalars['Boolean']>;
  idleProjectDaysPref?: InputMaybe<Scalars['Int']>;
  milestoneCompletedEmailPref?: InputMaybe<Scalars['Boolean']>;
  milestoneCompletedPref?: InputMaybe<Scalars['Boolean']>;
  noteAddedWatchedTaskSmsPref?: InputMaybe<Scalars['Boolean']>;
  noteMentionedUserSmsPref?: InputMaybe<Scalars['Boolean']>;
  overdueEmailPref?: InputMaybe<Scalars['Boolean']>;
  overduePref?: InputMaybe<Scalars['Boolean']>;
  projectOverviewEmailPref?: InputMaybe<ProjectOverviewEmailPrefEnumType>;
  projectRunningLateEmailPref?: InputMaybe<Scalars['Boolean']>;
  projectRunningLatePref?: InputMaybe<Scalars['Boolean']>;
  stuckEmailPref?: InputMaybe<Scalars['Boolean']>;
  stuckPref?: InputMaybe<Scalars['Boolean']>;
  taskAssignmentSmsPref?: InputMaybe<Scalars['Boolean']>;
  taskGroupCompletedEmailPref?: InputMaybe<Scalars['Boolean']>;
  taskGroupCompletedPref?: InputMaybe<Scalars['Boolean']>;
  taskReminderEmailPref?: InputMaybe<TaskReminderEmailPref>;
  taskReminderSmsPref?: InputMaybe<Scalars['Boolean']>;
  taskSignOffResponseSmsPref?: InputMaybe<Scalars['Boolean']>;
  taskStartedUnassignedEmailPref?: InputMaybe<Scalars['Boolean']>;
  taskStartedUnassignedPref?: InputMaybe<Scalars['Boolean']>;
  taskUpdatedDaysPref?: InputMaybe<Scalars['Int']>;
  taskUpdatedEmailPref?: InputMaybe<Scalars['Boolean']>;
  taskUpdatedPref?: InputMaybe<Scalars['Boolean']>;
  unaddressedNoteEmailPref?: InputMaybe<Scalars['Boolean']>;
  unaddressedNotePref?: InputMaybe<Scalars['Boolean']>;
  unsubscribeFromAllEmails?: InputMaybe<Scalars['Boolean']>;
}

/** Notification preferences for a user */
export interface NotificationPreferenceType {
  __typename?: 'NotificationPreferenceType';
  allTasksCompletedEmailPref?: Maybe<Scalars['Boolean']>;
  allTasksCompletedPref?: Maybe<Scalars['Boolean']>;
  doneEmailPref?: Maybe<Scalars['Boolean']>;
  donePref?: Maybe<Scalars['Boolean']>;
  groupedTaskCompletedEmailPref?: Maybe<Scalars['Boolean']>;
  groupedTaskCompletedPref?: Maybe<Scalars['Boolean']>;
  idleProjectDaysPref?: Maybe<Scalars['Int']>;
  milestoneCompletedEmailPref?: Maybe<Scalars['Boolean']>;
  milestoneCompletedPref?: Maybe<Scalars['Boolean']>;
  noteAddedWatchedTaskSmsPref?: Maybe<Scalars['Boolean']>;
  noteMentionedUserSmsPref?: Maybe<Scalars['Boolean']>;
  overdueEmailPref?: Maybe<Scalars['Boolean']>;
  overduePref?: Maybe<Scalars['Boolean']>;
  projectOverviewEmailPref?: Maybe<ProjectOverviewEmailPrefEnumType>;
  projectRunningLateEmailPref?: Maybe<Scalars['Boolean']>;
  projectRunningLatePref?: Maybe<Scalars['Boolean']>;
  stuckEmailPref?: Maybe<Scalars['Boolean']>;
  stuckPref?: Maybe<Scalars['Boolean']>;
  taskAssignmentSmsPref?: Maybe<Scalars['Boolean']>;
  taskGroupCompletedEmailPref?: Maybe<Scalars['Boolean']>;
  taskGroupCompletedPref?: Maybe<Scalars['Boolean']>;
  taskReminderEmailPref?: Maybe<TaskReminderEmailPref>;
  taskReminderSmsPref?: Maybe<Scalars['Boolean']>;
  taskSignOffResponseSmsPref?: Maybe<Scalars['Boolean']>;
  taskStartedUnassignedEmailPref?: Maybe<Scalars['Boolean']>;
  taskStartedUnassignedPref?: Maybe<Scalars['Boolean']>;
  taskUpdatedDaysPref?: Maybe<Scalars['Int']>;
  taskUpdatedEmailPref?: Maybe<Scalars['Boolean']>;
  taskUpdatedPref?: Maybe<Scalars['Boolean']>;
  unaddressedNoteEmailPref?: Maybe<Scalars['Boolean']>;
  unaddressedNotePref?: Maybe<Scalars['Boolean']>;
  unsubscribeFromAllEmails?: Maybe<Scalars['Boolean']>;
}

/** Enum for the possible notification types */
export enum NotificationTypeEnumType {
  /** Deprecated notification type. Will be removed Q2 2022 */
  Activity = 'ACTIVITY',
  /** user @mentions */
  Communication = 'COMMUNICATION',
  /** Errors for users to take action to fix */
  Error = 'ERROR',
  /** Notifications targeted at integrations like Slack */
  Integration = 'INTEGRATION',
  /** General web notifications */
  Notification = 'NOTIFICATION',
  /** Automated, system notifications */
  Schedule = 'SCHEDULE'
}

/** Open API token and webhooks */
export interface OpenApiDataType {
  __typename?: 'OpenApiDataType';
  openApiToken?: Maybe<Scalars['String']>;
  webhooks?: Maybe<Array<WebhookType>>;
}

/** Enum for operator */
export enum OperatorEnumType {
  /** and */
  And = 'AND',
  /** or */
  Or = 'OR'
}

/** An organization admin settings */
export interface OrganizationAdminSettings {
  __typename?: 'OrganizationAdminSettings';
  uploadLimitMb: Scalars['Int'];
}

/** An organization admin settings Input */
export interface OrganizationAdminSettingsInput {
  uploadLimitMb?: InputMaybe<Scalars['Int']>;
}

/** A user connection to the organization */
export interface OrganizationConnectedUsersType {
  __typename?: 'OrganizationConnectedUsersType';
  pageInfo?: Maybe<PageInfoType>;
  users?: Maybe<Array<UserType>>;
}

/** A connection organizations */
export interface OrganizationConnectionType {
  __typename?: 'OrganizationConnectionType';
  organizations?: Maybe<Array<OrganizationType>>;
  pageInfo?: Maybe<PageInfoType>;
}

/** Organization custom fields */
export interface OrganizationCustomFieldType {
  __typename?: 'OrganizationCustomFieldType';
  id: Scalars['ID'];
  internalOnly: Scalars['Boolean'];
  mergeTag: Scalars['Boolean'];
  mergeTagKey?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  sortOrder: Scalars['Float'];
  warnRemoveMergeTag: Scalars['Boolean'];
}

/** Enum for the possible organization customer types */
export enum OrganizationCustomerTypeEnumType {
  /** company */
  Company = 'COMPANY',
  /** individual */
  Individual = 'INDIVIDUAL',
  /** internal */
  Internal = 'INTERNAL'
}

/** Organization Project Reports */
export interface OrganizationProjectReports {
  __typename?: 'OrganizationProjectReports';
  createdAt: Scalars['DateType'];
  id: Scalars['ID'];
  organizationId: Scalars['String'];
  publicId: Scalars['String'];
  reportActive: Scalars['Boolean'];
  reportTitle: Scalars['String'];
  reportType: Scalars['String'];
  reportUrl: Scalars['String'];
}

/** input arguments for search all organizations */
export interface OrganizationSearchInput {
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<OrganizationSortEnum>;
  sortDirection?: InputMaybe<SortDirectionEnumType>;
  status?: InputMaybe<OrganizationStatusEnum>;
  type?: InputMaybe<Array<OrganizationTypeEnumType>>;
}

/** An organization setting */
export interface OrganizationSetting {
  __typename?: 'OrganizationSetting';
  allowForeignLanguage: Scalars['Boolean'];
  brandedEmailSenderEnabled?: Maybe<Scalars['Boolean']>;
  useStatusChangeReasons?: Maybe<Scalars['Boolean']>;
}

export enum OrganizationSortEnum {
  CreatedAt = 'CREATED_AT',
  Domain = 'DOMAIN',
  Name = 'NAME'
}

export enum OrganizationStatusEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Trial = 'TRIAL'
}

/** An organization */
export interface OrganizationType {
  __typename?: 'OrganizationType';
  adminSettings: OrganizationAdminSettings;
  adminUsersCount?: Maybe<Scalars['Int']>;
  archiveProjectsPermissions?: Maybe<ArchiveProjectsPermissionsEnumType>;
  bccEmail?: Maybe<Scalars['String']>;
  billableRate?: Maybe<Scalars['Int']>;
  billableUsersCount?: Maybe<Scalars['Int']>;
  brandsEnabled?: Maybe<Scalars['Boolean']>;
  contributorUsersCount?: Maybe<Scalars['Int']>;
  countryCode: CountryCodeEnumType;
  createdAt?: Maybe<Scalars['DateType']>;
  currencyCode: CurrencyCodeEnumType;
  customerDashboardEnabled: Scalars['Boolean'];
  customerType?: Maybe<OrganizationCustomerTypeEnumType>;
  deactivated?: Maybe<Scalars['Boolean']>;
  defaultCapacityHours?: Maybe<Scalars['Float']>;
  defaultTaskVisibility?: Maybe<TaskVisibilityEnumType>;
  disableTimeEntryForCompletedProjects?: Maybe<Scalars['Boolean']>;
  disableTimeEntryForPastMonths?: Maybe<Scalars['Boolean']>;
  domain?: Maybe<Scalars['String']>;
  guideUsersCount?: Maybe<Scalars['Int']>;
  headerLogo?: Maybe<ImageType>;
  /** @deprecated deprecated for workato */
  hubSpotIntegration?: Maybe<HubspotIntegrationType>;
  /** @deprecated deprecated for workato */
  hubspotEnabled?: Maybe<Scalars['Boolean']>;
  /** @deprecated moved to workato */
  hubspotIntegration?: Maybe<HubspotIntegrationType>;
  id: Scalars['ID'];
  identityProvider?: Maybe<IdentityProviderType>;
  internalNotesDefault: Scalars['Boolean'];
  ipaasAccountExists: Scalars['Boolean'];
  isCsatSurveyEnabled: Scalars['Boolean'];
  /** @deprecated deprecated for workato */
  jiraEnabled?: Maybe<Scalars['Boolean']>;
  /** @deprecated moved to workato */
  jiraIntegration?: Maybe<JiraIntegrationType>;
  /** @deprecated moved to workato */
  jiraSettings?: Maybe<JiraSettings>;
  logo?: Maybe<ImageType>;
  managerUsersCount?: Maybe<Scalars['Int']>;
  maxBillableUsers?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  openApiData?: Maybe<OpenApiDataType>;
  openApiEnabled?: Maybe<Scalars['Boolean']>;
  /** Users as a child of an organization with arguments */
  paginatedUsers?: Maybe<PaginatedUsersType>;
  participatingAs?: Maybe<Scalars['String']>;
  pmCanEditSkills?: Maybe<Scalars['Boolean']>;
  pmUsersCount?: Maybe<Scalars['Int']>;
  primaryColor?: Maybe<Scalars['String']>;
  primaryContact?: Maybe<UserType>;
  projectUpdatedSlackDaysPref?: Maybe<Scalars['Int']>;
  ratePerUser?: Maybe<Scalars['Float']>;
  resourceManagementEnabled?: Maybe<Scalars['Boolean']>;
  /** @deprecated deprecated for workato */
  salesforceEnabled?: Maybe<Scalars['Boolean']>;
  /** @deprecated moved to workato */
  salesforceIntegration?: Maybe<SalesforceIntegrationType>;
  /** Secure Links enabled for Customer Project Access */
  secureLinksEnabled: Scalars['Boolean'];
  /**
   * TTL (seconds) for the Secure Link token
   * @deprecated TTL for Verification Codes is 15 minutes
   */
  secureLinksTtl: Scalars['Int'];
  setting: OrganizationSetting;
  showShareableLink?: Maybe<Scalars['Boolean']>;
  skillCategories: Array<SkillCategory>;
  slackIntegrations?: Maybe<Array<Maybe<SlackIntegrationType>>>;
  ssoEnabled?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
  statusChangeReasonGroups?: Maybe<Array<StatusChangeReasonGroupType>>;
  taskFilterByFunction?: Maybe<Scalars['Boolean']>;
  taskOwnerUsersCount?: Maybe<Scalars['Int']>;
  templates?: Maybe<Array<Maybe<TemplateType>>>;
  thirdPartyConnectionsCount?: Maybe<Scalars['Int']>;
  /**
   * Get time tracking categories from organization
   * @deprecated deprecated in favor of time_tracking_category_connections
   */
  timeTrackingCategories: Array<TimeTrackingCategory>;
  timeTrackingCategoriesCount?: Maybe<Scalars['Int']>;
  /** Get time tracking categories from organization */
  timeTrackingCategoryConnections: PaginatedCategoriesType;
  timeTrackingEnabled?: Maybe<Scalars['Boolean']>;
  timeZone: Scalars['String'];
  trial: Scalars['Boolean'];
  type?: Maybe<OrganizationTypeEnumType>;
  /** Allow project members to upload files to projects and their tasks */
  uploadsEnabled: Scalars['Boolean'];
  uploadsViaEmailEnabled: Scalars['Boolean'];
  /** Users as a child of an organization with arguments */
  users?: Maybe<Array<Maybe<UserType>>>;
  usersCount?: Maybe<Scalars['Int']>;
  vanitySubdomain?: Maybe<Scalars['String']>;
  whiteLabelingEnabled?: Maybe<Scalars['Boolean']>;
  workatoKey?: Maybe<Scalars['String']>;
}


/** An organization */
export interface OrganizationTypePaginatedUsersArgs {
  listInputs?: InputMaybe<ListInput>;
  userState?: InputMaybe<Scalars['String']>;
}


/** An organization */
export interface OrganizationTypeTimeTrackingCategoriesArgs {
  billable?: InputMaybe<Scalars['Boolean']>;
  listInputs: ListInput;
}


/** An organization */
export interface OrganizationTypeTimeTrackingCategoryConnectionsArgs {
  billable?: InputMaybe<Scalars['Boolean']>;
  listInputs: ListInput;
}


/** An organization */
export interface OrganizationTypeUsersArgs {
  listInputs?: InputMaybe<ListInput>;
  userState?: InputMaybe<Scalars['String']>;
}

/** Enum for the possible organization types */
export enum OrganizationTypeEnumType {
  /** basic */
  Basic = 'BASIC',
  /** provider */
  Provider = 'PROVIDER',
  /** super_admin */
  SuperAdmin = 'SUPER_ADMIN',
  /** third_party */
  ThirdParty = 'THIRD_PARTY'
}

/** Information about pagination in a connection. */
export interface PageInfoType {
  __typename?: 'PageInfoType';
  currentPage?: Maybe<Scalars['Int']>;
  isOutOfBounds?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
  totalResults?: Maybe<Scalars['Int']>;
}

/** List of paginated time tracking categories */
export interface PaginatedCategoriesType {
  __typename?: 'PaginatedCategoriesType';
  categories?: Maybe<Array<TimeTrackingCategory>>;
  pageInfo?: Maybe<PageInfoType>;
}

/** List of paginated customers */
export interface PaginatedCustomersType {
  __typename?: 'PaginatedCustomersType';
  pageInfo?: Maybe<PageInfoType>;
  paginatedCustomers?: Maybe<Array<CustomerType>>;
}

/** List of paginated importer histories */
export interface PaginatedImporterHistoriesType {
  __typename?: 'PaginatedImporterHistoriesType';
  importerHistories?: Maybe<Array<ImporterHistory>>;
  pageInfo?: Maybe<PageInfoType>;
}

/** List of paginated milestones */
export interface PaginatedMilestones {
  __typename?: 'PaginatedMilestones';
  milestones?: Maybe<Array<MilestoneType>>;
  pageInfo?: Maybe<PageInfoType>;
}

/** List of paginated Notes */
export interface PaginatedNotesType {
  __typename?: 'PaginatedNotesType';
  notes?: Maybe<Array<NoteType>>;
  pageInfo?: Maybe<PageInfoType>;
}

/** Information about pagination of projects from the Jira API. */
export interface PaginatedProjectsPageInfoType {
  __typename?: 'PaginatedProjectsPageInfoType';
  currentPage: Scalars['Int'];
  totalPages: Scalars['Int'];
  totalResults: Scalars['Int'];
}

/** List of paginated tags */
export interface PaginatedTagsType {
  __typename?: 'PaginatedTagsType';
  pageInfo?: Maybe<PageInfoType>;
  tags?: Maybe<Array<TagType>>;
}

/** List of paginated tasks */
export interface PaginatedTasks {
  __typename?: 'PaginatedTasks';
  pageInfo: PageInfoType;
  tasks: Array<TaskType>;
}

/** List of paginated users */
export interface PaginatedUsersType {
  __typename?: 'PaginatedUsersType';
  pageInfo?: Maybe<PageInfoType>;
  users?: Maybe<Array<UserType>>;
}

export interface ParticipantInput {
  completed?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['ID']>;
}

export interface ParticipantsGroupType {
  customer?: InputMaybe<Scalars['Boolean']>;
  deselectedParticipants?: InputMaybe<Array<ParticipantInput>>;
  internal?: InputMaybe<Scalars['Boolean']>;
  selectAll: Scalars['Boolean'];
  thirdParty?: InputMaybe<Scalars['Boolean']>;
}

/** A pending custom field */
export interface PendingCustomFieldType {
  __typename?: 'PendingCustomFieldType';
  id: Scalars['ID'];
  value?: Maybe<Scalars['String']>;
}

/** Enum for the possible pending project providers */
export enum PendingProjectProviderEnumType {
  /** hubspot */
  Hubspot = 'HUBSPOT',
  /** open_api */
  OpenApi = 'OPEN_API',
  /** salesforce */
  Salesforce = 'SALESFORCE'
}

/** A pending project */
export interface PendingProjectType {
  __typename?: 'PendingProjectType';
  apiProjectId?: Maybe<Scalars['String']>;
  cashValue?: Maybe<Scalars['Int']>;
  customFields?: Maybe<Array<PendingCustomFieldType>>;
  customerUsersBlob?: Maybe<Array<Scalars['String']>>;
  domain?: Maybe<Scalars['String']>;
  endOn?: Maybe<Scalars['DateType']>;
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationType>;
  projectManager?: Maybe<UserType>;
  provider?: Maybe<Scalars['String']>;
  startOn?: Maybe<Scalars['DateType']>;
  templates?: Maybe<Array<TemplateType>>;
}

/** A connection of pending projects */
export interface PendingProjectsConnectionType {
  __typename?: 'PendingProjectsConnectionType';
  pageInfo?: Maybe<PageInfoType>;
  pendingProjects?: Maybe<Array<PendingProjectType>>;
}

/** A summary for pending projects by provider */
export interface PendingProjectsSummaryType {
  __typename?: 'PendingProjectsSummaryType';
  hubspot: Scalars['Int'];
  openApi: Scalars['Int'];
  salesforce: Scalars['Int'];
  total: Scalars['Int'];
}

/** Information about an specific platform app version. */
export interface PlatformVersionType {
  __typename?: 'PlatformVersionType';
  platform?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
}

/** Enum for the possible drag and drop position qualifiers */
export enum PositionQualifierEnum {
  /** after */
  After = 'AFTER',
  /** before */
  Before = 'BEFORE'
}

export interface PrioritiesInput {
  high: Scalars['String'];
  low: Scalars['String'];
  medium: Scalars['String'];
}

/** Enum for the possible priority types */
export enum PriorityEnumType {
  /** high */
  High = 'HIGH',
  /** low */
  Low = 'LOW',
  /** medium */
  Medium = 'MEDIUM'
}

/** Autogenerated return type of ProductboardToken. */
export interface ProductboardTokenPayload {
  __typename?: 'ProductboardTokenPayload';
  accessToken: Scalars['String'];
}

export interface ProjectBillRateInputType {
  allottedHours?: InputMaybe<Scalars['Float']>;
  allowOverages?: InputMaybe<Scalars['Boolean']>;
  billingProfileId?: InputMaybe<Scalars['ID']>;
  dollars?: InputMaybe<Scalars['Float']>;
  hours?: InputMaybe<Scalars['Float']>;
  projectId?: InputMaybe<Scalars['ID']>;
  rate?: InputMaybe<Scalars['Float']>;
  rateType?: InputMaybe<RateTypeEnum>;
  requireTimeEntry?: InputMaybe<Scalars['Boolean']>;
  secondaryDollars?: InputMaybe<Scalars['Float']>;
  secondaryRateType?: InputMaybe<RateTypeEnum>;
  showHoursToCustomers?: InputMaybe<Scalars['Boolean']>;
  showRemainingHours?: InputMaybe<Scalars['Boolean']>;
  timeTrackingCategoryId?: InputMaybe<Scalars['ID']>;
}

/** A Project Bill Rate object */
export interface ProjectBillRateType {
  __typename?: 'ProjectBillRateType';
  allottedHours?: Maybe<Scalars['Float']>;
  allowOverages?: Maybe<Scalars['Boolean']>;
  billingProfileId?: Maybe<Scalars['ID']>;
  billingProfileName?: Maybe<Scalars['String']>;
  dollars?: Maybe<Scalars['Float']>;
  dollarsHistory: Array<DollarsHistory>;
  hours?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  project?: Maybe<ProjectType>;
  purchasedHoursHistory: Array<PurchasedHoursHistory>;
  purchasedHoursRemaining?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  rateType?: Maybe<RateTypeEnum>;
  requireTimeEntry: Scalars['Boolean'];
  secondaryDollars?: Maybe<Scalars['Float']>;
  secondaryRateType?: Maybe<RateTypeEnum>;
  showHoursToCustomers?: Maybe<Scalars['Boolean']>;
  timeTrackingCategory?: Maybe<TimeTrackingCategory>;
}

/** A connection of projects */
export interface ProjectConnectionType {
  __typename?: 'ProjectConnectionType';
  /** returns the max amount of cash value on the whole project set */
  maxCashValue?: Maybe<Scalars['Int']>;
  pageInfo?: Maybe<PageInfoType>;
  projects?: Maybe<Array<ProjectType>>;
}

/** Count of the projects by sequential days */
export interface ProjectCountPerDayType {
  __typename?: 'ProjectCountPerDayType';
  organizationId?: Maybe<Scalars['ID']>;
  projectManagerId?: Maybe<Scalars['ID']>;
  projectsCount?: Maybe<Scalars['Int']>;
  sequentialDate?: Maybe<Scalars['DateType']>;
  sequentialWeek?: Maybe<Scalars['Int']>;
}

export interface ProjectCustomFieldInputType {
  customFieldId?: InputMaybe<Scalars['ID']>;
  value?: InputMaybe<Scalars['String']>;
}

/** Data needed for the project filter chip component */
export interface ProjectFilterChipType {
  __typename?: 'ProjectFilterChipType';
  key: Scalars['String'];
  label: Scalars['String'];
  value: Array<Scalars['String']>;
}

export interface ProjectFilters {
  activeMilestoneNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  brandNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cashValueRange?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  context?: InputMaybe<UserProjectOrganizationTypeEnumType>;
  customerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  endOn?: InputMaybe<Scalars['DateType']>;
  filterDateBy?: InputMaybe<Scalars['String']>;
  lastUpdatedDays?: InputMaybe<Scalars['Int']>;
  operators?: InputMaybe<FiltersOperatorType>;
  projectId?: InputMaybe<Scalars['ID']>;
  projectLateDays?: InputMaybe<Scalars['Int']>;
  projectManagerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  startOn?: InputMaybe<Scalars['DateType']>;
  statuses?: InputMaybe<Array<InputMaybe<StatusEnumType>>>;
  /** This field limit the list of projects to only projects where the User is an assignee on tasks */
  strict?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  templateIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  templateNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
}

export interface ProjectFiltersInput {
  activeMilestoneNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  brandNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cashValueRange?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  context?: InputMaybe<UserProjectOrganizationTypeEnumType>;
  customerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  endOn?: InputMaybe<Scalars['DateType']>;
  filterDateBy?: InputMaybe<Scalars['String']>;
  lastUpdatedDays?: InputMaybe<Scalars['Int']>;
  operators?: InputMaybe<FiltersOperatorType>;
  projectId?: InputMaybe<Scalars['ID']>;
  projectLateDays?: InputMaybe<Scalars['Int']>;
  projectManagerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  startOn?: InputMaybe<Scalars['DateType']>;
  statuses?: InputMaybe<Array<InputMaybe<StatusEnumType>>>;
  /** This field limit the list of projects to only projects where the User is an assignee on tasks */
  strict?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  templateIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
}

/** Filter Operator return type */
export interface ProjectFiltersOperators {
  __typename?: 'ProjectFiltersOperators';
  milestoneOperator?: Maybe<OperatorEnumType>;
  tagOperator?: Maybe<OperatorEnumType>;
  templateOperator?: Maybe<OperatorEnumType>;
}

export interface ProjectInfoFieldInput {
  infoFieldId: Scalars['ID'];
  infoFieldType: InfoFieldsEnum;
  projectInfoFieldId?: InputMaybe<Scalars['ID']>;
  value: Scalars['String'];
}

/** A connection of projects */
export interface ProjectListSummaryType {
  __typename?: 'ProjectListSummaryType';
  customerProjectsCount?: Maybe<Scalars['Int']>;
  providerProjectsCount?: Maybe<Scalars['Int']>;
  thirdPartyProjectsCount?: Maybe<Scalars['Int']>;
}

/** A paginated list of projects with filters */
export interface ProjectListType {
  __typename?: 'ProjectListType';
  appliedFilters?: Maybe<AppliedProjectFilters>;
  /** returns the max amount of cash value on the whole project set */
  maxCashValue?: Maybe<Scalars['Int']>;
  pageInfo?: Maybe<PageInfoType>;
  projects?: Maybe<Array<ProjectType>>;
  userFilterViews?: Maybe<Array<UserFilterViewType>>;
}

/** A project merge tag */
export interface ProjectMergeTag {
  __typename?: 'ProjectMergeTag';
  id: Scalars['ID'];
  mergeTag: MergeTag;
  value?: Maybe<Scalars['String']>;
}

/** Enum for the possible project or template type */
export enum ProjectOrTemplateEnumType {
  /** project */
  Project = 'PROJECT',
  /** template */
  Template = 'TEMPLATE'
}

/** skills with categories in template or project */
export interface ProjectOrTemplateSkillsType {
  __typename?: 'ProjectOrTemplateSkillsType';
  skillCategories?: Maybe<Array<SkillCategory>>;
}

/** Enum for the project overview email preferences */
export enum ProjectOverviewEmailPrefEnumType {
  /** daily */
  Daily = 'DAILY',
  /** monthly */
  Monthly = 'MONTHLY',
  /** overview_off */
  OverviewOff = 'OVERVIEW_OFF',
  /** weekly */
  Weekly = 'WEEKLY'
}

/** Analysis of total billing, cost, and profitability of a project */
export interface ProjectProfitabilitySummaryType {
  __typename?: 'ProjectProfitabilitySummaryType';
  budgetedCost?: Maybe<Scalars['Int']>;
  forecastedCost?: Maybe<Scalars['Int']>;
  totalBilledAmount: Scalars['Int'];
  totalCost?: Maybe<Scalars['Int']>;
  totalProfit?: Maybe<Scalars['Int']>;
}

/** a role assigned in a project */
export interface ProjectRoleType {
  __typename?: 'ProjectRoleType';
  former: Scalars['Boolean'];
  role: Skill;
}

/** A project summary bank */
export interface ProjectStats {
  __typename?: 'ProjectStats';
  forecastedHours?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  totalActionItems: Scalars['Int'];
  totalActualHours?: Maybe<Scalars['Float']>;
  totalAssignedTasks: Scalars['Int'];
  totalCustomerActiveOverdueTasks: Scalars['Int'];
  totalCustomerActualHours?: Maybe<Scalars['Float']>;
  totalCustomerDoneTasks: Scalars['Int'];
  totalCustomerEstimatedHours?: Maybe<Scalars['Float']>;
  totalCustomerNotStartedTasks: Scalars['Int'];
  totalCustomerOverdueTasks: Scalars['Int'];
  totalCustomerPlannedTasks: Scalars['Int'];
  totalCustomerRemainingHours?: Maybe<Scalars['Float']>;
  totalCustomerRemainingTasks: Scalars['Int'];
  totalCustomerSignOffTasks: Scalars['Int'];
  totalCustomerStuckTasks: Scalars['Int'];
  totalCustomerTasks: Scalars['Int'];
  totalCustomerWorkingOnItTasks: Scalars['Int'];
  totalDoneTasks: Scalars['Int'];
  totalEstimatedHours?: Maybe<Scalars['Float']>;
  totalInternalActiveOverdueTasks: Scalars['Int'];
  totalInternalActualHours?: Maybe<Scalars['Float']>;
  totalInternalDoneTasks: Scalars['Int'];
  totalInternalEstimatedHours?: Maybe<Scalars['Float']>;
  totalInternalLoggedBillableHours?: Maybe<Scalars['Float']>;
  totalInternalLoggedHours?: Maybe<Scalars['Float']>;
  totalInternalLoggedNonBillableHours?: Maybe<Scalars['Float']>;
  totalInternalNotStartedTasks: Scalars['Int'];
  totalInternalOverdueTasks: Scalars['Int'];
  totalInternalPlannedTasks: Scalars['Int'];
  totalInternalRemainingHours?: Maybe<Scalars['Float']>;
  totalInternalRemainingPurchasedHours?: Maybe<Scalars['Float']>;
  totalInternalRemainingTasks: Scalars['Int'];
  totalInternalSignOffTasks: Scalars['Int'];
  totalInternalStuckTasks: Scalars['Int'];
  totalInternalTasks: Scalars['Int'];
  totalInternalWorkingOnItTasks: Scalars['Int'];
  totalNotStartedTasks: Scalars['Int'];
  totalOpenActionItems: Scalars['Int'];
  totalSignOffTasks: Scalars['Int'];
  totalStuckTasks: Scalars['Int'];
  totalTasks: Scalars['Int'];
  totalTasksWithEstimatedHoursCount?: Maybe<Scalars['Float']>;
  totalTasksWithUnestimatedHoursCount?: Maybe<Scalars['Float']>;
  totalThirdPartyActiveOverdueTasks: Scalars['Int'];
  totalThirdPartyActualHours?: Maybe<Scalars['Float']>;
  totalThirdPartyDoneTasks: Scalars['Int'];
  totalThirdPartyEstimatedHours?: Maybe<Scalars['Float']>;
  totalThirdPartyNotStartedTasks: Scalars['Int'];
  totalThirdPartyOverdueTasks: Scalars['Int'];
  totalThirdPartyPlannedTasks: Scalars['Int'];
  totalThirdPartyRemainingHours?: Maybe<Scalars['Float']>;
  totalThirdPartyRemainingTasks: Scalars['Int'];
  totalThirdPartySignOffTasks: Scalars['Int'];
  totalThirdPartyStuckTasks: Scalars['Int'];
  totalThirdPartyTasks: Scalars['Int'];
  totalThirdPartyWorkingOnItTasks: Scalars['Int'];
  totalWorkingOnItTasks: Scalars['Int'];
}

/** A status that a Jira project can have */
export interface ProjectStatus {
  __typename?: 'ProjectStatus';
  id: Scalars['String'];
  name: Scalars['String'];
}

/** Project Status Change Reason */
export interface ProjectStatusChangeReasonType {
  __typename?: 'ProjectStatusChangeReasonType';
  createdAt: Scalars['DateTimeType'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  statusChangeReason: StatusChangeReasonType;
  updatedAt: Scalars['DateTimeType'];
  user?: Maybe<UserType>;
}

/** Enum for the possible project status types */
export enum ProjectStatusEnum {
  /** cancelled */
  Cancelled = 'CANCELLED',
  /** done */
  Done = 'DONE',
  /** late */
  Late = 'LATE',
  /** on_hold */
  OnHold = 'ON_HOLD',
  /** on_time */
  OnTime = 'ON_TIME'
}

/** A function for the project team */
export interface ProjectTeamFunction {
  __typename?: 'ProjectTeamFunction';
  hasUnassignedUsers?: Maybe<Scalars['Boolean']>;
  roles?: Maybe<Array<Skill>>;
  users?: Maybe<Array<UserType>>;
}

/** A unassigned user for the project team */
export interface ProjectTeamUnassignedUsers {
  __typename?: 'ProjectTeamUnassignedUsers';
  users?: Maybe<Array<UserType>>;
}

/** A project */
export interface ProjectType {
  __typename?: 'ProjectType';
  /** Action items */
  actionItems?: Maybe<Array<ActionItemType>>;
  archivedAt?: Maybe<Scalars['DateType']>;
  bccEmails?: Maybe<Scalars['String']>;
  bccEmailsEnabled?: Maybe<Scalars['Boolean']>;
  bccToProjectManager?: Maybe<Scalars['Boolean']>;
  brand?: Maybe<BrandType>;
  cashValue?: Maybe<Scalars['Int']>;
  completedAt?: Maybe<Scalars['DateType']>;
  createdAt: Scalars['DateType'];
  /** Indicates if the project is actively being populated */
  creating?: Maybe<Scalars['Boolean']>;
  currentUserProjectContext?: Maybe<UserProjectOrganizationTypeEnumType>;
  currentUserProjectTasksCount?: Maybe<Scalars['Int']>;
  currentUserRestrictedAccess?: Maybe<Scalars['Boolean']>;
  currentUserSettings?: Maybe<UserProject>;
  customerUsers?: Maybe<Array<UserType>>;
  customerV2?: Maybe<CustomerType>;
  deletedAt?: Maybe<Scalars['DateType']>;
  displayOrganization?: Maybe<DisplayOrganizationType>;
  doneTasksCount?: Maybe<Scalars['Int']>;
  endOn?: Maybe<Scalars['DateType']>;
  errorsCount: Scalars['Int'];
  externalId?: Maybe<Scalars['String']>;
  files?: Maybe<Array<FileType>>;
  firstActiveTemplate?: Maybe<Scalars['ID']>;
  /** Dynamic date calculated from project plan dates and dependencies */
  forecastedEndOn?: Maybe<Scalars['DateType']>;
  genericTimeReport: TimeReport;
  /** @deprecated Replaced to their own resolver ProjectTeamFunctions */
  groupedRoles: Array<Array<Skill>>;
  hubspotDealName?: Maybe<Scalars['String']>;
  hubspotObjectLink?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  jiraEpicLink?: Maybe<Scalars['String']>;
  languageName?: Maybe<Scalars['String']>;
  lastActivityAt?: Maybe<Scalars['DateType']>;
  lateProjectNotificationSentAt?: Maybe<Scalars['DateType']>;
  milestoneCount: Scalars['Int'];
  milestones?: Maybe<Array<MilestoneType>>;
  name: Scalars['String'];
  notes?: Maybe<Array<NoteType>>;
  openActionItemsCount?: Maybe<Scalars['Int']>;
  openTasksCount?: Maybe<Scalars['Int']>;
  organization?: Maybe<OrganizationType>;
  overdueTasksCount?: Maybe<Scalars['Int']>;
  overviewEmailScheduled: Scalars['Boolean'];
  /** Get your paginated milestones here */
  paginatedMilestones: PaginatedMilestones;
  pmDisplayRole?: Maybe<Scalars['String']>;
  pmNote?: Maybe<Scalars['String']>;
  pmNoteInternalOnly?: Maybe<Scalars['Boolean']>;
  profitabilitySummary?: Maybe<ProjectProfitabilitySummaryType>;
  projectBillRate?: Maybe<ProjectBillRateType>;
  projectManager?: Maybe<UserType>;
  projectStatusChangeReason?: Maybe<ProjectStatusChangeReasonType>;
  projectStatusChangeReasons?: Maybe<Array<ProjectStatusChangeReasonType>>;
  projectType?: Maybe<ProjectTypeEnumType>;
  properties: Array<Property>;
  roles: Array<Skill>;
  salesforceObjectId?: Maybe<Scalars['String']>;
  salesforceObjectLink?: Maybe<Scalars['String']>;
  salesforceOpportunityName?: Maybe<Scalars['String']>;
  /** Should this project calculate a forecasted end date */
  showForecast: Scalars['Boolean'];
  skillCategories: Array<SkillCategory>;
  startOn?: Maybe<Scalars['DateType']>;
  stats?: Maybe<ProjectStats>;
  status: StatusEnumType;
  stuckTasksCount?: Maybe<Scalars['Int']>;
  tags?: Maybe<Array<TagType>>;
  tasks: Array<TaskType>;
  templates?: Maybe<Array<TemplateType>>;
  /** Fetches all time records of a project given a user and a time period */
  timeRecordsPeriod: Array<TimeRecordType>;
  timeReport: TimeReport;
  timeReportingTasksCount: Scalars['Int'];
  /** Get time tracking categories from project */
  timeTrackingCategoryConnections: PaginatedCategoriesType;
  timeZone: Scalars['String'];
  totalTasksCount?: Maybe<Scalars['Int']>;
  userTimeCapacities: Array<CapacityType>;
  users?: Maybe<Array<UserType>>;
  usesCategories: Scalars['Boolean'];
}


/** A project */
export interface ProjectTypeActionItemsArgs {
  actionItemFilters?: InputMaybe<FiltersInput>;
  listInputs?: InputMaybe<ListInputTypeV2>;
}


/** A project */
export interface ProjectTypeGenericTimeReportArgs {
  endDate: Scalars['DateType'];
  filters?: InputMaybe<TimeReportFiltersInput>;
  startDate: Scalars['DateType'];
  userId?: InputMaybe<Scalars['ID']>;
}


/** A project */
export interface ProjectTypePaginatedMilestonesArgs {
  endDate?: InputMaybe<Scalars['DateType']>;
  filters?: InputMaybe<TimeReportFiltersInput>;
  listInputs: ListInput;
  startDate?: InputMaybe<Scalars['DateType']>;
}


/** A project */
export interface ProjectTypeTasksArgs {
  context?: InputMaybe<UserProjectOrganizationTypeEnumType>;
  taskFilters?: InputMaybe<TaskFilters>;
}


/** A project */
export interface ProjectTypeTimeRecordsPeriodArgs {
  endDate?: InputMaybe<Scalars['DateType']>;
  startDate?: InputMaybe<Scalars['DateType']>;
  userId?: InputMaybe<Scalars['ID']>;
}


/** A project */
export interface ProjectTypeTimeReportArgs {
  endDate: Scalars['DateType'];
  filters?: InputMaybe<TimeReportFiltersInput>;
  includeGeneric?: InputMaybe<Scalars['Boolean']>;
  startDate: Scalars['DateType'];
  userId?: InputMaybe<Scalars['ID']>;
}


/** A project */
export interface ProjectTypeTimeReportingTasksCountArgs {
  endDate: Scalars['DateType'];
  filters?: InputMaybe<TimeReportFiltersInput>;
  startDate: Scalars['DateType'];
  userId?: InputMaybe<Scalars['ID']>;
}


/** A project */
export interface ProjectTypeTimeTrackingCategoryConnectionsArgs {
  billable?: InputMaybe<Scalars['Boolean']>;
  focusMode?: InputMaybe<Scalars['Boolean']>;
  listInputs: ListInput;
}


/** A project */
export interface ProjectTypeUserTimeCapacitiesArgs {
  filters: CapacityFilterInput;
  groupBy: CapacityGroupByEnum;
  userId?: InputMaybe<Scalars['ID']>;
}

/** Enum for the possible project types */
export enum ProjectTypeEnumType {
  /** external */
  External = 'EXTERNAL',
  /** internal */
  Internal = 'INTERNAL'
}

/** Project subscription payload, includes stats as well */
export interface ProjectUpdatePayloadType {
  __typename?: 'ProjectUpdatePayloadType';
  project?: Maybe<ProjectType>;
  projectStats?: Maybe<ProjectStats>;
}

export interface ProjectUserInput {
  customerRoleId?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  lastName?: InputMaybe<Scalars['String']>;
  projectView?: InputMaybe<ProjectViewEnum>;
  restrictAccess?: InputMaybe<Scalars['Boolean']>;
}

/** Enum for the possible project views for customers */
export enum ProjectViewEnum {
  /** compass */
  Compass = 'COMPASS',
  /** legacy */
  Legacy = 'LEGACY'
}

/** A connection of users with time records */
export interface ProjectsTimeReportType {
  __typename?: 'ProjectsTimeReportType';
  pageInfo?: Maybe<PageInfoType>;
  projects?: Maybe<Array<ProjectType>>;
}

/** A generic property for a project or task */
export interface Property {
  __typename?: 'Property';
  name: Scalars['String'];
  value?: Maybe<Scalars['PropertyValue']>;
}

export interface PropertyInput {
  name: Scalars['String'];
  value?: InputMaybe<Scalars['PropertyValue']>;
}

/** The public profile for a customer */
export interface PublicCustomer {
  __typename?: 'PublicCustomer';
  domain: Scalars['String'];
  id: Scalars['ID'];
  logo?: Maybe<ImageType>;
  name: Scalars['String'];
}

/** Milestone information that is available for public projects */
export interface PublicMilestone {
  __typename?: 'PublicMilestone';
  active: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
}

/** The public profile for an organization */
export interface PublicOrganization {
  __typename?: 'PublicOrganization';
  domain: Scalars['String'];
  id: Scalars['ID'];
  logo?: Maybe<ImageType>;
  name: Scalars['String'];
}

/** Public facing version of a project to be used for building shareable links */
export interface PublicProject {
  __typename?: 'PublicProject';
  activeMilestones: Array<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateType']>;
  currentUserSettings?: Maybe<UserProject>;
  /** Customer of an external project. Will be null for internal projects */
  customer?: Maybe<PublicCustomer>;
  displayOrganization?: Maybe<DisplayOrganizationType>;
  endOn?: Maybe<Scalars['DateType']>;
  forecastedEndOn?: Maybe<Scalars['DateType']>;
  id: Scalars['ID'];
  manager?: Maybe<PublicUserProfile>;
  managerDisplayRole?: Maybe<Scalars['String']>;
  managerNote?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organization?: Maybe<PublicOrganization>;
  projectType: ProjectTypeEnumType;
  startOn: Scalars['DateType'];
  status: StatusEnumType;
  tags?: Maybe<Array<TagType>>;
  team?: Maybe<Array<PublicUserProfile>>;
  templates?: Maybe<Array<PublicTemplate>>;
}

/** Public facing version of a task for email actions */
export interface PublicTask {
  __typename?: 'PublicTask';
  assignee?: Maybe<PublicUserProfile>;
  createdAt?: Maybe<Scalars['DateType']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  milestone: PublicMilestone;
  name: Scalars['String'];
  project?: Maybe<PublicProject>;
  responsibility: TaskResponsibilityEnumType;
  status: TaskStatusEnum;
  taskParticipants?: Maybe<Array<TaskParticipantType>>;
  template: PublicTemplate;
  updatedAt?: Maybe<Scalars['DateType']>;
}

/** Template information that is available for public projects */
export interface PublicTemplate {
  __typename?: 'PublicTemplate';
  id: Scalars['ID'];
  milestones?: Maybe<Array<PublicMilestone>>;
  name: Scalars['String'];
  overview?: Maybe<Scalars['String']>;
  videoPlaceholderImage?: Maybe<ImageType>;
  videoUrl?: Maybe<Scalars['String']>;
}

/** User attributes that can be used for public project overviews */
export interface PublicUserProfile {
  __typename?: 'PublicUserProfile';
  avatar?: Maybe<ImageType>;
  /** Email address of the user. Will be null if project settings hide emails */
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  jobRole?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  projectContext?: Maybe<UserProjectOrganizationTypeEnumType>;
}

/** An additional purchased hours history */
export interface PurchasedHoursHistory {
  __typename?: 'PurchasedHoursHistory';
  date: Scalars['DateType'];
  purchasedHours: Scalars['Float'];
}

export interface Query {
  __typename?: 'Query';
  /** An action item */
  actionItem: ActionItemType;
  /** All users who belong to an admin team */
  adminTeam?: Maybe<Array<UserType>>;
  /** Fetches all milestones given a project_id */
  allProjectMilestones?: Maybe<Array<MilestoneType>>;
  /** Fetches all the users */
  allUsers: PaginatedUsersType;
  /** Fetches all tags available for a project or a task */
  availableTags?: Maybe<Array<TagType>>;
  /** Get billing profiles by organization */
  billingProfileConnections: BillingProfileConnectionType;
  /** Does an existing billing profile have the same name (case insensitive) */
  billingProfileNameExists: BillingProfileNameExistsType;
  /** A blueprint template */
  blueprintTemplate: TemplateType;
  /** Fetches all brands */
  brands?: Maybe<Array<BrandType>>;
  /**
   * Users with active projects or tasks cannot be deactivated without
   * reassignment. This will return all projects and tasks that need
   * to be reassigned before the user can be deactivated. If none are
   * found then the user is safe to deactivate.
   *
   */
  checkCanDeactivateUser?: Maybe<CheckCanDeactivateUserPayload>;
  /** Checks if invitation token is still valid for a user */
  checkInvitationToken?: Maybe<CheckInvitationTokenType>;
  /** Checks if any user to be removed has pending tasks with a specific role */
  checkPendingTasksRole?: Maybe<Array<UserType>>;
  /** Retrieves all common potential task watchers for an array of tasks */
  commonTaskWatchers?: Maybe<Array<UserType>>;
  /** Fetches all provider tasks by project for the current customer user */
  compassExperienceProviderTasksByProject?: Maybe<CompassProviderTasksByProjectType>;
  /** Fetches all tasks for the current customer user */
  compassExperienceUserTasksConnections?: Maybe<TaskConnectionType>;
  /** Fetches all file assets for a project in Compass */
  compassFiles?: Maybe<AssetConnectionType>;
  /** Return Completed Projects data for Line Chart (Project Trends) */
  completedProjectData?: Maybe<Array<MonthlyProjectCompletionDataType>>;
  /** Returns data for completed project duration trends report. */
  completedProjectDurationsTrendsTable?: Maybe<Array<MonthlyCompletedProjectDurationData>>;
  /** Fetches all integration connectors */
  connectors: Array<Connector>;
  /** Fetches the current authenticated user */
  currentUser?: Maybe<UserType>;
  /**
   * Fetches all tags of a given type for the current user
   * @deprecated use paginated current user tags
   */
  currentUserTags?: Maybe<Array<TagType>>;
  /** A customer */
  customer?: Maybe<CustomerType>;
  /** Customer project status for the widget in the customer dashboard */
  customerActiveProjectStatus?: Maybe<CustomerActiveProjectStatusType>;
  /** Fetches all projects from a customer */
  customerProjectList?: Maybe<CustomerProjectConnectionType>;
  /** Customer task status for the widget in the customer dashboard */
  customerTaskStatus?: Maybe<CustomerTaskStatusType>;
  /** Fetches all customers */
  customers?: Maybe<PaginatedCustomersType>;
  /** Return Dashboard Chart values depending on the type of data requested */
  dashboardChartValues?: Maybe<Array<DashboardType>>;
  /** Checks whether a dropped template, milestone, or task is eligible to be dropped with existing dependencies */
  dropEligibility?: Maybe<DropEligibilityType>;
  /** Return Early Tasks data for Project Trends Info */
  earlyTasksTrendsTable?: Maybe<Array<TaskTrendsDataType>>;
  /** Returns true if a user with the provided email exists. */
  emailTaken: Scalars['Boolean'];
  /** Returns the difference in event task information between proposed and current data */
  eventTaskDiff?: Maybe<TaskEventDiffType>;
  /** Fetches all file assets for an object */
  files?: Maybe<AssetConnectionType>;
  /** Returns the firebase messaging token for the current user. */
  firebaseMessagingToken?: Maybe<Scalars['String']>;
  /** Fetches all milestones from first active template of project */
  firstActiveTemplateMilestones?: Maybe<Array<MilestoneType>>;
  /** Forecasted end date for customer projects */
  forecastedEndDate?: Maybe<ForecasteEndDate>;
  /** Fetches Gainsight settings for organization */
  gainsightSettings?: Maybe<GainsightSettings>;
  /** Fetches the data required for the Gantt Chart View */
  ganttChartTimelines?: Maybe<Array<GanttChartConnectionType>>;
  /** Fetches paginated time records by task */
  genericTimeRecords?: Maybe<TaskTimeRecords>;
  /** Returns the URL redirect for the user based on the email provided. */
  getAuthRedirect?: Maybe<Scalars['String']>;
  /** Fetches average csat score for customer */
  getAverageCsatPerCustomer?: Maybe<AverageMilestoneCsatType>;
  /** Fetches the current agent user for the organization */
  getCurrentAgentUser?: Maybe<AgentUserType>;
  /** Get HubSpot OAuth URI to be sent to the user */
  getHubSpotOAuthLink?: Maybe<Scalars['String']>;
  /** Fetches all tags available for a project or a task */
  getLastWebhookDeliveries?: Maybe<Array<WebhookDeliveryType>>;
  /** Domain authentication for organization */
  getOrganizationDomains?: Maybe<Array<DomainVerificationRecordsType>>;
  /** Gets the mobile app version for a given platform */
  getPlatformAppVersion?: Maybe<PlatformVersionType>;
  /** Get package installation status from Salesforce */
  getSalesforcePackageInstallationStatus?: Maybe<SalesforcePackageStatusReturnType>;
  /** Slack channel for organization */
  getSlackChannels?: Maybe<Array<SlackIntegrationType>>;
  /** Fetches all the users that are available to be assigned as an agent for the organization */
  getValidUsersForAgentUser?: Maybe<Array<UserType>>;
  /**
   * Performs a search
   * @deprecated global search is deprecated. Will return zero results
   */
  globalSearch?: Maybe<GlobalSearchType>;
  /** Get organization importer history */
  importerHistories?: Maybe<PaginatedImporterHistoriesType>;
  /** Get organization info fields */
  infoFields?: Maybe<Array<MergeTag>>;
  /** Checks if a user has already accepted an invitation */
  invitationAcceptedCheck?: Maybe<InvitationCheckType>;
  /** retrieve a Jira Epic */
  jiraEpic: JiraEpic;
  /** retrieve Jira Epics */
  jiraEpics?: Maybe<Array<JiraEpic>>;
  /** retrieve global Jira issue types */
  jiraGlobalIssueTypes: Array<WorkatoJiraIssueType>;
  /** retrieve the global statuses that a Jira issue can have */
  jiraGlobalStatuses?: Maybe<Array<JiraStatus>>;
  /** retrieve the Priorities that a Jira issue can have */
  jiraPriorities?: Maybe<Array<JiraPriority>>;
  /** retrieve the Issue Types associated with this project */
  jiraProjectIssueTypes: Array<WorkatoJiraIssueType>;
  /** retrieve the Statuses that a particular Jira Project can have */
  jiraProjectStatuses?: Maybe<Array<ProjectStatus>>;
  /** retrieve the Jira Projects associated with this integration */
  jiraProjects?: Maybe<JiraPaginatedProjectType>;
  /** Fetches Jira settings for organization */
  jiraSettings?: Maybe<JiraSettings>;
  /** Return Late Tasks data for Project Trends Info */
  lateTasksTrendsTable?: Maybe<Array<TaskTrendsDataType>>;
  /** Get merge tags options */
  mergeTagOptions?: Maybe<Array<MergeTag>>;
  /** Get merge tags values */
  mergeTagValues?: Maybe<Array<ProjectMergeTag>>;
  /** Get merge tags for a project, task or action item */
  mergeTags?: Maybe<Array<MergeTagType>>;
  /** A milestone */
  milestone: MilestoneType;
  /** Gets count of tasks for a milestone */
  milestoneTaskCount?: Maybe<Scalars['Int']>;
  /** Check the expected task-dependency-violations as a result of a milestone move */
  moveMilestoneDependencyCheck: DependencyCheckResponseType;
  /** Fetches all notes for a noteable */
  noteableNotes?: Maybe<Array<NoteType>>;
  /** Fetches all notes for a noteable paginated */
  noteablePaginatedNotes?: Maybe<PaginatedNotesType>;
  /** returns all the notes for any noteable for a given customer user */
  notesByCustomerUser?: Maybe<NotesByCustomerUserConnectionType>;
  /** Fetches a paginated list of all of a users notifications of the given notification types */
  notificationConnections?: Maybe<NotificationConnections>;
  /** Returns an array of errors */
  notificationErrors?: Maybe<NotificationError>;
  /** An organization */
  organization?: Maybe<OrganizationType>;
  /** Get an org by domain, checks our DB then third party service */
  organizationByDomain?: Maybe<SuggestedOrgType>;
  /** Fetches all connected users to organization */
  organizationConnectedUsers?: Maybe<OrganizationConnectedUsersType>;
  /** Fetches all organizations, for super admin only */
  organizationConnections?: Maybe<OrganizationConnectionType>;
  /** All customers for an org for current user */
  organizationCustomers?: Maybe<Array<OrganizationType>>;
  /** Fetches all users for the current user's organization */
  organizationUsers: Array<UserType>;
  /** Fetches paginated current user tags */
  paginatedCurrentUserTags?: Maybe<PaginatedTagsType>;
  /** All potential assignees users for a single task in a template or project */
  paginatedPotentialSingleTaskAssignees?: Maybe<PaginatedUsersType>;
  /** All potential task users for a template or project */
  paginatedPotentialTaskAssignees?: Maybe<PaginatedUsersType>;
  /** All potential participant users for a task in template or project */
  paginatedPotentialTaskParticipants?: Maybe<PaginatedUsersType>;
  /** Fetches paginated potential user task assignees */
  paginatedUserTaskAssignees?: Maybe<PaginatedUsersType>;
  /** Fetches a pending project by ID */
  pendingProject?: Maybe<PendingProjectType>;
  /** Fetches all pending projects with pagination */
  pendingProjectsConnections?: Maybe<PendingProjectsConnectionType>;
  /** Returns the count of the pending projects by provider */
  pendingProjectsSummary?: Maybe<PendingProjectsSummaryType>;
  /** Gets milestones that tasks in a milestone can be dependent upon (ie all milestones before a milestone column) */
  potentialDependentMilestones?: Maybe<Array<MilestoneType>>;
  /** Gets task groups that tasks in a milestone can be dependent upon (ie all task groups before a milestone column) */
  potentialDependentTaskGroups?: Maybe<Array<TaskGroupType>>;
  /** Gets tasks that tasks in a milestone can be dependent upon (ie all tasks before a milestone column) */
  potentialDependentTasks?: Maybe<Array<TaskType>>;
  /** Gets the template that the tasks of a milestone in a template can be dependent upon (ie the template before this task - and only in a sequential project) */
  potentialDependentTemplate: Array<Maybe<TemplateType>>;
  /** All users in org that are not in project */
  potentialProjectUsers: Array<UserType>;
  /**
   * All potential task users for a template or project
   * @deprecated use paginated potential task assignees
   */
  potentialTaskAssignees?: Maybe<Array<UserType>>;
  /** Gets a list of potencial watchers for the given task, it depends on the task reponsibility */
  potentialTaskWatchers?: Maybe<Array<UserType>>;
  /** All third party users for an org that are not in project */
  potentialThirdPartyUsers: Array<UserType>;
  /** All relevant users in org */
  potentialTimeRecordUsers: Array<UserType>;
  /** A project */
  project: ProjectType;
  /** Fetches all active milestones from a user's projects. */
  projectActiveMilestones?: Maybe<Array<Scalars['String']>>;
  /** Fetches all activities for a project */
  projectActivities?: Maybe<Array<ActivityType>>;
  /** Fetches all activities for a project paginated */
  projectActivitiesConnections?: Maybe<ActivityConnectionType>;
  /** Fetches all project brands for a user org */
  projectBrands?: Maybe<Array<Scalars['String']>>;
  /** Fetches the data needed for project filter chip components */
  projectFilterChips?: Maybe<Array<Maybe<ProjectFilterChipType>>>;
  /** Get project info fields with the values */
  projectInfoFields?: Maybe<Array<ProjectMergeTag>>;
  /** Returns the count of the user's projects' contexts */
  projectListSummary?: Maybe<ProjectListSummaryType>;
  /** All project managers for an org for current_user */
  projectManagers?: Maybe<Array<UserType>>;
  /** Fetch one milestone given a milestone_id */
  projectMilestone?: Maybe<MilestoneType>;
  /** Fetches all milestones given a template_id in projects */
  projectMilestones?: Maybe<Array<MilestoneType>>;
  /** Get existing skills in project or template */
  projectOrTemplateSkills: ProjectOrTemplateSkillsType;
  /** Fetches all projects for time reporting */
  projectReportingList?: Maybe<ProjectsTimeReportType>;
  /** Get Status Change Reasons by Project */
  projectStatusChangeReasonConnections: Array<ProjectStatusChangeReasonType>;
  /** A Task Group */
  projectTaskGroup: TaskGroupType;
  /** Fetches all task groups given a milestone_id */
  projectTaskGroups?: Maybe<Array<TaskGroupType>>;
  /** Fetches all project or task notes paginated */
  projectTaskNotes?: Maybe<PaginatedNotesType>;
  /** Fetches all tasks for a given project */
  projectTasks?: Maybe<Array<TaskType>>;
  /** All users belonging to a given project */
  projectTeam: Array<UserType>;
  /** Functions and users for the project team */
  projectTeamFunctions?: Maybe<Array<ProjectTeamFunction>>;
  /** Users that are not assigned with functions for the project team */
  projectTeamInternalUnassignedUsers?: Maybe<ProjectTeamUnassignedUsers>;
  /** A project template */
  projectTemplate: TemplateType;
  /** Fetches all parent blueprint templates from a user's projects and if admin, all the orgs templates. */
  projectTemplates?: Maybe<Array<TemplateType>>;
  /** Fetches all time records by project */
  projectTimeRecords?: Maybe<Array<TimeRecordType>>;
  /** users belonging to a given project group by type */
  projectUsers?: Maybe<PaginatedUsersType>;
  /** Fetches all projects more efficiently */
  projects?: Maybe<ProjectListType>;
  /** Fetches all projects */
  projectsConnections?: Maybe<ProjectConnectionType>;
  /** A public/shareable version of a project */
  publicProject?: Maybe<PublicProject>;
  /** returns the customers in the users organization and their most recent note across any notable */
  recentCustomerNotes?: Maybe<RecentCustomerNotesConnectionType>;
  /** returns the most recent note for any noteable for a given customer of an organization */
  recentNotesByCustomer?: Maybe<RecentNotesByCustomerConnectionType>;
  /** Fetches all reports for an organization */
  reportsForOrganization: Array<OrganizationProjectReports>;
  /** paginated resource management users */
  resourceManagementUsers?: Maybe<OrganizationConnectedUsersType>;
  /** internal and third party users in org */
  resourcesUsers?: Maybe<OrganizationConnectedUsersType>;
  /** Retrieves all watchers per role in a project */
  roleTaskWatchers?: Maybe<Array<UserType>>;
  /** Retrieves all watchers per roles in a project */
  rolesTaskWatchers?: Maybe<Array<UserType>>;
  /** Paginated Organizations for Super Admins */
  searchOrganizations?: Maybe<OrganizationConnectionType>;
  /** Resolver for the customer object searchable dropdown */
  searchableCustomers?: Maybe<PaginatedCustomersType>;
  /** Fetches SharePoint lists for a SharePoint site */
  sharepointLists: Array<List>;
  /** Fetches SharePoint sites for an organization */
  sharepointSites: Array<Site>;
  /** Gets a skill by ID */
  skill: Skill;
  /** fetches all skills in org */
  skillsConnections?: Maybe<SkillConnectionType>;
  /** Fetches all stats given an object id */
  stats?: Maybe<Stats>;
  /** Get Status Change Reason Groups by Organization */
  statusChangeReasonGroupConnections: Array<StatusChangeReasonGroupType>;
  /** Return Stuck Tasks data for Project Trends Info */
  stuckTasksTrendsTable?: Maybe<Array<TaskTrendsDataType>>;
  /** Fetches all subtasks of a given task */
  subtasks?: Maybe<Array<SubtaskType>>;
  /** Fetches all subtasks groups of a given task */
  subtasksGroups?: Maybe<Array<SubtasksGroupType>>;
  /** Get the counts by project manager about action items */
  summaryByProjectManager?: Maybe<Array<SummaryByProjectManager>>;
  /** Get the counts by status about action items */
  summaryByStatus?: Maybe<SummaryByStatus>;
  /** Fetches survey response for project or milestone */
  surveyResponse?: Maybe<SurveyResponse>;
  /** A task */
  task: TaskType;
  /** Returns a public version of a task for completing tasks via email */
  taskActions: PublicTask;
  /** Check for potential conflicting dependencies when moving a task to a task group */
  taskDependenciesConflict: Scalars['Boolean'];
  /** A Task Group */
  taskGroup: TaskGroupType;
  /** Check if the tasks added to the task group will cause any conflict with their dependent tasks */
  taskGroupDependenciesConflict: Scalars['Boolean'];
  /** Gets count of tasks for a task group */
  taskGroupTaskCount?: Maybe<Scalars['Int']>;
  /** Fetches all task groups given a milestone_id */
  taskGroups?: Maybe<Array<TaskGroupType>>;
  /** Participants users for a participant task */
  taskParticipantsUsers?: Maybe<PaginatedUsersType>;
  /** Fetches paginated time records by task */
  taskTimeRecords?: Maybe<TaskTimeRecords>;
  /** Return top 5 tasks over budget data for Time tracking Info */
  tasksOverBudgetTable?: Maybe<Array<TaskOverBudgetDataType>>;
  /** Fetches all templates for an organization */
  templateConnections?: Maybe<Connections>;
  /** Return Templates Duration data for Project Trends Info */
  templateDurationsTrendsTable?: Maybe<TemplateDurationsDataType>;
  /** Fetches all milestones given a template_id in blueprint templates */
  templateMilestones?: Maybe<Array<MilestoneType>>;
  /** Fetches templates by id */
  templatesById?: Maybe<Array<TemplateType>>;
  /** paginated time capacity users */
  timeCapacityUsers?: Maybe<OrganizationConnectedUsersType>;
  /** Fetches the time entries summary */
  timeEntrySummary?: Maybe<TimeEntrySummary>;
  /** Fetches all totals of time records hours for the current user given a project in a time period */
  timePeriodTimeRecordsTotals?: Maybe<TimeRecordTotalsType>;
  /** Fetches all time record for a user in a project between a date range */
  timeRecordSummary?: Maybe<TimeRecordSummaryType>;
  /** Fetches the summary of projects or users time reports */
  timeReportSummary?: Maybe<TimeReportSummary>;
  /** Fetches all time records summary of a polymorphic object */
  timeReportingDetailList?: Maybe<TimeReportingDetailConnectionType>;
  /** Fetches all projects with their reporting summary */
  timeReportingList?: Maybe<TimeReportingConnectionType>;
  /** Return Time Tracked data for Line Chart */
  timeTrackedMonthlyData?: Maybe<Array<MonthlyTimeTrackedDataType>>;
  /** Fetches projects for time tracking entry */
  timeTracking?: Maybe<ProjectConnectionType>;
  /** Get a time tracking category */
  timeTrackingCategory: TimeTrackingCategory;
  /** Fetches all projects in a date range */
  timelineProjects?: Maybe<TimelineProjectsResponseType>;
  /** Returns the count of unread notifications. If no "types" are provided, "activity", "schedule", and "communication" are default types. */
  unreadNotificationsCount?: Maybe<Scalars['Int']>;
  /** Get all unread importer history errors for an organization */
  unreadTemplateImportErrors: Array<Notification>;
  /** A user */
  user: UserType;
  /** Get Custom Configurations for a User */
  userCustomConfigurationConnections: CustomConfigurationConnectionType;
  /** Fetches current users default project filter view (if there is one) */
  userDefaultFilterView?: Maybe<UserFilterViewType>;
  /** Fetches the current users saved filter views */
  userFilterViews?: Maybe<Array<UserFilterViewType>>;
  /** Return a list of pending surveys based on the logged user */
  userListSurveys: Array<SurveyType>;
  /** Fetches all users in a time period */
  userProjectReportingList?: Maybe<ProjectsTimeReportType>;
  /** Stats for a user based on a project */
  userProjectStats?: Maybe<UserProjectStatsType>;
  /** Fetches all users in a time period */
  userProjectTaskReportingList?: Maybe<TasksTimeReportType>;
  /** Fetches all tasks for the current user given a project */
  userProjectTasks?: Maybe<Array<TaskType>>;
  /** Fetches all users in a time period */
  userReportingList?: Maybe<UsersTimeReportType>;
  /** Return a user survey invite based on a milestone */
  userSurveyInviteByMilestone?: Maybe<SurveyType>;
  /** Return a user survey invite based on a project */
  userSurveyInviteByProject?: Maybe<SurveyType>;
  /** Fetches all tasks for the current user */
  userTasksConnections?: Maybe<TaskConnectionType>;
  /** Fetches all time records by user */
  userTimeRecords?: Maybe<Array<TimeRecordType>>;
  /** Gets users by skill IDs. The users must have all the skills that are provided as input */
  usersBySkills: Array<UserType>;
  /** Return top 5 users over budget data for Time tracking Info */
  usersOverBudgetTable?: Maybe<Array<UserOverBudgetDataType>>;
  /** Read organization vanity subdomain by project Id */
  vanitySubdomainByProjectId: VanitySubdomain;
}


export interface QueryActionItemArgs {
  id: Scalars['ID'];
}


export interface QueryAdminTeamArgs {
  userId: Scalars['ID'];
}


export interface QueryAllProjectMilestonesArgs {
  projectId: Scalars['ID'];
}


export interface QueryAllUsersArgs {
  listInputs?: InputMaybe<ListInput>;
}


export interface QueryAvailableTagsArgs {
  taggableId: Scalars['ID'];
  taggableType: TaggableEnumType;
  type?: InputMaybe<Scalars['String']>;
}


export interface QueryBillingProfileConnectionsArgs {
  listInputs: ListInput;
}


export interface QueryBillingProfileNameExistsArgs {
  name: Scalars['String'];
}


export interface QueryBlueprintTemplateArgs {
  id: Scalars['ID'];
}


export interface QueryBrandsArgs {
  listInputs?: InputMaybe<ListInput>;
}


export interface QueryCheckCanDeactivateUserArgs {
  input: CheckCanDeactivateUserInput;
}


export interface QueryCheckInvitationTokenArgs {
  email: Scalars['String'];
  invitationToken: Scalars['String'];
}


export interface QueryCheckPendingTasksRoleArgs {
  roleId: Scalars['ID'];
  unassignUserIds?: InputMaybe<Array<Scalars['ID']>>;
}


export interface QueryCommonTaskWatchersArgs {
  taskIds: Array<Scalars['ID']>;
}


export interface QueryCompassExperienceProviderTasksByProjectArgs {
  listInputs?: InputMaybe<ListInput>;
  projectId?: InputMaybe<Scalars['ID']>;
}


export interface QueryCompassExperienceUserTasksConnectionsArgs {
  listInputs?: InputMaybe<ListInput>;
  projectId?: InputMaybe<Scalars['ID']>;
  taskFilters?: InputMaybe<TaskFilters>;
  userId?: InputMaybe<Scalars['ID']>;
}


export interface QueryCompassFilesArgs {
  listInput: ListInput;
  projectId: Scalars['ID'];
}


export interface QueryCompletedProjectDataArgs {
  daysRange: Scalars['Int'];
}


export interface QueryCompletedProjectDurationsTrendsTableArgs {
  input: MonthlyCompletedProjectDurationDataInput;
}


export interface QueryConnectorsArgs {
  organizationId: Scalars['ID'];
}


export interface QueryCurrentUserTagsArgs {
  type?: InputMaybe<Scalars['String']>;
}


export interface QueryCustomerArgs {
  id: Scalars['ID'];
}


export interface QueryCustomerActiveProjectStatusArgs {
  id: Scalars['ID'];
  includeCompletedProjects?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryCustomerProjectListArgs {
  id: Scalars['ID'];
  includeCompletedProjects?: InputMaybe<Scalars['Boolean']>;
  listInputs?: InputMaybe<ListInput>;
}


export interface QueryCustomerTaskStatusArgs {
  id: Scalars['ID'];
  includedCompletedProjects?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryCustomersArgs {
  listInput?: InputMaybe<ListInput>;
}


export interface QueryDashboardChartValuesArgs {
  charType: Scalars['String'];
  endOnFilter?: InputMaybe<Scalars['String']>;
  projectFilters?: InputMaybe<ProjectFilters>;
}


export interface QueryDropEligibilityArgs {
  dropInputs?: InputMaybe<DropInput>;
}


export interface QueryEmailTakenArgs {
  input: RequestEmailTakenInput;
}


export interface QueryEventTaskDiffArgs {
  attendeeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  eventDatetime?: InputMaybe<Scalars['DateTimeType']>;
  eventInformation?: InputMaybe<Scalars['DraftJsTextType']>;
  eventTz?: InputMaybe<Scalars['String']>;
  meetingLength?: InputMaybe<Scalars['Int']>;
  taskId: Scalars['ID'];
}


export interface QueryFilesArgs {
  listInputs?: InputMaybe<ListInput>;
  objId: Scalars['ID'];
  objType: AssetableEnumType;
}


export interface QueryFirebaseMessagingTokenArgs {
  userId: Scalars['ID'];
}


export interface QueryFirstActiveTemplateMilestonesArgs {
  projectId: Scalars['ID'];
}


export interface QueryForecastedEndDateArgs {
  id: Scalars['ID'];
}


export interface QueryGanttChartTimelinesArgs {
  projectId: Scalars['ID'];
}


export interface QueryGenericTimeRecordsArgs {
  listInputs?: InputMaybe<ListInput>;
  projectFilters?: InputMaybe<ProjectFilters>;
  projectId: Scalars['ID'];
  taskId?: InputMaybe<Scalars['ID']>;
  workerId?: InputMaybe<Scalars['ID']>;
}


export interface QueryGetAuthRedirectArgs {
  email: Scalars['String'];
}


export interface QueryGetAverageCsatPerCustomerArgs {
  customerId: Scalars['ID'];
  includedCompletedProjects?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryGetLastWebhookDeliveriesArgs {
  webhookId: Scalars['ID'];
}


export interface QueryGetOrganizationDomainsArgs {
  organizationId: Scalars['ID'];
}


export interface QueryGetPlatformAppVersionArgs {
  platform: Scalars['String'];
}


export interface QueryGetSalesforcePackageInstallationStatusArgs {
  organizationId: Scalars['ID'];
}


export interface QueryGetSlackChannelsArgs {
  organizationId: Scalars['ID'];
}


export interface QueryGlobalSearchArgs {
  keyword: Scalars['String'];
  modelOptions?: InputMaybe<GlobalSearchModelInput>;
}


export interface QueryImporterHistoriesArgs {
  listInputs?: InputMaybe<ListInput>;
  organizationId: Scalars['ID'];
}


export interface QueryInfoFieldsArgs {
  organizationId: Scalars['ID'];
}


export interface QueryInvitationAcceptedCheckArgs {
  email: Scalars['String'];
}


export interface QueryJiraEpicArgs {
  epicKey: Scalars['String'];
}


export interface QueryJiraEpicsArgs {
  currentIndex: Scalars['String'];
  epicKey?: InputMaybe<Scalars['String']>;
  projectKey: Scalars['String'];
}


export interface QueryJiraGlobalStatusesArgs {
  issueId: Scalars['String'];
}


export interface QueryJiraProjectIssueTypesArgs {
  projectId: Scalars['String'];
}


export interface QueryJiraProjectStatusesArgs {
  issueId: Scalars['String'];
  projectId: Scalars['String'];
}


export interface QueryJiraProjectsArgs {
  searchValue?: InputMaybe<Scalars['String']>;
  startAt?: InputMaybe<Scalars['String']>;
}


export interface QueryMergeTagOptionsArgs {
  projectId?: InputMaybe<Scalars['ID']>;
  taggable: MergeTaggable;
}


export interface QueryMergeTagValuesArgs {
  customizedOnly: Scalars['Boolean'];
  projectId?: InputMaybe<Scalars['ID']>;
  taggable: MergeTaggable;
  taggableId?: InputMaybe<Scalars['ID']>;
}


export interface QueryMergeTagsArgs {
  actionItemId?: InputMaybe<Scalars['ID']>;
  projectId?: InputMaybe<Scalars['ID']>;
  taggable: MergeTaggableType;
  taskId?: InputMaybe<Scalars['ID']>;
}


export interface QueryMilestoneArgs {
  id: Scalars['ID'];
}


export interface QueryMilestoneTaskCountArgs {
  milestoneId: Scalars['ID'];
}


export interface QueryMoveMilestoneDependencyCheckArgs {
  inputs: MoveMilestoneInput;
}


export interface QueryNoteableNotesArgs {
  noteableId: Scalars['ID'];
  noteableType: NoteableEnumType;
}


export interface QueryNoteablePaginatedNotesArgs {
  listInputs?: InputMaybe<ListInput>;
  noteableId: Scalars['ID'];
  noteableType: NoteableEnumType;
}


export interface QueryNotesByCustomerUserArgs {
  listInputs?: InputMaybe<ListInput>;
  userId?: InputMaybe<Scalars['ID']>;
}


export interface QueryNotificationConnectionsArgs {
  listInputs?: InputMaybe<ListInput>;
  types?: InputMaybe<Array<InputMaybe<NotificationTypeEnumType>>>;
  unread?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryNotificationErrorsArgs {
  errorLimit?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['ID'];
}


export interface QueryOrganizationArgs {
  id: Scalars['ID'];
}


export interface QueryOrganizationByDomainArgs {
  domain?: InputMaybe<Scalars['String']>;
}


export interface QueryOrganizationConnectedUsersArgs {
  listInputs?: InputMaybe<ListInput>;
}


export interface QueryOrganizationConnectionsArgs {
  listInputs?: InputMaybe<ListInput>;
}


export interface QueryOrganizationUsersArgs {
  listInputs?: InputMaybe<ListInput>;
}


export interface QueryPaginatedCurrentUserTagsArgs {
  ids?: InputMaybe<Array<Scalars['ID']>>;
  listInputs?: InputMaybe<ListInput>;
  type?: InputMaybe<Scalars['String']>;
}


export interface QueryPaginatedPotentialSingleTaskAssigneesArgs {
  listInputs?: InputMaybe<ListInput>;
  milestoneId?: InputMaybe<Scalars['ID']>;
  projectId?: InputMaybe<Scalars['ID']>;
  responsibility?: InputMaybe<TaskResponsibilityEnumType>;
  skillIds?: InputMaybe<Array<Scalars['ID']>>;
}


export interface QueryPaginatedPotentialTaskAssigneesArgs {
  excludeIds?: InputMaybe<Array<Scalars['ID']>>;
  listInputs?: InputMaybe<ListInput>;
  milestoneId?: InputMaybe<Scalars['ID']>;
  projectId?: InputMaybe<Scalars['ID']>;
  responsibility?: InputMaybe<TaskResponsibilityEnumType>;
  skillId?: InputMaybe<Scalars['ID']>;
  skillIds?: InputMaybe<Array<Scalars['ID']>>;
}


export interface QueryPaginatedPotentialTaskParticipantsArgs {
  listInputs?: InputMaybe<ListInput>;
  milestoneId?: InputMaybe<Scalars['ID']>;
  projectId?: InputMaybe<Scalars['ID']>;
  skillIds?: InputMaybe<Array<Scalars['ID']>>;
}


export interface QueryPaginatedUserTaskAssigneesArgs {
  ids?: InputMaybe<Array<Scalars['ID']>>;
  listInputs?: InputMaybe<ListInput>;
}


export interface QueryPendingProjectArgs {
  id: Scalars['ID'];
}


export interface QueryPendingProjectsConnectionsArgs {
  integration: PendingProjectProviderEnumType;
  listInputs?: InputMaybe<ListInput>;
}


export interface QueryPotentialDependentMilestonesArgs {
  milestoneId: Scalars['ID'];
}


export interface QueryPotentialDependentTaskGroupsArgs {
  milestoneId: Scalars['ID'];
  taskGroupId?: InputMaybe<Scalars['ID']>;
  taskId?: InputMaybe<Scalars['ID']>;
}


export interface QueryPotentialDependentTasksArgs {
  milestoneId: Scalars['ID'];
  taskGroupId?: InputMaybe<Scalars['ID']>;
  taskId?: InputMaybe<Scalars['ID']>;
}


export interface QueryPotentialDependentTemplateArgs {
  milestoneId: Scalars['ID'];
}


export interface QueryPotentialProjectUsersArgs {
  organizationId?: InputMaybe<Scalars['ID']>;
  projectId: Scalars['ID'];
}


export interface QueryPotentialTaskAssigneesArgs {
  milestoneId: Scalars['ID'];
  organizationId?: InputMaybe<Scalars['ID']>;
  projectId?: InputMaybe<Scalars['ID']>;
}


export interface QueryPotentialTaskWatchersArgs {
  organizationId?: InputMaybe<Scalars['ID']>;
  taskId?: InputMaybe<Scalars['ID']>;
}


export interface QueryPotentialThirdPartyUsersArgs {
  organizationId?: InputMaybe<Scalars['ID']>;
  projectId: Scalars['ID'];
}


export interface QueryPotentialTimeRecordUsersArgs {
  organizationId?: InputMaybe<Scalars['ID']>;
}


export interface QueryProjectArgs {
  id: Scalars['ID'];
}


export interface QueryProjectActivitiesArgs {
  activityRelated?: InputMaybe<Scalars['ID']>;
  projectId: Scalars['ID'];
}


export interface QueryProjectActivitiesConnectionsArgs {
  activityRelated?: InputMaybe<Scalars['ID']>;
  listInputs?: InputMaybe<ListInput>;
  projectId: Scalars['ID'];
}


export interface QueryProjectFilterChipsArgs {
  input?: InputMaybe<ProjectFiltersInput>;
}


export interface QueryProjectInfoFieldsArgs {
  projectId: Scalars['ID'];
}


export interface QueryProjectManagersArgs {
  excludeAdmins?: InputMaybe<Scalars['Boolean']>;
  organizationId?: InputMaybe<Scalars['ID']>;
}


export interface QueryProjectMilestoneArgs {
  handleExactMultiRoles?: InputMaybe<Scalars['Boolean']>;
  milestoneId: Scalars['ID'];
  taskFilters?: InputMaybe<TaskFilters>;
}


export interface QueryProjectMilestonesArgs {
  handleExactMultiRoles?: InputMaybe<Scalars['Boolean']>;
  taskFilters?: InputMaybe<TaskFilters>;
  templateId: Scalars['ID'];
}


export interface QueryProjectOrTemplateSkillsArgs {
  id: Scalars['ID'];
  objectType: ProjectOrTemplateEnumType;
}


export interface QueryProjectReportingListArgs {
  endDate?: InputMaybe<Scalars['DateType']>;
  filters?: InputMaybe<TimeReportFiltersInput>;
  listInputs?: InputMaybe<ListInput>;
  projectId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['DateType']>;
  userId?: InputMaybe<Scalars['ID']>;
}


export interface QueryProjectStatusChangeReasonConnectionsArgs {
  projectId?: InputMaybe<Scalars['ID']>;
}


export interface QueryProjectTaskGroupArgs {
  id: Scalars['ID'];
}


export interface QueryProjectTaskGroupsArgs {
  milestoneId: Scalars['ID'];
  taskFilters?: InputMaybe<TaskFilters>;
}


export interface QueryProjectTaskNotesArgs {
  listInputs?: InputMaybe<ListInput>;
  noteableType: NoteableEnumType;
  projectId: Scalars['ID'];
  searchTerm?: InputMaybe<Scalars['String']>;
  visibilityTypes?: InputMaybe<Array<NoteVisibilityEnumType>>;
}


export interface QueryProjectTasksArgs {
  projectId: Scalars['ID'];
}


export interface QueryProjectTeamArgs {
  internalOnly?: InputMaybe<Scalars['Boolean']>;
  listInputs?: InputMaybe<ListInput>;
  projectId: Scalars['ID'];
}


export interface QueryProjectTeamFunctionsArgs {
  projectId: Scalars['ID'];
}


export interface QueryProjectTeamInternalUnassignedUsersArgs {
  projectId: Scalars['ID'];
}


export interface QueryProjectTemplateArgs {
  id: Scalars['ID'];
}


export interface QueryProjectTimeRecordsArgs {
  projectId?: InputMaybe<Scalars['ID']>;
}


export interface QueryProjectUsersArgs {
  listInputs?: InputMaybe<ListInput>;
  projectId?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<TaskResponsibilityEnumType>;
}


export interface QueryProjectsArgs {
  input?: InputMaybe<ProjectListInput>;
}


export interface QueryProjectsConnectionsArgs {
  filters?: InputMaybe<TimeReportFiltersInput>;
  listInputs?: InputMaybe<ListInput>;
  projectFilters?: InputMaybe<ProjectFilters>;
  userId?: InputMaybe<Scalars['ID']>;
}


export interface QueryPublicProjectArgs {
  id: Scalars['ID'];
}


export interface QueryRecentCustomerNotesArgs {
  listInputs?: InputMaybe<ListInput>;
}


export interface QueryRecentNotesByCustomerArgs {
  customerId: Scalars['ID'];
  listInputs?: InputMaybe<ListInput>;
}


export interface QueryReportsForOrganizationArgs {
  organizationId: Scalars['ID'];
}


export interface QueryResourceManagementUsersArgs {
  filters?: InputMaybe<CapacityFilterInput>;
  listInputs?: InputMaybe<ListInput>;
  organizationId?: InputMaybe<Scalars['ID']>;
}


export interface QueryResourcesUsersArgs {
  listInputs?: InputMaybe<ResourcesListInput>;
  organizationId?: InputMaybe<Scalars['ID']>;
  resourceFilters?: InputMaybe<ResourceFilters>;
}


export interface QueryRoleTaskWatchersArgs {
  id: Scalars['ID'];
  roleId: Scalars['ID'];
}


export interface QueryRolesTaskWatchersArgs {
  projectId: Scalars['ID'];
  roleIds: Array<Scalars['ID']>;
}


export interface QuerySearchOrganizationsArgs {
  input: OrganizationSearchInput;
}


export interface QuerySearchableCustomersArgs {
  customerIds?: InputMaybe<Array<Scalars['ID']>>;
  listInput?: InputMaybe<ListInput>;
}


export interface QuerySharepointListsArgs {
  siteUrl: Scalars['String'];
}


export interface QuerySharepointSitesArgs {
  searchTerm?: InputMaybe<Scalars['String']>;
}


export interface QuerySkillArgs {
  id: Scalars['ID'];
}


export interface QuerySkillsConnectionsArgs {
  listInputs?: InputMaybe<ListInput>;
  organizationId?: InputMaybe<Scalars['ID']>;
}


export interface QueryStatsArgs {
  objId: Scalars['ID'];
  objType: StatsEnumType;
}


export interface QueryStatusChangeReasonGroupConnectionsArgs {
  organizationId?: InputMaybe<Scalars['ID']>;
}


export interface QuerySubtasksArgs {
  taskId: Scalars['ID'];
}


export interface QuerySubtasksGroupsArgs {
  taskId: Scalars['ID'];
}


export interface QuerySummaryByProjectManagerArgs {
  organizationId?: InputMaybe<Scalars['ID']>;
}


export interface QuerySummaryByStatusArgs {
  organizationId?: InputMaybe<Scalars['ID']>;
}


export interface QuerySurveyResponseArgs {
  surveyInviteId: Scalars['ID'];
}


export interface QueryTaskArgs {
  id: Scalars['ID'];
}


export interface QueryTaskActionsArgs {
  id: Scalars['ID'];
}


export interface QueryTaskDependenciesConflictArgs {
  destinationId: Scalars['ID'];
  id: Scalars['ID'];
}


export interface QueryTaskGroupArgs {
  id: Scalars['ID'];
}


export interface QueryTaskGroupDependenciesConflictArgs {
  taskGroupId: Scalars['ID'];
  taskIds: Array<Scalars['ID']>;
}


export interface QueryTaskGroupTaskCountArgs {
  taskGroupId: Scalars['ID'];
}


export interface QueryTaskGroupsArgs {
  milestoneId: Scalars['ID'];
  taskFilters?: InputMaybe<TaskFilters>;
}


export interface QueryTaskParticipantsUsersArgs {
  listInputs?: InputMaybe<ListInput>;
  organizationId?: InputMaybe<Scalars['ID']>;
  projectId?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<TaskResponsibilityEnumType>;
}


export interface QueryTaskTimeRecordsArgs {
  listInputs?: InputMaybe<ListInput>;
  taskId?: InputMaybe<Scalars['ID']>;
  workerId?: InputMaybe<Scalars['ID']>;
}


export interface QueryTemplateConnectionsArgs {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  listInputs?: InputMaybe<ListInput>;
  onlyPublished?: InputMaybe<Scalars['Boolean']>;
}


export interface QueryTemplateMilestonesArgs {
  taskFilters?: InputMaybe<TaskFilters>;
  templateId: Scalars['ID'];
}


export interface QueryTemplatesByIdArgs {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
}


export interface QueryTimeCapacityUsersArgs {
  filters?: InputMaybe<CapacityFilterInput>;
  listInputs?: InputMaybe<ListInput>;
  organizationId?: InputMaybe<Scalars['ID']>;
}


export interface QueryTimeEntrySummaryArgs {
  endDate?: InputMaybe<Scalars['DateType']>;
  filters?: InputMaybe<TimeEntryFiltersInput>;
  listInputs?: InputMaybe<ListInput>;
  projectId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['DateType']>;
  userId: Scalars['ID'];
}


export interface QueryTimePeriodTimeRecordsTotalsArgs {
  endDate?: InputMaybe<Scalars['DateType']>;
  filters?: InputMaybe<TimeReportFiltersInput>;
  projectId: Scalars['ID'];
  startDate?: InputMaybe<Scalars['DateType']>;
  userId: Scalars['ID'];
}


export interface QueryTimeRecordSummaryArgs {
  endDate?: InputMaybe<Scalars['DateType']>;
  projectId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['DateType']>;
  userId?: InputMaybe<Scalars['ID']>;
}


export interface QueryTimeReportSummaryArgs {
  endDate: Scalars['DateType'];
  includeGeneric?: InputMaybe<Scalars['Boolean']>;
  keyword?: InputMaybe<Scalars['String']>;
  reportScope: ReportScopeEnumType;
  reportingFilters?: InputMaybe<TimeReportFiltersInput>;
  startDate: Scalars['DateType'];
}


export interface QueryTimeReportingDetailListArgs {
  endDate?: InputMaybe<Scalars['DateType']>;
  groupBy?: InputMaybe<Scalars['String']>;
  listInputs?: InputMaybe<ListInput>;
  reportingFilters?: InputMaybe<TimeReportingFilters>;
  reportingItemId: Scalars['ID'];
  startDate?: InputMaybe<Scalars['DateType']>;
}


export interface QueryTimeReportingListArgs {
  endDate?: InputMaybe<Scalars['DateType']>;
  groupBy?: InputMaybe<Scalars['String']>;
  listInputs?: InputMaybe<ListInput>;
  reportingFilters?: InputMaybe<TimeReportingFilters>;
  startDate?: InputMaybe<Scalars['DateType']>;
}


export interface QueryTimeTrackedMonthlyDataArgs {
  daysRange: Scalars['Int'];
}


export interface QueryTimeTrackingArgs {
  searchData?: InputMaybe<SearchProjectsTimeTrackingInput>;
}


export interface QueryTimeTrackingCategoryArgs {
  publicId: Scalars['ID'];
}


export interface QueryTimelineProjectsArgs {
  endDate?: InputMaybe<Scalars['DateType']>;
  keyword?: InputMaybe<Scalars['String']>;
  projectFilters?: InputMaybe<ProjectFilters>;
  startDate?: InputMaybe<Scalars['DateType']>;
}


export interface QueryUnreadNotificationsCountArgs {
  types?: InputMaybe<Array<InputMaybe<NotificationTypeEnumType>>>;
}


export interface QueryUnreadTemplateImportErrorsArgs {
  organizationId: Scalars['ID'];
}


export interface QueryUserArgs {
  id: Scalars['ID'];
}


export interface QueryUserCustomConfigurationConnectionsArgs {
  input: UserCustomConfigurationConnectionsInputType;
}


export interface QueryUserDefaultFilterViewArgs {
  category: Scalars['String'];
}


export interface QueryUserFilterViewsArgs {
  category: Scalars['String'];
}


export interface QueryUserProjectReportingListArgs {
  endDate?: InputMaybe<Scalars['DateType']>;
  filters?: InputMaybe<TimeReportFiltersInput>;
  listInputs?: InputMaybe<ListInput>;
  startDate?: InputMaybe<Scalars['DateType']>;
  userId?: InputMaybe<Scalars['ID']>;
}


export interface QueryUserProjectStatsArgs {
  projectId: Scalars['ID'];
  userId: Scalars['ID'];
}


export interface QueryUserProjectTaskReportingListArgs {
  endDate?: InputMaybe<Scalars['DateType']>;
  filters?: InputMaybe<TimeReportFiltersInput>;
  listInputs?: InputMaybe<ListInput>;
  projectId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['DateType']>;
  userId?: InputMaybe<Scalars['ID']>;
}


export interface QueryUserProjectTasksArgs {
  listInputs?: InputMaybe<ListInput>;
  projectId: Scalars['ID'];
}


export interface QueryUserReportingListArgs {
  endDate?: InputMaybe<Scalars['DateType']>;
  filters?: InputMaybe<TimeReportFiltersInput>;
  listInputs?: InputMaybe<ListInput>;
  startDate?: InputMaybe<Scalars['DateType']>;
}


export interface QueryUserSurveyInviteByMilestoneArgs {
  milestoneId: Scalars['ID'];
}


export interface QueryUserSurveyInviteByProjectArgs {
  projectId: Scalars['ID'];
}


export interface QueryUserTasksConnectionsArgs {
  listInputs?: InputMaybe<ListInput>;
  taskFilters?: InputMaybe<TaskFilters>;
  userId?: InputMaybe<Scalars['ID']>;
}


export interface QueryUserTimeRecordsArgs {
  userId?: InputMaybe<Scalars['ID']>;
}


export interface QueryUsersBySkillsArgs {
  skillIds: Array<Scalars['ID']>;
}


export interface QueryVanitySubdomainByProjectIdArgs {
  projectId: Scalars['ID'];
}

/** Enum for the possible rate types */
export enum RateTypeEnum {
  /** fixed_dollars */
  FixedDollars = 'FIXED_DOLLARS',
  /** fixed_hours */
  FixedHours = 'FIXED_HOURS',
  /** fixed_rate */
  FixedRate = 'FIXED_RATE',
  /** variable_rate */
  VariableRate = 'VARIABLE_RATE'
}

/** The data needed to display users available for task/project reassignment. */
export interface ReassignData {
  __typename?: 'ReassignData';
  availableUsers?: Maybe<Array<ReassignUserInfo>>;
  count?: Maybe<Scalars['Int']>;
  functionData?: Maybe<Array<ReassignFunctionData>>;
}

/** The users available for task reassignment based on function qualifications. */
export interface ReassignFunctionData {
  __typename?: 'ReassignFunctionData';
  availableUsers?: Maybe<Array<ReassignUserInfo>>;
  count: Scalars['Int'];
  functions: Array<Skill>;
}

/** The users available for task/project reassignment. */
export interface ReassignUserInfo {
  __typename?: 'ReassignUserInfo';
  avatar?: Maybe<ImageType>;
  capacity?: Maybe<Scalars['Int']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  projectsCount?: Maybe<Scalars['Int']>;
}

/** a connection of customers and their most recent note across any notable that the requesting org has access to */
export interface RecentCustomerNotesConnectionType {
  __typename?: 'RecentCustomerNotesConnectionType';
  customers?: Maybe<Array<CustomerNoteType>>;
  pageInfo?: Maybe<PageInfoType>;
}

/** a connection of the most recent note for any noteable for a given customer */
export interface RecentNotesByCustomerConnectionType {
  __typename?: 'RecentNotesByCustomerConnectionType';
  notes?: Maybe<Array<CustomerNoteType>>;
  pageInfo?: Maybe<PageInfoType>;
}

/** Autogenerated return type of RefreshAccessToken. */
export interface RefreshAccessTokenPayload {
  __typename?: 'RefreshAccessTokenPayload';
  /** access token for subsequent requests */
  accessToken: Scalars['String'];
}

/** Update the sort order of info fields. */
export interface ReorderInfoFieldInput {
  infoFieldId: Scalars['ID'];
  sortOrder: Scalars['Float'];
  type: InfoFieldsEnum;
}

/** Enum for the possible report scope types */
export enum ReportScopeEnumType {
  /** projects */
  Projects = 'PROJECTS',
  /** users */
  Users = 'USERS'
}

/** Request email taken input */
export interface RequestEmailTakenInput {
  email: Scalars['String'];
}

export interface ResourceFilters {
  usersType: ResourceTypeFilterEnum;
}

/** Enum to filter resource users by type */
export enum ResourceTypeFilterEnum {
  /** all */
  All = 'ALL',
  /** internal */
  Internal = 'INTERNAL',
  /** third_party */
  ThirdParty = 'THIRD_PARTY'
}

export interface ResourcesListInput {
  allMessages?: InputMaybe<Scalars['Boolean']>;
  customColumnSort?: InputMaybe<Scalars['ID']>;
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  paginated?: InputMaybe<Scalars['Boolean']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<SortByEnumType>;
  sortDirection?: InputMaybe<SortDirectionEnumType>;
  startFromId?: InputMaybe<Scalars['ID']>;
}

/** SMS Settings */
export interface SmsSettings {
  __typename?: 'SMSSettings';
  optedOutViaSms: Scalars['Boolean'];
  smsEnabled: Scalars['Boolean'];
}

/** Supported Salesforce API Hosts */
export enum SalesforceHostEnum {
  Production = 'PRODUCTION',
  Sandbox = 'SANDBOX'
}

/** A Salesforce Integration object */
export interface SalesforceIntegrationType {
  __typename?: 'SalesforceIntegrationType';
  email?: Maybe<Scalars['String']>;
  host: SalesforceHostEnum;
  id: Scalars['ID'];
  instanceUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationType>;
  organizationName?: Maybe<Scalars['String']>;
  packageInstallationId?: Maybe<Scalars['String']>;
  /** Semantic version number of installed managed package */
  packageVersionNumber: Scalars['String'];
  /** Is there a new managed package available for installation? */
  updateAvailable: Scalars['Boolean'];
  username?: Maybe<Scalars['String']>;
}

/** What you get when you ask for salesforce package installation status */
export interface SalesforcePackageStatusReturnType {
  __typename?: 'SalesforcePackageStatusReturnType';
  status?: Maybe<Scalars['String']>;
}

/** Input for searching and filtering projects on time tracking entry view. */
export interface SearchProjectsTimeTrackingInput {
  endDate?: InputMaybe<Scalars['DateType']>;
  filters?: InputMaybe<TimeEntryFiltersInput>;
  listInputs?: InputMaybe<ListInput>;
  projectId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['DateType']>;
  userId?: InputMaybe<Scalars['ID']>;
}

export interface SignerInputType {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  lastName?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
}

/** A signer - not an actual user */
export interface SignerType {
  __typename?: 'SignerType';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
}

/** A SharePoint site */
export interface Site {
  __typename?: 'Site';
  name: Scalars['String'];
  url: Scalars['String'];
}

/** An organization skill */
export interface Skill {
  __typename?: 'Skill';
  billableRate: Scalars['Float'];
  category: SkillCategory;
  id: Scalars['ID'];
  internalUsers: Array<UserType>;
  name: Scalars['String'];
  tasks: Array<TaskType>;
  userCount: Scalars['Int'];
  users: Array<UserType>;
}

/** An organization skill category */
export interface SkillCategory {
  __typename?: 'SkillCategory';
  id: Scalars['ID'];
  name: Scalars['String'];
  skillCount: Scalars['Int'];
  skills: Array<Skill>;
  userCount: Scalars['Int'];
}

/** A connection of skills */
export interface SkillConnectionType {
  __typename?: 'SkillConnectionType';
  pageInfo?: Maybe<PageInfoType>;
  skills?: Maybe<Array<Skill>>;
}

/** Slack integration */
export interface SlackIntegrationType {
  __typename?: 'SlackIntegrationType';
  channelId?: Maybe<Scalars['String']>;
  channelName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  teamId?: Maybe<Scalars['String']>;
  teamName?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
}

/** Enum for all the possible list sorting */
export enum SortByEnumType {
  /** allotted_hours */
  AllottedHours = 'ALLOTTED_HOURS',
  /** assignee_name */
  AssigneeName = 'ASSIGNEE_NAME',
  /** billable_rate */
  BillableRate = 'BILLABLE_RATE',
  /** billable_users_count */
  BillableUsersCount = 'BILLABLE_USERS_COUNT',
  /** brand */
  Brand = 'BRAND',
  /** cash_value */
  CashValue = 'CASH_VALUE',
  /** category_id */
  Category = 'CATEGORY',
  /** category_skills_count */
  CategorySkillsCount = 'CATEGORY_SKILLS_COUNT',
  /** cost_rate */
  CostRate = 'COST_RATE',
  /** created_at */
  Created = 'CREATED',
  /** creator_id */
  Creator = 'CREATOR',
  /** csat */
  Csat = 'CSAT',
  /** customer */
  Customer = 'CUSTOMER',
  /** customer_name */
  CustomerName = 'CUSTOMER_NAME',
  /** date_range */
  DateRange = 'DATE_RANGE',
  /** date_worked */
  DateWorked = 'DATE_WORKED',
  /** dependency */
  Dependency = 'DEPENDENCY',
  /** description */
  Description = 'DESCRIPTION',
  /** dollars */
  Dollars = 'DOLLARS',
  /** due_on */
  DueOn = 'DUE_ON',
  /** due_on_and_dependency */
  DueOnAndDependency = 'DUE_ON_AND_DEPENDENCY',
  /** last_edited_by_id */
  EditedBy = 'EDITED_BY',
  /** end_on */
  EndOn = 'END_ON',
  /** file_name */
  FileName = 'FILE_NAME',
  /** first_name */
  FirstName = 'FIRST_NAME',
  /** hours */
  Hours = 'HOURS',
  /** last_activity_at */
  LastActivityAt = 'LAST_ACTIVITY_AT',
  /** last_name */
  LastName = 'LAST_NAME',
  /** milestone */
  Milestone = 'MILESTONE',
  /** milestone_name */
  MilestoneName = 'MILESTONE_NAME',
  /** my_open_tasks */
  MyOpenTasks = 'MY_OPEN_TASKS',
  /** name */
  Name = 'NAME',
  /** open_action_items */
  OpenActionItems = 'OPEN_ACTION_ITEMS',
  /** open_tasks */
  OpenTasks = 'OPEN_TASKS',
  /** overdue_tasks_count */
  OverdueTasksCount = 'OVERDUE_TASKS_COUNT',
  /** pm_name */
  PmName = 'PM_NAME',
  /** priority */
  Priority = 'PRIORITY',
  /** projected_end_on */
  ProjectedEndOn = 'PROJECTED_END_ON',
  /** project_end */
  ProjectEnd = 'PROJECT_END',
  /** project_name */
  ProjectName = 'PROJECT_NAME',
  /** provider */
  Provider = 'PROVIDER',
  /** published */
  Published = 'PUBLISHED',
  /** rate_type */
  RateType = 'RATE_TYPE',
  /** sign_off */
  SignOff = 'SIGN_OFF',
  /** skills_count */
  SkillsCount = 'SKILLS_COUNT',
  /** start_on */
  StartOn = 'START_ON',
  /** status */
  Status = 'STATUS',
  /** stuck_tasks */
  StuckTasks = 'STUCK_TASKS',
  /** task_name */
  TaskName = 'TASK_NAME',
  /** template_name */
  TemplateName = 'TEMPLATE_NAME',
  /** time_elapsed */
  TimeElapsed = 'TIME_ELAPSED',
  /** billable */
  TimeRecordType = 'TIME_RECORD_TYPE',
  /** org_type */
  Type = 'TYPE',
  /** updated_at */
  Updated = 'UPDATED',
  /** uploader */
  Uploader = 'UPLOADER',
  /** users_count */
  UsersCount = 'USERS_COUNT',
  /** utilized_capacity */
  UtilizedCapacity = 'UTILIZED_CAPACITY',
  /** worker_id */
  Worker = 'WORKER'
}

/** Enum for the possible sort directions */
export enum SortDirectionEnumType {
  /** asc */
  Asc = 'ASC',
  /** desc */
  Desc = 'DESC'
}

/** sort task task group input */
export interface SortTaskTaskGroupInput {
  destinationDroppableId?: InputMaybe<Scalars['ID']>;
  destinationIndex?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  sortOrder: Scalars['Float'];
  type: SortableElementEnum;
}

/** Enum for the possible sortable elements */
export enum SortableElementEnum {
  /** task */
  Task = 'TASK',
  /** task_group */
  TaskGroup = 'TASK_GROUP'
}

/** Stats for a template, project, milestone, task */
export type Stats = MilestoneStats | ProjectStats | TemplateStats;

/** Enum for the possible stats types */
export enum StatsEnumType {
  /** blueprint_template */
  BlueprintTemplate = 'BLUEPRINT_TEMPLATE',
  /** milestone */
  Milestone = 'MILESTONE',
  /** project */
  Project = 'PROJECT'
}

/** Status Change Reason Group */
export interface StatusChangeReasonGroupType {
  __typename?: 'StatusChangeReasonGroupType';
  id: Scalars['ID'];
  name: Scalars['String'];
  organization?: Maybe<OrganizationType>;
  statusChangeReasons?: Maybe<Array<StatusChangeReasonType>>;
}

/** Status Change Reason */
export interface StatusChangeReasonType {
  __typename?: 'StatusChangeReasonType';
  description: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  statusChangeReasonGroup?: Maybe<StatusChangeReasonGroupType>;
}

/** Enum for the possible statuses */
export enum StatusEnumType {
  /** cancelled */
  Cancelled = 'CANCELLED',
  /** done */
  Done = 'DONE',
  /** late */
  Late = 'LATE',
  /** non_responsive */
  NonResponsive = 'NON_RESPONSIVE',
  /** not_applicable */
  NotApplicable = 'NOT_APPLICABLE',
  /** unscheduled */
  NotScheduled = 'NOT_SCHEDULED',
  /** not_started */
  NotStarted = 'NOT_STARTED',
  /** on_hold */
  OnHold = 'ON_HOLD',
  /** on_time */
  OnTime = 'ON_TIME',
  /** scheduled */
  Scheduled = 'SCHEDULED',
  /** sign_off */
  SignOff = 'SIGN_OFF',
  /** stuck */
  Stuck = 'STUCK',
  /** working_on_it */
  WorkingOnIt = 'WORKING_ON_IT'
}

/** Enum for the possible status update types */
export enum StatusObjectEnumType {
  /** action_item */
  ActionItem = 'ACTION_ITEM',
  /** project */
  Project = 'PROJECT',
  /** task */
  Task = 'TASK'
}

/** A return type for updating status on a generic object */
export type StatusObjectType = ActionItemType | ProjectType | TaskType;

export interface StatusesInput {
  done: Scalars['String'];
  notStarted: Scalars['String'];
  stuck: Scalars['String'];
  workingOnIt: Scalars['String'];
}

/** Subscription operations are only available through WebSocket connections */
export interface Subscription {
  __typename?: 'Subscription';
  milestoneUpdated?: Maybe<MilestoneUpdatePayloadType>;
  newError?: Maybe<Notification>;
  newNotification?: Maybe<Notification>;
  noteAdded?: Maybe<NoteType>;
  organizationUpdated?: Maybe<OrganizationType>;
  projectTaskNoteAdded?: Maybe<NoteType>;
  projectUpdated?: Maybe<ProjectUpdatePayloadType>;
  taskUpdated?: Maybe<TaskType>;
  templateUpdated?: Maybe<TemplateUpdatePayloadType>;
  templatesAdded?: Maybe<ProjectType>;
  userUpdated?: Maybe<UserType>;
}


/** Subscription operations are only available through WebSocket connections */
export interface SubscriptionMilestoneUpdatedArgs {
  templateId: Scalars['ID'];
}


/** Subscription operations are only available through WebSocket connections */
export interface SubscriptionNoteAddedArgs {
  noteableId: Scalars['ID'];
}


/** Subscription operations are only available through WebSocket connections */
export interface SubscriptionOrganizationUpdatedArgs {
  organizationId: Scalars['ID'];
}


/** Subscription operations are only available through WebSocket connections */
export interface SubscriptionProjectTaskNoteAddedArgs {
  projectId: Scalars['ID'];
}


/** Subscription operations are only available through WebSocket connections */
export interface SubscriptionProjectUpdatedArgs {
  projectId: Scalars['ID'];
}


/** Subscription operations are only available through WebSocket connections */
export interface SubscriptionTaskUpdatedArgs {
  taskId: Scalars['ID'];
}


/** Subscription operations are only available through WebSocket connections */
export interface SubscriptionTemplateUpdatedArgs {
  templateId: Scalars['ID'];
}


/** Subscription operations are only available through WebSocket connections */
export interface SubscriptionTemplatesAddedArgs {
  projectId: Scalars['ID'];
}


/** Subscription operations are only available through WebSocket connections */
export interface SubscriptionUserUpdatedArgs {
  userId: Scalars['ID'];
}

/** a subtask of a task, task checklists are comprised of subtasks */
export interface SubtaskType {
  __typename?: 'SubtaskType';
  completedAt?: Maybe<Scalars['DateType']>;
  completionUser?: Maybe<UserType>;
  createdAt?: Maybe<Scalars['DateType']>;
  done?: Maybe<Scalars['Boolean']>;
  groupId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  richName?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Float']>;
  task?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateType']>;
}

/** a group of subtasks in task */
export interface SubtasksGroupType {
  __typename?: 'SubtasksGroupType';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  task?: Maybe<TaskType>;
}

/** An organization suggested by a 3rd party based on domain */
export interface SuggestedOrgType {
  __typename?: 'SuggestedOrgType';
  customerLogo?: Maybe<ImageType>;
  description?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  /** if an org is provider or has projects with other orgs will return true */
  isEditable?: Maybe<Scalars['Boolean']>;
  /** if there is already an organization under the domain it will return true */
  isStored?: Maybe<Scalars['Boolean']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  primaryContactName?: Maybe<Scalars['String']>;
  type?: Maybe<OrganizationTypeEnumType>;
}

/** Summary of action items giving active ones grouped by their project manager */
export interface SummaryByProjectManager {
  __typename?: 'SummaryByProjectManager';
  activeCount: Scalars['Int'];
  done: Scalars['Int'];
  notStarted: Scalars['Int'];
  projectManagerId: UserType;
  workingOnIt: Scalars['Int'];
}

/** Summary of action items giving active ones grouped by their status */
export interface SummaryByStatus {
  __typename?: 'SummaryByStatus';
  activeCount: Scalars['Int'];
  done: Scalars['Int'];
  notStarted: Scalars['Int'];
  workingOnIt: Scalars['Int'];
}

export interface SurveyQuestionType {
  __typename?: 'SurveyQuestionType';
  id: Scalars['ID'];
  options?: Maybe<Scalars['JSON']>;
  title: Scalars['String'];
}

/** survey response type */
export interface SurveyResponse {
  __typename?: 'SurveyResponse';
  notes?: Maybe<Scalars['String']>;
  projectId: Scalars['ID'];
  respondedAt?: Maybe<Scalars['DateType']>;
  surveyInviteId: Scalars['ID'];
  surveyQuestionId: Scalars['ID'];
}

export interface SurveyType {
  __typename?: 'SurveyType';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  questions: Array<SurveyQuestionType>;
}

/** A Tag for projects or tasks */
export interface TagType {
  __typename?: 'TagType';
  color: Scalars['String'];
  id: Scalars['ID'];
  internalOnly: Scalars['Boolean'];
  name: Scalars['String'];
}

/** Enum for the possible taggable types */
export enum TaggableEnumType {
  /** action_item */
  ActionItem = 'ACTION_ITEM',
  /** blueprint_template */
  BlueprintTemplate = 'BLUEPRINT_TEMPLATE',
  /** project */
  Project = 'PROJECT',
  /** task */
  Task = 'TASK'
}

/** A return type for taggable items */
export type TaggableType = ActionItemType | ProjectType | TaskType;

/** A return type for tasks and task groups */
export type TaskAndGroupType = TaskGroupType | TaskType;

/** A connection of tasks */
export interface TaskConnectionType {
  __typename?: 'TaskConnectionType';
  /** returns all users that are assigned to tasks in the result set */
  allAssignees?: Maybe<Array<UserType>>;
  pageInfo?: Maybe<PageInfoType>;
  tasks?: Maybe<Array<TaskType>>;
}

/** Represents event task information between proposed and current data */
export interface TaskEventDiffType {
  __typename?: 'TaskEventDiffType';
  attendees?: Maybe<Array<UserType>>;
  eventDatetime?: Maybe<Scalars['DateTimeType']>;
  eventInformation?: Maybe<Scalars['String']>;
  eventTz?: Maybe<Scalars['String']>;
  hasDiff: Scalars['Boolean'];
  meetingLength?: Maybe<Scalars['Int']>;
}

export interface TaskFilters {
  allFunctionsSelected?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  assigneeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  customerDashboardStatuses?: InputMaybe<Array<CustomerDashboardStatusesEnumType>>;
  customerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  dependencies?: InputMaybe<Array<InputMaybe<DependencyStatusEnumType>>>;
  operators?: InputMaybe<FiltersOperatorType>;
  overdueSelected?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  priorities?: InputMaybe<Array<InputMaybe<PriorityEnumType>>>;
  projectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  projectStatuses?: InputMaybe<Array<InputMaybe<StatusEnumType>>>;
  responsibilities?: InputMaybe<Array<InputMaybe<TaskResponsibilityEnumType>>>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  statuses?: InputMaybe<Array<InputMaybe<StatusEnumType>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  visibility?: InputMaybe<Array<InputMaybe<TaskVisibilityEnumType>>>;
  watching?: InputMaybe<Scalars['Boolean']>;
}

/** A task group summary bank */
export interface TaskGroupStats {
  __typename?: 'TaskGroupStats';
  duration?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  totalCompleteTasks?: Maybe<Scalars['Int']>;
  totalRemainingTasks?: Maybe<Scalars['Int']>;
  totalTasks?: Maybe<Scalars['Int']>;
}

/** Enum for the possible task groups statuses */
export enum TaskGroupStatusEnumType {
  /** complete */
  Complete = 'COMPLETE',
  /** in_progress */
  InProgress = 'IN_PROGRESS',
  /** not_started */
  NotStarted = 'NOT_STARTED'
}

/** A task group */
export interface TaskGroupType {
  __typename?: 'TaskGroupType';
  active: Scalars['Boolean'];
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateType']>;
  completionMessage?: Maybe<Scalars['DraftJsTextType']>;
  createdAt?: Maybe<Scalars['DateType']>;
  dependentTasks?: Maybe<Array<TaskType>>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  enableCompletionNotification?: Maybe<Scalars['Boolean']>;
  forecastedEndOn?: Maybe<Scalars['DateType']>;
  id: Scalars['ID'];
  milestone?: Maybe<MilestoneType>;
  name: Scalars['String'];
  parentId: Scalars['ID'];
  project?: Maybe<ProjectType>;
  sortOrder?: Maybe<Scalars['Float']>;
  startedOn?: Maybe<Scalars['DateType']>;
  status?: Maybe<TaskGroupStatusEnumType>;
  summaryBank: TaskGroupStats;
  taskCount: Scalars['Int'];
  tasks?: Maybe<Array<TaskType>>;
  template: TemplateType;
  updatedAt?: Maybe<Scalars['DateType']>;
}


/** A task group */
export interface TaskGroupTypeTaskCountArgs {
  taskResponsibilities?: InputMaybe<Array<TaskResponsibilityEnumType>>;
}

export interface TaskOverBudgetDataType {
  __typename?: 'TaskOverBudgetDataType';
  estimatedHours: Scalars['Float'];
  id: Scalars['ID'];
  name: Scalars['String'];
  responsibility: TaskResponsibilityEnumType;
  task: TaskType;
  totalHours: Scalars['Float'];
}

/** Check task participants select all type */
export interface TaskParticipantSelectAllType {
  __typename?: 'TaskParticipantSelectAllType';
  customer: Scalars['Boolean'];
  internal: Scalars['Boolean'];
  internalInProject: Scalars['Boolean'];
  notInProject: Scalars['Boolean'];
  thirdParty: Scalars['Boolean'];
}

/** A user participant */
export interface TaskParticipantType {
  __typename?: 'TaskParticipantType';
  completed?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  invitationSentAt?: Maybe<Scalars['DateTimeType']>;
  user?: Maybe<UserType>;
}

/** Task Reassign */
export interface TaskReassignType {
  skillIds?: InputMaybe<Array<Scalars['ID']>>;
  taskReassignUserId?: InputMaybe<Scalars['ID']>;
}

/** Enum for the project overview email preferences */
export enum TaskReminderEmailPref {
  /** one_day */
  OneDay = 'ONE_DAY',
  /** task_reminder_off */
  TaskReminderOff = 'TASK_REMINDER_OFF',
  /** three_days */
  ThreeDays = 'THREE_DAYS',
  /** two_days */
  TwoDays = 'TWO_DAYS'
}

/** Enum for the possible task responsibility options */
export enum TaskResponsibilityEnumType {
  /** all */
  All = 'ALL',
  /** customer */
  Customer = 'CUSTOMER',
  /** internal */
  Internal = 'INTERNAL',
  /** internal_in_project */
  InternalInProject = 'INTERNAL_IN_PROJECT',
  /** not_in_project */
  NotInProject = 'NOT_IN_PROJECT',
  /** third_party */
  ThirdParty = 'THIRD_PARTY'
}

/** What you get when you update a task */
export interface TaskReturnType {
  __typename?: 'TaskReturnType';
  allMilestoneStats?: Maybe<Array<MilestoneStats>>;
  futureMilestones?: Maybe<Array<MilestoneType>>;
  milestone?: Maybe<MilestoneType>;
  milestoneStats?: Maybe<MilestoneStats>;
  project?: Maybe<ProjectType>;
  projectStats?: Maybe<ProjectStats>;
  shouldWarnUpdateStatus?: Maybe<Scalars['Boolean']>;
  task?: Maybe<TaskType>;
  taskGroup?: Maybe<TaskGroupType>;
  templateStats?: Maybe<TemplateStats>;
}

/** Enum for the possible status for a task */
export enum TaskStatusEnum {
  /** done */
  Done = 'DONE',
  /** not_applicable */
  NotApplicable = 'NOT_APPLICABLE',
  /** unscheduled */
  NotScheduled = 'NOT_SCHEDULED',
  /** not_started */
  NotStarted = 'NOT_STARTED',
  /** scheduled */
  Scheduled = 'SCHEDULED',
  /** sign_off */
  SignOff = 'SIGN_OFF',
  /** stuck */
  Stuck = 'STUCK',
  /** working_on_it */
  WorkingOnIt = 'WORKING_ON_IT'
}

/** A connection of time records in a task */
export interface TaskTimeRecords {
  __typename?: 'TaskTimeRecords';
  pageInfo: PageInfoType;
  timeRecords: Array<TimeRecordType>;
}

/** Template Duration table data */
export interface TaskTrendsDataType {
  __typename?: 'TaskTrendsDataType';
  blueprintTask?: Maybe<TaskType>;
  percentage?: Maybe<Scalars['Int']>;
  taskName?: Maybe<Scalars['String']>;
  templateName?: Maybe<Scalars['String']>;
}

/** A task */
export interface TaskType {
  __typename?: 'TaskType';
  actionItemsCount: Scalars['Int'];
  actualHours?: Maybe<Scalars['Float']>;
  assignee?: Maybe<UserType>;
  assignmentEmailSentAt?: Maybe<Scalars['DateTimeType']>;
  billableHours?: Maybe<Scalars['Float']>;
  completeSubtasksCount: Scalars['Int'];
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateType']>;
  createdAt?: Maybe<Scalars['DateType']>;
  creator?: Maybe<UserType>;
  currentUserTaskContext?: Maybe<CurrentUserTaskContextEnumType>;
  dependency?: Maybe<DependencyType>;
  dependencyType?: Maybe<Scalars['String']>;
  dependentTasks?: Maybe<Array<TaskType>>;
  dependentTasksCount: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  dueOn?: Maybe<Scalars['DateType']>;
  duration?: Maybe<Scalars['Int']>;
  estimatedHours?: Maybe<Scalars['Float']>;
  estimatedPoints?: Maybe<Scalars['Int']>;
  eventDatetime?: Maybe<Scalars['DateTimeType']>;
  eventInformation?: Maybe<Scalars['String']>;
  eventTz?: Maybe<Scalars['String']>;
  files?: Maybe<Array<FileType>>;
  freeFromDependency?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  incompleteSubtasksCount: Scalars['Int'];
  internalFilesCount: Scalars['Int'];
  internalNotesCount: Scalars['Int'];
  invitationGroupSentAt?: Maybe<Scalars['DateTimeType']>;
  jiraSync?: Maybe<Scalars['Boolean']>;
  jiraTask?: Maybe<JiraIssueType>;
  jiraTaskLink?: Maybe<Scalars['String']>;
  lastActivityAt?: Maybe<Scalars['DateType']>;
  meetingLength?: Maybe<Scalars['Int']>;
  milestone?: Maybe<MilestoneType>;
  mustStartOn?: Maybe<Scalars['DateType']>;
  mustStartOnEmailSentAt?: Maybe<Scalars['DateTimeType']>;
  mustStartOnRequired?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  nonBillableHours?: Maybe<Scalars['Float']>;
  notes?: Maybe<Array<NoteType>>;
  /** Fetches all tasks for the current user given a project */
  paginatedUsersForTimeRecords: PaginatedUsersType;
  participantCallToAction?: Maybe<Scalars['String']>;
  participantsSelectAll?: Maybe<TaskParticipantSelectAllType>;
  priority?: Maybe<PriorityEnumType>;
  project?: Maybe<ProjectType>;
  properties?: Maybe<Array<Property>>;
  publicFilesCount: Scalars['Int'];
  publicNotesCount: Scalars['Int'];
  resolvedDescription?: Maybe<Scalars['String']>;
  resolvedParticipantCallToAction?: Maybe<Scalars['String']>;
  responsibility: TaskResponsibilityEnumType;
  shouldWarnUpdateStatus?: Maybe<Scalars['Boolean']>;
  signOffRequired: Scalars['Boolean'];
  signer?: Maybe<SignerType>;
  skill?: Maybe<Skill>;
  skills?: Maybe<Array<Skill>>;
  sortOrder?: Maybe<Scalars['Float']>;
  startOn?: Maybe<Scalars['DateType']>;
  status: StatusEnumType;
  stuckMessage?: Maybe<Scalars['String']>;
  subtasks?: Maybe<Array<SubtaskType>>;
  subtasksGroups?: Maybe<Array<SubtasksGroupType>>;
  tags?: Maybe<Array<TagType>>;
  taskGroup?: Maybe<TaskGroupType>;
  taskParticipants?: Maybe<Array<TaskParticipantType>>;
  taskType?: Maybe<TaskTypeEnumType>;
  template?: Maybe<TemplateType>;
  /** Determines the assignees utilization for this task by taking the estimated task hours and splitting them across the duration of the task in business days, Example: Task with a duration of 4 business days and estimated hours of 20 would count 5 hours to the user's daily utilization. */
  timePeriodUtilization: TaskUtilizationType;
  /** Fetches all time records of a task given a user and a time period */
  timeRecordsPeriod: Array<TimeRecordType>;
  timeReport: TimeReport;
  timeZone: Scalars['String'];
  totalHours?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateType']>;
  visibility?: Maybe<TaskVisibilityEnumType>;
  watchers?: Maybe<Array<UserType>>;
}


/** A task */
export interface TaskTypePaginatedUsersForTimeRecordsArgs {
  endDate: Scalars['DateType'];
  listInputs?: InputMaybe<ListInput>;
  startDate: Scalars['DateType'];
}


/** A task */
export interface TaskTypeTimePeriodUtilizationArgs {
  endDate: Scalars['DateType'];
  startDate: Scalars['DateType'];
}


/** A task */
export interface TaskTypeTimeRecordsPeriodArgs {
  endDate?: InputMaybe<Scalars['DateType']>;
  startDate?: InputMaybe<Scalars['DateType']>;
  userId?: InputMaybe<Scalars['ID']>;
}


/** A task */
export interface TaskTypeTimeReportArgs {
  endDate: Scalars['DateType'];
  filters?: InputMaybe<TimeReportFiltersInput>;
  startDate: Scalars['DateType'];
  userId?: InputMaybe<Scalars['ID']>;
}

/** Enum for the possible task types */
export enum TaskTypeEnumType {
  /** event */
  Event = 'EVENT',
  /** grouped */
  Group = 'GROUP',
  /** regular */
  Regular = 'REGULAR'
}

/** Accepts a start_date and end_date. it is responsible for calculating how many hours from the estimated hours are applied to this period. */
export interface TaskUtilizationType {
  __typename?: 'TaskUtilizationType';
  hours: Scalars['Float'];
  userCapacity: Scalars['Float'];
  utilization: Scalars['Float'];
}

/** Enum for the possible task visibilities */
export enum TaskVisibilityEnumType {
  /** hidden */
  Hidden = 'HIDDEN',
  /** name_only */
  NameOnly = 'NAME_ONLY',
  /** visible */
  Visible = 'VISIBLE'
}

/** A connection of task with time records */
export interface TasksTimeReportType {
  __typename?: 'TasksTimeReportType';
  pageInfo?: Maybe<PageInfoType>;
  tasks?: Maybe<Array<TaskType>>;
}

/** Template Duration Type */
export interface TemplateDurationType {
  __typename?: 'TemplateDurationType';
  completions?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['Float']>;
  estimatedDuration?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  templateName?: Maybe<Scalars['String']>;
}

/** Template Duration table data */
export interface TemplateDurationsDataType {
  __typename?: 'TemplateDurationsDataType';
  templates?: Maybe<Array<TemplateDurationType>>;
}

/** Enum for the possible template types */
export enum TemplateEnumType {
  /** blueprint_template */
  BlueprintTemplate = 'BLUEPRINT_TEMPLATE',
  /** template */
  Template = 'TEMPLATE'
}

export interface TemplateInfoInput {
  /** The base64 encoded version of the logo image with metadata prefix e.g. "data:image/png;base64,<base64...>" */
  base64VideoPlaceholderImage?: InputMaybe<Scalars['String']>;
  experienceOverview?: InputMaybe<Scalars['DraftJsTextType']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Float']>;
  videoUrl?: InputMaybe<Scalars['String']>;
}

/** A template summary bank */
export interface TemplateStats {
  __typename?: 'TemplateStats';
  id: Scalars['ID'];
  totalActualHours: Scalars['Float'];
  totalAssignedTasks: Scalars['Int'];
  totalCompleteTasks: Scalars['Float'];
  totalCustomerActualHours: Scalars['Float'];
  totalCustomerHours: Scalars['Float'];
  totalCustomerPoints: Scalars['Int'];
  totalCustomerRemainingHours: Scalars['Float'];
  totalCustomerTasks: Scalars['Int'];
  totalEstimatedHours: Scalars['Float'];
  totalInternalActualHours: Scalars['Float'];
  totalInternalHours: Scalars['Float'];
  totalInternalLoggedBillableHours: Scalars['Float'];
  totalInternalLoggedHours: Scalars['Float'];
  totalInternalLoggedNonBillableHours: Scalars['Float'];
  totalInternalPoints: Scalars['Int'];
  totalInternalRemainingHours: Scalars['Float'];
  totalInternalRemainingPurchasedHours: Scalars['Float'];
  totalInternalTasks: Scalars['Int'];
  totalMilestones: Scalars['Int'];
  totalPoints: Scalars['Int'];
  totalRemainingHours: Scalars['Float'];
  totalTaskGroups: Scalars['Int'];
  totalTasks: Scalars['Int'];
  totalThirdPartyActualHours: Scalars['Float'];
  totalThirdPartyHours: Scalars['Float'];
  totalThirdPartyPoints: Scalars['Int'];
  totalThirdPartyRemainingHours: Scalars['Float'];
  totalThirdPartyTasks: Scalars['Int'];
}

/** A template */
export interface TemplateType {
  __typename?: 'TemplateType';
  active: Scalars['Boolean'];
  blueprintTemplateId?: Maybe<Scalars['ID']>;
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateType']>;
  createdAt?: Maybe<Scalars['DateType']>;
  creator?: Maybe<UserType>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  experienceOverview?: Maybe<Scalars['String']>;
  files?: Maybe<Array<FileType>>;
  hardDependency?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  jiraIssueDetailsEnabled?: Maybe<Scalars['Boolean']>;
  lastEditedBy?: Maybe<UserType>;
  milestones?: Maybe<Array<MilestoneType>>;
  name: Scalars['String'];
  organization: OrganizationType;
  project?: Maybe<ProjectType>;
  published: Scalars['Boolean'];
  sku?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Float']>;
  summaryBank: TemplateStats;
  updatedAt?: Maybe<Scalars['DateType']>;
  videoPlaceholderImage?: Maybe<ImageType>;
  videoUrl?: Maybe<Scalars['String']>;
}

/** Template subscription payload, includes stats as well */
export interface TemplateUpdatePayloadType {
  __typename?: 'TemplateUpdatePayloadType';
  template?: Maybe<TemplateType>;
  templateStats?: Maybe<TemplateStats>;
}

/** Filters for a time entry summary */
export interface TimeEntryFiltersInput {
  pmItemsOnly?: InputMaybe<Scalars['Boolean']>;
  projectStatuses?: InputMaybe<Array<InputMaybe<ProjectStatusEnum>>>;
  taskName?: InputMaybe<Scalars['String']>;
  taskStatuses?: InputMaybe<Array<InputMaybe<TaskStatusEnum>>>;
}

/** Totals of user time entry given a project and a time period */
export interface TimeEntrySummary {
  __typename?: 'TimeEntrySummary';
  totalBillableHours: Scalars['Float'];
  totalEstimatedHours: Scalars['Float'];
  totalHours?: Maybe<Scalars['Float']>;
  totalNonBillableHours: Scalars['Float'];
  totals: Array<TimeEntryTotalType>;
  totalsLoggedPerTask?: Maybe<Array<TimeEntryTotalLoggedPerTaskType>>;
}

/** A sum of logged hours in a task */
export interface TimeEntryTotalLoggedPerTaskType {
  __typename?: 'TimeEntryTotalLoggedPerTaskType';
  hours?: Maybe<Scalars['Float']>;
  taskId?: Maybe<Scalars['String']>;
}

/** A sum of hours in a date */
export interface TimeEntryTotalType {
  __typename?: 'TimeEntryTotalType';
  billable?: Maybe<Scalars['Boolean']>;
  dateWorked: Scalars['DateType'];
  hours: Scalars['Float'];
}

/** Summary of time records given a user project and date range */
export interface TimeRecordSummaryType {
  __typename?: 'TimeRecordSummaryType';
  billableHours?: Maybe<Scalars['Int']>;
  estimatedHours?: Maybe<Scalars['Int']>;
  totalHours?: Maybe<Scalars['Int']>;
}

/** A sum of hours in a date */
export interface TimeRecordTotalType {
  __typename?: 'TimeRecordTotalType';
  dateWorked: Scalars['String'];
  hours: Scalars['Float'];
}

/** totals of user time records given a project and a time period */
export interface TimeRecordTotalsType {
  __typename?: 'TimeRecordTotalsType';
  billableHours: Scalars['Float'];
  estimatedHours: Scalars['Float'];
  nonBillableHours: Scalars['Float'];
  totalHours: Scalars['Float'];
  totals: Array<TimeRecordTotalType>;
}

/** A set of time records */
export interface TimeRecordType {
  __typename?: 'TimeRecordType';
  billable?: Maybe<Scalars['Boolean']>;
  category?: Maybe<TimeTrackingCategory>;
  categoryId?: Maybe<Scalars['ID']>;
  creator?: Maybe<UserType>;
  dateWorked?: Maybe<Scalars['DateType']>;
  description?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  project?: Maybe<ProjectType>;
  projectId: Scalars['ID'];
  task?: Maybe<TaskType>;
  taskId?: Maybe<Scalars['ID']>;
  worker?: Maybe<UserType>;
  workerId: Scalars['ID'];
}

/** Time report stats on an object */
export interface TimeReport {
  __typename?: 'TimeReport';
  allTimeUserProjectTotalHours?: Maybe<Scalars['Float']>;
  billableHours: Scalars['Float'];
  estimatedHours: Scalars['Float'];
  nonBillableHours: Scalars['Float'];
  revenue?: Maybe<Scalars['Float']>;
  totalBilled?: Maybe<Scalars['Float']>;
  totalCost?: Maybe<Scalars['Float']>;
  totalHours: Scalars['Float'];
}

/** Enum for the possible report scope types */
export enum TimeReportExportStyleEnumType {
  /** detailed */
  Detailed = 'DETAILED',
  /** summary */
  Summary = 'SUMMARY'
}

/** Filters for a time report */
export interface TimeReportFiltersInput {
  pmItemsOnly?: InputMaybe<Scalars['Boolean']>;
  projectStatuses?: InputMaybe<Array<InputMaybe<ProjectStatusEnum>>>;
  taskName?: InputMaybe<Scalars['String']>;
  taskResponsibilities?: InputMaybe<Array<InputMaybe<TaskResponsibilityEnumType>>>;
  taskStatuses?: InputMaybe<Array<InputMaybe<TaskStatusEnum>>>;
}

/** A reporting summary for projects or users given a date range and filters */
export interface TimeReportSummary {
  __typename?: 'TimeReportSummary';
  billableHours: Scalars['Float'];
  estimatedHours: Scalars['Float'];
  nonBillableHours: Scalars['Float'];
  revenue?: Maybe<Scalars['Float']>;
  totalBilled?: Maybe<Scalars['Float']>;
  totalCost?: Maybe<Scalars['Float']>;
  totalHours?: Maybe<Scalars['Float']>;
  warning?: Maybe<TimeReportWarningEnumType>;
}

/** Enum for the time report warnings */
export enum TimeReportWarningEnumType {
  /** fixed_rate_cost_incomplete */
  FixedRateCostIncomplete = 'FIXED_RATE_COST_INCOMPLETE'
}

/** A connection of projects with time reporting summary */
export interface TimeReportingConnectionType {
  __typename?: 'TimeReportingConnectionType';
  dataList: Array<TimeReportingItemType>;
  pageInfo: PageInfoType;
}

export interface TimeReportingDetailConnectionType {
  __typename?: 'TimeReportingDetailConnectionType';
  dataList: Array<TimeReportingDetailType>;
  pageInfo: PageInfoType;
}

export interface TimeReportingDetailType {
  __typename?: 'TimeReportingDetailType';
  billableHours: Scalars['Float'];
  dateWorked: Scalars['DateType'];
  name: Scalars['String'];
  totalHours: Scalars['Float'];
  userName: Scalars['String'];
}

export interface TimeReportingFilters {
  projectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
}

/** The parent of a item reporting is polymorphic */
export type TimeReportingItemType = MilestoneType | ProjectType | TaskType;

export interface TimeTrackingCategory {
  __typename?: 'TimeTrackingCategory';
  billable: Scalars['Boolean'];
  billableRate: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
}

/** Organization time-tracking settings */
export interface TimeTrackingSettingsType {
  __typename?: 'TimeTrackingSettingsType';
  disableTimeEntryForCompletedProjects?: Maybe<Scalars['Boolean']>;
  disableTimeEntryForPastMonths?: Maybe<Scalars['Boolean']>;
}

/** A set of projects including their common project manager */
export interface TimelineProjectType {
  __typename?: 'TimelineProjectType';
  projectCountPerDay?: Maybe<Array<ProjectCountPerDayType>>;
  projectCountPerWeek?: Maybe<Array<ProjectCountPerDayType>>;
  projectManager?: Maybe<UserType>;
  projects?: Maybe<Array<ProjectType>>;
}

/** Information about projects in a timeline query response */
export interface TimelineProjectsResponseType {
  __typename?: 'TimelineProjectsResponseType';
  endDate?: Maybe<Scalars['DateType']>;
  projectsByProjectManager?: Maybe<Array<TimelineProjectType>>;
  startDate?: Maybe<Scalars['DateType']>;
}

export interface UpdateEmailAnswerSurveyInput {
  notes?: InputMaybe<Scalars['String']>;
  questionId: Scalars['ID'];
  surveyInviteId: Scalars['ID'];
}

/** update file input */
export interface UpdateFileInput {
  id: Scalars['ID'];
  internalOnly?: InputMaybe<Scalars['Boolean']>;
}

/** Autogenerated return type of Update. */
export interface UpdatePayload {
  __typename?: 'UpdatePayload';
  note?: Maybe<NoteType>;
}

/** Autogenerated return type of UpdateStatusChangeReason. */
export interface UpdateStatusChangeReasonPayload {
  __typename?: 'UpdateStatusChangeReasonPayload';
  statusChangeReason?: Maybe<StatusChangeReasonType>;
}

/** Expected arguments for updating a user project */
export interface UpdateUserProjectArguments {
  projectView?: InputMaybe<ProjectViewEnum>;
  restrictAccess?: InputMaybe<Scalars['Boolean']>;
}

/** Enum for updater */
export enum UpdaterEnumType {
  /** add */
  Add = 'ADD',
  /** replace */
  Replace = 'REPLACE'
}

/** Updater Operator */
export interface UpdaterOperatorType {
  tagUpdater?: InputMaybe<UpdaterEnumType>;
  watcherUpdater?: InputMaybe<UpdaterEnumType>;
}

/** Create or update a custom configuration */
export interface UpsertCustomConfigurationInputType {
  configuration: Scalars['String'];
  layoutIdentifier: Scalars['String'];
}

/** Creates or updates global Jira settings */
export interface UpsertGainsightSettingsInput {
  id?: InputMaybe<Scalars['ID']>;
  syncProjectNotesToActivityTimeline?: InputMaybe<Scalars['Boolean']>;
  syncTaskToCta?: InputMaybe<Scalars['Boolean']>;
}

/** Autogenerated return type of UpsertGainsightSettings. */
export interface UpsertGainsightSettingsPayload {
  __typename?: 'UpsertGainsightSettingsPayload';
  settings: GainsightSettings;
}

/** Creates or updates global Jira settings */
export interface UpsertJiraSettingsInput {
  id?: InputMaybe<Scalars['ID']>;
  issueTypeId?: InputMaybe<Scalars['String']>;
  issueTypeName?: InputMaybe<Scalars['String']>;
  priorities?: InputMaybe<JiraPriorityInput>;
  projectId?: InputMaybe<Scalars['String']>;
  projectKey?: InputMaybe<Scalars['String']>;
  projectName?: InputMaybe<Scalars['String']>;
  pushAs?: InputMaybe<JiraPushAsEnumType>;
  statuses?: InputMaybe<JiraStatusInput>;
}

/** Autogenerated return type of UpsertJiraSettings. */
export interface UpsertJiraSettingsPayload {
  __typename?: 'UpsertJiraSettingsPayload';
  settings: JiraSettings;
}

/** Create or update project info field input */
export interface UpsertProjectInfoFieldInput {
  projectId: Scalars['ID'];
  projectInfoFields: Array<ProjectInfoFieldInput>;
}

export interface UpsertUserAccountPropertiesInput {
  priorities: PrioritiesInput;
  statuses: StatusesInput;
}

/** Enum for the possible user capacity filter */
export enum UserCapacityEnum {
  /** c0to50 */
  C0To50 = 'C0TO50',
  /** c50to75 */
  C50To75 = 'C50TO75',
  /** c75to100 */
  C75To100 = 'C75TO100',
  /** over100 */
  Over100 = 'OVER100'
}

/** The input type for UserCustomConfigurationConnections */
export interface UserCustomConfigurationConnectionsInputType {
  layoutIdentifiers: Array<Scalars['String']>;
}

/** Enum for possible saved filter types */
export enum UserFilterViewEnumType {
  /** project */
  Project = 'PROJECT',
  /** task */
  Task = 'TASK'
}

/** a saved set of filters for a user */
export interface UserFilterViewType {
  __typename?: 'UserFilterViewType';
  category?: Maybe<UserFilterViewEnumType>;
  customers?: Maybe<Array<CustomerType>>;
  filters?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isDefault?: Maybe<Scalars['Boolean']>;
  /** @deprecated use filters instead */
  jsonFilterBlob?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  user?: Maybe<UserType>;
}

export interface UserOverBudgetDataType {
  __typename?: 'UserOverBudgetDataType';
  estimatedHours: Scalars['Float'];
  totalHours: Scalars['Float'];
  user: UserType;
}

/** represents the relationship between a customer user and a project */
export interface UserProject {
  __typename?: 'UserProject';
  id: Scalars['ID'];
  orgType: UserProjectOrganizationTypeEnumType;
  projectView?: Maybe<ProjectViewEnum>;
  restrictAccess: Scalars['Boolean'];
}

/** Enum for the possible user project organization types */
export enum UserProjectOrganizationTypeEnumType {
  /** Provider projects that have been archived */
  Archived = 'ARCHIVED',
  Customer = 'CUSTOMER',
  /** Provider projects that have been deleted */
  Deleted = 'DELETED',
  Provider = 'PROVIDER',
  /** Provider projects including those that were archived */
  ResourceManagement = 'RESOURCE_MANAGEMENT',
  ThirdParty = 'THIRD_PARTY'
}

/** Stats for a user on a project */
export interface UserProjectStatsType {
  __typename?: 'UserProjectStatsType';
  activeOverdueTasks?: Maybe<Scalars['Int']>;
  totalDoneTasks?: Maybe<Scalars['Int']>;
  totalOverdueTasks?: Maybe<Scalars['Int']>;
  totalPlannedTasks?: Maybe<Scalars['Int']>;
  totalRemainingTasks?: Maybe<Scalars['Int']>;
}

/** Enum for the possible user roles */
export enum UserRoleEnumType {
  /** admin */
  Admin = 'ADMIN',
  /** contributor */
  Contributor = 'CONTRIBUTOR',
  /** guide */
  Guide = 'GUIDE',
  /** manager */
  Manager = 'MANAGER',
  /** observer */
  Observer = 'OBSERVER',
  /** project_manager */
  ProjectManager = 'PROJECT_MANAGER',
  /** super_admin */
  SuperAdmin = 'SUPER_ADMIN',
  /** task_owner */
  TaskOwner = 'TASK_OWNER'
}

/** A user */
export interface UserType {
  __typename?: 'UserType';
  addedToQualtricsAt?: Maybe<Scalars['DateType']>;
  adminTeamsEnabled?: Maybe<Scalars['Boolean']>;
  avatar?: Maybe<ImageType>;
  bio?: Maybe<Scalars['String']>;
  calendarLink?: Maybe<Scalars['String']>;
  capacity?: Maybe<Scalars['Int']>;
  capacityHours?: Maybe<Scalars['Float']>;
  company?: Maybe<Scalars['String']>;
  costRate?: Maybe<Scalars['Float']>;
  costRateHistory: Array<CostRateHistoryType>;
  createdAt?: Maybe<Scalars['DateType']>;
  deactivated?: Maybe<Scalars['Boolean']>;
  displayOrganization?: Maybe<DisplayOrganizationType>;
  email?: Maybe<Scalars['String']>;
  firebaseMessagingToken?: Maybe<Scalars['String']>;
  firstAccessWithSecureLink?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  hasAccount?: Maybe<Scalars['Boolean']>;
  hideEmail?: Maybe<Scalars['Boolean']>;
  hidePhone?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isDarkModeEnabled?: Maybe<Scalars['Boolean']>;
  isThirdParty: Scalars['Boolean'];
  jobRole?: Maybe<Scalars['String']>;
  lastActivityAt?: Maybe<Scalars['DateType']>;
  lastName?: Maybe<Scalars['String']>;
  meetingLink?: Maybe<Scalars['String']>;
  notificationPreferences?: Maybe<NotificationPreferenceType>;
  onlyNotificationsTeamsEnabled?: Maybe<Scalars['Boolean']>;
  organization?: Maybe<OrganizationType>;
  organizationName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  projectConnectionCount: Scalars['Int'];
  projectContext?: Maybe<UserProjectOrganizationTypeEnumType>;
  projectRestrictedAccess?: Maybe<Scalars['Boolean']>;
  projectRoles: Array<ProjectRoleType>;
  projectSettings?: Maybe<UserProject>;
  projectStats?: Maybe<UserProjectStatsType>;
  projectsCount?: Maybe<Scalars['Int']>;
  role?: Maybe<UserRoleEnumType>;
  shouldDisableEmail?: Maybe<Scalars['Boolean']>;
  skillCategories: Array<SkillCategory>;
  skills: Array<Skill>;
  smsSettings?: Maybe<SmsSettings>;
  status?: Maybe<Scalars['String']>;
  timeCapacities: Array<CapacityType>;
  timeReport: TimeReport;
  timeReportingProjectsCount: Scalars['Int'];
  timeZone: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateType']>;
  watchedTasks?: Maybe<Array<TaskType>>;
  weeklyHours: Scalars['Float'];
}


/** A user */
export interface UserTypeProjectConnectionCountArgs {
  strict?: InputMaybe<Scalars['Boolean']>;
}


/** A user */
export interface UserTypeTimeCapacitiesArgs {
  filters: CapacityFilterInput;
  groupBy: CapacityGroupByEnum;
}


/** A user */
export interface UserTypeTimeReportArgs {
  endDate: Scalars['DateType'];
  filters?: InputMaybe<TimeReportFiltersInput>;
  includeGeneric?: InputMaybe<Scalars['Boolean']>;
  startDate: Scalars['DateType'];
}


/** A user */
export interface UserTypeTimeReportingProjectsCountArgs {
  endDate?: InputMaybe<Scalars['DateType']>;
  filters?: InputMaybe<TimeReportFiltersInput>;
  startDate?: InputMaybe<Scalars['DateType']>;
}

/** A connection of users with time records */
export interface UsersTimeReportType {
  __typename?: 'UsersTimeReportType';
  pageInfo: PageInfoType;
  users: Array<UserType>;
}

/** Oraganization vanity subdomain */
export interface VanitySubdomain {
  __typename?: 'VanitySubdomain';
  subdomain: Scalars['String'];
}

/** The Webhook Delivery type */
export interface WebhookDeliveryType {
  __typename?: 'WebhookDeliveryType';
  action?: Maybe<Scalars['String']>;
  attempts?: Maybe<Scalars['Int']>;
  details?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  responseCode?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  webhook?: Maybe<WebhookType>;
}

/** The Webhook type */
export interface WebhookType {
  __typename?: 'WebhookType';
  active?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  secret?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
}

/** An Issue Type available in this Jira integration */
export interface WorkatoJiraIssueType {
  __typename?: 'WorkatoJiraIssueType';
  id: Scalars['String'];
  name: Scalars['String'];
}

/** accept invitation input */
export interface AcceptInvitationInput {
  /** The base64 encoded version of the avatar image with metadata prefix e.g. "data:image/png;base64,iVBG..." */
  base64Avatar?: InputMaybe<Scalars['String']>;
  bio?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  invitationToken: Scalars['String'];
  jobRole?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  smsEnabled?: InputMaybe<Scalars['Boolean']>;
  testMode?: InputMaybe<Scalars['Boolean']>;
}

/** Autogenerated return type of acceptInvitation. */
export interface AcceptInvitationPayload {
  __typename?: 'acceptInvitationPayload';
  user?: Maybe<UserType>;
}

/** Export all the action items for a company */
export interface ActionItemsExportInput {
  organizationId: Scalars['ID'];
}

/** Autogenerated return type of actionItemsExport. */
export interface ActionItemsExportPayload {
  __typename?: 'actionItemsExportPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** Input for adding a new customer user without an organization or project */
export interface AddBasicCustomerUserInput {
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName?: InputMaybe<Scalars['String']>;
}

/** Autogenerated return type of addBasicCustomerUser. */
export interface AddBasicCustomerUserPayload {
  __typename?: 'addBasicCustomerUserPayload';
  user?: Maybe<UserType>;
}

/** add customer user input */
export interface AddCustomerUserInput {
  customerId: Scalars['ID'];
  projectId?: InputMaybe<Scalars['ID']>;
  users?: InputMaybe<Array<InputMaybe<ProjectUserInput>>>;
}

/** Adds a new or existing customer user to a project */
export interface AddCustomerUsersToProjectInput {
  defaultAssigneeIndex?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  users?: InputMaybe<Array<InputMaybe<ProjectUserInput>>>;
}

/** Autogenerated return type of addCustomerUsersToProject. */
export interface AddCustomerUsersToProjectPayload {
  __typename?: 'addCustomerUsersToProjectPayload';
  addedUsers?: Maybe<Array<UserType>>;
  project?: Maybe<ProjectType>;
}

/** Autogenerated return type of addCustomerUsersV2. */
export interface AddCustomerUsersV2Payload {
  __typename?: 'addCustomerUsersV2Payload';
  addedUsers?: Maybe<Array<UserType>>;
  success?: Maybe<Scalars['Boolean']>;
}

/** Adds internal users to a project */
export interface AddInternalUsersToProjectInput {
  defaultAssigneeId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  ids: Array<InputMaybe<Scalars['String']>>;
  overrideAssignedTasks?: InputMaybe<Scalars['Boolean']>;
}

/** Autogenerated return type of addInternalUsersToProject. */
export interface AddInternalUsersToProjectPayload {
  __typename?: 'addInternalUsersToProjectPayload';
  project?: Maybe<ProjectType>;
}

/** add report input */
export interface AddReportInput {
  organizationId: Scalars['ID'];
  publicId: Scalars['String'];
  reportActive?: InputMaybe<Scalars['Boolean']>;
  reportTitle: Scalars['String'];
  reportType: Scalars['String'];
  reportUrl: Scalars['String'];
}

/** Autogenerated return type of addReport. */
export interface AddReportPayload {
  __typename?: 'addReportPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** Adds a tag to a Project, Task or ActionItem */
export interface AddTagInput {
  tagId: Scalars['ID'];
  taggableId: Scalars['ID'];
  taggableType: TaggableEnumType;
}

/** Autogenerated return type of addTag. */
export interface AddTagPayload {
  __typename?: 'addTagPayload';
  taggable?: Maybe<TaggableType>;
}

/** Adds templates to a project */
export interface AddTemplatesToProjectInput {
  id: Scalars['ID'];
  sortOrder?: InputMaybe<Scalars['Float']>;
  templateIds: Array<InputMaybe<Scalars['ID']>>;
}

/** Autogenerated return type of addTemplatesToProject. */
export interface AddTemplatesToProjectPayload {
  __typename?: 'addTemplatesToProjectPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** Adds third party users to a project */
export interface AddThirdPartyUsersToProjectInput {
  id: Scalars['ID'];
  users: Array<InputMaybe<ProjectUserInput>>;
}

/** Autogenerated return type of addThirdPartyUsersToProject. */
export interface AddThirdPartyUsersToProjectPayload {
  __typename?: 'addThirdPartyUsersToProjectPayload';
  project?: Maybe<ProjectType>;
}

/** add user connection input */
export interface AddUserConnectionInput {
  email: Scalars['String'];
  firstName: Scalars['String'];
  isPrimaryContact?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  organizationName?: InputMaybe<Scalars['String']>;
  role: UserRoleEnumType;
}

/** Autogenerated return type of addUserConnection. */
export interface AddUserConnectionPayload {
  __typename?: 'addUserConnectionPayload';
  user: UserType;
}

export interface AddUserToQualtricsInput {
  projectId: Scalars['ID'];
  userId: Scalars['ID'];
}

/** Autogenerated return type of addUserToQualtrics. */
export interface AddUserToQualtricsPayload {
  __typename?: 'addUserToQualtricsPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** Add users to projects input */
export interface AddUsersToProjectsInput {
  projectIds: Array<Scalars['ID']>;
  userIds: Array<Scalars['ID']>;
}

/** Autogenerated return type of addUsersToProjects. */
export interface AddUsersToProjectsPayload {
  __typename?: 'addUsersToProjectsPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** add watcher input */
export interface AddWatcherInput {
  taskId: Scalars['ID'];
  watcherId: Scalars['ID'];
}

/** Autogenerated return type of addWatcher. */
export interface AddWatcherPayload {
  __typename?: 'addWatcherPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** Autogenerated return type of answerSurvey. */
export interface AnswerSurveyPayload {
  __typename?: 'answerSurveyPayload';
  success: Scalars['Boolean'];
}

/** Archives a project input */
export interface ArchiveProjectInput {
  id: Scalars['ID'];
}

/** Autogenerated return type of archiveProject. */
export interface ArchiveProjectPayload {
  __typename?: 'archiveProjectPayload';
  project?: Maybe<ProjectType>;
}

/** Asset input */
export interface AssetCreateInput {
  externalLink?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  internalOnly?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Scalars['Float']>;
}

/** assign firebase messaging token input */
export interface AssignFirebaseMessagingTokenInput {
  id: Scalars['ID'];
  messagingToken: Scalars['String'];
}

/** assign user to role input */
export interface AssignUserToRoleInput {
  assignAllRoleTasks?: InputMaybe<Scalars['Boolean']>;
  projectId: Scalars['ID'];
  roleId: Scalars['ID'];
  userId: Scalars['ID'];
}

/** Autogenerated return type of assignUserToRole. */
export interface AssignUserToRolePayload {
  __typename?: 'assignUserToRolePayload';
  projectRoles?: Maybe<Array<Skill>>;
  teamMember?: Maybe<UserType>;
}

/** assign user to roles input */
export interface AssignUserToRolesInput {
  assignAllRoleTasks?: InputMaybe<Scalars['Boolean']>;
  projectId: Scalars['ID'];
  roleIds: Array<Scalars['ID']>;
  userId: Scalars['ID'];
}

/** Autogenerated return type of assignUserToRoles. */
export interface AssignUserToRolesPayload {
  __typename?: 'assignUserToRolesPayload';
  teamMember?: Maybe<UserType>;
}

/** Updates the assignee user in a group of projects */
export interface BulkAssignProjectsInput {
  projectManagerId?: InputMaybe<Scalars['ID']>;
  projectsIds: Array<Scalars['ID']>;
}

/** Autogenerated return type of bulkAssignProjects. */
export interface BulkAssignProjectsPayload {
  __typename?: 'bulkAssignProjectsPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** Deletes many pending projects */
export interface BulkDeletePendingProjectsInput {
  pendingProjectIds: Array<Scalars['ID']>;
}

/** Autogenerated return type of bulkDeletePendingProjects. */
export interface BulkDeletePendingProjectsPayload {
  __typename?: 'bulkDeletePendingProjectsPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** Input to delete multiple projects */
export interface BulkDeleteProjectInput {
  ids: Array<Scalars['ID']>;
}

/** Autogenerated return type of bulkDeleteProjects. */
export interface BulkDeleteProjectsPayload {
  __typename?: 'bulkDeleteProjectsPayload';
  success: Scalars['Boolean'];
}

export interface BulkEditProjectsInput {
  projectIds: Array<Scalars['ID']>;
  tagIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Should the provided tags replace or be added to existing project tags? */
  tagOperator?: InputMaybe<UpdaterEnumType>;
}

/** Autogenerated return type of bulkEditProjects. */
export interface BulkEditProjectsPayload {
  __typename?: 'bulkEditProjectsPayload';
  projects: Array<ProjectType>;
}

/** bulk edit tasks input */
export interface BulkEditTasksInput {
  assigneeId?: InputMaybe<Scalars['ID']>;
  operators?: InputMaybe<UpdaterOperatorType>;
  priority?: InputMaybe<PriorityEnumType>;
  responsibility?: InputMaybe<TaskResponsibilityEnumType>;
  skillId?: InputMaybe<Scalars['ID']>;
  skillIds?: InputMaybe<Array<Scalars['ID']>>;
  status?: InputMaybe<StatusEnumType>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  taskGroupId?: InputMaybe<Scalars['ID']>;
  taskIds: Array<Scalars['ID']>;
  visibility?: InputMaybe<TaskVisibilityEnumType>;
  watcherIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
}

/** Autogenerated return type of bulkEditTasks. */
export interface BulkEditTasksPayload {
  __typename?: 'bulkEditTasksPayload';
  updatedTasks?: Maybe<Array<Maybe<TaskType>>>;
}

/** Result of successful and unsuccessful imported user */
export interface BulkImportedUser {
  __typename?: 'bulkImportedUser';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  skipInvitationEmail?: Maybe<Scalars['Boolean']>;
}

/** Result of successful and unsuccessful imported users */
export interface BulkImportedUsers {
  __typename?: 'bulkImportedUsers';
  acceptedUsers?: Maybe<Array<Maybe<UserType>>>;
  invalidUsers?: Maybe<Array<Maybe<BulkImportedUser>>>;
}

/** Input expected for bulk importing projects */
export interface BulkProjectImportInput {
  customerDomain: Scalars['String'];
  endOn?: InputMaybe<Scalars['DateType']>;
  projectManagerId: Scalars['ID'];
  projectName: Scalars['String'];
  startOn?: InputMaybe<Scalars['DateType']>;
  templateId?: InputMaybe<Scalars['ID']>;
}

/** Autogenerated return type of bulkProjectImport. */
export interface BulkProjectImportPayload {
  __typename?: 'bulkProjectImportPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** Input to reassign the project manager of multiple projects */
export interface BulkReassignPmInput {
  assignInternalTasks?: InputMaybe<Scalars['Boolean']>;
  newProjectManagerId: Scalars['ID'];
  projectIds: Array<Scalars['ID']>;
  reassignIncompleteTasks?: InputMaybe<Scalars['Boolean']>;
  skipProjectInvitationEmail?: InputMaybe<Scalars['Boolean']>;
  skipTaskReassignmentEmail?: InputMaybe<Scalars['Boolean']>;
}

/** Autogenerated return type of bulkReassignProjectManager. */
export interface BulkReassignProjectManagerPayload {
  __typename?: 'bulkReassignProjectManagerPayload';
  success: Scalars['Boolean'];
}

/** Input expected to bulk import templates */
export interface BulkTemplateImportInput {
  base64TemplateCsv: Scalars['String'];
  organizationId: Scalars['ID'];
}

/** Autogenerated return type of bulkTemplateImport. */
export interface BulkTemplateImportPayload {
  __typename?: 'bulkTemplateImportPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** Input expected to bulk import users */
export interface BulkUserImportInput {
  base64UserCsv: Scalars['String'];
  organizationId: Scalars['ID'];
}

/** Autogenerated return type of bulkUserImport. */
export interface BulkUserImportPayload {
  __typename?: 'bulkUserImportPayload';
  users?: Maybe<BulkImportedUsers>;
}

/** Changes the default filter view for a user */
export interface ChangeDefaultUserFilterInput {
  category: Scalars['String'];
  id: Scalars['ID'];
}

/** Autogenerated return type of changeDefaultUserFilter. */
export interface ChangeDefaultUserFilterPayload {
  __typename?: 'changeDefaultUserFilterPayload';
  userFilterViews?: Maybe<Array<UserFilterViewType>>;
}

/** change status input */
export interface ChangeStatusInput {
  status?: InputMaybe<StatusEnumType>;
  stuckMessage?: InputMaybe<Scalars['String']>;
  taskId: Scalars['ID'];
}

/** Autogenerated return type of changeStatus. */
export interface ChangeStatusPayload {
  __typename?: 'changeStatusPayload';
  task?: Maybe<PublicTask>;
}

export interface CheckCanDeactivateUserInput {
  id: Scalars['ID'];
}

/** Autogenerated return type of checkCanDeactivateUser. */
export interface CheckCanDeactivateUserPayload {
  __typename?: 'checkCanDeactivateUserPayload';
  results?: Maybe<CanDeactivateUserResults>;
}

/** Input necessary to clone a template into provided organization */
export interface CloneTemplateIntoOrganizationInput {
  destinationOrganizationId: Scalars['ID'];
  templateId: Scalars['ID'];
}

/** Autogenerated return type of cloneTemplateIntoOrganization. */
export interface CloneTemplateIntoOrganizationPayload {
  __typename?: 'cloneTemplateIntoOrganizationPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** connect hub spot input */
export interface ConnectHubSpotInput {
  code: Scalars['String'];
  organizationId: Scalars['ID'];
}

/** Autogenerated return type of connectHubSpot. */
export interface ConnectHubSpotPayload {
  __typename?: 'connectHubSpotPayload';
  organization?: Maybe<OrganizationType>;
}

/** connect salesforce input */
export interface ConnectSalesforceInput {
  code: Scalars['String'];
  host?: InputMaybe<SalesforceHostEnum>;
  organizationId: Scalars['ID'];
}

/** Autogenerated return type of connectSalesforce. */
export interface ConnectSalesforcePayload {
  __typename?: 'connectSalesforcePayload';
  organization?: Maybe<OrganizationType>;
}

/** Create a new action item */
export interface CreateActionItemInput {
  assigneeId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['DraftJsTextType']>;
  dueOn?: InputMaybe<Scalars['DateType']>;
  name: Scalars['String'];
  priority?: InputMaybe<PriorityEnumType>;
  projectId: Scalars['ID'];
  relatedTaskId?: InputMaybe<Scalars['ID']>;
  startOn?: InputMaybe<Scalars['DateType']>;
  visibility?: InputMaybe<TaskVisibilityEnumType>;
}

/** Autogenerated return type of createActionItem. */
export interface CreateActionItemPayload {
  __typename?: 'createActionItemPayload';
  actionItem?: Maybe<ActionItemType>;
}

/** Creates a new tag available to all Projects, Tasks or ActionItems of an organization */
export interface CreateAvailableTagInput {
  color: Scalars['String'];
  internalOnly?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  taggableId: Scalars['ID'];
  taggableType: TaggableEnumType;
}

/** Autogenerated return type of createAvailableTag. */
export interface CreateAvailableTagPayload {
  __typename?: 'createAvailableTagPayload';
  tag?: Maybe<TagType>;
}

/** Create a new billing profile */
export interface CreateBillingProfileInput {
  allottedHours?: InputMaybe<Scalars['Float']>;
  allowOverages?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  dollars?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  rateType: RateTypeEnum;
  secondaryDollars?: InputMaybe<Scalars['Float']>;
  secondaryRateType?: InputMaybe<RateTypeEnum>;
}

/** Autogenerated return type of createBillingProfile. */
export interface CreateBillingProfilePayload {
  __typename?: 'createBillingProfilePayload';
  billingProfile?: Maybe<BillingProfileType>;
}

/** Creates a brand */
export interface CreateBrandInput {
  /** The base64 encoded version of the logo image with metadata prefix e.g. "data:image/png;base64,<base64...>" */
  base64HeaderLogo?: InputMaybe<Scalars['String']>;
  /** The base64 encoded version of the logo image with metadata prefix e.g. "data:image/png;base64,<base64...>" */
  base64Logo?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  primaryColor?: InputMaybe<Scalars['String']>;
}

/** Autogenerated return type of createBrand. */
export interface CreateBrandPayload {
  __typename?: 'createBrandPayload';
  brand?: Maybe<BrandType>;
}

/** Input expected to create template by import */
export interface CreateByImportInput {
  organizationId: Scalars['ID'];
  uploadFileName: Scalars['String'];
  uploadFileUrl: Scalars['String'];
}

/** Autogenerated return type of createCustomer. */
export interface CreateCustomerPayload {
  __typename?: 'createCustomerPayload';
  customer?: Maybe<CustomerType>;
}

/** Autogenerated return type of createCustomerRole. */
export interface CreateCustomerRolePayload {
  __typename?: 'createCustomerRolePayload';
  success: Scalars['Boolean'];
}

/** Autogenerated return type of createEmailAnswerSurvey. */
export interface CreateEmailAnswerSurveyPayload {
  __typename?: 'createEmailAnswerSurveyPayload';
  success: Scalars['Boolean'];
}

/** Input expected to create a template, project, or users by import */
export interface CreateEntityByImportInput {
  organizationId: Scalars['ID'];
  uploadFileName: Scalars['String'];
  uploadFileUrl: Scalars['String'];
}

/** Autogenerated return type of createEntityByImport. */
export interface CreateEntityByImportPayload {
  __typename?: 'createEntityByImportPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** Create an Installation. */
export interface CreateInstallationInput {
  buildVersion?: InputMaybe<Scalars['String']>;
  deviceToken?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<InstallationDeviceTypeEnum>;
  userId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['String']>;
}

/** Autogenerated return type of createInstallation. */
export interface CreateInstallationPayload {
  __typename?: 'createInstallationPayload';
  installation?: Maybe<InstallationType>;
}

/** Autogenerated return type of createIpaasAccount. */
export interface CreateIpaasAccountPayload {
  __typename?: 'createIpaasAccountPayload';
  success: Scalars['Boolean'];
}

/** Create note input */
export interface CreateNoteInput {
  internalOnly?: InputMaybe<Scalars['Boolean']>;
  noteAttachments?: InputMaybe<Array<AssetCreateInput>>;
  noteableId: Scalars['ID'];
  noteableType: NoteableEnumType;
  raw: Scalars['DraftJsTextType'];
}

/** create organization input */
export interface CreateOrganizationInput {
  /**
   * The base64 encoded version of the logo image with metadata prefix.
   * e.g. "data:image/png;base64,<base64...>"'
   *
   * Note: this can also be a Clearbit image URI, I know... naming doesn't make sense
   *
   */
  base64Logo?: InputMaybe<Scalars['String']>;
  domain: Scalars['String'];
  name: Scalars['String'];
  /**
   * Trial Account
   *
   * These are meant to be short-lived accounts that will be upgraded to a full instance
   * once the trial has been converted into a paid account. Organizations can be updated
   * through the update mutation to remove the "Trial" status.
   *
   */
  trial?: InputMaybe<Scalars['Boolean']>;
  type: OrganizationTypeEnumType;
}

/** Autogenerated return type of createOrganization. */
export interface CreateOrganizationPayload {
  __typename?: 'createOrganizationPayload';
  organization?: Maybe<OrganizationType>;
}

/** Creates a project */
export interface CreateProjectInput {
  apiProjectId?: InputMaybe<Scalars['ID']>;
  bccEmails?: InputMaybe<Scalars['String']>;
  bccEmailsEnabled?: InputMaybe<Scalars['Boolean']>;
  bccToProjectManager?: InputMaybe<Scalars['Boolean']>;
  brandId?: InputMaybe<Scalars['ID']>;
  cashValue?: InputMaybe<Scalars['Int']>;
  customerId?: InputMaybe<Scalars['ID']>;
  endOn?: InputMaybe<Scalars['DateType']>;
  externalId?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Array<InputMaybe<FileInput>>>;
  name: Scalars['String'];
  /** Pending Project to link to this new Project */
  pendingProjectId?: InputMaybe<Scalars['ID']>;
  projectBillRate?: InputMaybe<ProjectBillRateInputType>;
  projectManagerId?: InputMaybe<Scalars['ID']>;
  /** Should a forecasted end date be calculated for this project? */
  showForecast?: InputMaybe<Scalars['Boolean']>;
  startOn?: InputMaybe<Scalars['DateType']>;
  status?: InputMaybe<StatusEnumType>;
  templateIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  v2CustomerId?: InputMaybe<Scalars['ID']>;
}

/** Autogenerated return type of createProject. */
export interface CreateProjectPayload {
  __typename?: 'createProjectPayload';
  createdProject?: Maybe<CreateProjectResponseType>;
}

/** create project status change reason input */
export interface CreateProjectStatusChangeReasonInput {
  description?: InputMaybe<Scalars['String']>;
  projectId: Scalars['ID'];
  statusChangeReasonId: Scalars['ID'];
}

/** Autogenerated return type of createProjectStatusChangeReason. */
export interface CreateProjectStatusChangeReasonPayload {
  __typename?: 'createProjectStatusChangeReasonPayload';
  projectStatusChangeReason?: Maybe<ProjectStatusChangeReasonType>;
}

/** Autogenerated return type of createProjectTaskGroup. */
export interface CreateProjectTaskGroupPayload {
  __typename?: 'createProjectTaskGroupPayload';
  taskGroup?: Maybe<TaskGroupType>;
}

/** Creates a project v2 */
export interface CreateProjectV2Input {
  apiProjectId?: InputMaybe<Scalars['ID']>;
  assignInternalTasksToPM?: InputMaybe<Scalars['Boolean']>;
  bccEmails?: InputMaybe<Scalars['String']>;
  bccEmailsEnabled?: InputMaybe<Scalars['Boolean']>;
  bccToProjectManager?: InputMaybe<Scalars['Boolean']>;
  brandId?: InputMaybe<Scalars['ID']>;
  cashValue?: InputMaybe<Scalars['Int']>;
  endOn?: InputMaybe<Scalars['DateType']>;
  externalId?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Array<InputMaybe<FileInput>>>;
  languageCode?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  /** Pending Project to link to this new Project */
  pendingProjectId?: InputMaybe<Scalars['ID']>;
  projectBillRate?: InputMaybe<ProjectBillRateInputType>;
  projectInfoFields?: InputMaybe<Array<ProjectInfoFieldInput>>;
  projectManagerId: Scalars['ID'];
  /** Should a forecasted end date be calculated for this project? */
  showForecast?: InputMaybe<Scalars['Boolean']>;
  startOn?: InputMaybe<Scalars['DateType']>;
  status?: InputMaybe<StatusEnumType>;
  templatesInfo?: InputMaybe<Array<TemplateInfoInput>>;
  v2Customer?: InputMaybe<CustomerInputType>;
}

/** Autogenerated return type of createProjectV2. */
export interface CreateProjectV2Payload {
  __typename?: 'createProjectV2Payload';
  createdProject?: Maybe<CreateProjectResponseType>;
}

/** create skill category input */
export interface CreateSkillCategoryInput {
  name: Scalars['String'];
}

/** Autogenerated return type of createSkillCategory. */
export interface CreateSkillCategoryPayload {
  __typename?: 'createSkillCategoryPayload';
  skillCategory: SkillCategory;
}

/** create status change reason group input */
export interface CreateStatusChangeReasonGroupInput {
  name: Scalars['String'];
}

/** Autogenerated return type of createStatusChangeReasonGroup. */
export interface CreateStatusChangeReasonGroupPayload {
  __typename?: 'createStatusChangeReasonGroupPayload';
  statusChangeReasonGroup?: Maybe<StatusChangeReasonGroupType>;
}

/** create status change reason  input */
export interface CreateStatusChangeReasonInput {
  name: Scalars['String'];
  statusChangeReasonGroupId: Scalars['ID'];
}

/** Autogenerated return type of createStatusChangeReason. */
export interface CreateStatusChangeReasonPayload {
  __typename?: 'createStatusChangeReasonPayload';
  statusChangeReason?: Maybe<StatusChangeReasonType>;
}

/** create subtask group input */
export interface CreateSubtaskGroupInput {
  name: Scalars['String'];
  taskId: Scalars['ID'];
}

/** Autogenerated return type of createSubtaskGroup. */
export interface CreateSubtaskGroupPayload {
  __typename?: 'createSubtaskGroupPayload';
  task?: Maybe<TaskType>;
}

/** create subtask input */
export interface CreateSubtaskInput {
  name: Scalars['String'];
  sortOrder: Scalars['Float'];
  subtasksGroupId?: InputMaybe<Scalars['ID']>;
  subtasksGroupName?: InputMaybe<Scalars['String']>;
  taskId: Scalars['ID'];
}

/** Autogenerated return type of createSubtask. */
export interface CreateSubtaskPayload {
  __typename?: 'createSubtaskPayload';
  task?: Maybe<TaskType>;
}

/** create task group input */
export interface CreateTaskGroupInput {
  completionMessage?: InputMaybe<Scalars['DraftJsTextType']>;
  description?: InputMaybe<Scalars['String']>;
  enableCompletionNotification?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  parentId: Scalars['ID'];
  sortOrder?: InputMaybe<Scalars['Float']>;
  taskIds?: InputMaybe<Array<Scalars['ID']>>;
}

/** Autogenerated return type of createTaskGroup. */
export interface CreateTaskGroupPayload {
  __typename?: 'createTaskGroupPayload';
  taskGroup?: Maybe<TaskGroupType>;
}

/** create task input */
export interface CreateTaskInput {
  actualHours?: InputMaybe<Scalars['Float']>;
  assigneeId?: InputMaybe<Scalars['ID']>;
  billableHours?: InputMaybe<Scalars['Float']>;
  dependencyId?: InputMaybe<Scalars['ID']>;
  dependencyType?: InputMaybe<DependencyEnumType>;
  description?: InputMaybe<Scalars['DraftJsTextType']>;
  dueOn?: InputMaybe<Scalars['DateType']>;
  duration?: InputMaybe<Scalars['Int']>;
  estimatedHours?: InputMaybe<Scalars['Float']>;
  estimatedPoints?: InputMaybe<Scalars['Int']>;
  eventDatetime?: InputMaybe<Scalars['DateTimeType']>;
  eventInformation?: InputMaybe<Scalars['DraftJsTextType']>;
  eventTz?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Array<InputMaybe<FileInput>>>;
  id?: InputMaybe<Scalars['ID']>;
  jiraSync?: InputMaybe<Scalars['Boolean']>;
  jiraTask?: InputMaybe<JiraIssueInputType>;
  meetingLength?: InputMaybe<Scalars['Int']>;
  milestoneId: Scalars['ID'];
  mustStartOn?: InputMaybe<Scalars['DateType']>;
  mustStartOnRequired?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  nonBillableHours?: InputMaybe<Scalars['Float']>;
  note?: InputMaybe<Scalars['String']>;
  participantCallToAction?: InputMaybe<Scalars['DraftJsTextType']>;
  participantIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  participantsGroupType?: InputMaybe<ParticipantsGroupType>;
  priority?: InputMaybe<PriorityEnumType>;
  responsibility?: InputMaybe<TaskResponsibilityEnumType>;
  /** If included and true, the event participants will receive the invite email. */
  shouldNotifyAttendees?: InputMaybe<Scalars['Boolean']>;
  signOffRequired?: InputMaybe<Scalars['Boolean']>;
  signer?: InputMaybe<SignerInputType>;
  skillId?: InputMaybe<Scalars['ID']>;
  skillIds?: InputMaybe<Array<Scalars['ID']>>;
  sortOrder: Scalars['Float'];
  startOn?: InputMaybe<Scalars['DateType']>;
  taskGroup?: InputMaybe<Scalars['Boolean']>;
  taskGroupId?: InputMaybe<Scalars['ID']>;
  taskType: TaskTypeEnumType;
  visibility?: InputMaybe<TaskVisibilityEnumType>;
}

/** Autogenerated return type of createTask. */
export interface CreateTaskPayload {
  __typename?: 'createTaskPayload';
  taskReturnData?: Maybe<TaskReturnType>;
}

/** Autogenerated return type of createTemplateByImport. */
export interface CreateTemplateByImportPayload {
  __typename?: 'createTemplateByImportPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** create template input */
export interface CreateTemplateInput {
  /**
   * The base64 encoded version of the logo image with
   *                                                     metadata prefix e.g. "data:image/png;base64,<base64...>"
   */
  base64VideoPlaceholderImage?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  experienceOverview?: InputMaybe<Scalars['DraftJsTextType']>;
  files?: InputMaybe<Array<InputMaybe<FileInput>>>;
  hardDependency?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  organizationId: Scalars['ID'];
  published?: InputMaybe<Scalars['Boolean']>;
  sku?: InputMaybe<Scalars['String']>;
  videoUrl?: InputMaybe<Scalars['String']>;
}

/** create template milestone input */
export interface CreateTemplateMilestoneInput {
  completionMessage?: InputMaybe<Scalars['DraftJsTextType']>;
  description?: InputMaybe<Scalars['String']>;
  enableCompletionNotification?: InputMaybe<Scalars['Boolean']>;
  enableSendSurvey?: InputMaybe<Scalars['Boolean']>;
  files?: InputMaybe<Array<InputMaybe<FileInput>>>;
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  sortOrder: Scalars['Float'];
  templateId?: InputMaybe<Scalars['ID']>;
  templateType: TemplateEnumType;
}

/** Autogenerated return type of createTemplateMilestone. */
export interface CreateTemplateMilestonePayload {
  __typename?: 'createTemplateMilestonePayload';
  milestone?: Maybe<MilestoneType>;
}

/** Autogenerated return type of createTemplate. */
export interface CreateTemplatePayload {
  __typename?: 'createTemplatePayload';
  template?: Maybe<TemplateType>;
}

/** Create a new time record */
export interface CreateTimeRecordInput {
  billable?: InputMaybe<Scalars['Boolean']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  dateWorked?: InputMaybe<Scalars['DateType']>;
  description?: InputMaybe<Scalars['String']>;
  hours?: InputMaybe<Scalars['Float']>;
  projectId: Scalars['ID'];
  taskId?: InputMaybe<Scalars['ID']>;
  workerId: Scalars['ID'];
}

/** Autogenerated return type of createTimeRecord. */
export interface CreateTimeRecordPayload {
  __typename?: 'createTimeRecordPayload';
  timeRecord?: Maybe<TimeRecordType>;
}

/** Creates a filter view for a user */
export interface CreateUserFilterViewInput {
  category: Scalars['String'];
  jsonFilterBlob: Scalars['String'];
  name: Scalars['String'];
}

/** Autogenerated return type of createUserFilterView. */
export interface CreateUserFilterViewPayload {
  __typename?: 'createUserFilterViewPayload';
  userFilterView?: Maybe<UserFilterViewType>;
}

/** Autogenerated return type of createUserFilterViewV2. */
export interface CreateUserFilterViewV2Payload {
  __typename?: 'createUserFilterViewV2Payload';
  userFilterViews?: Maybe<Array<UserFilterViewType>>;
}

/** create webhook input */
export interface CreateWebhookInput {
  organizationId: Scalars['ID'];
  secret?: InputMaybe<Scalars['String']>;
  url: Scalars['String'];
}

/** Autogenerated return type of createWebhook. */
export interface CreateWebhookPayload {
  __typename?: 'createWebhookPayload';
  organization?: Maybe<OrganizationType>;
}

/** customer input type */
export interface CustomerInputType {
  /** The base64 encoded version of the logo image with metadata prefix e.g. "data:image/png;base64,<base64...>" */
  base64Logo?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  domain?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  primaryContactName?: InputMaybe<Scalars['String']>;
}

/** deactivate organization input */
export interface DeactivateOrganizationInput {
  id: Scalars['ID'];
}

/** Autogenerated return type of deactivateOrganization. */
export interface DeactivateOrganizationPayload {
  __typename?: 'deactivateOrganizationPayload';
  organization?: Maybe<OrganizationType>;
}

/** Autogenerated return type of deactivateUserWithReassignment. */
export interface DeactivateUserWithReassignmentPayload {
  __typename?: 'deactivateUserWithReassignmentPayload';
  results?: Maybe<DeactivateUserResults>;
}

/** Delete an Action Item */
export interface DeleteActionItemInput {
  actionItemId: Scalars['ID'];
}

/** Autogenerated return type of deleteActionItem. */
export interface DeleteActionItemPayload {
  __typename?: 'deleteActionItemPayload';
  actionItemId: Scalars['ID'];
}

/** Deletes an available tag */
export interface DeleteAvailableTagInput {
  tagId: Scalars['ID'];
}

/** Autogenerated return type of deleteAvailableTag. */
export interface DeleteAvailableTagPayload {
  __typename?: 'deleteAvailableTagPayload';
  tag?: Maybe<TagType>;
}

/** Delete a billing profile */
export interface DeleteBillingProfileInput {
  id: Scalars['ID'];
}

/** Autogenerated return type of deleteBillingProfile. */
export interface DeleteBillingProfilePayload {
  __typename?: 'deleteBillingProfilePayload';
  success: Scalars['Boolean'];
}

/** Deletes a brand */
export interface DeleteBrandInput {
  id: Scalars['ID'];
}

/** Autogenerated return type of deleteBrand. */
export interface DeleteBrandPayload {
  __typename?: 'deleteBrandPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** delete file s3 input */
export interface DeleteFileS3Input {
  key: Scalars['String'];
}

/** delete identity provider input */
export interface DeleteIdentityProviderInput {
  id: Scalars['ID'];
}

/** Autogenerated return type of deleteIdentityProvider. */
export interface DeleteIdentityProviderPayload {
  __typename?: 'deleteIdentityProviderPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** Deletes an Installation */
export interface DeleteInstallationInput {
  deviceToken: Scalars['ID'];
}

/** Autogenerated return type of deleteInstallation. */
export interface DeleteInstallationPayload {
  __typename?: 'deleteInstallationPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** Deletes jira integration settings */
export interface DeleteJiraSettingsInput {
  id: Scalars['ID'];
  settings: Array<InputMaybe<Scalars['String']>>;
}

/** Autogenerated return type of deleteJiraSettings. */
export interface DeleteJiraSettingsPayload {
  __typename?: 'deleteJiraSettingsPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** Autogenerated return type of deleteMergeTag. */
export interface DeleteMergeTagPayload {
  __typename?: 'deleteMergeTagPayload';
  success: Scalars['Boolean'];
}

/** delete template milestone input */
export interface DeleteMilestoneInput {
  id: Scalars['ID'];
}

/** Autogenerated return type of deleteMilestone. */
export interface DeleteMilestonePayload {
  __typename?: 'deleteMilestonePayload';
  deleteMilestoneReturnData?: Maybe<DeleteMilestoneReturnType>;
}

/** Deletes a pending project */
export interface DeletePendingProjectInput {
  id: Scalars['ID'];
}

/** Autogenerated return type of deletePendingProject. */
export interface DeletePendingProjectPayload {
  __typename?: 'deletePendingProjectPayload';
  deletedPendingProjectId?: Maybe<Scalars['String']>;
}

/** Deletes a project */
export interface DeleteProjectInput {
  hardDelete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  restorePendingProject?: InputMaybe<Scalars['Boolean']>;
}

/** Delete a project time tracking category */
export interface DeleteProjectLevelTimeTrackingCategoryInput {
  projectId: Scalars['ID'];
  timeTrackingCategoryId: Scalars['ID'];
}

/** Autogenerated return type of deleteProjectLevelTimeTrackingCategory. */
export interface DeleteProjectLevelTimeTrackingCategoryPayload {
  __typename?: 'deleteProjectLevelTimeTrackingCategoryPayload';
  success: Scalars['Boolean'];
}

/** Autogenerated return type of deleteProject. */
export interface DeleteProjectPayload {
  __typename?: 'deleteProjectPayload';
  deletedProjectId?: Maybe<Scalars['String']>;
}

/** Autogenerated return type of deleteProjectTaskGroup. */
export interface DeleteProjectTaskGroupPayload {
  __typename?: 'deleteProjectTaskGroupPayload';
  deleteTaskGroupReturnData?: Maybe<DeleteTaskGroupReturnType>;
}

/** delete report input */
export interface DeleteReportInput {
  publicId: Scalars['String'];
}

/** Autogenerated return type of deleteReport. */
export interface DeleteReportPayload {
  __typename?: 'deleteReportPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** Autogenerated return type of deleteSkillCategory. */
export interface DeleteSkillCategoryPayload {
  __typename?: 'deleteSkillCategoryPayload';
  success: Scalars['Boolean'];
}

/** Autogenerated return type of deleteSkill. */
export interface DeleteSkillPayload {
  __typename?: 'deleteSkillPayload';
  success: Scalars['Boolean'];
}

/** delete subtask group input */
export interface DeleteSubtaskGroupInput {
  id: Scalars['ID'];
}

/** Autogenerated return type of deleteSubtaskGroup. */
export interface DeleteSubtaskGroupPayload {
  __typename?: 'deleteSubtaskGroupPayload';
  task?: Maybe<TaskType>;
}

/** delete subtask input */
export interface DeleteSubtaskInput {
  id: Scalars['ID'];
}

/** Autogenerated return type of deleteSubtask. */
export interface DeleteSubtaskPayload {
  __typename?: 'deleteSubtaskPayload';
  task?: Maybe<TaskType>;
}

/** delete task group input */
export interface DeleteTaskGroupInput {
  id: Scalars['ID'];
}

/** Autogenerated return type of deleteTaskGroup. */
export interface DeleteTaskGroupPayload {
  __typename?: 'deleteTaskGroupPayload';
  deleteTaskGroupReturnData?: Maybe<DeleteTaskGroupReturnType>;
}

/** delete task input */
export interface DeleteTaskInput {
  id: Scalars['ID'];
}

/** Autogenerated return type of deleteTask. */
export interface DeleteTaskPayload {
  __typename?: 'deleteTaskPayload';
  taskReturnData?: Maybe<TaskReturnType>;
}

/** destroy template input */
export interface DeleteTemplateInput {
  id: Scalars['ID'];
  templateType: TemplateEnumType;
}

/** Autogenerated return type of deleteTemplate. */
export interface DeleteTemplatePayload {
  __typename?: 'deleteTemplatePayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** Delete a Time Record */
export interface DeleteTimeRecordInput {
  id: Scalars['ID'];
}

/** Autogenerated return type of deleteTimeRecord. */
export interface DeleteTimeRecordPayload {
  __typename?: 'deleteTimeRecordPayload';
  success: Scalars['Boolean'];
}

/** Autogenerated return type of deleteTimeTrackingCategory. */
export interface DeleteTimeTrackingCategoryPayload {
  __typename?: 'deleteTimeTrackingCategoryPayload';
  success: Scalars['Boolean'];
}

/** Deletes a filter view from a user */
export interface DeleteUserFilterViewInput {
  id: Scalars['ID'];
}

/** Autogenerated return type of deleteUserFilterView. */
export interface DeleteUserFilterViewPayload {
  __typename?: 'deleteUserFilterViewPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** Autogenerated return type of deleteUserFilterViewV2. */
export interface DeleteUserFilterViewV2Payload {
  __typename?: 'deleteUserFilterViewV2Payload';
  userFilterViews?: Maybe<Array<UserFilterViewType>>;
}

/** delete webhook input */
export interface DeleteWebhookInput {
  id: Scalars['ID'];
}

/** Autogenerated return type of deleteWebhook. */
export interface DeleteWebhookPayload {
  __typename?: 'deleteWebhookPayload';
  organization?: Maybe<OrganizationType>;
}

/** disconnect hub spot input */
export interface DisconnectHubspotInput {
  organizationId: Scalars['ID'];
}

/** Autogenerated return type of disconnectHubspot. */
export interface DisconnectHubspotPayload {
  __typename?: 'disconnectHubspotPayload';
  organization?: Maybe<OrganizationType>;
}

/** disconnect jira input */
export interface DisconnectJiraInput {
  organizationId: Scalars['ID'];
}

/** Autogenerated return type of disconnectJira. */
export interface DisconnectJiraPayload {
  __typename?: 'disconnectJiraPayload';
  organization?: Maybe<OrganizationType>;
}

/** disconnect salesforce input */
export interface DisconnectSalesforceInput {
  organizationId: Scalars['ID'];
}

/** Autogenerated return type of disconnectSalesforce. */
export interface DisconnectSalesforcePayload {
  __typename?: 'disconnectSalesforcePayload';
  organization?: Maybe<OrganizationType>;
}

/** disconnect slack channel input */
export interface DisconnectSlackChannelInput {
  slackIntegrationId: Scalars['ID'];
}

/** Autogenerated return type of disconnectSlackChannel. */
export interface DisconnectSlackChannelPayload {
  __typename?: 'disconnectSlackChannelPayload';
  organization?: Maybe<OrganizationType>;
}

/** disconnect slack input */
export interface DisconnectSlackInput {
  organizationId: Scalars['ID'];
}

/** Autogenerated return type of disconnectSlack. */
export interface DisconnectSlackPayload {
  __typename?: 'disconnectSlackPayload';
  organization?: Maybe<OrganizationType>;
}

/** domain verification instructions input */
export interface DomainVerificationInstructionsInput {
  domainId?: InputMaybe<Scalars['ID']>;
  email: Scalars['String'];
  organizationId: Scalars['ID'];
}

/** Autogenerated return type of domainVerificationInstructions. */
export interface DomainVerificationInstructionsPayload {
  __typename?: 'domainVerificationInstructionsPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** Input expected to download archived activities for a project */
export interface DownloadArchivedActivitiesInput {
  projectId: Scalars['ID'];
}

/** Autogenerated return type of downloadArchivedActivities. */
export interface DownloadArchivedActivitiesPayload {
  __typename?: 'downloadArchivedActivitiesPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** Duplicate a billing profile */
export interface DuplicateBillingProfileInput {
  id: Scalars['String'];
}

/** Autogenerated return type of duplicateBillingProfile. */
export interface DuplicateBillingProfilePayload {
  __typename?: 'duplicateBillingProfilePayload';
  billingProfile?: Maybe<BillingProfileType>;
}

/** duplicate template milestone input */
export interface DuplicateMilestoneInput {
  id: Scalars['ID'];
  publicId?: InputMaybe<Scalars['ID']>;
  sortOrder: Scalars['Float'];
  /** A hash mapping original task IDs to new cloned public IDs */
  taskIds?: InputMaybe<Scalars['JSON']>;
}

/** Autogenerated return type of duplicateMilestone. */
export interface DuplicateMilestonePayload {
  __typename?: 'duplicateMilestonePayload';
  milestone?: Maybe<MilestoneType>;
}

/** Autogenerated return type of duplicateProjectTaskGroup. */
export interface DuplicateProjectTaskGroupPayload {
  __typename?: 'duplicateProjectTaskGroupPayload';
  taskGroup?: Maybe<TaskGroupType>;
}

/** duplicate task group input */
export interface DuplicateTaskGroupInput {
  id: Scalars['ID'];
  sortOrder: Scalars['Float'];
}

/** Autogenerated return type of duplicateTaskGroup. */
export interface DuplicateTaskGroupPayload {
  __typename?: 'duplicateTaskGroupPayload';
  taskGroup?: Maybe<TaskGroupType>;
}

/** duplicate task input */
export interface DuplicateTaskInput {
  id: Scalars['ID'];
  publicId?: InputMaybe<Scalars['ID']>;
}

/** Autogenerated return type of duplicateTask. */
export interface DuplicateTaskPayload {
  __typename?: 'duplicateTaskPayload';
  taskReturnData?: Maybe<TaskReturnType>;
}

/** duplicate template input */
export interface DuplicateTemplateInput {
  duplicateName: Scalars['String'];
  id: Scalars['ID'];
  templateType: TemplateEnumType;
}

/** Autogenerated return type of duplicateTemplate. */
export interface DuplicateTemplatePayload {
  __typename?: 'duplicateTemplatePayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** Autogenerated return type of enableIntegration. */
export interface EnableIntegrationPayload {
  __typename?: 'enableIntegrationPayload';
  success: Scalars['Boolean'];
}

/** export global tasks list input */
export interface ExportGlobalTasksListInput {
  taskFilters?: InputMaybe<TaskFilters>;
}

/** Autogenerated return type of exportGlobalTasksList. */
export interface ExportGlobalTasksListPayload {
  __typename?: 'exportGlobalTasksListPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** Creates and sends a CSV file containing a summary of filtered projects */
export interface ExportProjectListInput {
  projectFilters?: InputMaybe<ProjectFilters>;
}

/** Autogenerated return type of exportProjectList. */
export interface ExportProjectListPayload {
  __typename?: 'exportProjectListPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** impersonate user input */
export interface ImpersonateUserInput {
  id: Scalars['ID'];
}

/** Autogenerated return type of impersonateUser. */
export interface ImpersonateUserPayload {
  __typename?: 'impersonateUserPayload';
  /** impersonation token */
  accessToken: Scalars['String'];
  /** impersonation refresh token */
  refreshToken: Scalars['String'];
  user: UserType;
}

/** invite user to organization input */
export interface InviteUserToOrganizationInput {
  email: Scalars['String'];
  firstName: Scalars['String'];
  isPrimaryContact?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['ID'];
  role: UserRoleEnumType;
  skipInvitationEmail?: InputMaybe<Scalars['Boolean']>;
}

/** Autogenerated return type of inviteUserToOrganization. */
export interface InviteUserToOrganizationPayload {
  __typename?: 'inviteUserToOrganizationPayload';
  user: UserType;
}

export interface JiraPropertiesInput {
  createNewJiraResource?: InputMaybe<Scalars['Boolean']>;
  jiraEpicKey?: InputMaybe<Scalars['String']>;
  jiraEpicLink?: InputMaybe<Scalars['String']>;
  jiraMilestoneId?: InputMaybe<Scalars['ID']>;
  jiraProjectKey?: InputMaybe<Scalars['String']>;
  jiraProjectLink?: InputMaybe<Scalars['String']>;
}

/** manage watchers per role input */
export interface ManageWatchersPerRoleInput {
  addUserIds: Array<Scalars['ID']>;
  projectId: Scalars['ID'];
  removeUserIds: Array<Scalars['ID']>;
  /**
   * [DEPRECATED] This input is not used anymore and should be replaced with `skill_ids` argument.
   * This field is ignored and will be removed in a future release.
   *
   */
  skillId?: InputMaybe<Scalars['ID']>;
  skillIds: Array<Scalars['ID']>;
}

/** Autogenerated return type of manageWatchersPerRole. */
export interface ManageWatchersPerRolePayload {
  __typename?: 'manageWatchersPerRolePayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** Autogenerated return type of markAllErrorsRead. */
export interface MarkAllErrorsReadPayload {
  __typename?: 'markAllErrorsReadPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** Autogenerated return type of mergeCustomer. */
export interface MergeCustomerPayload {
  __typename?: 'mergeCustomerPayload';
  errors?: Maybe<Array<Scalars['String']>>;
  success: Scalars['Boolean'];
}

/** Input to define what data you want for the completed project duration trend report. */
export interface MonthlyCompletedProjectDurationDataInput {
  monthsRange: Scalars['Int'];
  projectManagerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  templateIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
}

/** Autogenerated return type of moveMilestone. */
export interface MoveMilestonePayload {
  __typename?: 'moveMilestonePayload';
  /** The milestone that was moved */
  milestone: MilestoneType;
  /** Whether the milestone was successfully moved */
  success: Scalars['Boolean'];
  taskDependencyViolationSummary: DependencyCheckResponseType;
}

/** move task group input */
export interface MoveTaskGroupInput {
  id: Scalars['ID'];
  milestoneId: Scalars['ID'];
  sortOrder: Scalars['Float'];
}

/** Move templates to organization input */
export interface MoveTemplatesToOrganizationInput {
  destinationOrganizationId: Array<Scalars['ID']>;
  templateIds: Array<Scalars['ID']>;
}

/** Autogenerated return type of moveTemplatesToOrganization. */
export interface MoveTemplatesToOrganizationPayload {
  __typename?: 'moveTemplatesToOrganizationPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** Autogenerated return type of moveToAnotherMilestone. */
export interface MoveToAnotherMilestonePayload {
  __typename?: 'moveToAnotherMilestonePayload';
  taskGroup?: Maybe<TaskGroupType>;
}

/** Autogenerated return type of moveToAnotherProjectMilestone. */
export interface MoveToAnotherProjectMilestonePayload {
  __typename?: 'moveToAnotherProjectMilestonePayload';
  taskGroup?: Maybe<TaskGroupType>;
}

/** Create or update organization setting input */
export interface OrganizationSettingInput {
  brandedEmailSenderEnabled?: InputMaybe<Scalars['Boolean']>;
  useStatusChangeReasons?: InputMaybe<Scalars['Boolean']>;
}

/** Input used to fetch a list of projects */
export interface ProjectListInput {
  filterId?: InputMaybe<Scalars['ID']>;
  listInputs?: InputMaybe<ListInput>;
  projectFilters?: InputMaybe<ProjectFiltersInput>;
  userId?: InputMaybe<Scalars['ID']>;
}

/** Autogenerated return type of readNotificationError. */
export interface ReadNotificationErrorPayload {
  __typename?: 'readNotificationErrorPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** Autogenerated return type of readNotification. */
export interface ReadNotificationPayload {
  __typename?: 'readNotificationPayload';
  notification: Notification;
}

/** Autogenerated return type of readNotifications. */
export interface ReadNotificationsPayload {
  __typename?: 'readNotificationsPayload';
  updatedNotifications?: Maybe<Array<Maybe<Notification>>>;
}

/** Info needed to reassign tasks and/or projects to another user. */
export interface ReassignmentInput {
  deactivateUserId: Scalars['ID'];
  projectReassignUserId?: InputMaybe<Scalars['ID']>;
  taskReassigns?: InputMaybe<Array<InputMaybe<TaskReassignType>>>;
}

/** Destroy an organization custom field */
export interface RemoveCustomFieldInput {
  customFieldId: Scalars['ID'];
}

/** Autogenerated return type of removeCustomField. */
export interface RemoveCustomFieldPayload {
  __typename?: 'removeCustomFieldPayload';
  success?: Maybe<Scalars['Boolean']>;
}

export interface RemoveCustomerFromRoleInput {
  customerId: Scalars['ID'];
  roleId: Scalars['ID'];
}

/** Autogenerated return type of removeCustomerFromRole. */
export interface RemoveCustomerFromRolePayload {
  __typename?: 'removeCustomerFromRolePayload';
  success: Scalars['Boolean'];
}

/** remove org connection input */
export interface RemoveOrgConnectionInput {
  partnerId: Scalars['ID'];
}

/** Autogenerated return type of removeOrgConnection. */
export interface RemoveOrgConnectionPayload {
  __typename?: 'removeOrgConnectionPayload';
  organization?: Maybe<OrganizationType>;
}

/** remove status change reason group input */
export interface RemoveStatusChangeReasonGroupInput {
  id: Scalars['ID'];
}

/** Autogenerated return type of removeStatusChangeReasonGroup. */
export interface RemoveStatusChangeReasonGroupPayload {
  __typename?: 'removeStatusChangeReasonGroupPayload';
  success: Scalars['Boolean'];
}

/** remove status change reason  input */
export interface RemoveStatusChangeReasonInput {
  id: Scalars['ID'];
}

/** Autogenerated return type of removeStatusChangeReason. */
export interface RemoveStatusChangeReasonPayload {
  __typename?: 'removeStatusChangeReasonPayload';
  success: Scalars['Boolean'];
}

/** Removes a tag from a Project, Task or ActionItem */
export interface RemoveTagInput {
  tagId: Scalars['ID'];
  taggableId: Scalars['ID'];
  taggableType: TaggableEnumType;
}

/** Autogenerated return type of removeTag. */
export interface RemoveTagPayload {
  __typename?: 'removeTagPayload';
  taggable?: Maybe<TaggableType>;
}

/** Autogenerated return type of removeTaskFromProjectTaskGroup. */
export interface RemoveTaskFromProjectTaskGroupPayload {
  __typename?: 'removeTaskFromProjectTaskGroupPayload';
  milestone?: Maybe<MilestoneType>;
}

/** remove task from task group */
export interface RemoveTaskFromTaskGroupInput {
  sortOrder?: InputMaybe<Scalars['Float']>;
  taskId: Scalars['ID'];
}

/** Autogenerated return type of removeTaskFromTaskGroup. */
export interface RemoveTaskFromTaskGroupPayload {
  __typename?: 'removeTaskFromTaskGroupPayload';
  milestone?: Maybe<MilestoneType>;
}

/** Removes a template from a project */
export interface RemoveTemplateFromProjectInput {
  id: Scalars['ID'];
  templateId: Scalars['ID'];
}

/** Autogenerated return type of removeTemplateFromProject. */
export interface RemoveTemplateFromProjectPayload {
  __typename?: 'removeTemplateFromProjectPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** Removes user assigned from project */
export interface RemoveUserAssignedFromProjectInput {
  projectId: Scalars['ID'];
  userId: Scalars['ID'];
}

/** Autogenerated return type of removeUserAssignedFromProject. */
export interface RemoveUserAssignedFromProjectPayload {
  __typename?: 'removeUserAssignedFromProjectPayload';
  projectRoles?: Maybe<Array<Skill>>;
  teamMember?: Maybe<UserType>;
}

/** Removes user from project */
export interface RemoveUserByRoleFromProjectInput {
  projectId: Scalars['ID'];
  skillId: Scalars['ID'];
  skillIds?: InputMaybe<Array<Scalars['ID']>>;
  userId?: InputMaybe<Scalars['ID']>;
}

/** Autogenerated return type of removeUserByRoleFromProject. */
export interface RemoveUserByRoleFromProjectPayload {
  __typename?: 'removeUserByRoleFromProjectPayload';
  projectRoles?: Maybe<Array<Skill>>;
  teamMember?: Maybe<UserType>;
}

/** remove user connection input */
export interface RemoveUserConnectionInput {
  userId: Scalars['ID'];
}

/** Autogenerated return type of removeUserConnection. */
export interface RemoveUserConnectionPayload {
  __typename?: 'removeUserConnectionPayload';
  organizationConnectedUsers?: Maybe<Array<Maybe<UserType>>>;
}

/** Removes user from project */
export interface RemoveUserFromProjectInput {
  id: Scalars['ID'];
  projectId: Scalars['ID'];
}

/** Autogenerated return type of removeUserFromProject. */
export interface RemoveUserFromProjectPayload {
  __typename?: 'removeUserFromProjectPayload';
  projectTeam?: Maybe<Array<Maybe<UserType>>>;
}

/** remove watcher input */
export interface RemoveWatcherInput {
  taskId: Scalars['ID'];
  watcherId: Scalars['ID'];
}

/** Autogenerated return type of removeWatcher. */
export interface RemoveWatcherPayload {
  __typename?: 'removeWatcherPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** Autogenerated return type of reorderInfoField. */
export interface ReorderInfoFieldPayload {
  __typename?: 'reorderInfoFieldPayload';
  infoField: MergeTag;
}

/** resend invite to user input */
export interface ResendInviteToUserInput {
  email: Scalars['String'];
  projectId?: InputMaybe<Scalars['ID']>;
}

/** Autogenerated return type of resendInviteToUser. */
export interface ResendInviteToUserPayload {
  __typename?: 'resendInviteToUserPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** Restores a previously deleted project */
export interface RestoreProjectInput {
  id: Scalars['ID'];
}

/** Autogenerated return type of restoreProject. */
export interface RestoreProjectPayload {
  __typename?: 'restoreProjectPayload';
  project?: Maybe<ProjectType>;
}

/** Update the value of a project custom field */
export interface SaveProjectCustomFieldsValuesInput {
  customFields: Array<ProjectCustomFieldInputType>;
  projectId: Scalars['ID'];
}

/** Autogenerated return type of saveProjectCustomFieldsValues. */
export interface SaveProjectCustomFieldsValuesPayload {
  __typename?: 'saveProjectCustomFieldsValuesPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** Autogenerated return type of saveUserAsAgent. */
export interface SaveUserAsAgentPayload {
  __typename?: 'saveUserAsAgentPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** send assigment email input */
export interface SendAssignmentEmailInput {
  id: Scalars['ID'];
}

/** Autogenerated return type of sendAssignmentEmail. */
export interface SendAssignmentEmailPayload {
  __typename?: 'sendAssignmentEmailPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** send event invite input */
export interface SendEventInviteInput {
  resendInvitation?: InputMaybe<Scalars['Boolean']>;
  taskId: Scalars['ID'];
}

/** Autogenerated return type of sendEventInvite. */
export interface SendEventInvitePayload {
  __typename?: 'sendEventInvitePayload';
  task?: Maybe<TaskType>;
}

/** Sends an email with a compressed file containing all project attachments */
export interface SendProjectAttachmentsInput {
  projectId: Scalars['ID'];
}

/** Autogenerated return type of sendProjectAttachments. */
export interface SendProjectAttachmentsPayload {
  __typename?: 'sendProjectAttachmentsPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** Autogenerated return type of sendProjectOverview. */
export interface SendProjectOverviewPayload {
  __typename?: 'sendProjectOverviewPayload';
  success: Scalars['Boolean'];
}

/** send setup email input */
export interface SendSetupEmailInput {
  email: Scalars['String'];
}

/** Autogenerated return type of sendSetupEmail. */
export interface SendSetupEmailPayload {
  __typename?: 'sendSetupEmailPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** send sign off input */
export interface SendSignOffInput {
  message?: InputMaybe<Scalars['String']>;
  taskId: Scalars['ID'];
}

/** Autogenerated return type of sendSignOff. */
export interface SendSignOffPayload {
  __typename?: 'sendSignOffPayload';
  sendSignOffReturnData?: Maybe<TaskReturnType>;
}

/** Sends a preview of the welcome email */
export interface SendWelcomeEmailPreviewInput {
  projectId: Scalars['ID'];
}

/** Autogenerated return type of sendWelcomeEmailPreview. */
export interface SendWelcomeEmailPreviewPayload {
  __typename?: 'sendWelcomeEmailPreviewPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** set deactivated on user input */
export interface SetDeactivatedOnUserInput {
  deactivated: Scalars['Boolean'];
  id: Scalars['ID'];
}

/** Autogenerated return type of setDeactivatedOnUser. */
export interface SetDeactivatedOnUserPayload {
  __typename?: 'setDeactivatedOnUserPayload';
  user?: Maybe<UserType>;
}

/** Enum for the possible actions */
export enum SignOffActionEnumType {
  /** approve */
  Approve = 'APPROVE',
  /** reject */
  Reject = 'REJECT'
}

/** Autogenerated return type of sortProjectTaskTaskGroup. */
export interface SortProjectTaskTaskGroupPayload {
  __typename?: 'sortProjectTaskTaskGroupPayload';
  sortedElement?: Maybe<TaskAndGroupType>;
}

/** Autogenerated return type of sortTaskTaskGroup. */
export interface SortTaskTaskGroupPayload {
  __typename?: 'sortTaskTaskGroupPayload';
  sortedElement?: Maybe<TaskAndGroupType>;
}

/** Autogenerated return type of startConnectionFlows. */
export interface StartConnectionFlowsPayload {
  __typename?: 'startConnectionFlowsPayload';
  success: Scalars['Boolean'];
}

/** Autogenerated return type of stopImpersonatingUser. */
export interface StopImpersonatingUserPayload {
  __typename?: 'stopImpersonatingUserPayload';
  /** access token for subsequent requests */
  accessToken: Scalars['String'];
  /** refresh token for refreshing access token */
  refreshToken: Scalars['String'];
  user: UserType;
}

/** Send an email with the user request access to the project */
export interface SubmitRequestAccessInput {
  projectId: Scalars['ID'];
  userEmail?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
}

/** Autogenerated return type of submitRequestAccess. */
export interface SubmitRequestAccessPayload {
  __typename?: 'submitRequestAccessPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** Export all the items in the time reporting */
export interface TimeReportExportInput {
  endDate?: InputMaybe<Scalars['DateType']>;
  filters?: InputMaybe<TimeReportFiltersInput>;
  includeGeneric?: InputMaybe<Scalars['Boolean']>;
  isSummarySelected?: InputMaybe<Scalars['Boolean']>;
  keyword?: InputMaybe<Scalars['String']>;
  reportScope?: InputMaybe<ReportScopeEnumType>;
  reportStyle?: InputMaybe<TimeReportExportStyleEnumType>;
  startDate?: InputMaybe<Scalars['DateType']>;
}

/** Autogenerated return type of timeReportExport. */
export interface TimeReportExportPayload {
  __typename?: 'timeReportExportPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** toggle group task completed input */
export interface ToggleGroupTaskCompletedInput {
  completed: Scalars['Boolean'];
  taskId: Scalars['ID'];
  userId: Scalars['ID'];
}

/** Autogenerated return type of toggleGroupTaskCompleted. */
export interface ToggleGroupTaskCompletedPayload {
  __typename?: 'toggleGroupTaskCompletedPayload';
  task?: Maybe<PublicTask>;
}

/** toggle identity provider input */
export interface ToggleIdentityProviderInput {
  id: Scalars['ID'];
}

/** Autogenerated return type of toggleIdentityProvider. */
export interface ToggleIdentityProviderPayload {
  __typename?: 'toggleIdentityProviderPayload';
  active?: Maybe<Scalars['Boolean']>;
}

/** toggle subtask done input */
export interface ToggleSubtaskDoneInput {
  id: Scalars['ID'];
}

/** Autogenerated return type of toggleSubtaskDone. */
export interface ToggleSubtaskDonePayload {
  __typename?: 'toggleSubtaskDonePayload';
  subtask?: Maybe<SubtaskType>;
}

/** trigger webhook input */
export interface TriggerWebhookInput {
  projectId: Scalars['ID'];
  webhookId: Scalars['ID'];
}

/** Autogenerated return type of triggerWebhook. */
export interface TriggerWebhookPayload {
  __typename?: 'triggerWebhookPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** Autogenerated return type of ungroupProjectTaskGroup. */
export interface UngroupProjectTaskGroupPayload {
  __typename?: 'ungroupProjectTaskGroupPayload';
  milestone?: Maybe<MilestoneType>;
}

/** ungroup task group input */
export interface UngroupTaskGroupInput {
  taskGroupId: Scalars['ID'];
}

/** Autogenerated return type of ungroupTaskGroup. */
export interface UngroupTaskGroupPayload {
  __typename?: 'ungroupTaskGroupPayload';
  milestone?: Maybe<MilestoneType>;
}

/** Update an action item */
export interface UpdateActionItemInput {
  assigneeId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['DraftJsTextType']>;
  dueOn?: InputMaybe<Scalars['DateType']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<PriorityEnumType>;
  relatedTaskId?: InputMaybe<Scalars['ID']>;
  startOn?: InputMaybe<Scalars['DateType']>;
  visibility?: InputMaybe<TaskVisibilityEnumType>;
}

/** Autogenerated return type of updateActionItem. */
export interface UpdateActionItemPayload {
  __typename?: 'updateActionItemPayload';
  actionItem?: Maybe<ActionItemType>;
}

/** update admin team input */
export interface UpdateAdminTeamInput {
  adminTeamsEnabled?: InputMaybe<Scalars['Boolean']>;
  onlyNotificationsTeamsEnabled?: InputMaybe<Scalars['Boolean']>;
  projectManagers?: InputMaybe<Array<InputMaybe<AdminTeamType>>>;
}

/** Autogenerated return type of updateAdminTeam. */
export interface UpdateAdminTeamPayload {
  __typename?: 'updateAdminTeamPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** update attachment sort order input */
export interface UpdateAttachmentSortOrderInput {
  assetId: Scalars['ID'];
  sortOrder: Scalars['Float'];
}

/** Autogenerated return type of updateAttachmentSortOrder. */
export interface UpdateAttachmentSortOrderPayload {
  __typename?: 'updateAttachmentSortOrderPayload';
  task?: Maybe<TaskType>;
}

/** Updates an available tag for all Projects, Tasks or ActionItems of an organization */
export interface UpdateAvailableTagInput {
  color?: InputMaybe<Scalars['String']>;
  internalOnly?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  tagId: Scalars['ID'];
}

/** Autogenerated return type of updateAvailableTag. */
export interface UpdateAvailableTagPayload {
  __typename?: 'updateAvailableTagPayload';
  tag?: Maybe<TagType>;
}

/** create skill category input */
export interface UpdateBillableOverrideInput {
  projectId: Scalars['ID'];
  rate: Scalars['Float'];
  skillId: Scalars['ID'];
}

/** Autogenerated return type of updateBillableOverride. */
export interface UpdateBillableOverridePayload {
  __typename?: 'updateBillableOverridePayload';
  success: Scalars['Boolean'];
}

/** Update a billing profile */
export interface UpdateBillingProfileInput {
  allottedHours?: InputMaybe<Scalars['Float']>;
  allowOverages?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  dollars?: InputMaybe<Scalars['Float']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  rateType?: InputMaybe<RateTypeEnum>;
  secondaryDollars?: InputMaybe<Scalars['Float']>;
  secondaryRateType?: InputMaybe<RateTypeEnum>;
}

/** Autogenerated return type of updateBillingProfile. */
export interface UpdateBillingProfilePayload {
  __typename?: 'updateBillingProfilePayload';
  billingProfile?: Maybe<BillingProfileType>;
}

/** Creates a brand */
export interface UpdateBrandInput {
  /** The base64 encoded version of the logo image with metadata prefix e.g. "data:image/png;base64,<base64...>" */
  base64HeaderLogo?: InputMaybe<Scalars['String']>;
  /** The base64 encoded version of the logo image with metadata prefix e.g. "data:image/png;base64,<base64...>" */
  base64Logo?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  primaryColor?: InputMaybe<Scalars['String']>;
}

/** Autogenerated return type of updateBrand. */
export interface UpdateBrandPayload {
  __typename?: 'updateBrandPayload';
  brand?: Maybe<BrandType>;
}

/** Update resources capacities input */
export interface UpdateCapacitiesInput {
  usersCapacityHours?: InputMaybe<Array<CapacityHoursInput>>;
}

/** Autogenerated return type of updateCapacities. */
export interface UpdateCapacitiesPayload {
  __typename?: 'updateCapacitiesPayload';
  updatedUsers?: Maybe<Array<UserType>>;
}

/** Add or update a custom field to organization */
export interface UpdateCustomFieldInput {
  customFieldId?: InputMaybe<Scalars['ID']>;
  internalOnly: Scalars['Boolean'];
  mergeTag: Scalars['Boolean'];
  name: Scalars['String'];
  organizationId: Scalars['ID'];
  sortOrder?: InputMaybe<Scalars['Float']>;
}

/** Autogenerated return type of updateCustomField. */
export interface UpdateCustomFieldPayload {
  __typename?: 'updateCustomFieldPayload';
  customType?: Maybe<OrganizationCustomFieldType>;
}

/** Autogenerated return type of updateCustomer. */
export interface UpdateCustomerPayload {
  __typename?: 'updateCustomerPayload';
  customer?: Maybe<CustomerType>;
}

/** update domain auth records input */
export interface UpdateDomainAuthRecordsInput {
  domain?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['ID']>;
  organizationId: Scalars['ID'];
  record1?: InputMaybe<Scalars['String']>;
  record2?: InputMaybe<Scalars['String']>;
  record3?: InputMaybe<Scalars['String']>;
  sendgridWhitelabelId?: InputMaybe<Scalars['String']>;
  verifyDomain?: InputMaybe<Scalars['Boolean']>;
}

/** Autogenerated return type of updateDomainAuthRecords. */
export interface UpdateDomainAuthRecordsPayload {
  __typename?: 'updateDomainAuthRecordsPayload';
  domainVerification?: Maybe<DomainVerificationRecordsType>;
}

/** Autogenerated return type of updateEmailAnswerSurvey. */
export interface UpdateEmailAnswerSurveyPayload {
  __typename?: 'updateEmailAnswerSurveyPayload';
  success: Scalars['Boolean'];
}

/** Autogenerated return type of updateFile. */
export interface UpdateFilePayload {
  __typename?: 'updateFilePayload';
  file?: Maybe<FileType>;
}

/** Input to update an entity for a Gantt chart */
export interface UpdateGanttEntityInput {
  assigneeId?: InputMaybe<Scalars['ID']>;
  dueOn?: InputMaybe<Scalars['DateType']>;
  duration?: InputMaybe<Scalars['Int']>;
  estimatedHours?: InputMaybe<Scalars['Float']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<PriorityEnumType>;
  responsibility?: InputMaybe<TaskResponsibilityEnumType>;
  startOn?: InputMaybe<Scalars['DateType']>;
  status?: InputMaybe<StatusEnumType>;
  type: Scalars['String'];
  visibility?: InputMaybe<TaskVisibilityEnumType>;
}

/** Autogenerated return type of updateGanttEntity. */
export interface UpdateGanttEntityPayload {
  __typename?: 'updateGanttEntityPayload';
  ganttReturnData?: Maybe<EntityReturnType>;
}

/** update identity provider input */
export interface UpdateIdentityProviderInput {
  certificate: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  issuer: Scalars['String'];
  jitProvisioning?: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['ID'];
  strictMode?: InputMaybe<Scalars['Boolean']>;
  targetUrl: Scalars['String'];
}

/** Autogenerated return type of updateIdentityProvider. */
export interface UpdateIdentityProviderPayload {
  __typename?: 'updateIdentityProviderPayload';
  organization?: Maybe<OrganizationType>;
}

/** Deletes jira integration settings */
export interface UpdateJiraIntegrationInput {
  defaultIssueTypeId?: InputMaybe<Scalars['String']>;
  defaultProjectId?: InputMaybe<Scalars['String']>;
  epicFormat?: InputMaybe<JiraEpicFormatEnumType>;
  epicFormatValue?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  issueFormat?: InputMaybe<JiraIssueFormatEnumType>;
  priorities?: InputMaybe<Array<InputMaybe<JiraPriorityInputType>>>;
  statuses?: InputMaybe<Array<InputMaybe<JiraStatusInputType>>>;
}

/** Autogenerated return type of updateJiraIntegration. */
export interface UpdateJiraIntegrationPayload {
  __typename?: 'updateJiraIntegrationPayload';
  jiraIntegration?: Maybe<JiraIntegrationType>;
}

/** Note data for updates */
export interface UpdateNoteInput {
  id: Scalars['ID'];
  internalOnly?: InputMaybe<Scalars['Boolean']>;
  noteAttachments?: InputMaybe<Array<AssetCreateInput>>;
  raw: Scalars['DraftJsTextType'];
}

/** Autogenerated return type of updateObjectStatus. */
export interface UpdateObjectStatusPayload {
  __typename?: 'updateObjectStatusPayload';
  resolveObject?: Maybe<StatusObjectType>;
}

/** update organization input */
export interface UpdateOrganizationInput {
  adminSettings?: InputMaybe<OrganizationAdminSettingsInput>;
  archiveProjectsPermissions?: InputMaybe<ArchiveProjectsPermissionsEnumType>;
  /** The base64 encoded version of the logo image with metadata prefix e.g. data:image/png;base64,<base64...>" */
  base64HeaderLogo?: InputMaybe<Scalars['String']>;
  /** The base64 encoded version of the logo image with metadata prefix e.g. "data:image/png;base64,<base64...>" */
  base64Logo?: InputMaybe<Scalars['String']>;
  bccEmail?: InputMaybe<Scalars['String']>;
  billableRate?: InputMaybe<Scalars['Int']>;
  brandsEnabled?: InputMaybe<Scalars['Boolean']>;
  countryCode?: InputMaybe<CountryCodeEnumType>;
  currencyCode?: InputMaybe<CurrencyCodeEnumType>;
  customerDashboardEnabled?: InputMaybe<Scalars['Boolean']>;
  defaultCapacityHours?: InputMaybe<Scalars['Float']>;
  defaultTaskVisibility?: InputMaybe<TaskVisibilityEnumType>;
  domain?: InputMaybe<Scalars['String']>;
  hubspotEnabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  internalNotesDefault?: InputMaybe<Scalars['Boolean']>;
  isCsatSurveyEnabled?: InputMaybe<Scalars['Boolean']>;
  jiraEnabled?: InputMaybe<Scalars['Boolean']>;
  maxBillableUsers?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  openApiEnabled?: InputMaybe<Scalars['Boolean']>;
  pmCanEditSkills?: InputMaybe<Scalars['Boolean']>;
  primaryColor?: InputMaybe<Scalars['String']>;
  projectUpdatedSlackDaysPref?: InputMaybe<Scalars['Int']>;
  ratePerUser?: InputMaybe<Scalars['Float']>;
  resourceManagementEnabled?: InputMaybe<Scalars['Boolean']>;
  salesforceEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Allow customers access to projects via secure links */
  secureLinksEnabled?: InputMaybe<Scalars['Boolean']>;
  setting?: InputMaybe<OrganizationSettingInput>;
  showShareableLink?: InputMaybe<Scalars['Boolean']>;
  ssoEnabled?: InputMaybe<Scalars['Boolean']>;
  taskFilterByFunction?: InputMaybe<Scalars['Boolean']>;
  timeTrackingEnabled?: InputMaybe<Scalars['Boolean']>;
  timeZone?: InputMaybe<Scalars['String']>;
  trial?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<OrganizationTypeEnumType>;
  /** Allow project members to upload files to projects and their tasks */
  uploadsEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Allow email attachments to be uploaded to projects */
  uploadsViaEmailEnabled?: InputMaybe<Scalars['Boolean']>;
  vanitySubdomain?: InputMaybe<Scalars['String']>;
  whiteLabelingEnabled?: InputMaybe<Scalars['Boolean']>;
  workatoKey?: InputMaybe<Scalars['String']>;
}

/** Autogenerated return type of updateOrganization. */
export interface UpdateOrganizationPayload {
  __typename?: 'updateOrganizationPayload';
  organization?: Maybe<OrganizationType>;
}

/** Updates a project */
export interface UpdateProjectInput {
  additionalPurchasedHours?: InputMaybe<Scalars['Int']>;
  assignInternalTasksToPM?: InputMaybe<Scalars['Boolean']>;
  bccEmails?: InputMaybe<Scalars['String']>;
  bccEmailsEnabled?: InputMaybe<Scalars['Boolean']>;
  bccToProjectManager?: InputMaybe<Scalars['Boolean']>;
  brandId?: InputMaybe<Scalars['ID']>;
  cashValue?: InputMaybe<Scalars['Int']>;
  endOn?: InputMaybe<Scalars['DateType']>;
  externalId?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Array<InputMaybe<FileInput>>>;
  id: Scalars['ID'];
  languageName?: InputMaybe<Scalars['String']>;
  modifiedDollars?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  overviewEmailScheduled?: InputMaybe<Scalars['Boolean']>;
  pmNote?: InputMaybe<Scalars['DraftJsTextType']>;
  pmNoteInternalOnly?: InputMaybe<Scalars['Boolean']>;
  projectBillRate?: InputMaybe<ProjectBillRateInputType>;
  projectManagerId?: InputMaybe<Scalars['ID']>;
  /** Should a forecasted end date be calculated for this project? */
  showForecast?: InputMaybe<Scalars['Boolean']>;
  startOn?: InputMaybe<Scalars['DateType']>;
  status?: InputMaybe<StatusEnumType>;
  templatesInfo?: InputMaybe<Array<TemplateInfoInput>>;
  timeZone?: InputMaybe<Scalars['String']>;
  v2CustomerId?: InputMaybe<Scalars['ID']>;
}

/** Autogenerated return type of updateProject. */
export interface UpdateProjectPayload {
  __typename?: 'updateProjectPayload';
  project?: Maybe<ProjectType>;
}

/** updates the generic properties of a project */
export interface UpdateProjectPropertiesInput {
  jiraProperties?: InputMaybe<JiraPropertiesInput>;
  projectId: Scalars['ID'];
  properties?: InputMaybe<Array<PropertyInput>>;
}

/** Autogenerated return type of updateProjectProperties. */
export interface UpdateProjectPropertiesPayload {
  __typename?: 'updateProjectPropertiesPayload';
  project: ProjectType;
  properties: Array<Property>;
}

/** Input to update a Projects status change reason */
export interface UpdateProjectStatusChangeReasonInput {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  statusChangeReasonId?: InputMaybe<Scalars['ID']>;
}

/** Autogenerated return type of updateProjectStatusChangeReason. */
export interface UpdateProjectStatusChangeReasonPayload {
  __typename?: 'updateProjectStatusChangeReasonPayload';
  projectStatusChangeReason?: Maybe<ProjectStatusChangeReasonType>;
}

/** Autogenerated return type of updateProjectTaskGroup. */
export interface UpdateProjectTaskGroupPayload {
  __typename?: 'updateProjectTaskGroupPayload';
  taskGroup?: Maybe<TaskGroupType>;
}

/** Autogenerated return type of updateProjectTaskGroupTask. */
export interface UpdateProjectTaskGroupTaskPayload {
  __typename?: 'updateProjectTaskGroupTaskPayload';
  taskReturnData?: Maybe<TaskReturnType>;
}

/** Update resource input */
export interface UpdateResourceInput {
  assignSkillIds?: InputMaybe<Array<Scalars['ID']>>;
  id?: InputMaybe<Scalars['ID']>;
  unassignSkillIds?: InputMaybe<Array<Scalars['ID']>>;
}

/** Autogenerated return type of updateResource. */
export interface UpdateResourcePayload {
  __typename?: 'updateResourcePayload';
  resource: UserType;
}

/** update sign off input */
export interface UpdateSignOffInput {
  action?: InputMaybe<SignOffActionEnumType>;
  taskId: Scalars['ID'];
}

/** Autogenerated return type of updateSignOff. */
export interface UpdateSignOffPayload {
  __typename?: 'updateSignOffPayload';
  task?: Maybe<PublicTask>;
}

/** Update skill category input */
export interface UpdateSkillCategoryInput {
  id: Scalars['ID'];
  name: Scalars['String'];
}

/** Autogenerated return type of updateSkillCategory. */
export interface UpdateSkillCategoryPayload {
  __typename?: 'updateSkillCategoryPayload';
  skillCategory: SkillCategory;
}

/** Update the sort order of an organization custom field. */
export interface UpdateSortOrderCustomFieldInput {
  customFieldId: Scalars['ID'];
  sortOrder: Scalars['Float'];
}

/** Autogenerated return type of updateSortOrderCustomField. */
export interface UpdateSortOrderCustomFieldPayload {
  __typename?: 'updateSortOrderCustomFieldPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** update status change reason group input */
export interface UpdateStatusChangeReasonGroupInput {
  id: Scalars['ID'];
  name: Scalars['String'];
}

/** Autogenerated return type of updateStatusChangeReasonGroup. */
export interface UpdateStatusChangeReasonGroupPayload {
  __typename?: 'updateStatusChangeReasonGroupPayload';
  statusChangeReasonGroup?: Maybe<StatusChangeReasonGroupType>;
}

/** update status change reason  input */
export interface UpdateStatusChangeReasonInput {
  id: Scalars['ID'];
  name: Scalars['String'];
  statusChangeReasonGroupId: Scalars['ID'];
}

/** Updates status for a generic object */
export interface UpdateStatusInputV2 {
  id: Scalars['ID'];
  objectType: StatusObjectEnumType;
  status?: InputMaybe<StatusEnumType>;
  stuckMessage?: InputMaybe<Scalars['String']>;
}

/** update sub task name input */
export interface UpdateSubTaskNameInput {
  id: Scalars['ID'];
  name: Scalars['String'];
}

/** Autogenerated return type of updateSubTaskName. */
export interface UpdateSubTaskNamePayload {
  __typename?: 'updateSubTaskNamePayload';
  subtask?: Maybe<SubtaskType>;
}

/** update subtask group input */
export interface UpdateSubtaskGroupInput {
  id: Scalars['ID'];
  name: Scalars['String'];
}

/** Autogenerated return type of updateSubtaskGroup. */
export interface UpdateSubtaskGroupPayload {
  __typename?: 'updateSubtaskGroupPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** update subtask input */
export interface UpdateSubtaskInput {
  id: Scalars['ID'];
  sortOrder?: InputMaybe<Scalars['Float']>;
  subtasksGroupId?: InputMaybe<Scalars['ID']>;
}

/** Autogenerated return type of updateSubtask. */
export interface UpdateSubtaskPayload {
  __typename?: 'updateSubtaskPayload';
  task?: Maybe<TaskType>;
}

/** update task group input */
export interface UpdateTaskGroupInput {
  completionMessage?: InputMaybe<Scalars['DraftJsTextType']>;
  description?: InputMaybe<Scalars['String']>;
  enableCompletionNotification?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Float']>;
}

/** Autogenerated return type of updateTaskGroup. */
export interface UpdateTaskGroupPayload {
  __typename?: 'updateTaskGroupPayload';
  taskGroup?: Maybe<TaskGroupType>;
}

/** Autogenerated return type of updateTaskGroupTask. */
export interface UpdateTaskGroupTaskPayload {
  __typename?: 'updateTaskGroupTaskPayload';
  taskReturnData?: Maybe<TaskReturnType>;
}

/** update task input */
export interface UpdateTaskInput {
  actualHours?: InputMaybe<Scalars['Float']>;
  assigneeId?: InputMaybe<Scalars['ID']>;
  billableHours?: InputMaybe<Scalars['Float']>;
  completedAt?: InputMaybe<Scalars['DateType']>;
  dependencyId?: InputMaybe<Scalars['ID']>;
  dependencyType?: InputMaybe<DependencyEnumType>;
  description?: InputMaybe<Scalars['DraftJsTextType']>;
  destinationDroppableId?: InputMaybe<Scalars['ID']>;
  destinationIndex?: InputMaybe<Scalars['ID']>;
  dueOn?: InputMaybe<Scalars['DateType']>;
  duration?: InputMaybe<Scalars['Int']>;
  estimatedHours?: InputMaybe<Scalars['Float']>;
  estimatedPoints?: InputMaybe<Scalars['Int']>;
  eventDatetime?: InputMaybe<Scalars['DateTimeType']>;
  eventInformation?: InputMaybe<Scalars['DraftJsTextType']>;
  eventTz?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Array<InputMaybe<FileInput>>>;
  id: Scalars['ID'];
  jiraSync?: InputMaybe<Scalars['Boolean']>;
  jiraTask?: InputMaybe<JiraIssueInputType>;
  k2NullifyAssigneeId?: InputMaybe<Scalars['Boolean']>;
  k2NullifyDependencyId?: InputMaybe<Scalars['Boolean']>;
  k2NullifyDueOn?: InputMaybe<Scalars['Boolean']>;
  k2NullifyStartOn?: InputMaybe<Scalars['Boolean']>;
  meetingLength?: InputMaybe<Scalars['Int']>;
  milestoneId?: InputMaybe<Scalars['ID']>;
  mustStartOn?: InputMaybe<Scalars['DateType']>;
  mustStartOnRequired?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  nonBillableHours?: InputMaybe<Scalars['Float']>;
  note?: InputMaybe<Scalars['String']>;
  /** if included in conjunction with should_notify_attendees, only new attendees will be notified */
  onlyNotifyNewAttendees?: InputMaybe<Scalars['Boolean']>;
  participantCallToAction?: InputMaybe<Scalars['DraftJsTextType']>;
  participants?: InputMaybe<Array<InputMaybe<ParticipantInput>>>;
  participantsGroupType?: InputMaybe<ParticipantsGroupType>;
  priority?: InputMaybe<PriorityEnumType>;
  responsibility?: InputMaybe<TaskResponsibilityEnumType>;
  shouldNotifyAttendees?: InputMaybe<Scalars['Boolean']>;
  signOffRequired?: InputMaybe<Scalars['Boolean']>;
  signer?: InputMaybe<SignerInputType>;
  skillId?: InputMaybe<Scalars['ID']>;
  skillIds?: InputMaybe<Array<Scalars['ID']>>;
  sortOrder?: InputMaybe<Scalars['Float']>;
  startOn?: InputMaybe<Scalars['DateType']>;
  status?: InputMaybe<StatusEnumType>;
  taskGroup?: InputMaybe<Scalars['Boolean']>;
  taskGroupId?: InputMaybe<Scalars['ID']>;
  taskType?: InputMaybe<TaskTypeEnumType>;
  timeZone?: InputMaybe<Scalars['String']>;
  visibility?: InputMaybe<TaskVisibilityEnumType>;
}

/** Autogenerated return type of updateTask. */
export interface UpdateTaskPayload {
  __typename?: 'updateTaskPayload';
  taskReturnData?: Maybe<TaskReturnType>;
}

/** update template input */
export interface UpdateTemplateInput {
  /**
   * The base64 encoded version of the logo image with
   *                                                     metadata prefix e.g. "data:image/png;base64,<base64...>"
   */
  base64VideoPlaceholderImage?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  experienceOverview?: InputMaybe<Scalars['DraftJsTextType']>;
  files?: InputMaybe<Array<InputMaybe<FileInput>>>;
  hardDependency?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  sku?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Float']>;
  templateType: TemplateEnumType;
  videoUrl?: InputMaybe<Scalars['String']>;
}

/** update template milestone input */
export interface UpdateTemplateMilestoneInput {
  completionMessage?: InputMaybe<Scalars['DraftJsTextType']>;
  description?: InputMaybe<Scalars['String']>;
  destinationIndex?: InputMaybe<Scalars['ID']>;
  enableCompletionNotification?: InputMaybe<Scalars['Boolean']>;
  enableSendSurvey?: InputMaybe<Scalars['Boolean']>;
  files?: InputMaybe<Array<InputMaybe<FileInput>>>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Float']>;
}

/** Autogenerated return type of updateTemplateMilestone. */
export interface UpdateTemplateMilestonePayload {
  __typename?: 'updateTemplateMilestonePayload';
  milestone?: Maybe<MilestoneType>;
}

/** Autogenerated return type of updateTemplate. */
export interface UpdateTemplatePayload {
  __typename?: 'updateTemplatePayload';
  template?: Maybe<TemplateType>;
}

/** Update a time record */
export interface UpdateTimeRecordInput {
  billable?: InputMaybe<Scalars['Boolean']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  dateWorked?: InputMaybe<Scalars['DateType']>;
  description?: InputMaybe<Scalars['String']>;
  hours?: InputMaybe<Scalars['Float']>;
  id: Scalars['ID'];
  projectId?: InputMaybe<Scalars['ID']>;
  taskId?: InputMaybe<Scalars['ID']>;
  workerId?: InputMaybe<Scalars['ID']>;
}

/** Autogenerated return type of updateTimeRecord. */
export interface UpdateTimeRecordPayload {
  __typename?: 'updateTimeRecordPayload';
  timeRecord?: Maybe<TimeRecordType>;
}

/** update time-tracking settings input */
export interface UpdateTimeTrackingSettingsInput {
  disableTimeEntryForCompletedProjects?: InputMaybe<Scalars['Boolean']>;
  disableTimeEntryForPastMonths?: InputMaybe<Scalars['Boolean']>;
}

/** Autogenerated return type of updateTimeTrackingSettings. */
export interface UpdateTimeTrackingSettingsPayload {
  __typename?: 'updateTimeTrackingSettingsPayload';
  timeTrackingSettings?: Maybe<TimeTrackingSettingsType>;
}

/** update user input */
export interface UpdateUserInput {
  /**
   * base64 encoded version of the avatar image with metadata prefix
   *                           e.g."data:image/png;base64,iVBG..."
   */
  base64Avatar?: InputMaybe<Scalars['String']>;
  bio?: InputMaybe<Scalars['String']>;
  calendarLink?: InputMaybe<Scalars['String']>;
  capacity?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<Scalars['String']>;
  costRate?: InputMaybe<Scalars['Float']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  hideEmail?: InputMaybe<Scalars['Boolean']>;
  hidePhone?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isDarkModeEnabled?: InputMaybe<Scalars['Boolean']>;
  jobRole?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  meetingLink?: InputMaybe<Scalars['String']>;
  notificationPreferences?: InputMaybe<NotificationPreferenceInputType>;
  phone?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<UserRoleEnumType>;
  skillIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  smsEnabled?: InputMaybe<Scalars['Boolean']>;
  timeZone?: InputMaybe<Scalars['String']>;
}

/** update user notification preferences input */
export interface UpdateUserNotificationPreferencesInput {
  id: Scalars['ID'];
  notificationPreferences?: InputMaybe<NotificationPreferenceInputType>;
}

/** Autogenerated return type of updateUserNotificationPreferences. */
export interface UpdateUserNotificationPreferencesPayload {
  __typename?: 'updateUserNotificationPreferencesPayload';
  user?: Maybe<UserType>;
}

/** Autogenerated return type of updateUser. */
export interface UpdateUserPayload {
  __typename?: 'updateUserPayload';
  user?: Maybe<UserType>;
}

/** Autogenerated return type of updateUserProject. */
export interface UpdateUserProjectPayload {
  __typename?: 'updateUserProjectPayload';
  project: ProjectType;
  projectView?: Maybe<ProjectViewEnum>;
  restrictAccess: Scalars['Boolean'];
  user: UserType;
}

/** update webhook input */
export interface UpdateWebhookInput {
  active?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  secret?: InputMaybe<Scalars['String']>;
  url: Scalars['String'];
}

/** Autogenerated return type of updateWebhook. */
export interface UpdateWebhookPayload {
  __typename?: 'updateWebhookPayload';
  organization?: Maybe<OrganizationType>;
}

/** Autogenerated return type of upsertCustomConfiguration. */
export interface UpsertCustomConfigurationPayload {
  __typename?: 'upsertCustomConfigurationPayload';
  configurations: CustomConfigurationType;
}

export interface UpsertCustomerRoleInput {
  name?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['ID']>;
  projectView?: InputMaybe<ProjectViewEnum>;
  restrictAccess?: InputMaybe<Scalars['Boolean']>;
  roleId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
}

/** Autogenerated return type of upsertCustomerRole. */
export interface UpsertCustomerRolePayload {
  __typename?: 'upsertCustomerRolePayload';
  success: Scalars['Boolean'];
}

/** Create or update info field input */
export interface UpsertInfoFieldInput {
  infoFieldId?: InputMaybe<Scalars['ID']>;
  internalOnly?: InputMaybe<Scalars['Boolean']>;
  mergeTag: Scalars['Boolean'];
  name: Scalars['String'];
  sortOrder?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<InfoFieldsEnum>;
}

/** Autogenerated return type of upsertInfoField. */
export interface UpsertInfoFieldPayload {
  __typename?: 'upsertInfoFieldPayload';
  infoField: MergeTag;
}

/** Create or update organization settings input */
export interface UpsertOrganizationSettingsInput {
  billableRateOverridesEnabled?: InputMaybe<Scalars['Boolean']>;
  genericTimeEntryEnabled?: InputMaybe<Scalars['Boolean']>;
  onlyAssigneeCanEnterTimeEnabled?: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['ID'];
  timeEntryRequiredEnabled?: InputMaybe<Scalars['Boolean']>;
  timeTrackingCategoriesEnabled?: InputMaybe<Scalars['Boolean']>;
}

/** Autogenerated return type of upsertOrganizationSettings. */
export interface UpsertOrganizationSettingsPayload {
  __typename?: 'upsertOrganizationSettingsPayload';
  organization: OrganizationType;
}

/** Autogenerated return type of upsertProjectInfoFields. */
export interface UpsertProjectInfoFieldsPayload {
  __typename?: 'upsertProjectInfoFieldsPayload';
  success?: Maybe<Scalars['Boolean']>;
}

/** Upsert a project time tracking category */
export interface UpsertProjectLevelTimeTrackingCategoryInput {
  billableRateOverride?: InputMaybe<Scalars['Float']>;
  projectId: Scalars['ID'];
  timeTrackingCategoryId: Scalars['ID'];
}

/** Autogenerated return type of upsertProjectLevelTimeTrackingCategory. */
export interface UpsertProjectLevelTimeTrackingCategoryPayload {
  __typename?: 'upsertProjectLevelTimeTrackingCategoryPayload';
  projectTimeTrackingCategory: TimeTrackingCategory;
}

/** Create or update skill input */
export interface UpsertSkillInput {
  assignUserIds?: InputMaybe<Array<Scalars['ID']>>;
  billableRate: Scalars['Float'];
  categoryId: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  unassignUserIds?: InputMaybe<Array<Scalars['ID']>>;
}

/** Autogenerated return type of upsertSkill. */
export interface UpsertSkillPayload {
  __typename?: 'upsertSkillPayload';
  skill: Skill;
}

/** Upsert a time tracking category */
export interface UpsertTimeTrackingCategoryInput {
  billable?: InputMaybe<Scalars['Boolean']>;
  billableRate?: InputMaybe<Scalars['Float']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
}

/** Autogenerated return type of upsertTimeTrackingCategory. */
export interface UpsertTimeTrackingCategoryPayload {
  __typename?: 'upsertTimeTrackingCategoryPayload';
  timeTrackingCategory: TimeTrackingCategory;
}

/** Autogenerated return type of upsertUserAccountProperties. */
export interface UpsertUserAccountPropertiesPayload {
  __typename?: 'upsertUserAccountPropertiesPayload';
  success: Scalars['Boolean'];
}

export type CustomerOrganizationFragment = (
  { id: string, name?: string | null, users?: Array<(
    { id: string, firstName?: string | null, lastName?: string | null }
    & { __typename?: 'UserType' }
  ) | null> | null, logo?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null }
  & { __typename?: 'OrganizationType' }
);

export type PageInfoFragment = (
  { totalPages?: number | null, totalResults?: number | null, currentPage?: number | null, limit?: number | null, isOutOfBounds?: boolean | null }
  & { __typename?: 'PageInfoType' }
);

export type SubtaskFragment = (
  { id: string, name?: string | null, richName?: string | null, done?: boolean | null, sortOrder?: number | null, groupId?: string | null }
  & { __typename?: 'SubtaskType' }
);

export type BulkAssignmentMutationBulkAssignmentMutationVariables = Exact<{
  taskIds: Array<Scalars['ID']> | Scalars['ID'];
  responsibility: TaskResponsibilityEnumType;
  assigneeId?: InputMaybe<Scalars['ID']>;
}>;


export type BulkAssignmentMutationBulkAssignmentMutation = (
  { bulkEditTasks?: (
    { updatedTasks?: Array<{ __typename: 'TaskType' } | null> | null }
    & { __typename?: 'bulkEditTasksPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ActionItemQueryActionItemQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ActionItemQueryActionItemQuery = (
  { actionItem: (
    { id: string, name?: string | null, createdOn?: any | null, description?: any | null, priority: PriorityEnumType, status: ActionItemStatusEnumType, startOn?: any | null, dueOn?: any | null, visibility?: ActionItemVisibilityEnumType | null, tags?: Array<(
      { id: string }
      & { __typename?: 'TagType' }
    )> | null, assignee?: (
      { id: string, firstName?: string | null }
      & { __typename?: 'UserType' }
    ) | null, relatedTask?: (
      { id: string, name: string, milestone?: (
        { id: string, name: string }
        & { __typename?: 'MilestoneType' }
      ) | null }
      & { __typename?: 'TaskType' }
    ) | null }
    & { __typename?: 'ActionItemType' }
  ) }
  & { __typename?: 'Query' }
);

export type ProjectFilterOptionsProjectFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectFilterOptionsProjectFilterOptionsQuery = (
  { projectBrands?: Array<string> | null, projectActiveMilestones?: Array<string> | null, projectManagers?: Array<(
    { id: string, firstName?: string | null, lastName?: string | null, jobRole?: string | null, organizationName?: string | null, organization?: (
      { id: string, name?: string | null }
      & { __typename?: 'OrganizationType' }
    ) | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null, displayOrganization?: (
      { name: string }
      & { __typename?: 'DisplayOrganizationType' }
    ) | null }
    & { __typename?: 'UserType' }
  )> | null, projectTemplates?: Array<(
    { id: string, name: string }
    & { __typename?: 'TemplateType' }
  )> | null, userDefaultFilterView?: (
    { id: string, jsonFilterBlob?: string | null }
    & { __typename?: 'UserFilterViewType' }
  ) | null, availableTags?: Array<(
    { id: string, color: string, name: string, internalOnly: boolean }
    & { __typename?: 'TagType' }
  )> | null }
  & { __typename?: 'Query' }
);

export type CustomFieldsInfoFieldsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type CustomFieldsInfoFieldsQuery = (
  { infoFields?: Array<(
    { id: string, name: string, sortOrder: number }
    & { __typename?: 'MergeTag' }
  )> | null }
  & { __typename?: 'Query' }
);

export type CustomFieldsUpsertInfoFieldMutationVariables = Exact<{
  input: UpsertInfoFieldInput;
}>;


export type CustomFieldsUpsertInfoFieldMutation = (
  { upsertInfoField?: (
    { infoField: (
      { id: string, name: string, sortOrder: number }
      & { __typename?: 'MergeTag' }
    ) }
    & { __typename?: 'upsertInfoFieldPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type CustomFieldsRemoveCustomFieldMutationVariables = Exact<{
  customField: RemoveCustomFieldInput;
}>;


export type CustomFieldsRemoveCustomFieldMutation = (
  { removeCustomField?: (
    { success?: boolean | null }
    & { __typename?: 'removeCustomFieldPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type CustomFieldsRemoveMergeTagMutationVariables = Exact<{
  mergeTagId: Scalars['ID'];
}>;


export type CustomFieldsRemoveMergeTagMutation = (
  { deleteMergeTag?: (
    { success: boolean }
    & { __typename?: 'deleteMergeTagPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type CustomFieldsReorderInfoFieldsMutationVariables = Exact<{
  input: ReorderInfoFieldInput;
}>;


export type CustomFieldsReorderInfoFieldsMutation = (
  { reorderInfoField?: (
    { infoField: (
      { id: string, sortOrder: number }
      & { __typename?: 'MergeTag' }
    ) }
    & { __typename?: 'reorderInfoFieldPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type CompanyIntegrationsOrganizationQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type CompanyIntegrationsOrganizationQuery = (
  { organization?: (
    { id: string, openApiEnabled?: boolean | null, jiraEnabled?: boolean | null, hubspotEnabled?: boolean | null, projectUpdatedSlackDaysPref?: number | null, salesforceEnabled?: boolean | null, openApiData?: (
      { openApiToken?: string | null, webhooks?: Array<(
        { id: string, url?: string | null, secret?: string | null, active?: boolean | null }
        & { __typename?: 'WebhookType' }
      )> | null }
      & { __typename?: 'OpenApiDataType' }
    ) | null, jiraIntegration?: (
      { id: string, siteName: string, siteUrl: string }
      & { __typename?: 'JiraIntegrationType' }
    ) | null, hubSpotIntegration?: (
      { id: string, hubSpotPortalId?: string | null }
      & { __typename?: 'HubspotIntegrationType' }
    ) | null, slackIntegrations?: Array<(
      { id: string, channelName?: string | null, channelId?: string | null, url?: string | null, teamName?: string | null }
      & { __typename?: 'SlackIntegrationType' }
    ) | null> | null, salesforceIntegration?: (
      { id: string, username?: string | null, organizationName?: string | null, host: SalesforceHostEnum }
      & { __typename?: 'SalesforceIntegrationType' }
    ) | null }
    & { __typename?: 'OrganizationType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type CompanyOpenApiOrganizationQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type CompanyOpenApiOrganizationQuery = (
  { organization?: (
    { id: string, openApiEnabled?: boolean | null, openApiData?: (
      { openApiToken?: string | null, webhooks?: Array<(
        { id: string, url?: string | null, secret?: string | null, active?: boolean | null }
        & { __typename?: 'WebhookType' }
      )> | null }
      & { __typename?: 'OpenApiDataType' }
    ) | null }
    & { __typename?: 'OrganizationType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type CompanySettingsOrganizationDetailsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type CompanySettingsOrganizationDetailsQuery = (
  { organization?: (
    { id: string, bccEmail?: string | null, uploadsViaEmailEnabled: boolean, defaultTaskVisibility?: TaskVisibilityEnumType | null, billableRate?: number | null, timeTrackingEnabled?: boolean | null, showShareableLink?: boolean | null, isCsatSurveyEnabled: boolean, internalNotesDefault: boolean, taskFilterByFunction?: boolean | null, currencyCode: CurrencyCodeEnumType, countryCode: CountryCodeEnumType, uploadsEnabled: boolean, whiteLabelingEnabled?: boolean | null, primaryColor?: string | null, name?: string | null, secureLinksEnabled: boolean, secureLinksTtl: number, ssoEnabled?: boolean | null, setting: (
      { brandedEmailSenderEnabled?: boolean | null, useStatusChangeReasons?: boolean | null }
      & { __typename?: 'OrganizationSetting' }
    ), headerLogo?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null, identityProvider?: (
      { id: string, active: boolean, certificate?: string | null, issuer?: string | null, jitProvisioning: boolean, strictMode: boolean, targetUrl?: string | null, entityId: string, attributeConsumeServiceEndpoint: string }
      & { __typename?: 'IdentityProviderType' }
    ) | null }
    & { __typename?: 'OrganizationType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type CompanySettingsUpdateSettingsMutationVariables = Exact<{
  organization: UpdateOrganizationInput;
}>;


export type CompanySettingsUpdateSettingsMutation = (
  { updateOrganization?: (
    { organization?: (
      { id: string, bccEmail?: string | null, uploadsViaEmailEnabled: boolean, defaultTaskVisibility?: TaskVisibilityEnumType | null, billableRate?: number | null, timeTrackingEnabled?: boolean | null, showShareableLink?: boolean | null, isCsatSurveyEnabled: boolean, internalNotesDefault: boolean, taskFilterByFunction?: boolean | null, currencyCode: CurrencyCodeEnumType, countryCode: CountryCodeEnumType, uploadsEnabled: boolean, whiteLabelingEnabled?: boolean | null, primaryColor?: string | null, name?: string | null, secureLinksEnabled: boolean, secureLinksTtl: number, ssoEnabled?: boolean | null, setting: (
        { useStatusChangeReasons?: boolean | null }
        & { __typename?: 'OrganizationSetting' }
      ), headerLogo?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null, identityProvider?: (
        { id: string, active: boolean, certificate?: string | null, issuer?: string | null, jitProvisioning: boolean, strictMode: boolean, targetUrl?: string | null, entityId: string, attributeConsumeServiceEndpoint: string }
        & { __typename?: 'IdentityProviderType' }
      ) | null }
      & { __typename?: 'OrganizationType' }
    ) | null }
    & { __typename?: 'updateOrganizationPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type CompanySettingsOrganizationDomainsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type CompanySettingsOrganizationDomainsQuery = (
  { getOrganizationDomains?: Array<(
    { id: string, domain?: string | null, status?: boolean | null, record1?: string | null, record2?: string | null, record3?: string | null, sendgridWhitelabelId?: string | null }
    & { __typename?: 'DomainVerificationRecordsType' }
  )> | null }
  & { __typename?: 'Query' }
);

export type CompanySettingsUpdateDomainRecordsMutationVariables = Exact<{
  domainAuthValues: UpdateDomainAuthRecordsInput;
}>;


export type CompanySettingsUpdateDomainRecordsMutation = (
  { updateDomainAuthRecords?: (
    { domainVerification?: (
      { id: string, domain?: string | null, status?: boolean | null, record1?: string | null, record2?: string | null, record3?: string | null, sendgridWhitelabelId?: string | null }
      & { __typename?: 'DomainVerificationRecordsType' }
    ) | null }
    & { __typename?: 'updateDomainAuthRecordsPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type CompanySettingsSendVerificationInstructionsMutationVariables = Exact<{
  input: DomainVerificationInstructionsInput;
}>;


export type CompanySettingsSendVerificationInstructionsMutation = (
  { domainVerificationInstructions?: (
    { success?: boolean | null }
    & { __typename?: 'domainVerificationInstructionsPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ProjectCreatedAtFragment = (
  { id: string, createdAt: any }
  & { __typename?: 'ProjectType' }
);

export type ProjectActivityLogProjectActivitiesConnectionsQueryVariables = Exact<{
  projectId: Scalars['ID'];
  activityRelated: Scalars['ID'];
  listInputs?: InputMaybe<ListInput>;
}>;


export type ProjectActivityLogProjectActivitiesConnectionsQuery = (
  { projectActivitiesConnections?: (
    { pageInfo?: (
      { totalPages?: number | null, totalResults?: number | null, currentPage?: number | null, limit?: number | null, isOutOfBounds?: boolean | null }
      & { __typename?: 'PageInfoType' }
    ) | null, activities?: Array<(
      { id: string, text?: string | null, createdAt?: any | null, internalOnly?: boolean | null, userNotRelevant?: boolean | null, user?: (
        { firstName?: string | null, lastName?: string | null }
        & { __typename?: 'DefaultActivityOwnerType' }
      ) | (
        { id: string, firstName?: string | null, lastName?: string | null }
        & { __typename?: 'SignerType' }
      ) | (
        { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null }
      & { __typename?: 'ActivityType' }
    )> | null }
    & { __typename?: 'ActivityConnectionType' }
  ) | null, project: (
    { id: string, createdAt: any }
    & { __typename?: 'ProjectType' }
  ) }
  & { __typename?: 'Query' }
);

export type CategoryListProjectSkillCategoriesQueryVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type CategoryListProjectSkillCategoriesQuery = (
  { project: (
    { id: string, skillCategories: Array<(
      { id: string, name: string, userCount: number, skillCount: number, skills: Array<(
        { id: string, billableRate: number, name: string, users: Array<(
          { id: string, jobRole?: string | null, firstName?: string | null, lastName?: string | null, avatar?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'UserType' }
        )> }
        & { __typename?: 'Skill' }
      )> }
      & { __typename?: 'SkillCategory' }
    )> }
    & { __typename?: 'ProjectType' }
  ) }
  & { __typename?: 'Query' }
);

export type UpdateBillableOverrideMutationVariables = Exact<{
  input: UpdateBillableOverrideInput;
}>;


export type UpdateBillableOverrideMutation = (
  { updateBillableOverride?: (
    { success: boolean }
    & { __typename?: 'updateBillableOverridePayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ProjectCustomFieldsProjectInfoFieldsQueryVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type ProjectCustomFieldsProjectInfoFieldsQuery = (
  { projectInfoFields?: Array<(
    { id: string, value?: string | null, mergeTag: (
      { id: string, name: string }
      & { __typename?: 'MergeTag' }
    ) }
    & { __typename?: 'ProjectMergeTag' }
  )> | null }
  & { __typename?: 'Query' }
);

export type ProjectCustomFieldsProjectOrganizationQueryVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type ProjectCustomFieldsProjectOrganizationQuery = (
  { project: (
    { id: string, organization?: (
      { id: string }
      & { __typename?: 'OrganizationType' }
    ) | null }
    & { __typename?: 'ProjectType' }
  ) }
  & { __typename?: 'Query' }
);

export type ProjectFilesProjectQueryVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type ProjectFilesProjectQuery = (
  { project: (
    { id: string, name: string }
    & { __typename?: 'ProjectType' }
  ) }
  & { __typename?: 'Query' }
);

export type ProjectNotesProjectQueryVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type ProjectNotesProjectQuery = (
  { project: (
    { id: string, organization?: (
      { id: string, internalNotesDefault: boolean }
      & { __typename?: 'OrganizationType' }
    ) | null }
    & { __typename: 'ProjectType' }
  ), projectTeam: Array<(
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, projectContext?: UserProjectOrganizationTypeEnumType | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null, organization?: (
      { id: string }
      & { __typename?: 'OrganizationType' }
    ) | null }
    & { __typename?: 'UserType' }
  )> }
  & { __typename?: 'Query' }
);

export type ProjectOverviewProjectUpdatedSubscriptionVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type ProjectOverviewProjectUpdatedSubscription = (
  { projectUpdated?: (
    { project?: (
      { id: string, status: StatusEnumType, forecastedEndOn?: any | null }
      & { __typename?: 'ProjectType' }
    ) | null, projectStats?: (
      { id: string, totalTasks: number, totalDoneTasks: number, totalSignOffTasks: number, totalStuckTasks: number, totalWorkingOnItTasks: number, totalNotStartedTasks: number, totalAssignedTasks: number }
      & { __typename?: 'ProjectStats' }
    ) | null }
    & { __typename?: 'ProjectUpdatePayloadType' }
  ) | null }
  & { __typename?: 'Subscription' }
);

export type ProjectPlanProjectQueryVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type ProjectPlanProjectQuery = (
  { project: (
    { id: string, creating?: boolean | null, firstActiveTemplate?: string | null, pmDisplayRole?: string | null, deletedAt?: any | null, archivedAt?: any | null, status: StatusEnumType, organization?: (
      { id: string, defaultTaskVisibility?: TaskVisibilityEnumType | null, timeTrackingEnabled?: boolean | null, resourceManagementEnabled?: boolean | null }
      & { __typename?: 'OrganizationType' }
    ) | null, templates?: Array<(
      { id: string, name: string, sortOrder?: number | null, active: boolean, hardDependency?: boolean | null, completedAt?: any | null, summaryBank: (
        { totalCompleteTasks: number, totalTasks: number, totalAssignedTasks: number, totalActualHours: number, totalEstimatedHours: number, totalRemainingHours: number, totalInternalHours: number, totalCustomerHours: number, totalThirdPartyHours: number, totalInternalRemainingHours: number, totalInternalActualHours: number, totalCustomerRemainingHours: number, totalCustomerActualHours: number, totalThirdPartyRemainingHours: number, totalThirdPartyActualHours: number, totalInternalLoggedHours: number, totalInternalLoggedBillableHours: number, totalInternalLoggedNonBillableHours: number, totalInternalRemainingPurchasedHours: number }
        & { __typename?: 'TemplateStats' }
      ), organization: (
        { id: string }
        & { __typename?: 'OrganizationType' }
      ) }
      & { __typename?: 'TemplateType' }
    )> | null, projectBillRate?: (
      { rateType?: RateTypeEnum | null, hours?: number | null }
      & { __typename?: 'ProjectBillRateType' }
    ) | null }
    & { __typename?: 'ProjectType' }
  ), projectTeam: Array<(
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, projectContext?: UserProjectOrganizationTypeEnumType | null, role?: UserRoleEnumType | null, jobRole?: string | null, organizationName?: string | null, skills: Array<(
      { id: string }
      & { __typename?: 'Skill' }
    )>, organization?: (
      { id: string, type?: OrganizationTypeEnumType | null, name?: string | null }
      & { __typename?: 'OrganizationType' }
    ) | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null, displayOrganization?: (
      { name: string }
      & { __typename?: 'DisplayOrganizationType' }
    ) | null }
    & { __typename?: 'UserType' }
  )>, stats?: { __typename?: 'MilestoneStats' | 'TemplateStats' } | (
    { id: string, totalTasks: number, totalDoneTasks: number, totalSignOffTasks: number, totalStuckTasks: number, totalWorkingOnItTasks: number, totalNotStartedTasks: number, totalAssignedTasks: number, totalCustomerOverdueTasks: number, totalThirdPartyOverdueTasks: number, totalInternalOverdueTasks: number }
    & { __typename?: 'ProjectStats' }
  ) | null }
  & { __typename?: 'Query' }
);

export type ProjectTeamProjectQueryVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type ProjectTeamProjectQuery = (
  { project: (
    { id: string, name: string, status: StatusEnumType, currentUserProjectContext?: UserProjectOrganizationTypeEnumType | null, projectType?: ProjectTypeEnumType | null, firstActiveTemplate?: string | null, organization?: (
      { id: string, resourceManagementEnabled?: boolean | null }
      & { __typename?: 'OrganizationType' }
    ) | null, customerV2?: (
      { id: string, name: string }
      & { __typename?: 'CustomerType' }
    ) | null }
    & { __typename?: 'ProjectType' }
  ) }
  & { __typename?: 'Query' }
);

export type UpdateSkillCategoryNameFragment = (
  { id: string, name: string }
  & { __typename?: 'SkillCategory' }
);

export type CategoryListSkillCategoriesQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type CategoryListSkillCategoriesQuery = (
  { organization?: (
    { id: string, skillCategories: Array<(
      { id: string, name: string, userCount: number, skillCount: number, skills: Array<(
        { id: string, billableRate: number, name: string, category: (
          { id: string, skillCount: number, userCount: number }
          & { __typename?: 'SkillCategory' }
        ), users: Array<(
          { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'UserType' }
        )> }
        & { __typename?: 'Skill' }
      )> }
      & { __typename?: 'SkillCategory' }
    )> }
    & { __typename?: 'OrganizationType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type SkillSetsCreateCategoryMutationVariables = Exact<{
  input: CreateSkillCategoryInput;
}>;


export type SkillSetsCreateCategoryMutation = (
  { createSkillCategory?: (
    { skillCategory: (
      { id: string, name: string }
      & { __typename?: 'SkillCategory' }
    ) }
    & { __typename?: 'createSkillCategoryPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type DeleteSkillCategoryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteSkillCategoryMutation = (
  { deleteSkillCategory?: (
    { success: boolean }
    & { __typename?: 'deleteSkillCategoryPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type SupportProductBoardTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type SupportProductBoardTokenMutation = (
  { productboardToken?: (
    { accessToken: string }
    & { __typename?: 'ProductboardTokenPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type TemplateFilesFilePageFragment = (
  { id: string, url?: string | null, fileName: string, size?: number | null, milestoneName?: string | null, deletable?: boolean | null, taskName?: string | null, createdAt?: any | null, internalOnly: boolean, isExternalHyperlink?: boolean | null, uploader?: (
    { id: string, firstName?: string | null, lastName?: string | null }
    & { __typename?: 'UserType' }
  ) | null }
  & { __typename?: 'FileType' }
);

export type TemplateFilesFilesPageQueryVariables = Exact<{
  templateId: Scalars['ID'];
  listInputs?: InputMaybe<ListInput>;
}>;


export type TemplateFilesFilesPageQuery = (
  { templatesById?: Array<(
    { id: string, name: string }
    & { __typename?: 'TemplateType' }
  )> | null, files?: (
    { pageInfo?: (
      { totalPages?: number | null, totalResults?: number | null, currentPage?: number | null, limit?: number | null, isOutOfBounds?: boolean | null }
      & { __typename?: 'PageInfoType' }
    ) | null, assets?: Array<(
      { id: string, url?: string | null, fileName: string, size?: number | null, milestoneName?: string | null, deletable?: boolean | null, taskName?: string | null, createdAt?: any | null, internalOnly: boolean, isExternalHyperlink?: boolean | null, uploader?: (
        { id: string, firstName?: string | null, lastName?: string | null }
        & { __typename?: 'UserType' }
      ) | null }
      & { __typename?: 'FileType' }
    )> | null }
    & { __typename?: 'AssetConnectionType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type TemplateFilesDeleteFilePageMutationVariables = Exact<{
  deleteFileInput: DeleteFileInput;
}>;


export type TemplateFilesDeleteFilePageMutation = (
  { deleteFile?: (
    { success?: boolean | null }
    & { __typename?: 'DeleteFilePayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type TemplateFilesUpdateTemplatePageMutationVariables = Exact<{
  input: UpdateTemplateInput;
}>;


export type TemplateFilesUpdateTemplatePageMutation = (
  { updateTemplate?: (
    { template?: (
      { id: string, files?: Array<(
        { id: string, url?: string | null, fileName: string, size?: number | null, milestoneName?: string | null, deletable?: boolean | null, taskName?: string | null, createdAt?: any | null, internalOnly: boolean, isExternalHyperlink?: boolean | null, uploader?: (
          { id: string, firstName?: string | null, lastName?: string | null }
          & { __typename?: 'UserType' }
        ) | null }
        & { __typename?: 'FileType' }
      )> | null }
      & { __typename?: 'TemplateType' }
    ) | null }
    & { __typename?: 'updateTemplatePayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type TemplateOverviewTemplateFragment = (
  { id: string, experienceOverview?: string | null, videoUrl?: string | null, description?: string | null, sku?: string | null, duration?: number | null, published: boolean, videoPlaceholderImage?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, files?: Array<(
    { id: string }
    & { __typename?: 'FileType' }
  )> | null, organization: (
    { id: string, name?: string | null }
    & { __typename?: 'OrganizationType' }
  ) }
  & { __typename?: 'TemplateType' }
);

export type TemplateOverviewTemplateStatsFragment = (
  { id: string, totalMilestones: number, totalTasks: number, totalCompleteTasks: number, totalPoints: number, totalEstimatedHours: number, totalInternalTasks: number, totalInternalPoints: number, totalInternalHours: number, totalCustomerTasks: number, totalCustomerPoints: number, totalCustomerHours: number, totalThirdPartyTasks: number, totalThirdPartyPoints: number, totalThirdPartyHours: number, totalAssignedTasks: number, totalActualHours: number, totalRemainingHours: number, totalInternalRemainingHours: number, totalInternalActualHours: number, totalCustomerRemainingHours: number, totalCustomerActualHours: number, totalThirdPartyRemainingHours: number, totalThirdPartyActualHours: number }
  & { __typename?: 'TemplateStats' }
);

export type TemplateOverviewTemplateStatsQueryVariables = Exact<{
  templateId: Scalars['ID'];
}>;


export type TemplateOverviewTemplateStatsQuery = (
  { stats?: { __typename?: 'MilestoneStats' | 'ProjectStats' } | (
    { id: string, totalMilestones: number, totalTasks: number, totalCompleteTasks: number, totalPoints: number, totalEstimatedHours: number, totalInternalTasks: number, totalInternalPoints: number, totalInternalHours: number, totalCustomerTasks: number, totalCustomerPoints: number, totalCustomerHours: number, totalThirdPartyTasks: number, totalThirdPartyPoints: number, totalThirdPartyHours: number, totalAssignedTasks: number, totalActualHours: number, totalRemainingHours: number, totalInternalRemainingHours: number, totalInternalActualHours: number, totalCustomerRemainingHours: number, totalCustomerActualHours: number, totalThirdPartyRemainingHours: number, totalThirdPartyActualHours: number }
    & { __typename?: 'TemplateStats' }
  ) | null }
  & { __typename?: 'Query' }
);

export type TemplateOverviewTemplateQueryVariables = Exact<{
  templateId: Scalars['ID'];
}>;


export type TemplateOverviewTemplateQuery = (
  { blueprintTemplate: (
    { id: string, experienceOverview?: string | null, videoUrl?: string | null, description?: string | null, sku?: string | null, duration?: number | null, published: boolean, videoPlaceholderImage?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null, files?: Array<(
      { id: string }
      & { __typename?: 'FileType' }
    )> | null, organization: (
      { id: string, name?: string | null }
      & { __typename?: 'OrganizationType' }
    ) }
    & { __typename?: 'TemplateType' }
  ) }
  & { __typename?: 'Query' }
);

export type ReportingIndexTimeReportSummaryQueryVariables = Exact<{
  start: Scalars['DateType'];
  end: Scalars['DateType'];
  filters?: InputMaybe<TimeReportFiltersInput>;
  reportScope: ReportScopeEnumType;
  includeGeneric: Scalars['Boolean'];
  keyword?: InputMaybe<Scalars['String']>;
}>;


export type ReportingIndexTimeReportSummaryQuery = (
  { timeReportSummary?: (
    { billableHours: number, estimatedHours: number, nonBillableHours: number, totalHours?: number | null, totalCost?: number | null, totalBilled?: number | null, warning?: TimeReportWarningEnumType | null }
    & { __typename?: 'TimeReportSummary' }
  ) | null }
  & { __typename?: 'Query' }
);

export type CompanyUsersFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, role?: UserRoleEnumType | null, status?: string | null, createdAt?: any | null, organizationName?: string | null, organization?: (
    { id: string, name?: string | null }
    & { __typename?: 'OrganizationType' }
  ) | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type UserIndexUsersQueryVariables = Exact<{
  listInputs?: InputMaybe<ListInput>;
}>;


export type UserIndexUsersQuery = (
  { allUsers: (
    { pageInfo?: (
      { totalPages?: number | null, totalResults?: number | null, currentPage?: number | null, limit?: number | null, isOutOfBounds?: boolean | null }
      & { __typename?: 'PageInfoType' }
    ) | null, users?: Array<(
      { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, role?: UserRoleEnumType | null, status?: string | null, createdAt?: any | null, organizationName?: string | null, organization?: (
        { id: string, name?: string | null }
        & { __typename?: 'OrganizationType' }
      ) | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    )> | null }
    & { __typename?: 'PaginatedUsersType' }
  ) }
  & { __typename?: 'Query' }
);

export type ResendInviteToEmailResendInvitationMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ResendInviteToEmailResendInvitationMutation = (
  { resendInviteToUser?: (
    { success?: boolean | null }
    & { __typename?: 'resendInviteToUserPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ResendInviteResendInvitationMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ResendInviteResendInvitationMutation = (
  { resendInviteToUser?: (
    { success?: boolean | null }
    & { __typename?: 'resendInviteToUserPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type TaskActionsTaskFragment = (
  { id: string, responsibility: TaskResponsibilityEnumType, name: string, description?: string | null, assignee?: (
    { firstName?: string | null, lastName?: string | null }
    & { __typename?: 'PublicUserProfile' }
  ) | null, project?: (
    { id: string, projectType: ProjectTypeEnumType, pmDisplayRole?: string | null, organization?: (
      { id: string, name: string, logo?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'PublicOrganization' }
    ) | null, projectManager?: (
      { id: string, firstName?: string | null, lastName?: string | null }
      & { __typename?: 'PublicUserProfile' }
    ) | null, displayOrganization?: (
      { name: string, logo?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'DisplayOrganizationType' }
    ) | null, customer?: (
      { id: string, name: string, logo?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'PublicCustomer' }
    ) | null }
    & { __typename?: 'PublicProject' }
  ) | null, milestone: (
    { id: string }
    & { __typename?: 'PublicMilestone' }
  ), template: (
    { id: string }
    & { __typename?: 'PublicTemplate' }
  ) }
  & { __typename?: 'PublicTask' }
);

export type TaskActionsTaskQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TaskActionsTaskQuery = (
  { taskActions: (
    { id: string, responsibility: TaskResponsibilityEnumType, name: string, description?: string | null, assignee?: (
      { firstName?: string | null, lastName?: string | null }
      & { __typename?: 'PublicUserProfile' }
    ) | null, project?: (
      { id: string, projectType: ProjectTypeEnumType, pmDisplayRole?: string | null, organization?: (
        { id: string, name: string, logo?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'PublicOrganization' }
      ) | null, projectManager?: (
        { id: string, firstName?: string | null, lastName?: string | null }
        & { __typename?: 'PublicUserProfile' }
      ) | null, displayOrganization?: (
        { name: string, logo?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'DisplayOrganizationType' }
      ) | null, customer?: (
        { id: string, name: string, logo?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'PublicCustomer' }
      ) | null }
      & { __typename?: 'PublicProject' }
    ) | null, milestone: (
      { id: string }
      & { __typename?: 'PublicMilestone' }
    ), template: (
      { id: string }
      & { __typename?: 'PublicTemplate' }
    ) }
    & { __typename?: 'PublicTask' }
  ) }
  & { __typename?: 'Query' }
);

export type TaskActionsUpdateSignOffMutationVariables = Exact<{
  taskId: Scalars['ID'];
  action: SignOffActionEnumType;
}>;


export type TaskActionsUpdateSignOffMutation = (
  { updateSignOff?: (
    { task?: (
      { id: string, responsibility: TaskResponsibilityEnumType, name: string, description?: string | null, assignee?: (
        { firstName?: string | null, lastName?: string | null }
        & { __typename?: 'PublicUserProfile' }
      ) | null, project?: (
        { id: string, projectType: ProjectTypeEnumType, pmDisplayRole?: string | null, organization?: (
          { id: string, name: string, logo?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'PublicOrganization' }
        ) | null, projectManager?: (
          { id: string, firstName?: string | null, lastName?: string | null }
          & { __typename?: 'PublicUserProfile' }
        ) | null, displayOrganization?: (
          { name: string, logo?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'DisplayOrganizationType' }
        ) | null, customer?: (
          { id: string, name: string, logo?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'PublicCustomer' }
        ) | null }
        & { __typename?: 'PublicProject' }
      ) | null, milestone: (
        { id: string }
        & { __typename?: 'PublicMilestone' }
      ), template: (
        { id: string }
        & { __typename?: 'PublicTemplate' }
      ) }
      & { __typename?: 'PublicTask' }
    ) | null }
    & { __typename?: 'updateSignOffPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type TaskActionsChangeStatusMutationVariables = Exact<{
  changeStatusInput: ChangeStatusInput;
}>;


export type TaskActionsChangeStatusMutation = (
  { changeStatus?: (
    { task?: (
      { id: string, responsibility: TaskResponsibilityEnumType, name: string, description?: string | null, assignee?: (
        { firstName?: string | null, lastName?: string | null }
        & { __typename?: 'PublicUserProfile' }
      ) | null, project?: (
        { id: string, projectType: ProjectTypeEnumType, pmDisplayRole?: string | null, organization?: (
          { id: string, name: string, logo?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'PublicOrganization' }
        ) | null, projectManager?: (
          { id: string, firstName?: string | null, lastName?: string | null }
          & { __typename?: 'PublicUserProfile' }
        ) | null, displayOrganization?: (
          { name: string, logo?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'DisplayOrganizationType' }
        ) | null, customer?: (
          { id: string, name: string, logo?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'PublicCustomer' }
        ) | null }
        & { __typename?: 'PublicProject' }
      ) | null, milestone: (
        { id: string }
        & { __typename?: 'PublicMilestone' }
      ), template: (
        { id: string }
        & { __typename?: 'PublicTemplate' }
      ) }
      & { __typename?: 'PublicTask' }
    ) | null }
    & { __typename?: 'changeStatusPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type TaskActionsToggleGroupTaskCompletedMutationVariables = Exact<{
  taskInput: ToggleGroupTaskCompletedInput;
}>;


export type TaskActionsToggleGroupTaskCompletedMutation = (
  { toggleGroupTaskCompleted?: (
    { task?: (
      { id: string, responsibility: TaskResponsibilityEnumType, name: string, description?: string | null, assignee?: (
        { firstName?: string | null, lastName?: string | null }
        & { __typename?: 'PublicUserProfile' }
      ) | null, project?: (
        { id: string, projectType: ProjectTypeEnumType, pmDisplayRole?: string | null, organization?: (
          { id: string, name: string, logo?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'PublicOrganization' }
        ) | null, projectManager?: (
          { id: string, firstName?: string | null, lastName?: string | null }
          & { __typename?: 'PublicUserProfile' }
        ) | null, displayOrganization?: (
          { name: string, logo?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'DisplayOrganizationType' }
        ) | null, customer?: (
          { id: string, name: string, logo?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'PublicCustomer' }
        ) | null }
        & { __typename?: 'PublicProject' }
      ) | null, milestone: (
        { id: string }
        & { __typename?: 'PublicMilestone' }
      ), template: (
        { id: string }
        & { __typename?: 'PublicTemplate' }
      ) }
      & { __typename?: 'PublicTask' }
    ) | null }
    & { __typename?: 'toggleGroupTaskCompletedPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type UnsubscribeUserUpdateUserNotificationPreferencesMutationVariables = Exact<{
  user: UpdateUserNotificationPreferencesInput;
}>;


export type UnsubscribeUserUpdateUserNotificationPreferencesMutation = (
  { updateUserNotificationPreferences?: (
    { user?: (
      { id: string, role?: UserRoleEnumType | null, notificationPreferences?: (
        { projectOverviewEmailPref?: ProjectOverviewEmailPrefEnumType | null, taskReminderEmailPref?: TaskReminderEmailPref | null, milestoneCompletedEmailPref?: boolean | null, milestoneCompletedPref?: boolean | null, taskGroupCompletedEmailPref?: boolean | null, taskGroupCompletedPref?: boolean | null, taskUpdatedEmailPref?: boolean | null, taskUpdatedPref?: boolean | null, taskUpdatedDaysPref?: number | null, overdueEmailPref?: boolean | null, overduePref?: boolean | null, stuckEmailPref?: boolean | null, stuckPref?: boolean | null, doneEmailPref?: boolean | null, donePref?: boolean | null, allTasksCompletedPref?: boolean | null, allTasksCompletedEmailPref?: boolean | null, idleProjectDaysPref?: number | null, unsubscribeFromAllEmails?: boolean | null, projectRunningLatePref?: boolean | null, projectRunningLateEmailPref?: boolean | null, taskStartedUnassignedPref?: boolean | null, taskStartedUnassignedEmailPref?: boolean | null, groupedTaskCompletedPref?: boolean | null, groupedTaskCompletedEmailPref?: boolean | null, unaddressedNoteEmailPref?: boolean | null, unaddressedNotePref?: boolean | null }
        & { __typename?: 'NotificationPreferenceType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null }
    & { __typename?: 'updateUserNotificationPreferencesPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type UnsubscribeWatcherTaskQueryVariables = Exact<{
  taskId: Scalars['ID'];
}>;


export type UnsubscribeWatcherTaskQuery = (
  { task: (
    { id: string, name: string, watchers?: Array<(
      { id: string }
      & { __typename?: 'UserType' }
    )> | null }
    & { __typename?: 'TaskType' }
  ) }
  & { __typename?: 'Query' }
);

export type UnsubscribeWatcherRemoveWatcherMutationVariables = Exact<{
  variables: RemoveWatcherInput;
}>;


export type UnsubscribeWatcherRemoveWatcherMutation = (
  { removeWatcher?: (
    { success?: boolean | null }
    & { __typename?: 'removeWatcherPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type AddCustomerPromptAddCustomerUsersToProjectMutationVariables = Exact<{
  projectId: Scalars['ID'];
  users?: InputMaybe<Array<ProjectUserInput> | ProjectUserInput>;
}>;


export type AddCustomerPromptAddCustomerUsersToProjectMutation = (
  { addCustomerUsersToProject?: (
    { project?: (
      { id: string, users?: Array<(
        { id: string, firstName?: string | null, lastName?: string | null, lastActivityAt?: any | null, status?: string | null, jobRole?: string | null, organizationName?: string | null, phone?: string | null, email?: string | null, hidePhone?: boolean | null, hideEmail?: boolean | null, projectContext?: UserProjectOrganizationTypeEnumType | null, notificationPreferences?: (
          { projectOverviewEmailPref?: ProjectOverviewEmailPrefEnumType | null, taskReminderEmailPref?: TaskReminderEmailPref | null, overdueEmailPref?: boolean | null, stuckEmailPref?: boolean | null, doneEmailPref?: boolean | null, overduePref?: boolean | null, stuckPref?: boolean | null, donePref?: boolean | null }
          & { __typename?: 'NotificationPreferenceType' }
        ) | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null, organization?: (
          { id: string, name?: string | null, type?: OrganizationTypeEnumType | null, logo?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'OrganizationType' }
        ) | null, displayOrganization?: (
          { name: string, logo?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'DisplayOrganizationType' }
        ) | null, projectSettings?: (
          { projectView?: ProjectViewEnum | null, restrictAccess: boolean }
          & { __typename?: 'UserProject' }
        ) | null, skills: Array<(
          { id: string, name: string, category: (
            { id: string, name: string }
            & { __typename?: 'SkillCategory' }
          ) }
          & { __typename?: 'Skill' }
        )> }
        & { __typename?: 'UserType' }
      )> | null, organization?: (
        { id: string }
        & { __typename?: 'OrganizationType' }
      ) | null }
      & { __typename?: 'ProjectType' }
    ) | null }
    & { __typename?: 'addCustomerUsersToProjectPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type AddCustomerPromptProjectFragment = (
  { id: string, creating?: boolean | null, customerV2?: (
    { name: string, id: string }
    & { __typename?: 'CustomerType' }
  ) | null }
  & { __typename?: 'ProjectType' }
);

export type ContextualizedAddTeamMemberDrawerProjectQueryVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type ContextualizedAddTeamMemberDrawerProjectQuery = (
  { project: (
    { id: string, creating?: boolean | null, customerV2?: (
      { name: string, id: string }
      & { __typename?: 'CustomerType' }
    ) | null }
    & { __typename?: 'ProjectType' }
  ) }
  & { __typename?: 'Query' }
);

export type AddCustomerPromptAProjectFragment = (
  { id: string, organization?: (
    { id: string, logo?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'OrganizationType' }
  ) | null, projectManager?: (
    { id: string, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'UserType' }
  ) | null }
  & { __typename?: 'ProjectType' }
);

export type AddCustomerPromptPmProjectQueryVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type AddCustomerPromptPmProjectQuery = (
  { project: (
    { id: string, organization?: (
      { id: string, logo?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'OrganizationType' }
    ) | null, projectManager?: (
      { id: string, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null }
    & { __typename?: 'ProjectType' }
  ) }
  & { __typename?: 'Query' }
);

export type AssigneeAvatarAssigneeAvatarFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type AssigneeAvatarUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type AttachmentsFileFragment = (
  { id: string, sortOrder?: number | null, url?: string | null, fileName: string, size?: number | null, milestoneName?: string | null, taskName?: string | null, createdAt?: any | null, internalOnly: boolean, deletable?: boolean | null, isExternalHyperlink?: boolean | null, uploader?: (
    { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'UserType' }
  ) | null }
  & { __typename?: 'FileType' }
);

export type AttachmentsUpdateAttachmentSortOrderMutationVariables = Exact<{
  input: UpdateAttachmentSortOrderInput;
}>;


export type AttachmentsUpdateAttachmentSortOrderMutation = (
  { updateAttachmentSortOrder?: (
    { task?: (
      { id: string, files?: Array<(
        { id: string, sortOrder?: number | null, url?: string | null, fileName: string, size?: number | null, milestoneName?: string | null, taskName?: string | null, createdAt?: any | null, internalOnly: boolean, deletable?: boolean | null, isExternalHyperlink?: boolean | null, uploader?: (
          { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'UserType' }
        ) | null }
        & { __typename?: 'FileType' }
      )> | null }
      & { __typename?: 'TaskType' }
    ) | null }
    & { __typename?: 'updateAttachmentSortOrderPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ChangeStatusTaskReturnFragment = (
  { task?: (
    { id: string, status: StatusEnumType }
    & { __typename?: 'TaskType' }
  ) | null }
  & { __typename?: 'TaskReturnType' }
);

export type ChangeStatusDropdownTaskFragment = (
  { id: string, dependentTasks?: Array<(
    { id: string }
    & { __typename?: 'TaskType' }
  )> | null, milestone?: (
    { id: string, sortOrder: number, dependentTasks?: Array<(
      { id: string }
      & { __typename?: 'TaskType' }
    )> | null }
    & { __typename?: 'MilestoneType' }
  ) | null }
  & { __typename?: 'TaskType' }
);

export type ChangeStatusDropdownTemplateFragment = (
  { milestones?: Array<(
    { id: string, sortOrder: number, tasks?: Array<(
      { id: string }
      & { __typename?: 'TaskType' }
    )> | null }
    & { __typename: 'MilestoneType' }
  )> | null }
  & { __typename: 'TemplateType' }
);

export type ChangeStatusDropdownUpdateNodeStatusMutationVariables = Exact<{
  id: Scalars['ID'];
  status: StatusEnumType;
  objectType: StatusObjectEnumType;
}>;


export type ChangeStatusDropdownUpdateNodeStatusMutation = (
  { updateObjectStatus?: (
    { resolveObject?: { __typename?: 'ActionItemType' } | (
      { id: string, status: StatusEnumType }
      & { __typename?: 'ProjectType' }
    ) | (
      { id: string, status: StatusEnumType, completedAt?: any | null, completed?: boolean | null, project?: (
        { id: string, startOn?: any | null, endOn?: any | null, completedAt?: any | null, forecastedEndOn?: any | null, stats?: (
          { totalTasks: number, totalDoneTasks: number, totalAssignedTasks: number, totalTasksWithUnestimatedHoursCount?: number | null, totalActualHours?: number | null, totalInternalEstimatedHours?: number | null }
          & { __typename?: 'ProjectStats' }
        ) | null, profitabilitySummary?: (
          { forecastedCost?: number | null, budgetedCost?: number | null }
          & { __typename?: 'ProjectProfitabilitySummaryType' }
        ) | null }
        & { __typename?: 'ProjectType' }
      ) | null }
      & { __typename?: 'TaskType' }
    ) | null }
    & { __typename?: 'updateObjectStatusPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ChecklistTaskFragment = (
  { id: string, responsibility: TaskResponsibilityEnumType, assignee?: (
    { id: string }
    & { __typename?: 'UserType' }
  ) | null, subtasks?: Array<(
    { id: string, name?: string | null, richName?: string | null, done?: boolean | null, sortOrder?: number | null, groupId?: string | null }
    & { __typename?: 'SubtaskType' }
  )> | null, subtasksGroups?: Array<(
    { id: string, name?: string | null }
    & { __typename?: 'SubtasksGroupType' }
  )> | null, watchers?: Array<(
    { id: string }
    & { __typename?: 'UserType' }
  )> | null }
  & { __typename?: 'TaskType' }
);

export type ChecklistAddSubtaskMutationVariables = Exact<{
  input: CreateSubtaskInput;
}>;


export type ChecklistAddSubtaskMutation = (
  { createSubtask?: (
    { task?: (
      { id: string, incompleteSubtasksCount: number, completeSubtasksCount: number, subtasksGroups?: Array<(
        { id: string, name?: string | null }
        & { __typename?: 'SubtasksGroupType' }
      )> | null, subtasks?: Array<(
        { id: string, name?: string | null, richName?: string | null, done?: boolean | null, sortOrder?: number | null, groupId?: string | null }
        & { __typename?: 'SubtaskType' }
      )> | null }
      & { __typename?: 'TaskType' }
    ) | null }
    & { __typename?: 'createSubtaskPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ChecklistAddGroupMutationVariables = Exact<{
  input: CreateSubtaskGroupInput;
}>;


export type ChecklistAddGroupMutation = (
  { createSubtasksGroup?: (
    { task?: (
      { id: string, subtasksGroups?: Array<(
        { id: string, name?: string | null }
        & { __typename?: 'SubtasksGroupType' }
      )> | null, subtasks?: Array<(
        { id: string, name?: string | null, richName?: string | null, done?: boolean | null, sortOrder?: number | null, groupId?: string | null }
        & { __typename?: 'SubtaskType' }
      )> | null }
      & { __typename?: 'TaskType' }
    ) | null }
    & { __typename?: 'createSubtaskGroupPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ChecklistGroupUpdateSubtasksGroupMutationVariables = Exact<{
  input: UpdateSubtaskGroupInput;
}>;


export type ChecklistGroupUpdateSubtasksGroupMutation = (
  { updateSubtasksGroup?: (
    { success?: boolean | null }
    & { __typename?: 'updateSubtaskGroupPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ChecklistGroupDeleteSubtasksGroupMutationVariables = Exact<{
  input: DeleteSubtaskGroupInput;
}>;


export type ChecklistGroupDeleteSubtasksGroupMutation = (
  { deleteSubtasksGroup?: (
    { task?: (
      { id: string, subtasks?: Array<(
        { id: string, name?: string | null, richName?: string | null, done?: boolean | null, sortOrder?: number | null, groupId?: string | null }
        & { __typename?: 'SubtaskType' }
      )> | null, subtasksGroups?: Array<(
        { id: string, name?: string | null }
        & { __typename?: 'SubtasksGroupType' }
      )> | null }
      & { __typename?: 'TaskType' }
    ) | null }
    & { __typename?: 'deleteSubtaskGroupPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ChecklistItemsTaskFragment = (
  { id: string, assignee?: (
    { id: string }
    & { __typename?: 'UserType' }
  ) | null }
  & { __typename?: 'TaskType' }
);

export type ChecklistPortalUpdateSubTaskNameMutationVariables = Exact<{
  input: UpdateSubTaskNameInput;
}>;


export type ChecklistPortalUpdateSubTaskNameMutation = (
  { updateSubTaskName?: (
    { subtask?: (
      { id: string, name?: string | null, richName?: string | null, done?: boolean | null, sortOrder?: number | null, groupId?: string | null, task?: (
        { id: string, incompleteSubtasksCount: number, completeSubtasksCount: number }
        & { __typename?: 'TaskType' }
      ) | null }
      & { __typename?: 'SubtaskType' }
    ) | null }
    & { __typename?: 'updateSubTaskNamePayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ChecklistPortalToggleMutationVariables = Exact<{
  input: ToggleSubtaskDoneInput;
}>;


export type ChecklistPortalToggleMutation = (
  { toggleSubtask?: (
    { subtask?: (
      { id: string, name?: string | null, richName?: string | null, done?: boolean | null, sortOrder?: number | null, groupId?: string | null, task?: (
        { id: string, incompleteSubtasksCount: number, completeSubtasksCount: number }
        & { __typename?: 'TaskType' }
      ) | null }
      & { __typename?: 'SubtaskType' }
    ) | null }
    & { __typename?: 'toggleSubtaskDonePayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ChecklistPortalDeleteSubtaskMutationVariables = Exact<{
  input: DeleteSubtaskInput;
}>;


export type ChecklistPortalDeleteSubtaskMutation = (
  { deleteSubtask?: (
    { task?: (
      { id: string, incompleteSubtasksCount: number, completeSubtasksCount: number, subtasks?: Array<(
        { id: string, name?: string | null, richName?: string | null, done?: boolean | null, sortOrder?: number | null, groupId?: string | null }
        & { __typename?: 'SubtaskType' }
      )> | null }
      & { __typename?: 'TaskType' }
    ) | null }
    & { __typename?: 'deleteSubtaskPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ConfirmUpdateStatusDialogUpdateNodeStatusMutationVariables = Exact<{
  id: Scalars['ID'];
  status: StatusEnumType;
  objectType: StatusObjectEnumType;
}>;


export type ConfirmUpdateStatusDialogUpdateNodeStatusMutation = (
  { updateObjectStatus?: (
    { resolveObject?: { __typename?: 'ActionItemType' | 'ProjectType' } | (
      { id: string, status: StatusEnumType, project?: (
        { id: string, startOn?: any | null, endOn?: any | null, completedAt?: any | null, forecastedEndOn?: any | null, stats?: (
          { totalTasks: number, totalDoneTasks: number, totalAssignedTasks: number, totalTasksWithUnestimatedHoursCount?: number | null, totalActualHours?: number | null, totalInternalEstimatedHours?: number | null }
          & { __typename?: 'ProjectStats' }
        ) | null, profitabilitySummary?: (
          { forecastedCost?: number | null, budgetedCost?: number | null }
          & { __typename?: 'ProjectProfitabilitySummaryType' }
        ) | null }
        & { __typename?: 'ProjectType' }
      ) | null }
      & { __typename: 'TaskType' }
    ) | null }
    & { __typename?: 'updateObjectStatusPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type CustomerMenuOptionCustomerFragment = (
  { id: string, name: string, email?: string | null, logo?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null }
  & { __typename?: 'CustomerType' }
);

export type DependencyIconMilestoneFragment = (
  { id: string, name: string, completed?: boolean | null, forecastedEndOn?: any | null }
  & { __typename: 'MilestoneType' }
);

export type DependencyIconTaskGroupFragment = (
  { id: string, name: string, completed?: boolean | null, forecastedEndOn?: any | null }
  & { __typename: 'TaskGroupType' }
);

export type DependencyIconTaskFragment = (
  { id: string, name: string, completed?: boolean | null, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null, dueOn?: any | null }
  & { __typename: 'TaskType' }
);

export type DependencyIconTemplateFragment = (
  { id: string, name: string, completed?: boolean | null }
  & { __typename: 'TemplateType' }
);

export type SaveFilterDialogSaveFilterMutationVariables = Exact<{
  input: CreateUserFilterViewInput;
}>;


export type SaveFilterDialogSaveFilterMutation = (
  { createUserFilterView?: (
    { userFilterView?: (
      { id: string, name?: string | null, category?: UserFilterViewEnumType | null, jsonFilterBlob?: string | null }
      & { __typename?: 'UserFilterViewType' }
    ) | null }
    & { __typename?: 'createUserFilterViewPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type StuckTaskMessageDialogUpdateNodeStatusMutationVariables = Exact<{
  id: Scalars['ID'];
  status: StatusEnumType;
  stuckMessage?: InputMaybe<Scalars['String']>;
  objectType: StatusObjectEnumType;
}>;


export type StuckTaskMessageDialogUpdateNodeStatusMutation = (
  { updateObjectStatus?: (
    { resolveObject?: { __typename?: 'ActionItemType' | 'ProjectType' } | (
      { id: string, status: StatusEnumType, project?: (
        { id: string, startOn?: any | null, endOn?: any | null, completedAt?: any | null, forecastedEndOn?: any | null, stats?: (
          { totalTasks: number, totalDoneTasks: number, totalAssignedTasks: number, totalTasksWithUnestimatedHoursCount?: number | null, totalActualHours?: number | null, totalInternalEstimatedHours?: number | null }
          & { __typename?: 'ProjectStats' }
        ) | null, profitabilitySummary?: (
          { forecastedCost?: number | null, budgetedCost?: number | null }
          & { __typename?: 'ProjectProfitabilitySummaryType' }
        ) | null }
        & { __typename?: 'ProjectType' }
      ) | null }
      & { __typename: 'TaskType' }
    ) | null }
    & { __typename?: 'updateObjectStatusPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type AdminTeamFormProjectManagersQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminTeamFormProjectManagersQuery = (
  { projectManagers?: Array<(
    { id: string, firstName?: string | null, lastName?: string | null, role?: UserRoleEnumType | null }
    & { __typename?: 'UserType' }
  )> | null }
  & { __typename?: 'Query' }
);

export type AdminTeamFormAdminTeamMembersQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type AdminTeamFormAdminTeamMembersQuery = (
  { adminTeam?: Array<(
    { id: string, firstName?: string | null, lastName?: string | null, role?: UserRoleEnumType | null }
    & { __typename?: 'UserType' }
  )> | null }
  & { __typename?: 'Query' }
);

export type AdminTeamFormUserQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type AdminTeamFormUserQuery = (
  { user: (
    { id: string, email?: string | null, role?: UserRoleEnumType | null }
    & { __typename?: 'UserType' }
  ) }
  & { __typename?: 'Query' }
);

export type AdminTeamFormUpdateAdminTeamMutationVariables = Exact<{
  data: UpdateAdminTeamInput;
}>;


export type AdminTeamFormUpdateAdminTeamMutation = (
  { updateAdminTeam?: (
    { success?: boolean | null }
    & { __typename?: 'updateAdminTeamPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type EditUserFormUserFragment = (
  { id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, jobRole?: string | null, role?: UserRoleEnumType | null, bio?: string | null, capacity?: number | null, hideEmail?: boolean | null, hidePhone?: boolean | null, calendarLink?: string | null, meetingLink?: string | null, deactivated?: boolean | null, status?: string | null, shouldDisableEmail?: boolean | null, costRate?: number | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, costRateHistory: Array<(
    { costRate: number, date: any }
    & { __typename?: 'CostRateHistoryType' }
  )>, organization?: (
    { id: string, timeTrackingEnabled?: boolean | null, resourceManagementEnabled?: boolean | null, billableUsersCount?: number | null, maxBillableUsers?: number | null, ratePerUser?: number | null, type?: OrganizationTypeEnumType | null, skillCategories: Array<(
      { id: string, name: string, skills: Array<(
        { id: string, name: string, category: (
          { id: string }
          & { __typename?: 'SkillCategory' }
        ) }
        & { __typename: 'Skill' }
      )> }
      & { __typename?: 'SkillCategory' }
    )> }
    & { __typename?: 'OrganizationType' }
  ) | null, skills: Array<(
    { id: string, name: string }
    & { __typename: 'Skill' }
  )> }
  & { __typename?: 'UserType' }
);

export type EditUserFormUserQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type EditUserFormUserQuery = (
  { user: (
    { id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, jobRole?: string | null, role?: UserRoleEnumType | null, bio?: string | null, capacity?: number | null, hideEmail?: boolean | null, hidePhone?: boolean | null, calendarLink?: string | null, meetingLink?: string | null, deactivated?: boolean | null, status?: string | null, shouldDisableEmail?: boolean | null, costRate?: number | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null, costRateHistory: Array<(
      { costRate: number, date: any }
      & { __typename?: 'CostRateHistoryType' }
    )>, organization?: (
      { id: string, timeTrackingEnabled?: boolean | null, resourceManagementEnabled?: boolean | null, billableUsersCount?: number | null, maxBillableUsers?: number | null, ratePerUser?: number | null, type?: OrganizationTypeEnumType | null, skillCategories: Array<(
        { id: string, name: string, skills: Array<(
          { id: string, name: string, category: (
            { id: string }
            & { __typename?: 'SkillCategory' }
          ) }
          & { __typename: 'Skill' }
        )> }
        & { __typename?: 'SkillCategory' }
      )> }
      & { __typename?: 'OrganizationType' }
    ) | null, skills: Array<(
      { id: string, name: string }
      & { __typename: 'Skill' }
    )> }
    & { __typename?: 'UserType' }
  ) }
  & { __typename?: 'Query' }
);

export type EditUserFormUserTasksQueryVariables = Exact<{
  userId: Scalars['ID'];
  listInputs?: InputMaybe<ListInput>;
}>;


export type EditUserFormUserTasksQuery = (
  { userTasksConnections?: (
    { tasks?: Array<(
      { id: string, name: string, description?: string | null, status: StatusEnumType, project?: (
        { id: string, name: string, status: StatusEnumType, organization?: (
          { id: string }
          & { __typename?: 'OrganizationType' }
        ) | null }
        & { __typename?: 'ProjectType' }
      ) | null }
      & { __typename?: 'TaskType' }
    )> | null }
    & { __typename?: 'TaskConnectionType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type EditUserFormProjectsQueryVariables = Exact<{
  projectFilters?: InputMaybe<ProjectFilters>;
  listInputs?: InputMaybe<ListInput>;
}>;


export type EditUserFormProjectsQuery = (
  { projectsConnections?: (
    { projects?: Array<(
      { id: string, name: string, status: StatusEnumType, projectManager?: (
        { id: string, firstName?: string | null, lastName?: string | null, status?: string | null }
        & { __typename?: 'UserType' }
      ) | null, customerV2?: (
        { id: string, name: string, logo?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'CustomerType' }
      ) | null }
      & { __typename?: 'ProjectType' }
    )> | null }
    & { __typename?: 'ProjectConnectionType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type EditUserFormUpdateUserMutationVariables = Exact<{
  user: UpdateUserInput;
}>;


export type EditUserFormUpdateUserMutation = (
  { updateUser?: (
    { user?: (
      { id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, jobRole?: string | null, role?: UserRoleEnumType | null, bio?: string | null, capacity?: number | null, hideEmail?: boolean | null, hidePhone?: boolean | null, calendarLink?: string | null, meetingLink?: string | null, deactivated?: boolean | null, status?: string | null, shouldDisableEmail?: boolean | null, costRate?: number | null, organization?: (
        { id: string, adminUsersCount?: number | null, pmUsersCount?: number | null, guideUsersCount?: number | null, contributorUsersCount?: number | null, taskOwnerUsersCount?: number | null, managerUsersCount?: number | null, timeTrackingEnabled?: boolean | null, resourceManagementEnabled?: boolean | null, billableUsersCount?: number | null, maxBillableUsers?: number | null, ratePerUser?: number | null, type?: OrganizationTypeEnumType | null, skillCategories: Array<(
          { id: string, name: string, skills: Array<(
            { id: string, name: string, category: (
              { id: string }
              & { __typename?: 'SkillCategory' }
            ) }
            & { __typename: 'Skill' }
          )> }
          & { __typename?: 'SkillCategory' }
        )> }
        & { __typename?: 'OrganizationType' }
      ) | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null, costRateHistory: Array<(
        { costRate: number, date: any }
        & { __typename?: 'CostRateHistoryType' }
      )>, skills: Array<(
        { id: string, name: string }
        & { __typename: 'Skill' }
      )> }
      & { __typename?: 'UserType' }
    ) | null }
    & { __typename?: 'updateUserPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type EditUserFormResendInvitationMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type EditUserFormResendInvitationMutation = (
  { resendInviteToUser?: (
    { success?: boolean | null }
    & { __typename?: 'resendInviteToUserPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type SkillsSelectSkillFragment = (
  { id: string, name: string }
  & { __typename: 'Skill' }
);

export type SkillsSelectUserFragment = (
  { id: string, skills: Array<(
    { id: string, name: string }
    & { __typename: 'Skill' }
  )>, organization?: (
    { id: string, resourceManagementEnabled?: boolean | null, skillCategories: Array<(
      { id: string, name: string, skills: Array<(
        { id: string, name: string, category: (
          { id: string }
          & { __typename?: 'SkillCategory' }
        ) }
        & { __typename: 'Skill' }
      )> }
      & { __typename?: 'SkillCategory' }
    )> }
    & { __typename?: 'OrganizationType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type NotificationsFormUserFragment = (
  { id: string, role?: UserRoleEnumType | null, notificationPreferences?: (
    { projectOverviewEmailPref?: ProjectOverviewEmailPrefEnumType | null, taskReminderEmailPref?: TaskReminderEmailPref | null, milestoneCompletedEmailPref?: boolean | null, milestoneCompletedPref?: boolean | null, taskGroupCompletedEmailPref?: boolean | null, taskGroupCompletedPref?: boolean | null, taskUpdatedEmailPref?: boolean | null, taskUpdatedPref?: boolean | null, taskUpdatedDaysPref?: number | null, overdueEmailPref?: boolean | null, overduePref?: boolean | null, stuckEmailPref?: boolean | null, stuckPref?: boolean | null, doneEmailPref?: boolean | null, donePref?: boolean | null, allTasksCompletedPref?: boolean | null, allTasksCompletedEmailPref?: boolean | null, idleProjectDaysPref?: number | null, unsubscribeFromAllEmails?: boolean | null, projectRunningLatePref?: boolean | null, projectRunningLateEmailPref?: boolean | null, taskStartedUnassignedPref?: boolean | null, taskStartedUnassignedEmailPref?: boolean | null, groupedTaskCompletedPref?: boolean | null, groupedTaskCompletedEmailPref?: boolean | null, unaddressedNoteEmailPref?: boolean | null, unaddressedNotePref?: boolean | null }
    & { __typename?: 'NotificationPreferenceType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type NotificationsFormUserQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type NotificationsFormUserQuery = (
  { user: (
    { id: string, role?: UserRoleEnumType | null, notificationPreferences?: (
      { projectOverviewEmailPref?: ProjectOverviewEmailPrefEnumType | null, taskReminderEmailPref?: TaskReminderEmailPref | null, milestoneCompletedEmailPref?: boolean | null, milestoneCompletedPref?: boolean | null, taskGroupCompletedEmailPref?: boolean | null, taskGroupCompletedPref?: boolean | null, taskUpdatedEmailPref?: boolean | null, taskUpdatedPref?: boolean | null, taskUpdatedDaysPref?: number | null, overdueEmailPref?: boolean | null, overduePref?: boolean | null, stuckEmailPref?: boolean | null, stuckPref?: boolean | null, doneEmailPref?: boolean | null, donePref?: boolean | null, allTasksCompletedPref?: boolean | null, allTasksCompletedEmailPref?: boolean | null, idleProjectDaysPref?: number | null, unsubscribeFromAllEmails?: boolean | null, projectRunningLatePref?: boolean | null, projectRunningLateEmailPref?: boolean | null, taskStartedUnassignedPref?: boolean | null, taskStartedUnassignedEmailPref?: boolean | null, groupedTaskCompletedPref?: boolean | null, groupedTaskCompletedEmailPref?: boolean | null, unaddressedNoteEmailPref?: boolean | null, unaddressedNotePref?: boolean | null }
      & { __typename?: 'NotificationPreferenceType' }
    ) | null }
    & { __typename?: 'UserType' }
  ) }
  & { __typename?: 'Query' }
);

export type NotificationsFormUpdateUserMutationVariables = Exact<{
  user: UpdateUserInput;
}>;


export type NotificationsFormUpdateUserMutation = (
  { updateUser?: (
    { user?: (
      { id: string, role?: UserRoleEnumType | null, notificationPreferences?: (
        { projectOverviewEmailPref?: ProjectOverviewEmailPrefEnumType | null, taskReminderEmailPref?: TaskReminderEmailPref | null, milestoneCompletedEmailPref?: boolean | null, milestoneCompletedPref?: boolean | null, taskGroupCompletedEmailPref?: boolean | null, taskGroupCompletedPref?: boolean | null, taskUpdatedEmailPref?: boolean | null, taskUpdatedPref?: boolean | null, taskUpdatedDaysPref?: number | null, overdueEmailPref?: boolean | null, overduePref?: boolean | null, stuckEmailPref?: boolean | null, stuckPref?: boolean | null, doneEmailPref?: boolean | null, donePref?: boolean | null, allTasksCompletedPref?: boolean | null, allTasksCompletedEmailPref?: boolean | null, idleProjectDaysPref?: number | null, unsubscribeFromAllEmails?: boolean | null, projectRunningLatePref?: boolean | null, projectRunningLateEmailPref?: boolean | null, taskStartedUnassignedPref?: boolean | null, taskStartedUnassignedEmailPref?: boolean | null, groupedTaskCompletedPref?: boolean | null, groupedTaskCompletedEmailPref?: boolean | null, unaddressedNoteEmailPref?: boolean | null, unaddressedNotePref?: boolean | null }
        & { __typename?: 'NotificationPreferenceType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null }
    & { __typename?: 'updateUserPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type SetupAccountFormSendSetupEmailMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type SetupAccountFormSendSetupEmailMutation = (
  { sendSetupEmail?: (
    { success?: boolean | null }
    & { __typename?: 'sendSetupEmailPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type FileTableRowUpdateFileMutationVariables = Exact<{
  updateFileInput: UpdateFileInput;
}>;


export type FileTableRowUpdateFileMutation = (
  { updateFile?: (
    { file?: (
      { id: string, deletable?: boolean | null, url?: string | null, fileName: string, size?: number | null, milestoneName?: string | null, taskName?: string | null, createdAt?: any | null, internalOnly: boolean, isExternalHyperlink?: boolean | null, uploader?: (
        { id: string, firstName?: string | null, lastName?: string | null }
        & { __typename?: 'UserType' }
      ) | null, assetable?: { __typename?: 'MilestoneType' | 'ProjectType' | 'TemplateType' } | (
        { id: string, milestone?: (
          { id: string }
          & { __typename?: 'MilestoneType' }
        ) | null, project?: (
          { id: string }
          & { __typename?: 'ProjectType' }
        ) | null, template?: (
          { id: string }
          & { __typename?: 'TemplateType' }
        ) | null }
        & { __typename?: 'TaskType' }
      ) | null }
      & { __typename?: 'FileType' }
    ) | null }
    & { __typename?: 'updateFilePayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type FormTagMultiSelectTagFragment = (
  { id: string, name: string, color: string }
  & { __typename?: 'TagType' }
);

export type MyTasksTasksQueryVariables = Exact<{
  projectId: Scalars['ID'];
  listInputs?: InputMaybe<ListInput>;
}>;


export type MyTasksTasksQuery = (
  { userProjectTasks?: Array<(
    { id: string, name: string, responsibility: TaskResponsibilityEnumType, visibility?: TaskVisibilityEnumType | null, shouldWarnUpdateStatus?: boolean | null, description?: string | null, signOffRequired: boolean, taskType?: TaskTypeEnumType | null, completedAt?: any | null, eventInformation?: string | null, eventDatetime?: any | null, participantCallToAction?: string | null, invitationGroupSentAt?: any | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, status: StatusEnumType, dueOn?: any | null, taskParticipants?: Array<(
      { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
        { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename: 'ImageType' }
        ) | null }
        & { __typename: 'UserType' }
      ) | null }
      & { __typename?: 'TaskParticipantType' }
    )> | null, template?: (
      { id: string, name: string, hardDependency?: boolean | null }
      & { __typename?: 'TemplateType' }
    ) | null, milestone?: (
      { id: string, name: string, sortOrder: number, status: MilestoneStatusEnumType }
      & { __typename?: 'MilestoneType' }
    ) | null, tags?: Array<(
      { id: string, color: string, internalOnly: boolean, name: string }
      & { __typename?: 'TagType' }
    )> | null, project?: (
      { id: string, projectType?: ProjectTypeEnumType | null, organization?: (
        { id: string, name?: string | null, defaultTaskVisibility?: TaskVisibilityEnumType | null }
        & { __typename?: 'OrganizationType' }
      ) | null, customerV2?: (
        { id: string, name: string }
        & { __typename?: 'CustomerType' }
      ) | null, projectManager?: (
        { id: string, firstName?: string | null, lastName?: string | null, calendarLink?: string | null, meetingLink?: string | null }
        & { __typename?: 'UserType' }
      ) | null }
      & { __typename?: 'ProjectType' }
    ) | null, notes?: Array<(
      { id: string, raw: string, createdAt: any, user: (
        { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) }
      & { __typename?: 'NoteType' }
    )> | null, files?: Array<(
      { id: string, fileName: string, size?: number | null, url?: string | null }
      & { __typename?: 'FileType' }
    )> | null, assignee?: (
      { id: string, firstName?: string | null, lastName?: string | null, calendarLink?: string | null, meetingLink?: string | null }
      & { __typename?: 'UserType' }
    ) | null, dependency?: (
      { id: string, name: string, completed?: boolean | null }
      & { __typename?: 'MilestoneType' | 'TaskGroupType' | 'TemplateType' }
    ) | (
      { id: string, name: string, completed?: boolean | null, visibility?: TaskVisibilityEnumType | null, shouldWarnUpdateStatus?: boolean | null }
      & { __typename?: 'TaskType' }
    ) | null, subtasks?: Array<(
      { id: string, name?: string | null, richName?: string | null, done?: boolean | null, sortOrder?: number | null, groupId?: string | null }
      & { __typename?: 'SubtaskType' }
    )> | null, subtasksGroups?: Array<(
      { id: string, name?: string | null }
      & { __typename?: 'SubtasksGroupType' }
    )> | null }
    & { __typename?: 'TaskType' }
  )> | null }
  & { __typename?: 'Query' }
);

export type MyTasksProjectQueryVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type MyTasksProjectQuery = (
  { project: (
    { id: string, name: string, pmDisplayRole?: string | null, currentUserProjectContext?: UserProjectOrganizationTypeEnumType | null, organization?: (
      { id: string }
      & { __typename?: 'OrganizationType' }
    ) | null, projectManager?: (
      { firstName?: string | null, lastName?: string | null }
      & { __typename?: 'UserType' }
    ) | null }
    & { __typename?: 'ProjectType' }
  ), projectTeam: Array<(
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, projectContext?: UserProjectOrganizationTypeEnumType | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null, organization?: (
      { id: string }
      & { __typename?: 'OrganizationType' }
    ) | null }
    & { __typename?: 'UserType' }
  )> }
  & { __typename?: 'Query' }
);

export type EditTaskDrawerTaskFragment = (
  { id: string, actualHours?: number | null, billableHours?: number | null, nonBillableHours?: number | null, assignmentEmailSentAt?: any | null, completedAt?: any | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, description?: string | null, dueOn?: any | null, duration?: number | null, estimatedHours?: number | null, estimatedPoints?: number | null, eventDatetime?: any | null, eventInformation?: string | null, invitationGroupSentAt?: any | null, meetingLength?: number | null, mustStartOn?: any | null, mustStartOnRequired?: boolean | null, jiraTaskLink?: string | null, name: string, participantCallToAction?: string | null, priority?: PriorityEnumType | null, responsibility: TaskResponsibilityEnumType, shouldWarnUpdateStatus?: boolean | null, signOffRequired: boolean, sortOrder?: number | null, startOn?: any | null, status: StatusEnumType, taskType?: TaskTypeEnumType | null, visibility?: TaskVisibilityEnumType | null, jiraSync?: boolean | null, tags?: Array<(
    { id: string }
    & { __typename?: 'TagType' }
  )> | null, skill?: (
    { id: string }
    & { __typename?: 'Skill' }
  ) | null, skills?: Array<(
    { id: string }
    & { __typename?: 'Skill' }
  )> | null, assignee?: (
    { id: string, firstName?: string | null, lastName?: string | null, calendarLink?: string | null, meetingLink?: string | null, role?: UserRoleEnumType | null, projectContext?: UserProjectOrganizationTypeEnumType | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'UserType' }
  ) | null, creator?: (
    { id: string }
    & { __typename?: 'UserType' }
  ) | null, signer?: (
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
    & { __typename?: 'SignerType' }
  ) | null, jiraTask?: (
    { id: string, externalId?: string | null, externalProjectId?: string | null, externalTypeId?: string | null, components?: Array<string> | null, createdInJira?: any | null }
    & { __typename?: 'JiraIssueType' }
  ) | null, files?: Array<(
    { id: string, sortOrder?: number | null, url?: string | null, fileName: string, size?: number | null, milestoneName?: string | null, taskName?: string | null, createdAt?: any | null, internalOnly: boolean, deletable?: boolean | null, isExternalHyperlink?: boolean | null, uploader?: (
      { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null }
    & { __typename?: 'FileType' }
  )> | null, milestone?: (
    { id: string, sortOrder: number, isFirstOfTemplate: boolean, isFirstOfProject: boolean, template: (
      { id: string, hardDependency?: boolean | null }
      & { __typename?: 'TemplateType' }
    ) }
    & { __typename?: 'MilestoneType' }
  ) | null, project?: (
    { id: string, name: string, status: StatusEnumType, currentUserProjectContext?: UserProjectOrganizationTypeEnumType | null, pmDisplayRole?: string | null, projectManager?: (
      { id: string, firstName?: string | null, lastName?: string | null, calendarLink?: string | null, meetingLink?: string | null }
      & { __typename?: 'UserType' }
    ) | null, organization?: (
      { id: string, name?: string | null, defaultTaskVisibility?: TaskVisibilityEnumType | null, timeTrackingEnabled?: boolean | null, resourceManagementEnabled?: boolean | null, internalNotesDefault: boolean }
      & { __typename?: 'OrganizationType' }
    ) | null, customerV2?: (
      { id: string, name: string }
      & { __typename?: 'CustomerType' }
    ) | null }
    & { __typename?: 'ProjectType' }
  ) | null, dependency?: (
    { id: string, name: string, completed?: boolean | null }
    & { __typename?: 'MilestoneType' | 'TaskGroupType' | 'TemplateType' }
  ) | (
    { id: string, name: string, completed?: boolean | null, shouldWarnUpdateStatus?: boolean | null }
    & { __typename?: 'TaskType' }
  ) | null, subtasks?: Array<(
    { id: string, name?: string | null, richName?: string | null, done?: boolean | null, sortOrder?: number | null, groupId?: string | null }
    & { __typename?: 'SubtaskType' }
  )> | null, subtasksGroups?: Array<(
    { id: string, name?: string | null }
    & { __typename?: 'SubtasksGroupType' }
  )> | null, watchers?: Array<(
    { id: string }
    & { __typename?: 'UserType' }
  )> | null, taskParticipants?: Array<(
    { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
      { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, capacity?: number | null, projectsCount?: number | null, projectContext?: UserProjectOrganizationTypeEnumType | null, organizationName?: string | null, organization?: (
        { id: string, name?: string | null }
        & { __typename?: 'OrganizationType' }
      ) | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null, displayOrganization?: (
        { name: string }
        & { __typename?: 'DisplayOrganizationType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null }
    & { __typename?: 'TaskParticipantType' }
  )> | null, participantsSelectAll?: (
    { internal: boolean, customer: boolean, thirdParty: boolean }
    & { __typename: 'TaskParticipantSelectAllType' }
  ) | null, taskGroup?: (
    { id: string }
    & { __typename?: 'TaskGroupType' }
  ) | null }
  & { __typename?: 'TaskType' }
);

export type MyTasksEditTaskDrawerProjectSnapshotFragment = (
  { id: string, startOn?: any | null, endOn?: any | null, completedAt?: any | null, forecastedEndOn?: any | null }
  & { __typename?: 'ProjectType' }
);

export type MyTasksEditTaskDrawerProjectStatsFragment = (
  { totalTasks: number, totalDoneTasks: number, totalAssignedTasks: number, totalTasksWithUnestimatedHoursCount?: number | null, totalActualHours?: number | null, totalInternalEstimatedHours?: number | null }
  & { __typename?: 'ProjectStats' }
);

export type MyTasksEditTaskDrawerUpdateTaskGroupTaskMutationVariables = Exact<{
  task: UpdateTaskInput;
}>;


export type MyTasksEditTaskDrawerUpdateTaskGroupTaskMutation = (
  { updateTaskGroupTask?: (
    { taskReturnData?: (
      { task?: (
        { id: string, taskType?: TaskTypeEnumType | null, name: string, description?: string | null, startOn?: any | null, dueOn?: any | null, estimatedHours?: number | null, actualHours?: number | null, billableHours?: number | null, nonBillableHours?: number | null, estimatedPoints?: number | null, duration?: number | null, sortOrder?: number | null, priority?: PriorityEnumType | null, responsibility: TaskResponsibilityEnumType, signOffRequired: boolean, status: StatusEnumType, shouldWarnUpdateStatus?: boolean | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, eventDatetime?: any | null, participantCallToAction?: string | null, invitationGroupSentAt?: any | null, assignmentEmailSentAt?: any | null, completedAt?: any | null, eventInformation?: string | null, meetingLength?: number | null, mustStartOn?: any | null, mustStartOnRequired?: boolean | null, jiraTaskLink?: string | null, visibility?: TaskVisibilityEnumType | null, jiraSync?: boolean | null, dependency?: (
          { id: string, completed?: boolean | null, name: string, tasks?: Array<(
            { id: string, shouldWarnUpdateStatus?: boolean | null }
            & { __typename?: 'TaskType' }
          )> | null }
          & { __typename?: 'MilestoneType' | 'TaskGroupType' }
        ) | (
          { id: string, completed?: boolean | null, shouldWarnUpdateStatus?: boolean | null, name: string }
          & { __typename?: 'TaskType' }
        ) | (
          { id: string, completed?: boolean | null, name: string }
          & { __typename?: 'TemplateType' }
        ) | null, assignee?: (
          { id: string, firstName?: string | null, lastName?: string | null, jobRole?: string | null, calendarLink?: string | null, meetingLink?: string | null, role?: UserRoleEnumType | null, projectContext?: UserProjectOrganizationTypeEnumType | null, avatar?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'UserType' }
        ) | null, signer?: (
          { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
          & { __typename?: 'SignerType' }
        ) | null, notes?: Array<(
          { id: string }
          & { __typename?: 'NoteType' }
        )> | null, jiraTask?: (
          { id: string, externalId?: string | null, externalProjectId?: string | null, externalTypeId?: string | null, components?: Array<string> | null, createdInJira?: any | null }
          & { __typename?: 'JiraIssueType' }
        ) | null, files?: Array<(
          { id: string, sortOrder?: number | null, url?: string | null, fileName: string, size?: number | null, milestoneName?: string | null, taskName?: string | null, createdAt?: any | null, internalOnly: boolean, deletable?: boolean | null, isExternalHyperlink?: boolean | null, uploader?: (
            { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
              { originalUrl?: string | null }
              & { __typename?: 'ImageType' }
            ) | null }
            & { __typename?: 'UserType' }
          ) | null }
          & { __typename?: 'FileType' }
        )> | null, subtasks?: Array<(
          { id: string, name?: string | null, richName?: string | null, done?: boolean | null, sortOrder?: number | null, groupId?: string | null }
          & { __typename?: 'SubtaskType' }
        )> | null, taskParticipants?: Array<(
          { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
            { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, capacity?: number | null, projectsCount?: number | null, projectContext?: UserProjectOrganizationTypeEnumType | null, organizationName?: string | null, organization?: (
              { id: string, name?: string | null }
              & { __typename?: 'OrganizationType' }
            ) | null, avatar?: (
              { originalUrl?: string | null }
              & { __typename?: 'ImageType' }
            ) | null, displayOrganization?: (
              { name: string }
              & { __typename?: 'DisplayOrganizationType' }
            ) | null }
            & { __typename?: 'UserType' }
          ) | null }
          & { __typename?: 'TaskParticipantType' }
        )> | null, template?: (
          { id: string, duration?: number | null }
          & { __typename?: 'TemplateType' }
        ) | null, project?: (
          { id: string, name: string, status: StatusEnumType, currentUserProjectContext?: UserProjectOrganizationTypeEnumType | null, pmDisplayRole?: string | null, startOn?: any | null, endOn?: any | null, completedAt?: any | null, forecastedEndOn?: any | null, stats?: (
            { totalTasks: number, totalDoneTasks: number, totalAssignedTasks: number, totalTasksWithUnestimatedHoursCount?: number | null, totalActualHours?: number | null, totalInternalEstimatedHours?: number | null }
            & { __typename?: 'ProjectStats' }
          ) | null, profitabilitySummary?: (
            { forecastedCost?: number | null, budgetedCost?: number | null }
            & { __typename?: 'ProjectProfitabilitySummaryType' }
          ) | null, projectManager?: (
            { id: string, firstName?: string | null, lastName?: string | null, calendarLink?: string | null, meetingLink?: string | null }
            & { __typename?: 'UserType' }
          ) | null, organization?: (
            { id: string, name?: string | null, defaultTaskVisibility?: TaskVisibilityEnumType | null, timeTrackingEnabled?: boolean | null, resourceManagementEnabled?: boolean | null, internalNotesDefault: boolean }
            & { __typename?: 'OrganizationType' }
          ) | null, customerV2?: (
            { id: string, name: string }
            & { __typename?: 'CustomerType' }
          ) | null }
          & { __typename?: 'ProjectType' }
        ) | null, tags?: Array<(
          { id: string }
          & { __typename?: 'TagType' }
        )> | null, skill?: (
          { id: string }
          & { __typename?: 'Skill' }
        ) | null, skills?: Array<(
          { id: string }
          & { __typename?: 'Skill' }
        )> | null, creator?: (
          { id: string }
          & { __typename?: 'UserType' }
        ) | null, milestone?: (
          { id: string, sortOrder: number, isFirstOfTemplate: boolean, isFirstOfProject: boolean, template: (
            { id: string, hardDependency?: boolean | null }
            & { __typename?: 'TemplateType' }
          ) }
          & { __typename?: 'MilestoneType' }
        ) | null, subtasksGroups?: Array<(
          { id: string, name?: string | null }
          & { __typename?: 'SubtasksGroupType' }
        )> | null, watchers?: Array<(
          { id: string }
          & { __typename?: 'UserType' }
        )> | null, participantsSelectAll?: (
          { internal: boolean, customer: boolean, thirdParty: boolean }
          & { __typename: 'TaskParticipantSelectAllType' }
        ) | null, taskGroup?: (
          { id: string }
          & { __typename?: 'TaskGroupType' }
        ) | null }
        & { __typename?: 'TaskType' }
      ) | null }
      & { __typename?: 'TaskReturnType' }
    ) | null }
    & { __typename?: 'updateTaskGroupTaskPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type MyTasksEditTaskDrawerGetAvailableTaskTagsQueryVariables = Exact<{
  taggableId: Scalars['ID'];
  taggableType: TaggableEnumType;
}>;


export type MyTasksEditTaskDrawerGetAvailableTaskTagsQuery = (
  { availableTags?: Array<(
    { id: string, color: string, name: string, internalOnly: boolean }
    & { __typename?: 'TagType' }
  )> | null }
  & { __typename?: 'Query' }
);

export type MyTasksEditTaskDrawerProjectTeamQueryVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type MyTasksEditTaskDrawerProjectTeamQuery = (
  { projectTeam: Array<(
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, projectContext?: UserProjectOrganizationTypeEnumType | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null, organization?: (
      { id: string }
      & { __typename?: 'OrganizationType' }
    ) | null }
    & { __typename?: 'UserType' }
  )> }
  & { __typename?: 'Query' }
);

export type MyTasksEditTaskDrawerCurrentUserSkillsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyTasksEditTaskDrawerCurrentUserSkillsQuery = (
  { currentUser?: (
    { skills: Array<(
      { id: string }
      & { __typename?: 'Skill' }
    )> }
    & { __typename?: 'UserType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type MyTasksEditTaskDrawerRemoveWatcherMutationVariables = Exact<{
  taskId: Scalars['ID'];
  watcherId: Scalars['ID'];
}>;


export type MyTasksEditTaskDrawerRemoveWatcherMutation = (
  { removeWatcher?: (
    { success?: boolean | null }
    & { __typename?: 'removeWatcherPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type AvatarListUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type PaginatedTagMultiSelectTagFragment = (
  { id: string, name: string, color: string }
  & { __typename?: 'TagType' }
);

export type ProjectManagerCardProjectFragment = (
  { id: string, pmDisplayRole?: string | null, pmNote?: string | null, pmNoteInternalOnly?: boolean | null, currentUserProjectContext?: UserProjectOrganizationTypeEnumType | null, projectManager?: (
    { id: string, firstName?: string | null, calendarLink?: string | null, lastName?: string | null, phone?: string | null, email?: string | null, bio?: string | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'UserType' }
  ) | null }
  & { __typename?: 'ProjectType' }
);

export type SummaryCardProjectFragment = (
  { id: string, firstActiveTemplate?: string | null, currentUserProjectContext?: UserProjectOrganizationTypeEnumType | null, status: StatusEnumType, startOn?: any | null, endOn?: any | null, completedAt?: any | null, forecastedEndOn?: any | null, projectType?: ProjectTypeEnumType | null, displayOrganization?: (
    { name: string, logo?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'DisplayOrganizationType' }
  ) | null, customerV2?: (
    { id: string, name: string, logo?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'CustomerType' }
  ) | null, templates?: Array<(
    { id: string, name: string, milestones?: Array<(
      { id: string, name: string, active: boolean }
      & { __typename?: 'MilestoneType' }
    )> | null }
    & { __typename?: 'TemplateType' }
  )> | null, files?: Array<(
    { id: string }
    & { __typename?: 'FileType' }
  )> | null, tags?: Array<(
    { id: string, color: string, name: string, internalOnly: boolean }
    & { __typename?: 'TagType' }
  )> | null, organization?: (
    { id: string, showShareableLink?: boolean | null }
    & { __typename?: 'OrganizationType' }
  ) | null }
  & { __typename?: 'ProjectType' }
);

export type SummaryCardProjectStatsFragment = (
  { id: string, totalTasks: number, totalDoneTasks: number, totalSignOffTasks: number, totalStuckTasks: number, totalWorkingOnItTasks: number, totalNotStartedTasks: number, totalAssignedTasks: number, totalCustomerOverdueTasks: number, totalThirdPartyOverdueTasks: number, totalInternalOverdueTasks: number }
  & { __typename?: 'ProjectStats' }
);

export type TeamCardProjectTeamQueryVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type TeamCardProjectTeamQuery = (
  { projectTeam: Array<(
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, projectContext?: UserProjectOrganizationTypeEnumType | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'UserType' }
  )> }
  & { __typename?: 'Query' }
);

export type ProjectPlanTemplateUpdatedV2SubscriptionVariables = Exact<{
  templateId: Scalars['ID'];
}>;


export type ProjectPlanTemplateUpdatedV2Subscription = (
  { templateUpdated?: (
    { template?: (
      { id: string, summaryBank: (
        { id: string, totalMilestones: number, totalTasks: number, totalCompleteTasks: number, totalPoints: number, totalEstimatedHours: number, totalInternalTasks: number, totalInternalPoints: number, totalInternalHours: number, totalCustomerTasks: number, totalCustomerPoints: number, totalCustomerHours: number, totalThirdPartyTasks: number, totalThirdPartyPoints: number, totalThirdPartyHours: number, totalAssignedTasks: number, totalActualHours: number, totalRemainingHours: number, totalInternalRemainingHours: number, totalInternalActualHours: number, totalCustomerRemainingHours: number, totalCustomerActualHours: number, totalThirdPartyRemainingHours: number, totalThirdPartyActualHours: number, totalInternalLoggedHours: number, totalInternalLoggedBillableHours: number, totalInternalLoggedNonBillableHours: number, totalInternalRemainingPurchasedHours: number }
        & { __typename?: 'TemplateStats' }
      ), milestones?: Array<(
        { id: string, sortOrder: number, name: string, startedOn?: any | null, forecastedEndOn?: any | null, completedAt?: any | null, completed?: boolean | null, active: boolean, tasksAndGroups?: Array<(
          { id: string, name: string, taskCount: number, sortOrder?: number | null, startedOn?: any | null, forecastedEndOn?: any | null, completedAt?: any | null, completed?: boolean | null, tasks?: Array<(
            { id: string, sortOrder?: number | null, status: StatusEnumType, visibility?: TaskVisibilityEnumType | null, responsibility: TaskResponsibilityEnumType, name: string, taskType?: TaskTypeEnumType | null, signOffRequired: boolean, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completedAt?: any | null, completed?: boolean | null, taskGroup?: (
              { id: string }
              & { __typename?: 'TaskGroupType' }
            ) | null, template?: (
              { id: string, hardDependency?: boolean | null }
              & { __typename?: 'TemplateType' }
            ) | null, milestone?: (
              { id: string, sortOrder: number, dependentTasks?: Array<(
                { id: string }
                & { __typename?: 'TaskType' }
              )> | null }
              & { __typename?: 'MilestoneType' }
            ) | null, signer?: (
              { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
              & { __typename?: 'SignerType' }
            ) | null, assignee?: (
              { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
                { originalUrl?: string | null }
                & { __typename?: 'ImageType' }
              ) | null }
              & { __typename?: 'UserType' }
            ) | null, dependency?: (
              { id: string, completed?: boolean | null, forecastedEndOn?: any | null, name: string }
              & { __typename: 'MilestoneType' | 'TaskGroupType' }
            ) | (
              { id: string, completed?: boolean | null, dueOn?: any | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null }
              & { __typename: 'TaskType' }
            ) | (
              { id: string, completed?: boolean | null, name: string }
              & { __typename: 'TemplateType' }
            ) | null, tags?: Array<(
              { id: string, color: string, name: string, internalOnly: boolean }
              & { __typename?: 'TagType' }
            )> | null, taskParticipants?: Array<(
              { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
                { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
                  { originalUrl?: string | null }
                  & { __typename?: 'ImageType' }
                ) | null }
                & { __typename?: 'UserType' }
              ) | null }
              & { __typename?: 'TaskParticipantType' }
            )> | null, dependentTasks?: Array<(
              { id: string }
              & { __typename?: 'TaskType' }
            )> | null }
            & { __typename?: 'TaskType' }
          )> | null, summaryBank: (
            { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
            & { __typename?: 'TaskGroupStats' }
          ) }
          & { __typename: 'TaskGroupType' }
        ) | (
          { id: string, sortOrder?: number | null, status: StatusEnumType, visibility?: TaskVisibilityEnumType | null, responsibility: TaskResponsibilityEnumType, name: string, taskType?: TaskTypeEnumType | null, signOffRequired: boolean, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completedAt?: any | null, completed?: boolean | null, template?: (
            { id: string, hardDependency?: boolean | null }
            & { __typename?: 'TemplateType' }
          ) | null, milestone?: (
            { id: string, sortOrder: number, dependentTasks?: Array<(
              { id: string }
              & { __typename?: 'TaskType' }
            )> | null }
            & { __typename?: 'MilestoneType' }
          ) | null, signer?: (
            { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
            & { __typename?: 'SignerType' }
          ) | null, assignee?: (
            { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
              { originalUrl?: string | null }
              & { __typename?: 'ImageType' }
            ) | null }
            & { __typename?: 'UserType' }
          ) | null, dependency?: (
            { id: string, completed?: boolean | null, forecastedEndOn?: any | null, name: string }
            & { __typename: 'MilestoneType' | 'TaskGroupType' }
          ) | (
            { id: string, completed?: boolean | null, dueOn?: any | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null }
            & { __typename: 'TaskType' }
          ) | (
            { id: string, completed?: boolean | null, name: string }
            & { __typename: 'TemplateType' }
          ) | null, tags?: Array<(
            { id: string, color: string, name: string, internalOnly: boolean }
            & { __typename?: 'TagType' }
          )> | null, taskParticipants?: Array<(
            { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
              { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
                { originalUrl?: string | null }
                & { __typename?: 'ImageType' }
              ) | null }
              & { __typename?: 'UserType' }
            ) | null }
            & { __typename?: 'TaskParticipantType' }
          )> | null, taskGroup?: (
            { id: string }
            & { __typename?: 'TaskGroupType' }
          ) | null, dependentTasks?: Array<(
            { id: string }
            & { __typename?: 'TaskType' }
          )> | null }
          & { __typename?: 'TaskType' }
        )> | null, template: (
          { id: string, hardDependency?: boolean | null }
          & { __typename?: 'TemplateType' }
        ), summaryBank: (
          { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
          & { __typename?: 'MilestoneStats' }
        ), dependentTasks?: Array<(
          { id: string }
          & { __typename?: 'TaskType' }
        )> | null }
        & { __typename?: 'MilestoneType' }
      )> | null }
      & { __typename?: 'TemplateType' }
    ) | null }
    & { __typename?: 'TemplateUpdatePayloadType' }
  ) | null }
  & { __typename?: 'Subscription' }
);

export type ProjectPlanTemplateFragment = (
  { id: string, name: string, sortOrder?: number | null, active: boolean, hardDependency?: boolean | null, completedAt?: any | null, summaryBank: (
    { totalCompleteTasks: number, totalTasks: number, totalAssignedTasks: number, totalActualHours: number, totalEstimatedHours: number, totalRemainingHours: number, totalInternalHours: number, totalCustomerHours: number, totalThirdPartyHours: number, totalInternalRemainingHours: number, totalInternalActualHours: number, totalCustomerRemainingHours: number, totalCustomerActualHours: number, totalThirdPartyRemainingHours: number, totalThirdPartyActualHours: number, totalInternalLoggedHours: number, totalInternalLoggedBillableHours: number, totalInternalLoggedNonBillableHours: number, totalInternalRemainingPurchasedHours: number }
    & { __typename?: 'TemplateStats' }
  ), organization: (
    { id: string }
    & { __typename?: 'OrganizationType' }
  ) }
  & { __typename?: 'TemplateType' }
);

export type ProjectPlanProjectSnapshotFragment = (
  { id: string, startOn?: any | null, endOn?: any | null, completedAt?: any | null, forecastedEndOn?: any | null }
  & { __typename?: 'ProjectType' }
);

export type ProjectPlanProjectStatsFragment = (
  { totalTasks: number, totalDoneTasks: number, totalAssignedTasks: number, totalTasksWithUnestimatedHoursCount?: number | null, totalActualHours?: number | null, totalInternalEstimatedHours?: number | null }
  & { __typename?: 'ProjectStats' }
);

export type ProjectPlanProjectFragment = (
  { id: string, creating?: boolean | null, firstActiveTemplate?: string | null, pmDisplayRole?: string | null, deletedAt?: any | null, archivedAt?: any | null, status: StatusEnumType, organization?: (
    { id: string, defaultTaskVisibility?: TaskVisibilityEnumType | null, timeTrackingEnabled?: boolean | null, resourceManagementEnabled?: boolean | null }
    & { __typename?: 'OrganizationType' }
  ) | null, templates?: Array<(
    { id: string, name: string, sortOrder?: number | null, active: boolean, hardDependency?: boolean | null, completedAt?: any | null, summaryBank: (
      { totalCompleteTasks: number, totalTasks: number, totalAssignedTasks: number, totalActualHours: number, totalEstimatedHours: number, totalRemainingHours: number, totalInternalHours: number, totalCustomerHours: number, totalThirdPartyHours: number, totalInternalRemainingHours: number, totalInternalActualHours: number, totalCustomerRemainingHours: number, totalCustomerActualHours: number, totalThirdPartyRemainingHours: number, totalThirdPartyActualHours: number, totalInternalLoggedHours: number, totalInternalLoggedBillableHours: number, totalInternalLoggedNonBillableHours: number, totalInternalRemainingPurchasedHours: number }
      & { __typename?: 'TemplateStats' }
    ), organization: (
      { id: string }
      & { __typename?: 'OrganizationType' }
    ) }
    & { __typename?: 'TemplateType' }
  )> | null, projectBillRate?: (
    { rateType?: RateTypeEnum | null, hours?: number | null }
    & { __typename?: 'ProjectBillRateType' }
  ) | null }
  & { __typename?: 'ProjectType' }
);

type ProjectPlanStatsMilestoneStatsTemplateStatsFragment = { __typename?: 'MilestoneStats' | 'TemplateStats' };

type ProjectPlanStatsProjectStatsFragment = (
  { id: string, totalTasks: number, totalDoneTasks: number, totalSignOffTasks: number, totalStuckTasks: number, totalWorkingOnItTasks: number, totalNotStartedTasks: number, totalAssignedTasks: number, totalCustomerOverdueTasks: number, totalThirdPartyOverdueTasks: number, totalInternalOverdueTasks: number }
  & { __typename?: 'ProjectStats' }
);

export type ProjectPlanStatsFragment = ProjectPlanStatsMilestoneStatsTemplateStatsFragment | ProjectPlanStatsProjectStatsFragment;

export type ProjectPlanUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, projectContext?: UserProjectOrganizationTypeEnumType | null, role?: UserRoleEnumType | null, jobRole?: string | null, organizationName?: string | null, skills: Array<(
    { id: string }
    & { __typename?: 'Skill' }
  )>, organization?: (
    { id: string, type?: OrganizationTypeEnumType | null, name?: string | null }
    & { __typename?: 'OrganizationType' }
  ) | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, displayOrganization?: (
    { name: string }
    & { __typename?: 'DisplayOrganizationType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type ProjectPlanCreateTaskV2MutationVariables = Exact<{
  taskInputs: CreateTaskInput;
}>;


export type ProjectPlanCreateTaskV2Mutation = (
  { createTask?: (
    { taskReturnData?: (
      { task?: (
        { id: string, status: StatusEnumType, priority?: PriorityEnumType | null, responsibility: TaskResponsibilityEnumType, taskType?: TaskTypeEnumType | null, visibility?: TaskVisibilityEnumType | null, completedAt?: any | null, name: string, signOffRequired: boolean, sortOrder?: number | null, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completed?: boolean | null, milestone?: (
          { startedOn?: any | null, forecastedEndOn?: any | null, completedAt?: any | null, completed?: boolean | null, id: string, sortOrder: number, summaryBank: (
            { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
            & { __typename?: 'MilestoneStats' }
          ), dependentTasks?: Array<(
            { id: string }
            & { __typename?: 'TaskType' }
          )> | null }
          & { __typename?: 'MilestoneType' }
        ) | null, taskGroup?: (
          { startedOn?: any | null, forecastedEndOn?: any | null, completedAt?: any | null, completed?: boolean | null, id: string, summaryBank: (
            { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
            & { __typename?: 'TaskGroupStats' }
          ) }
          & { __typename?: 'TaskGroupType' }
        ) | null, template?: (
          { id: string, hardDependency?: boolean | null, summaryBank: (
            { id: string, totalMilestones: number, totalTasks: number, totalCompleteTasks: number, totalPoints: number, totalEstimatedHours: number, totalInternalTasks: number, totalInternalPoints: number, totalInternalHours: number, totalCustomerTasks: number, totalCustomerPoints: number, totalCustomerHours: number, totalThirdPartyTasks: number, totalThirdPartyPoints: number, totalThirdPartyHours: number, totalAssignedTasks: number, totalActualHours: number, totalRemainingHours: number, totalInternalRemainingHours: number, totalInternalActualHours: number, totalCustomerRemainingHours: number, totalCustomerActualHours: number, totalThirdPartyRemainingHours: number, totalThirdPartyActualHours: number, totalInternalLoggedHours: number, totalInternalLoggedBillableHours: number, totalInternalLoggedNonBillableHours: number, totalInternalRemainingPurchasedHours: number }
            & { __typename?: 'TemplateStats' }
          ) }
          & { __typename?: 'TemplateType' }
        ) | null, project?: (
          { id: string, startOn?: any | null, endOn?: any | null, completedAt?: any | null, forecastedEndOn?: any | null, stats?: (
            { totalTasks: number, totalDoneTasks: number, totalAssignedTasks: number, totalTasksWithUnestimatedHoursCount?: number | null, totalActualHours?: number | null, totalInternalEstimatedHours?: number | null }
            & { __typename?: 'ProjectStats' }
          ) | null, profitabilitySummary?: (
            { forecastedCost?: number | null, budgetedCost?: number | null }
            & { __typename?: 'ProjectProfitabilitySummaryType' }
          ) | null }
          & { __typename?: 'ProjectType' }
        ) | null, signer?: (
          { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
          & { __typename?: 'SignerType' }
        ) | null, assignee?: (
          { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'UserType' }
        ) | null, dependency?: (
          { id: string, completed?: boolean | null, forecastedEndOn?: any | null, name: string }
          & { __typename: 'MilestoneType' | 'TaskGroupType' }
        ) | (
          { id: string, completed?: boolean | null, dueOn?: any | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null }
          & { __typename: 'TaskType' }
        ) | (
          { id: string, completed?: boolean | null, name: string }
          & { __typename: 'TemplateType' }
        ) | null, tags?: Array<(
          { id: string, color: string, name: string, internalOnly: boolean }
          & { __typename?: 'TagType' }
        )> | null, taskParticipants?: Array<(
          { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
            { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
              { originalUrl?: string | null }
              & { __typename?: 'ImageType' }
            ) | null }
            & { __typename?: 'UserType' }
          ) | null }
          & { __typename?: 'TaskParticipantType' }
        )> | null, dependentTasks?: Array<(
          { id: string }
          & { __typename?: 'TaskType' }
        )> | null }
        & { __typename?: 'TaskType' }
      ) | null }
      & { __typename?: 'TaskReturnType' }
    ) | null }
    & { __typename?: 'createTaskPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ProjectPlanReadNotificationErrorMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProjectPlanReadNotificationErrorMutation = (
  { readNotificationError?: (
    { success?: boolean | null }
    & { __typename?: 'readNotificationErrorPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ProjectPlanMarkAllErrorsReadMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProjectPlanMarkAllErrorsReadMutation = (
  { markAllErrorsRead?: (
    { success?: boolean | null }
    & { __typename?: 'markAllErrorsReadPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ProjectPlanProjectErrorsQueryVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type ProjectPlanProjectErrorsQuery = (
  { notificationErrors?: (
    { totalErrors: number, notifications: Array<(
      { id: string, text?: string | null }
      & { __typename?: 'Notification' }
    )> }
    & { __typename?: 'NotificationError' }
  ) | null }
  & { __typename?: 'Query' }
);

export type ProjectBulkEditDrawerTaskFragment = (
  { id: string, status: StatusEnumType, priority?: PriorityEnumType | null, responsibility: TaskResponsibilityEnumType, taskType?: TaskTypeEnumType | null, visibility?: TaskVisibilityEnumType | null, completedAt?: any | null }
  & { __typename?: 'TaskType' }
);

export type ProjectBulkEditDrawerUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, projectContext?: UserProjectOrganizationTypeEnumType | null, role?: UserRoleEnumType | null, jobRole?: string | null, organizationName?: string | null, skills: Array<(
    { id: string }
    & { __typename?: 'Skill' }
  )>, organization?: (
    { id: string, type?: OrganizationTypeEnumType | null, name?: string | null }
    & { __typename?: 'OrganizationType' }
  ) | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, displayOrganization?: (
    { name: string }
    & { __typename?: 'DisplayOrganizationType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type ProjectBulkEditDrawerProjectFragment = (
  { id: string, organization?: (
    { resourceManagementEnabled?: boolean | null }
    & { __typename?: 'OrganizationType' }
  ) | null }
  & { __typename?: 'ProjectType' }
);

export type ProjectBulkEditDrawerMilestoneFragment = (
  { id: string }
  & { __typename?: 'MilestoneType' }
);

export type ProjectBulkEditDrawerTemplateFragment = (
  { id: string, organization: (
    { id: string }
    & { __typename?: 'OrganizationType' }
  ) }
  & { __typename?: 'TemplateType' }
);

export type ProjectBulkEditFormTaskGroupDependenciesConflictV2QueryVariables = Exact<{
  taskGroupId: Scalars['ID'];
  taskIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ProjectBulkEditFormTaskGroupDependenciesConflictV2Query = (
  { taskGroupDependenciesConflict: boolean }
  & { __typename?: 'Query' }
);

export type BulkEditFormUserFragment = (
  { id: string, skills: Array<(
    { id: string, name: string }
    & { __typename: 'Skill' }
  )>, organization?: (
    { id: string, resourceManagementEnabled?: boolean | null, skillCategories: Array<(
      { id: string, name: string, skills: Array<(
        { id: string, name: string, category: (
          { id: string }
          & { __typename?: 'SkillCategory' }
        ) }
        & { __typename: 'Skill' }
      )> }
      & { __typename?: 'SkillCategory' }
    )> }
    & { __typename?: 'OrganizationType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type ProjectBulkEditFormBulkEditTasksMutationVariables = Exact<{
  input: BulkEditTasksInput;
}>;


export type ProjectBulkEditFormBulkEditTasksMutation = (
  { bulkEditTasks?: (
    { updatedTasks?: Array<(
      { id: string, status: StatusEnumType, priority?: PriorityEnumType | null, responsibility: TaskResponsibilityEnumType, taskType?: TaskTypeEnumType | null, visibility?: TaskVisibilityEnumType | null, completedAt?: any | null, assignee?: (
        { id: string }
        & { __typename?: 'UserType' }
      ) | null, tags?: Array<(
        { id: string }
        & { __typename?: 'TagType' }
      )> | null, watchers?: Array<(
        { id: string }
        & { __typename?: 'UserType' }
      )> | null, skill?: (
        { id: string, name: string, category: (
          { id: string, name: string }
          & { __typename?: 'SkillCategory' }
        ) }
        & { __typename?: 'Skill' }
      ) | null, skills?: Array<(
        { id: string, name: string, category: (
          { id: string, name: string }
          & { __typename?: 'SkillCategory' }
        ) }
        & { __typename?: 'Skill' }
      )> | null }
      & { __typename?: 'TaskType' }
    ) | null> | null }
    & { __typename?: 'bulkEditTasksPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ProjectBulkEditFormAssigneesQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars['ID']>;
  milestoneId: Scalars['ID'];
  organizationId?: InputMaybe<Scalars['ID']>;
}>;


export type ProjectBulkEditFormAssigneesQuery = (
  { potentialTaskAssignees?: Array<(
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, projectContext?: UserProjectOrganizationTypeEnumType | null, role?: UserRoleEnumType | null, jobRole?: string | null, organizationName?: string | null, skills: Array<(
      { id: string }
      & { __typename?: 'Skill' }
    )>, organization?: (
      { id: string, type?: OrganizationTypeEnumType | null, name?: string | null }
      & { __typename?: 'OrganizationType' }
    ) | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null, displayOrganization?: (
      { name: string }
      & { __typename?: 'DisplayOrganizationType' }
    ) | null }
    & { __typename?: 'UserType' }
  )> | null }
  & { __typename?: 'Query' }
);

export type ProjectBulkEditFormPaginatedAssigneesQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars['ID']>;
  milestoneId: Scalars['ID'];
  skillIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  listInput?: InputMaybe<ListInput>;
  responsibility?: InputMaybe<TaskResponsibilityEnumType>;
}>;


export type ProjectBulkEditFormPaginatedAssigneesQuery = (
  { paginatedPotentialTaskAssignees?: (
    { users?: Array<(
      { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, projectContext?: UserProjectOrganizationTypeEnumType | null, role?: UserRoleEnumType | null, jobRole?: string | null, organizationName?: string | null, skills: Array<(
        { id: string }
        & { __typename?: 'Skill' }
      )>, organization?: (
        { id: string, type?: OrganizationTypeEnumType | null, name?: string | null }
        & { __typename?: 'OrganizationType' }
      ) | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null, displayOrganization?: (
        { name: string }
        & { __typename?: 'DisplayOrganizationType' }
      ) | null }
      & { __typename?: 'UserType' }
    )> | null, pageInfo?: (
      { totalPages?: number | null, totalResults?: number | null, currentPage?: number | null, limit?: number | null, isOutOfBounds?: boolean | null }
      & { __typename: 'PageInfoType' }
    ) | null }
    & { __typename?: 'PaginatedUsersType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type ProjectBulkEditFormCommonTaskWatchersQueryVariables = Exact<{
  taskIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ProjectBulkEditFormCommonTaskWatchersQuery = (
  { commonTaskWatchers?: Array<(
    { id: string, email?: string | null, firstName?: string | null, lastName?: string | null, jobRole?: string | null, organizationName?: string | null, organization?: (
      { id: string, name?: string | null }
      & { __typename?: 'OrganizationType' }
    ) | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null, displayOrganization?: (
      { name: string }
      & { __typename?: 'DisplayOrganizationType' }
    ) | null }
    & { __typename?: 'UserType' }
  )> | null }
  & { __typename?: 'Query' }
);

export type ProjectBulkEditFormTagsQueryVariables = Exact<{
  taggableId: Scalars['ID'];
  type?: InputMaybe<Scalars['String']>;
  taggableType: TaggableEnumType;
}>;


export type ProjectBulkEditFormTagsQuery = (
  { availableTags?: Array<(
    { id: string, name: string, color: string }
    & { __typename?: 'TagType' }
  )> | null }
  & { __typename?: 'Query' }
);

export type BulkEditFormUserQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type BulkEditFormUserQuery = (
  { user: (
    { id: string, skills: Array<(
      { id: string, name: string }
      & { __typename: 'Skill' }
    )>, organization?: (
      { id: string, resourceManagementEnabled?: boolean | null, skillCategories: Array<(
        { id: string, name: string, skills: Array<(
          { id: string, name: string, category: (
            { id: string }
            & { __typename?: 'SkillCategory' }
          ) }
          & { __typename: 'Skill' }
        )> }
        & { __typename?: 'SkillCategory' }
      )> }
      & { __typename?: 'OrganizationType' }
    ) | null }
    & { __typename?: 'UserType' }
  ) }
  & { __typename?: 'Query' }
);

export type AssigneeSelectUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, projectContext?: UserProjectOrganizationTypeEnumType | null, role?: UserRoleEnumType | null, jobRole?: string | null, organizationName?: string | null, skills: Array<(
    { id: string }
    & { __typename?: 'Skill' }
  )>, organization?: (
    { id: string, type?: OrganizationTypeEnumType | null, name?: string | null }
    & { __typename?: 'OrganizationType' }
  ) | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, displayOrganization?: (
    { name: string }
    & { __typename?: 'DisplayOrganizationType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type PaginatedAssigneeSelectUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, projectContext?: UserProjectOrganizationTypeEnumType | null, jobRole?: string | null, organizationName?: string | null, skills: Array<(
    { id: string }
    & { __typename?: 'Skill' }
  )>, organization?: (
    { id: string, name?: string | null }
    & { __typename?: 'OrganizationType' }
  ) | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, displayOrganization?: (
    { name: string }
    & { __typename?: 'DisplayOrganizationType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type ProjectBulkEditFormTaskFragment = (
  { id: string, status: StatusEnumType, priority?: PriorityEnumType | null, responsibility: TaskResponsibilityEnumType, taskType?: TaskTypeEnumType | null, visibility?: TaskVisibilityEnumType | null, completedAt?: any | null }
  & { __typename?: 'TaskType' }
);

export type ProjectBulkEditFormProjectFragment = (
  { id: string, organization?: (
    { resourceManagementEnabled?: boolean | null }
    & { __typename?: 'OrganizationType' }
  ) | null }
  & { __typename?: 'ProjectType' }
);

export type ProjectBulkEditFormMilestoneFragment = (
  { id: string }
  & { __typename?: 'MilestoneType' }
);

export type ProjectBulkEditFormTemplateFragment = (
  { id: string, organization: (
    { id: string }
    & { __typename?: 'OrganizationType' }
  ) }
  & { __typename?: 'TemplateType' }
);

export type ProjectBulkEditFormUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, projectContext?: UserProjectOrganizationTypeEnumType | null, role?: UserRoleEnumType | null, jobRole?: string | null, organizationName?: string | null, skills: Array<(
    { id: string }
    & { __typename?: 'Skill' }
  )>, organization?: (
    { id: string, type?: OrganizationTypeEnumType | null, name?: string | null }
    & { __typename?: 'OrganizationType' }
  ) | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, displayOrganization?: (
    { name: string }
    & { __typename?: 'DisplayOrganizationType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type ProjectMilestoneBoardMilestoneUpdatedSubscriptionVariables = Exact<{
  templateId: Scalars['ID'];
}>;


export type ProjectMilestoneBoardMilestoneUpdatedSubscription = (
  { milestoneUpdated?: (
    { milestone?: (
      { id: string, duration?: number | null, completed?: boolean | null, startedOn?: any | null, name: string, forecastedEndOn?: any | null, completedAt?: any | null, active: boolean, sortOrder: number, summaryBank: (
        { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
        & { __typename?: 'MilestoneStats' }
      ), dependentTasks?: Array<(
        { id: string }
        & { __typename?: 'TaskType' }
      )> | null, template: (
        { id: string, hardDependency?: boolean | null }
        & { __typename?: 'TemplateType' }
      ) }
      & { __typename?: 'MilestoneType' }
    ) | null, milestoneStats?: (
      { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
      & { __typename?: 'MilestoneStats' }
    ) | null }
    & { __typename?: 'MilestoneUpdatePayloadType' }
  ) | null }
  & { __typename?: 'Subscription' }
);

export type ProjectMilestoneBoardMilestoneFragment = (
  { id: string, sortOrder: number, name: string, startedOn?: any | null, forecastedEndOn?: any | null, completedAt?: any | null, completed?: boolean | null, active: boolean, tasksAndGroups?: Array<(
    { id: string, name: string, taskCount: number, sortOrder?: number | null, startedOn?: any | null, forecastedEndOn?: any | null, completedAt?: any | null, completed?: boolean | null, tasks?: Array<(
      { id: string, sortOrder?: number | null, status: StatusEnumType, visibility?: TaskVisibilityEnumType | null, responsibility: TaskResponsibilityEnumType, name: string, taskType?: TaskTypeEnumType | null, signOffRequired: boolean, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completedAt?: any | null, completed?: boolean | null, taskGroup?: (
        { id: string }
        & { __typename?: 'TaskGroupType' }
      ) | null, template?: (
        { id: string, hardDependency?: boolean | null }
        & { __typename?: 'TemplateType' }
      ) | null, milestone?: (
        { id: string, sortOrder: number, dependentTasks?: Array<(
          { id: string }
          & { __typename?: 'TaskType' }
        )> | null }
        & { __typename?: 'MilestoneType' }
      ) | null, signer?: (
        { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
        & { __typename?: 'SignerType' }
      ) | null, assignee?: (
        { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null, dependency?: (
        { id: string, completed?: boolean | null, forecastedEndOn?: any | null, name: string }
        & { __typename: 'MilestoneType' | 'TaskGroupType' }
      ) | (
        { id: string, completed?: boolean | null, dueOn?: any | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null }
        & { __typename: 'TaskType' }
      ) | (
        { id: string, completed?: boolean | null, name: string }
        & { __typename: 'TemplateType' }
      ) | null, tags?: Array<(
        { id: string, color: string, name: string, internalOnly: boolean }
        & { __typename?: 'TagType' }
      )> | null, taskParticipants?: Array<(
        { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
          { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'UserType' }
        ) | null }
        & { __typename?: 'TaskParticipantType' }
      )> | null, dependentTasks?: Array<(
        { id: string }
        & { __typename?: 'TaskType' }
      )> | null }
      & { __typename?: 'TaskType' }
    )> | null, summaryBank: (
      { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
      & { __typename?: 'TaskGroupStats' }
    ) }
    & { __typename: 'TaskGroupType' }
  ) | (
    { id: string, sortOrder?: number | null, status: StatusEnumType, visibility?: TaskVisibilityEnumType | null, responsibility: TaskResponsibilityEnumType, name: string, taskType?: TaskTypeEnumType | null, signOffRequired: boolean, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completedAt?: any | null, completed?: boolean | null, template?: (
      { id: string, hardDependency?: boolean | null }
      & { __typename?: 'TemplateType' }
    ) | null, milestone?: (
      { id: string, sortOrder: number, dependentTasks?: Array<(
        { id: string }
        & { __typename?: 'TaskType' }
      )> | null }
      & { __typename?: 'MilestoneType' }
    ) | null, signer?: (
      { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
      & { __typename?: 'SignerType' }
    ) | null, assignee?: (
      { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null, dependency?: (
      { id: string, completed?: boolean | null, forecastedEndOn?: any | null, name: string }
      & { __typename: 'MilestoneType' | 'TaskGroupType' }
    ) | (
      { id: string, completed?: boolean | null, dueOn?: any | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null }
      & { __typename: 'TaskType' }
    ) | (
      { id: string, completed?: boolean | null, name: string }
      & { __typename: 'TemplateType' }
    ) | null, tags?: Array<(
      { id: string, color: string, name: string, internalOnly: boolean }
      & { __typename?: 'TagType' }
    )> | null, taskParticipants?: Array<(
      { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
        { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null }
      & { __typename?: 'TaskParticipantType' }
    )> | null, taskGroup?: (
      { id: string }
      & { __typename?: 'TaskGroupType' }
    ) | null, dependentTasks?: Array<(
      { id: string }
      & { __typename?: 'TaskType' }
    )> | null }
    & { __typename?: 'TaskType' }
  )> | null, template: (
    { id: string, hardDependency?: boolean | null }
    & { __typename?: 'TemplateType' }
  ), summaryBank: (
    { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
    & { __typename?: 'MilestoneStats' }
  ), dependentTasks?: Array<(
    { id: string }
    & { __typename?: 'TaskType' }
  )> | null }
  & { __typename?: 'MilestoneType' }
);

export type ProjectMilestoneBoardTaskFragment = (
  { id: string, status: StatusEnumType, visibility?: TaskVisibilityEnumType | null, responsibility: TaskResponsibilityEnumType, name: string, taskType?: TaskTypeEnumType | null, signOffRequired: boolean, sortOrder?: number | null, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completedAt?: any | null, completed?: boolean | null, template?: (
    { id: string, hardDependency?: boolean | null }
    & { __typename?: 'TemplateType' }
  ) | null, milestone?: (
    { id: string, sortOrder: number, dependentTasks?: Array<(
      { id: string }
      & { __typename?: 'TaskType' }
    )> | null }
    & { __typename?: 'MilestoneType' }
  ) | null, signer?: (
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
    & { __typename?: 'SignerType' }
  ) | null, assignee?: (
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'UserType' }
  ) | null, dependency?: (
    { id: string, completed?: boolean | null, forecastedEndOn?: any | null, name: string }
    & { __typename: 'MilestoneType' | 'TaskGroupType' }
  ) | (
    { id: string, completed?: boolean | null, dueOn?: any | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null }
    & { __typename: 'TaskType' }
  ) | (
    { id: string, completed?: boolean | null, name: string }
    & { __typename: 'TemplateType' }
  ) | null, tags?: Array<(
    { id: string, color: string, name: string, internalOnly: boolean }
    & { __typename?: 'TagType' }
  )> | null, taskParticipants?: Array<(
    { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
      { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null }
    & { __typename?: 'TaskParticipantType' }
  )> | null, taskGroup?: (
    { id: string }
    & { __typename?: 'TaskGroupType' }
  ) | null, dependentTasks?: Array<(
    { id: string }
    & { __typename?: 'TaskType' }
  )> | null }
  & { __typename?: 'TaskType' }
);

export type ProjectUseMilestonesCreateMilestoneMutationVariables = Exact<{
  milestoneVars: CreateTemplateMilestoneInput;
}>;


export type ProjectUseMilestonesCreateMilestoneMutation = (
  { createTemplateMilestone?: (
    { milestone?: (
      { id: string, name: string, startedOn?: any | null, forecastedEndOn?: any | null, completedAt?: any | null, completed?: boolean | null, active: boolean, sortOrder: number, template: (
        { id: string, hardDependency?: boolean | null }
        & { __typename?: 'TemplateType' }
      ), tasksAndGroups?: Array<(
        { id: string, name: string, taskCount: number, sortOrder?: number | null, startedOn?: any | null, forecastedEndOn?: any | null, completedAt?: any | null, completed?: boolean | null, summaryBank: (
          { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
          & { __typename?: 'TaskGroupStats' }
        ), tasks?: Array<(
          { id: string, status: StatusEnumType, visibility?: TaskVisibilityEnumType | null, responsibility: TaskResponsibilityEnumType, name: string, taskType?: TaskTypeEnumType | null, signOffRequired: boolean, sortOrder?: number | null, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completedAt?: any | null, completed?: boolean | null, taskGroup?: (
            { id: string }
            & { __typename?: 'TaskGroupType' }
          ) | null, template?: (
            { id: string, hardDependency?: boolean | null }
            & { __typename?: 'TemplateType' }
          ) | null, milestone?: (
            { id: string, sortOrder: number, dependentTasks?: Array<(
              { id: string }
              & { __typename?: 'TaskType' }
            )> | null }
            & { __typename?: 'MilestoneType' }
          ) | null, signer?: (
            { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
            & { __typename?: 'SignerType' }
          ) | null, assignee?: (
            { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
              { originalUrl?: string | null }
              & { __typename?: 'ImageType' }
            ) | null }
            & { __typename?: 'UserType' }
          ) | null, dependency?: (
            { id: string, completed?: boolean | null, forecastedEndOn?: any | null, name: string }
            & { __typename: 'MilestoneType' | 'TaskGroupType' }
          ) | (
            { id: string, completed?: boolean | null, dueOn?: any | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null }
            & { __typename: 'TaskType' }
          ) | (
            { id: string, completed?: boolean | null, name: string }
            & { __typename: 'TemplateType' }
          ) | null, tags?: Array<(
            { id: string, color: string, name: string, internalOnly: boolean }
            & { __typename?: 'TagType' }
          )> | null, taskParticipants?: Array<(
            { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
              { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
                { originalUrl?: string | null }
                & { __typename?: 'ImageType' }
              ) | null }
              & { __typename?: 'UserType' }
            ) | null }
            & { __typename?: 'TaskParticipantType' }
          )> | null, dependentTasks?: Array<(
            { id: string }
            & { __typename?: 'TaskType' }
          )> | null }
          & { __typename?: 'TaskType' }
        )> | null }
        & { __typename: 'TaskGroupType' }
      ) | (
        { id: string, status: StatusEnumType, visibility?: TaskVisibilityEnumType | null, responsibility: TaskResponsibilityEnumType, name: string, taskType?: TaskTypeEnumType | null, signOffRequired: boolean, sortOrder?: number | null, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completedAt?: any | null, completed?: boolean | null, template?: (
          { id: string, hardDependency?: boolean | null }
          & { __typename?: 'TemplateType' }
        ) | null, milestone?: (
          { id: string, sortOrder: number, dependentTasks?: Array<(
            { id: string }
            & { __typename?: 'TaskType' }
          )> | null }
          & { __typename?: 'MilestoneType' }
        ) | null, signer?: (
          { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
          & { __typename?: 'SignerType' }
        ) | null, assignee?: (
          { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'UserType' }
        ) | null, dependency?: (
          { id: string, completed?: boolean | null, forecastedEndOn?: any | null, name: string }
          & { __typename: 'MilestoneType' | 'TaskGroupType' }
        ) | (
          { id: string, completed?: boolean | null, dueOn?: any | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null }
          & { __typename: 'TaskType' }
        ) | (
          { id: string, completed?: boolean | null, name: string }
          & { __typename: 'TemplateType' }
        ) | null, tags?: Array<(
          { id: string, color: string, name: string, internalOnly: boolean }
          & { __typename?: 'TagType' }
        )> | null, taskParticipants?: Array<(
          { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
            { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
              { originalUrl?: string | null }
              & { __typename?: 'ImageType' }
            ) | null }
            & { __typename?: 'UserType' }
          ) | null }
          & { __typename?: 'TaskParticipantType' }
        )> | null, taskGroup?: (
          { id: string }
          & { __typename?: 'TaskGroupType' }
        ) | null, dependentTasks?: Array<(
          { id: string }
          & { __typename?: 'TaskType' }
        )> | null }
        & { __typename?: 'TaskType' }
      )> | null, summaryBank: (
        { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
        & { __typename?: 'MilestoneStats' }
      ), dependentTasks?: Array<(
        { id: string }
        & { __typename?: 'TaskType' }
      )> | null }
      & { __typename?: 'MilestoneType' }
    ) | null }
    & { __typename?: 'createTemplateMilestonePayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ProjectEditMilestoneDrawerUpdateMilestoneMutationVariables = Exact<{
  milestone: UpdateTemplateMilestoneInput;
}>;


export type ProjectEditMilestoneDrawerUpdateMilestoneMutation = (
  { updateTemplateMilestone?: (
    { milestone?: (
      { id: string, name: string, sortOrder: number, description?: string | null, completionMessage?: string | null, enableCompletionNotification?: boolean | null, enableSendSurvey?: boolean | null, files?: Array<(
        { id: string, url?: string | null, fileName: string, size?: number | null, milestoneName?: string | null, taskName?: string | null, createdAt?: any | null, internalOnly: boolean, deletable?: boolean | null, isExternalHyperlink?: boolean | null, uploader?: (
          { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'UserType' }
        ) | null }
        & { __typename?: 'FileType' }
      )> | null }
      & { __typename?: 'MilestoneType' }
    ) | null }
    & { __typename?: 'updateTemplateMilestonePayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type MilestoneTasksFragment = (
  { tasksAndGroups?: Array<(
    { id: string, sortOrder?: number | null }
    & { __typename?: 'TaskGroupType' | 'TaskType' }
  )> | null }
  & { __typename?: 'MilestoneType' }
);

export type ProjectAddTaskDrawerTaskFragment = (
  { id: string, actualHours?: number | null, billableHours?: number | null, nonBillableHours?: number | null, assignmentEmailSentAt?: any | null, completedAt?: any | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, description?: string | null, dueOn?: any | null, duration?: number | null, estimatedHours?: number | null, estimatedPoints?: number | null, eventDatetime?: any | null, eventInformation?: string | null, invitationGroupSentAt?: any | null, meetingLength?: number | null, mustStartOn?: any | null, mustStartOnRequired?: boolean | null, jiraTaskLink?: string | null, name: string, participantCallToAction?: string | null, priority?: PriorityEnumType | null, responsibility: TaskResponsibilityEnumType, shouldWarnUpdateStatus?: boolean | null, signOffRequired: boolean, sortOrder?: number | null, startOn?: any | null, status: StatusEnumType, taskType?: TaskTypeEnumType | null, visibility?: TaskVisibilityEnumType | null, jiraSync?: boolean | null, tags?: Array<(
    { id: string }
    & { __typename?: 'TagType' }
  )> | null, skill?: (
    { id: string }
    & { __typename?: 'Skill' }
  ) | null, skills?: Array<(
    { id: string }
    & { __typename?: 'Skill' }
  )> | null, assignee?: (
    { id: string, firstName?: string | null, lastName?: string | null, calendarLink?: string | null, meetingLink?: string | null, role?: UserRoleEnumType | null, projectContext?: UserProjectOrganizationTypeEnumType | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'UserType' }
  ) | null, creator?: (
    { id: string }
    & { __typename?: 'UserType' }
  ) | null, signer?: (
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
    & { __typename?: 'SignerType' }
  ) | null, jiraTask?: (
    { id: string, externalId?: string | null, externalProjectId?: string | null, externalTypeId?: string | null, components?: Array<string> | null, createdInJira?: any | null }
    & { __typename?: 'JiraIssueType' }
  ) | null, files?: Array<(
    { id: string, sortOrder?: number | null, url?: string | null, fileName: string, size?: number | null, milestoneName?: string | null, taskName?: string | null, createdAt?: any | null, internalOnly: boolean, deletable?: boolean | null, isExternalHyperlink?: boolean | null, uploader?: (
      { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null }
    & { __typename?: 'FileType' }
  )> | null, milestone?: (
    { id: string, sortOrder: number, isFirstOfTemplate: boolean, isFirstOfProject: boolean, template: (
      { id: string, hardDependency?: boolean | null }
      & { __typename?: 'TemplateType' }
    ) }
    & { __typename?: 'MilestoneType' }
  ) | null, project?: (
    { id: string, name: string, status: StatusEnumType, currentUserProjectContext?: UserProjectOrganizationTypeEnumType | null, pmDisplayRole?: string | null, projectManager?: (
      { id: string, firstName?: string | null, lastName?: string | null, calendarLink?: string | null, meetingLink?: string | null }
      & { __typename?: 'UserType' }
    ) | null, organization?: (
      { id: string, name?: string | null, defaultTaskVisibility?: TaskVisibilityEnumType | null, timeTrackingEnabled?: boolean | null, resourceManagementEnabled?: boolean | null, internalNotesDefault: boolean }
      & { __typename?: 'OrganizationType' }
    ) | null, customerV2?: (
      { id: string, name: string }
      & { __typename?: 'CustomerType' }
    ) | null }
    & { __typename?: 'ProjectType' }
  ) | null, dependency?: (
    { id: string, name: string, completed?: boolean | null }
    & { __typename?: 'MilestoneType' | 'TaskGroupType' | 'TemplateType' }
  ) | (
    { id: string, name: string, completed?: boolean | null, shouldWarnUpdateStatus?: boolean | null }
    & { __typename?: 'TaskType' }
  ) | null, subtasks?: Array<(
    { id: string, name?: string | null, richName?: string | null, done?: boolean | null, sortOrder?: number | null, groupId?: string | null }
    & { __typename?: 'SubtaskType' }
  )> | null, subtasksGroups?: Array<(
    { id: string, name?: string | null }
    & { __typename?: 'SubtasksGroupType' }
  )> | null, watchers?: Array<(
    { id: string }
    & { __typename?: 'UserType' }
  )> | null, taskParticipants?: Array<(
    { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
      { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, capacity?: number | null, projectsCount?: number | null, projectContext?: UserProjectOrganizationTypeEnumType | null, organizationName?: string | null, organization?: (
        { id: string, name?: string | null }
        & { __typename?: 'OrganizationType' }
      ) | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null, displayOrganization?: (
        { name: string }
        & { __typename?: 'DisplayOrganizationType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null }
    & { __typename?: 'TaskParticipantType' }
  )> | null, participantsSelectAll?: (
    { internal: boolean, customer: boolean, thirdParty: boolean }
    & { __typename: 'TaskParticipantSelectAllType' }
  ) | null, taskGroup?: (
    { id: string }
    & { __typename?: 'TaskGroupType' }
  ) | null }
  & { __typename?: 'TaskType' }
);

export type ProjectPlanEditTaskDrawerProjectSnapshotFragment = (
  { id: string, startOn?: any | null, endOn?: any | null, completedAt?: any | null, forecastedEndOn?: any | null }
  & { __typename?: 'ProjectType' }
);

export type ProjectPlanEditTaskDrawerProjectStatsFragment = (
  { totalTasks: number, totalDoneTasks: number, totalAssignedTasks: number, totalTasksWithUnestimatedHoursCount?: number | null, totalActualHours?: number | null, totalInternalEstimatedHours?: number | null }
  & { __typename?: 'ProjectStats' }
);

export type ProjectPlanEditTaskDrawerUpdateTaskGroupTaskMutationVariables = Exact<{
  task: UpdateTaskInput;
}>;


export type ProjectPlanEditTaskDrawerUpdateTaskGroupTaskMutation = (
  { updateTaskGroupTask?: (
    { taskReturnData?: (
      { task?: (
        { id: string, taskType?: TaskTypeEnumType | null, name: string, description?: string | null, startOn?: any | null, dueOn?: any | null, estimatedHours?: number | null, actualHours?: number | null, billableHours?: number | null, nonBillableHours?: number | null, estimatedPoints?: number | null, duration?: number | null, sortOrder?: number | null, priority?: PriorityEnumType | null, responsibility: TaskResponsibilityEnumType, signOffRequired: boolean, status: StatusEnumType, shouldWarnUpdateStatus?: boolean | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, eventDatetime?: any | null, participantCallToAction?: string | null, invitationGroupSentAt?: any | null, assignmentEmailSentAt?: any | null, completedAt?: any | null, eventInformation?: string | null, meetingLength?: number | null, mustStartOn?: any | null, mustStartOnRequired?: boolean | null, jiraTaskLink?: string | null, visibility?: TaskVisibilityEnumType | null, jiraSync?: boolean | null, dependency?: (
          { id: string, completed?: boolean | null, name: string, tasks?: Array<(
            { id: string, shouldWarnUpdateStatus?: boolean | null }
            & { __typename?: 'TaskType' }
          )> | null }
          & { __typename?: 'MilestoneType' | 'TaskGroupType' }
        ) | (
          { id: string, completed?: boolean | null, shouldWarnUpdateStatus?: boolean | null, name: string }
          & { __typename?: 'TaskType' }
        ) | (
          { id: string, completed?: boolean | null, name: string }
          & { __typename?: 'TemplateType' }
        ) | null, assignee?: (
          { id: string, firstName?: string | null, lastName?: string | null, jobRole?: string | null, calendarLink?: string | null, meetingLink?: string | null, role?: UserRoleEnumType | null, projectContext?: UserProjectOrganizationTypeEnumType | null, avatar?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'UserType' }
        ) | null, signer?: (
          { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
          & { __typename?: 'SignerType' }
        ) | null, notes?: Array<(
          { id: string }
          & { __typename?: 'NoteType' }
        )> | null, jiraTask?: (
          { id: string, externalId?: string | null, externalProjectId?: string | null, externalTypeId?: string | null, components?: Array<string> | null, createdInJira?: any | null }
          & { __typename?: 'JiraIssueType' }
        ) | null, files?: Array<(
          { id: string, sortOrder?: number | null, url?: string | null, fileName: string, size?: number | null, milestoneName?: string | null, taskName?: string | null, createdAt?: any | null, internalOnly: boolean, deletable?: boolean | null, isExternalHyperlink?: boolean | null, uploader?: (
            { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
              { originalUrl?: string | null }
              & { __typename?: 'ImageType' }
            ) | null }
            & { __typename?: 'UserType' }
          ) | null }
          & { __typename?: 'FileType' }
        )> | null, subtasks?: Array<(
          { id: string, name?: string | null, richName?: string | null, done?: boolean | null, sortOrder?: number | null, groupId?: string | null }
          & { __typename?: 'SubtaskType' }
        )> | null, taskParticipants?: Array<(
          { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
            { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, capacity?: number | null, projectsCount?: number | null, projectContext?: UserProjectOrganizationTypeEnumType | null, organizationName?: string | null, organization?: (
              { id: string, name?: string | null }
              & { __typename?: 'OrganizationType' }
            ) | null, avatar?: (
              { originalUrl?: string | null }
              & { __typename?: 'ImageType' }
            ) | null, displayOrganization?: (
              { name: string }
              & { __typename?: 'DisplayOrganizationType' }
            ) | null }
            & { __typename?: 'UserType' }
          ) | null }
          & { __typename?: 'TaskParticipantType' }
        )> | null, template?: (
          { id: string, duration?: number | null }
          & { __typename?: 'TemplateType' }
        ) | null, project?: (
          { id: string, status: StatusEnumType, name: string, currentUserProjectContext?: UserProjectOrganizationTypeEnumType | null, pmDisplayRole?: string | null, startOn?: any | null, endOn?: any | null, completedAt?: any | null, forecastedEndOn?: any | null, stats?: (
            { totalTasks: number, totalDoneTasks: number, totalAssignedTasks: number, totalTasksWithUnestimatedHoursCount?: number | null, totalActualHours?: number | null, totalInternalEstimatedHours?: number | null }
            & { __typename?: 'ProjectStats' }
          ) | null, profitabilitySummary?: (
            { forecastedCost?: number | null, budgetedCost?: number | null }
            & { __typename?: 'ProjectProfitabilitySummaryType' }
          ) | null, projectManager?: (
            { id: string, firstName?: string | null, lastName?: string | null, calendarLink?: string | null, meetingLink?: string | null }
            & { __typename?: 'UserType' }
          ) | null, organization?: (
            { id: string, name?: string | null, defaultTaskVisibility?: TaskVisibilityEnumType | null, timeTrackingEnabled?: boolean | null, resourceManagementEnabled?: boolean | null, internalNotesDefault: boolean }
            & { __typename?: 'OrganizationType' }
          ) | null, customerV2?: (
            { id: string, name: string }
            & { __typename?: 'CustomerType' }
          ) | null }
          & { __typename?: 'ProjectType' }
        ) | null, tags?: Array<(
          { id: string }
          & { __typename?: 'TagType' }
        )> | null, skill?: (
          { id: string }
          & { __typename?: 'Skill' }
        ) | null, skills?: Array<(
          { id: string }
          & { __typename?: 'Skill' }
        )> | null, creator?: (
          { id: string }
          & { __typename?: 'UserType' }
        ) | null, milestone?: (
          { id: string, sortOrder: number, isFirstOfTemplate: boolean, isFirstOfProject: boolean, template: (
            { id: string, hardDependency?: boolean | null }
            & { __typename?: 'TemplateType' }
          ) }
          & { __typename?: 'MilestoneType' }
        ) | null, subtasksGroups?: Array<(
          { id: string, name?: string | null }
          & { __typename?: 'SubtasksGroupType' }
        )> | null, watchers?: Array<(
          { id: string }
          & { __typename?: 'UserType' }
        )> | null, participantsSelectAll?: (
          { internal: boolean, customer: boolean, thirdParty: boolean }
          & { __typename: 'TaskParticipantSelectAllType' }
        ) | null, taskGroup?: (
          { id: string }
          & { __typename?: 'TaskGroupType' }
        ) | null }
        & { __typename?: 'TaskType' }
      ) | null }
      & { __typename?: 'TaskReturnType' }
    ) | null }
    & { __typename?: 'updateTaskGroupTaskPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type EditTaskDrawerGetAvailableTaskTagsQueryVariables = Exact<{
  taggableId: Scalars['ID'];
  taggableType: TaggableEnumType;
}>;


export type EditTaskDrawerGetAvailableTaskTagsQuery = (
  { availableTags?: Array<(
    { id: string, color: string, name: string, internalOnly: boolean }
    & { __typename?: 'TagType' }
  )> | null }
  & { __typename?: 'Query' }
);

export type ProjectPlanEditTaskDrawerCurrentUserSkillsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectPlanEditTaskDrawerCurrentUserSkillsQuery = (
  { currentUser?: (
    { skills: Array<(
      { id: string }
      & { __typename?: 'Skill' }
    )> }
    & { __typename?: 'UserType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type ProjectPlanEditTaskDrawerRemoveWatcherMutationVariables = Exact<{
  taskId: Scalars['ID'];
  watcherId: Scalars['ID'];
}>;


export type ProjectPlanEditTaskDrawerRemoveWatcherMutation = (
  { removeWatcher?: (
    { success?: boolean | null }
    & { __typename?: 'removeWatcherPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ProjectPlanEditTaskDrawerProjectTeamQueryVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type ProjectPlanEditTaskDrawerProjectTeamQuery = (
  { projectTeam: Array<(
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, projectContext?: UserProjectOrganizationTypeEnumType | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null, organization?: (
      { id: string }
      & { __typename?: 'OrganizationType' }
    ) | null }
    & { __typename?: 'UserType' }
  )> }
  & { __typename?: 'Query' }
);

export type MilestoneColumnProjectSnapshotFragment = (
  { id: string, startOn?: any | null, endOn?: any | null, completedAt?: any | null, forecastedEndOn?: any | null }
  & { __typename?: 'ProjectType' }
);

export type MilestoneColumnProjectStatsFragment = (
  { totalTasks: number, totalDoneTasks: number, totalAssignedTasks: number, totalTasksWithUnestimatedHoursCount?: number | null, totalActualHours?: number | null, totalInternalEstimatedHours?: number | null }
  & { __typename?: 'ProjectStats' }
);

export type ProjectMilestoneColumnDuplicateMilestoneMutationVariables = Exact<{
  id: Scalars['ID'];
  sortOrder: Scalars['Float'];
}>;


export type ProjectMilestoneColumnDuplicateMilestoneMutation = (
  { duplicateMilestone?: (
    { milestone?: (
      { id: string, sortOrder: number, name: string, startedOn?: any | null, forecastedEndOn?: any | null, completedAt?: any | null, completed?: boolean | null, active: boolean, template: (
        { id: string, hardDependency?: boolean | null, summaryBank: (
          { id: string, totalMilestones: number, totalTasks: number, totalCompleteTasks: number, totalPoints: number, totalEstimatedHours: number, totalInternalTasks: number, totalInternalPoints: number, totalInternalHours: number, totalCustomerTasks: number, totalCustomerPoints: number, totalCustomerHours: number, totalThirdPartyTasks: number, totalThirdPartyPoints: number, totalThirdPartyHours: number, totalAssignedTasks: number, totalActualHours: number, totalRemainingHours: number, totalInternalRemainingHours: number, totalInternalActualHours: number, totalCustomerRemainingHours: number, totalCustomerActualHours: number, totalThirdPartyRemainingHours: number, totalThirdPartyActualHours: number, totalInternalLoggedHours: number, totalInternalLoggedBillableHours: number, totalInternalLoggedNonBillableHours: number, totalInternalRemainingPurchasedHours: number }
          & { __typename?: 'TemplateStats' }
        ) }
        & { __typename?: 'TemplateType' }
      ), project?: (
        { id: string, startOn?: any | null, endOn?: any | null, completedAt?: any | null, forecastedEndOn?: any | null, stats?: (
          { totalTasks: number, totalDoneTasks: number, totalAssignedTasks: number, totalTasksWithUnestimatedHoursCount?: number | null, totalActualHours?: number | null, totalInternalEstimatedHours?: number | null }
          & { __typename?: 'ProjectStats' }
        ) | null, profitabilitySummary?: (
          { forecastedCost?: number | null, budgetedCost?: number | null }
          & { __typename?: 'ProjectProfitabilitySummaryType' }
        ) | null }
        & { __typename?: 'ProjectType' }
      ) | null, tasksAndGroups?: Array<(
        { id: string, sortOrder?: number | null, name: string, taskCount: number, startedOn?: any | null, forecastedEndOn?: any | null, completedAt?: any | null, completed?: boolean | null, tasks?: Array<(
          { id: string, sortOrder?: number | null, status: StatusEnumType, visibility?: TaskVisibilityEnumType | null, responsibility: TaskResponsibilityEnumType, priority?: PriorityEnumType | null, taskType?: TaskTypeEnumType | null, completedAt?: any | null, name: string, signOffRequired: boolean, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completed?: boolean | null, assignee?: (
            { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
              { originalUrl?: string | null }
              & { __typename?: 'ImageType' }
            ) | null }
            & { __typename?: 'UserType' }
          ) | null, taskGroup?: (
            { id: string }
            & { __typename?: 'TaskGroupType' }
          ) | null, template?: (
            { id: string, hardDependency?: boolean | null }
            & { __typename?: 'TemplateType' }
          ) | null, milestone?: (
            { id: string, sortOrder: number, dependentTasks?: Array<(
              { id: string }
              & { __typename?: 'TaskType' }
            )> | null }
            & { __typename?: 'MilestoneType' }
          ) | null, signer?: (
            { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
            & { __typename?: 'SignerType' }
          ) | null, dependency?: (
            { id: string, completed?: boolean | null, forecastedEndOn?: any | null, name: string }
            & { __typename: 'MilestoneType' | 'TaskGroupType' }
          ) | (
            { id: string, completed?: boolean | null, dueOn?: any | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null }
            & { __typename: 'TaskType' }
          ) | (
            { id: string, completed?: boolean | null, name: string }
            & { __typename: 'TemplateType' }
          ) | null, tags?: Array<(
            { id: string, color: string, name: string, internalOnly: boolean }
            & { __typename?: 'TagType' }
          )> | null, taskParticipants?: Array<(
            { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
              { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
                { originalUrl?: string | null }
                & { __typename?: 'ImageType' }
              ) | null }
              & { __typename?: 'UserType' }
            ) | null }
            & { __typename?: 'TaskParticipantType' }
          )> | null, dependentTasks?: Array<(
            { id: string }
            & { __typename?: 'TaskType' }
          )> | null }
          & { __typename?: 'TaskType' }
        )> | null, summaryBank: (
          { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
          & { __typename?: 'TaskGroupStats' }
        ) }
        & { __typename: 'TaskGroupType' }
      ) | (
        { id: string, sortOrder?: number | null, status: StatusEnumType, visibility?: TaskVisibilityEnumType | null, responsibility: TaskResponsibilityEnumType, priority?: PriorityEnumType | null, taskType?: TaskTypeEnumType | null, completedAt?: any | null, name: string, signOffRequired: boolean, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completed?: boolean | null, assignee?: (
          { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'UserType' }
        ) | null, template?: (
          { id: string, hardDependency?: boolean | null }
          & { __typename?: 'TemplateType' }
        ) | null, milestone?: (
          { id: string, sortOrder: number, dependentTasks?: Array<(
            { id: string }
            & { __typename?: 'TaskType' }
          )> | null }
          & { __typename?: 'MilestoneType' }
        ) | null, signer?: (
          { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
          & { __typename?: 'SignerType' }
        ) | null, dependency?: (
          { id: string, completed?: boolean | null, forecastedEndOn?: any | null, name: string }
          & { __typename: 'MilestoneType' | 'TaskGroupType' }
        ) | (
          { id: string, completed?: boolean | null, dueOn?: any | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null }
          & { __typename: 'TaskType' }
        ) | (
          { id: string, completed?: boolean | null, name: string }
          & { __typename: 'TemplateType' }
        ) | null, tags?: Array<(
          { id: string, color: string, name: string, internalOnly: boolean }
          & { __typename?: 'TagType' }
        )> | null, taskParticipants?: Array<(
          { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
            { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
              { originalUrl?: string | null }
              & { __typename?: 'ImageType' }
            ) | null }
            & { __typename?: 'UserType' }
          ) | null }
          & { __typename?: 'TaskParticipantType' }
        )> | null, taskGroup?: (
          { id: string }
          & { __typename?: 'TaskGroupType' }
        ) | null, dependentTasks?: Array<(
          { id: string }
          & { __typename?: 'TaskType' }
        )> | null }
        & { __typename?: 'TaskType' }
      )> | null, summaryBank: (
        { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
        & { __typename?: 'MilestoneStats' }
      ), dependentTasks?: Array<(
        { id: string }
        & { __typename?: 'TaskType' }
      )> | null }
      & { __typename?: 'MilestoneType' }
    ) | null }
    & { __typename?: 'duplicateMilestonePayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ProjectMilestoneColumnDuplicateTaskMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProjectMilestoneColumnDuplicateTaskMutation = (
  { duplicateTask?: (
    { taskReturnData?: (
      { task?: (
        { id: string, status: StatusEnumType, visibility?: TaskVisibilityEnumType | null, responsibility: TaskResponsibilityEnumType, priority?: PriorityEnumType | null, taskType?: TaskTypeEnumType | null, completedAt?: any | null, name: string, signOffRequired: boolean, sortOrder?: number | null, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completed?: boolean | null, milestone?: (
          { startedOn?: any | null, forecastedEndOn?: any | null, completedAt?: any | null, completed?: boolean | null, id: string, sortOrder: number, summaryBank: (
            { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
            & { __typename?: 'MilestoneStats' }
          ), dependentTasks?: Array<(
            { id: string }
            & { __typename?: 'TaskType' }
          )> | null }
          & { __typename?: 'MilestoneType' }
        ) | null, taskGroup?: (
          { startedOn?: any | null, forecastedEndOn?: any | null, completedAt?: any | null, completed?: boolean | null, id: string, summaryBank: (
            { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
            & { __typename?: 'TaskGroupStats' }
          ) }
          & { __typename?: 'TaskGroupType' }
        ) | null, template?: (
          { id: string, hardDependency?: boolean | null, summaryBank: (
            { id: string, totalMilestones: number, totalTasks: number, totalCompleteTasks: number, totalPoints: number, totalEstimatedHours: number, totalInternalTasks: number, totalInternalPoints: number, totalInternalHours: number, totalCustomerTasks: number, totalCustomerPoints: number, totalCustomerHours: number, totalThirdPartyTasks: number, totalThirdPartyPoints: number, totalThirdPartyHours: number, totalAssignedTasks: number, totalActualHours: number, totalRemainingHours: number, totalInternalRemainingHours: number, totalInternalActualHours: number, totalCustomerRemainingHours: number, totalCustomerActualHours: number, totalThirdPartyRemainingHours: number, totalThirdPartyActualHours: number, totalInternalLoggedHours: number, totalInternalLoggedBillableHours: number, totalInternalLoggedNonBillableHours: number, totalInternalRemainingPurchasedHours: number }
            & { __typename?: 'TemplateStats' }
          ) }
          & { __typename?: 'TemplateType' }
        ) | null, project?: (
          { id: string, startOn?: any | null, endOn?: any | null, completedAt?: any | null, forecastedEndOn?: any | null, stats?: (
            { totalTasks: number, totalDoneTasks: number, totalAssignedTasks: number, totalTasksWithUnestimatedHoursCount?: number | null, totalActualHours?: number | null, totalInternalEstimatedHours?: number | null }
            & { __typename?: 'ProjectStats' }
          ) | null, profitabilitySummary?: (
            { forecastedCost?: number | null, budgetedCost?: number | null }
            & { __typename?: 'ProjectProfitabilitySummaryType' }
          ) | null }
          & { __typename?: 'ProjectType' }
        ) | null, signer?: (
          { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
          & { __typename?: 'SignerType' }
        ) | null, assignee?: (
          { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'UserType' }
        ) | null, dependency?: (
          { id: string, completed?: boolean | null, forecastedEndOn?: any | null, name: string }
          & { __typename: 'MilestoneType' | 'TaskGroupType' }
        ) | (
          { id: string, completed?: boolean | null, dueOn?: any | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null }
          & { __typename: 'TaskType' }
        ) | (
          { id: string, completed?: boolean | null, name: string }
          & { __typename: 'TemplateType' }
        ) | null, tags?: Array<(
          { id: string, color: string, name: string, internalOnly: boolean }
          & { __typename?: 'TagType' }
        )> | null, taskParticipants?: Array<(
          { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
            { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
              { originalUrl?: string | null }
              & { __typename?: 'ImageType' }
            ) | null }
            & { __typename?: 'UserType' }
          ) | null }
          & { __typename?: 'TaskParticipantType' }
        )> | null, dependentTasks?: Array<(
          { id: string }
          & { __typename?: 'TaskType' }
        )> | null }
        & { __typename?: 'TaskType' }
      ) | null }
      & { __typename?: 'TaskReturnType' }
    ) | null }
    & { __typename?: 'duplicateTaskPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ProjectMilestoneColumnMilestoneFragment = (
  { id: string, name: string, startedOn?: any | null, forecastedEndOn?: any | null, completedAt?: any | null, completed?: boolean | null, active: boolean, sortOrder: number, template: (
    { id: string, hardDependency?: boolean | null }
    & { __typename?: 'TemplateType' }
  ), tasksAndGroups?: Array<(
    { id: string, name: string, taskCount: number, sortOrder?: number | null, startedOn?: any | null, forecastedEndOn?: any | null, completedAt?: any | null, completed?: boolean | null, summaryBank: (
      { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
      & { __typename?: 'TaskGroupStats' }
    ), tasks?: Array<(
      { id: string, status: StatusEnumType, visibility?: TaskVisibilityEnumType | null, responsibility: TaskResponsibilityEnumType, name: string, taskType?: TaskTypeEnumType | null, signOffRequired: boolean, sortOrder?: number | null, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completedAt?: any | null, completed?: boolean | null, taskGroup?: (
        { id: string }
        & { __typename?: 'TaskGroupType' }
      ) | null, template?: (
        { id: string, hardDependency?: boolean | null }
        & { __typename?: 'TemplateType' }
      ) | null, milestone?: (
        { id: string, sortOrder: number, dependentTasks?: Array<(
          { id: string }
          & { __typename?: 'TaskType' }
        )> | null }
        & { __typename?: 'MilestoneType' }
      ) | null, signer?: (
        { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
        & { __typename?: 'SignerType' }
      ) | null, assignee?: (
        { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null, dependency?: (
        { id: string, completed?: boolean | null, forecastedEndOn?: any | null, name: string }
        & { __typename: 'MilestoneType' | 'TaskGroupType' }
      ) | (
        { id: string, completed?: boolean | null, dueOn?: any | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null }
        & { __typename: 'TaskType' }
      ) | (
        { id: string, completed?: boolean | null, name: string }
        & { __typename: 'TemplateType' }
      ) | null, tags?: Array<(
        { id: string, color: string, name: string, internalOnly: boolean }
        & { __typename?: 'TagType' }
      )> | null, taskParticipants?: Array<(
        { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
          { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'UserType' }
        ) | null }
        & { __typename?: 'TaskParticipantType' }
      )> | null, dependentTasks?: Array<(
        { id: string }
        & { __typename?: 'TaskType' }
      )> | null }
      & { __typename?: 'TaskType' }
    )> | null }
    & { __typename: 'TaskGroupType' }
  ) | (
    { id: string, status: StatusEnumType, visibility?: TaskVisibilityEnumType | null, responsibility: TaskResponsibilityEnumType, name: string, taskType?: TaskTypeEnumType | null, signOffRequired: boolean, sortOrder?: number | null, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completedAt?: any | null, completed?: boolean | null, template?: (
      { id: string, hardDependency?: boolean | null }
      & { __typename?: 'TemplateType' }
    ) | null, milestone?: (
      { id: string, sortOrder: number, dependentTasks?: Array<(
        { id: string }
        & { __typename?: 'TaskType' }
      )> | null }
      & { __typename?: 'MilestoneType' }
    ) | null, signer?: (
      { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
      & { __typename?: 'SignerType' }
    ) | null, assignee?: (
      { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null, dependency?: (
      { id: string, completed?: boolean | null, forecastedEndOn?: any | null, name: string }
      & { __typename: 'MilestoneType' | 'TaskGroupType' }
    ) | (
      { id: string, completed?: boolean | null, dueOn?: any | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null }
      & { __typename: 'TaskType' }
    ) | (
      { id: string, completed?: boolean | null, name: string }
      & { __typename: 'TemplateType' }
    ) | null, tags?: Array<(
      { id: string, color: string, name: string, internalOnly: boolean }
      & { __typename?: 'TagType' }
    )> | null, taskParticipants?: Array<(
      { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
        { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null }
      & { __typename?: 'TaskParticipantType' }
    )> | null, taskGroup?: (
      { id: string }
      & { __typename?: 'TaskGroupType' }
    ) | null, dependentTasks?: Array<(
      { id: string }
      & { __typename?: 'TaskType' }
    )> | null }
    & { __typename?: 'TaskType' }
  )> | null, summaryBank: (
    { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
    & { __typename?: 'MilestoneStats' }
  ), dependentTasks?: Array<(
    { id: string }
    & { __typename?: 'TaskType' }
  )> | null }
  & { __typename?: 'MilestoneType' }
);

export type ProjectMilestoneColumnTaskFragment = (
  { id: string, status: StatusEnumType, visibility?: TaskVisibilityEnumType | null, responsibility: TaskResponsibilityEnumType, name: string, taskType?: TaskTypeEnumType | null, signOffRequired: boolean, sortOrder?: number | null, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completedAt?: any | null, completed?: boolean | null, template?: (
    { id: string, hardDependency?: boolean | null }
    & { __typename?: 'TemplateType' }
  ) | null, milestone?: (
    { id: string, sortOrder: number, dependentTasks?: Array<(
      { id: string }
      & { __typename?: 'TaskType' }
    )> | null }
    & { __typename?: 'MilestoneType' }
  ) | null, signer?: (
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
    & { __typename?: 'SignerType' }
  ) | null, assignee?: (
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'UserType' }
  ) | null, dependency?: (
    { id: string, completed?: boolean | null, forecastedEndOn?: any | null, name: string }
    & { __typename: 'MilestoneType' | 'TaskGroupType' }
  ) | (
    { id: string, completed?: boolean | null, dueOn?: any | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null }
    & { __typename: 'TaskType' }
  ) | (
    { id: string, completed?: boolean | null, name: string }
    & { __typename: 'TemplateType' }
  ) | null, tags?: Array<(
    { id: string, color: string, name: string, internalOnly: boolean }
    & { __typename?: 'TagType' }
  )> | null, taskParticipants?: Array<(
    { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
      { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null }
    & { __typename?: 'TaskParticipantType' }
  )> | null, taskGroup?: (
    { id: string }
    & { __typename?: 'TaskGroupType' }
  ) | null, dependentTasks?: Array<(
    { id: string }
    & { __typename?: 'TaskType' }
  )> | null }
  & { __typename?: 'TaskType' }
);

export type ProjectMilestoneColumnTaskGroupFragment = (
  { id: string, name: string, taskCount: number, sortOrder?: number | null, startedOn?: any | null, forecastedEndOn?: any | null, completedAt?: any | null, completed?: boolean | null, summaryBank: (
    { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
    & { __typename?: 'TaskGroupStats' }
  ), tasks?: Array<(
    { id: string, status: StatusEnumType, visibility?: TaskVisibilityEnumType | null, responsibility: TaskResponsibilityEnumType, name: string, taskType?: TaskTypeEnumType | null, signOffRequired: boolean, sortOrder?: number | null, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completedAt?: any | null, completed?: boolean | null, taskGroup?: (
      { id: string }
      & { __typename?: 'TaskGroupType' }
    ) | null, template?: (
      { id: string, hardDependency?: boolean | null }
      & { __typename?: 'TemplateType' }
    ) | null, milestone?: (
      { id: string, sortOrder: number, dependentTasks?: Array<(
        { id: string }
        & { __typename?: 'TaskType' }
      )> | null }
      & { __typename?: 'MilestoneType' }
    ) | null, signer?: (
      { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
      & { __typename?: 'SignerType' }
    ) | null, assignee?: (
      { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null, dependency?: (
      { id: string, completed?: boolean | null, forecastedEndOn?: any | null, name: string }
      & { __typename: 'MilestoneType' | 'TaskGroupType' }
    ) | (
      { id: string, completed?: boolean | null, dueOn?: any | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null }
      & { __typename: 'TaskType' }
    ) | (
      { id: string, completed?: boolean | null, name: string }
      & { __typename: 'TemplateType' }
    ) | null, tags?: Array<(
      { id: string, color: string, name: string, internalOnly: boolean }
      & { __typename?: 'TagType' }
    )> | null, taskParticipants?: Array<(
      { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
        { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null }
      & { __typename?: 'TaskParticipantType' }
    )> | null, dependentTasks?: Array<(
      { id: string }
      & { __typename?: 'TaskType' }
    )> | null }
    & { __typename?: 'TaskType' }
  )> | null }
  & { __typename: 'TaskGroupType' }
);

export type ProjectMilestoneHeaderMilestoneStatsFragment = (
  { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
  & { __typename?: 'MilestoneStats' }
);

export type ProjectMilestoneHeaderMilestoneFragment = (
  { id: string, name: string, startedOn?: any | null, forecastedEndOn?: any | null, completedAt?: any | null, completed?: boolean | null, active: boolean, sortOrder: number, summaryBank: (
    { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
    & { __typename?: 'MilestoneStats' }
  ), dependentTasks?: Array<(
    { id: string }
    & { __typename?: 'TaskType' }
  )> | null, template: (
    { id: string, hardDependency?: boolean | null }
    & { __typename?: 'TemplateType' }
  ) }
  & { __typename?: 'MilestoneType' }
);

export type ProjectUseMilestonesDeleteMilestoneMutationVariables = Exact<{
  deleteMilestoneInput: DeleteMilestoneInput;
}>;


export type ProjectUseMilestonesDeleteMilestoneMutation = (
  { deleteMilestone?: (
    { deleteMilestoneReturnData?: (
      { milestones?: Array<(
        { id: string }
        & { __typename?: 'MilestoneType' }
      )> | null }
      & { __typename?: 'DeleteMilestoneReturnType' }
    ) | null }
    & { __typename?: 'deleteMilestonePayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ProjectPlanTaskCardTaskFragment = (
  { id: string, status: StatusEnumType, visibility?: TaskVisibilityEnumType | null, responsibility: TaskResponsibilityEnumType, name: string, taskType?: TaskTypeEnumType | null, signOffRequired: boolean, sortOrder?: number | null, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completedAt?: any | null, completed?: boolean | null, template?: (
    { id: string, hardDependency?: boolean | null }
    & { __typename?: 'TemplateType' }
  ) | null, milestone?: (
    { id: string, sortOrder: number, dependentTasks?: Array<(
      { id: string }
      & { __typename?: 'TaskType' }
    )> | null }
    & { __typename?: 'MilestoneType' }
  ) | null, signer?: (
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
    & { __typename?: 'SignerType' }
  ) | null, assignee?: (
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'UserType' }
  ) | null, dependency?: (
    { id: string, completed?: boolean | null, forecastedEndOn?: any | null, name: string }
    & { __typename: 'MilestoneType' | 'TaskGroupType' }
  ) | (
    { id: string, completed?: boolean | null, dueOn?: any | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null }
    & { __typename: 'TaskType' }
  ) | (
    { id: string, completed?: boolean | null, name: string }
    & { __typename: 'TemplateType' }
  ) | null, tags?: Array<(
    { id: string, color: string, name: string, internalOnly: boolean }
    & { __typename?: 'TagType' }
  )> | null, taskGroup?: (
    { id: string }
    & { __typename?: 'TaskGroupType' }
  ) | null, taskParticipants?: Array<(
    { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
      { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null }
    & { __typename?: 'TaskParticipantType' }
  )> | null, dependentTasks?: Array<(
    { id: string }
    & { __typename?: 'TaskType' }
  )> | null }
  & { __typename?: 'TaskType' }
);

export type ProjectTaskCardBodyTaskFragment = (
  { id: string, taskType?: TaskTypeEnumType | null, signOffRequired: boolean, status: StatusEnumType, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, name: string, responsibility: TaskResponsibilityEnumType, visibility?: TaskVisibilityEnumType | null, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, signer?: (
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
    & { __typename?: 'SignerType' }
  ) | null, assignee?: (
    { id: string }
    & { __typename?: 'UserType' }
  ) | null, taskGroup?: (
    { id: string }
    & { __typename?: 'TaskGroupType' }
  ) | null, template?: (
    { id: string, hardDependency?: boolean | null }
    & { __typename?: 'TemplateType' }
  ) | null, dependency?: (
    { id: string, completed?: boolean | null }
    & { __typename?: 'MilestoneType' | 'TaskGroupType' | 'TaskType' | 'TemplateType' }
  ) | null, taskParticipants?: Array<(
    { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
      { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null }
    & { __typename?: 'TaskParticipantType' }
  )> | null, dependentTasks?: Array<(
    { id: string }
    & { __typename?: 'TaskType' }
  )> | null, milestone?: (
    { id: string, sortOrder: number, dependentTasks?: Array<(
      { id: string }
      & { __typename?: 'TaskType' }
    )> | null }
    & { __typename?: 'MilestoneType' }
  ) | null }
  & { __typename?: 'TaskType' }
);

export type ProjectStatusDropDownTaskFragment = (
  { id: string, status: StatusEnumType, taskType?: TaskTypeEnumType | null, signOffRequired: boolean, shouldWarnUpdateStatus?: boolean | null, taskGroup?: (
    { id: string }
    & { __typename?: 'TaskGroupType' }
  ) | null, template?: (
    { id: string, hardDependency?: boolean | null }
    & { __typename?: 'TemplateType' }
  ) | null, assignee?: (
    { id: string }
    & { __typename?: 'UserType' }
  ) | null, dependency?: (
    { id: string, completed?: boolean | null }
    & { __typename?: 'MilestoneType' | 'TaskGroupType' | 'TaskType' | 'TemplateType' }
  ) | null, dependentTasks?: Array<(
    { id: string }
    & { __typename?: 'TaskType' }
  )> | null, milestone?: (
    { id: string, sortOrder: number, dependentTasks?: Array<(
      { id: string }
      & { __typename?: 'TaskType' }
    )> | null }
    & { __typename?: 'MilestoneType' }
  ) | null }
  & { __typename?: 'TaskType' }
);

export type ProjectTaskBodyFooterTaskFragment = (
  { id: string, name: string, taskType?: TaskTypeEnumType | null, responsibility: TaskResponsibilityEnumType, visibility?: TaskVisibilityEnumType | null, signOffRequired: boolean, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, shouldWarnUpdateStatus?: boolean | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, assignee?: (
    { id: string }
    & { __typename?: 'UserType' }
  ) | null, taskParticipants?: Array<(
    { id: string, invitationSentAt?: any | null }
    & { __typename?: 'TaskParticipantType' }
  )> | null, dependency?: (
    { id: string, completed?: boolean | null }
    & { __typename?: 'MilestoneType' | 'TaskGroupType' | 'TaskType' | 'TemplateType' }
  ) | null }
  & { __typename?: 'TaskType' }
);

export type ProjectTaskInsightsTaskFragment = (
  { id: string, taskType?: TaskTypeEnumType | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, taskParticipants?: Array<(
    { id: string, completed?: boolean | null, user?: (
      { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null }
    & { __typename?: 'TaskParticipantType' }
  )> | null, assignee?: (
    { id: string }
    & { __typename?: 'UserType' }
  ) | null }
  & { __typename?: 'TaskType' }
);

export type ProjectTaskCardFooterTaskFragment = (
  { id: string, name: string, taskType?: TaskTypeEnumType | null, meetingLength?: number | null, eventDatetime?: any | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completedAt?: any | null, completed?: boolean | null, dependency?: (
    { id: string, completed?: boolean | null, forecastedEndOn?: any | null, name: string }
    & { __typename: 'MilestoneType' | 'TaskGroupType' }
  ) | (
    { id: string, completed?: boolean | null, dueOn?: any | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null }
    & { __typename: 'TaskType' }
  ) | (
    { id: string, completed?: boolean | null, name: string }
    & { __typename: 'TemplateType' }
  ) | null, tags?: Array<(
    { id: string, color: string, name: string, internalOnly: boolean }
    & { __typename?: 'TagType' }
  )> | null, assignee?: (
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'UserType' }
  ) | null }
  & { __typename?: 'TaskType' }
);

export type ProjectTaskCardFooterDatesTaskFragment = (
  { id: string, name: string, taskType?: TaskTypeEnumType | null, meetingLength?: number | null, eventDatetime?: any | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completedAt?: any | null, completed?: boolean | null, dependency?: (
    { id: string, completed?: boolean | null, forecastedEndOn?: any | null }
    & { __typename?: 'MilestoneType' | 'TaskGroupType' }
  ) | (
    { id: string, completed?: boolean | null, dueOn?: any | null }
    & { __typename?: 'TaskType' }
  ) | (
    { id: string, completed?: boolean | null }
    & { __typename?: 'TemplateType' }
  ) | null }
  & { __typename?: 'TaskType' }
);

export type ProjectTaskCardHeaderTaskFragment = (
  { id: string, name: string, taskType?: TaskTypeEnumType | null, status: StatusEnumType, sortOrder?: number | null, responsibility: TaskResponsibilityEnumType, milestone?: (
    { id: string }
    & { __typename?: 'MilestoneType' }
  ) | null, assignee?: (
    { id: string }
    & { __typename?: 'UserType' }
  ) | null }
  & { __typename?: 'TaskType' }
);

export type ProjectHeaderMenuDeleteTaskMutationVariables = Exact<{
  deleteTaskInput: DeleteTaskInput;
}>;


export type ProjectHeaderMenuDeleteTaskMutation = (
  { deleteTask?: (
    { taskReturnData?: (
      { milestone?: (
        { id: string, summaryBank: (
          { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
          & { __typename?: 'MilestoneStats' }
        ) }
        & { __typename?: 'MilestoneType' }
      ) | null }
      & { __typename?: 'TaskReturnType' }
    ) | null }
    & { __typename?: 'deleteTaskPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ProjectHeaderMenuSendAssigmentEmailMutationVariables = Exact<{
  taskId: Scalars['ID'];
}>;


export type ProjectHeaderMenuSendAssigmentEmailMutation = (
  { sendAssignmentEmail?: (
    { success?: boolean | null }
    & { __typename?: 'sendAssignmentEmailPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ProjectHeaderMenuTaskFragment = (
  { id: string, name: string, status: StatusEnumType, sortOrder?: number | null, responsibility: TaskResponsibilityEnumType, taskType?: TaskTypeEnumType | null, assignee?: (
    { id: string }
    & { __typename?: 'UserType' }
  ) | null, milestone?: (
    { id: string }
    & { __typename?: 'MilestoneType' }
  ) | null }
  & { __typename?: 'TaskType' }
);

export type ProjectTaskGroupCardTaskGroupFragment = (
  { id: string, name: string, taskCount: number, sortOrder?: number | null, startedOn?: any | null, forecastedEndOn?: any | null, completedAt?: any | null, completed?: boolean | null, summaryBank: (
    { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
    & { __typename?: 'TaskGroupStats' }
  ), tasks?: Array<(
    { id: string, status: StatusEnumType, visibility?: TaskVisibilityEnumType | null, responsibility: TaskResponsibilityEnumType, name: string, taskType?: TaskTypeEnumType | null, signOffRequired: boolean, sortOrder?: number | null, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completedAt?: any | null, completed?: boolean | null, taskGroup?: (
      { id: string }
      & { __typename?: 'TaskGroupType' }
    ) | null, template?: (
      { id: string, hardDependency?: boolean | null }
      & { __typename?: 'TemplateType' }
    ) | null, milestone?: (
      { id: string, sortOrder: number, dependentTasks?: Array<(
        { id: string }
        & { __typename?: 'TaskType' }
      )> | null }
      & { __typename?: 'MilestoneType' }
    ) | null, signer?: (
      { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
      & { __typename?: 'SignerType' }
    ) | null, assignee?: (
      { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null, dependency?: (
      { id: string, completed?: boolean | null, forecastedEndOn?: any | null, name: string }
      & { __typename: 'MilestoneType' | 'TaskGroupType' }
    ) | (
      { id: string, completed?: boolean | null, dueOn?: any | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null }
      & { __typename: 'TaskType' }
    ) | (
      { id: string, completed?: boolean | null, name: string }
      & { __typename: 'TemplateType' }
    ) | null, tags?: Array<(
      { id: string, color: string, name: string, internalOnly: boolean }
      & { __typename?: 'TagType' }
    )> | null, taskParticipants?: Array<(
      { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
        { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null }
      & { __typename?: 'TaskParticipantType' }
    )> | null, dependentTasks?: Array<(
      { id: string }
      & { __typename?: 'TaskType' }
    )> | null }
    & { __typename?: 'TaskType' }
  )> | null }
  & { __typename: 'TaskGroupType' }
);

export type UngroupedTasksFragment = (
  { tasks?: Array<(
    { id: string }
    & { __typename?: 'TaskType' }
  )> | null }
  & { __typename?: 'TaskGroupType' }
);

export type ProjectTemplateHoverInfoSummaryBankFragment = (
  { totalCompleteTasks: number, totalTasks: number, totalAssignedTasks: number, totalActualHours: number, totalEstimatedHours: number, totalRemainingHours: number, totalInternalHours: number, totalCustomerHours: number, totalThirdPartyHours: number, totalInternalRemainingHours: number, totalInternalActualHours: number, totalCustomerRemainingHours: number, totalCustomerActualHours: number, totalThirdPartyRemainingHours: number, totalThirdPartyActualHours: number, totalInternalLoggedHours: number, totalInternalLoggedBillableHours: number, totalInternalLoggedNonBillableHours: number, totalInternalRemainingPurchasedHours: number }
  & { __typename?: 'TemplateStats' }
);

export type ProjectTemplateHoverInfoProjectFragment = (
  { id: string, projectBillRate?: (
    { rateType?: RateTypeEnum | null, hours?: number | null }
    & { __typename?: 'ProjectBillRateType' }
  ) | null, organization?: (
    { timeTrackingEnabled?: boolean | null }
    & { __typename?: 'OrganizationType' }
  ) | null }
  & { __typename?: 'ProjectType' }
);

export type UseMilestoneMilestoneFragment = (
  { id: string, sortOrder: number, name: string, startedOn?: any | null, forecastedEndOn?: any | null, completedAt?: any | null, completed?: boolean | null, active: boolean, tasksAndGroups?: Array<(
    { id: string, sortOrder?: number | null, name: string, taskCount: number, startedOn?: any | null, forecastedEndOn?: any | null, completedAt?: any | null, completed?: boolean | null, tasks?: Array<(
      { id: string, sortOrder?: number | null, status: StatusEnumType, visibility?: TaskVisibilityEnumType | null, responsibility: TaskResponsibilityEnumType, priority?: PriorityEnumType | null, taskType?: TaskTypeEnumType | null, completedAt?: any | null, name: string, signOffRequired: boolean, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completed?: boolean | null, assignee?: (
        { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null, taskGroup?: (
        { id: string }
        & { __typename?: 'TaskGroupType' }
      ) | null, template?: (
        { id: string, hardDependency?: boolean | null }
        & { __typename?: 'TemplateType' }
      ) | null, milestone?: (
        { id: string, sortOrder: number, dependentTasks?: Array<(
          { id: string }
          & { __typename?: 'TaskType' }
        )> | null }
        & { __typename?: 'MilestoneType' }
      ) | null, signer?: (
        { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
        & { __typename?: 'SignerType' }
      ) | null, dependency?: (
        { id: string, completed?: boolean | null, forecastedEndOn?: any | null, name: string }
        & { __typename: 'MilestoneType' | 'TaskGroupType' }
      ) | (
        { id: string, completed?: boolean | null, dueOn?: any | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null }
        & { __typename: 'TaskType' }
      ) | (
        { id: string, completed?: boolean | null, name: string }
        & { __typename: 'TemplateType' }
      ) | null, tags?: Array<(
        { id: string, color: string, name: string, internalOnly: boolean }
        & { __typename?: 'TagType' }
      )> | null, taskParticipants?: Array<(
        { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
          { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'UserType' }
        ) | null }
        & { __typename?: 'TaskParticipantType' }
      )> | null, dependentTasks?: Array<(
        { id: string }
        & { __typename?: 'TaskType' }
      )> | null }
      & { __typename?: 'TaskType' }
    )> | null, summaryBank: (
      { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
      & { __typename?: 'TaskGroupStats' }
    ) }
    & { __typename: 'TaskGroupType' }
  ) | (
    { id: string, sortOrder?: number | null, status: StatusEnumType, visibility?: TaskVisibilityEnumType | null, responsibility: TaskResponsibilityEnumType, priority?: PriorityEnumType | null, taskType?: TaskTypeEnumType | null, completedAt?: any | null, name: string, signOffRequired: boolean, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completed?: boolean | null, assignee?: (
      { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null, template?: (
      { id: string, hardDependency?: boolean | null }
      & { __typename?: 'TemplateType' }
    ) | null, milestone?: (
      { id: string, sortOrder: number, dependentTasks?: Array<(
        { id: string }
        & { __typename?: 'TaskType' }
      )> | null }
      & { __typename?: 'MilestoneType' }
    ) | null, signer?: (
      { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
      & { __typename?: 'SignerType' }
    ) | null, dependency?: (
      { id: string, completed?: boolean | null, forecastedEndOn?: any | null, name: string }
      & { __typename: 'MilestoneType' | 'TaskGroupType' }
    ) | (
      { id: string, completed?: boolean | null, dueOn?: any | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null }
      & { __typename: 'TaskType' }
    ) | (
      { id: string, completed?: boolean | null, name: string }
      & { __typename: 'TemplateType' }
    ) | null, tags?: Array<(
      { id: string, color: string, name: string, internalOnly: boolean }
      & { __typename?: 'TagType' }
    )> | null, taskParticipants?: Array<(
      { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
        { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null }
      & { __typename?: 'TaskParticipantType' }
    )> | null, taskGroup?: (
      { id: string }
      & { __typename?: 'TaskGroupType' }
    ) | null, dependentTasks?: Array<(
      { id: string }
      & { __typename?: 'TaskType' }
    )> | null }
    & { __typename?: 'TaskType' }
  )> | null, template: (
    { id: string, hardDependency?: boolean | null }
    & { __typename?: 'TemplateType' }
  ), summaryBank: (
    { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
    & { __typename?: 'MilestoneStats' }
  ), dependentTasks?: Array<(
    { id: string }
    & { __typename?: 'TaskType' }
  )> | null }
  & { __typename?: 'MilestoneType' }
);

export type UseMilestonesFirstActiveTemplateMilestonesQueryVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type UseMilestonesFirstActiveTemplateMilestonesQuery = (
  { firstActiveTemplateMilestones?: Array<(
    { id: string, sortOrder: number, name: string, startedOn?: any | null, forecastedEndOn?: any | null, completedAt?: any | null, completed?: boolean | null, active: boolean, tasksAndGroups?: Array<(
      { id: string, sortOrder?: number | null, name: string, taskCount: number, startedOn?: any | null, forecastedEndOn?: any | null, completedAt?: any | null, completed?: boolean | null, tasks?: Array<(
        { id: string, sortOrder?: number | null, status: StatusEnumType, visibility?: TaskVisibilityEnumType | null, responsibility: TaskResponsibilityEnumType, priority?: PriorityEnumType | null, taskType?: TaskTypeEnumType | null, completedAt?: any | null, name: string, signOffRequired: boolean, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completed?: boolean | null, assignee?: (
          { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'UserType' }
        ) | null, taskGroup?: (
          { id: string }
          & { __typename?: 'TaskGroupType' }
        ) | null, template?: (
          { id: string, hardDependency?: boolean | null }
          & { __typename?: 'TemplateType' }
        ) | null, milestone?: (
          { id: string, sortOrder: number, dependentTasks?: Array<(
            { id: string }
            & { __typename?: 'TaskType' }
          )> | null }
          & { __typename?: 'MilestoneType' }
        ) | null, signer?: (
          { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
          & { __typename?: 'SignerType' }
        ) | null, dependency?: (
          { id: string, completed?: boolean | null, forecastedEndOn?: any | null, name: string }
          & { __typename: 'MilestoneType' | 'TaskGroupType' }
        ) | (
          { id: string, completed?: boolean | null, dueOn?: any | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null }
          & { __typename: 'TaskType' }
        ) | (
          { id: string, completed?: boolean | null, name: string }
          & { __typename: 'TemplateType' }
        ) | null, tags?: Array<(
          { id: string, color: string, name: string, internalOnly: boolean }
          & { __typename?: 'TagType' }
        )> | null, taskParticipants?: Array<(
          { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
            { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
              { originalUrl?: string | null }
              & { __typename?: 'ImageType' }
            ) | null }
            & { __typename?: 'UserType' }
          ) | null }
          & { __typename?: 'TaskParticipantType' }
        )> | null, dependentTasks?: Array<(
          { id: string }
          & { __typename?: 'TaskType' }
        )> | null }
        & { __typename?: 'TaskType' }
      )> | null, summaryBank: (
        { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
        & { __typename?: 'TaskGroupStats' }
      ) }
      & { __typename: 'TaskGroupType' }
    ) | (
      { id: string, sortOrder?: number | null, status: StatusEnumType, visibility?: TaskVisibilityEnumType | null, responsibility: TaskResponsibilityEnumType, priority?: PriorityEnumType | null, taskType?: TaskTypeEnumType | null, completedAt?: any | null, name: string, signOffRequired: boolean, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completed?: boolean | null, assignee?: (
        { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null, template?: (
        { id: string, hardDependency?: boolean | null }
        & { __typename?: 'TemplateType' }
      ) | null, milestone?: (
        { id: string, sortOrder: number, dependentTasks?: Array<(
          { id: string }
          & { __typename?: 'TaskType' }
        )> | null }
        & { __typename?: 'MilestoneType' }
      ) | null, signer?: (
        { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
        & { __typename?: 'SignerType' }
      ) | null, dependency?: (
        { id: string, completed?: boolean | null, forecastedEndOn?: any | null, name: string }
        & { __typename: 'MilestoneType' | 'TaskGroupType' }
      ) | (
        { id: string, completed?: boolean | null, dueOn?: any | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null }
        & { __typename: 'TaskType' }
      ) | (
        { id: string, completed?: boolean | null, name: string }
        & { __typename: 'TemplateType' }
      ) | null, tags?: Array<(
        { id: string, color: string, name: string, internalOnly: boolean }
        & { __typename?: 'TagType' }
      )> | null, taskParticipants?: Array<(
        { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
          { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'UserType' }
        ) | null }
        & { __typename?: 'TaskParticipantType' }
      )> | null, taskGroup?: (
        { id: string }
        & { __typename?: 'TaskGroupType' }
      ) | null, dependentTasks?: Array<(
        { id: string }
        & { __typename?: 'TaskType' }
      )> | null }
      & { __typename?: 'TaskType' }
    )> | null, template: (
      { id: string, hardDependency?: boolean | null }
      & { __typename?: 'TemplateType' }
    ), summaryBank: (
      { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
      & { __typename?: 'MilestoneStats' }
    ), dependentTasks?: Array<(
      { id: string }
      & { __typename?: 'TaskType' }
    )> | null }
    & { __typename?: 'MilestoneType' }
  )> | null }
  & { __typename?: 'Query' }
);

export type UseMilestonesProjectMilestonesQueryVariables = Exact<{
  templateId: Scalars['ID'];
  taskFilters?: InputMaybe<TaskFilters>;
  handleExactMultiRoles?: InputMaybe<Scalars['Boolean']>;
}>;


export type UseMilestonesProjectMilestonesQuery = (
  { projectMilestones?: Array<(
    { id: string, sortOrder: number, name: string, startedOn?: any | null, forecastedEndOn?: any | null, completedAt?: any | null, completed?: boolean | null, active: boolean, tasksAndGroups?: Array<(
      { id: string, sortOrder?: number | null, name: string, taskCount: number, startedOn?: any | null, forecastedEndOn?: any | null, completedAt?: any | null, completed?: boolean | null, tasks?: Array<(
        { id: string, sortOrder?: number | null, status: StatusEnumType, visibility?: TaskVisibilityEnumType | null, responsibility: TaskResponsibilityEnumType, priority?: PriorityEnumType | null, taskType?: TaskTypeEnumType | null, completedAt?: any | null, name: string, signOffRequired: boolean, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completed?: boolean | null, assignee?: (
          { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'UserType' }
        ) | null, taskGroup?: (
          { id: string }
          & { __typename?: 'TaskGroupType' }
        ) | null, template?: (
          { id: string, hardDependency?: boolean | null }
          & { __typename?: 'TemplateType' }
        ) | null, milestone?: (
          { id: string, sortOrder: number, dependentTasks?: Array<(
            { id: string }
            & { __typename?: 'TaskType' }
          )> | null }
          & { __typename?: 'MilestoneType' }
        ) | null, signer?: (
          { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
          & { __typename?: 'SignerType' }
        ) | null, dependency?: (
          { id: string, completed?: boolean | null, forecastedEndOn?: any | null, name: string }
          & { __typename: 'MilestoneType' | 'TaskGroupType' }
        ) | (
          { id: string, completed?: boolean | null, dueOn?: any | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null }
          & { __typename: 'TaskType' }
        ) | (
          { id: string, completed?: boolean | null, name: string }
          & { __typename: 'TemplateType' }
        ) | null, tags?: Array<(
          { id: string, color: string, name: string, internalOnly: boolean }
          & { __typename?: 'TagType' }
        )> | null, taskParticipants?: Array<(
          { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
            { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
              { originalUrl?: string | null }
              & { __typename?: 'ImageType' }
            ) | null }
            & { __typename?: 'UserType' }
          ) | null }
          & { __typename?: 'TaskParticipantType' }
        )> | null, dependentTasks?: Array<(
          { id: string }
          & { __typename?: 'TaskType' }
        )> | null }
        & { __typename?: 'TaskType' }
      )> | null, summaryBank: (
        { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
        & { __typename?: 'TaskGroupStats' }
      ) }
      & { __typename: 'TaskGroupType' }
    ) | (
      { id: string, sortOrder?: number | null, status: StatusEnumType, visibility?: TaskVisibilityEnumType | null, responsibility: TaskResponsibilityEnumType, priority?: PriorityEnumType | null, taskType?: TaskTypeEnumType | null, completedAt?: any | null, name: string, signOffRequired: boolean, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completed?: boolean | null, assignee?: (
        { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null, template?: (
        { id: string, hardDependency?: boolean | null }
        & { __typename?: 'TemplateType' }
      ) | null, milestone?: (
        { id: string, sortOrder: number, dependentTasks?: Array<(
          { id: string }
          & { __typename?: 'TaskType' }
        )> | null }
        & { __typename?: 'MilestoneType' }
      ) | null, signer?: (
        { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
        & { __typename?: 'SignerType' }
      ) | null, dependency?: (
        { id: string, completed?: boolean | null, forecastedEndOn?: any | null, name: string }
        & { __typename: 'MilestoneType' | 'TaskGroupType' }
      ) | (
        { id: string, completed?: boolean | null, dueOn?: any | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null }
        & { __typename: 'TaskType' }
      ) | (
        { id: string, completed?: boolean | null, name: string }
        & { __typename: 'TemplateType' }
      ) | null, tags?: Array<(
        { id: string, color: string, name: string, internalOnly: boolean }
        & { __typename?: 'TagType' }
      )> | null, taskParticipants?: Array<(
        { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
          { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'UserType' }
        ) | null }
        & { __typename?: 'TaskParticipantType' }
      )> | null, taskGroup?: (
        { id: string }
        & { __typename?: 'TaskGroupType' }
      ) | null, dependentTasks?: Array<(
        { id: string }
        & { __typename?: 'TaskType' }
      )> | null }
      & { __typename?: 'TaskType' }
    )> | null, template: (
      { id: string, hardDependency?: boolean | null }
      & { __typename?: 'TemplateType' }
    ), summaryBank: (
      { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
      & { __typename?: 'MilestoneStats' }
    ), dependentTasks?: Array<(
      { id: string }
      & { __typename?: 'TaskType' }
    )> | null }
    & { __typename?: 'MilestoneType' }
  )> | null }
  & { __typename?: 'Query' }
);

export type MoveTasksWithinTaskGroupInProjectMutationVariables = Exact<{
  input: SortTaskTaskGroupInput;
}>;


export type MoveTasksWithinTaskGroupInProjectMutation = (
  { sortProjectTaskTaskGroup?: (
    { sortedElement?: { __typename?: 'TaskGroupType' } | (
      { id: string, sortOrder?: number | null, status: StatusEnumType, visibility?: TaskVisibilityEnumType | null, responsibility: TaskResponsibilityEnumType, name: string, taskType?: TaskTypeEnumType | null, signOffRequired: boolean, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completedAt?: any | null, completed?: boolean | null, template?: (
        { id: string, hardDependency?: boolean | null }
        & { __typename?: 'TemplateType' }
      ) | null, milestone?: (
        { id: string, sortOrder: number, dependentTasks?: Array<(
          { id: string }
          & { __typename?: 'TaskType' }
        )> | null }
        & { __typename?: 'MilestoneType' }
      ) | null, signer?: (
        { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
        & { __typename?: 'SignerType' }
      ) | null, assignee?: (
        { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null, dependency?: (
        { id: string, completed?: boolean | null, forecastedEndOn?: any | null, name: string }
        & { __typename: 'MilestoneType' | 'TaskGroupType' }
      ) | (
        { id: string, completed?: boolean | null, dueOn?: any | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null }
        & { __typename: 'TaskType' }
      ) | (
        { id: string, completed?: boolean | null, name: string }
        & { __typename: 'TemplateType' }
      ) | null, tags?: Array<(
        { id: string, color: string, name: string, internalOnly: boolean }
        & { __typename?: 'TagType' }
      )> | null, taskParticipants?: Array<(
        { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
          { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'UserType' }
        ) | null }
        & { __typename?: 'TaskParticipantType' }
      )> | null, taskGroup?: (
        { id: string }
        & { __typename?: 'TaskGroupType' }
      ) | null, dependentTasks?: Array<(
        { id: string }
        & { __typename?: 'TaskType' }
      )> | null }
      & { __typename?: 'TaskType' }
    ) | null }
    & { __typename?: 'sortProjectTaskTaskGroupPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type MoveTaskGroupToAnotherMilestoneInProjectMutationVariables = Exact<{
  input: MoveTaskGroupInput;
}>;


export type MoveTaskGroupToAnotherMilestoneInProjectMutation = (
  { moveToAnotherProjectMilestone?: (
    { taskGroup?: (
      { id: string, sortOrder?: number | null }
      & { __typename?: 'TaskGroupType' }
    ) | null }
    & { __typename?: 'moveToAnotherProjectMilestonePayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ProjectUseSortingUpdateProjectTaskMutationVariables = Exact<{
  input: UpdateTaskInput;
}>;


export type ProjectUseSortingUpdateProjectTaskMutation = (
  { updateProjectTaskGroupTask?: (
    { taskReturnData?: (
      { task?: (
        { name: string }
        & { __typename?: 'TaskType' }
      ) | null }
      & { __typename?: 'TaskReturnType' }
    ) | null }
    & { __typename?: 'updateProjectTaskGroupTaskPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ProjectUseSortingUpdateMilestoneMutationVariables = Exact<{
  milestone: UpdateTemplateMilestoneInput;
}>;


export type ProjectUseSortingUpdateMilestoneMutation = (
  { updateTemplateMilestone?: (
    { milestone?: (
      { id: string, sortOrder: number }
      & { __typename?: 'MilestoneType' }
    ) | null }
    & { __typename?: 'updateTemplateMilestonePayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ProjectUseSortingCheckDropEligibilityQueryVariables = Exact<{
  input: DropInput;
}>;


export type ProjectUseSortingCheckDropEligibilityQuery = (
  { dropEligibility?: (
    { eligibility?: boolean | null, message?: string | null }
    & { __typename?: 'DropEligibilityType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type TaskGroupTasksFragment = (
  { tasks?: Array<(
    { id: string, sortOrder?: number | null }
    & { __typename?: 'TaskType' }
  )> | null }
  & { __typename?: 'TaskGroupType' }
);

export type PublicProjectOverviewRequestAccessMutationVariables = Exact<{
  userData: SubmitRequestAccessInput;
}>;


export type PublicProjectOverviewRequestAccessMutation = (
  { submitRequestAccess?: (
    { success?: boolean | null }
    & { __typename?: 'submitRequestAccessPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type MentionControlProjectTeamFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, projectContext?: UserProjectOrganizationTypeEnumType | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, organization?: (
    { id: string }
    & { __typename?: 'OrganizationType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type UpsertSkillFragment = (
  { id: string }
  & { __typename?: 'Skill' }
);

export type SkillDialogFragment = (
  { id: string, name: string, billableRate: number, userCount: number, category: (
    { id: string, name: string, skillCount: number, userCount: number }
    & { __typename?: 'SkillCategory' }
  ), users: Array<(
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null }
    & { __typename?: 'UserType' }
  )> }
  & { __typename?: 'Skill' }
);

export type SkillDialogSkillCategoriesQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type SkillDialogSkillCategoriesQuery = (
  { organization?: (
    { skillCategories: Array<(
      { id: string, name: string, skillCount: number, userCount: number }
      & { __typename?: 'SkillCategory' }
    )> }
    & { __typename?: 'OrganizationType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type SkillDialogUpsertSkillMutationVariables = Exact<{
  input: UpsertSkillInput;
}>;


export type SkillDialogUpsertSkillMutation = (
  { upsertSkill?: (
    { skill: (
      { id: string, name: string, billableRate: number, userCount: number, category: (
        { id: string, name: string, skillCount: number, userCount: number }
        & { __typename?: 'SkillCategory' }
      ), users: Array<(
        { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null }
        & { __typename?: 'UserType' }
      )> }
      & { __typename?: 'Skill' }
    ) }
    & { __typename?: 'upsertSkillPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type SkillDialogSkillQueryVariables = Exact<{
  skillId: Scalars['ID'];
}>;


export type SkillDialogSkillQuery = (
  { skill: (
    { id: string, name: string, billableRate: number, userCount: number, category: (
      { id: string, name: string, skillCount: number, userCount: number }
      & { __typename?: 'SkillCategory' }
    ), users: Array<(
      { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null }
      & { __typename?: 'UserType' }
    )> }
    & { __typename?: 'Skill' }
  ) }
  & { __typename?: 'Query' }
);

export type SkillDialogCheckPendingTasksRoleQueryVariables = Exact<{
  roleId: Scalars['ID'];
  unassignUserIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type SkillDialogCheckPendingTasksRoleQuery = (
  { checkPendingTasksRole?: Array<(
    { id: string, firstName?: string | null }
    & { __typename?: 'UserType' }
  )> | null }
  & { __typename?: 'Query' }
);

export type SkillDialogDeleteSkillMutationVariables = Exact<{
  skillId: Scalars['ID'];
}>;


export type SkillDialogDeleteSkillMutation = (
  { deleteSkill?: (
    { success: boolean }
    & { __typename?: 'deleteSkillPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type TagsAvailableTagsFragment = (
  { id: string, color: string, name: string, internalOnly: boolean }
  & { __typename?: 'TagType' }
);

export type TagsAvailableTagsQueryVariables = Exact<{
  taggableId: Scalars['ID'];
  type?: InputMaybe<Scalars['String']>;
  taggableType: TaggableEnumType;
}>;


export type TagsAvailableTagsQuery = (
  { availableTags?: Array<(
    { id: string, color: string, name: string, internalOnly: boolean }
    & { __typename?: 'TagType' }
  )> | null }
  & { __typename?: 'Query' }
);

export type TagColorItemAddTagMutationVariables = Exact<{
  tagInput: AddTagInput;
}>;


export type TagColorItemAddTagMutation = (
  { addTag?: (
    { taggable?: (
      { id: string, tags?: Array<(
        { id: string, color: string, name: string, internalOnly: boolean }
        & { __typename?: 'TagType' }
      )> | null }
      & { __typename?: 'ActionItemType' | 'ProjectType' | 'TaskType' }
    ) | null }
    & { __typename?: 'addTagPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type TagsCreateAvailableTagMutationVariables = Exact<{
  availableTagInput: CreateAvailableTagInput;
}>;


export type TagsCreateAvailableTagMutation = (
  { createAvailableTag?: (
    { tag?: (
      { id: string, color: string, name: string, internalOnly: boolean }
      & { __typename?: 'TagType' }
    ) | null }
    & { __typename?: 'createAvailableTagPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type TagColorItemTagFragment = (
  { id: string, color: string, name: string, internalOnly: boolean }
  & { __typename?: 'TagType' }
);

export type TagColorItemDeleteAvailableTagMutationVariables = Exact<{
  availableTagInput: DeleteAvailableTagInput;
}>;


export type TagColorItemDeleteAvailableTagMutation = (
  { deleteAvailableTag?: (
    { tag?: (
      { id: string, color: string, name: string, internalOnly: boolean }
      & { __typename?: 'TagType' }
    ) | null }
    & { __typename?: 'deleteAvailableTagPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type TagColorItemEditAvailableTagMutationVariables = Exact<{
  availableTagInput: UpdateAvailableTagInput;
}>;


export type TagColorItemEditAvailableTagMutation = (
  { updateAvailableTag?: (
    { tag?: (
      { id: string, color: string, name: string, internalOnly: boolean }
      & { __typename?: 'TagType' }
    ) | null }
    & { __typename?: 'updateAvailableTagPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type TagColorItemRemoveTagMutationVariables = Exact<{
  tagInput: RemoveTagInput;
}>;


export type TagColorItemRemoveTagMutation = (
  { removeTag?: (
    { taggable?: (
      { id: string, tags?: Array<(
        { id: string, color: string, name: string, internalOnly: boolean }
        & { __typename?: 'TagType' }
      )> | null }
      & { __typename?: 'ActionItemType' | 'ProjectType' | 'TaskType' }
    ) | null }
    & { __typename?: 'removeTagPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type TagsBarTagFragment = (
  { id: string, color: string, name: string, internalOnly: boolean }
  & { __typename?: 'TagType' }
);

export type MissingTimeEntriesCardTaskFragment = (
  { id: string, project?: (
    { id: string, projectType: ProjectTypeEnumType, displayOrganization?: (
      { name: string, logo?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'DisplayOrganizationType' }
    ) | null, customer?: (
      { id: string, name: string, logo?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'PublicCustomer' }
    ) | null }
    & { __typename?: 'PublicProject' }
  ) | null, milestone: (
    { id: string }
    & { __typename?: 'PublicMilestone' }
  ), template: (
    { id: string }
    & { __typename?: 'PublicTemplate' }
  ) }
  & { __typename?: 'PublicTask' }
);

export type TaskStatusDropdownProjectFragment = (
  { id: string, name: string, pmDisplayRole?: string | null, currentUserProjectContext?: UserProjectOrganizationTypeEnumType | null, projectManager?: (
    { firstName?: string | null, lastName?: string | null }
    & { __typename?: 'UserType' }
  ) | null }
  & { __typename?: 'ProjectType' }
);

export type DeleteUserDialogUserTasksConnectionsQueryVariables = Exact<{
  userId: Scalars['ID'];
  taskFilters?: InputMaybe<TaskFilters>;
  listInputs?: InputMaybe<ListInput>;
}>;


export type DeleteUserDialogUserTasksConnectionsQuery = (
  { userTasksConnections?: (
    { tasks?: Array<(
      { id: string, name: string, description?: string | null, status: StatusEnumType, project?: (
        { id: string, name: string, status: StatusEnumType, organization?: (
          { id: string }
          & { __typename?: 'OrganizationType' }
        ) | null }
        & { __typename?: 'ProjectType' }
      ) | null }
      & { __typename?: 'TaskType' }
    )> | null }
    & { __typename?: 'TaskConnectionType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type TeamCardUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, lastActivityAt?: any | null, status?: string | null, jobRole?: string | null, organizationName?: string | null, phone?: string | null, email?: string | null, hidePhone?: boolean | null, hideEmail?: boolean | null, projectContext?: UserProjectOrganizationTypeEnumType | null, notificationPreferences?: (
    { projectOverviewEmailPref?: ProjectOverviewEmailPrefEnumType | null, taskReminderEmailPref?: TaskReminderEmailPref | null, overdueEmailPref?: boolean | null, stuckEmailPref?: boolean | null, doneEmailPref?: boolean | null, overduePref?: boolean | null, stuckPref?: boolean | null, donePref?: boolean | null }
    & { __typename?: 'NotificationPreferenceType' }
  ) | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, organization?: (
    { id: string, name?: string | null, type?: OrganizationTypeEnumType | null, logo?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'OrganizationType' }
  ) | null, displayOrganization?: (
    { name: string, logo?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'DisplayOrganizationType' }
  ) | null, projectSettings?: (
    { projectView?: ProjectViewEnum | null, restrictAccess: boolean }
    & { __typename?: 'UserProject' }
  ) | null, skills: Array<(
    { id: string, name: string, category: (
      { id: string, name: string }
      & { __typename?: 'SkillCategory' }
    ) }
    & { __typename?: 'Skill' }
  )> }
  & { __typename?: 'UserType' }
);

export type TeamCardUserProjectStatsQueryVariables = Exact<{
  userId: Scalars['ID'];
  projectId: Scalars['ID'];
}>;


export type TeamCardUserProjectStatsQuery = (
  { userProjectStats?: (
    { totalDoneTasks?: number | null, totalRemainingTasks?: number | null, totalPlannedTasks?: number | null, totalOverdueTasks?: number | null, activeOverdueTasks?: number | null }
    & { __typename?: 'UserProjectStatsType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type TeamCardResendInvitationMutationVariables = Exact<{
  email: Scalars['String'];
  projectId?: InputMaybe<Scalars['ID']>;
}>;


export type TeamCardResendInvitationMutation = (
  { resendInviteToUser?: (
    { success?: boolean | null }
    & { __typename?: 'resendInviteToUserPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type TeamMemberSkillsSkillFragment = (
  { id: string, name: string, category: (
    { id: string, name: string }
    & { __typename?: 'SkillCategory' }
  ) }
  & { __typename?: 'Skill' }
);

export type TemplatePlanTemplateV2Fragment = (
  { id: string, organization: (
    { id: string, defaultTaskVisibility?: TaskVisibilityEnumType | null }
    & { __typename?: 'OrganizationType' }
  ) }
  & { __typename?: 'TemplateType' }
);

export type TemplatePlanAvailableTagsFragment = (
  { id: string, color: string, name: string, internalOnly: boolean }
  & { __typename?: 'TagType' }
);

export type TemplatePlanAvailableTagsQueryVariables = Exact<{
  taggableId: Scalars['ID'];
  type?: InputMaybe<Scalars['String']>;
  taggableType: TaggableEnumType;
}>;


export type TemplatePlanAvailableTagsQuery = (
  { availableTags?: Array<(
    { id: string, color: string, name: string, internalOnly: boolean }
    & { __typename?: 'TagType' }
  )> | null }
  & { __typename?: 'Query' }
);

export type TemplatePlanTemplateQueryVariables = Exact<{
  templateId: Scalars['ID'];
}>;


export type TemplatePlanTemplateQuery = (
  { blueprintTemplate: (
    { id: string, organization: (
      { id: string, defaultTaskVisibility?: TaskVisibilityEnumType | null }
      & { __typename?: 'OrganizationType' }
    ) }
    & { __typename?: 'TemplateType' }
  ) }
  & { __typename?: 'Query' }
);

export type TemplatePlanCreateTaskV2MutationVariables = Exact<{
  taskInputs: CreateTaskInput;
}>;


export type TemplatePlanCreateTaskV2Mutation = (
  { createTask?: (
    { taskReturnData?: (
      { task?: (
        { id: string, status: StatusEnumType, priority?: PriorityEnumType | null, responsibility: TaskResponsibilityEnumType, taskType?: TaskTypeEnumType | null, visibility?: TaskVisibilityEnumType | null, name: string, signOffRequired: boolean, sortOrder?: number | null, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completedAt?: any | null, template?: (
          { id: string, duration?: number | null, hardDependency?: boolean | null }
          & { __typename?: 'TemplateType' }
        ) | null, milestone?: (
          { id: string, sortOrder: number, dependentTasks?: Array<(
            { id: string }
            & { __typename?: 'TaskType' }
          )> | null }
          & { __typename?: 'MilestoneType' }
        ) | null, signer?: (
          { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
          & { __typename?: 'SignerType' }
        ) | null, assignee?: (
          { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'UserType' }
        ) | null, dependency?: (
          { id: string, completed?: boolean | null, name: string, forecastedEndOn?: any | null }
          & { __typename: 'MilestoneType' | 'TaskGroupType' }
        ) | (
          { id: string, completed?: boolean | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null, dueOn?: any | null }
          & { __typename: 'TaskType' }
        ) | (
          { id: string, completed?: boolean | null, name: string }
          & { __typename: 'TemplateType' }
        ) | null, tags?: Array<(
          { id: string, color: string, name: string, internalOnly: boolean }
          & { __typename?: 'TagType' }
        )> | null, taskParticipants?: Array<(
          { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
            { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
              { originalUrl?: string | null }
              & { __typename?: 'ImageType' }
            ) | null }
            & { __typename?: 'UserType' }
          ) | null }
          & { __typename?: 'TaskParticipantType' }
        )> | null, taskGroup?: (
          { id: string }
          & { __typename?: 'TaskGroupType' }
        ) | null, dependentTasks?: Array<(
          { id: string }
          & { __typename?: 'TaskType' }
        )> | null }
        & { __typename?: 'TaskType' }
      ) | null }
      & { __typename?: 'TaskReturnType' }
    ) | null }
    & { __typename?: 'createTaskPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type TemplateBulkEditDrawerTaskFragment = (
  { id: string, status: StatusEnumType, priority?: PriorityEnumType | null, responsibility: TaskResponsibilityEnumType, taskType?: TaskTypeEnumType | null, visibility?: TaskVisibilityEnumType | null }
  & { __typename?: 'TaskType' }
);

export type TemplateBulkEditDrawerUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, projectContext?: UserProjectOrganizationTypeEnumType | null, role?: UserRoleEnumType | null, jobRole?: string | null, organizationName?: string | null, skills: Array<(
    { id: string }
    & { __typename?: 'Skill' }
  )>, organization?: (
    { id: string, type?: OrganizationTypeEnumType | null, name?: string | null }
    & { __typename?: 'OrganizationType' }
  ) | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, displayOrganization?: (
    { name: string }
    & { __typename?: 'DisplayOrganizationType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type TemplateBulkEditDrawerMilestoneFragment = (
  { id: string }
  & { __typename?: 'MilestoneType' }
);

export type TemplateBulkEditDrawerTemplateFragment = (
  { id: string, organization: (
    { id: string }
    & { __typename?: 'OrganizationType' }
  ) }
  & { __typename?: 'TemplateType' }
);

export type TemplateBulkEditFormTaskGroupDependenciesConflictQueryVariables = Exact<{
  taskGroupId: Scalars['ID'];
  taskIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type TemplateBulkEditFormTaskGroupDependenciesConflictQuery = (
  { taskGroupDependenciesConflict: boolean }
  & { __typename?: 'Query' }
);

export type TemplateBulkEditFormBulkEditTasksMutationVariables = Exact<{
  input: BulkEditTasksInput;
}>;


export type TemplateBulkEditFormBulkEditTasksMutation = (
  { bulkEditTasks?: (
    { updatedTasks?: Array<(
      { id: string, status: StatusEnumType, priority?: PriorityEnumType | null, responsibility: TaskResponsibilityEnumType, taskType?: TaskTypeEnumType | null, visibility?: TaskVisibilityEnumType | null, assignee?: (
        { id: string }
        & { __typename?: 'UserType' }
      ) | null, tags?: Array<(
        { id: string }
        & { __typename?: 'TagType' }
      )> | null, watchers?: Array<(
        { id: string }
        & { __typename?: 'UserType' }
      )> | null, skill?: (
        { id: string, name: string, category: (
          { id: string, name: string }
          & { __typename?: 'SkillCategory' }
        ) }
        & { __typename?: 'Skill' }
      ) | null }
      & { __typename?: 'TaskType' }
    ) | null> | null }
    & { __typename?: 'bulkEditTasksPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type TemplateBulkEditFormAssigneesQueryVariables = Exact<{
  milestoneId: Scalars['ID'];
  organizationId?: InputMaybe<Scalars['ID']>;
}>;


export type TemplateBulkEditFormAssigneesQuery = (
  { potentialTaskAssignees?: Array<(
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, projectContext?: UserProjectOrganizationTypeEnumType | null, role?: UserRoleEnumType | null, jobRole?: string | null, organizationName?: string | null, skills: Array<(
      { id: string }
      & { __typename?: 'Skill' }
    )>, organization?: (
      { id: string, type?: OrganizationTypeEnumType | null, name?: string | null }
      & { __typename?: 'OrganizationType' }
    ) | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null, displayOrganization?: (
      { name: string }
      & { __typename?: 'DisplayOrganizationType' }
    ) | null }
    & { __typename?: 'UserType' }
  )> | null }
  & { __typename?: 'Query' }
);

export type TemplateBulkEditFormCommonTaskWatchersQueryVariables = Exact<{
  taskIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type TemplateBulkEditFormCommonTaskWatchersQuery = (
  { commonTaskWatchers?: Array<(
    { id: string, email?: string | null, firstName?: string | null, lastName?: string | null, jobRole?: string | null, organizationName?: string | null, organization?: (
      { id: string, name?: string | null }
      & { __typename?: 'OrganizationType' }
    ) | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null, displayOrganization?: (
      { name: string }
      & { __typename?: 'DisplayOrganizationType' }
    ) | null }
    & { __typename?: 'UserType' }
  )> | null }
  & { __typename?: 'Query' }
);

export type TemplateBulkEditFormTagsQueryVariables = Exact<{
  taggableId: Scalars['ID'];
  type?: InputMaybe<Scalars['String']>;
  taggableType: TaggableEnumType;
}>;


export type TemplateBulkEditFormTagsQuery = (
  { availableTags?: Array<(
    { id: string, name: string, color: string }
    & { __typename?: 'TagType' }
  )> | null }
  & { __typename?: 'Query' }
);

export type TemplateBulkEditFormMilestoneFragment = (
  { id: string }
  & { __typename?: 'MilestoneType' }
);

export type TemplateBulkEditFormTaskFragment = (
  { id: string, status: StatusEnumType, priority?: PriorityEnumType | null, responsibility: TaskResponsibilityEnumType, taskType?: TaskTypeEnumType | null, visibility?: TaskVisibilityEnumType | null }
  & { __typename?: 'TaskType' }
);

export type TemplateBulkEditFormTemplateFragment = (
  { id: string, organization: (
    { id: string }
    & { __typename?: 'OrganizationType' }
  ) }
  & { __typename?: 'TemplateType' }
);

export type TemplateBulkEditFormUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, projectContext?: UserProjectOrganizationTypeEnumType | null, role?: UserRoleEnumType | null, jobRole?: string | null, organizationName?: string | null, skills: Array<(
    { id: string }
    & { __typename?: 'Skill' }
  )>, organization?: (
    { id: string, type?: OrganizationTypeEnumType | null, name?: string | null }
    & { __typename?: 'OrganizationType' }
  ) | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, displayOrganization?: (
    { name: string }
    & { __typename?: 'DisplayOrganizationType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type TemplateMilestoneBoardMilestoneUpdatedSubscriptionVariables = Exact<{
  templateId: Scalars['ID'];
}>;


export type TemplateMilestoneBoardMilestoneUpdatedSubscription = (
  { milestoneUpdated?: (
    { milestone?: (
      { id: string, duration?: number | null, completed?: boolean | null, startedOn?: any | null, name: string, forecastedEndOn?: any | null, completedAt?: any | null, active: boolean, sortOrder: number, summaryBank: (
        { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
        & { __typename?: 'MilestoneStats' }
      ), dependentTasks?: Array<(
        { id: string }
        & { __typename?: 'TaskType' }
      )> | null, template: (
        { id: string, hardDependency?: boolean | null }
        & { __typename?: 'TemplateType' }
      ) }
      & { __typename?: 'MilestoneType' }
    ) | null, milestoneStats?: (
      { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
      & { __typename?: 'MilestoneStats' }
    ) | null }
    & { __typename?: 'MilestoneUpdatePayloadType' }
  ) | null }
  & { __typename?: 'Subscription' }
);

export type TemplateMilestoneBoardMilestoneFragment = (
  { id: string, sortOrder: number, name: string, startedOn?: any | null, forecastedEndOn?: any | null, completedAt?: any | null, active: boolean, tasksAndGroups?: Array<(
    { id: string, name: string, taskCount: number, sortOrder?: number | null, startedOn?: any | null, forecastedEndOn?: any | null, completedAt?: any | null, tasks?: Array<(
      { id: string, sortOrder?: number | null, status: StatusEnumType, visibility?: TaskVisibilityEnumType | null, responsibility: TaskResponsibilityEnumType, name: string, taskType?: TaskTypeEnumType | null, signOffRequired: boolean, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completedAt?: any | null, taskGroup?: (
        { id: string }
        & { __typename?: 'TaskGroupType' }
      ) | null, milestone?: (
        { id: string, sortOrder: number, dependentTasks?: Array<(
          { id: string }
          & { __typename?: 'TaskType' }
        )> | null }
        & { __typename?: 'MilestoneType' }
      ) | null, signer?: (
        { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
        & { __typename?: 'SignerType' }
      ) | null, assignee?: (
        { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null, dependency?: (
        { id: string, completed?: boolean | null, name: string, forecastedEndOn?: any | null }
        & { __typename: 'MilestoneType' | 'TaskGroupType' }
      ) | (
        { id: string, completed?: boolean | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null, dueOn?: any | null }
        & { __typename: 'TaskType' }
      ) | (
        { id: string, completed?: boolean | null, name: string }
        & { __typename: 'TemplateType' }
      ) | null, tags?: Array<(
        { id: string, color: string, name: string, internalOnly: boolean }
        & { __typename?: 'TagType' }
      )> | null, taskParticipants?: Array<(
        { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
          { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'UserType' }
        ) | null }
        & { __typename?: 'TaskParticipantType' }
      )> | null, template?: (
        { id: string, hardDependency?: boolean | null }
        & { __typename?: 'TemplateType' }
      ) | null, dependentTasks?: Array<(
        { id: string }
        & { __typename?: 'TaskType' }
      )> | null }
      & { __typename?: 'TaskType' }
    )> | null, summaryBank: (
      { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
      & { __typename?: 'TaskGroupStats' }
    ) }
    & { __typename: 'TaskGroupType' }
  ) | (
    { id: string, sortOrder?: number | null, status: StatusEnumType, visibility?: TaskVisibilityEnumType | null, responsibility: TaskResponsibilityEnumType, name: string, taskType?: TaskTypeEnumType | null, signOffRequired: boolean, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completedAt?: any | null, milestone?: (
      { id: string, sortOrder: number, dependentTasks?: Array<(
        { id: string }
        & { __typename?: 'TaskType' }
      )> | null }
      & { __typename?: 'MilestoneType' }
    ) | null, signer?: (
      { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
      & { __typename?: 'SignerType' }
    ) | null, assignee?: (
      { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null, dependency?: (
      { id: string, completed?: boolean | null, name: string, forecastedEndOn?: any | null }
      & { __typename: 'MilestoneType' | 'TaskGroupType' }
    ) | (
      { id: string, completed?: boolean | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null, dueOn?: any | null }
      & { __typename: 'TaskType' }
    ) | (
      { id: string, completed?: boolean | null, name: string }
      & { __typename: 'TemplateType' }
    ) | null, tags?: Array<(
      { id: string, color: string, name: string, internalOnly: boolean }
      & { __typename?: 'TagType' }
    )> | null, taskParticipants?: Array<(
      { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
        { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null }
      & { __typename?: 'TaskParticipantType' }
    )> | null, taskGroup?: (
      { id: string }
      & { __typename?: 'TaskGroupType' }
    ) | null, template?: (
      { id: string, hardDependency?: boolean | null }
      & { __typename?: 'TemplateType' }
    ) | null, dependentTasks?: Array<(
      { id: string }
      & { __typename?: 'TaskType' }
    )> | null }
    & { __typename?: 'TaskType' }
  )> | null, template: (
    { id: string, hardDependency?: boolean | null }
    & { __typename?: 'TemplateType' }
  ), summaryBank: (
    { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
    & { __typename?: 'MilestoneStats' }
  ), dependentTasks?: Array<(
    { id: string }
    & { __typename?: 'TaskType' }
  )> | null }
  & { __typename?: 'MilestoneType' }
);

export type TemplateMilestoneBoardTaskFragment = (
  { id: string, status: StatusEnumType, visibility?: TaskVisibilityEnumType | null, responsibility: TaskResponsibilityEnumType, name: string, taskType?: TaskTypeEnumType | null, signOffRequired: boolean, sortOrder?: number | null, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completedAt?: any | null, milestone?: (
    { id: string, sortOrder: number, dependentTasks?: Array<(
      { id: string }
      & { __typename?: 'TaskType' }
    )> | null }
    & { __typename?: 'MilestoneType' }
  ) | null, signer?: (
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
    & { __typename?: 'SignerType' }
  ) | null, assignee?: (
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'UserType' }
  ) | null, dependency?: (
    { id: string, completed?: boolean | null, name: string, forecastedEndOn?: any | null }
    & { __typename: 'MilestoneType' | 'TaskGroupType' }
  ) | (
    { id: string, completed?: boolean | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null, dueOn?: any | null }
    & { __typename: 'TaskType' }
  ) | (
    { id: string, completed?: boolean | null, name: string }
    & { __typename: 'TemplateType' }
  ) | null, tags?: Array<(
    { id: string, color: string, name: string, internalOnly: boolean }
    & { __typename?: 'TagType' }
  )> | null, taskParticipants?: Array<(
    { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
      { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null }
    & { __typename?: 'TaskParticipantType' }
  )> | null, taskGroup?: (
    { id: string }
    & { __typename?: 'TaskGroupType' }
  ) | null, template?: (
    { id: string, hardDependency?: boolean | null }
    & { __typename?: 'TemplateType' }
  ) | null, dependentTasks?: Array<(
    { id: string }
    & { __typename?: 'TaskType' }
  )> | null }
  & { __typename?: 'TaskType' }
);

export type TemplateEditMilestoneDrawerUpdateMilestoneMutationVariables = Exact<{
  milestone: UpdateTemplateMilestoneInput;
}>;


export type TemplateEditMilestoneDrawerUpdateMilestoneMutation = (
  { updateTemplateMilestone?: (
    { milestone?: (
      { id: string, name: string, sortOrder: number, description?: string | null, completionMessage?: string | null, enableCompletionNotification?: boolean | null, enableSendSurvey?: boolean | null, files?: Array<(
        { id: string, url?: string | null, fileName: string, size?: number | null, milestoneName?: string | null, taskName?: string | null, createdAt?: any | null, internalOnly: boolean, deletable?: boolean | null, isExternalHyperlink?: boolean | null, uploader?: (
          { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'UserType' }
        ) | null }
        & { __typename?: 'FileType' }
      )> | null }
      & { __typename?: 'MilestoneType' }
    ) | null }
    & { __typename?: 'updateTemplateMilestonePayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type TemplateAddTaskDrawerTaskFragment = (
  { id: string, actualHours?: number | null, billableHours?: number | null, nonBillableHours?: number | null, assignmentEmailSentAt?: any | null, completedAt?: any | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, description?: string | null, dueOn?: any | null, duration?: number | null, estimatedHours?: number | null, estimatedPoints?: number | null, eventDatetime?: any | null, eventInformation?: string | null, invitationGroupSentAt?: any | null, meetingLength?: number | null, mustStartOn?: any | null, mustStartOnRequired?: boolean | null, jiraTaskLink?: string | null, name: string, participantCallToAction?: string | null, priority?: PriorityEnumType | null, responsibility: TaskResponsibilityEnumType, shouldWarnUpdateStatus?: boolean | null, signOffRequired: boolean, sortOrder?: number | null, startOn?: any | null, status: StatusEnumType, taskType?: TaskTypeEnumType | null, visibility?: TaskVisibilityEnumType | null, jiraSync?: boolean | null, tags?: Array<(
    { id: string }
    & { __typename?: 'TagType' }
  )> | null, skill?: (
    { id: string }
    & { __typename?: 'Skill' }
  ) | null, skills?: Array<(
    { id: string }
    & { __typename?: 'Skill' }
  )> | null, assignee?: (
    { id: string, firstName?: string | null, lastName?: string | null, calendarLink?: string | null, meetingLink?: string | null, role?: UserRoleEnumType | null, projectContext?: UserProjectOrganizationTypeEnumType | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'UserType' }
  ) | null, creator?: (
    { id: string }
    & { __typename?: 'UserType' }
  ) | null, signer?: (
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
    & { __typename?: 'SignerType' }
  ) | null, jiraTask?: (
    { id: string, externalId?: string | null, externalProjectId?: string | null, externalTypeId?: string | null, components?: Array<string> | null, createdInJira?: any | null }
    & { __typename?: 'JiraIssueType' }
  ) | null, files?: Array<(
    { id: string, sortOrder?: number | null, url?: string | null, fileName: string, size?: number | null, milestoneName?: string | null, taskName?: string | null, createdAt?: any | null, internalOnly: boolean, deletable?: boolean | null, isExternalHyperlink?: boolean | null, uploader?: (
      { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null }
    & { __typename?: 'FileType' }
  )> | null, milestone?: (
    { id: string, sortOrder: number, isFirstOfTemplate: boolean, isFirstOfProject: boolean, template: (
      { id: string, hardDependency?: boolean | null }
      & { __typename?: 'TemplateType' }
    ) }
    & { __typename?: 'MilestoneType' }
  ) | null, project?: (
    { id: string, name: string, status: StatusEnumType, currentUserProjectContext?: UserProjectOrganizationTypeEnumType | null, pmDisplayRole?: string | null, projectManager?: (
      { id: string, firstName?: string | null, lastName?: string | null, calendarLink?: string | null, meetingLink?: string | null }
      & { __typename?: 'UserType' }
    ) | null, organization?: (
      { id: string, name?: string | null, defaultTaskVisibility?: TaskVisibilityEnumType | null, timeTrackingEnabled?: boolean | null, resourceManagementEnabled?: boolean | null, internalNotesDefault: boolean }
      & { __typename?: 'OrganizationType' }
    ) | null, customerV2?: (
      { id: string, name: string }
      & { __typename?: 'CustomerType' }
    ) | null }
    & { __typename?: 'ProjectType' }
  ) | null, dependency?: (
    { id: string, name: string, completed?: boolean | null }
    & { __typename?: 'MilestoneType' | 'TaskGroupType' | 'TemplateType' }
  ) | (
    { id: string, name: string, completed?: boolean | null, shouldWarnUpdateStatus?: boolean | null }
    & { __typename?: 'TaskType' }
  ) | null, subtasks?: Array<(
    { id: string, name?: string | null, richName?: string | null, done?: boolean | null, sortOrder?: number | null, groupId?: string | null }
    & { __typename?: 'SubtaskType' }
  )> | null, subtasksGroups?: Array<(
    { id: string, name?: string | null }
    & { __typename?: 'SubtasksGroupType' }
  )> | null, watchers?: Array<(
    { id: string }
    & { __typename?: 'UserType' }
  )> | null, taskParticipants?: Array<(
    { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
      { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, capacity?: number | null, projectsCount?: number | null, projectContext?: UserProjectOrganizationTypeEnumType | null, organizationName?: string | null, organization?: (
        { id: string, name?: string | null }
        & { __typename?: 'OrganizationType' }
      ) | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null, displayOrganization?: (
        { name: string }
        & { __typename?: 'DisplayOrganizationType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null }
    & { __typename?: 'TaskParticipantType' }
  )> | null, participantsSelectAll?: (
    { internal: boolean, customer: boolean, thirdParty: boolean }
    & { __typename: 'TaskParticipantSelectAllType' }
  ) | null, taskGroup?: (
    { id: string }
    & { __typename?: 'TaskGroupType' }
  ) | null }
  & { __typename?: 'TaskType' }
);

export type TemplateEditTaskDrawerTaskFragment = (
  { id: string, actualHours?: number | null, billableHours?: number | null, nonBillableHours?: number | null, assignmentEmailSentAt?: any | null, completedAt?: any | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, description?: string | null, dueOn?: any | null, duration?: number | null, estimatedHours?: number | null, estimatedPoints?: number | null, eventDatetime?: any | null, eventInformation?: string | null, invitationGroupSentAt?: any | null, meetingLength?: number | null, mustStartOn?: any | null, mustStartOnRequired?: boolean | null, jiraTaskLink?: string | null, name: string, participantCallToAction?: string | null, priority?: PriorityEnumType | null, responsibility: TaskResponsibilityEnumType, shouldWarnUpdateStatus?: boolean | null, signOffRequired: boolean, sortOrder?: number | null, startOn?: any | null, status: StatusEnumType, taskType?: TaskTypeEnumType | null, visibility?: TaskVisibilityEnumType | null, jiraSync?: boolean | null, tags?: Array<(
    { id: string }
    & { __typename?: 'TagType' }
  )> | null, skill?: (
    { id: string }
    & { __typename?: 'Skill' }
  ) | null, skills?: Array<(
    { id: string }
    & { __typename?: 'Skill' }
  )> | null, assignee?: (
    { id: string, firstName?: string | null, lastName?: string | null, calendarLink?: string | null, meetingLink?: string | null, role?: UserRoleEnumType | null, projectContext?: UserProjectOrganizationTypeEnumType | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'UserType' }
  ) | null, creator?: (
    { id: string }
    & { __typename?: 'UserType' }
  ) | null, signer?: (
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
    & { __typename?: 'SignerType' }
  ) | null, jiraTask?: (
    { id: string, externalId?: string | null, externalProjectId?: string | null, externalTypeId?: string | null, components?: Array<string> | null, createdInJira?: any | null }
    & { __typename?: 'JiraIssueType' }
  ) | null, files?: Array<(
    { id: string, sortOrder?: number | null, url?: string | null, fileName: string, size?: number | null, milestoneName?: string | null, taskName?: string | null, createdAt?: any | null, internalOnly: boolean, deletable?: boolean | null, isExternalHyperlink?: boolean | null, uploader?: (
      { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null }
    & { __typename?: 'FileType' }
  )> | null, milestone?: (
    { id: string, sortOrder: number, isFirstOfTemplate: boolean, isFirstOfProject: boolean, template: (
      { id: string, hardDependency?: boolean | null }
      & { __typename?: 'TemplateType' }
    ) }
    & { __typename?: 'MilestoneType' }
  ) | null, project?: (
    { id: string, name: string, status: StatusEnumType, currentUserProjectContext?: UserProjectOrganizationTypeEnumType | null, pmDisplayRole?: string | null, projectManager?: (
      { id: string, firstName?: string | null, lastName?: string | null, calendarLink?: string | null, meetingLink?: string | null }
      & { __typename?: 'UserType' }
    ) | null, organization?: (
      { id: string, name?: string | null, defaultTaskVisibility?: TaskVisibilityEnumType | null, timeTrackingEnabled?: boolean | null, resourceManagementEnabled?: boolean | null, internalNotesDefault: boolean }
      & { __typename?: 'OrganizationType' }
    ) | null, customerV2?: (
      { id: string, name: string }
      & { __typename?: 'CustomerType' }
    ) | null }
    & { __typename?: 'ProjectType' }
  ) | null, dependency?: (
    { id: string, name: string, completed?: boolean | null }
    & { __typename?: 'MilestoneType' | 'TaskGroupType' | 'TemplateType' }
  ) | (
    { id: string, name: string, completed?: boolean | null, shouldWarnUpdateStatus?: boolean | null }
    & { __typename?: 'TaskType' }
  ) | null, subtasks?: Array<(
    { id: string, name?: string | null, richName?: string | null, done?: boolean | null, sortOrder?: number | null, groupId?: string | null }
    & { __typename?: 'SubtaskType' }
  )> | null, subtasksGroups?: Array<(
    { id: string, name?: string | null }
    & { __typename?: 'SubtasksGroupType' }
  )> | null, watchers?: Array<(
    { id: string }
    & { __typename?: 'UserType' }
  )> | null, taskParticipants?: Array<(
    { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
      { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, capacity?: number | null, projectsCount?: number | null, projectContext?: UserProjectOrganizationTypeEnumType | null, organizationName?: string | null, organization?: (
        { id: string, name?: string | null }
        & { __typename?: 'OrganizationType' }
      ) | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null, displayOrganization?: (
        { name: string }
        & { __typename?: 'DisplayOrganizationType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null }
    & { __typename?: 'TaskParticipantType' }
  )> | null, participantsSelectAll?: (
    { internal: boolean, customer: boolean, thirdParty: boolean }
    & { __typename: 'TaskParticipantSelectAllType' }
  ) | null, taskGroup?: (
    { id: string }
    & { __typename?: 'TaskGroupType' }
  ) | null }
  & { __typename?: 'TaskType' }
);

export type TemplateEditTaskDrawerUpdateTaskGroupTaskMutationVariables = Exact<{
  task: UpdateTaskInput;
}>;


export type TemplateEditTaskDrawerUpdateTaskGroupTaskMutation = (
  { updateTaskGroupTask?: (
    { taskReturnData?: (
      { task?: (
        { id: string, taskType?: TaskTypeEnumType | null, name: string, description?: string | null, startOn?: any | null, dueOn?: any | null, estimatedHours?: number | null, actualHours?: number | null, billableHours?: number | null, nonBillableHours?: number | null, estimatedPoints?: number | null, duration?: number | null, sortOrder?: number | null, priority?: PriorityEnumType | null, responsibility: TaskResponsibilityEnumType, signOffRequired: boolean, status: StatusEnumType, shouldWarnUpdateStatus?: boolean | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, eventDatetime?: any | null, participantCallToAction?: string | null, invitationGroupSentAt?: any | null, assignmentEmailSentAt?: any | null, completedAt?: any | null, eventInformation?: string | null, meetingLength?: number | null, mustStartOn?: any | null, mustStartOnRequired?: boolean | null, jiraTaskLink?: string | null, visibility?: TaskVisibilityEnumType | null, jiraSync?: boolean | null, dependency?: (
          { id: string, completed?: boolean | null, name: string, tasks?: Array<(
            { id: string, shouldWarnUpdateStatus?: boolean | null }
            & { __typename?: 'TaskType' }
          )> | null }
          & { __typename?: 'MilestoneType' | 'TaskGroupType' }
        ) | (
          { id: string, completed?: boolean | null, shouldWarnUpdateStatus?: boolean | null, name: string }
          & { __typename?: 'TaskType' }
        ) | (
          { id: string, completed?: boolean | null, name: string }
          & { __typename?: 'TemplateType' }
        ) | null, assignee?: (
          { id: string, firstName?: string | null, lastName?: string | null, jobRole?: string | null, calendarLink?: string | null, meetingLink?: string | null, role?: UserRoleEnumType | null, projectContext?: UserProjectOrganizationTypeEnumType | null, avatar?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'UserType' }
        ) | null, signer?: (
          { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
          & { __typename?: 'SignerType' }
        ) | null, jiraTask?: (
          { id: string, externalId?: string | null, externalProjectId?: string | null, externalTypeId?: string | null, components?: Array<string> | null, createdInJira?: any | null }
          & { __typename?: 'JiraIssueType' }
        ) | null, files?: Array<(
          { id: string, sortOrder?: number | null, url?: string | null, fileName: string, size?: number | null, milestoneName?: string | null, taskName?: string | null, createdAt?: any | null, internalOnly: boolean, deletable?: boolean | null, isExternalHyperlink?: boolean | null, uploader?: (
            { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
              { originalUrl?: string | null }
              & { __typename?: 'ImageType' }
            ) | null }
            & { __typename?: 'UserType' }
          ) | null }
          & { __typename?: 'FileType' }
        )> | null, subtasks?: Array<(
          { id: string, name?: string | null, richName?: string | null, done?: boolean | null, sortOrder?: number | null, groupId?: string | null }
          & { __typename?: 'SubtaskType' }
        )> | null, taskParticipants?: Array<(
          { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
            { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, capacity?: number | null, projectsCount?: number | null, projectContext?: UserProjectOrganizationTypeEnumType | null, organizationName?: string | null, organization?: (
              { id: string, name?: string | null }
              & { __typename?: 'OrganizationType' }
            ) | null, avatar?: (
              { originalUrl?: string | null }
              & { __typename?: 'ImageType' }
            ) | null, displayOrganization?: (
              { name: string }
              & { __typename?: 'DisplayOrganizationType' }
            ) | null }
            & { __typename?: 'UserType' }
          ) | null }
          & { __typename?: 'TaskParticipantType' }
        )> | null, template?: (
          { id: string, duration?: number | null }
          & { __typename?: 'TemplateType' }
        ) | null, tags?: Array<(
          { id: string }
          & { __typename?: 'TagType' }
        )> | null, skill?: (
          { id: string }
          & { __typename?: 'Skill' }
        ) | null, skills?: Array<(
          { id: string }
          & { __typename?: 'Skill' }
        )> | null, creator?: (
          { id: string }
          & { __typename?: 'UserType' }
        ) | null, milestone?: (
          { id: string, sortOrder: number, isFirstOfTemplate: boolean, isFirstOfProject: boolean, template: (
            { id: string, hardDependency?: boolean | null }
            & { __typename?: 'TemplateType' }
          ) }
          & { __typename?: 'MilestoneType' }
        ) | null, project?: (
          { id: string, name: string, status: StatusEnumType, currentUserProjectContext?: UserProjectOrganizationTypeEnumType | null, pmDisplayRole?: string | null, projectManager?: (
            { id: string, firstName?: string | null, lastName?: string | null, calendarLink?: string | null, meetingLink?: string | null }
            & { __typename?: 'UserType' }
          ) | null, organization?: (
            { id: string, name?: string | null, defaultTaskVisibility?: TaskVisibilityEnumType | null, timeTrackingEnabled?: boolean | null, resourceManagementEnabled?: boolean | null, internalNotesDefault: boolean }
            & { __typename?: 'OrganizationType' }
          ) | null, customerV2?: (
            { id: string, name: string }
            & { __typename?: 'CustomerType' }
          ) | null }
          & { __typename?: 'ProjectType' }
        ) | null, subtasksGroups?: Array<(
          { id: string, name?: string | null }
          & { __typename?: 'SubtasksGroupType' }
        )> | null, watchers?: Array<(
          { id: string }
          & { __typename?: 'UserType' }
        )> | null, participantsSelectAll?: (
          { internal: boolean, customer: boolean, thirdParty: boolean }
          & { __typename: 'TaskParticipantSelectAllType' }
        ) | null, taskGroup?: (
          { id: string }
          & { __typename?: 'TaskGroupType' }
        ) | null }
        & { __typename?: 'TaskType' }
      ) | null }
      & { __typename?: 'TaskReturnType' }
    ) | null }
    & { __typename?: 'updateTaskGroupTaskPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type TemplateEditTaskDrawerGetAvailableTaskTagsQueryVariables = Exact<{
  taggableId: Scalars['ID'];
  taggableType: TaggableEnumType;
}>;


export type TemplateEditTaskDrawerGetAvailableTaskTagsQuery = (
  { availableTags?: Array<(
    { id: string, color: string, name: string, internalOnly: boolean }
    & { __typename?: 'TagType' }
  )> | null }
  & { __typename?: 'Query' }
);

export type TemplateEditTaskDrawerCurrentUserSkillsQueryVariables = Exact<{ [key: string]: never; }>;


export type TemplateEditTaskDrawerCurrentUserSkillsQuery = (
  { currentUser?: (
    { skills: Array<(
      { id: string }
      & { __typename?: 'Skill' }
    )> }
    & { __typename?: 'UserType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type TemplateWatchersRemoveWatcherMutationVariables = Exact<{
  variables: RemoveWatcherInput;
}>;


export type TemplateWatchersRemoveWatcherMutation = (
  { removeWatcher?: (
    { success?: boolean | null }
    & { __typename?: 'removeWatcherPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type TaskFormTaskQueryVariables = Exact<{
  id: Scalars['ID'];
  noProjectContext?: InputMaybe<Scalars['Boolean']>;
}>;


export type TaskFormTaskQuery = (
  { task: (
    { id: string, actualHours?: number | null, billableHours?: number | null, nonBillableHours?: number | null, assignmentEmailSentAt?: any | null, completedAt?: any | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, description?: string | null, dueOn?: any | null, duration?: number | null, estimatedHours?: number | null, estimatedPoints?: number | null, eventDatetime?: any | null, eventInformation?: string | null, invitationGroupSentAt?: any | null, meetingLength?: number | null, mustStartOn?: any | null, mustStartOnRequired?: boolean | null, jiraTaskLink?: string | null, name: string, participantCallToAction?: string | null, priority?: PriorityEnumType | null, responsibility: TaskResponsibilityEnumType, shouldWarnUpdateStatus?: boolean | null, signOffRequired: boolean, sortOrder?: number | null, startOn?: any | null, status: StatusEnumType, taskType?: TaskTypeEnumType | null, visibility?: TaskVisibilityEnumType | null, jiraSync?: boolean | null, project?: (
      { currentUserProjectContext?: UserProjectOrganizationTypeEnumType | null, id: string, name: string, status: StatusEnumType, pmDisplayRole?: string | null, projectManager?: (
        { id: string, firstName?: string | null, lastName?: string | null, calendarLink?: string | null, meetingLink?: string | null }
        & { __typename?: 'UserType' }
      ) | null, organization?: (
        { id: string, name?: string | null, defaultTaskVisibility?: TaskVisibilityEnumType | null, timeTrackingEnabled?: boolean | null, resourceManagementEnabled?: boolean | null, internalNotesDefault: boolean }
        & { __typename?: 'OrganizationType' }
      ) | null, customerV2?: (
        { id: string, name: string }
        & { __typename?: 'CustomerType' }
      ) | null }
      & { __typename?: 'ProjectType' }
    ) | null, tags?: Array<(
      { id: string }
      & { __typename?: 'TagType' }
    )> | null, skill?: (
      { id: string }
      & { __typename?: 'Skill' }
    ) | null, skills?: Array<(
      { id: string }
      & { __typename?: 'Skill' }
    )> | null, assignee?: (
      { id: string, firstName?: string | null, lastName?: string | null, calendarLink?: string | null, meetingLink?: string | null, role?: UserRoleEnumType | null, projectContext?: UserProjectOrganizationTypeEnumType | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null, creator?: (
      { id: string }
      & { __typename?: 'UserType' }
    ) | null, signer?: (
      { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
      & { __typename?: 'SignerType' }
    ) | null, jiraTask?: (
      { id: string, externalId?: string | null, externalProjectId?: string | null, externalTypeId?: string | null, components?: Array<string> | null, createdInJira?: any | null }
      & { __typename?: 'JiraIssueType' }
    ) | null, files?: Array<(
      { id: string, sortOrder?: number | null, url?: string | null, fileName: string, size?: number | null, milestoneName?: string | null, taskName?: string | null, createdAt?: any | null, internalOnly: boolean, deletable?: boolean | null, isExternalHyperlink?: boolean | null, uploader?: (
        { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null }
      & { __typename?: 'FileType' }
    )> | null, milestone?: (
      { id: string, sortOrder: number, isFirstOfTemplate: boolean, isFirstOfProject: boolean, template: (
        { id: string, hardDependency?: boolean | null }
        & { __typename?: 'TemplateType' }
      ) }
      & { __typename?: 'MilestoneType' }
    ) | null, dependency?: (
      { id: string, name: string, completed?: boolean | null }
      & { __typename?: 'MilestoneType' | 'TaskGroupType' | 'TemplateType' }
    ) | (
      { id: string, name: string, completed?: boolean | null, shouldWarnUpdateStatus?: boolean | null }
      & { __typename?: 'TaskType' }
    ) | null, subtasks?: Array<(
      { id: string, name?: string | null, richName?: string | null, done?: boolean | null, sortOrder?: number | null, groupId?: string | null }
      & { __typename?: 'SubtaskType' }
    )> | null, subtasksGroups?: Array<(
      { id: string, name?: string | null }
      & { __typename?: 'SubtasksGroupType' }
    )> | null, watchers?: Array<(
      { id: string }
      & { __typename?: 'UserType' }
    )> | null, taskParticipants?: Array<(
      { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
        { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, capacity?: number | null, projectsCount?: number | null, projectContext?: UserProjectOrganizationTypeEnumType | null, organizationName?: string | null, organization?: (
          { id: string, name?: string | null }
          & { __typename?: 'OrganizationType' }
        ) | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null, displayOrganization?: (
          { name: string }
          & { __typename?: 'DisplayOrganizationType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null }
      & { __typename?: 'TaskParticipantType' }
    )> | null, participantsSelectAll?: (
      { internal: boolean, customer: boolean, thirdParty: boolean }
      & { __typename: 'TaskParticipantSelectAllType' }
    ) | null, taskGroup?: (
      { id: string }
      & { __typename?: 'TaskGroupType' }
    ) | null }
    & { __typename?: 'TaskType' }
  ) }
  & { __typename?: 'Query' }
);

export type TaskFormTaskV2QueryVariables = Exact<{
  id: Scalars['ID'];
  noProjectContext?: InputMaybe<Scalars['Boolean']>;
}>;


export type TaskFormTaskV2Query = (
  { task: (
    { id: string, actualHours?: number | null, billableHours?: number | null, nonBillableHours?: number | null, assignmentEmailSentAt?: any | null, completedAt?: any | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, description?: string | null, dueOn?: any | null, duration?: number | null, estimatedHours?: number | null, estimatedPoints?: number | null, eventDatetime?: any | null, eventInformation?: string | null, invitationGroupSentAt?: any | null, meetingLength?: number | null, mustStartOn?: any | null, mustStartOnRequired?: boolean | null, jiraTaskLink?: string | null, name: string, participantCallToAction?: string | null, priority?: PriorityEnumType | null, responsibility: TaskResponsibilityEnumType, shouldWarnUpdateStatus?: boolean | null, signOffRequired: boolean, sortOrder?: number | null, startOn?: any | null, status: StatusEnumType, taskType?: TaskTypeEnumType | null, visibility?: TaskVisibilityEnumType | null, jiraSync?: boolean | null, project?: (
      { currentUserProjectContext?: UserProjectOrganizationTypeEnumType | null, id: string, name: string, status: StatusEnumType, pmDisplayRole?: string | null, projectManager?: (
        { id: string, firstName?: string | null, lastName?: string | null, calendarLink?: string | null, meetingLink?: string | null }
        & { __typename?: 'UserType' }
      ) | null, organization?: (
        { id: string, name?: string | null, defaultTaskVisibility?: TaskVisibilityEnumType | null, timeTrackingEnabled?: boolean | null, resourceManagementEnabled?: boolean | null, internalNotesDefault: boolean }
        & { __typename?: 'OrganizationType' }
      ) | null, customerV2?: (
        { id: string, name: string }
        & { __typename?: 'CustomerType' }
      ) | null }
      & { __typename?: 'ProjectType' }
    ) | null, tags?: Array<(
      { id: string }
      & { __typename?: 'TagType' }
    )> | null, skill?: (
      { id: string }
      & { __typename?: 'Skill' }
    ) | null, skills?: Array<(
      { id: string }
      & { __typename?: 'Skill' }
    )> | null, assignee?: (
      { id: string, firstName?: string | null, lastName?: string | null, calendarLink?: string | null, meetingLink?: string | null, role?: UserRoleEnumType | null, projectContext?: UserProjectOrganizationTypeEnumType | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null, creator?: (
      { id: string }
      & { __typename?: 'UserType' }
    ) | null, signer?: (
      { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
      & { __typename?: 'SignerType' }
    ) | null, jiraTask?: (
      { id: string, externalId?: string | null, externalProjectId?: string | null, externalTypeId?: string | null, components?: Array<string> | null, createdInJira?: any | null }
      & { __typename?: 'JiraIssueType' }
    ) | null, files?: Array<(
      { id: string, sortOrder?: number | null, url?: string | null, fileName: string, size?: number | null, milestoneName?: string | null, taskName?: string | null, createdAt?: any | null, internalOnly: boolean, deletable?: boolean | null, isExternalHyperlink?: boolean | null, uploader?: (
        { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null }
      & { __typename?: 'FileType' }
    )> | null, milestone?: (
      { id: string, sortOrder: number, isFirstOfTemplate: boolean, isFirstOfProject: boolean, template: (
        { id: string, hardDependency?: boolean | null }
        & { __typename?: 'TemplateType' }
      ) }
      & { __typename?: 'MilestoneType' }
    ) | null, dependency?: (
      { id: string, name: string, completed?: boolean | null }
      & { __typename?: 'MilestoneType' | 'TaskGroupType' | 'TemplateType' }
    ) | (
      { id: string, name: string, completed?: boolean | null, shouldWarnUpdateStatus?: boolean | null }
      & { __typename?: 'TaskType' }
    ) | null, subtasks?: Array<(
      { id: string, name?: string | null, richName?: string | null, done?: boolean | null, sortOrder?: number | null, groupId?: string | null }
      & { __typename?: 'SubtaskType' }
    )> | null, subtasksGroups?: Array<(
      { id: string, name?: string | null }
      & { __typename?: 'SubtasksGroupType' }
    )> | null, watchers?: Array<(
      { id: string }
      & { __typename?: 'UserType' }
    )> | null, taskParticipants?: Array<(
      { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
        { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, capacity?: number | null, projectsCount?: number | null, projectContext?: UserProjectOrganizationTypeEnumType | null, organizationName?: string | null, organization?: (
          { id: string, name?: string | null }
          & { __typename?: 'OrganizationType' }
        ) | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null, displayOrganization?: (
          { name: string }
          & { __typename?: 'DisplayOrganizationType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null }
      & { __typename?: 'TaskParticipantType' }
    )> | null, participantsSelectAll?: (
      { internal: boolean, customer: boolean, thirdParty: boolean }
      & { __typename: 'TaskParticipantSelectAllType' }
    ) | null, taskGroup?: (
      { id: string }
      & { __typename?: 'TaskGroupType' }
    ) | null }
    & { __typename?: 'TaskType' }
  ) }
  & { __typename?: 'Query' }
);

export type TemplateMilestoneColumnDuplicateMilestoneMutationVariables = Exact<{
  id: Scalars['ID'];
  sortOrder: Scalars['Float'];
}>;


export type TemplateMilestoneColumnDuplicateMilestoneMutation = (
  { duplicateMilestone?: (
    { milestone?: (
      { id: string, sortOrder: number, name: string, startedOn?: any | null, forecastedEndOn?: any | null, completedAt?: any | null, active: boolean, tasksAndGroups?: Array<(
        { id: string, name: string, taskCount: number, sortOrder?: number | null, startedOn?: any | null, forecastedEndOn?: any | null, completedAt?: any | null, tasks?: Array<(
          { id: string, status: StatusEnumType, visibility?: TaskVisibilityEnumType | null, responsibility: TaskResponsibilityEnumType, priority?: PriorityEnumType | null, taskType?: TaskTypeEnumType | null, name: string, signOffRequired: boolean, sortOrder?: number | null, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completedAt?: any | null, taskGroup?: (
            { id: string }
            & { __typename?: 'TaskGroupType' }
          ) | null, milestone?: (
            { id: string, sortOrder: number, dependentTasks?: Array<(
              { id: string }
              & { __typename?: 'TaskType' }
            )> | null }
            & { __typename?: 'MilestoneType' }
          ) | null, signer?: (
            { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
            & { __typename?: 'SignerType' }
          ) | null, assignee?: (
            { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
              { originalUrl?: string | null }
              & { __typename?: 'ImageType' }
            ) | null }
            & { __typename?: 'UserType' }
          ) | null, dependency?: (
            { id: string, completed?: boolean | null, name: string, forecastedEndOn?: any | null }
            & { __typename: 'MilestoneType' | 'TaskGroupType' }
          ) | (
            { id: string, completed?: boolean | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null, dueOn?: any | null }
            & { __typename: 'TaskType' }
          ) | (
            { id: string, completed?: boolean | null, name: string }
            & { __typename: 'TemplateType' }
          ) | null, tags?: Array<(
            { id: string, color: string, name: string, internalOnly: boolean }
            & { __typename?: 'TagType' }
          )> | null, taskParticipants?: Array<(
            { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
              { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
                { originalUrl?: string | null }
                & { __typename?: 'ImageType' }
              ) | null }
              & { __typename?: 'UserType' }
            ) | null }
            & { __typename?: 'TaskParticipantType' }
          )> | null, template?: (
            { id: string, hardDependency?: boolean | null }
            & { __typename?: 'TemplateType' }
          ) | null, dependentTasks?: Array<(
            { id: string }
            & { __typename?: 'TaskType' }
          )> | null }
          & { __typename?: 'TaskType' }
        )> | null, summaryBank: (
          { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
          & { __typename?: 'TaskGroupStats' }
        ) }
        & { __typename: 'TaskGroupType' }
      ) | (
        { id: string, status: StatusEnumType, visibility?: TaskVisibilityEnumType | null, responsibility: TaskResponsibilityEnumType, priority?: PriorityEnumType | null, taskType?: TaskTypeEnumType | null, name: string, signOffRequired: boolean, sortOrder?: number | null, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completedAt?: any | null, milestone?: (
          { id: string, sortOrder: number, dependentTasks?: Array<(
            { id: string }
            & { __typename?: 'TaskType' }
          )> | null }
          & { __typename?: 'MilestoneType' }
        ) | null, signer?: (
          { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
          & { __typename?: 'SignerType' }
        ) | null, assignee?: (
          { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'UserType' }
        ) | null, dependency?: (
          { id: string, completed?: boolean | null, name: string, forecastedEndOn?: any | null }
          & { __typename: 'MilestoneType' | 'TaskGroupType' }
        ) | (
          { id: string, completed?: boolean | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null, dueOn?: any | null }
          & { __typename: 'TaskType' }
        ) | (
          { id: string, completed?: boolean | null, name: string }
          & { __typename: 'TemplateType' }
        ) | null, tags?: Array<(
          { id: string, color: string, name: string, internalOnly: boolean }
          & { __typename?: 'TagType' }
        )> | null, taskGroup?: (
          { id: string }
          & { __typename?: 'TaskGroupType' }
        ) | null, template?: (
          { id: string, hardDependency?: boolean | null }
          & { __typename?: 'TemplateType' }
        ) | null, taskParticipants?: Array<(
          { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
            { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
              { originalUrl?: string | null }
              & { __typename?: 'ImageType' }
            ) | null }
            & { __typename?: 'UserType' }
          ) | null }
          & { __typename?: 'TaskParticipantType' }
        )> | null, dependentTasks?: Array<(
          { id: string }
          & { __typename?: 'TaskType' }
        )> | null }
        & { __typename?: 'TaskType' }
      )> | null, summaryBank: (
        { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
        & { __typename?: 'MilestoneStats' }
      ), dependentTasks?: Array<(
        { id: string }
        & { __typename?: 'TaskType' }
      )> | null, template: (
        { id: string, hardDependency?: boolean | null }
        & { __typename?: 'TemplateType' }
      ) }
      & { __typename?: 'MilestoneType' }
    ) | null }
    & { __typename?: 'duplicateMilestonePayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type TemplateMilestoneColumnDuplicateTaskMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TemplateMilestoneColumnDuplicateTaskMutation = (
  { duplicateTask?: (
    { taskReturnData?: (
      { task?: (
        { id: string, status: StatusEnumType, visibility?: TaskVisibilityEnumType | null, responsibility: TaskResponsibilityEnumType, priority?: PriorityEnumType | null, taskType?: TaskTypeEnumType | null, name: string, signOffRequired: boolean, sortOrder?: number | null, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completedAt?: any | null, milestone?: (
          { id: string, sortOrder: number, dependentTasks?: Array<(
            { id: string }
            & { __typename?: 'TaskType' }
          )> | null }
          & { __typename?: 'MilestoneType' }
        ) | null, signer?: (
          { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
          & { __typename?: 'SignerType' }
        ) | null, assignee?: (
          { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'UserType' }
        ) | null, dependency?: (
          { id: string, completed?: boolean | null, name: string, forecastedEndOn?: any | null }
          & { __typename: 'MilestoneType' | 'TaskGroupType' }
        ) | (
          { id: string, completed?: boolean | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null, dueOn?: any | null }
          & { __typename: 'TaskType' }
        ) | (
          { id: string, completed?: boolean | null, name: string }
          & { __typename: 'TemplateType' }
        ) | null, tags?: Array<(
          { id: string, color: string, name: string, internalOnly: boolean }
          & { __typename?: 'TagType' }
        )> | null, taskGroup?: (
          { id: string }
          & { __typename?: 'TaskGroupType' }
        ) | null, template?: (
          { id: string, hardDependency?: boolean | null }
          & { __typename?: 'TemplateType' }
        ) | null, taskParticipants?: Array<(
          { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
            { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
              { originalUrl?: string | null }
              & { __typename?: 'ImageType' }
            ) | null }
            & { __typename?: 'UserType' }
          ) | null }
          & { __typename?: 'TaskParticipantType' }
        )> | null, dependentTasks?: Array<(
          { id: string }
          & { __typename?: 'TaskType' }
        )> | null }
        & { __typename?: 'TaskType' }
      ) | null }
      & { __typename?: 'TaskReturnType' }
    ) | null }
    & { __typename?: 'duplicateTaskPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type TemplateMilestoneColumnMilestoneFragment = (
  { id: string, name: string, startedOn?: any | null, forecastedEndOn?: any | null, completedAt?: any | null, active: boolean, sortOrder: number, template: (
    { id: string, hardDependency?: boolean | null }
    & { __typename?: 'TemplateType' }
  ), tasksAndGroups?: Array<(
    { id: string, name: string, taskCount: number, sortOrder?: number | null, startedOn?: any | null, forecastedEndOn?: any | null, completedAt?: any | null, summaryBank: (
      { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
      & { __typename?: 'TaskGroupStats' }
    ), tasks?: Array<(
      { id: string, status: StatusEnumType, visibility?: TaskVisibilityEnumType | null, responsibility: TaskResponsibilityEnumType, name: string, taskType?: TaskTypeEnumType | null, signOffRequired: boolean, sortOrder?: number | null, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completedAt?: any | null, taskGroup?: (
        { id: string }
        & { __typename?: 'TaskGroupType' }
      ) | null, milestone?: (
        { id: string, sortOrder: number, dependentTasks?: Array<(
          { id: string }
          & { __typename?: 'TaskType' }
        )> | null }
        & { __typename?: 'MilestoneType' }
      ) | null, signer?: (
        { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
        & { __typename?: 'SignerType' }
      ) | null, assignee?: (
        { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null, dependency?: (
        { id: string, completed?: boolean | null, name: string, forecastedEndOn?: any | null }
        & { __typename: 'MilestoneType' | 'TaskGroupType' }
      ) | (
        { id: string, completed?: boolean | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null, dueOn?: any | null }
        & { __typename: 'TaskType' }
      ) | (
        { id: string, completed?: boolean | null, name: string }
        & { __typename: 'TemplateType' }
      ) | null, tags?: Array<(
        { id: string, color: string, name: string, internalOnly: boolean }
        & { __typename?: 'TagType' }
      )> | null, taskParticipants?: Array<(
        { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
          { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'UserType' }
        ) | null }
        & { __typename?: 'TaskParticipantType' }
      )> | null, template?: (
        { id: string, hardDependency?: boolean | null }
        & { __typename?: 'TemplateType' }
      ) | null, dependentTasks?: Array<(
        { id: string }
        & { __typename?: 'TaskType' }
      )> | null }
      & { __typename?: 'TaskType' }
    )> | null }
    & { __typename: 'TaskGroupType' }
  ) | (
    { id: string, status: StatusEnumType, visibility?: TaskVisibilityEnumType | null, responsibility: TaskResponsibilityEnumType, name: string, taskType?: TaskTypeEnumType | null, signOffRequired: boolean, sortOrder?: number | null, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completedAt?: any | null, milestone?: (
      { id: string, sortOrder: number, dependentTasks?: Array<(
        { id: string }
        & { __typename?: 'TaskType' }
      )> | null }
      & { __typename?: 'MilestoneType' }
    ) | null, signer?: (
      { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
      & { __typename?: 'SignerType' }
    ) | null, assignee?: (
      { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null, dependency?: (
      { id: string, completed?: boolean | null, name: string, forecastedEndOn?: any | null }
      & { __typename: 'MilestoneType' | 'TaskGroupType' }
    ) | (
      { id: string, completed?: boolean | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null, dueOn?: any | null }
      & { __typename: 'TaskType' }
    ) | (
      { id: string, completed?: boolean | null, name: string }
      & { __typename: 'TemplateType' }
    ) | null, tags?: Array<(
      { id: string, color: string, name: string, internalOnly: boolean }
      & { __typename?: 'TagType' }
    )> | null, taskParticipants?: Array<(
      { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
        { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null }
      & { __typename?: 'TaskParticipantType' }
    )> | null, taskGroup?: (
      { id: string }
      & { __typename?: 'TaskGroupType' }
    ) | null, template?: (
      { id: string, hardDependency?: boolean | null }
      & { __typename?: 'TemplateType' }
    ) | null, dependentTasks?: Array<(
      { id: string }
      & { __typename?: 'TaskType' }
    )> | null }
    & { __typename?: 'TaskType' }
  )> | null, summaryBank: (
    { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
    & { __typename?: 'MilestoneStats' }
  ), dependentTasks?: Array<(
    { id: string }
    & { __typename?: 'TaskType' }
  )> | null }
  & { __typename?: 'MilestoneType' }
);

export type TemplateMilestoneColumnTaskFragment = (
  { id: string, status: StatusEnumType, visibility?: TaskVisibilityEnumType | null, responsibility: TaskResponsibilityEnumType, name: string, taskType?: TaskTypeEnumType | null, signOffRequired: boolean, sortOrder?: number | null, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completedAt?: any | null, milestone?: (
    { id: string, sortOrder: number, dependentTasks?: Array<(
      { id: string }
      & { __typename?: 'TaskType' }
    )> | null }
    & { __typename?: 'MilestoneType' }
  ) | null, signer?: (
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
    & { __typename?: 'SignerType' }
  ) | null, assignee?: (
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'UserType' }
  ) | null, dependency?: (
    { id: string, completed?: boolean | null, name: string, forecastedEndOn?: any | null }
    & { __typename: 'MilestoneType' | 'TaskGroupType' }
  ) | (
    { id: string, completed?: boolean | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null, dueOn?: any | null }
    & { __typename: 'TaskType' }
  ) | (
    { id: string, completed?: boolean | null, name: string }
    & { __typename: 'TemplateType' }
  ) | null, tags?: Array<(
    { id: string, color: string, name: string, internalOnly: boolean }
    & { __typename?: 'TagType' }
  )> | null, taskParticipants?: Array<(
    { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
      { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null }
    & { __typename?: 'TaskParticipantType' }
  )> | null, taskGroup?: (
    { id: string }
    & { __typename?: 'TaskGroupType' }
  ) | null, template?: (
    { id: string, hardDependency?: boolean | null }
    & { __typename?: 'TemplateType' }
  ) | null, dependentTasks?: Array<(
    { id: string }
    & { __typename?: 'TaskType' }
  )> | null }
  & { __typename?: 'TaskType' }
);

export type TemplateMilestoneColumnTaskGroupFragment = (
  { id: string, name: string, taskCount: number, sortOrder?: number | null, startedOn?: any | null, forecastedEndOn?: any | null, completedAt?: any | null, summaryBank: (
    { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
    & { __typename?: 'TaskGroupStats' }
  ), tasks?: Array<(
    { id: string, status: StatusEnumType, visibility?: TaskVisibilityEnumType | null, responsibility: TaskResponsibilityEnumType, name: string, taskType?: TaskTypeEnumType | null, signOffRequired: boolean, sortOrder?: number | null, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completedAt?: any | null, taskGroup?: (
      { id: string }
      & { __typename?: 'TaskGroupType' }
    ) | null, milestone?: (
      { id: string, sortOrder: number, dependentTasks?: Array<(
        { id: string }
        & { __typename?: 'TaskType' }
      )> | null }
      & { __typename?: 'MilestoneType' }
    ) | null, signer?: (
      { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
      & { __typename?: 'SignerType' }
    ) | null, assignee?: (
      { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null, dependency?: (
      { id: string, completed?: boolean | null, name: string, forecastedEndOn?: any | null }
      & { __typename: 'MilestoneType' | 'TaskGroupType' }
    ) | (
      { id: string, completed?: boolean | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null, dueOn?: any | null }
      & { __typename: 'TaskType' }
    ) | (
      { id: string, completed?: boolean | null, name: string }
      & { __typename: 'TemplateType' }
    ) | null, tags?: Array<(
      { id: string, color: string, name: string, internalOnly: boolean }
      & { __typename?: 'TagType' }
    )> | null, taskParticipants?: Array<(
      { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
        { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null }
      & { __typename?: 'TaskParticipantType' }
    )> | null, template?: (
      { id: string, hardDependency?: boolean | null }
      & { __typename?: 'TemplateType' }
    ) | null, dependentTasks?: Array<(
      { id: string }
      & { __typename?: 'TaskType' }
    )> | null }
    & { __typename?: 'TaskType' }
  )> | null }
  & { __typename: 'TaskGroupType' }
);

export type TemplateMilestoneHeaderMilestoneStatsFragment = (
  { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
  & { __typename?: 'MilestoneStats' }
);

export type TemplateMilestoneHeaderMilestoneFragment = (
  { id: string, name: string, startedOn?: any | null, forecastedEndOn?: any | null, completedAt?: any | null, active: boolean, sortOrder: number, summaryBank: (
    { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
    & { __typename?: 'MilestoneStats' }
  ), dependentTasks?: Array<(
    { id: string }
    & { __typename?: 'TaskType' }
  )> | null, template: (
    { id: string, hardDependency?: boolean | null }
    & { __typename?: 'TemplateType' }
  ) }
  & { __typename?: 'MilestoneType' }
);

export type TemplateTaskCardTaskFragment = (
  { id: string, status: StatusEnumType, visibility?: TaskVisibilityEnumType | null, responsibility: TaskResponsibilityEnumType, name: string, taskType?: TaskTypeEnumType | null, signOffRequired: boolean, sortOrder?: number | null, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completedAt?: any | null, milestone?: (
    { id: string, sortOrder: number, dependentTasks?: Array<(
      { id: string }
      & { __typename?: 'TaskType' }
    )> | null }
    & { __typename?: 'MilestoneType' }
  ) | null, signer?: (
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
    & { __typename?: 'SignerType' }
  ) | null, assignee?: (
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'UserType' }
  ) | null, dependency?: (
    { id: string, completed?: boolean | null, name: string, forecastedEndOn?: any | null }
    & { __typename: 'MilestoneType' | 'TaskGroupType' }
  ) | (
    { id: string, completed?: boolean | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null, dueOn?: any | null }
    & { __typename: 'TaskType' }
  ) | (
    { id: string, completed?: boolean | null, name: string }
    & { __typename: 'TemplateType' }
  ) | null, tags?: Array<(
    { id: string, color: string, name: string, internalOnly: boolean }
    & { __typename?: 'TagType' }
  )> | null, taskGroup?: (
    { id: string }
    & { __typename?: 'TaskGroupType' }
  ) | null, template?: (
    { id: string, hardDependency?: boolean | null }
    & { __typename?: 'TemplateType' }
  ) | null, taskParticipants?: Array<(
    { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
      { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null }
    & { __typename?: 'TaskParticipantType' }
  )> | null, dependentTasks?: Array<(
    { id: string }
    & { __typename?: 'TaskType' }
  )> | null }
  & { __typename?: 'TaskType' }
);

export type TemplateTaskCardBodyTaskFragment = (
  { id: string, taskType?: TaskTypeEnumType | null, signOffRequired: boolean, status: StatusEnumType, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, name: string, responsibility: TaskResponsibilityEnumType, visibility?: TaskVisibilityEnumType | null, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, signer?: (
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
    & { __typename?: 'SignerType' }
  ) | null, assignee?: (
    { id: string }
    & { __typename?: 'UserType' }
  ) | null, taskGroup?: (
    { id: string }
    & { __typename?: 'TaskGroupType' }
  ) | null, template?: (
    { id: string, hardDependency?: boolean | null }
    & { __typename?: 'TemplateType' }
  ) | null, dependency?: (
    { id: string, completed?: boolean | null }
    & { __typename?: 'MilestoneType' | 'TaskGroupType' | 'TaskType' | 'TemplateType' }
  ) | null, taskParticipants?: Array<(
    { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
      { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null }
    & { __typename?: 'TaskParticipantType' }
  )> | null, dependentTasks?: Array<(
    { id: string }
    & { __typename?: 'TaskType' }
  )> | null, milestone?: (
    { id: string, sortOrder: number, dependentTasks?: Array<(
      { id: string }
      & { __typename?: 'TaskType' }
    )> | null }
    & { __typename?: 'MilestoneType' }
  ) | null }
  & { __typename?: 'TaskType' }
);

export type TemplateStatusDropDownTaskFragment = (
  { id: string, status: StatusEnumType, taskType?: TaskTypeEnumType | null, signOffRequired: boolean, shouldWarnUpdateStatus?: boolean | null, taskGroup?: (
    { id: string }
    & { __typename?: 'TaskGroupType' }
  ) | null, template?: (
    { id: string, hardDependency?: boolean | null }
    & { __typename?: 'TemplateType' }
  ) | null, assignee?: (
    { id: string }
    & { __typename?: 'UserType' }
  ) | null, dependency?: (
    { id: string, completed?: boolean | null }
    & { __typename?: 'MilestoneType' | 'TaskGroupType' | 'TaskType' | 'TemplateType' }
  ) | null, dependentTasks?: Array<(
    { id: string }
    & { __typename?: 'TaskType' }
  )> | null, milestone?: (
    { id: string, sortOrder: number, dependentTasks?: Array<(
      { id: string }
      & { __typename?: 'TaskType' }
    )> | null }
    & { __typename?: 'MilestoneType' }
  ) | null }
  & { __typename?: 'TaskType' }
);

export type TemplateTaskBodyFooterTaskFragment = (
  { id: string, name: string, taskType?: TaskTypeEnumType | null, responsibility: TaskResponsibilityEnumType, visibility?: TaskVisibilityEnumType | null, signOffRequired: boolean, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, shouldWarnUpdateStatus?: boolean | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, assignee?: (
    { id: string }
    & { __typename?: 'UserType' }
  ) | null, taskParticipants?: Array<(
    { id: string, invitationSentAt?: any | null }
    & { __typename?: 'TaskParticipantType' }
  )> | null, dependency?: (
    { id: string, completed?: boolean | null }
    & { __typename?: 'MilestoneType' | 'TaskGroupType' | 'TaskType' | 'TemplateType' }
  ) | null }
  & { __typename?: 'TaskType' }
);

export type TemplateTaskInsightsTaskFragment = (
  { id: string, taskType?: TaskTypeEnumType | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, taskParticipants?: Array<(
    { id: string, completed?: boolean | null, user?: (
      { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null }
    & { __typename?: 'TaskParticipantType' }
  )> | null, assignee?: (
    { id: string }
    & { __typename?: 'UserType' }
  ) | null }
  & { __typename?: 'TaskType' }
);

export type TemplateTaskCardFooterTaskFragment = (
  { id: string, name: string, taskType?: TaskTypeEnumType | null, meetingLength?: number | null, eventDatetime?: any | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completedAt?: any | null, dependency?: (
    { id: string, completed?: boolean | null, name: string, forecastedEndOn?: any | null }
    & { __typename: 'MilestoneType' | 'TaskGroupType' }
  ) | (
    { id: string, completed?: boolean | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null, dueOn?: any | null }
    & { __typename: 'TaskType' }
  ) | (
    { id: string, completed?: boolean | null, name: string }
    & { __typename: 'TemplateType' }
  ) | null, tags?: Array<(
    { id: string, color: string, name: string, internalOnly: boolean }
    & { __typename?: 'TagType' }
  )> | null, assignee?: (
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'UserType' }
  ) | null }
  & { __typename?: 'TaskType' }
);

export type TemplateTaskCardFooterDatesTaskFragment = (
  { id: string, name: string, taskType?: TaskTypeEnumType | null, meetingLength?: number | null, eventDatetime?: any | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completedAt?: any | null, dependency?: (
    { id: string, completed?: boolean | null }
    & { __typename?: 'MilestoneType' | 'TaskGroupType' | 'TaskType' | 'TemplateType' }
  ) | null }
  & { __typename?: 'TaskType' }
);

export type TemplateTaskCardHeaderTaskFragment = (
  { id: string, name: string, taskType?: TaskTypeEnumType | null, status: StatusEnumType, sortOrder?: number | null, responsibility: TaskResponsibilityEnumType, milestone?: (
    { id: string }
    & { __typename?: 'MilestoneType' }
  ) | null, assignee?: (
    { id: string }
    & { __typename?: 'UserType' }
  ) | null }
  & { __typename?: 'TaskType' }
);

export type TemplateHeaderMenuSendAssigmentEmailMutationVariables = Exact<{
  taskId: Scalars['ID'];
}>;


export type TemplateHeaderMenuSendAssigmentEmailMutation = (
  { sendAssignmentEmail?: (
    { success?: boolean | null }
    & { __typename?: 'sendAssignmentEmailPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type TemplateHeaderMenuTaskFragment = (
  { id: string, name: string, status: StatusEnumType, sortOrder?: number | null, responsibility: TaskResponsibilityEnumType, taskType?: TaskTypeEnumType | null, assignee?: (
    { id: string }
    & { __typename?: 'UserType' }
  ) | null, milestone?: (
    { id: string }
    & { __typename?: 'MilestoneType' }
  ) | null }
  & { __typename?: 'TaskType' }
);

export type TemplateTaskGroupCardTaskGroupFragment = (
  { id: string, name: string, taskCount: number, sortOrder?: number | null, startedOn?: any | null, forecastedEndOn?: any | null, completedAt?: any | null, summaryBank: (
    { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
    & { __typename?: 'TaskGroupStats' }
  ), tasks?: Array<(
    { id: string, status: StatusEnumType, visibility?: TaskVisibilityEnumType | null, responsibility: TaskResponsibilityEnumType, name: string, taskType?: TaskTypeEnumType | null, signOffRequired: boolean, sortOrder?: number | null, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completedAt?: any | null, taskGroup?: (
      { id: string }
      & { __typename?: 'TaskGroupType' }
    ) | null, milestone?: (
      { id: string, sortOrder: number, dependentTasks?: Array<(
        { id: string }
        & { __typename?: 'TaskType' }
      )> | null }
      & { __typename?: 'MilestoneType' }
    ) | null, signer?: (
      { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
      & { __typename?: 'SignerType' }
    ) | null, assignee?: (
      { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null, dependency?: (
      { id: string, completed?: boolean | null, name: string, forecastedEndOn?: any | null }
      & { __typename: 'MilestoneType' | 'TaskGroupType' }
    ) | (
      { id: string, completed?: boolean | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null, dueOn?: any | null }
      & { __typename: 'TaskType' }
    ) | (
      { id: string, completed?: boolean | null, name: string }
      & { __typename: 'TemplateType' }
    ) | null, tags?: Array<(
      { id: string, color: string, name: string, internalOnly: boolean }
      & { __typename?: 'TagType' }
    )> | null, taskParticipants?: Array<(
      { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
        { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null }
      & { __typename?: 'TaskParticipantType' }
    )> | null, template?: (
      { id: string, hardDependency?: boolean | null }
      & { __typename?: 'TemplateType' }
    ) | null, dependentTasks?: Array<(
      { id: string }
      & { __typename?: 'TaskType' }
    )> | null }
    & { __typename?: 'TaskType' }
  )> | null }
  & { __typename: 'TaskGroupType' }
);

export type UseMilestonesTemplateMilestonesQueryVariables = Exact<{
  templateId: Scalars['ID'];
  taskFilters?: InputMaybe<TaskFilters>;
}>;


export type UseMilestonesTemplateMilestonesQuery = (
  { templateMilestones?: Array<(
    { id: string, sortOrder: number, name: string, startedOn?: any | null, forecastedEndOn?: any | null, completedAt?: any | null, active: boolean, tasksAndGroups?: Array<(
      { id: string, sortOrder?: number | null, name: string, taskCount: number, startedOn?: any | null, forecastedEndOn?: any | null, completedAt?: any | null, tasks?: Array<(
        { id: string, sortOrder?: number | null, status: StatusEnumType, visibility?: TaskVisibilityEnumType | null, responsibility: TaskResponsibilityEnumType, priority?: PriorityEnumType | null, taskType?: TaskTypeEnumType | null, name: string, signOffRequired: boolean, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completedAt?: any | null, assignee?: (
          { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'UserType' }
        ) | null, taskGroup?: (
          { id: string }
          & { __typename?: 'TaskGroupType' }
        ) | null, milestone?: (
          { id: string, sortOrder: number, dependentTasks?: Array<(
            { id: string }
            & { __typename?: 'TaskType' }
          )> | null }
          & { __typename?: 'MilestoneType' }
        ) | null, signer?: (
          { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
          & { __typename?: 'SignerType' }
        ) | null, dependency?: (
          { id: string, completed?: boolean | null, name: string, forecastedEndOn?: any | null }
          & { __typename: 'MilestoneType' | 'TaskGroupType' }
        ) | (
          { id: string, completed?: boolean | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null, dueOn?: any | null }
          & { __typename: 'TaskType' }
        ) | (
          { id: string, completed?: boolean | null, name: string }
          & { __typename: 'TemplateType' }
        ) | null, tags?: Array<(
          { id: string, color: string, name: string, internalOnly: boolean }
          & { __typename?: 'TagType' }
        )> | null, taskParticipants?: Array<(
          { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
            { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
              { originalUrl?: string | null }
              & { __typename?: 'ImageType' }
            ) | null }
            & { __typename?: 'UserType' }
          ) | null }
          & { __typename?: 'TaskParticipantType' }
        )> | null, template?: (
          { id: string, hardDependency?: boolean | null }
          & { __typename?: 'TemplateType' }
        ) | null, dependentTasks?: Array<(
          { id: string }
          & { __typename?: 'TaskType' }
        )> | null }
        & { __typename?: 'TaskType' }
      )> | null, summaryBank: (
        { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
        & { __typename?: 'TaskGroupStats' }
      ) }
      & { __typename: 'TaskGroupType' }
    ) | (
      { id: string, sortOrder?: number | null, status: StatusEnumType, visibility?: TaskVisibilityEnumType | null, responsibility: TaskResponsibilityEnumType, priority?: PriorityEnumType | null, taskType?: TaskTypeEnumType | null, name: string, signOffRequired: boolean, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completedAt?: any | null, assignee?: (
        { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null, milestone?: (
        { id: string, sortOrder: number, dependentTasks?: Array<(
          { id: string }
          & { __typename?: 'TaskType' }
        )> | null }
        & { __typename?: 'MilestoneType' }
      ) | null, signer?: (
        { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
        & { __typename?: 'SignerType' }
      ) | null, dependency?: (
        { id: string, completed?: boolean | null, name: string, forecastedEndOn?: any | null }
        & { __typename: 'MilestoneType' | 'TaskGroupType' }
      ) | (
        { id: string, completed?: boolean | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null, dueOn?: any | null }
        & { __typename: 'TaskType' }
      ) | (
        { id: string, completed?: boolean | null, name: string }
        & { __typename: 'TemplateType' }
      ) | null, tags?: Array<(
        { id: string, color: string, name: string, internalOnly: boolean }
        & { __typename?: 'TagType' }
      )> | null, taskParticipants?: Array<(
        { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
          { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'UserType' }
        ) | null }
        & { __typename?: 'TaskParticipantType' }
      )> | null, taskGroup?: (
        { id: string }
        & { __typename?: 'TaskGroupType' }
      ) | null, template?: (
        { id: string, hardDependency?: boolean | null }
        & { __typename?: 'TemplateType' }
      ) | null, dependentTasks?: Array<(
        { id: string }
        & { __typename?: 'TaskType' }
      )> | null }
      & { __typename?: 'TaskType' }
    )> | null, template: (
      { id: string, hardDependency?: boolean | null }
      & { __typename?: 'TemplateType' }
    ), summaryBank: (
      { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
      & { __typename?: 'MilestoneStats' }
    ), dependentTasks?: Array<(
      { id: string }
      & { __typename?: 'TaskType' }
    )> | null }
    & { __typename?: 'MilestoneType' }
  )> | null }
  & { __typename?: 'Query' }
);

export type TemplateUseMilestonesCreateMilestoneMutationVariables = Exact<{
  milestoneVars: CreateTemplateMilestoneInput;
}>;


export type TemplateUseMilestonesCreateMilestoneMutation = (
  { createTemplateMilestone?: (
    { milestone?: (
      { id: string, name: string, startedOn?: any | null, forecastedEndOn?: any | null, completedAt?: any | null, active: boolean, sortOrder: number, template: (
        { id: string, hardDependency?: boolean | null }
        & { __typename?: 'TemplateType' }
      ), tasksAndGroups?: Array<(
        { id: string, name: string, taskCount: number, sortOrder?: number | null, startedOn?: any | null, forecastedEndOn?: any | null, completedAt?: any | null, summaryBank: (
          { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
          & { __typename?: 'TaskGroupStats' }
        ), tasks?: Array<(
          { id: string, status: StatusEnumType, visibility?: TaskVisibilityEnumType | null, responsibility: TaskResponsibilityEnumType, name: string, taskType?: TaskTypeEnumType | null, signOffRequired: boolean, sortOrder?: number | null, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completedAt?: any | null, taskGroup?: (
            { id: string }
            & { __typename?: 'TaskGroupType' }
          ) | null, milestone?: (
            { id: string, sortOrder: number, dependentTasks?: Array<(
              { id: string }
              & { __typename?: 'TaskType' }
            )> | null }
            & { __typename?: 'MilestoneType' }
          ) | null, signer?: (
            { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
            & { __typename?: 'SignerType' }
          ) | null, assignee?: (
            { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
              { originalUrl?: string | null }
              & { __typename?: 'ImageType' }
            ) | null }
            & { __typename?: 'UserType' }
          ) | null, dependency?: (
            { id: string, completed?: boolean | null, name: string, forecastedEndOn?: any | null }
            & { __typename: 'MilestoneType' | 'TaskGroupType' }
          ) | (
            { id: string, completed?: boolean | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null, dueOn?: any | null }
            & { __typename: 'TaskType' }
          ) | (
            { id: string, completed?: boolean | null, name: string }
            & { __typename: 'TemplateType' }
          ) | null, tags?: Array<(
            { id: string, color: string, name: string, internalOnly: boolean }
            & { __typename?: 'TagType' }
          )> | null, taskParticipants?: Array<(
            { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
              { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
                { originalUrl?: string | null }
                & { __typename?: 'ImageType' }
              ) | null }
              & { __typename?: 'UserType' }
            ) | null }
            & { __typename?: 'TaskParticipantType' }
          )> | null, template?: (
            { id: string, hardDependency?: boolean | null }
            & { __typename?: 'TemplateType' }
          ) | null, dependentTasks?: Array<(
            { id: string }
            & { __typename?: 'TaskType' }
          )> | null }
          & { __typename?: 'TaskType' }
        )> | null }
        & { __typename: 'TaskGroupType' }
      ) | (
        { id: string, status: StatusEnumType, visibility?: TaskVisibilityEnumType | null, responsibility: TaskResponsibilityEnumType, name: string, taskType?: TaskTypeEnumType | null, signOffRequired: boolean, sortOrder?: number | null, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completedAt?: any | null, milestone?: (
          { id: string, sortOrder: number, dependentTasks?: Array<(
            { id: string }
            & { __typename?: 'TaskType' }
          )> | null }
          & { __typename?: 'MilestoneType' }
        ) | null, signer?: (
          { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
          & { __typename?: 'SignerType' }
        ) | null, assignee?: (
          { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'UserType' }
        ) | null, dependency?: (
          { id: string, completed?: boolean | null, name: string, forecastedEndOn?: any | null }
          & { __typename: 'MilestoneType' | 'TaskGroupType' }
        ) | (
          { id: string, completed?: boolean | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null, dueOn?: any | null }
          & { __typename: 'TaskType' }
        ) | (
          { id: string, completed?: boolean | null, name: string }
          & { __typename: 'TemplateType' }
        ) | null, tags?: Array<(
          { id: string, color: string, name: string, internalOnly: boolean }
          & { __typename?: 'TagType' }
        )> | null, taskParticipants?: Array<(
          { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
            { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
              { originalUrl?: string | null }
              & { __typename?: 'ImageType' }
            ) | null }
            & { __typename?: 'UserType' }
          ) | null }
          & { __typename?: 'TaskParticipantType' }
        )> | null, taskGroup?: (
          { id: string }
          & { __typename?: 'TaskGroupType' }
        ) | null, template?: (
          { id: string, hardDependency?: boolean | null }
          & { __typename?: 'TemplateType' }
        ) | null, dependentTasks?: Array<(
          { id: string }
          & { __typename?: 'TaskType' }
        )> | null }
        & { __typename?: 'TaskType' }
      )> | null, summaryBank: (
        { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
        & { __typename?: 'MilestoneStats' }
      ), dependentTasks?: Array<(
        { id: string }
        & { __typename?: 'TaskType' }
      )> | null }
      & { __typename?: 'MilestoneType' }
    ) | null }
    & { __typename?: 'createTemplateMilestonePayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type TemplateUseMilestonesDeleteMilestoneMutationVariables = Exact<{
  deleteMilestoneInput: DeleteMilestoneInput;
}>;


export type TemplateUseMilestonesDeleteMilestoneMutation = (
  { deleteMilestone?: (
    { deleteMilestoneReturnData?: (
      { milestones?: Array<(
        { id: string, tasks?: Array<(
          { id: string, dependency?: (
            { id: string, completed?: boolean | null }
            & { __typename?: 'MilestoneType' | 'TaskGroupType' | 'TemplateType' }
          ) | (
            { id: string, completed?: boolean | null, visibility?: TaskVisibilityEnumType | null }
            & { __typename?: 'TaskType' }
          ) | null }
          & { __typename?: 'TaskType' }
        )> | null }
        & { __typename?: 'MilestoneType' }
      )> | null, templateStats?: (
        { id: string, totalMilestones: number, totalTasks: number, totalCompleteTasks: number, totalPoints: number, totalEstimatedHours: number, totalInternalTasks: number, totalInternalPoints: number, totalInternalHours: number, totalCustomerTasks: number, totalCustomerPoints: number, totalCustomerHours: number, totalThirdPartyTasks: number, totalThirdPartyPoints: number, totalThirdPartyHours: number, totalAssignedTasks: number, totalActualHours: number, totalRemainingHours: number, totalInternalRemainingHours: number, totalInternalActualHours: number, totalCustomerRemainingHours: number, totalCustomerActualHours: number, totalThirdPartyRemainingHours: number, totalThirdPartyActualHours: number }
        & { __typename?: 'TemplateStats' }
      ) | null }
      & { __typename?: 'DeleteMilestoneReturnType' }
    ) | null }
    & { __typename?: 'deleteMilestonePayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type NewMilestoneFragment = (
  { id: string }
  & { __typename?: 'MilestoneType' }
);

export type MoveTasksWithinTaskGroupInTemplateMutationVariables = Exact<{
  input: SortTaskTaskGroupInput;
}>;


export type MoveTasksWithinTaskGroupInTemplateMutation = (
  { sortTaskTaskGroup?: (
    { sortedElement?: { __typename?: 'TaskGroupType' } | (
      { id: string, sortOrder?: number | null, status: StatusEnumType, visibility?: TaskVisibilityEnumType | null, responsibility: TaskResponsibilityEnumType, name: string, taskType?: TaskTypeEnumType | null, signOffRequired: boolean, shouldWarnUpdateStatus?: boolean | null, completeSubtasksCount: number, incompleteSubtasksCount: number, actionItemsCount: number, internalNotesCount: number, publicNotesCount: number, internalFilesCount: number, publicFilesCount: number, invitationGroupSentAt?: any | null, eventDatetime?: any | null, eventInformation?: string | null, participantCallToAction?: string | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, meetingLength?: number | null, dueOn?: any | null, startOn?: any | null, duration?: number | null, completedAt?: any | null, milestone?: (
        { id: string, sortOrder: number, dependentTasks?: Array<(
          { id: string }
          & { __typename?: 'TaskType' }
        )> | null }
        & { __typename?: 'MilestoneType' }
      ) | null, signer?: (
        { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
        & { __typename?: 'SignerType' }
      ) | null, assignee?: (
        { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null, dependency?: (
        { id: string, completed?: boolean | null, name: string, forecastedEndOn?: any | null }
        & { __typename: 'MilestoneType' | 'TaskGroupType' }
      ) | (
        { id: string, completed?: boolean | null, name: string, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null, dueOn?: any | null }
        & { __typename: 'TaskType' }
      ) | (
        { id: string, completed?: boolean | null, name: string }
        & { __typename: 'TemplateType' }
      ) | null, tags?: Array<(
        { id: string, color: string, name: string, internalOnly: boolean }
        & { __typename?: 'TagType' }
      )> | null, taskParticipants?: Array<(
        { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
          { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'UserType' }
        ) | null }
        & { __typename?: 'TaskParticipantType' }
      )> | null, taskGroup?: (
        { id: string }
        & { __typename?: 'TaskGroupType' }
      ) | null, template?: (
        { id: string, hardDependency?: boolean | null }
        & { __typename?: 'TemplateType' }
      ) | null, dependentTasks?: Array<(
        { id: string }
        & { __typename?: 'TaskType' }
      )> | null }
      & { __typename?: 'TaskType' }
    ) | null }
    & { __typename?: 'sortTaskTaskGroupPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type MoveTaskGroupToAnotherMilestoneInTemplateMutationVariables = Exact<{
  input: MoveTaskGroupInput;
}>;


export type MoveTaskGroupToAnotherMilestoneInTemplateMutation = (
  { moveToAnotherMilestone?: (
    { taskGroup?: (
      { id: string, sortOrder?: number | null }
      & { __typename?: 'TaskGroupType' }
    ) | null }
    & { __typename?: 'moveToAnotherMilestonePayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type TemplateUseSortingUpdateTaskMutationVariables = Exact<{
  input: UpdateTaskInput;
}>;


export type TemplateUseSortingUpdateTaskMutation = (
  { updateTaskGroupTask?: (
    { taskReturnData?: (
      { task?: (
        { name: string }
        & { __typename?: 'TaskType' }
      ) | null }
      & { __typename?: 'TaskReturnType' }
    ) | null }
    & { __typename?: 'updateTaskGroupTaskPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type TemplateUseSortingUpdateMilestoneMutationVariables = Exact<{
  milestone: UpdateTemplateMilestoneInput;
}>;


export type TemplateUseSortingUpdateMilestoneMutation = (
  { updateTemplateMilestone?: (
    { milestone?: (
      { id: string, sortOrder: number }
      & { __typename?: 'MilestoneType' }
    ) | null }
    & { __typename?: 'updateTemplateMilestonePayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type TemplateUseSortingCheckDropEligibilityQueryVariables = Exact<{
  input: DropInput;
}>;


export type TemplateUseSortingCheckDropEligibilityQuery = (
  { dropEligibility?: (
    { eligibility?: boolean | null, message?: string | null }
    & { __typename?: 'DropEligibilityType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type ConnectedUsersUsersQueryVariables = Exact<{
  listInputs: ListInput;
}>;


export type ConnectedUsersUsersQuery = (
  { organizationConnectedUsers?: (
    { pageInfo?: (
      { totalPages?: number | null, totalResults?: number | null, currentPage?: number | null, limit?: number | null, isOutOfBounds?: boolean | null }
      & { __typename?: 'PageInfoType' }
    ) | null, users?: Array<(
      { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, role?: UserRoleEnumType | null, status?: string | null, organizationName?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null, organization?: (
        { id: string, name?: string | null }
        & { __typename?: 'OrganizationType' }
      ) | null }
      & { __typename?: 'UserType' }
    )> | null }
    & { __typename?: 'OrganizationConnectedUsersType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type SetDeactivatedOnUserDialogUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, deactivated?: boolean | null }
  & { __typename?: 'UserType' }
);

export type ProjectReassignProjectManagersQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type ProjectReassignProjectManagersQuery = (
  { projectManagers?: Array<(
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, capacity?: number | null, projectsCount?: number | null, organizationName?: string | null, organization?: (
      { id: string, name?: string | null }
      & { __typename?: 'OrganizationType' }
    ) | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null, displayOrganization?: (
      { name: string }
      & { __typename?: 'DisplayOrganizationType' }
    ) | null }
    & { __typename?: 'UserType' }
  )> | null }
  & { __typename?: 'Query' }
);

export type ProjectReassignBulkProjectAssignmentMutationVariables = Exact<{
  projectsIds: Array<Scalars['ID']> | Scalars['ID'];
  projectManagerId?: InputMaybe<Scalars['ID']>;
}>;


export type ProjectReassignBulkProjectAssignmentMutation = (
  { bulkAssignProjects?: (
    { success?: boolean | null }
    & { __typename?: 'bulkAssignProjectsPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ProjectReassignProjectFragment = (
  { id: string, name: string, status: StatusEnumType, projectManager?: (
    { id: string, firstName?: string | null, lastName?: string | null, status?: string | null }
    & { __typename?: 'UserType' }
  ) | null, customerV2?: (
    { id: string, name: string, logo?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'CustomerType' }
  ) | null }
  & { __typename?: 'ProjectType' }
);

export type TaskAssigneesPotentialTaskAssigneesQueryVariables = Exact<{
  milestoneId: Scalars['ID'];
  organizationId?: InputMaybe<Scalars['ID']>;
  projectId?: InputMaybe<Scalars['ID']>;
}>;


export type TaskAssigneesPotentialTaskAssigneesQuery = (
  { potentialTaskAssignees?: Array<(
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, projectContext?: UserProjectOrganizationTypeEnumType | null, role?: UserRoleEnumType | null, jobRole?: string | null, organizationName?: string | null, skills: Array<(
      { id: string }
      & { __typename?: 'Skill' }
    )>, organization?: (
      { id: string, type?: OrganizationTypeEnumType | null, name?: string | null }
      & { __typename?: 'OrganizationType' }
    ) | null, displayOrganization?: (
      { name: string }
      & { __typename?: 'DisplayOrganizationType' }
    ) | null }
    & { __typename?: 'UserType' }
  )> | null }
  & { __typename?: 'Query' }
);

export type TaskReassignProjectTeamQueryVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type TaskReassignProjectTeamQuery = (
  { projectTeam: Array<(
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null, organization?: (
      { id: string, name?: string | null }
      & { __typename?: 'OrganizationType' }
    ) | null }
    & { __typename?: 'UserType' }
  )> }
  & { __typename?: 'Query' }
);

export type TaskReassignTaskFragment = (
  { id: string, name: string, description?: string | null, status: StatusEnumType, project?: (
    { id: string, name: string, status: StatusEnumType, organization?: (
      { id: string }
      & { __typename?: 'OrganizationType' }
    ) | null }
    & { __typename?: 'ProjectType' }
  ) | null }
  & { __typename?: 'TaskType' }
);

export type UserMenuOptionUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, jobRole?: string | null, organizationName?: string | null, organization?: (
    { id: string, name?: string | null }
    & { __typename?: 'OrganizationType' }
  ) | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, displayOrganization?: (
    { name: string }
    & { __typename?: 'DisplayOrganizationType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type UserMenuOptionUserWithCapacityFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, capacity?: number | null, projectsCount?: number | null, organizationName?: string | null, organization?: (
    { id: string, name?: string | null }
    & { __typename?: 'OrganizationType' }
  ) | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, displayOrganization?: (
    { name: string }
    & { __typename?: 'DisplayOrganizationType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type WatchersPotentialTaskWatchersQueryVariables = Exact<{
  taskId: Scalars['ID'];
}>;


export type WatchersPotentialTaskWatchersQuery = (
  { potentialTaskWatchers?: Array<(
    { id: string, firstName?: string | null, lastName?: string | null, jobRole?: string | null, organizationName?: string | null, organization?: (
      { id: string, name?: string | null }
      & { __typename?: 'OrganizationType' }
    ) | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null, displayOrganization?: (
      { name: string }
      & { __typename?: 'DisplayOrganizationType' }
    ) | null }
    & { __typename?: 'UserType' }
  )> | null }
  & { __typename?: 'Query' }
);

export type WatchersWatchersQueryVariables = Exact<{
  taskId: Scalars['ID'];
}>;


export type WatchersWatchersQuery = (
  { task: (
    { id: string, watchers?: Array<(
      { id: string }
      & { __typename?: 'UserType' }
    )> | null }
    & { __typename?: 'TaskType' }
  ) }
  & { __typename?: 'Query' }
);

export type WatchersAddWatcherMutationVariables = Exact<{
  variables: AddWatcherInput;
}>;


export type WatchersAddWatcherMutation = (
  { addWatcher?: (
    { success?: boolean | null }
    & { __typename?: 'addWatcherPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type WatchersRemoveWatcherMutationVariables = Exact<{
  variables: RemoveWatcherInput;
}>;


export type WatchersRemoveWatcherMutation = (
  { removeWatcher?: (
    { success?: boolean | null }
    & { __typename?: 'removeWatcherPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type BrandTableRowTemplateFragment = (
  { id: string, name?: string | null, primaryColor?: string | null, logo?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, headerLogo?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null }
  & { __typename?: 'BrandType' }
);

export type NewBrandFragment = (
  { id: string, name?: string | null, logo?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null }
  & { __typename?: 'BrandType' }
);

export type BrandViewBrandListQueryVariables = Exact<{
  listInputs?: InputMaybe<ListInput>;
}>;


export type BrandViewBrandListQuery = (
  { brands?: Array<(
    { id: string, name?: string | null, primaryColor?: string | null, logo?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null, headerLogo?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'BrandType' }
  )> | null }
  & { __typename?: 'Query' }
);

export type BrandViewCreateBrandMutationVariables = Exact<{
  brand: CreateBrandInput;
}>;


export type BrandViewCreateBrandMutation = (
  { createBrand?: (
    { brand?: (
      { id: string, name?: string | null, primaryColor?: string | null, logo?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null, headerLogo?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'BrandType' }
    ) | null }
    & { __typename?: 'createBrandPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type BrandViewUpdateBrandMutationVariables = Exact<{
  brand: UpdateBrandInput;
}>;


export type BrandViewUpdateBrandMutation = (
  { updateBrand?: (
    { brand?: (
      { id: string, name?: string | null, primaryColor?: string | null, logo?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null, headerLogo?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'BrandType' }
    ) | null }
    & { __typename?: 'updateBrandPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type RemoveBrandDialogDeleteBrandMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveBrandDialogDeleteBrandMutation = (
  { deleteBrand?: (
    { success?: boolean | null }
    & { __typename?: 'deleteBrandPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type MyFiltersButtonUserProjectFilterViewsQueryVariables = Exact<{
  category: Scalars['String'];
}>;


export type MyFiltersButtonUserProjectFilterViewsQuery = (
  { userFilterViews?: Array<(
    { id: string, name?: string | null, jsonFilterBlob?: string | null, category?: UserFilterViewEnumType | null, isDefault?: boolean | null, customers?: Array<(
      { id: string, name: string }
      & { __typename?: 'CustomerType' }
    )> | null }
    & { __typename?: 'UserFilterViewType' }
  )> | null }
  & { __typename?: 'Query' }
);

export type ConfirmDeleteFilterDialogUserFilterViewFragment = (
  { id: string, name?: string | null }
  & { __typename?: 'UserFilterViewType' }
);

export type ConfirmDeleteFilterDialogDeleteFilterViewMutationVariables = Exact<{
  input: DeleteUserFilterViewInput;
}>;


export type ConfirmDeleteFilterDialogDeleteFilterViewMutation = (
  { deleteFilterView?: (
    { success?: boolean | null }
    & { __typename?: 'deleteUserFilterViewPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type FilterMenuItemToggleDefaultFilterMutationVariables = Exact<{
  input: ChangeDefaultUserFilterInput;
}>;


export type FilterMenuItemToggleDefaultFilterMutation = (
  { changeDefaultUserFilter?: (
    { userFilterViews?: Array<(
      { id: string, name?: string | null, isDefault?: boolean | null }
      & { __typename?: 'UserFilterViewType' }
    )> | null }
    & { __typename?: 'changeDefaultUserFilterPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type NewUserFragment = (
  { id: string }
  & { __typename?: 'UserType' }
);

export type AddUserDrawerOrganizationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AddUserDrawerOrganizationQuery = (
  { organization?: (
    { id: string, type?: OrganizationTypeEnumType | null, billableUsersCount?: number | null, maxBillableUsers?: number | null, ratePerUser?: number | null }
    & { __typename?: 'OrganizationType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type AddUserDrawerInviteUserToOrganizationMutationVariables = Exact<{
  user: InviteUserToOrganizationInput;
}>;


export type AddUserDrawerInviteUserToOrganizationMutation = (
  { inviteUserToOrganization?: (
    { user: (
      { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, role?: UserRoleEnumType | null }
      & { __typename?: 'UserType' }
    ) }
    & { __typename?: 'inviteUserToOrganizationPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type AddUserFormOrganizationFragment = (
  { id: string, type?: OrganizationTypeEnumType | null, billableUsersCount?: number | null, maxBillableUsers?: number | null, ratePerUser?: number | null }
  & { __typename?: 'OrganizationType' }
);

export type AuthenticationSettingsOrganizationFragment = (
  { id: string, name?: string | null, secureLinksEnabled: boolean, secureLinksTtl: number, ssoEnabled?: boolean | null, identityProvider?: (
    { id: string, active: boolean, certificate?: string | null, issuer?: string | null, jitProvisioning: boolean, strictMode: boolean, targetUrl?: string | null, entityId: string, attributeConsumeServiceEndpoint: string }
    & { __typename?: 'IdentityProviderType' }
  ) | null }
  & { __typename?: 'OrganizationType' }
);

export type AvailableLicensesOrganizationFragment = (
  { id: string, resourceManagementEnabled?: boolean | null, billableUsersCount?: number | null, maxBillableUsers?: number | null, ratePerUser?: number | null, type?: OrganizationTypeEnumType | null }
  & { __typename?: 'OrganizationType' }
);

export type OrganizationTableRowOrganizationFragment = (
  { id: string, name?: string | null, type?: OrganizationTypeEnumType | null, participatingAs?: string | null, usersCount?: number | null, billableUsersCount?: number | null, createdAt?: any | null, thirdPartyConnectionsCount?: number | null, logo?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, primaryContact?: (
    { firstName?: string | null, lastName?: string | null }
    & { __typename?: 'UserType' }
  ) | null }
  & { __typename?: 'OrganizationType' }
);

export type CompanyIndexOrganizationsQueryVariables = Exact<{
  listInputs?: InputMaybe<ListInput>;
}>;


export type CompanyIndexOrganizationsQuery = (
  { organizationConnections?: (
    { pageInfo?: (
      { totalPages?: number | null, totalResults?: number | null, currentPage?: number | null, limit?: number | null, isOutOfBounds?: boolean | null }
      & { __typename?: 'PageInfoType' }
    ) | null, organizations?: Array<(
      { id: string, name?: string | null, type?: OrganizationTypeEnumType | null, participatingAs?: string | null, usersCount?: number | null, billableUsersCount?: number | null, createdAt?: any | null, thirdPartyConnectionsCount?: number | null, logo?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null, primaryContact?: (
        { firstName?: string | null, lastName?: string | null }
        & { __typename?: 'UserType' }
      ) | null }
      & { __typename?: 'OrganizationType' }
    )> | null }
    & { __typename?: 'OrganizationConnectionType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type CompanyIndexCreateOrganizationMutationVariables = Exact<{
  organization: CreateOrganizationInput;
}>;


export type CompanyIndexCreateOrganizationMutation = (
  { createOrganization?: (
    { organization?: (
      { id: string, name?: string | null, type?: OrganizationTypeEnumType | null, participatingAs?: string | null, usersCount?: number | null, billableUsersCount?: number | null, createdAt?: any | null, thirdPartyConnectionsCount?: number | null, logo?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null, primaryContact?: (
        { firstName?: string | null, lastName?: string | null }
        & { __typename?: 'UserType' }
      ) | null }
      & { __typename?: 'OrganizationType' }
    ) | null }
    & { __typename?: 'createOrganizationPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type CompanyIndexOrganizationFragment = (
  { id: string, name?: string | null, type?: OrganizationTypeEnumType | null, participatingAs?: string | null, usersCount?: number | null, billableUsersCount?: number | null, createdAt?: any | null, thirdPartyConnectionsCount?: number | null, logo?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, primaryContact?: (
    { firstName?: string | null, lastName?: string | null }
    & { __typename?: 'UserType' }
  ) | null }
  & { __typename?: 'OrganizationType' }
);

export type CreateBillingProfileMutationVariables = Exact<{
  input: CreateBillingProfileInput;
}>;


export type CreateBillingProfileMutation = (
  { createBillingProfile?: (
    { billingProfile?: (
      { id: string, name?: string | null }
      & { __typename?: 'BillingProfileType' }
    ) | null }
    & { __typename?: 'createBillingProfilePayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type UpdateBillingProfileMutationVariables = Exact<{
  input: UpdateBillingProfileInput;
}>;


export type UpdateBillingProfileMutation = (
  { updateBillingProfile?: (
    { billingProfile?: (
      { id: string, name?: string | null }
      & { __typename?: 'BillingProfileType' }
    ) | null }
    & { __typename?: 'updateBillingProfilePayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type DeleteBillingProfileMutationVariables = Exact<{
  input: DeleteBillingProfileInput;
}>;


export type DeleteBillingProfileMutation = (
  { deleteBillingProfile?: (
    { success: boolean }
    & { __typename?: 'deleteBillingProfilePayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type BillingProfilesQueryVariables = Exact<{
  listInputs: ListInput;
}>;


export type BillingProfilesQuery = (
  { billingProfileConnections: (
    { billingProfiles?: Array<(
      { allottedHours?: number | null, allowOverages?: boolean | null, description?: string | null, dollars?: number | null, name?: string | null, rateType?: RateTypeEnum | null, secondaryDollars?: number | null, secondaryRateType?: RateTypeEnum | null, id: string }
      & { __typename?: 'BillingProfileType' }
    )> | null, pageInfo?: (
      { totalPages?: number | null, totalResults?: number | null, currentPage?: number | null, limit?: number | null, isOutOfBounds?: boolean | null }
      & { __typename?: 'PageInfoType' }
    ) | null }
    & { __typename?: 'BillingProfileConnectionType' }
  ) }
  & { __typename?: 'Query' }
);

export type ValidateBillingProfileNameQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type ValidateBillingProfileNameQuery = (
  { billingProfileNameExists: (
    { exists: boolean }
    & { __typename?: 'BillingProfileNameExistsType' }
  ) }
  & { __typename?: 'Query' }
);

export type DeleteTimeCategoryDialogDeleteCategoryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteTimeCategoryDialogDeleteCategoryMutation = (
  { deleteTimeTrackingCategory?: (
    { success: boolean }
    & { __typename?: 'deleteTimeTrackingCategoryPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type GlobalTimeTrackingCategoriesCategoryFragment = (
  { name: string, description?: string | null, billable: boolean, billableRate: number, id: string }
  & { __typename?: 'TimeTrackingCategory' }
);

export type GlobalTimeTrackingCategoriesOrganizationQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  listInputs: ListInput;
}>;


export type GlobalTimeTrackingCategoriesOrganizationQuery = (
  { organization?: (
    { timeTrackingCategoryConnections: (
      { pageInfo?: (
        { totalPages?: number | null, totalResults?: number | null, currentPage?: number | null, limit?: number | null, isOutOfBounds?: boolean | null }
        & { __typename?: 'PageInfoType' }
      ) | null, categories?: Array<(
        { name: string, description?: string | null, billable: boolean, billableRate: number, id: string }
        & { __typename?: 'TimeTrackingCategory' }
      )> | null }
      & { __typename?: 'PaginatedCategoriesType' }
    ) }
    & { __typename?: 'OrganizationType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type CompanyUsersUsersQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  listInputs?: InputMaybe<ListInput>;
  userState?: InputMaybe<Scalars['String']>;
}>;


export type CompanyUsersUsersQuery = (
  { organization?: (
    { id: string, timeTrackingEnabled?: boolean | null, adminUsersCount?: number | null, pmUsersCount?: number | null, guideUsersCount?: number | null, contributorUsersCount?: number | null, taskOwnerUsersCount?: number | null, managerUsersCount?: number | null, maxBillableUsers?: number | null, billableUsersCount?: number | null, type?: OrganizationTypeEnumType | null, paginatedUsers?: (
      { pageInfo?: (
        { totalPages?: number | null, totalResults?: number | null, currentPage?: number | null, limit?: number | null, isOutOfBounds?: boolean | null }
        & { __typename?: 'PageInfoType' }
      ) | null, users?: Array<(
        { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, role?: UserRoleEnumType | null, status?: string | null, createdAt?: any | null, costRate?: number | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      )> | null }
      & { __typename?: 'PaginatedUsersType' }
    ) | null }
    & { __typename?: 'OrganizationType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type ConnectHubSpotMutationVariables = Exact<{
  organizationId: Scalars['ID'];
  code: Scalars['String'];
}>;


export type ConnectHubSpotMutation = (
  { connectHubSpot?: (
    { organization?: (
      { id: string, hubSpotIntegration?: (
        { id: string, hubSpotPortalId?: string | null }
        & { __typename?: 'HubspotIntegrationType' }
      ) | null }
      & { __typename?: 'OrganizationType' }
    ) | null }
    & { __typename?: 'connectHubSpotPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ConnectSalesforceMutationVariables = Exact<{
  organizationId: Scalars['ID'];
  code: Scalars['String'];
  host?: InputMaybe<SalesforceHostEnum>;
}>;


export type ConnectSalesforceMutation = (
  { connectSalesforce?: (
    { organization?: (
      { id: string, salesforceIntegration?: (
        { id: string, username?: string | null, organizationName?: string | null }
        & { __typename?: 'SalesforceIntegrationType' }
      ) | null }
      & { __typename?: 'OrganizationType' }
    ) | null }
    & { __typename?: 'connectSalesforcePayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ConnectSalesforcePollStatusQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type ConnectSalesforcePollStatusQuery = (
  { getSalesforcePackageInstallationStatus?: (
    { status?: string | null }
    & { __typename?: 'SalesforcePackageStatusReturnType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type DomainVerificationDrawerDomainFragment = (
  { id: string, domain?: string | null, record1?: string | null, record2?: string | null, record3?: string | null, sendgridWhitelabelId?: string | null }
  & { __typename?: 'DomainVerificationRecordsType' }
);

export type DomainVerificationFormDomainFragment = (
  { id: string, domain?: string | null, record1?: string | null, record2?: string | null, record3?: string | null, sendgridWhitelabelId?: string | null }
  & { __typename?: 'DomainVerificationRecordsType' }
);

export type EditCompanyDrawerOrganizationQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type EditCompanyDrawerOrganizationQuery = (
  { organization?: (
    { id: string, name?: string | null, domain?: string | null, type?: OrganizationTypeEnumType | null, maxBillableUsers?: number | null, ratePerUser?: number | null, ipaasAccountExists: boolean, currencyCode: CurrencyCodeEnumType, timeTrackingEnabled?: boolean | null, brandsEnabled?: boolean | null, hubspotEnabled?: boolean | null, jiraEnabled?: boolean | null, openApiEnabled?: boolean | null, resourceManagementEnabled?: boolean | null, salesforceEnabled?: boolean | null, ssoEnabled?: boolean | null, whiteLabelingEnabled?: boolean | null, customerDashboardEnabled: boolean, logo?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null, adminSettings: (
      { uploadLimitMb: number }
      & { __typename?: 'OrganizationAdminSettings' }
    ) }
    & { __typename?: 'OrganizationType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type EditCompanyDrawerUpdateOrganizationMutationVariables = Exact<{
  input: UpdateOrganizationInput;
}>;


export type EditCompanyDrawerUpdateOrganizationMutation = (
  { updateOrganization?: (
    { organization?: (
      { id: string, name?: string | null, domain?: string | null, type?: OrganizationTypeEnumType | null, maxBillableUsers?: number | null, ratePerUser?: number | null, ipaasAccountExists: boolean, currencyCode: CurrencyCodeEnumType, timeTrackingEnabled?: boolean | null, brandsEnabled?: boolean | null, hubspotEnabled?: boolean | null, jiraEnabled?: boolean | null, openApiEnabled?: boolean | null, resourceManagementEnabled?: boolean | null, salesforceEnabled?: boolean | null, ssoEnabled?: boolean | null, whiteLabelingEnabled?: boolean | null, customerDashboardEnabled: boolean, logo?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null, adminSettings: (
        { uploadLimitMb: number }
        & { __typename?: 'OrganizationAdminSettings' }
      ) }
      & { __typename?: 'OrganizationType' }
    ) | null }
    & { __typename?: 'updateOrganizationPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type EditCustomFieldDrawerMergeTagFragment = (
  { id: string, name: string, sortOrder: number }
  & { __typename?: 'MergeTag' }
);

export type EditCustomFieldFormMergeTagFragment = (
  { id: string, name: string, sortOrder: number }
  & { __typename?: 'MergeTag' }
);

export type EditDialogChannelFragment = (
  { id: string, channelName?: string | null, channelId?: string | null, url?: string | null, teamName?: string | null }
  & { __typename?: 'SlackIntegrationType' }
);

export type EmailSettingsDomainFragment = (
  { id: string, domain?: string | null, status?: boolean | null, record1?: string | null, record2?: string | null, record3?: string | null, sendgridWhitelabelId?: string | null }
  & { __typename?: 'DomainVerificationRecordsType' }
);

export type FeaturesFeaturesFragment = (
  { id: string, timeTrackingEnabled?: boolean | null, brandsEnabled?: boolean | null, hubspotEnabled?: boolean | null, jiraEnabled?: boolean | null, openApiEnabled?: boolean | null, resourceManagementEnabled?: boolean | null, salesforceEnabled?: boolean | null, ssoEnabled?: boolean | null, whiteLabelingEnabled?: boolean | null, customerDashboardEnabled: boolean }
  & { __typename?: 'OrganizationType' }
);

export type HubSpotIntegrationOrganizationFragment = (
  { id: string, hubspotEnabled?: boolean | null, hubSpotIntegration?: (
    { id: string, hubSpotPortalId?: string | null }
    & { __typename?: 'HubspotIntegrationType' }
  ) | null }
  & { __typename?: 'OrganizationType' }
);

export type HubSpotIntegrationGetOAuthHubSpotLinkQueryVariables = Exact<{ [key: string]: never; }>;


export type HubSpotIntegrationGetOAuthHubSpotLinkQuery = (
  { getHubSpotOAuthLink?: string | null }
  & { __typename?: 'Query' }
);

export type HubSpotIntegrationDisconnectHubSpotMutationVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type HubSpotIntegrationDisconnectHubSpotMutation = (
  { disconnectHubSpot?: (
    { organization?: (
      { id: string, hubSpotIntegration?: (
        { id: string, hubSpotPortalId?: string | null }
        & { __typename?: 'HubspotIntegrationType' }
      ) | null }
      & { __typename?: 'OrganizationType' }
    ) | null }
    & { __typename?: 'disconnectHubspotPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type JiraIntegrationOrganizationFragment = (
  { id: string, jiraEnabled?: boolean | null, jiraIntegration?: (
    { id: string, siteName: string, siteUrl: string }
    & { __typename?: 'JiraIntegrationType' }
  ) | null }
  & { __typename?: 'OrganizationType' }
);

export type JiraIntegrationDisconnectJiraMutationVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type JiraIntegrationDisconnectJiraMutation = (
  { disconnectJira?: (
    { organization?: (
      { id: string, jiraEnabled?: boolean | null, jiraIntegration?: (
        { id: string, siteName: string, siteUrl: string }
        & { __typename?: 'JiraIntegrationType' }
      ) | null }
      & { __typename?: 'OrganizationType' }
    ) | null }
    & { __typename?: 'disconnectJiraPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type DeliveriesViewWebhookDeliveryFragment = (
  { id: string, action?: string | null, responseCode?: string | null, details?: string | null, attempts?: number | null, status?: string | null }
  & { __typename?: 'WebhookDeliveryType' }
);

export type DeliveriesLastWebhookDeliveriesQueryVariables = Exact<{
  webhookId: Scalars['ID'];
}>;


export type DeliveriesLastWebhookDeliveriesQuery = (
  { getLastWebhookDeliveries?: Array<(
    { id: string, action?: string | null, responseCode?: string | null, details?: string | null, attempts?: number | null, status?: string | null }
    & { __typename?: 'WebhookDeliveryType' }
  )> | null }
  & { __typename?: 'Query' }
);

export type OpenApiSettingsOrganizationFragment = (
  { id: string, openApiEnabled?: boolean | null, openApiData?: (
    { openApiToken?: string | null, webhooks?: Array<(
      { id: string, url?: string | null, secret?: string | null, active?: boolean | null }
      & { __typename?: 'WebhookType' }
    )> | null }
    & { __typename?: 'OpenApiDataType' }
  ) | null }
  & { __typename?: 'OrganizationType' }
);

export type OpenApiSettingsProjectListQueryVariables = Exact<{
  listInputs?: InputMaybe<ListInput>;
  projectFilters?: InputMaybe<ProjectFilters>;
}>;


export type OpenApiSettingsProjectListQuery = (
  { projectsConnections?: (
    { projects?: Array<(
      { id: string, name: string, customerV2?: (
        { id: string, name: string, logo?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'CustomerType' }
      ) | null }
      & { __typename?: 'ProjectType' }
    )> | null }
    & { __typename?: 'ProjectConnectionType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type OpenApiSettingsCreateWebhookMutationVariables = Exact<{
  input: CreateWebhookInput;
}>;


export type OpenApiSettingsCreateWebhookMutation = (
  { createWebhook?: (
    { organization?: (
      { id: string, openApiEnabled?: boolean | null, openApiData?: (
        { openApiToken?: string | null, webhooks?: Array<(
          { id: string, url?: string | null, secret?: string | null, active?: boolean | null }
          & { __typename?: 'WebhookType' }
        )> | null }
        & { __typename?: 'OpenApiDataType' }
      ) | null }
      & { __typename?: 'OrganizationType' }
    ) | null }
    & { __typename?: 'createWebhookPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type OpenApiSettingsUpdateWebhookMutationVariables = Exact<{
  input: UpdateWebhookInput;
}>;


export type OpenApiSettingsUpdateWebhookMutation = (
  { updateWebhook?: (
    { organization?: (
      { id: string, openApiEnabled?: boolean | null, openApiData?: (
        { openApiToken?: string | null, webhooks?: Array<(
          { id: string, url?: string | null, secret?: string | null, active?: boolean | null }
          & { __typename?: 'WebhookType' }
        )> | null }
        & { __typename?: 'OpenApiDataType' }
      ) | null }
      & { __typename?: 'OrganizationType' }
    ) | null }
    & { __typename?: 'updateWebhookPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type OpenApiSettingsDeleteWebhookMutationVariables = Exact<{
  input: DeleteWebhookInput;
}>;


export type OpenApiSettingsDeleteWebhookMutation = (
  { deleteWebhook?: (
    { organization?: (
      { id: string, openApiEnabled?: boolean | null, openApiData?: (
        { openApiToken?: string | null, webhooks?: Array<(
          { id: string, url?: string | null, secret?: string | null, active?: boolean | null }
          & { __typename?: 'WebhookType' }
        )> | null }
        & { __typename?: 'OpenApiDataType' }
      ) | null }
      & { __typename?: 'OrganizationType' }
    ) | null }
    & { __typename?: 'deleteWebhookPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type OpenApiSettingsTriggerWebhookMutationVariables = Exact<{
  input: TriggerWebhookInput;
}>;


export type OpenApiSettingsTriggerWebhookMutation = (
  { triggerWebhook?: (
    { success?: boolean | null }
    & { __typename?: 'triggerWebhookPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ProjectMenuOptionProjectFragment = (
  { id: string, name: string, customerV2?: (
    { id: string, name: string, logo?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'CustomerType' }
  ) | null }
  & { __typename?: 'ProjectType' }
);

export type TriggerWebhookAlertDialogProjectFragment = (
  { id: string, name: string, customerV2?: (
    { id: string, name: string, logo?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'CustomerType' }
  ) | null }
  & { __typename?: 'ProjectType' }
);

export type OrganizationFormOrganizationFragment = (
  { id: string, name?: string | null, domain?: string | null, type?: OrganizationTypeEnumType | null, maxBillableUsers?: number | null, ratePerUser?: number | null, ipaasAccountExists: boolean, currencyCode: CurrencyCodeEnumType, timeTrackingEnabled?: boolean | null, brandsEnabled?: boolean | null, hubspotEnabled?: boolean | null, jiraEnabled?: boolean | null, openApiEnabled?: boolean | null, resourceManagementEnabled?: boolean | null, salesforceEnabled?: boolean | null, ssoEnabled?: boolean | null, whiteLabelingEnabled?: boolean | null, customerDashboardEnabled: boolean, logo?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, adminSettings: (
    { uploadLimitMb: number }
    & { __typename?: 'OrganizationAdminSettings' }
  ) }
  & { __typename?: 'OrganizationType' }
);

export type OrganizationTableRowRemoveOrgConnectionMutationVariables = Exact<{
  org: RemoveOrgConnectionInput;
}>;


export type OrganizationTableRowRemoveOrgConnectionMutation = (
  { removeOrgConnection?: (
    { organization?: (
      { id: string }
      & { __typename?: 'OrganizationType' }
    ) | null }
    & { __typename?: 'removeOrgConnectionPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ProjectProviderSettingsOrganizationFragment = (
  { id: string, defaultTaskVisibility?: TaskVisibilityEnumType | null, billableRate?: number | null, timeTrackingEnabled?: boolean | null, showShareableLink?: boolean | null, isCsatSurveyEnabled: boolean, internalNotesDefault: boolean, taskFilterByFunction?: boolean | null, currencyCode: CurrencyCodeEnumType, countryCode: CountryCodeEnumType, uploadsEnabled: boolean, setting: (
    { useStatusChangeReasons?: boolean | null }
    & { __typename?: 'OrganizationSetting' }
  ) }
  & { __typename?: 'OrganizationType' }
);

export type SalesforceIntegrationOrganizationFragment = (
  { id: string, salesforceEnabled?: boolean | null, salesforceIntegration?: (
    { id: string, username?: string | null, organizationName?: string | null, host: SalesforceHostEnum }
    & { __typename?: 'SalesforceIntegrationType' }
  ) | null }
  & { __typename?: 'OrganizationType' }
);

export type SalesforceIntegrationDisconnectSalesforceMutationVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type SalesforceIntegrationDisconnectSalesforceMutation = (
  { disconnectSalesforce?: (
    { organization?: (
      { id: string, salesforceIntegration?: (
        { id: string, username?: string | null, organizationName?: string | null }
        & { __typename?: 'SalesforceIntegrationType' }
      ) | null }
      & { __typename?: 'OrganizationType' }
    ) | null }
    & { __typename?: 'disconnectSalesforcePayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type SecureLinksSettingsOrganizationFragment = (
  { id: string, name?: string | null, secureLinksEnabled: boolean, secureLinksTtl: number }
  & { __typename?: 'OrganizationType' }
);

export type LogInSettingsUpdateSecureLinksMutationVariables = Exact<{
  inputs: UpdateOrganizationInput;
}>;


export type LogInSettingsUpdateSecureLinksMutation = (
  { updateOrganization?: (
    { organization?: (
      { id: string, name?: string | null, secureLinksEnabled: boolean, secureLinksTtl: number }
      & { __typename?: 'OrganizationType' }
    ) | null }
    & { __typename?: 'updateOrganizationPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type SingleSignOnSettingsOrganizationFragment = (
  { id: string, ssoEnabled?: boolean | null, identityProvider?: (
    { id: string, active: boolean, certificate?: string | null, issuer?: string | null, jitProvisioning: boolean, strictMode: boolean, targetUrl?: string | null, entityId: string, attributeConsumeServiceEndpoint: string }
    & { __typename?: 'IdentityProviderType' }
  ) | null }
  & { __typename?: 'OrganizationType' }
);

export type SingleSignOnSettingsDeleteIdentityProviderMutationVariables = Exact<{
  inputs: DeleteIdentityProviderInput;
}>;


export type SingleSignOnSettingsDeleteIdentityProviderMutation = (
  { deleteIdentityProvider?: (
    { success?: boolean | null }
    & { __typename?: 'deleteIdentityProviderPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type SingleSignOnSettingsToggleIdentityProviderMutationVariables = Exact<{
  inputs: ToggleIdentityProviderInput;
}>;


export type SingleSignOnSettingsToggleIdentityProviderMutation = (
  { toggleIdentityProvider?: (
    { active?: boolean | null }
    & { __typename?: 'toggleIdentityProviderPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type SingleSignOnSettingsUpdateIdentityProviderMutationVariables = Exact<{
  inputs: UpdateIdentityProviderInput;
}>;


export type SingleSignOnSettingsUpdateIdentityProviderMutation = (
  { updateIdentityProvider?: (
    { organization?: (
      { id: string, ssoEnabled?: boolean | null, identityProvider?: (
        { id: string, active: boolean, certificate?: string | null, issuer?: string | null, jitProvisioning: boolean, strictMode: boolean, targetUrl?: string | null, entityId: string, attributeConsumeServiceEndpoint: string }
        & { __typename?: 'IdentityProviderType' }
      ) | null }
      & { __typename?: 'OrganizationType' }
    ) | null }
    & { __typename?: 'updateIdentityProviderPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type SlackIntegrationOrganizationFragment = (
  { id: string, projectUpdatedSlackDaysPref?: number | null, slackIntegrations?: Array<(
    { id: string, channelName?: string | null, channelId?: string | null, url?: string | null, teamName?: string | null }
    & { __typename?: 'SlackIntegrationType' }
  ) | null> | null }
  & { __typename?: 'OrganizationType' }
);

export type SlackIntegrationDisconnectSlackMutationVariables = Exact<{
  input: DisconnectSlackInput;
}>;


export type SlackIntegrationDisconnectSlackMutation = (
  { disconnectSlack?: (
    { organization?: (
      { id: string, projectUpdatedSlackDaysPref?: number | null, slackIntegrations?: Array<(
        { id: string, channelName?: string | null, channelId?: string | null, url?: string | null, teamName?: string | null }
        & { __typename?: 'SlackIntegrationType' }
      ) | null> | null }
      & { __typename?: 'OrganizationType' }
    ) | null }
    & { __typename?: 'disconnectSlackPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type SlackIntegrationDisconnectSlackChannelMutationVariables = Exact<{
  slackChannelId: DisconnectSlackChannelInput;
}>;


export type SlackIntegrationDisconnectSlackChannelMutation = (
  { disconnectSlackChannel?: (
    { organization?: (
      { id: string, projectUpdatedSlackDaysPref?: number | null, slackIntegrations?: Array<(
        { id: string, channelName?: string | null, channelId?: string | null, url?: string | null, teamName?: string | null }
        & { __typename?: 'SlackIntegrationType' }
      ) | null> | null }
      & { __typename?: 'OrganizationType' }
    ) | null }
    & { __typename?: 'disconnectSlackChannelPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type SlackIntegrationUpdateOrganizationMutationVariables = Exact<{
  organization: UpdateOrganizationInput;
}>;


export type SlackIntegrationUpdateOrganizationMutation = (
  { updateOrganization?: (
    { organization?: (
      { id: string, projectUpdatedSlackDaysPref?: number | null }
      & { __typename?: 'OrganizationType' }
    ) | null }
    & { __typename?: 'updateOrganizationPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type UserTableRowUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, role?: UserRoleEnumType | null, status?: string | null, createdAt?: any | null, costRate?: number | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type WhiteLabelingSettingsOrganizationFragment = (
  { id: string, whiteLabelingEnabled?: boolean | null, primaryColor?: string | null, headerLogo?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null }
  & { __typename?: 'OrganizationType' }
);

export type AddConnectedUserDrawerMutationVariables = Exact<{
  input: AddUserConnectionInput;
}>;


export type AddConnectedUserDrawerMutation = (
  { addUserConnection?: (
    { user: (
      { id: string }
      & { __typename?: 'UserType' }
    ) }
    & { __typename?: 'addUserConnectionPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ConnectedUserTableRowUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, role?: UserRoleEnumType | null, status?: string | null, organizationName?: string | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, organization?: (
    { id: string, name?: string | null }
    & { __typename?: 'OrganizationType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type ConnectedUserTableRowRemoveUserConnectionMutationVariables = Exact<{
  user: RemoveUserConnectionInput;
}>;


export type ConnectedUserTableRowRemoveUserConnectionMutation = (
  { removeUserConnection?: (
    { organizationConnectedUsers?: Array<(
      { id: string }
      & { __typename?: 'UserType' }
    ) | null> | null }
    & { __typename?: 'removeUserConnectionPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type MergeCustomerMutationVariables = Exact<{
  customerToDeleteId: Scalars['ID'];
  reassignToCustomerId: Scalars['ID'];
}>;


export type MergeCustomerMutation = (
  { mergeCustomer?: (
    { success: boolean, errors?: Array<string> | null }
    & { __typename?: 'mergeCustomerPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type FiltersCapacitySkillCategoriesQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type FiltersCapacitySkillCategoriesQuery = (
  { organization?: (
    { id: string, skillCategories: Array<(
      { id: string, name: string, skills: Array<(
        { id: string, name: string, category: (
          { id: string }
          & { __typename?: 'SkillCategory' }
        ) }
        & { __typename?: 'Skill' }
      )> }
      & { __typename?: 'SkillCategory' }
    )> }
    & { __typename?: 'OrganizationType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type AddCompanyFormOrganizationByDomainQueryVariables = Exact<{
  domain?: InputMaybe<Scalars['String']>;
}>;


export type AddCompanyFormOrganizationByDomainQuery = (
  { organizationByDomain?: (
    { name?: string | null, logo?: string | null, domain?: string | null, type?: OrganizationTypeEnumType | null, isStored?: boolean | null, isEditable?: boolean | null }
    & { __typename?: 'SuggestedOrgType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type FilterPlanFormAssigneeFragment = (
  { id: string, email?: string | null, firstName?: string | null, lastName?: string | null, jobRole?: string | null, organizationName?: string | null, organization?: (
    { id: string, name?: string | null }
    & { __typename?: 'OrganizationType' }
  ) | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, displayOrganization?: (
    { name: string }
    & { __typename?: 'DisplayOrganizationType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type MilestoneFormMilestoneFragment = (
  { id: string, name: string, sortOrder: number, description?: string | null, completionMessage?: string | null, enableCompletionNotification?: boolean | null, enableSendSurvey?: boolean | null, files?: Array<(
    { id: string, url?: string | null, fileName: string, size?: number | null, milestoneName?: string | null, taskName?: string | null, createdAt?: any | null, internalOnly: boolean, deletable?: boolean | null, isExternalHyperlink?: boolean | null, uploader?: (
      { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null }
    & { __typename?: 'FileType' }
  )> | null }
  & { __typename?: 'MilestoneType' }
);

export type MilestoneFormMilestoneFormQueryVariables = Exact<{
  milestoneId: Scalars['ID'];
}>;


export type MilestoneFormMilestoneFormQuery = (
  { milestone: (
    { id: string, name: string, sortOrder: number, description?: string | null, completionMessage?: string | null, enableCompletionNotification?: boolean | null, enableSendSurvey?: boolean | null, files?: Array<(
      { id: string, url?: string | null, fileName: string, size?: number | null, milestoneName?: string | null, taskName?: string | null, createdAt?: any | null, internalOnly: boolean, deletable?: boolean | null, isExternalHyperlink?: boolean | null, uploader?: (
        { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null }
      & { __typename?: 'FileType' }
    )> | null }
    & { __typename?: 'MilestoneType' }
  ) }
  & { __typename?: 'Query' }
);

export type AssigneeFieldUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, projectContext?: UserProjectOrganizationTypeEnumType | null, role?: UserRoleEnumType | null, jobRole?: string | null, organizationName?: string | null, skills: Array<(
    { id: string }
    & { __typename?: 'Skill' }
  )>, organization?: (
    { id: string, type?: OrganizationTypeEnumType | null, name?: string | null }
    & { __typename?: 'OrganizationType' }
  ) | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, displayOrganization?: (
    { name: string }
    & { __typename?: 'DisplayOrganizationType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type ContributorFieldsProjectFragment = (
  { id: string, pmDisplayRole?: string | null, projectManager?: (
    { id: string, firstName?: string | null, lastName?: string | null }
    & { __typename?: 'UserType' }
  ) | null }
  & { __typename?: 'ProjectType' }
);

export type FormAssigneeFieldUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, projectContext?: UserProjectOrganizationTypeEnumType | null, jobRole?: string | null, organizationName?: string | null, skills: Array<(
    { id: string }
    & { __typename?: 'Skill' }
  )>, organization?: (
    { id: string, type?: OrganizationTypeEnumType | null, name?: string | null }
    & { __typename?: 'OrganizationType' }
  ) | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, displayOrganization?: (
    { name: string }
    & { __typename?: 'DisplayOrganizationType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type SharedFieldsJiraIntegrationFragment = (
  { defaultProjectId?: string | null, defaultIssueTypeId?: string | null, apiProjects?: Array<(
    { id: string, externalId?: string | null, name?: string | null, issueTypes: Array<(
      { id: string, externalId?: string | null, name?: string | null }
      & { __typename?: 'JiraApiIssueType' }
    )> }
    & { __typename?: 'JiraAPIProjectType' }
  )> | null }
  & { __typename?: 'JiraIntegrationType' }
);

export type SharedFieldsJiraSettingsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  projectId?: InputMaybe<Scalars['String']>;
  shouldSkip?: InputMaybe<Scalars['Boolean']>;
}>;


export type SharedFieldsJiraSettingsQuery = (
  { organization?: (
    { id: string, jiraIntegration?: (
      { id: string, defaultProjectId?: string | null, defaultIssueTypeId?: string | null, apiProjectComponents?: Array<(
        { externalId?: string | null, id: string, name?: string | null }
        & { __typename?: 'JiraApiComponentType' }
      )> | null, apiProjects?: Array<(
        { id: string, externalId?: string | null, name?: string | null, issueTypes: Array<(
          { id: string, externalId?: string | null, name?: string | null }
          & { __typename?: 'JiraApiIssueType' }
        )> }
        & { __typename?: 'JiraAPIProjectType' }
      )> | null }
      & { __typename?: 'JiraIntegrationType' }
    ) | null }
    & { __typename?: 'OrganizationType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type PaginatedAssigneeFieldCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type PaginatedAssigneeFieldCurrentUserQuery = (
  { currentUser?: (
    { id: string, skills: Array<(
      { id: string }
      & { __typename?: 'Skill' }
    )> }
    & { __typename?: 'UserType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type TaskOwnerFieldsProjectFragment = (
  { id: string, pmDisplayRole?: string | null, projectManager?: (
    { id: string, firstName?: string | null, lastName?: string | null }
    & { __typename?: 'UserType' }
  ) | null }
  & { __typename?: 'ProjectType' }
);

export type DeleteTimeEntryDialogTimeRecordFragment = (
  { id: string, taskId?: string | null, billable?: boolean | null, hours?: number | null }
  & { __typename?: 'TimeRecordType' }
);

export type DeleteTimeEntryDialogDeleteTimeRecordMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteTimeEntryDialogDeleteTimeRecordMutation = (
  { deleteTimeRecord?: (
    { success: boolean }
    & { __typename?: 'deleteTimeRecordPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type TimeEntryTableTimeRecordFragment = (
  { id: string, dateWorked?: any | null, description?: string | null, billable?: boolean | null, hours?: number | null, taskId?: string | null, projectId: string, workerId: string, categoryId?: string | null, worker?: (
    { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'UserType' }
  ) | null, category?: (
    { id: string, name: string }
    & { __typename?: 'TimeTrackingCategory' }
  ) | null }
  & { __typename?: 'TimeRecordType' }
);

export type TimeEntryTableTaskTimeRecordsQueryVariables = Exact<{
  taskId: Scalars['ID'];
  listInputs?: InputMaybe<ListInput>;
}>;


export type TimeEntryTableTaskTimeRecordsQuery = (
  { task: (
    { id: string, actualHours?: number | null, estimatedHours?: number | null }
    & { __typename?: 'TaskType' }
  ), taskTimeRecords?: (
    { pageInfo: (
      { totalPages?: number | null, totalResults?: number | null, currentPage?: number | null, limit?: number | null, isOutOfBounds?: boolean | null }
      & { __typename: 'PageInfoType' }
    ), timeRecords: Array<(
      { id: string, dateWorked?: any | null, description?: string | null, billable?: boolean | null, hours?: number | null, taskId?: string | null, projectId: string, workerId: string, categoryId?: string | null, worker?: (
        { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null, category?: (
        { id: string, name: string }
        & { __typename?: 'TimeTrackingCategory' }
      ) | null }
      & { __typename?: 'TimeRecordType' }
    )> }
    & { __typename?: 'TaskTimeRecords' }
  ) | null }
  & { __typename?: 'Query' }
);

export type AssigneeMultiSelectUserFragment = (
  { id: string, email?: string | null, firstName?: string | null, lastName?: string | null, jobRole?: string | null, organizationName?: string | null, organization?: (
    { id: string, name?: string | null }
    & { __typename?: 'OrganizationType' }
  ) | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, displayOrganization?: (
    { name: string }
    & { __typename?: 'DisplayOrganizationType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type FormRoleMultiSelectSkillFragment = (
  { id: string, name: string, category: (
    { id: string }
    & { __typename?: 'SkillCategory' }
  ) }
  & { __typename?: 'Skill' }
);

export type FormRoleMultiSelectSkillCategoriesQueryVariables = Exact<{
  id: Scalars['ID'];
  objectType: ProjectOrTemplateEnumType;
}>;


export type FormRoleMultiSelectSkillCategoriesQuery = (
  { projectOrTemplateSkills: (
    { skillCategories?: Array<(
      { id: string, name: string, skills: Array<(
        { id: string, name: string, category: (
          { id: string }
          & { __typename?: 'SkillCategory' }
        ) }
        & { __typename?: 'Skill' }
      )> }
      & { __typename?: 'SkillCategory' }
    )> | null }
    & { __typename?: 'ProjectOrTemplateSkillsType' }
  ) }
  & { __typename?: 'Query' }
);

export type ParticipantAvatarListUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, projectContext?: UserProjectOrganizationTypeEnumType | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type PaginatedAssigneeMultiSelectUserFragment = (
  { id: string, email?: string | null, firstName?: string | null, lastName?: string | null, jobRole?: string | null, organizationName?: string | null, organization?: (
    { id: string, name?: string | null }
    & { __typename?: 'OrganizationType' }
  ) | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, displayOrganization?: (
    { name: string }
    & { __typename?: 'DisplayOrganizationType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type ParticipantsTaskParticipantsUsersQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  projectId?: InputMaybe<Scalars['ID']>;
  type: TaskResponsibilityEnumType;
  listInputs?: InputMaybe<ListInput>;
}>;


export type ParticipantsTaskParticipantsUsersQuery = (
  { taskParticipantsUsers?: (
    { users?: Array<(
      { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, projectContext?: UserProjectOrganizationTypeEnumType | null, role?: UserRoleEnumType | null, jobRole?: string | null, organizationName?: string | null, skills: Array<(
        { id: string }
        & { __typename?: 'Skill' }
      )>, organization?: (
        { id: string, type?: OrganizationTypeEnumType | null, name?: string | null }
        & { __typename?: 'OrganizationType' }
      ) | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null, displayOrganization?: (
        { name: string }
        & { __typename?: 'DisplayOrganizationType' }
      ) | null }
      & { __typename: 'UserType' }
    )> | null, pageInfo?: (
      { totalPages?: number | null, totalResults?: number | null, currentPage?: number | null, limit?: number | null, isOutOfBounds?: boolean | null }
      & { __typename: 'PageInfoType' }
    ) | null }
    & { __typename: 'PaginatedUsersType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type RoleMultiSelectOrganizationFragment = (
  { id: string, skillCategories: Array<(
    { id: string, name: string, skills: Array<(
      { id: string, name: string, category: (
        { id: string }
        & { __typename?: 'SkillCategory' }
      ) }
      & { __typename?: 'Skill' }
    )> }
    & { __typename?: 'SkillCategory' }
  )> }
  & { __typename?: 'OrganizationType' }
);

export type RoleMultiSelectSkillFragment = (
  { id: string, name: string, category: (
    { id: string }
    & { __typename?: 'SkillCategory' }
  ) }
  & { __typename?: 'Skill' }
);

export type RoleMultiSelectSkillCategoriesQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type RoleMultiSelectSkillCategoriesQuery = (
  { organization?: (
    { id: string, skillCategories: Array<(
      { id: string, name: string, skills: Array<(
        { id: string, name: string, category: (
          { id: string }
          & { __typename?: 'SkillCategory' }
        ) }
        & { __typename?: 'Skill' }
      )> }
      & { __typename?: 'SkillCategory' }
    )> }
    & { __typename?: 'OrganizationType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type TaskFormContextUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, projectContext?: UserProjectOrganizationTypeEnumType | null, role?: UserRoleEnumType | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, displayOrganization?: (
    { name: string }
    & { __typename?: 'DisplayOrganizationType' }
  ) | null, organization?: (
    { id: string, name?: string | null, type?: OrganizationTypeEnumType | null }
    & { __typename?: 'OrganizationType' }
  ) | null, skills: Array<(
    { id: string }
    & { __typename?: 'Skill' }
  )> }
  & { __typename?: 'UserType' }
);

export type TaskFormContextTaskFragment = (
  { id: string, actualHours?: number | null, billableHours?: number | null, nonBillableHours?: number | null, assignmentEmailSentAt?: any | null, completedAt?: any | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, description?: string | null, dueOn?: any | null, duration?: number | null, estimatedHours?: number | null, estimatedPoints?: number | null, eventDatetime?: any | null, eventInformation?: string | null, invitationGroupSentAt?: any | null, meetingLength?: number | null, mustStartOn?: any | null, mustStartOnRequired?: boolean | null, jiraTaskLink?: string | null, name: string, participantCallToAction?: string | null, priority?: PriorityEnumType | null, responsibility: TaskResponsibilityEnumType, shouldWarnUpdateStatus?: boolean | null, signOffRequired: boolean, sortOrder?: number | null, startOn?: any | null, status: StatusEnumType, taskType?: TaskTypeEnumType | null, visibility?: TaskVisibilityEnumType | null, jiraSync?: boolean | null, tags?: Array<(
    { id: string }
    & { __typename?: 'TagType' }
  )> | null, skill?: (
    { id: string }
    & { __typename?: 'Skill' }
  ) | null, skills?: Array<(
    { id: string }
    & { __typename?: 'Skill' }
  )> | null, assignee?: (
    { id: string, firstName?: string | null, lastName?: string | null, calendarLink?: string | null, meetingLink?: string | null, role?: UserRoleEnumType | null, projectContext?: UserProjectOrganizationTypeEnumType | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'UserType' }
  ) | null, creator?: (
    { id: string }
    & { __typename?: 'UserType' }
  ) | null, signer?: (
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
    & { __typename?: 'SignerType' }
  ) | null, jiraTask?: (
    { id: string, externalId?: string | null, externalProjectId?: string | null, externalTypeId?: string | null, components?: Array<string> | null, createdInJira?: any | null }
    & { __typename?: 'JiraIssueType' }
  ) | null, files?: Array<(
    { id: string, sortOrder?: number | null, url?: string | null, fileName: string, size?: number | null, milestoneName?: string | null, taskName?: string | null, createdAt?: any | null, internalOnly: boolean, deletable?: boolean | null, isExternalHyperlink?: boolean | null, uploader?: (
      { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null }
    & { __typename?: 'FileType' }
  )> | null, milestone?: (
    { id: string, sortOrder: number, isFirstOfTemplate: boolean, isFirstOfProject: boolean, template: (
      { id: string, hardDependency?: boolean | null }
      & { __typename?: 'TemplateType' }
    ) }
    & { __typename?: 'MilestoneType' }
  ) | null, project?: (
    { id: string, name: string, status: StatusEnumType, currentUserProjectContext?: UserProjectOrganizationTypeEnumType | null, pmDisplayRole?: string | null, projectManager?: (
      { id: string, firstName?: string | null, lastName?: string | null, calendarLink?: string | null, meetingLink?: string | null }
      & { __typename?: 'UserType' }
    ) | null, organization?: (
      { id: string, name?: string | null, defaultTaskVisibility?: TaskVisibilityEnumType | null, timeTrackingEnabled?: boolean | null, resourceManagementEnabled?: boolean | null, internalNotesDefault: boolean }
      & { __typename?: 'OrganizationType' }
    ) | null, customerV2?: (
      { id: string, name: string }
      & { __typename?: 'CustomerType' }
    ) | null }
    & { __typename?: 'ProjectType' }
  ) | null, dependency?: (
    { id: string, name: string, completed?: boolean | null }
    & { __typename?: 'MilestoneType' | 'TaskGroupType' | 'TemplateType' }
  ) | (
    { id: string, name: string, completed?: boolean | null, shouldWarnUpdateStatus?: boolean | null }
    & { __typename?: 'TaskType' }
  ) | null, subtasks?: Array<(
    { id: string, name?: string | null, richName?: string | null, done?: boolean | null, sortOrder?: number | null, groupId?: string | null }
    & { __typename?: 'SubtaskType' }
  )> | null, subtasksGroups?: Array<(
    { id: string, name?: string | null }
    & { __typename?: 'SubtasksGroupType' }
  )> | null, watchers?: Array<(
    { id: string }
    & { __typename?: 'UserType' }
  )> | null, taskParticipants?: Array<(
    { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
      { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, capacity?: number | null, projectsCount?: number | null, projectContext?: UserProjectOrganizationTypeEnumType | null, organizationName?: string | null, organization?: (
        { id: string, name?: string | null }
        & { __typename?: 'OrganizationType' }
      ) | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null, displayOrganization?: (
        { name: string }
        & { __typename?: 'DisplayOrganizationType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null }
    & { __typename?: 'TaskParticipantType' }
  )> | null, participantsSelectAll?: (
    { internal: boolean, customer: boolean, thirdParty: boolean }
    & { __typename: 'TaskParticipantSelectAllType' }
  ) | null, taskGroup?: (
    { id: string }
    & { __typename?: 'TaskGroupType' }
  ) | null }
  & { __typename?: 'TaskType' }
);

export type TaskFormContextProjectTeamByParticipantsQueryVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type TaskFormContextProjectTeamByParticipantsQuery = (
  { projectTeam: Array<(
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, projectContext?: UserProjectOrganizationTypeEnumType | null, role?: UserRoleEnumType | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null, displayOrganization?: (
      { name: string }
      & { __typename?: 'DisplayOrganizationType' }
    ) | null, organization?: (
      { id: string, name?: string | null, type?: OrganizationTypeEnumType | null }
      & { __typename?: 'OrganizationType' }
    ) | null, skills: Array<(
      { id: string }
      & { __typename?: 'Skill' }
    )> }
    & { __typename?: 'UserType' }
  )> }
  & { __typename?: 'Query' }
);

export type TaskFormContextPotentialTaskDependenciesQueryVariables = Exact<{
  taskId?: InputMaybe<Scalars['ID']>;
  milestoneId: Scalars['ID'];
  taskGroupId?: InputMaybe<Scalars['ID']>;
}>;


export type TaskFormContextPotentialTaskDependenciesQuery = (
  { potentialDependentTasks?: Array<(
    { id: string, name: string, completed?: boolean | null, dueOn?: any | null }
    & { __typename?: 'TaskType' }
  )> | null }
  & { __typename?: 'Query' }
);

export type TaskFormContextPotentialMilestoneDependenciesQueryVariables = Exact<{
  milestoneId: Scalars['ID'];
}>;


export type TaskFormContextPotentialMilestoneDependenciesQuery = (
  { potentialDependentMilestones?: Array<(
    { id: string, name: string, completed?: boolean | null, forecastedEndOn?: any | null }
    & { __typename?: 'MilestoneType' }
  )> | null }
  & { __typename?: 'Query' }
);

export type TaskFormContextPotentialTaskGroupDependenciesQueryVariables = Exact<{
  taskId?: InputMaybe<Scalars['ID']>;
  milestoneId: Scalars['ID'];
  taskGroupId?: InputMaybe<Scalars['ID']>;
}>;


export type TaskFormContextPotentialTaskGroupDependenciesQuery = (
  { potentialDependentTaskGroups?: Array<(
    { id: string, name: string, completed?: boolean | null, forecastedEndOn?: any | null }
    & { __typename?: 'TaskGroupType' }
  )> | null }
  & { __typename?: 'Query' }
);

export type TaskFormContextPotentialTemplateDependencyQueryVariables = Exact<{
  milestoneId: Scalars['ID'];
}>;


export type TaskFormContextPotentialTemplateDependencyQuery = (
  { potentialDependentTemplate: Array<(
    { id: string, name: string, completed?: boolean | null, milestones?: Array<(
      { forecastedEndOn?: any | null }
      & { __typename?: 'MilestoneType' }
    )> | null }
    & { __typename?: 'TemplateType' }
  ) | null> }
  & { __typename?: 'Query' }
);

export type TaskFormContextPotentialTaskAssigneesQueryVariables = Exact<{
  milestoneId: Scalars['ID'];
}>;


export type TaskFormContextPotentialTaskAssigneesQuery = (
  { potentialTaskAssignees?: Array<(
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, projectContext?: UserProjectOrganizationTypeEnumType | null, role?: UserRoleEnumType | null, jobRole?: string | null, organizationName?: string | null, skills: Array<(
      { id: string }
      & { __typename?: 'Skill' }
    )>, organization?: (
      { id: string, type?: OrganizationTypeEnumType | null, name?: string | null }
      & { __typename?: 'OrganizationType' }
    ) | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null, displayOrganization?: (
      { name: string }
      & { __typename?: 'DisplayOrganizationType' }
    ) | null }
    & { __typename?: 'UserType' }
  )> | null }
  & { __typename?: 'Query' }
);

export type TaskFormContextPaginatedPotentialSingleTaskAssigneesQueryVariables = Exact<{
  milestoneId: Scalars['ID'];
  listInput?: InputMaybe<ListInput>;
  responsibility?: InputMaybe<TaskResponsibilityEnumType>;
  skillId?: InputMaybe<Scalars['ID']>;
  skillIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type TaskFormContextPaginatedPotentialSingleTaskAssigneesQuery = (
  { paginatedPotentialTaskAssignees?: (
    { users?: Array<(
      { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, projectContext?: UserProjectOrganizationTypeEnumType | null, role?: UserRoleEnumType | null, jobRole?: string | null, organizationName?: string | null, skills: Array<(
        { id: string }
        & { __typename?: 'Skill' }
      )>, organization?: (
        { id: string, type?: OrganizationTypeEnumType | null, name?: string | null }
        & { __typename?: 'OrganizationType' }
      ) | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null, displayOrganization?: (
        { name: string }
        & { __typename?: 'DisplayOrganizationType' }
      ) | null }
      & { __typename?: 'UserType' }
    )> | null, pageInfo?: (
      { totalPages?: number | null, totalResults?: number | null, currentPage?: number | null, limit?: number | null, isOutOfBounds?: boolean | null }
      & { __typename: 'PageInfoType' }
    ) | null }
    & { __typename?: 'PaginatedUsersType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type TaskFormContextMilestoneInfoQueryVariables = Exact<{
  milestoneId: Scalars['ID'];
}>;


export type TaskFormContextMilestoneInfoQuery = (
  { milestone: (
    { id: string, isFirstOfProject: boolean, isFirstOfTemplate: boolean }
    & { __typename?: 'MilestoneType' }
  ) }
  & { __typename?: 'Query' }
);

export type TaskFormContextTaskCountQueryVariables = Exact<{
  milestoneId: Scalars['ID'];
}>;


export type TaskFormContextTaskCountQuery = (
  { milestoneTaskCount?: number | null }
  & { __typename?: 'Query' }
);

export type NotesNoteFragment = (
  { id: string, raw: string, createdAt: any, deletable?: boolean | null, internalOnly: boolean, user: (
    { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'UserType' }
  ), attachments: Array<(
    { id: string, fileName: string, url?: string | null, internalOnly: boolean }
    & { __typename?: 'FileType' }
  )> }
  & { __typename?: 'NoteType' }
);

export type NotesProjectTeamFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, projectContext?: UserProjectOrganizationTypeEnumType | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, organization?: (
    { id: string }
    & { __typename?: 'OrganizationType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type NotesOnNoteAddedSubscriptionVariables = Exact<{
  noteableId: Scalars['ID'];
}>;


export type NotesOnNoteAddedSubscription = (
  { noteAdded?: (
    { id: string, raw: string, createdAt: any, internalOnly: boolean, user: (
      { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    ), attachments: Array<(
      { id: string, fileName: string, url?: string | null, internalOnly: boolean }
      & { __typename?: 'FileType' }
    )> }
    & { __typename?: 'NoteType' }
  ) | null }
  & { __typename?: 'Subscription' }
);

export type NotesPaginatedNotesQueryVariables = Exact<{
  noteableId: Scalars['ID'];
  noteableType: NoteableEnumType;
  listInput?: InputMaybe<ListInput>;
}>;


export type NotesPaginatedNotesQuery = (
  { noteablePaginatedNotes?: (
    { pageInfo?: (
      { totalPages?: number | null, totalResults?: number | null, currentPage?: number | null, limit?: number | null, isOutOfBounds?: boolean | null }
      & { __typename?: 'PageInfoType' }
    ) | null, notes?: Array<(
      { id: string, raw: string, createdAt: any, deletable?: boolean | null, internalOnly: boolean, user: (
        { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ), attachments: Array<(
        { id: string, fileName: string, url?: string | null, internalOnly: boolean }
        & { __typename?: 'FileType' }
      )> }
      & { __typename?: 'NoteType' }
    )> | null }
    & { __typename?: 'PaginatedNotesType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type CreateProjectNoteMutationVariables = Exact<{
  note: CreateNoteInput;
}>;


export type CreateProjectNoteMutation = (
  { createNote?: (
    { note?: (
      { id: string, raw: string, createdAt: any, deletable?: boolean | null, internalOnly: boolean, user: (
        { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ), attachments: Array<(
        { id: string, fileName: string, url?: string | null, internalOnly: boolean }
        & { __typename?: 'FileType' }
      )> }
      & { __typename?: 'NoteType' }
    ) | null }
    & { __typename?: 'CreatePayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type NotesListNoteFragment = (
  { id: string, raw: string, createdAt: any, internalOnly: boolean, user: (
    { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'UserType' }
  ), attachments: Array<(
    { id: string, fileName: string, url?: string | null, internalOnly: boolean }
    & { __typename?: 'FileType' }
  )> }
  & { __typename?: 'NoteType' }
);

export type UpdateNoteToProjectUpdateNoteMutationVariables = Exact<{
  note: UpdateNoteInput;
}>;


export type UpdateNoteToProjectUpdateNoteMutation = (
  { updateNote?: (
    { note?: (
      { id: string, raw: string, createdAt: any, deletable?: boolean | null, internalOnly: boolean, user: (
        { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ), attachments: Array<(
        { id: string, fileName: string, url?: string | null, internalOnly: boolean }
        & { __typename?: 'FileType' }
      )> }
      & { __typename?: 'NoteType' }
    ) | null }
    & { __typename?: 'UpdatePayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type RemoveNoteDialogDeleteNoteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveNoteDialogDeleteNoteMutation = (
  { deleteNote?: (
    { success?: boolean | null }
    & { __typename?: 'DestroyPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type NotesListItemNoteFragment = (
  { id: string, raw: string, createdAt: any, internalOnly: boolean, user: (
    { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'UserType' }
  ), attachments: Array<(
    { id: string, fileName: string, url?: string | null, internalOnly: boolean }
    & { __typename?: 'FileType' }
  )>, noteable: (
    { id: string, name: string, status: StatusEnumType }
    & { __typename?: 'ProjectType' }
  ) | (
    { id: string, name: string, status: StatusEnumType, milestone?: (
      { id: string }
      & { __typename?: 'MilestoneType' }
    ) | null, project?: (
      { id: string }
      & { __typename?: 'ProjectType' }
    ) | null, template?: (
      { id: string }
      & { __typename?: 'TemplateType' }
    ) | null }
    & { __typename?: 'TaskType' }
  ) }
  & { __typename?: 'NoteType' }
);

export type NotesListItemUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, projectContext?: UserProjectOrganizationTypeEnumType | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, organization?: (
    { id: string }
    & { __typename?: 'OrganizationType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type NotesListItemUpdateNoteMutationVariables = Exact<{
  note: UpdateNoteInput;
}>;


export type NotesListItemUpdateNoteMutation = (
  { updateNote?: (
    { note?: (
      { id: string, raw: string, createdAt: any, internalOnly: boolean, user: (
        { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ), attachments: Array<(
        { id: string, fileName: string, url?: string | null, internalOnly: boolean }
        & { __typename?: 'FileType' }
      )>, noteable: (
        { id: string, name: string, status: StatusEnumType }
        & { __typename?: 'ProjectType' }
      ) | (
        { id: string, name: string, status: StatusEnumType, milestone?: (
          { id: string }
          & { __typename?: 'MilestoneType' }
        ) | null, project?: (
          { id: string }
          & { __typename?: 'ProjectType' }
        ) | null, template?: (
          { id: string }
          & { __typename?: 'TemplateType' }
        ) | null }
        & { __typename?: 'TaskType' }
      ) }
      & { __typename?: 'NoteType' }
    ) | null }
    & { __typename?: 'UpdatePayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type NotesListItemCreateNoteMutationVariables = Exact<{
  note: CreateNoteInput;
}>;


export type NotesListItemCreateNoteMutation = (
  { createNote?: (
    { note?: (
      { id: string, raw: string, createdAt: any, internalOnly: boolean, user: (
        { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ), attachments: Array<(
        { id: string, fileName: string, url?: string | null, internalOnly: boolean }
        & { __typename?: 'FileType' }
      )>, noteable: (
        { id: string, name: string, status: StatusEnumType }
        & { __typename?: 'ProjectType' }
      ) | (
        { id: string, name: string, status: StatusEnumType, milestone?: (
          { id: string }
          & { __typename?: 'MilestoneType' }
        ) | null, project?: (
          { id: string }
          & { __typename?: 'ProjectType' }
        ) | null, template?: (
          { id: string }
          & { __typename?: 'TemplateType' }
        ) | null }
        & { __typename?: 'TaskType' }
      ) }
      & { __typename?: 'NoteType' }
    ) | null }
    & { __typename?: 'CreatePayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type AddCustomerUsersCustomerUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
  & { __typename?: 'UserType' }
);

export type AddCustomerUsersPotentialProjectUsersQueryVariables = Exact<{
  projectId: Scalars['ID'];
  organizationId: Scalars['ID'];
}>;


export type AddCustomerUsersPotentialProjectUsersQuery = (
  { potentialProjectUsers: Array<(
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
    & { __typename?: 'UserType' }
  )> }
  & { __typename?: 'Query' }
);

export type AddCustomerUsersSendWelcomeEmailPreviewMutationVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type AddCustomerUsersSendWelcomeEmailPreviewMutation = (
  { sendWelcomeEmailPreview?: (
    { success?: boolean | null }
    & { __typename?: 'sendWelcomeEmailPreviewPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type AddInternalUsersUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, role?: UserRoleEnumType | null }
  & { __typename?: 'UserType' }
);

export type AddInternalUsersPotentialInternalProjectUsersQueryVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type AddInternalUsersPotentialInternalProjectUsersQuery = (
  { potentialProjectUsers: Array<(
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, role?: UserRoleEnumType | null, jobRole?: string | null, organizationName?: string | null, organization?: (
      { id: string, name?: string | null }
      & { __typename?: 'OrganizationType' }
    ) | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null, displayOrganization?: (
      { name: string }
      & { __typename?: 'DisplayOrganizationType' }
    ) | null }
    & { __typename?: 'UserType' }
  )> }
  & { __typename?: 'Query' }
);

export type AddProjectCustomFieldsFormInfoFieldsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type AddProjectCustomFieldsFormInfoFieldsQuery = (
  { infoFields?: Array<(
    { id: string, name: string }
    & { __typename?: 'MergeTag' }
  )> | null }
  & { __typename?: 'Query' }
);

export type AddRemoveTemplatesFormUpdateProjectMutationVariables = Exact<{
  project: UpdateProjectInput;
}>;


export type AddRemoveTemplatesFormUpdateProjectMutation = (
  { updateProject?: (
    { project?: (
      { id: string, forecastedEndOn?: any | null }
      & { __typename?: 'ProjectType' }
    ) | null }
    & { __typename?: 'updateProjectPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type AddRemoveTemplatesFormAddTemplatesMutationVariables = Exact<{
  input: RemoveTemplateFromProjectInput;
}>;


export type AddRemoveTemplatesFormAddTemplatesMutation = (
  { removeTemplateFromProject?: (
    { success?: boolean | null }
    & { __typename?: 'removeTemplateFromProjectPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type AddTeamMemberDrawerProjectFragment = (
  { id: string, creating?: boolean | null, projectType?: ProjectTypeEnumType | null, customerV2?: (
    { id: string, name: string }
    & { __typename?: 'CustomerType' }
  ) | null }
  & { __typename?: 'ProjectType' }
);

export type AddThirdPartyUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
  & { __typename?: 'UserType' }
);

export type AddThirdPartyUsersPotentialInternalProjectUsersQueryVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type AddThirdPartyUsersPotentialInternalProjectUsersQuery = (
  { potentialThirdPartyUsers: Array<(
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, organizationName?: string | null, organization?: (
      { id: string, name?: string | null }
      & { __typename?: 'OrganizationType' }
    ) | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null, displayOrganization?: (
      { name: string }
      & { __typename?: 'DisplayOrganizationType' }
    ) | null }
    & { __typename?: 'UserType' }
  )> }
  & { __typename?: 'Query' }
);

export type ArchiveProjectConfirmationArchiveProjectMutationVariables = Exact<{
  project: ArchiveProjectInput;
}>;


export type ArchiveProjectConfirmationArchiveProjectMutation = (
  { archiveProject?: (
    { project?: (
      { id: string, archivedAt?: any | null }
      & { __typename?: 'ProjectType' }
    ) | null }
    & { __typename?: 'archiveProjectPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type BillingProfileInputProjectFragment = (
  { id: string, name: string, projectBillRate?: (
    { id: string, rateType?: RateTypeEnum | null, dollars?: number | null, hours?: number | null, rate?: number | null, billingProfileId?: string | null, billingProfileName?: string | null, allottedHours?: number | null, secondaryDollars?: number | null, secondaryRateType?: RateTypeEnum | null, allowOverages?: boolean | null, timeTrackingCategory?: (
      { id: string, name: string, billableRate: number }
      & { __typename?: 'TimeTrackingCategory' }
    ) | null }
    & { __typename?: 'ProjectBillRateType' }
  ) | null }
  & { __typename?: 'ProjectType' }
);

export type FlatFeeInputDollarsHistoryFragment = (
  { date: any, dollars: number }
  & { __typename?: 'DollarsHistory' }
);

export type FlatFeeInputProjectFragment = (
  { id: string, projectBillRate?: (
    { id: string, hours?: number | null, showHoursToCustomers?: boolean | null, rateType?: RateTypeEnum | null, dollarsHistory: Array<(
      { date: any, dollars: number }
      & { __typename?: 'DollarsHistory' }
    )> }
    & { __typename?: 'ProjectBillRateType' }
  ) | null }
  & { __typename?: 'ProjectType' }
);

export type BillableRatesCategoryListSkillCategoryFragment = (
  { id: string, name: string, userCount: number, skillCount: number, skills: Array<(
    { id: string, billableRate: number, name: string, users: Array<(
      { id: string, jobRole?: string | null, firstName?: string | null, lastName?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    )> }
    & { __typename?: 'Skill' }
  )> }
  & { __typename?: 'SkillCategory' }
);

export type ConfirmCreateTemplateDialogFragment = (
  { id: string, name: string }
  & { __typename?: 'TemplateType' }
);

export type ConfirmCreateTemplateDialogCreateTemplateFromProjectPlanMutationVariables = Exact<{
  id: Scalars['ID'];
  duplicateName: Scalars['String'];
  templateType: TemplateEnumType;
}>;


export type ConfirmCreateTemplateDialogCreateTemplateFromProjectPlanMutation = (
  { duplicateTemplate?: (
    { success?: boolean | null }
    & { __typename?: 'duplicateTemplatePayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type DeleteProjectConfirmationRestoreProjectMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteProjectConfirmationRestoreProjectMutation = (
  { restoreProject?: (
    { project?: (
      { id: string, deletedAt?: any | null }
      & { __typename?: 'ProjectType' }
    ) | null }
    & { __typename?: 'restoreProjectPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type DeleteProjectConfirmationDeleteProjectMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteProjectConfirmationDeleteProjectMutation = (
  { deleteProject?: (
    { deletedProjectId?: string | null }
    & { __typename?: 'deleteProjectPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type DownloadArchivedActivitiesMutationVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type DownloadArchivedActivitiesMutation = (
  { downloadArchivedActivities?: (
    { success?: boolean | null }
    & { __typename?: 'downloadArchivedActivitiesPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type DraggableTemplateTemplateFragment = (
  { id: string, name: string, duration?: number | null }
  & { __typename?: 'TemplateType' }
);

export type EditProjectDrawerProjectFragment = (
  { id: string, projectType?: ProjectTypeEnumType | null, name: string, externalId?: string | null, startOn?: any | null, endOn?: any | null, doneTasksCount?: number | null, showForecast: boolean, cashValue?: number | null, bccToProjectManager?: boolean | null, bccEmails?: string | null, bccEmailsEnabled?: boolean | null, salesforceOpportunityName?: string | null, salesforceObjectLink?: string | null, jiraEpicLink?: string | null, hubspotObjectLink?: string | null, hubspotDealName?: string | null, pmDisplayRole?: string | null, pmNote?: string | null, pmNoteInternalOnly?: boolean | null, tags?: Array<(
    { id: string, name: string, color: string, internalOnly: boolean }
    & { __typename?: 'TagType' }
  )> | null, organization?: (
    { id: string, showShareableLink?: boolean | null, salesforceEnabled?: boolean | null, hubspotEnabled?: boolean | null, defaultTaskVisibility?: TaskVisibilityEnumType | null, timeTrackingEnabled?: boolean | null }
    & { __typename?: 'OrganizationType' }
  ) | null, customerV2?: (
    { id: string }
    & { __typename?: 'CustomerType' }
  ) | null, projectManager?: (
    { id: string }
    & { __typename?: 'UserType' }
  ) | null, brand?: (
    { id: string }
    & { __typename?: 'BrandType' }
  ) | null, files?: Array<(
    { id: string, fileName: string, size?: number | null, url?: string | null, internalOnly: boolean, isExternalHyperlink?: boolean | null, uploader?: (
      { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null }
    & { __typename?: 'FileType' }
  )> | null, projectBillRate?: (
    { id: string, rateType?: RateTypeEnum | null, dollars?: number | null, hours?: number | null, rate?: number | null, billingProfileId?: string | null, billingProfileName?: string | null, allottedHours?: number | null, secondaryDollars?: number | null, secondaryRateType?: RateTypeEnum | null, allowOverages?: boolean | null, purchasedHoursRemaining?: number | null, showHoursToCustomers?: boolean | null, requireTimeEntry: boolean, timeTrackingCategory?: (
      { id: string, name: string, billableRate: number }
      & { __typename?: 'TimeTrackingCategory' }
    ) | null, purchasedHoursHistory: Array<(
      { date: any, purchasedHours: number }
      & { __typename?: 'PurchasedHoursHistory' }
    )>, dollarsHistory: Array<(
      { date: any, dollars: number }
      & { __typename?: 'DollarsHistory' }
    )> }
    & { __typename?: 'ProjectBillRateType' }
  ) | null }
  & { __typename?: 'ProjectType' }
);

export type EditProjectDrawerProjectQueryVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type EditProjectDrawerProjectQuery = (
  { project: (
    { id: string, projectType?: ProjectTypeEnumType | null, name: string, externalId?: string | null, startOn?: any | null, endOn?: any | null, doneTasksCount?: number | null, showForecast: boolean, cashValue?: number | null, bccToProjectManager?: boolean | null, bccEmails?: string | null, bccEmailsEnabled?: boolean | null, salesforceOpportunityName?: string | null, salesforceObjectLink?: string | null, jiraEpicLink?: string | null, hubspotObjectLink?: string | null, hubspotDealName?: string | null, pmDisplayRole?: string | null, pmNote?: string | null, pmNoteInternalOnly?: boolean | null, tags?: Array<(
      { id: string, name: string, color: string, internalOnly: boolean }
      & { __typename?: 'TagType' }
    )> | null, organization?: (
      { id: string, showShareableLink?: boolean | null, salesforceEnabled?: boolean | null, hubspotEnabled?: boolean | null, defaultTaskVisibility?: TaskVisibilityEnumType | null, timeTrackingEnabled?: boolean | null }
      & { __typename?: 'OrganizationType' }
    ) | null, customerV2?: (
      { id: string }
      & { __typename?: 'CustomerType' }
    ) | null, projectManager?: (
      { id: string }
      & { __typename?: 'UserType' }
    ) | null, brand?: (
      { id: string }
      & { __typename?: 'BrandType' }
    ) | null, files?: Array<(
      { id: string, fileName: string, size?: number | null, url?: string | null, internalOnly: boolean, isExternalHyperlink?: boolean | null, uploader?: (
        { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null }
      & { __typename?: 'FileType' }
    )> | null, projectBillRate?: (
      { id: string, rateType?: RateTypeEnum | null, dollars?: number | null, hours?: number | null, rate?: number | null, billingProfileId?: string | null, billingProfileName?: string | null, allottedHours?: number | null, secondaryDollars?: number | null, secondaryRateType?: RateTypeEnum | null, allowOverages?: boolean | null, purchasedHoursRemaining?: number | null, showHoursToCustomers?: boolean | null, requireTimeEntry: boolean, timeTrackingCategory?: (
        { id: string, name: string, billableRate: number }
        & { __typename?: 'TimeTrackingCategory' }
      ) | null, purchasedHoursHistory: Array<(
        { date: any, purchasedHours: number }
        & { __typename?: 'PurchasedHoursHistory' }
      )>, dollarsHistory: Array<(
        { date: any, dollars: number }
        & { __typename?: 'DollarsHistory' }
      )> }
      & { __typename?: 'ProjectBillRateType' }
    ) | null }
    & { __typename?: 'ProjectType' }
  ) }
  & { __typename?: 'Query' }
);

export type EditProjectDrawerGetAvailableProjectTagsQueryVariables = Exact<{
  taggableId: Scalars['ID'];
  taggableType: TaggableEnumType;
}>;


export type EditProjectDrawerGetAvailableProjectTagsQuery = (
  { availableTags?: Array<(
    { id: string, color: string, name: string, internalOnly: boolean }
    & { __typename?: 'TagType' }
  )> | null }
  & { __typename?: 'Query' }
);

export type EditTemplatesDrawerProjectFragment = (
  { id: string, templates?: Array<(
    { id: string, name: string, videoUrl?: string | null, experienceOverview?: string | null, sortOrder?: number | null, duration?: number | null, hardDependency?: boolean | null, videoPlaceholderImage?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null, milestones?: Array<(
      { duration?: number | null }
      & { __typename?: 'MilestoneType' }
    )> | null }
    & { __typename?: 'TemplateType' }
  )> | null }
  & { __typename?: 'ProjectType' }
);

export type EditTemplatesDrawerTemplateFragment = (
  { id: string, name: string, videoUrl?: string | null, experienceOverview?: string | null, sortOrder?: number | null, duration?: number | null, hardDependency?: boolean | null, videoPlaceholderImage?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, milestones?: Array<(
    { duration?: number | null }
    & { __typename?: 'MilestoneType' }
  )> | null }
  & { __typename?: 'TemplateType' }
);

export type EditTemplatesDrawerProjectQueryVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type EditTemplatesDrawerProjectQuery = (
  { project: (
    { id: string, templates?: Array<(
      { id: string, name: string, videoUrl?: string | null, experienceOverview?: string | null, sortOrder?: number | null, duration?: number | null, hardDependency?: boolean | null, videoPlaceholderImage?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null, milestones?: Array<(
        { duration?: number | null }
        & { __typename?: 'MilestoneType' }
      )> | null }
      & { __typename?: 'TemplateType' }
    )> | null }
    & { __typename?: 'ProjectType' }
  ) }
  & { __typename?: 'Query' }
);

export type EditTemplatesDrawerUpdateTemplateMutationVariables = Exact<{
  template: UpdateTemplateInput;
}>;


export type EditTemplatesDrawerUpdateTemplateMutation = (
  { updateTemplate?: (
    { template?: (
      { id: string, name: string, videoUrl?: string | null, experienceOverview?: string | null, sortOrder?: number | null, duration?: number | null, videoPlaceholderImage?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null, milestones?: Array<(
        { duration?: number | null }
        & { __typename?: 'MilestoneType' }
      )> | null }
      & { __typename?: 'TemplateType' }
    ) | null }
    & { __typename?: 'updateTemplatePayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type EditTemplatesDrawerAddTemplatesMutationVariables = Exact<{
  input: AddTemplatesToProjectInput;
}>;


export type EditTemplatesDrawerAddTemplatesMutation = (
  { addTemplatesToProject?: (
    { success?: boolean | null }
    & { __typename?: 'addTemplatesToProjectPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type EventInformationTaskFragment = (
  { id: string, eventDatetime?: any | null, eventInformation?: string | null, name: string, assignee?: (
    { id: string }
    & { __typename?: 'UserType' }
  ) | null, milestone?: (
    { id: string }
    & { __typename?: 'MilestoneType' }
  ) | null, template?: (
    { id: string }
    & { __typename?: 'TemplateType' }
  ) | null, project?: (
    { id: string }
    & { __typename?: 'ProjectType' }
  ) | null, taskParticipants?: Array<(
    { id: string, completed?: boolean | null, user?: (
      { id: string, email?: string | null, firstName?: string | null, lastName?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null }
    & { __typename?: 'TaskParticipantType' }
  )> | null }
  & { __typename?: 'TaskType' }
);

export type FilterActionItemDrawerUserFragment = (
  { id: string, email?: string | null, firstName?: string | null, lastName?: string | null, jobRole?: string | null, organizationName?: string | null, organization?: (
    { id: string, name?: string | null }
    & { __typename?: 'OrganizationType' }
  ) | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, displayOrganization?: (
    { name: string }
    & { __typename?: 'DisplayOrganizationType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type FilterActionItemDrawerTaskFragment = (
  { id: string, name: string }
  & { __typename?: 'TaskType' }
);

export type FilterActionItemFormUserFragment = (
  { id: string, email?: string | null, firstName?: string | null, lastName?: string | null, jobRole?: string | null, organizationName?: string | null, organization?: (
    { id: string, name?: string | null }
    & { __typename?: 'OrganizationType' }
  ) | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, displayOrganization?: (
    { name: string }
    & { __typename?: 'DisplayOrganizationType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type FilterActionItemFormTaskFragment = (
  { id: string, name: string }
  & { __typename?: 'TaskType' }
);

export type FilterProjectPlanDrawerAssigneeFragment = (
  { id: string, email?: string | null, firstName?: string | null, lastName?: string | null, jobRole?: string | null, organizationName?: string | null, organization?: (
    { id: string, name?: string | null }
    & { __typename?: 'OrganizationType' }
  ) | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, displayOrganization?: (
    { name: string }
    & { __typename?: 'DisplayOrganizationType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type FilterProjectPlanDrawerAvailableTagsQueryVariables = Exact<{
  taggableId: Scalars['ID'];
  type?: InputMaybe<Scalars['String']>;
  taggableType: TaggableEnumType;
}>;


export type FilterProjectPlanDrawerAvailableTagsQuery = (
  { availableTags?: Array<(
    { id: string, color: string, name: string, internalOnly: boolean }
    & { __typename?: 'TagType' }
  )> | null }
  & { __typename?: 'Query' }
);

export type FormTimePreferencesProjectFragment = (
  { id: string, projectBillRate?: (
    { id: string, requireTimeEntry: boolean }
    & { __typename?: 'ProjectBillRateType' }
  ) | null }
  & { __typename?: 'ProjectType' }
);

export type RequireTimeEntriesFormProjectBillRateFragment = (
  { id: string, requireTimeEntry: boolean }
  & { __typename?: 'ProjectBillRateType' }
);

export type GroupTaskInformationTaskFragment = (
  { id: string, participantCallToAction?: string | null, invitationGroupSentAt?: any | null, name: string, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, assignee?: (
    { id: string }
    & { __typename?: 'UserType' }
  ) | null, taskParticipants?: Array<(
    { id: string, invitationSentAt?: any | null, completed?: boolean | null, user?: (
      { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null }
    & { __typename?: 'TaskParticipantType' }
  )> | null, milestone?: (
    { id: string }
    & { __typename?: 'MilestoneType' }
  ) | null, template?: (
    { id: string }
    & { __typename?: 'TemplateType' }
  ) | null, project?: (
    { id: string }
    & { __typename?: 'ProjectType' }
  ) | null }
  & { __typename?: 'TaskType' }
);

export type GroupTaskInformationToggleGroupTaskCompletedMutationVariables = Exact<{
  taskInputs: ToggleGroupTaskCompletedInput;
}>;


export type GroupTaskInformationToggleGroupTaskCompletedMutation = (
  { toggleGroupTaskCompleted?: (
    { task?: (
      { id: string, taskParticipants?: Array<(
        { id: string, completed?: boolean | null }
        & { __typename?: 'TaskParticipantType' }
      )> | null }
      & { __typename?: 'PublicTask' }
    ) | null }
    & { __typename?: 'toggleGroupTaskCompletedPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type MyTaskChecklistGroupToggleMutationVariables = Exact<{
  input: ToggleSubtaskDoneInput;
}>;


export type MyTaskChecklistGroupToggleMutation = (
  { toggleSubtask?: (
    { subtask?: (
      { id: string, name?: string | null, richName?: string | null, done?: boolean | null, sortOrder?: number | null, groupId?: string | null }
      & { __typename?: 'SubtaskType' }
    ) | null }
    & { __typename?: 'toggleSubtaskDonePayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type MyTasksAttachmentsTaskFragment = (
  { id: string, milestone?: (
    { id: string }
    & { __typename?: 'MilestoneType' }
  ) | null }
  & { __typename?: 'TaskType' }
);

export type MyTasksAttachmentsFileFragment = (
  { id: string, fileName: string, size?: number | null, url?: string | null }
  & { __typename?: 'FileType' }
);

export type MyTasksNoteNoteFragment = (
  { id: string, raw: string, createdAt: any, user: (
    { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'UserType' }
  ) }
  & { __typename?: 'NoteType' }
);

export type PmNoteFormProjectFragment = (
  { id: string, pmDisplayRole?: string | null, pmNote?: string | null, pmNoteInternalOnly?: boolean | null }
  & { __typename?: 'ProjectType' }
);

export type ProjectActionItemsUpdateActionItemMutationVariables = Exact<{
  input: UpdateActionItemInput;
}>;


export type ProjectActionItemsUpdateActionItemMutation = (
  { updateActionItem?: (
    { actionItem?: (
      { id: string, name?: string | null, createdOn?: any | null, description?: any | null, priority: PriorityEnumType, status: ActionItemStatusEnumType, startOn?: any | null, dueOn?: any | null, visibility?: ActionItemVisibilityEnumType | null, tags?: Array<(
        { id: string }
        & { __typename?: 'TagType' }
      )> | null, assignee?: (
        { id: string, firstName?: string | null }
        & { __typename?: 'UserType' }
      ) | null, relatedTask?: (
        { id: string, name: string, milestone?: (
          { id: string, name: string }
          & { __typename?: 'MilestoneType' }
        ) | null }
        & { __typename?: 'TaskType' }
      ) | null }
      & { __typename?: 'ActionItemType' }
    ) | null }
    & { __typename?: 'updateActionItemPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ActionItemDrawerUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, projectContext?: UserProjectOrganizationTypeEnumType | null, role?: UserRoleEnumType | null, jobRole?: string | null, organizationName?: string | null, skills: Array<(
    { id: string }
    & { __typename?: 'Skill' }
  )>, organization?: (
    { id: string, type?: OrganizationTypeEnumType | null, name?: string | null }
    & { __typename?: 'OrganizationType' }
  ) | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, displayOrganization?: (
    { name: string }
    & { __typename?: 'DisplayOrganizationType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type ActionItemDrawerTaskFragment = (
  { id: string, name: string }
  & { __typename?: 'TaskType' }
);

export type ActionItemFormActionItemFragment = (
  { id: string, name?: string | null, createdOn?: any | null, description?: any | null, priority: PriorityEnumType, status: ActionItemStatusEnumType, startOn?: any | null, dueOn?: any | null, visibility?: ActionItemVisibilityEnumType | null, tags?: Array<(
    { id: string }
    & { __typename?: 'TagType' }
  )> | null, assignee?: (
    { id: string, firstName?: string | null }
    & { __typename?: 'UserType' }
  ) | null, relatedTask?: (
    { id: string, name: string, milestone?: (
      { id: string, name: string }
      & { __typename?: 'MilestoneType' }
    ) | null }
    & { __typename?: 'TaskType' }
  ) | null }
  & { __typename?: 'ActionItemType' }
);

export type ActionItemFormUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, projectContext?: UserProjectOrganizationTypeEnumType | null, role?: UserRoleEnumType | null, jobRole?: string | null, organizationName?: string | null, skills: Array<(
    { id: string }
    & { __typename?: 'Skill' }
  )>, organization?: (
    { id: string, type?: OrganizationTypeEnumType | null, name?: string | null }
    & { __typename?: 'OrganizationType' }
  ) | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, displayOrganization?: (
    { name: string }
    & { __typename?: 'DisplayOrganizationType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type ActionItemFormTaskFragment = (
  { id: string, name: string }
  & { __typename?: 'TaskType' }
);

export type ActionItemRowActionItemRowFragment = (
  { id: string, name?: string | null, createdOn?: any | null, priority: PriorityEnumType, status: ActionItemStatusEnumType, dueOn?: any | null, visibility?: ActionItemVisibilityEnumType | null, internalNotesCount: number, relatedTask?: (
    { id: string, name: string, milestone?: (
      { id: string, name: string }
      & { __typename?: 'MilestoneType' }
    ) | null }
    & { __typename?: 'TaskType' }
  ) | null, assignee?: (
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'UserType' }
  ) | null, tags?: Array<(
    { id: string, color: string, name: string, internalOnly: boolean }
    & { __typename?: 'TagType' }
  )> | null }
  & { __typename?: 'ActionItemType' }
);

export type ProjectActionItemsActionItemsQueryVariables = Exact<{
  projectId: Scalars['ID'];
  listInputs?: InputMaybe<ListInputTypeV2>;
  actionItemFilters?: InputMaybe<FiltersInput>;
}>;


export type ProjectActionItemsActionItemsQuery = (
  { project: (
    { id: string, actionItems?: Array<(
      { id: string, name?: string | null, createdOn?: any | null, priority: PriorityEnumType, status: ActionItemStatusEnumType, dueOn?: any | null, visibility?: ActionItemVisibilityEnumType | null, internalNotesCount: number, relatedTask?: (
        { id: string, name: string, milestone?: (
          { id: string, name: string }
          & { __typename?: 'MilestoneType' }
        ) | null }
        & { __typename?: 'TaskType' }
      ) | null, assignee?: (
        { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null, tags?: Array<(
        { id: string, color: string, name: string, internalOnly: boolean }
        & { __typename?: 'TagType' }
      )> | null }
      & { __typename?: 'ActionItemType' }
    )> | null }
    & { __typename?: 'ProjectType' }
  ) }
  & { __typename?: 'Query' }
);

export type ProjectActionItemsProjectTeamQueryVariables = Exact<{
  projectId: Scalars['ID'];
  internalOnly?: InputMaybe<Scalars['Boolean']>;
}>;


export type ProjectActionItemsProjectTeamQuery = (
  { projectTeam: Array<(
    { id: string, email?: string | null, firstName?: string | null, lastName?: string | null, projectContext?: UserProjectOrganizationTypeEnumType | null, role?: UserRoleEnumType | null, jobRole?: string | null, organizationName?: string | null, skills: Array<(
      { id: string }
      & { __typename?: 'Skill' }
    )>, organization?: (
      { id: string, type?: OrganizationTypeEnumType | null, name?: string | null }
      & { __typename?: 'OrganizationType' }
    ) | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null, displayOrganization?: (
      { name: string }
      & { __typename?: 'DisplayOrganizationType' }
    ) | null }
    & { __typename?: 'UserType' }
  )> }
  & { __typename?: 'Query' }
);

export type ProjectActionItemsProjectTasksQueryVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type ProjectActionItemsProjectTasksQuery = (
  { projectTasks?: Array<(
    { id: string, name: string }
    & { __typename?: 'TaskType' }
  )> | null }
  & { __typename?: 'Query' }
);

export type ProjectActionItemsCreateActionItemMutationVariables = Exact<{
  input: CreateActionItemInput;
}>;


export type ProjectActionItemsCreateActionItemMutation = (
  { createActionItem?: (
    { actionItem?: (
      { id: string, name?: string | null, createdOn?: any | null, priority: PriorityEnumType, status: ActionItemStatusEnumType, dueOn?: any | null, visibility?: ActionItemVisibilityEnumType | null, internalNotesCount: number, relatedTask?: (
        { id: string, name: string, milestone?: (
          { id: string, name: string }
          & { __typename?: 'MilestoneType' }
        ) | null }
        & { __typename?: 'TaskType' }
      ) | null, assignee?: (
        { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null, tags?: Array<(
        { id: string, color: string, name: string, internalOnly: boolean }
        & { __typename?: 'TagType' }
      )> | null }
      & { __typename?: 'ActionItemType' }
    ) | null }
    & { __typename?: 'createActionItemPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ProjectActionItemsDeleteActionItemMutationVariables = Exact<{
  input: DeleteActionItemInput;
}>;


export type ProjectActionItemsDeleteActionItemMutation = (
  { deleteActionItem?: (
    { actionItemId: string }
    & { __typename?: 'deleteActionItemPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ProjectActionItemsProjectTeamFragment = (
  { id: string, email?: string | null, firstName?: string | null, lastName?: string | null, projectContext?: UserProjectOrganizationTypeEnumType | null, role?: UserRoleEnumType | null, jobRole?: string | null, organizationName?: string | null, skills: Array<(
    { id: string }
    & { __typename?: 'Skill' }
  )>, organization?: (
    { id: string, type?: OrganizationTypeEnumType | null, name?: string | null }
    & { __typename?: 'OrganizationType' }
  ) | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, displayOrganization?: (
    { name: string }
    & { __typename?: 'DisplayOrganizationType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type ProjectFilesProjectFragment = (
  { id: string, name: string }
  & { __typename?: 'ProjectType' }
);

export type ProjectFilesFileFragment = (
  { id: string, url?: string | null, fileName: string, size?: number | null, milestoneName?: string | null, deletable?: boolean | null, taskName?: string | null, createdAt?: any | null, internalOnly: boolean, isExternalHyperlink?: boolean | null, uploader?: (
    { id: string, firstName?: string | null, lastName?: string | null }
    & { __typename?: 'UserType' }
  ) | null, assetable?: { __typename?: 'MilestoneType' | 'ProjectType' | 'TemplateType' } | (
    { id: string, milestone?: (
      { id: string }
      & { __typename?: 'MilestoneType' }
    ) | null, project?: (
      { id: string }
      & { __typename?: 'ProjectType' }
    ) | null, template?: (
      { id: string }
      & { __typename?: 'TemplateType' }
    ) | null }
    & { __typename?: 'TaskType' }
  ) | null }
  & { __typename?: 'FileType' }
);

export type ProjectFilesFilesQueryVariables = Exact<{
  projectId: Scalars['ID'];
  listInputs?: InputMaybe<ListInput>;
}>;


export type ProjectFilesFilesQuery = (
  { files?: (
    { pageInfo?: (
      { totalPages?: number | null, totalResults?: number | null, currentPage?: number | null, limit?: number | null, isOutOfBounds?: boolean | null }
      & { __typename?: 'PageInfoType' }
    ) | null, assets?: Array<(
      { id: string, url?: string | null, fileName: string, size?: number | null, milestoneName?: string | null, deletable?: boolean | null, taskName?: string | null, createdAt?: any | null, internalOnly: boolean, isExternalHyperlink?: boolean | null, uploader?: (
        { id: string, firstName?: string | null, lastName?: string | null }
        & { __typename?: 'UserType' }
      ) | null, assetable?: { __typename?: 'MilestoneType' | 'ProjectType' | 'TemplateType' } | (
        { id: string, milestone?: (
          { id: string }
          & { __typename?: 'MilestoneType' }
        ) | null, project?: (
          { id: string }
          & { __typename?: 'ProjectType' }
        ) | null, template?: (
          { id: string }
          & { __typename?: 'TemplateType' }
        ) | null }
        & { __typename?: 'TaskType' }
      ) | null }
      & { __typename?: 'FileType' }
    )> | null }
    & { __typename?: 'AssetConnectionType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type ProjectFilesSendAttachmentsMutationVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type ProjectFilesSendAttachmentsMutation = (
  { sendProjectAttachments?: (
    { success?: boolean | null }
    & { __typename?: 'sendProjectAttachmentsPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ProjectFilesDeleteFileMutationVariables = Exact<{
  deleteFileInput: DeleteFileInput;
}>;


export type ProjectFilesDeleteFileMutation = (
  { deleteFile?: (
    { success?: boolean | null }
    & { __typename?: 'DeleteFilePayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ProjectInfoFormProjectFragment = (
  { id: string, name: string, externalId?: string | null, startOn?: any | null, endOn?: any | null, doneTasksCount?: number | null, showForecast: boolean, cashValue?: number | null, bccToProjectManager?: boolean | null, bccEmails?: string | null, bccEmailsEnabled?: boolean | null, salesforceOpportunityName?: string | null, salesforceObjectLink?: string | null, jiraEpicLink?: string | null, hubspotObjectLink?: string | null, hubspotDealName?: string | null, projectManager?: (
    { id: string }
    & { __typename?: 'UserType' }
  ) | null, brand?: (
    { id: string }
    & { __typename?: 'BrandType' }
  ) | null, files?: Array<(
    { id: string, fileName: string, size?: number | null, url?: string | null, internalOnly: boolean, isExternalHyperlink?: boolean | null, uploader?: (
      { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null }
    & { __typename?: 'FileType' }
  )> | null, customerV2?: (
    { id: string }
    & { __typename?: 'CustomerType' }
  ) | null, organization?: (
    { id: string, salesforceEnabled?: boolean | null, hubspotEnabled?: boolean | null, defaultTaskVisibility?: TaskVisibilityEnumType | null, timeTrackingEnabled?: boolean | null }
    & { __typename?: 'OrganizationType' }
  ) | null, projectBillRate?: (
    { id: string, rateType?: RateTypeEnum | null, dollars?: number | null, hours?: number | null, rate?: number | null, billingProfileId?: string | null, billingProfileName?: string | null, allottedHours?: number | null, secondaryDollars?: number | null, secondaryRateType?: RateTypeEnum | null, allowOverages?: boolean | null, purchasedHoursRemaining?: number | null, showHoursToCustomers?: boolean | null, requireTimeEntry: boolean, timeTrackingCategory?: (
      { id: string, name: string, billableRate: number }
      & { __typename?: 'TimeTrackingCategory' }
    ) | null, purchasedHoursHistory: Array<(
      { date: any, purchasedHours: number }
      & { __typename?: 'PurchasedHoursHistory' }
    )>, dollarsHistory: Array<(
      { date: any, dollars: number }
      & { __typename?: 'DollarsHistory' }
    )> }
    & { __typename?: 'ProjectBillRateType' }
  ) | null }
  & { __typename?: 'ProjectType' }
);

export type ProjectInfoFormProjectManagersQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectInfoFormProjectManagersQuery = (
  { projectManagers?: Array<(
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, capacity?: number | null, projectsCount?: number | null, organizationName?: string | null, organization?: (
      { id: string, name?: string | null }
      & { __typename?: 'OrganizationType' }
    ) | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null, displayOrganization?: (
      { name: string }
      & { __typename?: 'DisplayOrganizationType' }
    ) | null }
    & { __typename?: 'UserType' }
  )> | null }
  & { __typename?: 'Query' }
);

export type ProjectInfoFormBrandListQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectInfoFormBrandListQuery = (
  { brands?: Array<(
    { id: string, name?: string | null, logo?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'BrandType' }
  )> | null }
  & { __typename?: 'Query' }
);

export type ProjectInfoFormInfoFieldsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type ProjectInfoFormInfoFieldsQuery = (
  { infoFields?: Array<(
    { id: string, name: string }
    & { __typename?: 'MergeTag' }
  )> | null }
  & { __typename?: 'Query' }
);

export type ProjectInfoFormUpsertInfoFieldsMutationVariables = Exact<{
  input: UpsertProjectInfoFieldInput;
}>;


export type ProjectInfoFormUpsertInfoFieldsMutation = (
  { upsertProjectInfoField?: (
    { success?: boolean | null }
    & { __typename?: 'upsertProjectInfoFieldsPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ProjectInfoFormTemplateFragment = (
  { id: string, name: string, duration?: number | null, experienceOverview?: string | null, description?: string | null, videoUrl?: string | null, sortOrder?: number | null, videoPlaceholderImage?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null }
  & { __typename?: 'TemplateType' }
);

export type PendingProjectDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PendingProjectDetailQuery = (
  { pendingProject?: (
    { id: string, name?: string | null, domain?: string | null, provider?: string | null, externalId?: string | null, startOn?: any | null, endOn?: any | null, cashValue?: number | null, customerUsersBlob?: Array<string> | null, apiProjectId?: string | null, organization?: (
      { id: string, name?: string | null, hubspotEnabled?: boolean | null, salesforceEnabled?: boolean | null, openApiEnabled?: boolean | null, hubSpotIntegration?: (
        { id: string }
        & { __typename?: 'HubspotIntegrationType' }
      ) | null, salesforceIntegration?: (
        { id: string }
        & { __typename?: 'SalesforceIntegrationType' }
      ) | null }
      & { __typename?: 'OrganizationType' }
    ) | null, projectManager?: (
      { id: string }
      & { __typename?: 'UserType' }
    ) | null, templates?: Array<(
      { id: string }
      & { __typename?: 'TemplateType' }
    )> | null, customFields?: Array<(
      { id: string, value?: string | null }
      & { __typename?: 'PendingCustomFieldType' }
    )> | null }
    & { __typename?: 'PendingProjectType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type ProjectListTableProjectFragment = (
  { id: string, deletedAt?: any | null, errorsCount: number, name: string, cashValue?: number | null, totalTasksCount?: number | null, openTasksCount?: number | null, openActionItemsCount?: number | null, overdueTasksCount?: number | null, startOn?: any | null, endOn?: any | null, completedAt?: any | null, forecastedEndOn?: any | null, archivedAt?: any | null, currentUserProjectContext?: UserProjectOrganizationTypeEnumType | null, currentUserRestrictedAccess?: boolean | null, lastActivityAt?: any | null, status: StatusEnumType, projectType?: ProjectTypeEnumType | null, projectStatusChangeReasons?: Array<(
    { id: string, name: string, description?: string | null, createdAt: any, updatedAt: any, user?: (
      { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null, statusChangeReason: (
      { id: string, name: string, statusChangeReasonGroup?: (
        { id: string, name: string }
        & { __typename?: 'StatusChangeReasonGroupType' }
      ) | null }
      & { __typename?: 'StatusChangeReasonType' }
    ) }
    & { __typename?: 'ProjectStatusChangeReasonType' }
  )> | null, currentUserSettings?: (
    { projectView?: ProjectViewEnum | null, restrictAccess: boolean }
    & { __typename?: 'UserProject' }
  ) | null, projectManager?: (
    { id: string, firstName?: string | null, lastName?: string | null, status?: string | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'UserType' }
  ) | null, customerV2?: (
    { id: string, name: string, logo?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'CustomerType' }
  ) | null, templates?: Array<(
    { id: string, milestones?: Array<(
      { id: string, name: string, active: boolean }
      & { __typename?: 'MilestoneType' }
    )> | null }
    & { __typename?: 'TemplateType' }
  )> | null, organization?: (
    { id: string, name?: string | null }
    & { __typename?: 'OrganizationType' }
  ) | null, displayOrganization?: (
    { name: string }
    & { __typename?: 'DisplayOrganizationType' }
  ) | null, brand?: (
    { id: string, name?: string | null, logo?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'BrandType' }
  ) | null, tags?: Array<(
    { id: string, color: string, name: string, internalOnly: boolean }
    & { __typename: 'TagType' }
  )> | null }
  & { __typename?: 'ProjectType' }
);

export type SideBarUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, capacity?: number | null, projectsCount?: number | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type ProjectNotesProjectFragment = (
  { id: string, organization?: (
    { id: string, internalNotesDefault: boolean }
    & { __typename?: 'OrganizationType' }
  ) | null }
  & { __typename: 'ProjectType' }
);

export type ProjectSnapshotProjectFragment = (
  { id: string, startOn?: any | null, endOn?: any | null, completedAt?: any | null, forecastedEndOn?: any | null }
  & { __typename?: 'ProjectType' }
);

export type ProjectSnapshotStatsFragment = (
  { totalTasks: number, totalDoneTasks: number }
  & { __typename?: 'ProjectStats' }
);

export type ProjectSnapshotProjectQueryVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type ProjectSnapshotProjectQuery = (
  { project: (
    { id: string, startOn?: any | null, endOn?: any | null, completedAt?: any | null, forecastedEndOn?: any | null }
    & { __typename?: 'ProjectType' }
  ) }
  & { __typename?: 'Query' }
);

export type ProjectSnapshotStatsQueryVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type ProjectSnapshotStatsQuery = (
  { stats?: { __typename?: 'MilestoneStats' | 'TemplateStats' } | (
    { id: string, totalTasks: number, totalDoneTasks: number }
    & { __typename?: 'ProjectStats' }
  ) | null }
  & { __typename?: 'Query' }
);

export type ProjectSnapshotStatusUpdatedSubscriptionVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type ProjectSnapshotStatusUpdatedSubscription = (
  { projectUpdated?: (
    { project?: (
      { id: string, startOn?: any | null, endOn?: any | null, completedAt?: any | null, forecastedEndOn?: any | null }
      & { __typename?: 'ProjectType' }
    ) | null, projectStats?: (
      { totalTasks: number, totalDoneTasks: number }
      & { __typename?: 'ProjectStats' }
    ) | null }
    & { __typename?: 'ProjectUpdatePayloadType' }
  ) | null }
  & { __typename?: 'Subscription' }
);

export type ProjectTableRowProjectFragment = (
  { id: string, name: string, cashValue?: number | null, totalTasksCount?: number | null, openTasksCount?: number | null, openActionItemsCount?: number | null, overdueTasksCount?: number | null, startOn?: any | null, endOn?: any | null, completedAt?: any | null, forecastedEndOn?: any | null, deletedAt?: any | null, archivedAt?: any | null, currentUserProjectContext?: UserProjectOrganizationTypeEnumType | null, currentUserRestrictedAccess?: boolean | null, lastActivityAt?: any | null, status: StatusEnumType, projectType?: ProjectTypeEnumType | null, errorsCount: number, projectStatusChangeReasons?: Array<(
    { id: string, name: string, description?: string | null, createdAt: any, updatedAt: any, user?: (
      { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null, statusChangeReason: (
      { id: string, name: string, statusChangeReasonGroup?: (
        { id: string, name: string }
        & { __typename?: 'StatusChangeReasonGroupType' }
      ) | null }
      & { __typename?: 'StatusChangeReasonType' }
    ) }
    & { __typename?: 'ProjectStatusChangeReasonType' }
  )> | null, currentUserSettings?: (
    { projectView?: ProjectViewEnum | null, restrictAccess: boolean }
    & { __typename?: 'UserProject' }
  ) | null, projectManager?: (
    { id: string, firstName?: string | null, lastName?: string | null, status?: string | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'UserType' }
  ) | null, customerV2?: (
    { id: string, name: string, logo?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'CustomerType' }
  ) | null, templates?: Array<(
    { id: string, milestones?: Array<(
      { id: string, name: string, active: boolean }
      & { __typename?: 'MilestoneType' }
    )> | null }
    & { __typename?: 'TemplateType' }
  )> | null, organization?: (
    { id: string, name?: string | null }
    & { __typename?: 'OrganizationType' }
  ) | null, displayOrganization?: (
    { name: string }
    & { __typename?: 'DisplayOrganizationType' }
  ) | null, brand?: (
    { id: string, name?: string | null, logo?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'BrandType' }
  ) | null, tags?: Array<(
    { id: string, color: string, name: string, internalOnly: boolean }
    & { __typename: 'TagType' }
  )> | null }
  & { __typename?: 'ProjectType' }
);

export type ProjectTaskCardTaskFragment = (
  { id: string, name: string, responsibility: TaskResponsibilityEnumType, visibility?: TaskVisibilityEnumType | null, shouldWarnUpdateStatus?: boolean | null, description?: string | null, signOffRequired: boolean, taskType?: TaskTypeEnumType | null, completedAt?: any | null, eventInformation?: string | null, eventDatetime?: any | null, participantCallToAction?: string | null, invitationGroupSentAt?: any | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, status: StatusEnumType, dueOn?: any | null, taskParticipants?: Array<(
    { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
      { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename: 'ImageType' }
      ) | null }
      & { __typename: 'UserType' }
    ) | null }
    & { __typename?: 'TaskParticipantType' }
  )> | null, template?: (
    { id: string, name: string, hardDependency?: boolean | null }
    & { __typename?: 'TemplateType' }
  ) | null, milestone?: (
    { id: string, name: string, sortOrder: number, status: MilestoneStatusEnumType }
    & { __typename?: 'MilestoneType' }
  ) | null, tags?: Array<(
    { id: string, color: string, internalOnly: boolean, name: string }
    & { __typename?: 'TagType' }
  )> | null, project?: (
    { id: string, projectType?: ProjectTypeEnumType | null, organization?: (
      { id: string, name?: string | null, defaultTaskVisibility?: TaskVisibilityEnumType | null }
      & { __typename?: 'OrganizationType' }
    ) | null, customerV2?: (
      { id: string, name: string }
      & { __typename?: 'CustomerType' }
    ) | null, projectManager?: (
      { id: string, firstName?: string | null, lastName?: string | null, calendarLink?: string | null, meetingLink?: string | null }
      & { __typename?: 'UserType' }
    ) | null }
    & { __typename?: 'ProjectType' }
  ) | null, notes?: Array<(
    { id: string, raw: string, createdAt: any, user: (
      { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) }
    & { __typename?: 'NoteType' }
  )> | null, files?: Array<(
    { id: string, fileName: string, size?: number | null, url?: string | null }
    & { __typename?: 'FileType' }
  )> | null, assignee?: (
    { id: string, firstName?: string | null, lastName?: string | null, calendarLink?: string | null, meetingLink?: string | null }
    & { __typename?: 'UserType' }
  ) | null, dependency?: (
    { id: string, name: string, completed?: boolean | null }
    & { __typename?: 'MilestoneType' | 'TaskGroupType' | 'TemplateType' }
  ) | (
    { id: string, name: string, completed?: boolean | null, visibility?: TaskVisibilityEnumType | null, shouldWarnUpdateStatus?: boolean | null }
    & { __typename?: 'TaskType' }
  ) | null, subtasks?: Array<(
    { id: string, name?: string | null, richName?: string | null, done?: boolean | null, sortOrder?: number | null, groupId?: string | null }
    & { __typename?: 'SubtaskType' }
  )> | null, subtasksGroups?: Array<(
    { id: string, name?: string | null }
    & { __typename?: 'SubtasksGroupType' }
  )> | null }
  & { __typename?: 'TaskType' }
);

export type ProjectTeamUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, lastActivityAt?: any | null, status?: string | null, jobRole?: string | null, organizationName?: string | null, phone?: string | null, email?: string | null, hidePhone?: boolean | null, hideEmail?: boolean | null, projectContext?: UserProjectOrganizationTypeEnumType | null, notificationPreferences?: (
    { projectOverviewEmailPref?: ProjectOverviewEmailPrefEnumType | null, taskReminderEmailPref?: TaskReminderEmailPref | null, overdueEmailPref?: boolean | null, stuckEmailPref?: boolean | null, doneEmailPref?: boolean | null, overduePref?: boolean | null, stuckPref?: boolean | null, donePref?: boolean | null }
    & { __typename?: 'NotificationPreferenceType' }
  ) | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, organization?: (
    { id: string, name?: string | null, type?: OrganizationTypeEnumType | null, logo?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'OrganizationType' }
  ) | null, displayOrganization?: (
    { name: string, logo?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'DisplayOrganizationType' }
  ) | null, projectSettings?: (
    { projectView?: ProjectViewEnum | null, restrictAccess: boolean }
    & { __typename?: 'UserProject' }
  ) | null, skills: Array<(
    { id: string, name: string, category: (
      { id: string, name: string }
      & { __typename?: 'SkillCategory' }
    ) }
    & { __typename?: 'Skill' }
  )> }
  & { __typename?: 'UserType' }
);

export type ProjectTeamProjectTeamQueryVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type ProjectTeamProjectTeamQuery = (
  { projectTeam: Array<(
    { id: string, firstName?: string | null, lastName?: string | null, lastActivityAt?: any | null, status?: string | null, jobRole?: string | null, organizationName?: string | null, phone?: string | null, email?: string | null, hidePhone?: boolean | null, hideEmail?: boolean | null, projectContext?: UserProjectOrganizationTypeEnumType | null, notificationPreferences?: (
      { projectOverviewEmailPref?: ProjectOverviewEmailPrefEnumType | null, taskReminderEmailPref?: TaskReminderEmailPref | null, overdueEmailPref?: boolean | null, stuckEmailPref?: boolean | null, doneEmailPref?: boolean | null, overduePref?: boolean | null, stuckPref?: boolean | null, donePref?: boolean | null }
      & { __typename?: 'NotificationPreferenceType' }
    ) | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null, organization?: (
      { id: string, name?: string | null, type?: OrganizationTypeEnumType | null, logo?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'OrganizationType' }
    ) | null, displayOrganization?: (
      { name: string, logo?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'DisplayOrganizationType' }
    ) | null, projectSettings?: (
      { projectView?: ProjectViewEnum | null, restrictAccess: boolean }
      & { __typename?: 'UserProject' }
    ) | null, skills: Array<(
      { id: string, name: string, category: (
        { id: string, name: string }
        & { __typename?: 'SkillCategory' }
      ) }
      & { __typename?: 'Skill' }
    )> }
    & { __typename?: 'UserType' }
  )> }
  & { __typename?: 'Query' }
);

export type ProjectTeamRemoveTeamMemberMutationVariables = Exact<{
  user: RemoveUserFromProjectInput;
}>;


export type ProjectTeamRemoveTeamMemberMutation = (
  { removeUserFromProject?: (
    { projectTeam?: Array<(
      { id: string, firstName?: string | null, lastName?: string | null, lastActivityAt?: any | null, status?: string | null, jobRole?: string | null, organizationName?: string | null, phone?: string | null, email?: string | null, hidePhone?: boolean | null, hideEmail?: boolean | null, projectContext?: UserProjectOrganizationTypeEnumType | null, notificationPreferences?: (
        { projectOverviewEmailPref?: ProjectOverviewEmailPrefEnumType | null, taskReminderEmailPref?: TaskReminderEmailPref | null, overdueEmailPref?: boolean | null, stuckEmailPref?: boolean | null, doneEmailPref?: boolean | null, overduePref?: boolean | null, stuckPref?: boolean | null, donePref?: boolean | null }
        & { __typename?: 'NotificationPreferenceType' }
      ) | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null, organization?: (
        { id: string, name?: string | null, type?: OrganizationTypeEnumType | null, logo?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'OrganizationType' }
      ) | null, displayOrganization?: (
        { name: string, logo?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'DisplayOrganizationType' }
      ) | null, projectSettings?: (
        { projectView?: ProjectViewEnum | null, restrictAccess: boolean }
        & { __typename?: 'UserProject' }
      ) | null, skills: Array<(
        { id: string, name: string, category: (
          { id: string, name: string }
          & { __typename?: 'SkillCategory' }
        ) }
        & { __typename?: 'Skill' }
      )> }
      & { __typename?: 'UserType' }
    ) | null> | null }
    & { __typename?: 'removeUserFromProjectPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ProjectTeamAddInternalUsersToProjectMutationVariables = Exact<{
  projectId: Scalars['ID'];
  userIds: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  defaultAssigneeId?: InputMaybe<Scalars['ID']>;
}>;


export type ProjectTeamAddInternalUsersToProjectMutation = (
  { addInternalUsersToProject?: (
    { project?: (
      { id: string, users?: Array<(
        { id: string, firstName?: string | null, lastName?: string | null, lastActivityAt?: any | null, status?: string | null, jobRole?: string | null, organizationName?: string | null, phone?: string | null, email?: string | null, hidePhone?: boolean | null, hideEmail?: boolean | null, projectContext?: UserProjectOrganizationTypeEnumType | null, notificationPreferences?: (
          { projectOverviewEmailPref?: ProjectOverviewEmailPrefEnumType | null, taskReminderEmailPref?: TaskReminderEmailPref | null, overdueEmailPref?: boolean | null, stuckEmailPref?: boolean | null, doneEmailPref?: boolean | null, overduePref?: boolean | null, stuckPref?: boolean | null, donePref?: boolean | null }
          & { __typename?: 'NotificationPreferenceType' }
        ) | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null, organization?: (
          { id: string, name?: string | null, type?: OrganizationTypeEnumType | null, logo?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'OrganizationType' }
        ) | null, displayOrganization?: (
          { name: string, logo?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'DisplayOrganizationType' }
        ) | null, projectSettings?: (
          { projectView?: ProjectViewEnum | null, restrictAccess: boolean }
          & { __typename?: 'UserProject' }
        ) | null, skills: Array<(
          { id: string, name: string, category: (
            { id: string, name: string }
            & { __typename?: 'SkillCategory' }
          ) }
          & { __typename?: 'Skill' }
        )> }
        & { __typename?: 'UserType' }
      )> | null }
      & { __typename?: 'ProjectType' }
    ) | null }
    & { __typename?: 'addInternalUsersToProjectPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ProjectTeamAddCustomerUsersToProjectMutationVariables = Exact<{
  projectId: Scalars['ID'];
  users?: InputMaybe<Array<ProjectUserInput> | ProjectUserInput>;
  defaultAssigneeIndex?: InputMaybe<Scalars['Int']>;
}>;


export type ProjectTeamAddCustomerUsersToProjectMutation = (
  { addCustomerUsersToProject?: (
    { project?: (
      { id: string, users?: Array<(
        { id: string, firstName?: string | null, lastName?: string | null, lastActivityAt?: any | null, status?: string | null, jobRole?: string | null, organizationName?: string | null, phone?: string | null, email?: string | null, hidePhone?: boolean | null, hideEmail?: boolean | null, projectContext?: UserProjectOrganizationTypeEnumType | null, notificationPreferences?: (
          { projectOverviewEmailPref?: ProjectOverviewEmailPrefEnumType | null, taskReminderEmailPref?: TaskReminderEmailPref | null, overdueEmailPref?: boolean | null, stuckEmailPref?: boolean | null, doneEmailPref?: boolean | null, overduePref?: boolean | null, stuckPref?: boolean | null, donePref?: boolean | null }
          & { __typename?: 'NotificationPreferenceType' }
        ) | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null, organization?: (
          { id: string, name?: string | null, type?: OrganizationTypeEnumType | null, logo?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'OrganizationType' }
        ) | null, displayOrganization?: (
          { name: string, logo?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'DisplayOrganizationType' }
        ) | null, projectSettings?: (
          { projectView?: ProjectViewEnum | null, restrictAccess: boolean }
          & { __typename?: 'UserProject' }
        ) | null, skills: Array<(
          { id: string, name: string, category: (
            { id: string, name: string }
            & { __typename?: 'SkillCategory' }
          ) }
          & { __typename?: 'Skill' }
        )> }
        & { __typename?: 'UserType' }
      )> | null }
      & { __typename?: 'ProjectType' }
    ) | null }
    & { __typename?: 'addCustomerUsersToProjectPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ProjectTeamAddThirdPartyUsersToProjectMutationVariables = Exact<{
  projectId: Scalars['ID'];
  users: Array<InputMaybe<ProjectUserInput>> | InputMaybe<ProjectUserInput>;
}>;


export type ProjectTeamAddThirdPartyUsersToProjectMutation = (
  { addThirdPartyUsersToProject?: (
    { project?: (
      { id: string, users?: Array<(
        { id: string, firstName?: string | null, lastName?: string | null, lastActivityAt?: any | null, status?: string | null, jobRole?: string | null, organizationName?: string | null, phone?: string | null, email?: string | null, hidePhone?: boolean | null, hideEmail?: boolean | null, projectContext?: UserProjectOrganizationTypeEnumType | null, notificationPreferences?: (
          { projectOverviewEmailPref?: ProjectOverviewEmailPrefEnumType | null, taskReminderEmailPref?: TaskReminderEmailPref | null, overdueEmailPref?: boolean | null, stuckEmailPref?: boolean | null, doneEmailPref?: boolean | null, overduePref?: boolean | null, stuckPref?: boolean | null, donePref?: boolean | null }
          & { __typename?: 'NotificationPreferenceType' }
        ) | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null, organization?: (
          { id: string, name?: string | null, type?: OrganizationTypeEnumType | null, logo?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'OrganizationType' }
        ) | null, displayOrganization?: (
          { name: string, logo?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'DisplayOrganizationType' }
        ) | null, projectSettings?: (
          { projectView?: ProjectViewEnum | null, restrictAccess: boolean }
          & { __typename?: 'UserProject' }
        ) | null, skills: Array<(
          { id: string, name: string, category: (
            { id: string, name: string }
            & { __typename?: 'SkillCategory' }
          ) }
          & { __typename?: 'Skill' }
        )> }
        & { __typename?: 'UserType' }
      )> | null }
      & { __typename?: 'ProjectType' }
    ) | null }
    & { __typename?: 'addThirdPartyUsersToProjectPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ProjectTeamUpdateUserProjectMutationVariables = Exact<{
  projectId: Scalars['ID'];
  userId: Scalars['ID'];
  arguments: UpdateUserProjectArguments;
}>;


export type ProjectTeamUpdateUserProjectMutation = (
  { updateUserProject?: (
    { projectView?: ProjectViewEnum | null, restrictAccess: boolean }
    & { __typename?: 'updateUserProjectPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ProjectTeamGroupedRoleListUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, status?: string | null, hidePhone?: boolean | null, phone?: string | null, hideEmail?: boolean | null, email?: string | null, organizationName?: string | null, addedToQualtricsAt?: any | null, lastActivityAt?: any | null, projectContext?: UserProjectOrganizationTypeEnumType | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, displayOrganization?: (
    { name: string, logo?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'DisplayOrganizationType' }
  ) | null, organization?: (
    { id: string, type?: OrganizationTypeEnumType | null }
    & { __typename?: 'OrganizationType' }
  ) | null, projectStats?: (
    { totalDoneTasks?: number | null, totalRemainingTasks?: number | null, totalPlannedTasks?: number | null, activeOverdueTasks?: number | null }
    & { __typename?: 'UserProjectStatsType' }
  ) | null, projectSettings?: (
    { projectView?: ProjectViewEnum | null, restrictAccess: boolean }
    & { __typename?: 'UserProject' }
  ) | null, notificationPreferences?: (
    { taskReminderEmailPref?: TaskReminderEmailPref | null, projectOverviewEmailPref?: ProjectOverviewEmailPrefEnumType | null }
    & { __typename?: 'NotificationPreferenceType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type ProjectTeamGroupedRoleListRolesFragment = (
  { id: string, name: string, category: (
    { id: string, name: string }
    & { __typename?: 'SkillCategory' }
  ) }
  & { __typename?: 'Skill' }
);

export type GetProjectTeamFunctionsQueryVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type GetProjectTeamFunctionsQuery = (
  { projectTeamFunctions?: Array<(
    { hasUnassignedUsers?: boolean | null, users?: Array<(
      { id: string, firstName?: string | null, lastName?: string | null, status?: string | null, hidePhone?: boolean | null, phone?: string | null, hideEmail?: boolean | null, email?: string | null, organizationName?: string | null, addedToQualtricsAt?: any | null, lastActivityAt?: any | null, projectContext?: UserProjectOrganizationTypeEnumType | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null, displayOrganization?: (
        { name: string, logo?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'DisplayOrganizationType' }
      ) | null, organization?: (
        { id: string, type?: OrganizationTypeEnumType | null }
        & { __typename?: 'OrganizationType' }
      ) | null, projectStats?: (
        { totalDoneTasks?: number | null, totalRemainingTasks?: number | null, totalPlannedTasks?: number | null, activeOverdueTasks?: number | null }
        & { __typename?: 'UserProjectStatsType' }
      ) | null, projectSettings?: (
        { projectView?: ProjectViewEnum | null, restrictAccess: boolean }
        & { __typename?: 'UserProject' }
      ) | null, notificationPreferences?: (
        { taskReminderEmailPref?: TaskReminderEmailPref | null, projectOverviewEmailPref?: ProjectOverviewEmailPrefEnumType | null }
        & { __typename?: 'NotificationPreferenceType' }
      ) | null }
      & { __typename?: 'UserType' }
    )> | null, roles?: Array<(
      { id: string, name: string, category: (
        { id: string, name: string }
        & { __typename?: 'SkillCategory' }
      ) }
      & { __typename?: 'Skill' }
    )> | null }
    & { __typename?: 'ProjectTeamFunction' }
  )> | null }
  & { __typename?: 'Query' }
);

export type AddWatchersFormRolesTaskWatchersQueryVariables = Exact<{
  projectId: Scalars['ID'];
  roleIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type AddWatchersFormRolesTaskWatchersQuery = (
  { rolesTaskWatchers?: Array<(
    { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'UserType' }
  )> | null }
  & { __typename?: 'Query' }
);

export type AssignRolesFormAssignUserToRolesMutationVariables = Exact<{
  input: AssignUserToRolesInput;
}>;


export type AssignRolesFormAssignUserToRolesMutation = (
  { assignUserToRoles?: (
    { teamMember?: (
      { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, projectContext?: UserProjectOrganizationTypeEnumType | null, role?: UserRoleEnumType | null, jobRole?: string | null, organizationName?: string | null, skills: Array<(
        { id: string }
        & { __typename?: 'Skill' }
      )>, organization?: (
        { id: string, type?: OrganizationTypeEnumType | null, name?: string | null }
        & { __typename?: 'OrganizationType' }
      ) | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null, displayOrganization?: (
        { name: string }
        & { __typename?: 'DisplayOrganizationType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null }
    & { __typename?: 'assignUserToRolesPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type MultipleResourcesDropdownUsersBySkillsQueryVariables = Exact<{
  skillIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type MultipleResourcesDropdownUsersBySkillsQuery = (
  { usersBySkills: Array<(
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, projectContext?: UserProjectOrganizationTypeEnumType | null, role?: UserRoleEnumType | null, jobRole?: string | null, organizationName?: string | null, skills: Array<(
      { id: string }
      & { __typename?: 'Skill' }
    )>, organization?: (
      { id: string, type?: OrganizationTypeEnumType | null, name?: string | null }
      & { __typename?: 'OrganizationType' }
    ) | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null, displayOrganization?: (
      { name: string }
      & { __typename?: 'DisplayOrganizationType' }
    ) | null }
    & { __typename?: 'UserType' }
  )> }
  & { __typename?: 'Query' }
);

export type EmptyRolesBoxRolesFragment = (
  { id: string }
  & { __typename?: 'Skill' }
);

export type RolesHeaderRolesFragment = (
  { id: string, name: string, category: (
    { id: string, name: string }
    & { __typename?: 'SkillCategory' }
  ) }
  & { __typename?: 'Skill' }
);

export type UserInviteInformationUserFragment = (
  { id: string, status?: string | null, email?: string | null, firstAccessWithSecureLink?: boolean | null }
  & { __typename?: 'UserType' }
);

export type UserInviteInformationResendInvitationMutationVariables = Exact<{
  email: Scalars['String'];
  projectId?: InputMaybe<Scalars['ID']>;
}>;


export type UserInviteInformationResendInvitationMutation = (
  { resendInviteToUser?: (
    { success?: boolean | null }
    & { __typename?: 'resendInviteToUserPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type UserProgressBarUserProjectStatsFragment = (
  { totalDoneTasks?: number | null, totalRemainingTasks?: number | null, totalPlannedTasks?: number | null, activeOverdueTasks?: number | null }
  & { __typename?: 'UserProjectStatsType' }
);

export type UserViewInformationUserFragment = (
  { id: string, addedToQualtricsAt?: any | null, lastActivityAt?: any | null, projectContext?: UserProjectOrganizationTypeEnumType | null, projectSettings?: (
    { projectView?: ProjectViewEnum | null, restrictAccess: boolean }
    & { __typename?: 'UserProject' }
  ) | null, notificationPreferences?: (
    { taskReminderEmailPref?: TaskReminderEmailPref | null, projectOverviewEmailPref?: ProjectOverviewEmailPrefEnumType | null }
    & { __typename?: 'NotificationPreferenceType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type UserWithRolesUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, status?: string | null, hidePhone?: boolean | null, phone?: string | null, hideEmail?: boolean | null, email?: string | null, organizationName?: string | null, addedToQualtricsAt?: any | null, lastActivityAt?: any | null, projectContext?: UserProjectOrganizationTypeEnumType | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, displayOrganization?: (
    { name: string, logo?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'DisplayOrganizationType' }
  ) | null, organization?: (
    { id: string, type?: OrganizationTypeEnumType | null }
    & { __typename?: 'OrganizationType' }
  ) | null, projectStats?: (
    { totalDoneTasks?: number | null, totalRemainingTasks?: number | null, totalPlannedTasks?: number | null, activeOverdueTasks?: number | null }
    & { __typename?: 'UserProjectStatsType' }
  ) | null, projectSettings?: (
    { projectView?: ProjectViewEnum | null, restrictAccess: boolean }
    & { __typename?: 'UserProject' }
  ) | null, notificationPreferences?: (
    { taskReminderEmailPref?: TaskReminderEmailPref | null, projectOverviewEmailPref?: ProjectOverviewEmailPrefEnumType | null }
    & { __typename?: 'NotificationPreferenceType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type TeamCardCastListResendInvitationMutationVariables = Exact<{
  email: Scalars['String'];
  projectId?: InputMaybe<Scalars['ID']>;
}>;


export type TeamCardCastListResendInvitationMutation = (
  { resendInviteToUser?: (
    { success?: boolean | null }
    & { __typename?: 'resendInviteToUserPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ProjectTemplatesDropEligibilityQueryVariables = Exact<{
  input: DropInput;
}>;


export type ProjectTemplatesDropEligibilityQuery = (
  { dropEligibility?: (
    { eligibility?: boolean | null, message?: string | null }
    & { __typename?: 'DropEligibilityType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type ProjectTemplatesTemplateFragment = (
  { id: string, name: string, duration?: number | null }
  & { __typename?: 'TemplateType' }
);

export type ProjectTimelineTimelineProjectsQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['DateType']>;
  endDate?: InputMaybe<Scalars['DateType']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  projectFilters?: InputMaybe<ProjectFilters>;
}>;


export type ProjectTimelineTimelineProjectsQuery = (
  { timelineProjects?: (
    { startDate?: any | null, endDate?: any | null, projectsByProjectManager?: Array<(
      { projectManager?: (
        { id: string, firstName?: string | null, lastName?: string | null, capacity?: number | null, projectsCount?: number | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null, projects?: Array<(
        { id: string, name: string, totalTasksCount?: number | null, doneTasksCount?: number | null, startOn?: any | null, endOn?: any | null, forecastedEndOn?: any | null, status: StatusEnumType, projectType?: ProjectTypeEnumType | null, customerV2?: (
          { id: string, name: string, logo?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'CustomerType' }
        ) | null, displayOrganization?: (
          { name: string, logo?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'DisplayOrganizationType' }
        ) | null }
        & { __typename?: 'ProjectType' }
      )> | null, projectCountPerDay?: Array<(
        { projectsCount?: number | null, sequentialDate?: any | null }
        & { __typename?: 'ProjectCountPerDayType' }
      )> | null, projectCountPerWeek?: Array<(
        { projectsCount?: number | null, sequentialDate?: any | null, sequentialWeek?: number | null }
        & { __typename?: 'ProjectCountPerDayType' }
      )> | null }
      & { __typename?: 'TimelineProjectType' }
    )> | null }
    & { __typename?: 'TimelineProjectsResponseType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type ProjectTimelineItemProjectFragment = (
  { id: string, name: string, totalTasksCount?: number | null, doneTasksCount?: number | null, startOn?: any | null, endOn?: any | null, forecastedEndOn?: any | null, status: StatusEnumType, projectType?: ProjectTypeEnumType | null, customerV2?: (
    { id: string, name: string, logo?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'CustomerType' }
  ) | null, displayOrganization?: (
    { name: string, logo?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'DisplayOrganizationType' }
  ) | null }
  & { __typename?: 'ProjectType' }
);

export type PurchasedInputHistoryFragment = (
  { date: any, purchasedHours: number }
  & { __typename?: 'PurchasedHoursHistory' }
);

export type PurchasedInputProjectFragment = (
  { id: string, projectBillRate?: (
    { id: string, hours?: number | null, rateType?: RateTypeEnum | null, purchasedHoursRemaining?: number | null, purchasedHoursHistory: Array<(
      { date: any, purchasedHours: number }
      & { __typename?: 'PurchasedHoursHistory' }
    )> }
    & { __typename?: 'ProjectBillRateType' }
  ) | null }
  & { __typename?: 'ProjectType' }
);

export type BillableRatesDetailSkillFragment = (
  { id: string, billableRate: number, name: string, users: Array<(
    { id: string, jobRole?: string | null, firstName?: string | null, lastName?: string | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'UserType' }
  )> }
  & { __typename?: 'Skill' }
);

export type SoftDeleteProjectConfirmationDeleteProjectMutationVariables = Exact<{
  id: Scalars['ID'];
  hardDelete: Scalars['Boolean'];
}>;


export type SoftDeleteProjectConfirmationDeleteProjectMutation = (
  { deleteProject?: (
    { deletedProjectId?: string | null }
    & { __typename?: 'deleteProjectPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type StatusDropDownUpdateNodeStatusMutationVariables = Exact<{
  id: Scalars['ID'];
  status: StatusEnumType;
  objectType: StatusObjectEnumType;
}>;


export type StatusDropDownUpdateNodeStatusMutation = (
  { updateObjectStatus?: (
    { resolveObject?: (
      { id: string, status: ActionItemStatusEnumType }
      & { __typename: 'ActionItemType' }
    ) | { __typename?: 'ProjectType' | 'TaskType' } | null }
    & { __typename?: 'updateObjectStatusPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type BillableRatesSummarySkillCategoryFragment = (
  { id: string, name: string, userCount: number, skillCount: number }
  & { __typename?: 'SkillCategory' }
);

export type TabsProjectFragment = (
  { id: string, currentUserRestrictedAccess?: boolean | null, currentUserProjectContext?: UserProjectOrganizationTypeEnumType | null, usesCategories: boolean, status: StatusEnumType, organization?: (
    { id: string, resourceManagementEnabled?: boolean | null, timeTrackingEnabled?: boolean | null }
    & { __typename?: 'OrganizationType' }
  ) | null }
  & { __typename?: 'ProjectType' }
);

export type TemplateInfoFormTemplateFragment = (
  { id: string, name: string, experienceOverview?: string | null, videoUrl?: string | null, hardDependency?: boolean | null, videoPlaceholderImage?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null }
  & { __typename?: 'TemplateType' }
);

export type TemplateInfoRowTemplateFragment = (
  { id: string, name: string, experienceOverview?: string | null, videoUrl?: string | null, hardDependency?: boolean | null, videoPlaceholderImage?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null }
  & { __typename?: 'TemplateType' }
);

export type CapacityBoxUserFragment = (
  { id: string }
  & { __typename?: 'UserType' }
);

export type CapacityBoxCapacityFragment = (
  { actualHours: number, capacityHours: number, projectCount: number, taskCount: number, indeterminate: boolean, startDate: any, endDate: any, percentage?: number | null }
  & { __typename?: 'CapacityType' }
);

export type CapacityBoxProjectFragment = (
  { id: string, userTimeCapacities: Array<(
    { actualHours: number, capacityHours: number, projectCount: number, taskCount: number, indeterminate: boolean, startDate: any, endDate: any, percentage?: number | null }
    & { __typename?: 'CapacityType' }
  )> }
  & { __typename?: 'ProjectType' }
);

export type CapacityBoxProjectsQueryVariables = Exact<{
  filters: CapacityFilterInput;
  groupBy: CapacityGroupByEnum;
  userId: Scalars['ID'];
}>;


export type CapacityBoxProjectsQuery = (
  { projectsConnections?: (
    { projects?: Array<(
      { id: string, name: string, status: StatusEnumType, userTimeCapacities: Array<(
        { actualHours: number, capacityHours: number, projectCount: number, taskCount: number, indeterminate: boolean, startDate: any, endDate: any, percentage?: number | null }
        & { __typename?: 'CapacityType' }
      )> }
      & { __typename?: 'ProjectType' }
    )> | null }
    & { __typename?: 'ProjectConnectionType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type CapacityListBoxCapacityFragment = (
  { actualHours: number, capacityHours: number, projectCount: number, taskCount: number, indeterminate: boolean, startDate: any, endDate: any, percentage?: number | null }
  & { __typename?: 'CapacityType' }
);

export type CapacityDetailsModalTaskFragment = (
  { id: string, startOn?: any | null, dueOn?: any | null, completedAt?: any | null, estimatedHours?: number | null, name: string, status: StatusEnumType, template?: (
    { id: string }
    & { __typename?: 'TemplateType' }
  ) | null, milestone?: (
    { id: string }
    & { __typename?: 'MilestoneType' }
  ) | null, skill?: (
    { id: string, name: string }
    & { __typename?: 'Skill' }
  ) | null, timePeriodUtilization: (
    { hours: number, userCapacity: number, utilization: number }
    & { __typename?: 'TaskUtilizationType' }
  ) }
  & { __typename?: 'TaskType' }
);

export type CapacityDetailsModalProjectFragment = (
  { id: string, name: string, status: StatusEnumType, endOn?: any | null, forecastedEndOn?: any | null, totalTasksCount?: number | null, openTasksCount?: number | null, projectManager?: (
    { id: string }
    & { __typename?: 'UserType' }
  ) | null }
  & { __typename?: 'ProjectType' }
);

export type CapacityDetailsModalUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, skills: Array<(
    { id: string }
    & { __typename?: 'Skill' }
  )> }
  & { __typename?: 'UserType' }
);

export type CapacityDetailsModalProjectsQueryVariables = Exact<{
  userId: Scalars['ID'];
  startDate: Scalars['DateType'];
  endDate: Scalars['DateType'];
  filters: ProjectFilters;
}>;


export type CapacityDetailsModalProjectsQuery = (
  { projectsConnections?: (
    { projects?: Array<(
      { id: string, name: string, status: StatusEnumType, endOn?: any | null, forecastedEndOn?: any | null, totalTasksCount?: number | null, openTasksCount?: number | null, tasks: Array<(
        { id: string, startOn?: any | null, dueOn?: any | null, completedAt?: any | null, estimatedHours?: number | null, name: string, status: StatusEnumType, template?: (
          { id: string }
          & { __typename?: 'TemplateType' }
        ) | null, milestone?: (
          { id: string }
          & { __typename?: 'MilestoneType' }
        ) | null, skill?: (
          { id: string, name: string }
          & { __typename?: 'Skill' }
        ) | null, timePeriodUtilization: (
          { hours: number, userCapacity: number, utilization: number }
          & { __typename?: 'TaskUtilizationType' }
        ) }
        & { __typename?: 'TaskType' }
      )>, projectManager?: (
        { id: string }
        & { __typename?: 'UserType' }
      ) | null }
      & { __typename?: 'ProjectType' }
    )> | null }
    & { __typename?: 'ProjectConnectionType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type CapacityDetailsModalHeaderQueriedUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, timeCapacities: Array<(
    { actualHours: number, capacityHours: number, percentage?: number | null }
    & { __typename?: 'CapacityType' }
  )> }
  & { __typename?: 'UserType' }
);

export type CapacityDetailsModalHeaderUserQueryVariables = Exact<{
  id: Scalars['ID'];
  filters: CapacityFilterInput;
}>;


export type CapacityDetailsModalHeaderUserQuery = (
  { user: (
    { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null, timeCapacities: Array<(
      { actualHours: number, capacityHours: number, percentage?: number | null }
      & { __typename?: 'CapacityType' }
    )> }
    & { __typename?: 'UserType' }
  ) }
  & { __typename?: 'Query' }
);

export type CapacityDetailsModalHeaderUserUpdatedSubscriptionVariables = Exact<{
  id: Scalars['ID'];
  filters: CapacityFilterInput;
}>;


export type CapacityDetailsModalHeaderUserUpdatedSubscription = (
  { userUpdated?: (
    { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null, timeCapacities: Array<(
      { actualHours: number, capacityHours: number, percentage?: number | null }
      & { __typename?: 'CapacityType' }
    )> }
    & { __typename?: 'UserType' }
  ) | null }
  & { __typename?: 'Subscription' }
);

export type TaskPillUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, skills: Array<(
    { id: string }
    & { __typename?: 'Skill' }
  )> }
  & { __typename?: 'UserType' }
);

export type TaskPillTaskFragment = (
  { id: string, name: string, startOn?: any | null, dueOn?: any | null, status: StatusEnumType, estimatedHours?: number | null, template?: (
    { id: string }
    & { __typename?: 'TemplateType' }
  ) | null, milestone?: (
    { id: string }
    & { __typename?: 'MilestoneType' }
  ) | null, skill?: (
    { id: string, name: string }
    & { __typename?: 'Skill' }
  ) | null, timePeriodUtilization: (
    { hours: number, userCapacity: number, utilization: number }
    & { __typename?: 'TaskUtilizationType' }
  ) }
  & { __typename?: 'TaskType' }
);

export type TaskPillProjectFragment = (
  { id: string }
  & { __typename?: 'ProjectType' }
);

export type TaskPillUpdateTaskMutationVariables = Exact<{
  inputs: UpdateTaskInput;
}>;


export type TaskPillUpdateTaskMutation = (
  { updateTask?: (
    { taskReturnData?: (
      { task?: (
        { id: string, assignee?: (
          { id: string, firstName?: string | null, lastName?: string | null, skills: Array<(
            { id: string }
            & { __typename?: 'Skill' }
          )> }
          & { __typename?: 'UserType' }
        ) | null }
        & { __typename?: 'TaskType' }
      ) | null }
      & { __typename?: 'TaskReturnType' }
    ) | null }
    & { __typename?: 'updateTaskPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type TaskPillTaskUpdatedSubscriptionVariables = Exact<{
  taskId: Scalars['ID'];
  startDate: Scalars['DateType'];
  endDate: Scalars['DateType'];
}>;


export type TaskPillTaskUpdatedSubscription = (
  { taskUpdated?: (
    { id: string, name: string, startOn?: any | null, dueOn?: any | null, status: StatusEnumType, estimatedHours?: number | null, template?: (
      { id: string }
      & { __typename?: 'TemplateType' }
    ) | null, milestone?: (
      { id: string }
      & { __typename?: 'MilestoneType' }
    ) | null, skill?: (
      { id: string, name: string }
      & { __typename?: 'Skill' }
    ) | null, timePeriodUtilization: (
      { hours: number, userCapacity: number, utilization: number }
      & { __typename?: 'TaskUtilizationType' }
    ) }
    & { __typename?: 'TaskType' }
  ) | null }
  & { __typename?: 'Subscription' }
);

export type UserDropdownUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, skills: Array<(
    { id: string }
    & { __typename?: 'Skill' }
  )>, timeCapacities: Array<(
    { actualHours: number, capacityHours: number, percentage?: number | null }
    & { __typename?: 'CapacityType' }
  )> }
  & { __typename?: 'UserType' }
);

export type UserDropdownSkillFragment = (
  { id: string, name: string }
  & { __typename?: 'Skill' }
);

export type UserDropdownResourceManagementUsersQueryVariables = Exact<{
  filters: CapacityFilterInput;
  listInputs?: InputMaybe<ListInput>;
}>;


export type UserDropdownResourceManagementUsersQuery = (
  { resourceManagementUsers?: (
    { users?: Array<(
      { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null, skills: Array<(
        { id: string }
        & { __typename?: 'Skill' }
      )>, timeCapacities: Array<(
        { actualHours: number, capacityHours: number, percentage?: number | null }
        & { __typename?: 'CapacityType' }
      )> }
      & { __typename?: 'UserType' }
    )> | null }
    & { __typename?: 'OrganizationConnectedUsersType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type CapacityListUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, timeCapacities: Array<(
    { actualHours: number, capacityHours: number, projectCount: number, taskCount: number, indeterminate: boolean, startDate: any, endDate: any, percentage?: number | null }
    & { __typename?: 'CapacityType' }
  )>, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type CapacityPlanningUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, timeCapacities: Array<(
    { actualHours: number, capacityHours: number, projectCount: number, taskCount: number, indeterminate: boolean, startDate: any, endDate: any, percentage?: number | null }
    & { __typename?: 'CapacityType' }
  )>, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type CapacityPlanningUsersQueryVariables = Exact<{
  listInputs: ListInput;
  groupBy: CapacityGroupByEnum;
  filters: CapacityFilterInput;
}>;


export type CapacityPlanningUsersQuery = (
  { timeCapacityUsers?: (
    { pageInfo?: (
      { totalPages?: number | null, totalResults?: number | null, currentPage?: number | null, limit?: number | null, isOutOfBounds?: boolean | null }
      & { __typename?: 'PageInfoType' }
    ) | null, users?: Array<(
      { id: string, firstName?: string | null, lastName?: string | null, timeCapacities: Array<(
        { actualHours: number, capacityHours: number, projectCount: number, taskCount: number, indeterminate: boolean, startDate: any, endDate: any, percentage?: number | null }
        & { __typename?: 'CapacityType' }
      )>, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    )> | null }
    & { __typename?: 'OrganizationConnectedUsersType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type CategoryListSkillCategoryFragment = (
  { id: string, name: string, userCount: number, skillCount: number, skills: Array<(
    { id: string, billableRate: number, name: string, category: (
      { id: string, skillCount: number, userCount: number }
      & { __typename?: 'SkillCategory' }
    ), users: Array<(
      { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    )> }
    & { __typename?: 'Skill' }
  )> }
  & { __typename?: 'SkillCategory' }
);

export type DetailSkillFragment = (
  { id: string, billableRate: number, name: string, category: (
    { id: string, skillCount: number, userCount: number }
    & { __typename?: 'SkillCategory' }
  ), users: Array<(
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'UserType' }
  )> }
  & { __typename?: 'Skill' }
);

export type ResourceEditDialogUserQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type ResourceEditDialogUserQuery = (
  { user: (
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, skills: Array<(
      { id: string, name: string, category: (
        { id: string, name: string }
        & { __typename?: 'SkillCategory' }
      ) }
      & { __typename?: 'Skill' }
    )>, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'UserType' }
  ) }
  & { __typename?: 'Query' }
);

export type ResourceEditDialogUpdateResourceMutationVariables = Exact<{
  input: UpdateResourceInput;
}>;


export type ResourceEditDialogUpdateResourceMutation = (
  { updateResource?: (
    { resource: (
      { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, skills: Array<(
        { id: string, name: string, category: (
          { id: string, name: string }
          & { __typename?: 'SkillCategory' }
        ) }
        & { __typename?: 'Skill' }
      )>, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) }
    & { __typename?: 'updateResourcePayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ResourcesTableSkillCategoriesQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type ResourcesTableSkillCategoriesQuery = (
  { organization?: (
    { skillCategories: Array<(
      { id: string, name: string, skillCount: number, userCount: number }
      & { __typename?: 'SkillCategory' }
    )> }
    & { __typename?: 'OrganizationType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type SkillsListUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, skills: Array<(
    { id: string, name: string, category: (
      { id: string, name: string }
      & { __typename?: 'SkillCategory' }
    ) }
    & { __typename?: 'Skill' }
  )>, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type SkillsListSkillFragment = (
  { id: string, name: string, category: (
    { id: string, name: string }
    & { __typename?: 'SkillCategory' }
  ) }
  & { __typename?: 'Skill' }
);

export type SkillsListSkillsConnectionsQueryVariables = Exact<{
  listInputs?: InputMaybe<ListInput>;
}>;


export type SkillsListSkillsConnectionsQuery = (
  { skillsConnections?: (
    { pageInfo?: (
      { totalPages?: number | null, totalResults?: number | null, currentPage?: number | null, limit?: number | null, isOutOfBounds?: boolean | null }
      & { __typename: 'PageInfoType' }
    ) | null, skills?: Array<(
      { id: string, name: string, category: (
        { id: string, name: string }
        & { __typename?: 'SkillCategory' }
      ) }
      & { __typename?: 'Skill' }
    )> | null }
    & { __typename?: 'SkillConnectionType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type SummarySkillCategoryFragment = (
  { id: string, name: string, userCount: number, skillCount: number }
  & { __typename?: 'SkillCategory' }
);

export type CurrentCategoryFragment = (
  { id: string, skills: Array<(
    { id: string, users: Array<(
      { id: string }
      & { __typename?: 'UserType' }
    )> }
    & { __typename?: 'Skill' }
  )> }
  & { __typename?: 'SkillCategory' }
);

export type UpdateCategoryNameMutationVariables = Exact<{
  input: UpdateSkillCategoryInput;
}>;


export type UpdateCategoryNameMutation = (
  { updateSkillCategory?: (
    { skillCategory: (
      { id: string, name: string }
      & { __typename?: 'SkillCategory' }
    ) }
    & { __typename?: 'updateSkillCategoryPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type GetCurrentCategoryFragment = (
  { id: string, skills: Array<(
    { id: string, users: Array<(
      { id: string }
      & { __typename?: 'UserType' }
    )> }
    & { __typename?: 'Skill' }
  )> }
  & { __typename?: 'SkillCategory' }
);

export type TimeCapacityUserFragment = (
  { id: string, timeCapacities: Array<(
    { actualHours: number, capacityHours: number, projectCount: number, taskCount: number, indeterminate: boolean, startDate: any, endDate: any, percentage?: number | null }
    & { __typename?: 'CapacityType' }
  )> }
  & { __typename?: 'UserType' }
);

export type CapacityListUserCellUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type ProjectCapacityUserFragment = (
  { id: string }
  & { __typename?: 'UserType' }
);

export type SettingsUpdateCapacitiesMutationVariables = Exact<{
  input: UpdateCapacitiesInput;
}>;


export type SettingsUpdateCapacitiesMutation = (
  { updateCapacities?: (
    { updatedUsers?: Array<(
      { id: string, capacityHours?: number | null }
      & { __typename?: 'UserType' }
    )> | null }
    & { __typename?: 'updateCapacitiesPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type CapacityUpdateOrganizationMutationVariables = Exact<{
  organization: UpdateOrganizationInput;
}>;


export type CapacityUpdateOrganizationMutation = (
  { updateOrganization?: (
    { organization?: (
      { id: string, defaultCapacityHours?: number | null, pmCanEditSkills?: boolean | null }
      & { __typename?: 'OrganizationType' }
    ) | null }
    & { __typename?: 'updateOrganizationPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type EditTaskDrawerProjectSnapshotFragment = (
  { id: string, startOn?: any | null, endOn?: any | null, completedAt?: any | null, forecastedEndOn?: any | null }
  & { __typename?: 'ProjectType' }
);

export type EditTaskDrawerProjectStatsFragment = (
  { totalTasks: number, totalDoneTasks: number, totalAssignedTasks: number, totalTasksWithUnestimatedHoursCount?: number | null, totalActualHours?: number | null, totalInternalEstimatedHours?: number | null }
  & { __typename?: 'ProjectStats' }
);

export type EditTaskDrawerUpdateTaskGroupTaskMutationVariables = Exact<{
  task: UpdateTaskInput;
}>;


export type EditTaskDrawerUpdateTaskGroupTaskMutation = (
  { updateTaskGroupTask?: (
    { taskReturnData?: (
      { task?: (
        { id: string, taskType?: TaskTypeEnumType | null, name: string, description?: string | null, startOn?: any | null, dueOn?: any | null, estimatedHours?: number | null, actualHours?: number | null, billableHours?: number | null, nonBillableHours?: number | null, estimatedPoints?: number | null, duration?: number | null, sortOrder?: number | null, priority?: PriorityEnumType | null, responsibility: TaskResponsibilityEnumType, signOffRequired: boolean, status: StatusEnumType, shouldWarnUpdateStatus?: boolean | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, eventDatetime?: any | null, participantCallToAction?: string | null, invitationGroupSentAt?: any | null, assignmentEmailSentAt?: any | null, completedAt?: any | null, eventInformation?: string | null, meetingLength?: number | null, mustStartOn?: any | null, mustStartOnRequired?: boolean | null, jiraTaskLink?: string | null, visibility?: TaskVisibilityEnumType | null, jiraSync?: boolean | null, dependency?: (
          { id: string, completed?: boolean | null, name: string, tasks?: Array<(
            { id: string, shouldWarnUpdateStatus?: boolean | null }
            & { __typename?: 'TaskType' }
          )> | null }
          & { __typename?: 'MilestoneType' | 'TaskGroupType' }
        ) | (
          { id: string, completed?: boolean | null, shouldWarnUpdateStatus?: boolean | null, name: string }
          & { __typename?: 'TaskType' }
        ) | (
          { id: string, completed?: boolean | null, name: string }
          & { __typename?: 'TemplateType' }
        ) | null, assignee?: (
          { id: string, firstName?: string | null, lastName?: string | null, jobRole?: string | null, calendarLink?: string | null, meetingLink?: string | null, role?: UserRoleEnumType | null, projectContext?: UserProjectOrganizationTypeEnumType | null, avatar?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'UserType' }
        ) | null, signer?: (
          { id: string, firstName?: string | null, lastName?: string | null, email?: string | null }
          & { __typename?: 'SignerType' }
        ) | null, notes?: Array<(
          { id: string }
          & { __typename?: 'NoteType' }
        )> | null, jiraTask?: (
          { id: string, externalId?: string | null, externalProjectId?: string | null, externalTypeId?: string | null, components?: Array<string> | null, createdInJira?: any | null }
          & { __typename?: 'JiraIssueType' }
        ) | null, files?: Array<(
          { id: string, sortOrder?: number | null, url?: string | null, fileName: string, size?: number | null, milestoneName?: string | null, taskName?: string | null, createdAt?: any | null, internalOnly: boolean, deletable?: boolean | null, isExternalHyperlink?: boolean | null, uploader?: (
            { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
              { originalUrl?: string | null }
              & { __typename?: 'ImageType' }
            ) | null }
            & { __typename?: 'UserType' }
          ) | null }
          & { __typename?: 'FileType' }
        )> | null, subtasks?: Array<(
          { id: string, name?: string | null, richName?: string | null, done?: boolean | null, sortOrder?: number | null, groupId?: string | null }
          & { __typename?: 'SubtaskType' }
        )> | null, taskParticipants?: Array<(
          { id: string, completed?: boolean | null, invitationSentAt?: any | null, user?: (
            { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, capacity?: number | null, projectsCount?: number | null, projectContext?: UserProjectOrganizationTypeEnumType | null, organizationName?: string | null, organization?: (
              { id: string, name?: string | null }
              & { __typename?: 'OrganizationType' }
            ) | null, avatar?: (
              { originalUrl?: string | null }
              & { __typename?: 'ImageType' }
            ) | null, displayOrganization?: (
              { name: string }
              & { __typename?: 'DisplayOrganizationType' }
            ) | null }
            & { __typename?: 'UserType' }
          ) | null }
          & { __typename?: 'TaskParticipantType' }
        )> | null, template?: (
          { id: string, duration?: number | null }
          & { __typename?: 'TemplateType' }
        ) | null, project?: (
          { id: string, status: StatusEnumType, name: string, currentUserProjectContext?: UserProjectOrganizationTypeEnumType | null, pmDisplayRole?: string | null, startOn?: any | null, endOn?: any | null, completedAt?: any | null, forecastedEndOn?: any | null, stats?: (
            { totalTasks: number, totalDoneTasks: number, totalAssignedTasks: number, totalTasksWithUnestimatedHoursCount?: number | null, totalActualHours?: number | null, totalInternalEstimatedHours?: number | null }
            & { __typename?: 'ProjectStats' }
          ) | null, profitabilitySummary?: (
            { forecastedCost?: number | null, budgetedCost?: number | null }
            & { __typename?: 'ProjectProfitabilitySummaryType' }
          ) | null, projectManager?: (
            { id: string, firstName?: string | null, lastName?: string | null, calendarLink?: string | null, meetingLink?: string | null }
            & { __typename?: 'UserType' }
          ) | null, organization?: (
            { id: string, name?: string | null, defaultTaskVisibility?: TaskVisibilityEnumType | null, timeTrackingEnabled?: boolean | null, resourceManagementEnabled?: boolean | null, internalNotesDefault: boolean }
            & { __typename?: 'OrganizationType' }
          ) | null, customerV2?: (
            { id: string, name: string }
            & { __typename?: 'CustomerType' }
          ) | null }
          & { __typename?: 'ProjectType' }
        ) | null, tags?: Array<(
          { id: string }
          & { __typename?: 'TagType' }
        )> | null, skill?: (
          { id: string }
          & { __typename?: 'Skill' }
        ) | null, skills?: Array<(
          { id: string }
          & { __typename?: 'Skill' }
        )> | null, creator?: (
          { id: string }
          & { __typename?: 'UserType' }
        ) | null, milestone?: (
          { id: string, sortOrder: number, isFirstOfTemplate: boolean, isFirstOfProject: boolean, template: (
            { id: string, hardDependency?: boolean | null }
            & { __typename?: 'TemplateType' }
          ) }
          & { __typename?: 'MilestoneType' }
        ) | null, subtasksGroups?: Array<(
          { id: string, name?: string | null }
          & { __typename?: 'SubtasksGroupType' }
        )> | null, watchers?: Array<(
          { id: string }
          & { __typename?: 'UserType' }
        )> | null, participantsSelectAll?: (
          { internal: boolean, customer: boolean, thirdParty: boolean }
          & { __typename: 'TaskParticipantSelectAllType' }
        ) | null, taskGroup?: (
          { id: string }
          & { __typename?: 'TaskGroupType' }
        ) | null }
        & { __typename?: 'TaskType' }
      ) | null }
      & { __typename?: 'TaskReturnType' }
    ) | null }
    & { __typename?: 'updateTaskGroupTaskPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type EditTaskDrawerProjectTeamQueryVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type EditTaskDrawerProjectTeamQuery = (
  { projectTeam: Array<(
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, projectContext?: UserProjectOrganizationTypeEnumType | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null, organization?: (
      { id: string }
      & { __typename?: 'OrganizationType' }
    ) | null }
    & { __typename?: 'UserType' }
  )> }
  & { __typename?: 'Query' }
);

export type EditTaskDrawerCurrentUserSkillsQueryVariables = Exact<{ [key: string]: never; }>;


export type EditTaskDrawerCurrentUserSkillsQuery = (
  { currentUser?: (
    { skills: Array<(
      { id: string }
      & { __typename?: 'Skill' }
    )> }
    & { __typename?: 'UserType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type EditTaskDrawerRemoveWatcherMutationVariables = Exact<{
  taskId: Scalars['ID'];
  watcherId: Scalars['ID'];
}>;


export type EditTaskDrawerRemoveWatcherMutation = (
  { removeWatcher?: (
    { success?: boolean | null }
    & { __typename?: 'removeWatcherPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type FilterOptionsCustomerFilterFragment = (
  { id: string, name: string, logo?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null }
  & { __typename?: 'CustomerType' }
);

export type FilterTasksFormPaginatedUserTaskAssigneesQueryVariables = Exact<{
  listInput?: InputMaybe<ListInput>;
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type FilterTasksFormPaginatedUserTaskAssigneesQuery = (
  { paginatedUserTaskAssignees?: (
    { users?: Array<(
      { id: string, email?: string | null, firstName?: string | null, lastName?: string | null, jobRole?: string | null, organizationName?: string | null, organization?: (
        { id: string, name?: string | null }
        & { __typename?: 'OrganizationType' }
      ) | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null, displayOrganization?: (
        { name: string }
        & { __typename?: 'DisplayOrganizationType' }
      ) | null }
      & { __typename?: 'UserType' }
    )> | null, pageInfo?: (
      { totalPages?: number | null, totalResults?: number | null, currentPage?: number | null, limit?: number | null, isOutOfBounds?: boolean | null }
      & { __typename: 'PageInfoType' }
    ) | null }
    & { __typename?: 'PaginatedUsersType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type TaskIndexTableRowTaskFragment = (
  { id: string, name: string, taskType?: TaskTypeEnumType | null, visibility?: TaskVisibilityEnumType | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, priority?: PriorityEnumType | null, shouldWarnUpdateStatus?: boolean | null, status: StatusEnumType, dueOn?: any | null, signOffRequired: boolean, template?: (
    { id: string, name: string, hardDependency?: boolean | null }
    & { __typename?: 'TemplateType' }
  ) | null, assignee?: (
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'UserType' }
  ) | null, milestone?: (
    { id: string, name: string, sortOrder: number }
    & { __typename?: 'MilestoneType' }
  ) | null, taskGroup?: (
    { id: string }
    & { __typename?: 'TaskGroupType' }
  ) | null, dependency?: (
    { id: string, name: string, completed?: boolean | null, forecastedEndOn?: any | null }
    & { __typename: 'MilestoneType' | 'TaskGroupType' }
  ) | (
    { id: string, name: string, completed?: boolean | null, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null, dueOn?: any | null }
    & { __typename: 'TaskType' }
  ) | (
    { id: string, name: string, completed?: boolean | null }
    & { __typename: 'TemplateType' }
  ) | null, tags?: Array<(
    { id: string, color: string, name: string, internalOnly: boolean }
    & { __typename: 'TagType' }
  )> | null, project?: (
    { id: string, name: string, currentUserProjectContext?: UserProjectOrganizationTypeEnumType | null, startOn?: any | null, endOn?: any | null, pmDisplayRole?: string | null, projectType?: ProjectTypeEnumType | null, organization?: (
      { id: string }
      & { __typename?: 'OrganizationType' }
    ) | null, customerV2?: (
      { id: string, name: string, logo?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'CustomerType' }
    ) | null }
    & { __typename?: 'ProjectType' }
  ) | null }
  & { __typename?: 'TaskType' }
);

export type TaskIndexExportGlobalTasksListMutationVariables = Exact<{
  taskFilters?: InputMaybe<TaskFilters>;
}>;


export type TaskIndexExportGlobalTasksListMutation = (
  { exportGlobalTasksList?: (
    { success?: boolean | null }
    & { __typename?: 'exportGlobalTasksListPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type TaskListTableTaskListQueryVariables = Exact<{
  listInputs?: InputMaybe<ListInput>;
  taskFilters?: InputMaybe<TaskFilters>;
}>;


export type TaskListTableTaskListQuery = (
  { userTasksConnections?: (
    { pageInfo?: (
      { totalPages?: number | null, totalResults?: number | null, currentPage?: number | null, limit?: number | null, isOutOfBounds?: boolean | null }
      & { __typename?: 'PageInfoType' }
    ) | null, tasks?: Array<(
      { id: string, name: string, taskType?: TaskTypeEnumType | null, visibility?: TaskVisibilityEnumType | null, currentUserTaskContext?: CurrentUserTaskContextEnumType | null, priority?: PriorityEnumType | null, shouldWarnUpdateStatus?: boolean | null, status: StatusEnumType, dueOn?: any | null, signOffRequired: boolean, template?: (
        { id: string, name: string, hardDependency?: boolean | null }
        & { __typename?: 'TemplateType' }
      ) | null, assignee?: (
        { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobRole?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null, milestone?: (
        { id: string, name: string, sortOrder: number }
        & { __typename?: 'MilestoneType' }
      ) | null, taskGroup?: (
        { id: string }
        & { __typename?: 'TaskGroupType' }
      ) | null, dependency?: (
        { id: string, name: string, completed?: boolean | null, forecastedEndOn?: any | null }
        & { __typename: 'MilestoneType' | 'TaskGroupType' }
      ) | (
        { id: string, name: string, completed?: boolean | null, shouldWarnUpdateStatus?: boolean | null, visibility?: TaskVisibilityEnumType | null, dueOn?: any | null }
        & { __typename: 'TaskType' }
      ) | (
        { id: string, name: string, completed?: boolean | null }
        & { __typename: 'TemplateType' }
      ) | null, tags?: Array<(
        { id: string, color: string, name: string, internalOnly: boolean }
        & { __typename: 'TagType' }
      )> | null, project?: (
        { id: string, name: string, currentUserProjectContext?: UserProjectOrganizationTypeEnumType | null, startOn?: any | null, endOn?: any | null, pmDisplayRole?: string | null, projectType?: ProjectTypeEnumType | null, organization?: (
          { id: string }
          & { __typename?: 'OrganizationType' }
        ) | null, customerV2?: (
          { id: string, name: string, logo?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'CustomerType' }
        ) | null }
        & { __typename?: 'ProjectType' }
      ) | null }
      & { __typename?: 'TaskType' }
    )> | null }
    & { __typename?: 'TaskConnectionType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type TaskMilestoneFragment = (
  { milestone?: (
    { id: string }
    & { __typename?: 'MilestoneType' }
  ) | null }
  & { __typename?: 'TaskType' }
);

export type DeleteTaskDialogProjectSnapshotFragment = (
  { id: string, startOn?: any | null, endOn?: any | null, completedAt?: any | null, forecastedEndOn?: any | null }
  & { __typename?: 'ProjectType' }
);

export type DeleteTaskDialogProjectStatsFragment = (
  { totalTasks: number, totalDoneTasks: number, totalAssignedTasks: number, totalTasksWithUnestimatedHoursCount?: number | null, totalActualHours?: number | null, totalInternalEstimatedHours?: number | null }
  & { __typename?: 'ProjectStats' }
);

export type ProjectDeleteTaskDialogDeleteTaskMutationVariables = Exact<{
  deleteTaskInput: DeleteTaskInput;
}>;


export type ProjectDeleteTaskDialogDeleteTaskMutation = (
  { deleteTask?: (
    { taskReturnData?: (
      { milestone?: (
        { id: string }
        & { __typename?: 'MilestoneType' }
      ) | null, project?: (
        { id: string, startOn?: any | null, endOn?: any | null, completedAt?: any | null, forecastedEndOn?: any | null, stats?: (
          { totalTasks: number, totalDoneTasks: number, totalAssignedTasks: number, totalTasksWithUnestimatedHoursCount?: number | null, totalActualHours?: number | null, totalInternalEstimatedHours?: number | null }
          & { __typename?: 'ProjectStats' }
        ) | null, profitabilitySummary?: (
          { forecastedCost?: number | null, budgetedCost?: number | null }
          & { __typename?: 'ProjectProfitabilitySummaryType' }
        ) | null }
        & { __typename?: 'ProjectType' }
      ) | null }
      & { __typename?: 'TaskReturnType' }
    ) | null }
    & { __typename?: 'deleteTaskPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type TemplateDialogContextDeleteTaskMutationVariables = Exact<{
  deleteTaskInput: DeleteTaskInput;
}>;


export type TemplateDialogContextDeleteTaskMutation = (
  { deleteTask?: (
    { taskReturnData?: (
      { milestone?: (
        { id: string, summaryBank: (
          { id: string, totalTasks?: number | null, totalCompleteTasks?: number | null, totalRemainingTasks?: number | null, duration?: number | null }
          & { __typename?: 'MilestoneStats' }
        ) }
        & { __typename?: 'MilestoneType' }
      ) | null }
      & { __typename?: 'TaskReturnType' }
    ) | null }
    & { __typename?: 'deleteTaskPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type SendActionParticipantsDialogEventInviteMutationVariables = Exact<{
  taskId: Scalars['ID'];
  resendInvitation?: InputMaybe<Scalars['Boolean']>;
}>;


export type SendActionParticipantsDialogEventInviteMutation = (
  { sendEventInvite?: (
    { task?: (
      { id: string, invitationGroupSentAt?: any | null, taskParticipants?: Array<(
        { id: string, invitationSentAt?: any | null }
        & { __typename?: 'TaskParticipantType' }
      )> | null }
      & { __typename?: 'TaskType' }
    ) | null }
    & { __typename?: 'sendEventInvitePayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type SendSignOffDialogSendSignOffMutationVariables = Exact<{
  taskId: Scalars['ID'];
  message: Scalars['String'];
}>;


export type SendSignOffDialogSendSignOffMutation = (
  { sendSignOff?: (
    { sendSignOffReturnData?: (
      { task?: (
        { id: string, status: StatusEnumType }
        & { __typename?: 'TaskType' }
      ) | null }
      & { __typename?: 'TaskReturnType' }
    ) | null }
    & { __typename?: 'sendSignOffPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ConfirmDeleteTemplateDialogTemplateFragment = (
  { id: string, name: string }
  & { __typename?: 'TemplateType' }
);

export type ConfirmDeleteTemplateDialogDeleteTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
  templateType: TemplateEnumType;
}>;


export type ConfirmDeleteTemplateDialogDeleteTemplateMutation = (
  { deleteTemplate?: (
    { success?: boolean | null }
    & { __typename?: 'deleteTemplatePayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ConfirmDuplicateTemplateDialogFragment = (
  { id: string, name: string }
  & { __typename?: 'TemplateType' }
);

export type ConfirmDuplicateTemplateDialogDuplicateTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
  duplicateName: Scalars['String'];
  templateType: TemplateEnumType;
}>;


export type ConfirmDuplicateTemplateDialogDuplicateTemplateMutation = (
  { duplicateTemplate?: (
    { success?: boolean | null }
    & { __typename?: 'duplicateTemplatePayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type EditTemplateFormTemplateFragment = (
  { id: string, name: string, sku?: string | null, description?: string | null, videoUrl?: string | null, experienceOverview?: string | null, hardDependency?: boolean | null, published: boolean, videoPlaceholderImage?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, files?: Array<(
    { id: string, fileName: string, size?: number | null, url?: string | null, deletable?: boolean | null, internalOnly: boolean, isExternalHyperlink?: boolean | null, uploader?: (
      { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null }
    & { __typename?: 'FileType' }
  )> | null }
  & { __typename?: 'TemplateType' }
);

export type EditTemplateFormEditTemplateV2Fragment = (
  { id: string, name: string, sku?: string | null, description?: string | null, videoUrl?: string | null, experienceOverview?: string | null, hardDependency?: boolean | null, published: boolean, videoPlaceholderImage?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, files?: Array<(
    { id: string, fileName: string, size?: number | null, url?: string | null, internalOnly: boolean, isExternalHyperlink?: boolean | null }
    & { __typename?: 'FileType' }
  )> | null, milestones?: Array<(
    { id: string, duration?: number | null, tasks?: Array<(
      { id: string, duration?: number | null, dependency?: (
        { id: string, name: string, completed?: boolean | null }
        & { __typename?: 'MilestoneType' | 'TaskGroupType' | 'TaskType' | 'TemplateType' }
      ) | null }
      & { __typename?: 'TaskType' }
    )> | null }
    & { __typename?: 'MilestoneType' }
  )> | null }
  & { __typename?: 'TemplateType' }
);

export type EditTemplateFormUpdateTemplateV2MutationVariables = Exact<{
  template: UpdateTemplateInput;
}>;


export type EditTemplateFormUpdateTemplateV2Mutation = (
  { updateTemplate?: (
    { template?: (
      { id: string, name: string, sku?: string | null, description?: string | null, videoUrl?: string | null, experienceOverview?: string | null, hardDependency?: boolean | null, published: boolean, videoPlaceholderImage?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null, files?: Array<(
        { id: string, fileName: string, size?: number | null, url?: string | null, internalOnly: boolean, isExternalHyperlink?: boolean | null }
        & { __typename?: 'FileType' }
      )> | null, milestones?: Array<(
        { id: string, duration?: number | null, tasks?: Array<(
          { id: string, duration?: number | null, dependency?: (
            { id: string, name: string, completed?: boolean | null }
            & { __typename?: 'MilestoneType' | 'TaskGroupType' | 'TaskType' | 'TemplateType' }
          ) | null }
          & { __typename?: 'TaskType' }
        )> | null }
        & { __typename?: 'MilestoneType' }
      )> | null }
      & { __typename?: 'TemplateType' }
    ) | null }
    & { __typename?: 'updateTemplatePayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type EditTemplateDrawerTemplateFragment = (
  { id: string, name: string, sku?: string | null, description?: string | null, videoUrl?: string | null, experienceOverview?: string | null, hardDependency?: boolean | null, published: boolean, videoPlaceholderImage?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, files?: Array<(
    { id: string, fileName: string, size?: number | null, url?: string | null, deletable?: boolean | null, internalOnly: boolean, isExternalHyperlink?: boolean | null, uploader?: (
      { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null }
    & { __typename?: 'FileType' }
  )> | null }
  & { __typename?: 'TemplateType' }
);

export type FilterTemplatePlanDrawerAssigneeFragment = (
  { id: string, email?: string | null, firstName?: string | null, lastName?: string | null, jobRole?: string | null, organizationName?: string | null, organization?: (
    { id: string, name?: string | null }
    & { __typename?: 'OrganizationType' }
  ) | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, displayOrganization?: (
    { name: string }
    & { __typename?: 'DisplayOrganizationType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type TemplateTableRowTemplateFragment = (
  { id: string, name: string, sku?: string | null, description?: string | null, hardDependency?: boolean | null, videoUrl?: string | null, experienceOverview?: string | null, published: boolean, createdAt?: any | null, updatedAt?: any | null, videoPlaceholderImage?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, creator?: (
    { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'UserType' }
  ) | null, lastEditedBy?: (
    { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'UserType' }
  ) | null }
  & { __typename?: 'TemplateType' }
);

export type TemplateIndexTemplateFragment = (
  { id: string, name: string, sku?: string | null, description?: string | null, hardDependency?: boolean | null, videoUrl?: string | null, experienceOverview?: string | null, published: boolean, createdAt?: any | null, updatedAt?: any | null, videoPlaceholderImage?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, creator?: (
    { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'UserType' }
  ) | null, lastEditedBy?: (
    { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'UserType' }
  ) | null }
  & { __typename?: 'TemplateType' }
);

export type TemplateIndexTemplateListQueryVariables = Exact<{
  listInputs?: InputMaybe<ListInput>;
}>;


export type TemplateIndexTemplateListQuery = (
  { templateConnections?: (
    { pageInfo?: (
      { totalPages?: number | null, totalResults?: number | null, currentPage?: number | null, limit?: number | null, isOutOfBounds?: boolean | null }
      & { __typename?: 'PageInfoType' }
    ) | null, templates?: Array<(
      { id: string, name: string, sku?: string | null, description?: string | null, hardDependency?: boolean | null, videoUrl?: string | null, experienceOverview?: string | null, published: boolean, createdAt?: any | null, updatedAt?: any | null, videoPlaceholderImage?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null, creator?: (
        { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null, lastEditedBy?: (
        { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null }
      & { __typename?: 'TemplateType' }
    )> | null }
    & { __typename?: 'Connections' }
  ) | null }
  & { __typename?: 'Query' }
);

export type TemplateIndexCreateTemplateMutationVariables = Exact<{
  template: CreateTemplateInput;
}>;


export type TemplateIndexCreateTemplateMutation = (
  { createTemplate?: (
    { template?: (
      { id: string, name: string, sku?: string | null, description?: string | null, hardDependency?: boolean | null, videoUrl?: string | null, experienceOverview?: string | null, published: boolean, createdAt?: any | null, updatedAt?: any | null, videoPlaceholderImage?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null, creator?: (
        { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null, lastEditedBy?: (
        { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null }
      & { __typename?: 'TemplateType' }
    ) | null }
    & { __typename?: 'createTemplatePayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type TemplateFilesFileFragment = (
  { id: string, url?: string | null, fileName: string, size?: number | null, milestoneName?: string | null, deletable?: boolean | null, taskName?: string | null, createdAt?: any | null, internalOnly: boolean, isExternalHyperlink?: boolean | null, uploader?: (
    { id: string, firstName?: string | null, lastName?: string | null }
    & { __typename?: 'UserType' }
  ) | null }
  & { __typename?: 'FileType' }
);

export type TemplateFilesFilesQueryVariables = Exact<{
  templateId: Scalars['ID'];
  listInputs?: InputMaybe<ListInput>;
}>;


export type TemplateFilesFilesQuery = (
  { templatesById?: Array<(
    { id: string, name: string }
    & { __typename?: 'TemplateType' }
  )> | null, files?: (
    { pageInfo?: (
      { totalPages?: number | null, totalResults?: number | null, currentPage?: number | null, limit?: number | null, isOutOfBounds?: boolean | null }
      & { __typename?: 'PageInfoType' }
    ) | null, assets?: Array<(
      { deletable?: boolean | null, id: string, url?: string | null, fileName: string, size?: number | null, milestoneName?: string | null, taskName?: string | null, createdAt?: any | null, internalOnly: boolean, isExternalHyperlink?: boolean | null, uploader?: (
        { id: string, firstName?: string | null, lastName?: string | null }
        & { __typename?: 'UserType' }
      ) | null }
      & { __typename?: 'FileType' }
    )> | null }
    & { __typename?: 'AssetConnectionType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type TemplateFilesDeleteFileMutationVariables = Exact<{
  deleteFileInput: DeleteFileInput;
}>;


export type TemplateFilesDeleteFileMutation = (
  { deleteFile?: (
    { success?: boolean | null }
    & { __typename?: 'DeleteFilePayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type TemplateFilesUpdateTemplateMutationVariables = Exact<{
  input: UpdateTemplateInput;
}>;


export type TemplateFilesUpdateTemplateMutation = (
  { updateTemplate?: (
    { template?: (
      { id: string, files?: Array<(
        { id: string, url?: string | null, fileName: string, size?: number | null, milestoneName?: string | null, deletable?: boolean | null, taskName?: string | null, createdAt?: any | null, internalOnly: boolean, isExternalHyperlink?: boolean | null, uploader?: (
          { id: string, firstName?: string | null, lastName?: string | null }
          & { __typename?: 'UserType' }
        ) | null }
        & { __typename?: 'FileType' }
      )> | null }
      & { __typename?: 'TemplateType' }
    ) | null }
    & { __typename?: 'updateTemplatePayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type AddEditTimeEntryTimeRecordFragment = (
  { id: string, dateWorked?: any | null, description?: string | null, billable?: boolean | null, hours?: number | null, categoryId?: string | null, taskId?: string | null, projectId: string, workerId: string, worker?: (
    { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'UserType' }
  ) | null, category?: (
    { id: string, name: string }
    & { __typename?: 'TimeTrackingCategory' }
  ) | null }
  & { __typename?: 'TimeRecordType' }
);

export type AddEditTimeEntryTimeRecordPageFragment = (
  { currentPage?: number | null, isOutOfBounds?: boolean | null, limit?: number | null, totalPages?: number | null, totalResults?: number | null }
  & { __typename?: 'PageInfoType' }
);

export type AddEditTimeEntriesTaskTimeRecordsQueryVariables = Exact<{
  taskId: Scalars['ID'];
  listInputs?: InputMaybe<ListInput>;
}>;


export type AddEditTimeEntriesTaskTimeRecordsQuery = (
  { task: (
    { id: string, name: string, estimatedHours?: number | null, totalHours?: number | null }
    & { __typename?: 'TaskType' }
  ), taskTimeRecords?: (
    { pageInfo: (
      { currentPage?: number | null, isOutOfBounds?: boolean | null, limit?: number | null, totalPages?: number | null, totalResults?: number | null }
      & { __typename?: 'PageInfoType' }
    ), timeRecords: Array<(
      { id: string, dateWorked?: any | null, description?: string | null, billable?: boolean | null, hours?: number | null, categoryId?: string | null, taskId?: string | null, projectId: string, workerId: string, worker?: (
        { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null, category?: (
        { id: string, name: string }
        & { __typename?: 'TimeTrackingCategory' }
      ) | null }
      & { __typename?: 'TimeRecordType' }
    )> }
    & { __typename?: 'TaskTimeRecords' }
  ) | null }
  & { __typename?: 'Query' }
);

export type AddEditTimeEntriesGenericTimeRecordsQueryVariables = Exact<{
  projectId: Scalars['ID'];
  listInputs?: InputMaybe<ListInput>;
  workerId: Scalars['ID'];
  startDate: Scalars['DateType'];
  endDate: Scalars['DateType'];
}>;


export type AddEditTimeEntriesGenericTimeRecordsQuery = (
  { project: (
    { id: string, name: string, timeReport: (
      { allTimeUserProjectTotalHours?: number | null }
      & { __typename?: 'TimeReport' }
    ) }
    & { __typename?: 'ProjectType' }
  ), genericTimeRecords?: (
    { pageInfo: (
      { currentPage?: number | null, isOutOfBounds?: boolean | null, limit?: number | null, totalPages?: number | null, totalResults?: number | null }
      & { __typename?: 'PageInfoType' }
    ), timeRecords: Array<(
      { id: string, dateWorked?: any | null, description?: string | null, billable?: boolean | null, hours?: number | null, categoryId?: string | null, taskId?: string | null, projectId: string, workerId: string, worker?: (
        { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null, category?: (
        { id: string, name: string }
        & { __typename?: 'TimeTrackingCategory' }
      ) | null }
      & { __typename?: 'TimeRecordType' }
    )> }
    & { __typename?: 'TaskTimeRecords' }
  ) | null }
  & { __typename?: 'Query' }
);

export type CategoryInfinitySelectorOrganizationTypeFragment = (
  { id: string, timeTrackingCategoryConnections: (
    { categories?: Array<(
      { id: string, name: string, billable: boolean }
      & { __typename?: 'TimeTrackingCategory' }
    )> | null, pageInfo?: (
      { totalPages?: number | null, totalResults?: number | null, currentPage?: number | null, limit?: number | null, isOutOfBounds?: boolean | null }
      & { __typename?: 'PageInfoType' }
    ) | null }
    & { __typename?: 'PaginatedCategoriesType' }
  ) }
  & { __typename?: 'OrganizationType' }
);

export type CategoryInfinitySelectorOrganizationQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  listInputs: ListInput;
}>;


export type CategoryInfinitySelectorOrganizationQuery = (
  { organization?: (
    { id: string, timeTrackingCategoryConnections: (
      { categories?: Array<(
        { id: string, name: string, billable: boolean }
        & { __typename?: 'TimeTrackingCategory' }
      )> | null, pageInfo?: (
        { totalPages?: number | null, totalResults?: number | null, currentPage?: number | null, limit?: number | null, isOutOfBounds?: boolean | null }
        & { __typename?: 'PageInfoType' }
      ) | null }
      & { __typename?: 'PaginatedCategoriesType' }
    ) }
    & { __typename?: 'OrganizationType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type CategoryOptionTimeTrackingCategoryFragment = (
  { id: string, name: string, billable: boolean }
  & { __typename?: 'TimeTrackingCategory' }
);

export type ExportButtonTimeReportExportMutationVariables = Exact<{
  input: TimeReportExportInput;
}>;


export type ExportButtonTimeReportExportMutation = (
  { timeReportExport?: (
    { success?: boolean | null }
    & { __typename?: 'timeReportExportPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type GenericTimeProjectQueryVariables = Exact<{
  id: Scalars['ID'];
  filters?: InputMaybe<TimeReportFiltersInput>;
  startDate: Scalars['DateType'];
  endDate: Scalars['DateType'];
  userId?: InputMaybe<Scalars['ID']>;
}>;


export type GenericTimeProjectQuery = (
  { project: (
    { id: string, name: string, genericTimeReport: (
      { estimatedHours: number, nonBillableHours: number, billableHours: number, totalHours: number, totalCost?: number | null, totalBilled?: number | null, revenue?: number | null, allTimeUserProjectTotalHours?: number | null }
      & { __typename?: 'TimeReport' }
    ) }
    & { __typename?: 'ProjectType' }
  ) }
  & { __typename?: 'Query' }
);

export type MilestoneDetailsProjectFragment = (
  { id: string, milestoneCount: number }
  & { __typename?: 'ProjectType' }
);

export type MilestoneDetailsProjectQueryVariables = Exact<{
  id: Scalars['ID'];
  listInput: ListInput;
  filters?: InputMaybe<TimeReportFiltersInput>;
  startDate: Scalars['DateType'];
  endDate: Scalars['DateType'];
  taskResponsibilities?: InputMaybe<Array<TaskResponsibilityEnumType> | TaskResponsibilityEnumType>;
}>;


export type MilestoneDetailsProjectQuery = (
  { project: (
    { id: string, paginatedMilestones: (
      { milestones?: Array<(
        { id: string, taskCount: number, status: MilestoneStatusEnumType, name: string, timeReport: (
          { estimatedHours: number, nonBillableHours: number, billableHours: number, totalHours: number, totalCost?: number | null, totalBilled?: number | null, revenue?: number | null, allTimeUserProjectTotalHours?: number | null }
          & { __typename?: 'TimeReport' }
        ) }
        & { __typename?: 'MilestoneType' }
      )> | null, pageInfo?: (
        { totalPages?: number | null, totalResults?: number | null, currentPage?: number | null, limit?: number | null, isOutOfBounds?: boolean | null }
        & { __typename?: 'PageInfoType' }
      ) | null }
      & { __typename?: 'PaginatedMilestones' }
    ) }
    & { __typename?: 'ProjectType' }
  ) }
  & { __typename?: 'Query' }
);

export type MilestoneAccordionMilestoneFragment = (
  { id: string, taskCount: number, status: MilestoneStatusEnumType, name: string, timeReport: (
    { estimatedHours: number, nonBillableHours: number, billableHours: number, totalHours: number, totalCost?: number | null, totalBilled?: number | null, revenue?: number | null, allTimeUserProjectTotalHours?: number | null }
    & { __typename?: 'TimeReport' }
  ) }
  & { __typename?: 'MilestoneType' }
);

export type MilestoneAccordionTaskFragment = (
  { id: string, status: StatusEnumType, name: string, taskType?: TaskTypeEnumType | null, dueOn?: any | null, project?: (
    { id: string, projectBillRate?: (
      { rateType?: RateTypeEnum | null }
      & { __typename?: 'ProjectBillRateType' }
    ) | null }
    & { __typename?: 'ProjectType' }
  ) | null, paginatedUsersForTimeRecords: (
    { users?: Array<(
      { email?: string | null, id: string, firstName?: string | null, lastName?: string | null, jobRole?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    )> | null, pageInfo?: (
      { totalPages?: number | null, totalResults?: number | null, currentPage?: number | null, limit?: number | null, isOutOfBounds?: boolean | null }
      & { __typename: 'PageInfoType' }
    ) | null }
    & { __typename?: 'PaginatedUsersType' }
  ), milestone?: (
    { id: string, name: string }
    & { __typename?: 'MilestoneType' }
  ) | null, timeReport: (
    { estimatedHours: number, nonBillableHours: number, billableHours: number, totalHours: number, totalCost?: number | null, totalBilled?: number | null, revenue?: number | null, allTimeUserProjectTotalHours?: number | null }
    & { __typename?: 'TimeReport' }
  ), timeRecordsPeriod?: Array<(
    { id: string, billable?: boolean | null, dateWorked?: any | null, hours?: number | null }
    & { __typename?: 'TimeRecordType' }
  )> }
  & { __typename?: 'TaskType' }
);

export type MilestoneAccordionMilestoneQueryVariables = Exact<{
  id: Scalars['ID'];
  listInput: ListInput;
  filters?: InputMaybe<TimeReportFiltersInput>;
  userId?: InputMaybe<Scalars['ID']>;
  startDate: Scalars['DateType'];
  endDate: Scalars['DateType'];
  includeTimeRecords: Scalars['Boolean'];
}>;


export type MilestoneAccordionMilestoneQuery = (
  { milestone: (
    { id: string, paginatedTasks: (
      { tasks: Array<(
        { id: string, status: StatusEnumType, name: string, taskType?: TaskTypeEnumType | null, dueOn?: any | null, project?: (
          { id: string, projectBillRate?: (
            { rateType?: RateTypeEnum | null }
            & { __typename?: 'ProjectBillRateType' }
          ) | null }
          & { __typename?: 'ProjectType' }
        ) | null, paginatedUsersForTimeRecords: (
          { users?: Array<(
            { email?: string | null, id: string, firstName?: string | null, lastName?: string | null, jobRole?: string | null, avatar?: (
              { originalUrl?: string | null }
              & { __typename?: 'ImageType' }
            ) | null }
            & { __typename?: 'UserType' }
          )> | null, pageInfo?: (
            { totalPages?: number | null, totalResults?: number | null, currentPage?: number | null, limit?: number | null, isOutOfBounds?: boolean | null }
            & { __typename: 'PageInfoType' }
          ) | null }
          & { __typename?: 'PaginatedUsersType' }
        ), milestone?: (
          { id: string, name: string }
          & { __typename?: 'MilestoneType' }
        ) | null, timeReport: (
          { estimatedHours: number, nonBillableHours: number, billableHours: number, totalHours: number, totalCost?: number | null, totalBilled?: number | null, revenue?: number | null, allTimeUserProjectTotalHours?: number | null }
          & { __typename?: 'TimeReport' }
        ), timeRecordsPeriod?: Array<(
          { id: string, billable?: boolean | null, dateWorked?: any | null, hours?: number | null }
          & { __typename?: 'TimeRecordType' }
        )> }
        & { __typename?: 'TaskType' }
      )>, pageInfo: (
        { totalPages?: number | null, totalResults?: number | null, currentPage?: number | null, limit?: number | null, isOutOfBounds?: boolean | null }
        & { __typename?: 'PageInfoType' }
      ) }
      & { __typename?: 'PaginatedTasks' }
    ) }
    & { __typename?: 'MilestoneType' }
  ) }
  & { __typename?: 'Query' }
);

export type MilestoneRowMilestoneFragment = (
  { id: string, name: string, timeReport: (
    { estimatedHours: number, nonBillableHours: number, billableHours: number, totalHours: number, totalCost?: number | null, totalBilled?: number | null, revenue?: number | null, allTimeUserProjectTotalHours?: number | null }
    & { __typename?: 'TimeReport' }
  ) }
  & { __typename?: 'MilestoneType' }
);

export type ProjectAccordionProjectFragment = (
  { id: string, status: StatusEnumType, name: string, milestoneCount: number, timeReportingTasksCount?: number, projectBillRate?: (
    { rateType?: RateTypeEnum | null }
    & { __typename?: 'ProjectBillRateType' }
  ) | null, timeReport: (
    { estimatedHours: number, nonBillableHours: number, billableHours: number, totalHours: number, totalCost?: number | null, totalBilled?: number | null, revenue?: number | null, allTimeUserProjectTotalHours?: number | null }
    & { __typename?: 'TimeReport' }
  ), genericTimeReport?: (
    { estimatedHours: number, nonBillableHours: number, billableHours: number, totalHours: number, totalCost?: number | null, totalBilled?: number | null, revenue?: number | null, allTimeUserProjectTotalHours?: number | null }
    & { __typename?: 'TimeReport' }
  ), timeRecordsPeriod?: Array<(
    { id: string, billable?: boolean | null, dateWorked?: any | null, hours?: number | null }
    & { __typename?: 'TimeRecordType' }
  )> }
  & { __typename?: 'ProjectType' }
);

export type ProjectRowProjectFragment = (
  { id: string, name: string, projectBillRate?: (
    { rateType?: RateTypeEnum | null }
    & { __typename?: 'ProjectBillRateType' }
  ) | null, timeReport: (
    { estimatedHours: number, nonBillableHours: number, billableHours: number, totalHours: number, totalCost?: number | null, totalBilled?: number | null, revenue?: number | null, allTimeUserProjectTotalHours?: number | null }
    & { __typename?: 'TimeReport' }
  ), genericTimeReport?: (
    { estimatedHours: number, nonBillableHours: number, billableHours: number, totalHours: number, totalCost?: number | null, totalBilled?: number | null, revenue?: number | null, allTimeUserProjectTotalHours?: number | null }
    & { __typename?: 'TimeReport' }
  ), timeRecordsPeriod?: Array<(
    { id: string, billable?: boolean | null, dateWorked?: any | null, hours?: number | null }
    & { __typename?: 'TimeRecordType' }
  )> }
  & { __typename?: 'ProjectType' }
);

export type ProjectScopedTableProjectsConnectionsQueryVariables = Exact<{
  listInput: ListInput;
  filters: TimeReportFiltersInput;
  projectFilters?: InputMaybe<ProjectFilters>;
  startDate: Scalars['DateType'];
  endDate: Scalars['DateType'];
  userId?: InputMaybe<Scalars['ID']>;
  isRootView: Scalars['Boolean'];
  includeGeneric: Scalars['Boolean'];
  includeTimeRecords: Scalars['Boolean'];
}>;


export type ProjectScopedTableProjectsConnectionsQuery = (
  { projectsConnections?: (
    { pageInfo?: (
      { totalPages?: number | null, totalResults?: number | null, currentPage?: number | null, limit?: number | null, isOutOfBounds?: boolean | null }
      & { __typename?: 'PageInfoType' }
    ) | null, projects?: Array<(
      { id: string, status: StatusEnumType, name: string, milestoneCount: number, timeReportingTasksCount?: number, projectBillRate?: (
        { rateType?: RateTypeEnum | null }
        & { __typename?: 'ProjectBillRateType' }
      ) | null, timeReport: (
        { estimatedHours: number, nonBillableHours: number, billableHours: number, totalHours: number, totalCost?: number | null, totalBilled?: number | null, revenue?: number | null, allTimeUserProjectTotalHours?: number | null }
        & { __typename?: 'TimeReport' }
      ), genericTimeReport?: (
        { estimatedHours: number, nonBillableHours: number, billableHours: number, totalHours: number, totalCost?: number | null, totalBilled?: number | null, revenue?: number | null, allTimeUserProjectTotalHours?: number | null }
        & { __typename?: 'TimeReport' }
      ), timeRecordsPeriod?: Array<(
        { id: string, billable?: boolean | null, dateWorked?: any | null, hours?: number | null }
        & { __typename?: 'TimeRecordType' }
      )> }
      & { __typename?: 'ProjectType' }
    )> | null }
    & { __typename?: 'ProjectConnectionType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type SummaryRowProjectFragment = (
  { id: string, status: StatusEnumType }
  & { __typename?: 'ProjectType' }
);

export type SummaryRowMilestoneFragment = (
  { id: string, status: MilestoneStatusEnumType }
  & { __typename?: 'MilestoneType' }
);

export type SummaryRowTaskFragment = (
  { id: string, status: StatusEnumType }
  & { __typename?: 'TaskType' }
);

export type SummaryRowUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type TaskDetailTaskFragment = (
  { id: string, status: StatusEnumType, name: string, taskType?: TaskTypeEnumType | null, dueOn?: any | null, project?: (
    { id: string, projectBillRate?: (
      { rateType?: RateTypeEnum | null }
      & { __typename?: 'ProjectBillRateType' }
    ) | null }
    & { __typename?: 'ProjectType' }
  ) | null, paginatedUsersForTimeRecords: (
    { users?: Array<(
      { email?: string | null, id: string, firstName?: string | null, lastName?: string | null, jobRole?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    )> | null, pageInfo?: (
      { totalPages?: number | null, totalResults?: number | null, currentPage?: number | null, limit?: number | null, isOutOfBounds?: boolean | null }
      & { __typename: 'PageInfoType' }
    ) | null }
    & { __typename?: 'PaginatedUsersType' }
  ), milestone?: (
    { id: string, name: string }
    & { __typename?: 'MilestoneType' }
  ) | null, timeReport: (
    { estimatedHours: number, nonBillableHours: number, billableHours: number, totalHours: number, totalCost?: number | null, totalBilled?: number | null, revenue?: number | null, allTimeUserProjectTotalHours?: number | null }
    & { __typename?: 'TimeReport' }
  ), timeRecordsPeriod?: Array<(
    { id: string, billable?: boolean | null, dateWorked?: any | null, hours?: number | null }
    & { __typename?: 'TimeRecordType' }
  )> }
  & { __typename?: 'TaskType' }
);

export type TaskDetailsProjectFragment = (
  { id: string, timeReportingTasksCount?: number }
  & { __typename?: 'ProjectType' }
);

export type TaskDetailsUserTasksQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']>;
  projectId?: InputMaybe<Scalars['ID']>;
  listInput?: InputMaybe<ListInput>;
  filters?: InputMaybe<TimeReportFiltersInput>;
  startDate: Scalars['DateType'];
  endDate: Scalars['DateType'];
  includeTimeRecords: Scalars['Boolean'];
}>;


export type TaskDetailsUserTasksQuery = (
  { userProjectTaskReportingList?: (
    { pageInfo?: (
      { totalPages?: number | null, totalResults?: number | null, currentPage?: number | null, limit?: number | null, isOutOfBounds?: boolean | null }
      & { __typename?: 'PageInfoType' }
    ) | null, tasks?: Array<(
      { id: string, status: StatusEnumType, name: string, taskType?: TaskTypeEnumType | null, dueOn?: any | null, project?: (
        { id: string, projectBillRate?: (
          { rateType?: RateTypeEnum | null }
          & { __typename?: 'ProjectBillRateType' }
        ) | null }
        & { __typename?: 'ProjectType' }
      ) | null, paginatedUsersForTimeRecords: (
        { users?: Array<(
          { email?: string | null, id: string, firstName?: string | null, lastName?: string | null, jobRole?: string | null, avatar?: (
            { originalUrl?: string | null }
            & { __typename?: 'ImageType' }
          ) | null }
          & { __typename?: 'UserType' }
        )> | null, pageInfo?: (
          { totalPages?: number | null, totalResults?: number | null, currentPage?: number | null, limit?: number | null, isOutOfBounds?: boolean | null }
          & { __typename: 'PageInfoType' }
        ) | null }
        & { __typename?: 'PaginatedUsersType' }
      ), milestone?: (
        { id: string, name: string }
        & { __typename?: 'MilestoneType' }
      ) | null, timeReport: (
        { estimatedHours: number, nonBillableHours: number, billableHours: number, totalHours: number, totalCost?: number | null, totalBilled?: number | null, revenue?: number | null, allTimeUserProjectTotalHours?: number | null }
        & { __typename?: 'TimeReport' }
      ), timeRecordsPeriod?: Array<(
        { id: string, billable?: boolean | null, dateWorked?: any | null, hours?: number | null }
        & { __typename?: 'TimeRecordType' }
      )> }
      & { __typename?: 'TaskType' }
    )> | null }
    & { __typename?: 'TasksTimeReportType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type PaginatedUsersForTimeRecordsUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, jobRole?: string | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type TaskRowTaskFragment = (
  { id: string, name: string, taskType?: TaskTypeEnumType | null, dueOn?: any | null, project?: (
    { id: string, projectBillRate?: (
      { rateType?: RateTypeEnum | null }
      & { __typename?: 'ProjectBillRateType' }
    ) | null }
    & { __typename?: 'ProjectType' }
  ) | null, paginatedUsersForTimeRecords: (
    { users?: Array<(
      { email?: string | null, id: string, firstName?: string | null, lastName?: string | null, jobRole?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    )> | null, pageInfo?: (
      { totalPages?: number | null, totalResults?: number | null, currentPage?: number | null, limit?: number | null, isOutOfBounds?: boolean | null }
      & { __typename: 'PageInfoType' }
    ) | null }
    & { __typename?: 'PaginatedUsersType' }
  ), milestone?: (
    { id: string, name: string }
    & { __typename?: 'MilestoneType' }
  ) | null, timeReport: (
    { estimatedHours: number, nonBillableHours: number, billableHours: number, totalHours: number, totalCost?: number | null, totalBilled?: number | null, revenue?: number | null, allTimeUserProjectTotalHours?: number | null }
    & { __typename?: 'TimeReport' }
  ), timeRecordsPeriod?: Array<(
    { id: string, billable?: boolean | null, dateWorked?: any | null, hours?: number | null }
    & { __typename?: 'TimeRecordType' }
  )> }
  & { __typename?: 'TaskType' }
);

export type DateFieldProjectTypeFragment = (
  { id: string, organization?: (
    { id: string, disableTimeEntryForPastMonths?: boolean | null, disableTimeEntryForCompletedProjects?: boolean | null }
    & { __typename?: 'OrganizationType' }
  ) | null }
  & { __typename?: 'ProjectType' }
);

export type TimeEntryDialogProjectTypeFragment = (
  { id: string, name: string, status: StatusEnumType, projectBillRate?: (
    { id: string, rateType?: RateTypeEnum | null }
    & { __typename?: 'ProjectBillRateType' }
  ) | null, organization?: (
    { id: string, disableTimeEntryForPastMonths?: boolean | null, disableTimeEntryForCompletedProjects?: boolean | null }
    & { __typename?: 'OrganizationType' }
  ) | null }
  & { __typename?: 'ProjectType' }
);

export type TimeEntryDialogTaskTypeFragment = (
  { id: string, name: string, estimatedHours?: number | null, totalHours?: number | null, milestone?: (
    { id: string }
    & { __typename?: 'MilestoneType' }
  ) | null, project?: (
    { id: string, status: StatusEnumType, projectBillRate?: (
      { id: string, rateType?: RateTypeEnum | null }
      & { __typename?: 'ProjectBillRateType' }
    ) | null, organization?: (
      { id: string, disableTimeEntryForPastMonths?: boolean | null, disableTimeEntryForCompletedProjects?: boolean | null }
      & { __typename?: 'OrganizationType' }
    ) | null }
    & { __typename?: 'ProjectType' }
  ) | null }
  & { __typename?: 'TaskType' }
);

export type TimeEntryDialogTaskQueryVariables = Exact<{
  input: Scalars['ID'];
}>;


export type TimeEntryDialogTaskQuery = (
  { task: (
    { id: string, name: string, estimatedHours?: number | null, totalHours?: number | null, milestone?: (
      { id: string }
      & { __typename?: 'MilestoneType' }
    ) | null, project?: (
      { id: string, status: StatusEnumType, projectBillRate?: (
        { id: string, rateType?: RateTypeEnum | null }
        & { __typename?: 'ProjectBillRateType' }
      ) | null, organization?: (
        { id: string, disableTimeEntryForPastMonths?: boolean | null, disableTimeEntryForCompletedProjects?: boolean | null }
        & { __typename?: 'OrganizationType' }
      ) | null }
      & { __typename?: 'ProjectType' }
    ) | null }
    & { __typename?: 'TaskType' }
  ) }
  & { __typename?: 'Query' }
);

export type TimeEntryDialogProjectQueryVariables = Exact<{
  input: Scalars['ID'];
}>;


export type TimeEntryDialogProjectQuery = (
  { project: (
    { id: string, name: string, status: StatusEnumType, projectBillRate?: (
      { id: string, rateType?: RateTypeEnum | null }
      & { __typename?: 'ProjectBillRateType' }
    ) | null, organization?: (
      { id: string, disableTimeEntryForPastMonths?: boolean | null, disableTimeEntryForCompletedProjects?: boolean | null }
      & { __typename?: 'OrganizationType' }
    ) | null }
    & { __typename?: 'ProjectType' }
  ) }
  & { __typename?: 'Query' }
);

export type AutoFillButtonTaskTypeFragment = (
  { id: string, estimatedHours?: number | null, totalHours?: number | null }
  & { __typename?: 'TaskType' }
);

export type AutoFillButtonTaskUpdatedSubscriptionVariables = Exact<{
  taskId: Scalars['ID'];
}>;


export type AutoFillButtonTaskUpdatedSubscription = (
  { taskUpdated?: (
    { id: string, estimatedHours?: number | null, totalHours?: number | null }
    & { __typename?: 'TaskType' }
  ) | null }
  & { __typename?: 'Subscription' }
);

export type TimeFieldsTaskTypeFragment = (
  { id: string, estimatedHours?: number | null, totalHours?: number | null }
  & { __typename?: 'TaskType' }
);

export type UserSelectorDefaultUserQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type UserSelectorDefaultUserQuery = (
  { user: (
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, projectContext?: UserProjectOrganizationTypeEnumType | null, role?: UserRoleEnumType | null, jobRole?: string | null, organizationName?: string | null, skills: Array<(
      { id: string }
      & { __typename?: 'Skill' }
    )>, organization?: (
      { id: string, type?: OrganizationTypeEnumType | null, name?: string | null }
      & { __typename?: 'OrganizationType' }
    ) | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null, displayOrganization?: (
      { name: string }
      & { __typename?: 'DisplayOrganizationType' }
    ) | null }
    & { __typename?: 'UserType' }
  ) }
  & { __typename?: 'Query' }
);

export type UserSelectorPaginatedPotentialTimeAssigneeQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars['ID']>;
  milestoneId?: InputMaybe<Scalars['ID']>;
  excludeIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  listInput?: InputMaybe<ListInput>;
  responsibility?: InputMaybe<TaskResponsibilityEnumType>;
}>;


export type UserSelectorPaginatedPotentialTimeAssigneeQuery = (
  { paginatedPotentialTaskAssignees?: (
    { users?: Array<(
      { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, projectContext?: UserProjectOrganizationTypeEnumType | null, role?: UserRoleEnumType | null, jobRole?: string | null, organizationName?: string | null, skills: Array<(
        { id: string }
        & { __typename?: 'Skill' }
      )>, organization?: (
        { id: string, type?: OrganizationTypeEnumType | null, name?: string | null }
        & { __typename?: 'OrganizationType' }
      ) | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null, displayOrganization?: (
        { name: string }
        & { __typename?: 'DisplayOrganizationType' }
      ) | null }
      & { __typename?: 'UserType' }
    )> | null, pageInfo?: (
      { totalPages?: number | null, totalResults?: number | null, currentPage?: number | null, limit?: number | null, isOutOfBounds?: boolean | null }
      & { __typename: 'PageInfoType' }
    ) | null }
    & { __typename?: 'PaginatedUsersType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type TimeReportColumnsTimeReportFragment = (
  { estimatedHours: number, nonBillableHours: number, billableHours: number, totalHours: number, totalCost?: number | null, totalBilled?: number | null, revenue?: number | null, allTimeUserProjectTotalHours?: number | null }
  & { __typename?: 'TimeReport' }
);

export type TimeReportSummaryTimeReportSummaryFragment = (
  { billableHours: number, estimatedHours: number, nonBillableHours: number, totalHours?: number | null, totalCost?: number | null, totalBilled?: number | null, warning?: TimeReportWarningEnumType | null }
  & { __typename?: 'TimeReportSummary' }
);

export type TimesheetFormTimeEntrySummaryQueryVariables = Exact<{
  listInput: ListInput;
  userId: Scalars['ID'];
  startDate?: InputMaybe<Scalars['DateType']>;
  endDate?: InputMaybe<Scalars['DateType']>;
  projectId?: InputMaybe<Scalars['ID']>;
  filters?: InputMaybe<TimeEntryFiltersInput>;
}>;


export type TimesheetFormTimeEntrySummaryQuery = (
  { timeEntrySummary?: (
    { totalBillableHours: number, totalEstimatedHours: number, totalNonBillableHours: number, totalHours?: number | null, totalsLoggedPerTask?: Array<(
      { taskId?: string | null, hours?: number | null }
      & { __typename?: 'TimeEntryTotalLoggedPerTaskType' }
    )> | null, totals: Array<(
      { dateWorked: any, hours: number, billable?: boolean | null }
      & { __typename?: 'TimeEntryTotalType' }
    )> }
    & { __typename?: 'TimeEntrySummary' }
  ) | null }
  & { __typename?: 'Query' }
);

export type TimesheetFormProjectReportingListQueryVariables = Exact<{
  listInput: ListInput;
  filters: TimeReportFiltersInput;
  startDate: Scalars['DateType'];
  endDate: Scalars['DateType'];
  userId?: InputMaybe<Scalars['ID']>;
  projectId?: InputMaybe<Scalars['ID']>;
  isRootView: Scalars['Boolean'];
  includeGeneric: Scalars['Boolean'];
  includeTimeRecords: Scalars['Boolean'];
}>;


export type TimesheetFormProjectReportingListQuery = (
  { projectReportingList?: (
    { pageInfo?: (
      { totalPages?: number | null, totalResults?: number | null, currentPage?: number | null, limit?: number | null, isOutOfBounds?: boolean | null }
      & { __typename?: 'PageInfoType' }
    ) | null, projects?: Array<(
      { id: string, status: StatusEnumType, name: string, milestoneCount: number, timeReportingTasksCount?: number, projectBillRate?: (
        { rateType?: RateTypeEnum | null }
        & { __typename?: 'ProjectBillRateType' }
      ) | null, timeReport: (
        { estimatedHours: number, nonBillableHours: number, billableHours: number, totalHours: number, totalCost?: number | null, totalBilled?: number | null, revenue?: number | null, allTimeUserProjectTotalHours?: number | null }
        & { __typename?: 'TimeReport' }
      ), genericTimeReport?: (
        { estimatedHours: number, nonBillableHours: number, billableHours: number, totalHours: number, totalCost?: number | null, totalBilled?: number | null, revenue?: number | null, allTimeUserProjectTotalHours?: number | null }
        & { __typename?: 'TimeReport' }
      ), timeRecordsPeriod?: Array<(
        { id: string, billable?: boolean | null, dateWorked?: any | null, hours?: number | null }
        & { __typename?: 'TimeRecordType' }
      )> }
      & { __typename?: 'ProjectType' }
    )> | null }
    & { __typename?: 'ProjectsTimeReportType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type TimesheetHeaderPotentialTimeRecordUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type TimesheetHeaderPotentialTimeRecordUsersQuery = (
  { potentialTimeRecordUsers: Array<(
    { id: string, firstName?: string | null, lastName?: string | null, jobRole?: string | null, projectContext?: UserProjectOrganizationTypeEnumType | null, role?: UserRoleEnumType | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null, displayOrganization?: (
      { name: string }
      & { __typename?: 'DisplayOrganizationType' }
    ) | null, organization?: (
      { id: string, name?: string | null }
      & { __typename?: 'OrganizationType' }
    ) | null }
    & { __typename?: 'UserType' }
  )> }
  & { __typename?: 'Query' }
);

export type TimesheetHeaderProjectsConnectionsQueryVariables = Exact<{
  listInputs?: InputMaybe<ListInput>;
  userId?: InputMaybe<Scalars['ID']>;
}>;


export type TimesheetHeaderProjectsConnectionsQuery = (
  { projectsConnections?: (
    { projects?: Array<(
      { id: string, name: string }
      & { __typename?: 'ProjectType' }
    )> | null }
    & { __typename?: 'ProjectConnectionType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type UserAccordionUserFragment = (
  { id: string, timeReportingProjectsCount: number, firstName?: string | null, lastName?: string | null, timeReport: (
    { estimatedHours: number, nonBillableHours: number, billableHours: number, totalHours: number, totalCost?: number | null, totalBilled?: number | null, revenue?: number | null, allTimeUserProjectTotalHours?: number | null }
    & { __typename?: 'TimeReport' }
  ), avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type UserAccordionUserProjectReportingListQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']>;
  listInput?: InputMaybe<ListInput>;
  filters?: InputMaybe<TimeReportFiltersInput>;
  startDate: Scalars['DateType'];
  endDate: Scalars['DateType'];
  isRootView: Scalars['Boolean'];
  includeGeneric: Scalars['Boolean'];
  includeTimeRecords: Scalars['Boolean'];
}>;


export type UserAccordionUserProjectReportingListQuery = (
  { userProjectReportingList?: (
    { pageInfo?: (
      { totalPages?: number | null, totalResults?: number | null, currentPage?: number | null, limit?: number | null, isOutOfBounds?: boolean | null }
      & { __typename?: 'PageInfoType' }
    ) | null, projects?: Array<(
      { id: string, status: StatusEnumType, name: string, milestoneCount: number, timeReportingTasksCount?: number, projectBillRate?: (
        { rateType?: RateTypeEnum | null }
        & { __typename?: 'ProjectBillRateType' }
      ) | null, timeReport: (
        { estimatedHours: number, nonBillableHours: number, billableHours: number, totalHours: number, totalCost?: number | null, totalBilled?: number | null, revenue?: number | null, allTimeUserProjectTotalHours?: number | null }
        & { __typename?: 'TimeReport' }
      ), genericTimeReport?: (
        { estimatedHours: number, nonBillableHours: number, billableHours: number, totalHours: number, totalCost?: number | null, totalBilled?: number | null, revenue?: number | null, allTimeUserProjectTotalHours?: number | null }
        & { __typename?: 'TimeReport' }
      ), timeRecordsPeriod?: Array<(
        { id: string, billable?: boolean | null, dateWorked?: any | null, hours?: number | null }
        & { __typename?: 'TimeRecordType' }
      )> }
      & { __typename?: 'ProjectType' }
    )> | null }
    & { __typename?: 'ProjectsTimeReportType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type UserRowUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, timeReport: (
    { estimatedHours: number, nonBillableHours: number, billableHours: number, totalHours: number, totalCost?: number | null, totalBilled?: number | null, revenue?: number | null, allTimeUserProjectTotalHours?: number | null }
    & { __typename?: 'TimeReport' }
  ) }
  & { __typename?: 'UserType' }
);

export type UserScopedTableUserReportingListQueryVariables = Exact<{
  listInput: ListInput;
  filters: TimeReportFiltersInput;
  startDate: Scalars['DateType'];
  endDate: Scalars['DateType'];
  includeGeneric: Scalars['Boolean'];
}>;


export type UserScopedTableUserReportingListQuery = (
  { userReportingList?: (
    { pageInfo: (
      { totalPages?: number | null, totalResults?: number | null, currentPage?: number | null, limit?: number | null, isOutOfBounds?: boolean | null }
      & { __typename?: 'PageInfoType' }
    ), users: Array<(
      { id: string, timeReportingProjectsCount: number, firstName?: string | null, lastName?: string | null, timeReport: (
        { estimatedHours: number, nonBillableHours: number, billableHours: number, totalHours: number, totalCost?: number | null, totalBilled?: number | null, revenue?: number | null, allTimeUserProjectTotalHours?: number | null }
        & { __typename?: 'TimeReport' }
      ), avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    )> }
    & { __typename?: 'UsersTimeReportType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type AvatarUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type FileRowFileFragment = (
  { id: string, fileName: string, deletable?: boolean | null, internalOnly: boolean, isExternalHyperlink?: boolean | null, url?: string | null, uploader?: (
    { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'UserType' }
  ) | null }
  & { __typename?: 'FileType' }
);

export type FileRowUpdateFileMutationVariables = Exact<{
  updateFileInput: UpdateFileInput;
}>;


export type FileRowUpdateFileMutation = (
  { updateFile?: (
    { file?: (
      { id: string, fileName: string, deletable?: boolean | null, internalOnly: boolean, isExternalHyperlink?: boolean | null, url?: string | null, uploader?: (
        { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null }
      & { __typename?: 'FileType' }
    ) | null }
    & { __typename?: 'updateFilePayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type MultipleFileListFileFragment = (
  { id: string, url?: string | null, fileName: string, size?: number | null, milestoneName?: string | null, taskName?: string | null, createdAt?: any | null, internalOnly: boolean, deletable?: boolean | null, isExternalHyperlink?: boolean | null, uploader?: (
    { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'UserType' }
  ) | null }
  & { __typename?: 'FileType' }
);

export type MultipleFileListDeleteFileMutationVariables = Exact<{
  deleteFileInput: DeleteFileFromObjectInput;
}>;


export type MultipleFileListDeleteFileMutation = (
  { deleteFileFromObject?: (
    { files?: Array<(
      { id: string, url?: string | null, fileName: string, size?: number | null, milestoneName?: string | null, taskName?: string | null, createdAt?: any | null, internalOnly: boolean, deletable?: boolean | null, isExternalHyperlink?: boolean | null, uploader?: (
        { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null }
      & { __typename?: 'FileType' }
    ) | null> | null }
    & { __typename?: 'DeleteFileFromObjectPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ReactFormMultipleFileUploaderRemoveFileToS3MutationVariables = Exact<{
  fileKey: DeleteFileS3Input;
}>;


export type ReactFormMultipleFileUploaderRemoveFileToS3Mutation = (
  { deleteFileS3?: (
    { success?: boolean | null }
    & { __typename?: 'DeleteFileS3Payload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type FormAssigneeMultiSelectUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, jobRole?: string | null, organizationName?: string | null, organization?: (
    { id: string, name?: string | null }
    & { __typename?: 'OrganizationType' }
  ) | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, displayOrganization?: (
    { name: string }
    & { __typename?: 'DisplayOrganizationType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type UserTableRowCompanyUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, role?: UserRoleEnumType | null, status?: string | null, createdAt?: any | null, organizationName?: string | null, organization?: (
    { id: string, name?: string | null }
    & { __typename?: 'OrganizationType' }
  ) | null, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type CurrentUserContextOrganizationUpdatedSubscriptionVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type CurrentUserContextOrganizationUpdatedSubscription = (
  { organizationUpdated?: (
    { id: string, currencyCode: CurrencyCodeEnumType, countryCode: CountryCodeEnumType }
    & { __typename?: 'OrganizationType' }
  ) | null }
  & { __typename?: 'Subscription' }
);

export type CurrentUserContextCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserContextCurrentUserQuery = (
  { currentUser?: (
    { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, role?: UserRoleEnumType | null, adminTeamsEnabled?: boolean | null, createdAt?: any | null, hasAccount?: boolean | null, onlyNotificationsTeamsEnabled?: boolean | null, projectsCount?: number | null, weeklyHours: number, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null, organization?: (
      { id: string, billableRate?: number | null, brandsEnabled?: boolean | null, countryCode: CountryCodeEnumType, createdAt?: any | null, currencyCode: CurrencyCodeEnumType, customerDashboardEnabled: boolean, defaultTaskVisibility?: TaskVisibilityEnumType | null, domain?: string | null, jiraEnabled?: boolean | null, name?: string | null, pmCanEditSkills?: boolean | null, primaryColor?: string | null, resourceManagementEnabled?: boolean | null, secureLinksEnabled: boolean, taskFilterByFunction?: boolean | null, timeTrackingEnabled?: boolean | null, trial: boolean, type?: OrganizationTypeEnumType | null, whiteLabelingEnabled?: boolean | null, adminSettings: (
        { uploadLimitMb: number }
        & { __typename?: 'OrganizationAdminSettings' }
      ), logo?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null, setting: (
        { useStatusChangeReasons?: boolean | null }
        & { __typename?: 'OrganizationSetting' }
      ) }
      & { __typename?: 'OrganizationType' }
    ) | null }
    & { __typename?: 'UserType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type CurrentUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, role?: UserRoleEnumType | null, adminTeamsEnabled?: boolean | null, createdAt?: any | null, hasAccount?: boolean | null, onlyNotificationsTeamsEnabled?: boolean | null, projectsCount?: number | null, weeklyHours: number, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, organization?: (
    { id: string, billableRate?: number | null, brandsEnabled?: boolean | null, countryCode: CountryCodeEnumType, createdAt?: any | null, currencyCode: CurrencyCodeEnumType, customerDashboardEnabled: boolean, defaultTaskVisibility?: TaskVisibilityEnumType | null, domain?: string | null, jiraEnabled?: boolean | null, name?: string | null, pmCanEditSkills?: boolean | null, primaryColor?: string | null, resourceManagementEnabled?: boolean | null, secureLinksEnabled: boolean, taskFilterByFunction?: boolean | null, timeTrackingEnabled?: boolean | null, trial: boolean, type?: OrganizationTypeEnumType | null, whiteLabelingEnabled?: boolean | null, adminSettings: (
      { uploadLimitMb: number }
      & { __typename?: 'OrganizationAdminSettings' }
    ), logo?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null, setting: (
      { useStatusChangeReasons?: boolean | null }
      & { __typename?: 'OrganizationSetting' }
    ) }
    & { __typename?: 'OrganizationType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type CurrentUserProjectContextProviderProjectFragment = (
  { currentUserProjectContext?: UserProjectOrganizationTypeEnumType | null, organization?: (
    { name?: string | null, resourceManagementEnabled?: boolean | null }
    & { __typename?: 'OrganizationType' }
  ) | null }
  & { __typename?: 'ProjectType' }
);

export type DependencyConflictContextTaskDependenciesConflictQueryVariables = Exact<{
  id: Scalars['ID'];
  destinationId: Scalars['ID'];
}>;


export type DependencyConflictContextTaskDependenciesConflictQuery = (
  { taskDependenciesConflict: boolean }
  & { __typename?: 'Query' }
);

export type MaxAttachmentSizeProviderTaskQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MaxAttachmentSizeProviderTaskQuery = (
  { task: (
    { id: string, template?: (
      { organization: (
        { adminSettings: (
          { uploadLimitMb: number }
          & { __typename?: 'OrganizationAdminSettings' }
        ) }
        & { __typename?: 'OrganizationType' }
      ) }
      & { __typename?: 'TemplateType' }
    ) | null }
    & { __typename: 'TaskType' }
  ) }
  & { __typename?: 'Query' }
);

export type MaxAttachmentSizeProviderTemplateQueryVariables = Exact<{
  templateId: Scalars['ID'];
}>;


export type MaxAttachmentSizeProviderTemplateQuery = (
  { blueprintTemplate: (
    { id: string, organization: (
      { adminSettings: (
        { uploadLimitMb: number }
        & { __typename?: 'OrganizationAdminSettings' }
      ) }
      & { __typename?: 'OrganizationType' }
    ) }
    & { __typename: 'TemplateType' }
  ) }
  & { __typename?: 'Query' }
);

export type MaxAttachmentSizeProviderProjectQueryVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type MaxAttachmentSizeProviderProjectQuery = (
  { project: (
    { id: string, organization?: (
      { adminSettings: (
        { uploadLimitMb: number }
        & { __typename?: 'OrganizationAdminSettings' }
      ) }
      & { __typename?: 'OrganizationType' }
    ) | null }
    & { __typename: 'ProjectType' }
  ) }
  & { __typename?: 'Query' }
);

export type PaginatedTaskFilterContextFilterAssetsQueryVariables = Exact<{
  listInput?: InputMaybe<ListInput>;
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type PaginatedTaskFilterContextFilterAssetsQuery = (
  { paginatedCurrentUserTags?: (
    { tags?: Array<(
      { id: string, name: string, color: string }
      & { __typename?: 'TagType' }
    )> | null, pageInfo?: (
      { totalPages?: number | null, totalResults?: number | null, currentPage?: number | null, limit?: number | null, isOutOfBounds?: boolean | null }
      & { __typename: 'PageInfoType' }
    ) | null }
    & { __typename?: 'PaginatedTagsType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type TaskFilterContextFilterProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type TaskFilterContextFilterProjectsQuery = (
  { projectsConnections?: (
    { projects?: Array<(
      { id: string, name: string }
      & { __typename?: 'ProjectType' }
    )> | null }
    & { __typename?: 'ProjectConnectionType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type CustomerTaskFilterContextFilterProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerTaskFilterContextFilterProjectsQuery = (
  { projectsConnections?: (
    { projects?: Array<(
      { id: string, name: string }
      & { __typename?: 'ProjectType' }
    )> | null }
    & { __typename?: 'ProjectConnectionType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type TaskFilterContextDefaultFilterQueryVariables = Exact<{ [key: string]: never; }>;


export type TaskFilterContextDefaultFilterQuery = (
  { userDefaultFilterView?: (
    { id: string, jsonFilterBlob?: string | null }
    & { __typename?: 'UserFilterViewType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type TaskVisibilityProviderTaskFragment = (
  { id: string, responsibility: TaskResponsibilityEnumType, visibility?: TaskVisibilityEnumType | null, taskParticipants?: Array<(
    { id: string }
    & { __typename?: 'TaskParticipantType' }
  )> | null }
  & { __typename?: 'TaskType' }
);

export type EditTemplatesProjectTemplatesQueryVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type EditTemplatesProjectTemplatesQuery = (
  { project: (
    { id: string, templates?: Array<(
      { id: string }
      & { __typename?: 'TemplateType' }
    )> | null }
    & { __typename: 'ProjectType' }
  ) }
  & { __typename?: 'Query' }
);

export type ResourceUserFragment = (
  { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, role?: UserRoleEnumType | null, status?: string | null, createdAt?: any | null, jobRole?: string | null, isThirdParty: boolean, skills: Array<(
    { id: string, name: string, category: (
      { id: string }
      & { __typename?: 'SkillCategory' }
    ) }
    & { __typename?: 'Skill' }
  )>, avatar?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null }
  & { __typename?: 'UserType' }
);

export type UseResourcesUsersResourcesUsersQueryVariables = Exact<{
  listInputs?: InputMaybe<ResourcesListInput>;
  resourceFilters?: InputMaybe<ResourceFilters>;
}>;


export type UseResourcesUsersResourcesUsersQuery = (
  { resourcesUsers?: (
    { pageInfo?: (
      { totalPages?: number | null, totalResults?: number | null, currentPage?: number | null, limit?: number | null, isOutOfBounds?: boolean | null }
      & { __typename: 'PageInfoType' }
    ) | null, users?: Array<(
      { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, role?: UserRoleEnumType | null, status?: string | null, createdAt?: any | null, jobRole?: string | null, isThirdParty: boolean, skills: Array<(
        { id: string, name: string, category: (
          { id: string }
          & { __typename?: 'SkillCategory' }
        ) }
        & { __typename?: 'Skill' }
      )>, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    )> | null }
    & { __typename?: 'OrganizationConnectedUsersType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type ProjectListProjectListQueryVariables = Exact<{
  listInputs?: InputMaybe<ListInput>;
  filters: TimeReportFiltersInput;
  userId?: InputMaybe<Scalars['ID']>;
  projectId?: InputMaybe<Scalars['ID']>;
}>;


export type ProjectListProjectListQuery = (
  { projectReportingList?: (
    { pageInfo?: (
      { totalPages?: number | null, totalResults?: number | null, currentPage?: number | null, limit?: number | null, isOutOfBounds?: boolean | null }
      & { __typename: 'PageInfoType' }
    ) | null, projects?: Array<(
      { id: string, name: string, customerV2?: (
        { id: string, logo?: (
          { originalUrl?: string | null }
          & { __typename: 'ImageType' }
        ) | null }
        & { __typename: 'CustomerType' }
      ) | null }
      & { __typename: 'ProjectType' }
    )> | null }
    & { __typename?: 'ProjectsTimeReportType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type TimeEntryDialogCreateTimeRecordMutationVariables = Exact<{
  input: CreateTimeRecordInput;
}>;


export type TimeEntryDialogCreateTimeRecordMutation = (
  { createTimeRecord?: (
    { timeRecord?: (
      { id: string, dateWorked?: any | null, description?: string | null, billable?: boolean | null, hours?: number | null, taskId?: string | null, projectId: string, workerId: string, categoryId?: string | null, worker?: (
        { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null, category?: (
        { id: string, name: string }
        & { __typename?: 'TimeTrackingCategory' }
      ) | null }
      & { __typename?: 'TimeRecordType' }
    ) | null }
    & { __typename?: 'createTimeRecordPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type TimeEntryDialogUpdateTimeRecordMutationVariables = Exact<{
  input: UpdateTimeRecordInput;
}>;


export type TimeEntryDialogUpdateTimeRecordMutation = (
  { updateTimeRecord?: (
    { timeRecord?: (
      { id: string, dateWorked?: any | null, description?: string | null, billable?: boolean | null, hours?: number | null, taskId?: string | null, projectId: string, workerId: string, categoryId?: string | null, worker?: (
        { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null, category?: (
        { id: string, name: string }
        & { __typename?: 'TimeTrackingCategory' }
      ) | null }
      & { __typename?: 'TimeRecordType' }
    ) | null }
    & { __typename?: 'updateTimeRecordPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type TimeEntryDialogUpdateNodeStatusMutationVariables = Exact<{
  id: Scalars['ID'];
  status: StatusEnumType;
  objectType: StatusObjectEnumType;
}>;


export type TimeEntryDialogUpdateNodeStatusMutation = (
  { updateObjectStatus?: (
    { resolveObject?: { __typename?: 'ActionItemType' | 'ProjectType' } | (
      { id: string, status: StatusEnumType, completed?: boolean | null, completedAt?: any | null, project?: (
        { id: string, startOn?: any | null, endOn?: any | null, completedAt?: any | null, forecastedEndOn?: any | null, stats?: (
          { totalTasks: number, totalDoneTasks: number, totalAssignedTasks: number, totalTasksWithUnestimatedHoursCount?: number | null, totalActualHours?: number | null, totalInternalEstimatedHours?: number | null }
          & { __typename?: 'ProjectStats' }
        ) | null, profitabilitySummary?: (
          { forecastedCost?: number | null, budgetedCost?: number | null }
          & { __typename?: 'ProjectProfitabilitySummaryType' }
        ) | null }
        & { __typename?: 'ProjectType' }
      ) | null }
      & { __typename?: 'TaskType' }
    ) | null }
    & { __typename?: 'updateObjectStatusPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type UseFileUploaderRemoveFileToS3MutationVariables = Exact<{
  fileKey: DeleteFileS3Input;
}>;


export type UseFileUploaderRemoveFileToS3Mutation = (
  { deleteFileS3?: (
    { success?: boolean | null }
    & { __typename?: 'DeleteFileS3Payload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type UseNoteAttachmentsDeleteFileMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UseNoteAttachmentsDeleteFileMutation = (
  { deleteNoteAttachment?: (
    { note?: (
      { id: string, attachments: Array<(
        { id: string, fileName: string, url?: string | null, internalOnly: boolean }
        & { __typename?: 'FileType' }
      )> }
      & { __typename?: 'NoteType' }
    ) | null }
    & { __typename?: 'DestroyAttachmentPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type UseMergeTagsMergeTagsQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars['ID']>;
  taggable: MergeTaggable;
}>;


export type UseMergeTagsMergeTagsQuery = (
  { mergeTagOptions?: Array<(
    { id: string, name: string, slug: string, external?: boolean | null }
    & { __typename?: 'MergeTag' }
  )> | null }
  & { __typename?: 'Query' }
);

export type UseMergeTagsProjectMergeTagsQueryVariables = Exact<{
  projectId: Scalars['ID'];
  taggable: MergeTaggable;
  taggableId?: InputMaybe<Scalars['ID']>;
  customizedOnly: Scalars['Boolean'];
}>;


export type UseMergeTagsProjectMergeTagsQuery = (
  { mergeTagValues?: Array<(
    { id: string, value?: string | null, mergeTag: (
      { id: string, slug: string, name: string, external?: boolean | null }
      & { __typename?: 'MergeTag' }
    ) }
    & { __typename?: 'ProjectMergeTag' }
  )> | null }
  & { __typename?: 'Query' }
);

export type UseTaskVisibilityTaskFragment = (
  { id: string, responsibility: TaskResponsibilityEnumType, visibility?: TaskVisibilityEnumType | null, taskParticipants?: Array<(
    { id: string }
    & { __typename?: 'TaskParticipantType' }
  )> | null }
  & { __typename?: 'TaskType' }
);

export type ProjectReassignFragment = (
  { id: string, name: string, status: StatusEnumType, projectManager?: (
    { id: string, firstName?: string | null, lastName?: string | null }
    & { __typename?: 'UserType' }
  ) | null, customerV2?: (
    { id: string, logo?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'CustomerType' }
  ) | null }
  & { __typename?: 'ProjectType' }
);

export type UseUserProjectsProjectListQueryVariables = Exact<{
  projectFilters?: InputMaybe<ProjectFilters>;
  listInputs?: InputMaybe<ListInput>;
}>;


export type UseUserProjectsProjectListQuery = (
  { projectsConnections?: (
    { pageInfo?: (
      { totalPages?: number | null, totalResults?: number | null, currentPage?: number | null, limit?: number | null, isOutOfBounds?: boolean | null }
      & { __typename: 'PageInfoType' }
    ) | null, projects?: Array<(
      { id: string, name: string, status: StatusEnumType, projectManager?: (
        { id: string, firstName?: string | null, lastName?: string | null, status?: string | null }
        & { __typename?: 'UserType' }
      ) | null, customerV2?: (
        { id: string, name: string, logo?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'CustomerType' }
      ) | null }
      & { __typename?: 'ProjectType' }
    )> | null }
    & { __typename?: 'ProjectConnectionType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type TaskReassignFragment = (
  { id: string, name: string, description?: string | null, status: StatusEnumType, project?: (
    { id: string, name: string, status: StatusEnumType, organization?: (
      { id: string }
      & { __typename?: 'OrganizationType' }
    ) | null }
    & { __typename?: 'ProjectType' }
  ) | null }
  & { __typename?: 'TaskType' }
);

export type UseUserTasksUserTasksConnectionsQueryVariables = Exact<{
  userId: Scalars['ID'];
  taskFilters?: InputMaybe<TaskFilters>;
  listInputs?: InputMaybe<ListInput>;
}>;


export type UseUserTasksUserTasksConnectionsQuery = (
  { userTasksConnections?: (
    { pageInfo?: (
      { totalPages?: number | null, totalResults?: number | null, currentPage?: number | null, limit?: number | null, isOutOfBounds?: boolean | null }
      & { __typename: 'PageInfoType' }
    ) | null, tasks?: Array<(
      { id: string, name: string, description?: string | null, status: StatusEnumType, project?: (
        { id: string, name: string, status: StatusEnumType, organization?: (
          { id: string }
          & { __typename?: 'OrganizationType' }
        ) | null }
        & { __typename?: 'ProjectType' }
      ) | null }
      & { __typename?: 'TaskType' }
    )> | null }
    & { __typename?: 'TaskConnectionType' }
  ) | null }
  & { __typename?: 'Query' }
);

export type CompanyDetailLayoutOrganizationFragment = (
  { id: string, name?: string | null, domain?: string | null, deactivated?: boolean | null, logo?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null }
  & { __typename?: 'OrganizationType' }
);

export type ProjectLayoutProjectFragment = (
  { id: string, name: string, currentUserRestrictedAccess?: boolean | null, currentUserProjectContext?: UserProjectOrganizationTypeEnumType | null, creating?: boolean | null, pmDisplayRole?: string | null, pmNote?: string | null, archivedAt?: any | null, usesCategories: boolean, status: StatusEnumType, displayOrganization?: (
    { name: string, logo?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'DisplayOrganizationType' }
  ) | null, profitabilitySummary?: (
    { totalCost?: number | null, totalBilledAmount: number, totalProfit?: number | null, budgetedCost?: number | null, forecastedCost?: number | null }
    & { __typename?: 'ProjectProfitabilitySummaryType' }
  ) | null, users?: Array<(
    { id: string, firstName?: string | null, lastName?: string | null, jobRole?: string | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'UserType' }
  )> | null, projectManager?: (
    { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null }
    & { __typename?: 'UserType' }
  ) | null, organization?: (
    { name?: string | null, resourceManagementEnabled?: boolean | null, id: string, timeTrackingEnabled?: boolean | null }
    & { __typename?: 'OrganizationType' }
  ) | null }
  & { __typename?: 'ProjectType' }
);

export type ProjectLayoutProjectQueryVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type ProjectLayoutProjectQuery = (
  { project: (
    { id: string, name: string, currentUserRestrictedAccess?: boolean | null, currentUserProjectContext?: UserProjectOrganizationTypeEnumType | null, creating?: boolean | null, pmDisplayRole?: string | null, pmNote?: string | null, archivedAt?: any | null, usesCategories: boolean, status: StatusEnumType, displayOrganization?: (
      { name: string, logo?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'DisplayOrganizationType' }
    ) | null, profitabilitySummary?: (
      { totalCost?: number | null, totalBilledAmount: number, totalProfit?: number | null, budgetedCost?: number | null, forecastedCost?: number | null }
      & { __typename?: 'ProjectProfitabilitySummaryType' }
    ) | null, users?: Array<(
      { id: string, firstName?: string | null, lastName?: string | null, jobRole?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    )> | null, projectManager?: (
      { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null, organization?: (
      { name?: string | null, resourceManagementEnabled?: boolean | null, id: string, timeTrackingEnabled?: boolean | null }
      & { __typename?: 'OrganizationType' }
    ) | null }
    & { __typename?: 'ProjectType' }
  ), stats?: { __typename?: 'MilestoneStats' | 'TemplateStats' } | (
    { id: string, totalTasks: number, totalDoneTasks: number, totalAssignedTasks: number }
    & { __typename?: 'ProjectStats' }
  ) | null }
  & { __typename?: 'Query' }
);

export type ProjectLayoutUpdateProjectMutationVariables = Exact<{
  project: UpdateProjectInput;
}>;


export type ProjectLayoutUpdateProjectMutation = (
  { updateProject?: (
    { project?: (
      { id: string, name: string, currentUserRestrictedAccess?: boolean | null, currentUserProjectContext?: UserProjectOrganizationTypeEnumType | null, creating?: boolean | null, pmDisplayRole?: string | null, pmNote?: string | null, archivedAt?: any | null, usesCategories: boolean, status: StatusEnumType, displayOrganization?: (
        { name: string, logo?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'DisplayOrganizationType' }
      ) | null, profitabilitySummary?: (
        { totalCost?: number | null, totalBilledAmount: number, totalProfit?: number | null, budgetedCost?: number | null, forecastedCost?: number | null }
        & { __typename?: 'ProjectProfitabilitySummaryType' }
      ) | null, users?: Array<(
        { id: string, firstName?: string | null, lastName?: string | null, jobRole?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      )> | null, projectManager?: (
        { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null, organization?: (
        { name?: string | null, resourceManagementEnabled?: boolean | null, id: string, timeTrackingEnabled?: boolean | null }
        & { __typename?: 'OrganizationType' }
      ) | null }
      & { __typename?: 'ProjectType' }
    ) | null }
    & { __typename?: 'updateProjectPayload' }
  ) | null }
  & { __typename?: 'Mutation' }
);

export type ProjectUpdatedCsatSubscriptionVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type ProjectUpdatedCsatSubscription = (
  { projectUpdated?: (
    { project?: (
      { id: string }
      & { __typename?: 'ProjectType' }
    ) | null }
    & { __typename?: 'ProjectUpdatePayloadType' }
  ) | null }
  & { __typename?: 'Subscription' }
);

export type TemplateLayoutTemplateUpdatedSubscriptionVariables = Exact<{
  templateId: Scalars['ID'];
}>;


export type TemplateLayoutTemplateUpdatedSubscription = (
  { templateUpdated?: (
    { template?: (
      { id: string, duration?: number | null }
      & { __typename?: 'TemplateType' }
    ) | null, templateStats?: (
      { id: string, totalMilestones: number, totalTasks: number, totalCompleteTasks: number, totalPoints: number, totalEstimatedHours: number, totalInternalTasks: number, totalInternalPoints: number, totalInternalHours: number, totalCustomerTasks: number, totalCustomerPoints: number, totalCustomerHours: number, totalThirdPartyTasks: number, totalThirdPartyPoints: number, totalThirdPartyHours: number, totalAssignedTasks: number, totalActualHours: number, totalRemainingHours: number, totalInternalRemainingHours: number, totalInternalActualHours: number, totalCustomerRemainingHours: number, totalCustomerActualHours: number, totalThirdPartyRemainingHours: number, totalThirdPartyActualHours: number }
      & { __typename?: 'TemplateStats' }
    ) | null }
    & { __typename?: 'TemplateUpdatePayloadType' }
  ) | null }
  & { __typename?: 'Subscription' }
);

export type TemplateShowLayoutTemplateFragment = (
  { id: string, name: string, sku?: string | null, description?: string | null, videoUrl?: string | null, experienceOverview?: string | null, hardDependency?: boolean | null, published: boolean, videoPlaceholderImage?: (
    { originalUrl?: string | null }
    & { __typename?: 'ImageType' }
  ) | null, files?: Array<(
    { id: string, fileName: string, size?: number | null, url?: string | null, deletable?: boolean | null, internalOnly: boolean, isExternalHyperlink?: boolean | null, uploader?: (
      { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
        { originalUrl?: string | null }
        & { __typename?: 'ImageType' }
      ) | null }
      & { __typename?: 'UserType' }
    ) | null }
    & { __typename?: 'FileType' }
  )> | null }
  & { __typename?: 'TemplateType' }
);

export type TemplateShowLayoutTemplateQueryVariables = Exact<{
  templateId: Scalars['ID'];
}>;


export type TemplateShowLayoutTemplateQuery = (
  { blueprintTemplate: (
    { id: string, name: string, sku?: string | null, description?: string | null, videoUrl?: string | null, experienceOverview?: string | null, hardDependency?: boolean | null, published: boolean, videoPlaceholderImage?: (
      { originalUrl?: string | null }
      & { __typename?: 'ImageType' }
    ) | null, files?: Array<(
      { id: string, fileName: string, size?: number | null, url?: string | null, deletable?: boolean | null, internalOnly: boolean, isExternalHyperlink?: boolean | null, uploader?: (
        { id: string, firstName?: string | null, lastName?: string | null, avatar?: (
          { originalUrl?: string | null }
          & { __typename?: 'ImageType' }
        ) | null }
        & { __typename?: 'UserType' }
      ) | null }
      & { __typename?: 'FileType' }
    )> | null }
    & { __typename?: 'TemplateType' }
  ) }
  & { __typename?: 'Query' }
);

export const CustomerOrganizationFragmentDoc = gql`
    fragment CustomerOrganizationFragment on OrganizationType {
  id
  name
  users {
    id
    firstName
    lastName
  }
  logo {
    originalUrl
  }
}
    `;
export const ProjectCreatedAtFragmentDoc = gql`
    fragment ProjectCreatedAt on ProjectType {
  id
  createdAt
}
    `;
export const UpdateSkillCategoryNameFragmentDoc = gql`
    fragment UpdateSkillCategoryName on SkillCategory {
  id
  name
}
    `;
export const TemplateFilesFilePageFragmentDoc = gql`
    fragment TemplateFiles_File_Page on FileType {
  id
  url
  fileName
  size
  milestoneName
  deletable
  taskName
  uploader {
    id
    firstName
    lastName
  }
  createdAt
  internalOnly
  isExternalHyperlink
}
    `;
export const TemplateOverviewTemplateFragmentDoc = gql`
    fragment TemplateOverview_Template on TemplateType {
  id
  experienceOverview
  videoUrl
  description
  sku
  duration
  published
  videoPlaceholderImage {
    originalUrl
  }
  files {
    id
  }
  organization {
    id
    name
  }
}
    `;
export const TemplateOverviewTemplateStatsFragmentDoc = gql`
    fragment TemplateOverview_TemplateStats on TemplateStats {
  id
  totalMilestones
  totalTasks
  totalCompleteTasks
  totalPoints
  totalEstimatedHours
  totalInternalTasks
  totalInternalPoints
  totalInternalHours
  totalCustomerTasks
  totalCustomerPoints
  totalCustomerHours
  totalThirdPartyTasks
  totalThirdPartyPoints
  totalThirdPartyHours
  totalAssignedTasks
  totalActualHours
  totalRemainingHours
  totalInternalRemainingHours
  totalInternalActualHours
  totalCustomerRemainingHours
  totalCustomerActualHours
  totalThirdPartyRemainingHours
  totalThirdPartyActualHours
}
    `;
export const UserTableRowCompanyUserFragmentDoc = gql`
    fragment UserTableRowCompanyUser on UserType {
  id
  firstName
  lastName
  email
  role
  status
  createdAt
  organization {
    id
    name
  }
  organizationName
  avatar {
    originalUrl
  }
}
    `;
export const CompanyUsersFragmentDoc = gql`
    fragment CompanyUsers on UserType {
  id
  ...UserTableRowCompanyUser
}
    ${UserTableRowCompanyUserFragmentDoc}`;
export const MissingTimeEntriesCardTaskFragmentDoc = gql`
    fragment MissingTimeEntriesCard_Task on PublicTask {
  id
  project {
    id
    displayOrganization {
      name
      logo {
        originalUrl
      }
    }
    customer {
      id
      name
      logo {
        originalUrl
      }
    }
    projectType
  }
  milestone {
    id
  }
  template {
    id
  }
}
    `;
export const TaskActionsTaskFragmentDoc = gql`
    fragment TaskActions_Task on PublicTask {
  id
  responsibility
  name
  description
  assignee {
    firstName
    lastName
  }
  project {
    id
    pmDisplayRole: managerDisplayRole
    organization {
      id
      name
      logo {
        originalUrl
      }
    }
    projectManager: manager {
      id
      firstName
      lastName
    }
    displayOrganization {
      name
      logo {
        originalUrl
      }
    }
    customer {
      id
      name
      logo {
        originalUrl
      }
    }
  }
  ...MissingTimeEntriesCard_Task
}
    ${MissingTimeEntriesCardTaskFragmentDoc}`;
export const AddCustomerPromptProjectFragmentDoc = gql`
    fragment AddCustomerPrompt_Project on ProjectType {
  id
  creating
  customerV2 {
    name
    id
  }
}
    `;
export const AddCustomerPromptAProjectFragmentDoc = gql`
    fragment AddCustomerPromptA_Project on ProjectType {
  id
  organization {
    id
    logo {
      originalUrl
    }
  }
  projectManager {
    id
    avatar {
      originalUrl
    }
  }
}
    `;
export const ChangeStatusTaskReturnFragmentDoc = gql`
    fragment ChangeStatus_TaskReturn on TaskReturnType {
  task {
    id
    status
  }
}
    `;
export const ChangeStatusDropdownTemplateFragmentDoc = gql`
    fragment ChangeStatusDropdown_Template on TemplateType {
  milestones {
    id
    sortOrder
    tasks {
      id
    }
    __typename
  }
  __typename
}
    `;
export const SubtaskFragmentDoc = gql`
    fragment SubtaskFragment on SubtaskType {
  id
  name
  richName
  done
  sortOrder
  groupId
}
    `;
export const ChecklistItemsTaskFragmentDoc = gql`
    fragment ChecklistItems_Task on TaskType {
  id
  assignee {
    id
  }
}
    `;
export const ChecklistTaskFragmentDoc = gql`
    fragment Checklist_Task on TaskType {
  id
  responsibility
  assignee {
    id
  }
  subtasks {
    id
    ...SubtaskFragment
  }
  subtasksGroups {
    id
    name
  }
  watchers {
    id
  }
  ...ChecklistItems_Task
}
    ${SubtaskFragmentDoc}
${ChecklistItemsTaskFragmentDoc}`;
export const CustomerMenuOptionCustomerFragmentDoc = gql`
    fragment CustomerMenuOption_Customer on CustomerType {
  id
  name
  email
  logo {
    originalUrl
  }
}
    `;
export const AvailableLicensesOrganizationFragmentDoc = gql`
    fragment AvailableLicenses_Organization on OrganizationType {
  id
  resourceManagementEnabled
  billableUsersCount
  maxBillableUsers
  ratePerUser
  type
}
    `;
export const SetDeactivatedOnUserDialogUserFragmentDoc = gql`
    fragment SetDeactivatedOnUserDialogUser on UserType {
  id
  firstName
  lastName
  email
  deactivated
}
    `;
export const SkillsSelectSkillFragmentDoc = gql`
    fragment SkillsSelect_Skill on Skill {
  id
  name
  __typename
}
    `;
export const SkillsSelectUserFragmentDoc = gql`
    fragment SkillsSelect_User on UserType {
  id
  skills {
    id
    ...SkillsSelect_Skill
  }
  organization {
    id
    resourceManagementEnabled
    skillCategories {
      id
      name
      skills {
        ...SkillsSelect_Skill
        category {
          id
        }
      }
    }
  }
}
    ${SkillsSelectSkillFragmentDoc}`;
export const EditUserFormUserFragmentDoc = gql`
    fragment EditUserForm_User on UserType {
  id
  email
  firstName
  lastName
  phone
  jobRole
  role
  bio
  capacity
  hideEmail
  hidePhone
  calendarLink
  meetingLink
  deactivated
  status
  shouldDisableEmail
  costRate
  avatar {
    originalUrl
  }
  costRateHistory {
    costRate
    date
  }
  organization {
    id
    timeTrackingEnabled
    ...AvailableLicenses_Organization
  }
  ...SetDeactivatedOnUserDialogUser
  ...SkillsSelect_User
}
    ${AvailableLicensesOrganizationFragmentDoc}
${SetDeactivatedOnUserDialogUserFragmentDoc}
${SkillsSelectUserFragmentDoc}`;
export const NotificationsFormUserFragmentDoc = gql`
    fragment NotificationsForm_User on UserType {
  id
  role
  notificationPreferences {
    projectOverviewEmailPref
    taskReminderEmailPref
    milestoneCompletedEmailPref
    milestoneCompletedPref
    taskGroupCompletedEmailPref
    taskGroupCompletedPref
    taskUpdatedEmailPref
    taskUpdatedPref
    taskUpdatedDaysPref
    overdueEmailPref
    overduePref
    stuckEmailPref
    stuckPref
    doneEmailPref
    donePref
    allTasksCompletedPref
    allTasksCompletedEmailPref
    idleProjectDaysPref
    unsubscribeFromAllEmails
    projectRunningLatePref
    projectRunningLateEmailPref
    taskStartedUnassignedPref
    taskStartedUnassignedEmailPref
    groupedTaskCompletedPref
    groupedTaskCompletedEmailPref
    unaddressedNoteEmailPref
    unaddressedNotePref
  }
}
    `;
export const FormTagMultiSelectTagFragmentDoc = gql`
    fragment FormTagMultiSelect_Tag on TagType {
  id
  name
  color
}
    `;
export const AvatarUserFragmentDoc = gql`
    fragment Avatar_User on UserType {
  id
  firstName
  lastName
  avatar {
    originalUrl
  }
}
    `;
export const FileRowFileFragmentDoc = gql`
    fragment FileRow_File on FileType {
  id
  fileName
  deletable
  internalOnly
  isExternalHyperlink
  uploader {
    id
    firstName
    lastName
    ...Avatar_User
  }
  url
}
    ${AvatarUserFragmentDoc}`;
export const MultipleFileListFileFragmentDoc = gql`
    fragment MultipleFileList_File on FileType {
  id
  url
  fileName
  size
  milestoneName
  taskName
  createdAt
  internalOnly
  uploader {
    id
    firstName
    lastName
    avatar {
      originalUrl
    }
  }
  ...FileRow_File
}
    ${FileRowFileFragmentDoc}`;
export const AttachmentsFileFragmentDoc = gql`
    fragment Attachments_File on FileType {
  id
  sortOrder
  ...MultipleFileList_File
}
    ${MultipleFileListFileFragmentDoc}`;
export const ContributorFieldsProjectFragmentDoc = gql`
    fragment ContributorFields_Project on ProjectType {
  id
  pmDisplayRole
  projectManager {
    id
    firstName
    lastName
  }
}
    `;
export const TaskFormContextTaskFragmentDoc = gql`
    fragment TaskFormContext_Task on TaskType {
  id
  actualHours
  billableHours
  nonBillableHours
  assignmentEmailSentAt
  completedAt
  currentUserTaskContext
  description
  dueOn
  duration
  estimatedHours
  estimatedPoints
  eventDatetime
  eventInformation
  invitationGroupSentAt
  meetingLength
  mustStartOn
  mustStartOnRequired
  jiraTaskLink
  name
  participantCallToAction
  priority
  responsibility
  shouldWarnUpdateStatus
  signOffRequired
  sortOrder
  startOn
  status
  taskType
  visibility
  jiraSync
  tags {
    id
  }
  skill {
    id
  }
  skills {
    id
  }
  assignee {
    id
    firstName
    lastName
    calendarLink
    meetingLink
    role
    projectContext
    avatar {
      originalUrl
    }
  }
  creator {
    id
  }
  signer {
    id
    firstName
    lastName
    email
  }
  jiraTask {
    id
    externalId
    externalProjectId
    externalTypeId
    components
    createdInJira
  }
  files {
    id
    ...Attachments_File
  }
  milestone {
    id
    sortOrder
    isFirstOfTemplate
    isFirstOfProject
    template {
      id
      hardDependency
    }
  }
  project {
    id
    name
    status
    currentUserProjectContext
    projectManager {
      id
      firstName
      lastName
      calendarLink
      meetingLink
    }
    organization {
      id
      name
      defaultTaskVisibility
      timeTrackingEnabled
      resourceManagementEnabled
      internalNotesDefault
    }
    customerV2 {
      id
      name
    }
    pmDisplayRole
    ...ContributorFields_Project
  }
  dependency {
    ... on MilestoneType {
      id
      name
      completed
    }
    ... on TaskType {
      id
      name
      completed
      shouldWarnUpdateStatus
    }
    ... on TemplateType {
      id
      name
      completed
    }
    ... on TaskGroupType {
      id
      name
      completed
    }
  }
  subtasks {
    id
    name
    richName
    done
    sortOrder
    groupId
  }
  subtasksGroups {
    id
    name
  }
  watchers {
    id
  }
  taskParticipants {
    id
    completed
    invitationSentAt
    user {
      id
      firstName
      lastName
      email
      jobRole
      capacity
      projectsCount
      projectContext
      organization {
        id
        name
      }
      organizationName
      avatar {
        originalUrl
      }
      displayOrganization {
        name
      }
    }
  }
  participantsSelectAll {
    internal
    customer
    thirdParty
    __typename
  }
  taskGroup {
    id
  }
}
    ${AttachmentsFileFragmentDoc}
${ContributorFieldsProjectFragmentDoc}`;
export const EditTaskDrawerTaskFragmentDoc = gql`
    fragment EditTaskDrawer_Task on TaskType {
  id
  ...TaskFormContext_Task
}
    ${TaskFormContextTaskFragmentDoc}`;
export const MyTasksEditTaskDrawerProjectSnapshotFragmentDoc = gql`
    fragment MyTasksEditTaskDrawer_ProjectSnapshotFragment on ProjectType {
  id
  startOn
  endOn
  completedAt
  forecastedEndOn
}
    `;
export const MyTasksEditTaskDrawerProjectStatsFragmentDoc = gql`
    fragment MyTasksEditTaskDrawer_ProjectStatsFragment on ProjectStats {
  totalTasks
  totalDoneTasks
  totalAssignedTasks
  totalTasksWithUnestimatedHoursCount
  totalActualHours
  totalInternalEstimatedHours
}
    `;
export const PaginatedTagMultiSelectTagFragmentDoc = gql`
    fragment PaginatedTagMultiSelect_Tag on TagType {
  id
  name
  color
}
    `;
export const ProjectManagerCardProjectFragmentDoc = gql`
    fragment ProjectManagerCard_Project on ProjectType {
  id
  pmDisplayRole
  pmNote
  pmNoteInternalOnly
  currentUserProjectContext
  projectManager {
    id
    firstName
    calendarLink
    lastName
    phone
    email
    bio
    avatar {
      originalUrl
    }
  }
}
    `;
export const SummaryCardProjectFragmentDoc = gql`
    fragment SummaryCard_Project on ProjectType {
  id
  firstActiveTemplate
  currentUserProjectContext
  status
  startOn
  endOn
  completedAt
  forecastedEndOn
  displayOrganization {
    name
    logo {
      originalUrl
    }
  }
  customerV2 {
    id
    name
    logo {
      originalUrl
    }
  }
  projectType
  templates {
    id
    name
    milestones {
      id
      name
      active
    }
  }
  files {
    id
  }
  tags {
    id
    color
    name
    internalOnly
  }
  organization {
    id
    showShareableLink
  }
}
    `;
export const SummaryCardProjectStatsFragmentDoc = gql`
    fragment SummaryCard_ProjectStats on ProjectStats {
  id
  totalTasks
  totalDoneTasks
  totalSignOffTasks
  totalStuckTasks
  totalWorkingOnItTasks
  totalNotStartedTasks
  totalAssignedTasks
  totalCustomerOverdueTasks
  totalThirdPartyOverdueTasks
  totalInternalOverdueTasks
}
    `;
export const ProjectPlanProjectSnapshotFragmentDoc = gql`
    fragment ProjectPlan_ProjectSnapshotFragment on ProjectType {
  id
  startOn
  endOn
  completedAt
  forecastedEndOn
}
    `;
export const ProjectPlanProjectStatsFragmentDoc = gql`
    fragment ProjectPlan_ProjectStatsFragment on ProjectStats {
  totalTasks
  totalDoneTasks
  totalAssignedTasks
  totalTasksWithUnestimatedHoursCount
  totalActualHours
  totalInternalEstimatedHours
}
    `;
export const ProjectTemplateHoverInfoSummaryBankFragmentDoc = gql`
    fragment ProjectTemplateHoverInfo_SummaryBank on TemplateStats {
  totalCompleteTasks
  totalTasks
  totalAssignedTasks
  totalActualHours
  totalEstimatedHours
  totalRemainingHours
  totalInternalHours
  totalCustomerHours
  totalThirdPartyHours
  totalInternalRemainingHours
  totalInternalActualHours
  totalCustomerRemainingHours
  totalCustomerActualHours
  totalThirdPartyRemainingHours
  totalThirdPartyActualHours
  totalInternalLoggedHours
  totalInternalLoggedBillableHours
  totalInternalLoggedNonBillableHours
  totalInternalRemainingPurchasedHours
}
    `;
export const ProjectBulkEditFormTemplateFragmentDoc = gql`
    fragment ProjectBulkEditForm_Template on TemplateType {
  id
  organization {
    id
  }
}
    `;
export const ProjectBulkEditDrawerTemplateFragmentDoc = gql`
    fragment ProjectBulkEditDrawer_Template on TemplateType {
  id
  ...ProjectBulkEditForm_Template
}
    ${ProjectBulkEditFormTemplateFragmentDoc}`;
export const ProjectPlanTemplateFragmentDoc = gql`
    fragment ProjectPlan_Template on TemplateType {
  id
  name
  sortOrder
  active
  hardDependency
  completedAt
  summaryBank {
    totalCompleteTasks
    totalTasks
    ...ProjectTemplateHoverInfo_SummaryBank
  }
  ...ProjectBulkEditDrawer_Template
}
    ${ProjectTemplateHoverInfoSummaryBankFragmentDoc}
${ProjectBulkEditDrawerTemplateFragmentDoc}`;
export const ProjectBulkEditFormProjectFragmentDoc = gql`
    fragment ProjectBulkEditForm_Project on ProjectType {
  id
  organization {
    resourceManagementEnabled
  }
}
    `;
export const ProjectBulkEditDrawerProjectFragmentDoc = gql`
    fragment ProjectBulkEditDrawer_Project on ProjectType {
  id
  ...ProjectBulkEditForm_Project
}
    ${ProjectBulkEditFormProjectFragmentDoc}`;
export const ProjectTemplateHoverInfoProjectFragmentDoc = gql`
    fragment ProjectTemplateHoverInfo_Project on ProjectType {
  id
  projectBillRate {
    rateType
    hours
  }
  organization {
    timeTrackingEnabled
  }
}
    `;
export const ProjectPlanProjectFragmentDoc = gql`
    fragment ProjectPlan_Project on ProjectType {
  id
  creating
  firstActiveTemplate
  pmDisplayRole
  organization {
    id
    defaultTaskVisibility
  }
  templates {
    id
    ...ProjectPlan_Template
  }
  deletedAt
  archivedAt
  status
  ...ProjectBulkEditDrawer_Project
  ...ProjectTemplateHoverInfo_Project
}
    ${ProjectPlanTemplateFragmentDoc}
${ProjectBulkEditDrawerProjectFragmentDoc}
${ProjectTemplateHoverInfoProjectFragmentDoc}`;
export const ProjectPlanStatsFragmentDoc = gql`
    fragment ProjectPlan_Stats on Stats {
  ... on ProjectStats {
    id
    totalTasks
    totalDoneTasks
    totalSignOffTasks
    totalStuckTasks
    totalWorkingOnItTasks
    totalNotStartedTasks
    totalAssignedTasks
    totalCustomerOverdueTasks
    totalThirdPartyOverdueTasks
    totalInternalOverdueTasks
  }
}
    `;
export const UserMenuOptionUserFragmentDoc = gql`
    fragment UserMenuOption_User on UserType {
  id
  firstName
  lastName
  jobRole
  organization {
    id
    name
  }
  organizationName
  avatar {
    originalUrl
  }
  displayOrganization {
    name
  }
}
    `;
export const AssigneeFieldUserFragmentDoc = gql`
    fragment AssigneeField_User on UserType {
  id
  firstName
  lastName
  email
  projectContext
  role
  skills {
    id
  }
  organization {
    id
    type
  }
  ...UserMenuOption_User
}
    ${UserMenuOptionUserFragmentDoc}`;
export const TemplateBulkEditFormUserFragmentDoc = gql`
    fragment TemplateBulkEditForm_User on UserType {
  id
  ...AssigneeField_User
}
    ${AssigneeFieldUserFragmentDoc}`;
export const TemplateBulkEditDrawerUserFragmentDoc = gql`
    fragment TemplateBulkEditDrawer_User on UserType {
  id
  ...TemplateBulkEditForm_User
}
    ${TemplateBulkEditFormUserFragmentDoc}`;
export const ProjectPlanUserFragmentDoc = gql`
    fragment ProjectPlan_User on UserType {
  id
  ...TemplateBulkEditDrawer_User
}
    ${TemplateBulkEditDrawerUserFragmentDoc}`;
export const ProjectBulkEditFormUserFragmentDoc = gql`
    fragment ProjectBulkEditForm_User on UserType {
  id
  ...AssigneeField_User
}
    ${AssigneeFieldUserFragmentDoc}`;
export const ProjectBulkEditDrawerUserFragmentDoc = gql`
    fragment ProjectBulkEditDrawer_User on UserType {
  id
  ...ProjectBulkEditForm_User
}
    ${ProjectBulkEditFormUserFragmentDoc}`;
export const BulkEditFormUserFragmentDoc = gql`
    fragment BulkEditForm_User on UserType {
  id
  skills {
    id
    ...SkillsSelect_Skill
  }
  organization {
    id
    resourceManagementEnabled
    skillCategories {
      id
      name
      skills {
        ...SkillsSelect_Skill
        category {
          id
        }
      }
    }
  }
}
    ${SkillsSelectSkillFragmentDoc}`;
export const AssigneeSelectUserFragmentDoc = gql`
    fragment AssigneeSelect_User on UserType {
  id
  firstName
  lastName
  email
  projectContext
  role
  skills {
    id
  }
  organization {
    id
    type
  }
  ...UserMenuOption_User
}
    ${UserMenuOptionUserFragmentDoc}`;
export const PaginatedAssigneeSelectUserFragmentDoc = gql`
    fragment PaginatedAssigneeSelect_User on UserType {
  id
  firstName
  lastName
  email
  projectContext
  skills {
    id
  }
  ...UserMenuOption_User
}
    ${UserMenuOptionUserFragmentDoc}`;
export const ProjectHeaderMenuTaskFragmentDoc = gql`
    fragment ProjectHeaderMenu_Task on TaskType {
  id
  name
  status
  sortOrder
  responsibility
  taskType
  assignee {
    id
  }
  milestone {
    id
  }
}
    `;
export const ProjectTaskCardHeaderTaskFragmentDoc = gql`
    fragment ProjectTaskCardHeader_Task on TaskType {
  id
  name
  taskType
  status
  milestone {
    id
  }
  ...ProjectHeaderMenu_Task
}
    ${ProjectHeaderMenuTaskFragmentDoc}`;
export const ChangeStatusDropdownTaskFragmentDoc = gql`
    fragment ChangeStatusDropdown_Task on TaskType {
  id
  dependentTasks {
    id
  }
  milestone {
    id
    sortOrder
    dependentTasks {
      id
    }
  }
}
    `;
export const ProjectStatusDropDownTaskFragmentDoc = gql`
    fragment ProjectStatusDropDown_Task on TaskType {
  id
  status
  taskType
  signOffRequired
  shouldWarnUpdateStatus
  taskGroup {
    id
  }
  template {
    id
    hardDependency
  }
  assignee {
    id
  }
  dependency {
    ... on MilestoneType {
      id
      completed
    }
    ... on TaskType {
      id
      completed
    }
    ... on TemplateType {
      id
      completed
    }
    ... on TaskGroupType {
      id
      completed
    }
  }
  ...ChangeStatusDropdown_Task
}
    ${ChangeStatusDropdownTaskFragmentDoc}`;
export const ProjectTaskInsightsTaskFragmentDoc = gql`
    fragment ProjectTaskInsights_Task on TaskType {
  id
  taskType
  completeSubtasksCount
  incompleteSubtasksCount
  actionItemsCount
  internalNotesCount
  publicNotesCount
  internalFilesCount
  publicFilesCount
  taskParticipants {
    id
    completed
    user {
      id
      firstName
      lastName
      avatar {
        originalUrl
      }
    }
  }
  assignee {
    id
  }
}
    `;
export const ProjectTaskBodyFooterTaskFragmentDoc = gql`
    fragment ProjectTaskBodyFooter_Task on TaskType {
  id
  name
  taskType
  responsibility
  visibility
  signOffRequired
  invitationGroupSentAt
  eventDatetime
  eventInformation
  participantCallToAction
  shouldWarnUpdateStatus
  currentUserTaskContext
  assignee {
    id
  }
  taskParticipants {
    id
    invitationSentAt
  }
  dependency {
    ... on MilestoneType {
      id
      completed
    }
    ... on TaskType {
      id
      completed
    }
    ... on TemplateType {
      id
      completed
    }
    ... on TaskGroupType {
      id
      completed
    }
  }
}
    `;
export const ProjectTaskCardBodyTaskFragmentDoc = gql`
    fragment ProjectTaskCardBody_Task on TaskType {
  id
  taskType
  signOffRequired
  signer {
    id
    firstName
    lastName
    email
  }
  assignee {
    id
  }
  ...ProjectStatusDropDown_Task
  ...ProjectTaskInsights_Task
  ...ProjectTaskBodyFooter_Task
}
    ${ProjectStatusDropDownTaskFragmentDoc}
${ProjectTaskInsightsTaskFragmentDoc}
${ProjectTaskBodyFooterTaskFragmentDoc}`;
export const DependencyIconTaskFragmentDoc = gql`
    fragment DependencyIcon_Task on TaskType {
  id
  name
  completed
  shouldWarnUpdateStatus
  visibility
  dueOn
  __typename
}
    `;
export const DependencyIconMilestoneFragmentDoc = gql`
    fragment DependencyIcon_Milestone on MilestoneType {
  id
  name
  completed
  forecastedEndOn
  __typename
}
    `;
export const DependencyIconTemplateFragmentDoc = gql`
    fragment DependencyIcon_Template on TemplateType {
  id
  name
  completed
  __typename
}
    `;
export const DependencyIconTaskGroupFragmentDoc = gql`
    fragment DependencyIcon_TaskGroup on TaskGroupType {
  id
  name
  completed
  forecastedEndOn
  __typename
}
    `;
export const TagsBarTagFragmentDoc = gql`
    fragment TagsBar_Tag on TagType {
  id
  color
  name
  internalOnly
}
    `;
export const AssigneeAvatarUserFragmentDoc = gql`
    fragment AssigneeAvatar_User on UserType {
  id
  firstName
  lastName
  email
  jobRole
  avatar {
    originalUrl
  }
}
    `;
export const ProjectTaskCardFooterDatesTaskFragmentDoc = gql`
    fragment ProjectTaskCardFooterDates_Task on TaskType {
  id
  name
  taskType
  meetingLength
  eventDatetime
  dueOn
  startOn
  duration
  completedAt
  completed
  dependency {
    ... on MilestoneType {
      id
      completed
      forecastedEndOn
    }
    ... on TaskType {
      id
      completed
      dueOn
    }
    ... on TemplateType {
      id
      completed
    }
    ... on TaskGroupType {
      id
      completed
      forecastedEndOn
    }
  }
}
    `;
export const ProjectTaskCardFooterTaskFragmentDoc = gql`
    fragment ProjectTaskCardFooter_Task on TaskType {
  id
  dependency {
    ...DependencyIcon_Task
    ...DependencyIcon_Milestone
    ...DependencyIcon_Template
    ...DependencyIcon_TaskGroup
  }
  tags {
    ...TagsBar_Tag
  }
  assignee {
    ...AssigneeAvatar_User
  }
  ...ProjectTaskCardFooterDates_Task
}
    ${DependencyIconTaskFragmentDoc}
${DependencyIconMilestoneFragmentDoc}
${DependencyIconTemplateFragmentDoc}
${DependencyIconTaskGroupFragmentDoc}
${TagsBarTagFragmentDoc}
${AssigneeAvatarUserFragmentDoc}
${ProjectTaskCardFooterDatesTaskFragmentDoc}`;
export const ProjectPlanTaskCardTaskFragmentDoc = gql`
    fragment ProjectPlanTaskCard_Task on TaskType {
  id
  status
  visibility
  responsibility
  template {
    id
  }
  ...ProjectTaskCardHeader_Task
  ...ProjectTaskCardBody_Task
  ...ProjectTaskCardFooter_Task
}
    ${ProjectTaskCardHeaderTaskFragmentDoc}
${ProjectTaskCardBodyTaskFragmentDoc}
${ProjectTaskCardFooterTaskFragmentDoc}`;
export const UseTaskVisibilityTaskFragmentDoc = gql`
    fragment UseTaskVisibility_Task on TaskType {
  id
  responsibility
  visibility
  taskParticipants {
    id
  }
}
    `;
export const TaskVisibilityProviderTaskFragmentDoc = gql`
    fragment TaskVisibilityProvider_Task on TaskType {
  id
  ...UseTaskVisibility_Task
}
    ${UseTaskVisibilityTaskFragmentDoc}`;
export const ProjectMilestoneColumnTaskFragmentDoc = gql`
    fragment ProjectMilestoneColumn_Task on TaskType {
  id
  ...ProjectPlanTaskCard_Task
  ...TaskVisibilityProvider_Task
}
    ${ProjectPlanTaskCardTaskFragmentDoc}
${TaskVisibilityProviderTaskFragmentDoc}`;
export const ProjectMilestoneBoardTaskFragmentDoc = gql`
    fragment ProjectMilestoneBoard_Task on TaskType {
  id
  ...ProjectMilestoneColumn_Task
}
    ${ProjectMilestoneColumnTaskFragmentDoc}`;
export const MilestoneTasksFragmentDoc = gql`
    fragment milestoneTasks on MilestoneType {
  tasksAndGroups {
    ... on TaskType {
      id
      sortOrder
    }
    ... on TaskGroupType {
      id
      sortOrder
    }
  }
}
    `;
export const ProjectAddTaskDrawerTaskFragmentDoc = gql`
    fragment ProjectAddTaskDrawer_Task on TaskType {
  id
  ...TaskFormContext_Task
}
    ${TaskFormContextTaskFragmentDoc}`;
export const ProjectPlanEditTaskDrawerProjectSnapshotFragmentDoc = gql`
    fragment ProjectPlanEditTaskDrawer_ProjectSnapshotFragment on ProjectType {
  id
  startOn
  endOn
  completedAt
  forecastedEndOn
}
    `;
export const ProjectPlanEditTaskDrawerProjectStatsFragmentDoc = gql`
    fragment ProjectPlanEditTaskDrawer_ProjectStatsFragment on ProjectStats {
  totalTasks
  totalDoneTasks
  totalAssignedTasks
  totalTasksWithUnestimatedHoursCount
  totalActualHours
  totalInternalEstimatedHours
}
    `;
export const MilestoneColumnProjectSnapshotFragmentDoc = gql`
    fragment MilestoneColumn_ProjectSnapshotFragment on ProjectType {
  id
  startOn
  endOn
  completedAt
  forecastedEndOn
}
    `;
export const MilestoneColumnProjectStatsFragmentDoc = gql`
    fragment MilestoneColumn_ProjectStatsFragment on ProjectStats {
  totalTasks
  totalDoneTasks
  totalAssignedTasks
  totalTasksWithUnestimatedHoursCount
  totalActualHours
  totalInternalEstimatedHours
}
    `;
export const ProjectMilestoneHeaderMilestoneStatsFragmentDoc = gql`
    fragment ProjectMilestoneHeader_MilestoneStats on MilestoneStats {
  id
  totalTasks
  totalCompleteTasks
  totalRemainingTasks
  duration
}
    `;
export const UngroupedTasksFragmentDoc = gql`
    fragment ungroupedTasks on TaskGroupType {
  tasks {
    id
  }
}
    `;
export const ProjectMilestoneHeaderMilestoneFragmentDoc = gql`
    fragment ProjectMilestoneHeader_Milestone on MilestoneType {
  id
  name
  startedOn
  forecastedEndOn
  completedAt
  completed
  active
  sortOrder
  summaryBank {
    id
    totalTasks
    totalCompleteTasks
    totalRemainingTasks
    duration
  }
  dependentTasks {
    id
  }
  template {
    id
    hardDependency
  }
}
    `;
export const ProjectTaskGroupCardTaskGroupFragmentDoc = gql`
    fragment ProjectTaskGroupCard_TaskGroup on TaskGroupType {
  id
  name
  taskCount
  __typename
  sortOrder
  startedOn
  forecastedEndOn
  completedAt
  completed
  summaryBank {
    id
    totalTasks
    totalCompleteTasks
    totalRemainingTasks
    duration
  }
  tasks {
    ...ProjectPlanTaskCard_Task
    ...TaskVisibilityProvider_Task
    taskGroup {
      id
    }
  }
}
    ${ProjectPlanTaskCardTaskFragmentDoc}
${TaskVisibilityProviderTaskFragmentDoc}`;
export const ProjectMilestoneColumnMilestoneFragmentDoc = gql`
    fragment ProjectMilestoneColumn_Milestone on MilestoneType {
  id
  template {
    id
    hardDependency
  }
  ...ProjectMilestoneHeader_Milestone
  tasksAndGroups {
    ... on TaskType {
      id
      ...ProjectPlanTaskCard_Task
      ...TaskVisibilityProvider_Task
    }
    ... on TaskGroupType {
      ...ProjectTaskGroupCard_TaskGroup
    }
  }
}
    ${ProjectMilestoneHeaderMilestoneFragmentDoc}
${ProjectPlanTaskCardTaskFragmentDoc}
${TaskVisibilityProviderTaskFragmentDoc}
${ProjectTaskGroupCardTaskGroupFragmentDoc}`;
export const ProjectMilestoneColumnTaskGroupFragmentDoc = gql`
    fragment ProjectMilestoneColumn_TaskGroup on TaskGroupType {
  id
  ...ProjectTaskGroupCard_TaskGroup
}
    ${ProjectTaskGroupCardTaskGroupFragmentDoc}`;
export const ProjectMilestoneBoardMilestoneFragmentDoc = gql`
    fragment ProjectMilestoneBoard_Milestone on MilestoneType {
  id
  sortOrder
  ...ProjectMilestoneColumn_Milestone
  tasksAndGroups {
    ... on TaskType {
      id
      sortOrder
      ...ProjectMilestoneColumn_Task
    }
    ... on TaskGroupType {
      ...ProjectMilestoneColumn_TaskGroup
      tasks {
        id
        sortOrder
        ...ProjectMilestoneColumn_Task
      }
    }
  }
}
    ${ProjectMilestoneColumnMilestoneFragmentDoc}
${ProjectMilestoneColumnTaskFragmentDoc}
${ProjectMilestoneColumnTaskGroupFragmentDoc}`;
export const ProjectBulkEditFormMilestoneFragmentDoc = gql`
    fragment ProjectBulkEditForm_Milestone on MilestoneType {
  id
}
    `;
export const ProjectBulkEditDrawerMilestoneFragmentDoc = gql`
    fragment ProjectBulkEditDrawer_Milestone on MilestoneType {
  id
  ...ProjectBulkEditForm_Milestone
}
    ${ProjectBulkEditFormMilestoneFragmentDoc}`;
export const ProjectBulkEditFormTaskFragmentDoc = gql`
    fragment ProjectBulkEditForm_Task on TaskType {
  id
  status
  priority
  responsibility
  taskType
  visibility
  completedAt
}
    `;
export const ProjectBulkEditDrawerTaskFragmentDoc = gql`
    fragment ProjectBulkEditDrawer_Task on TaskType {
  id
  ...ProjectBulkEditForm_Task
}
    ${ProjectBulkEditFormTaskFragmentDoc}`;
export const UseMilestoneMilestoneFragmentDoc = gql`
    fragment UseMilestone_Milestone on MilestoneType {
  id
  ...ProjectMilestoneBoard_Milestone
  ...ProjectBulkEditDrawer_Milestone
  tasksAndGroups {
    ... on TaskType {
      id
      sortOrder
      assignee {
        avatar {
          originalUrl
        }
      }
      ...ProjectBulkEditDrawer_Task
    }
    ... on TaskGroupType {
      id
      sortOrder
      name
      tasks {
        id
        sortOrder
        assignee {
          avatar {
            originalUrl
          }
        }
        ...ProjectBulkEditDrawer_Task
      }
      __typename
    }
  }
}
    ${ProjectMilestoneBoardMilestoneFragmentDoc}
${ProjectBulkEditDrawerMilestoneFragmentDoc}
${ProjectBulkEditDrawerTaskFragmentDoc}`;
export const TaskGroupTasksFragmentDoc = gql`
    fragment taskGroupTasks on TaskGroupType {
  tasks {
    id
    sortOrder
  }
}
    `;
export const UpsertSkillFragmentDoc = gql`
    fragment UpsertSkill on Skill {
  id
}
    `;
export const SkillDialogFragmentDoc = gql`
    fragment SkillDialog on Skill {
  id
  name
  billableRate
  userCount
  category {
    id
    name
    skillCount
    userCount
  }
  users {
    id
    firstName
    lastName
    email
    jobRole
  }
}
    `;
export const TaskStatusDropdownProjectFragmentDoc = gql`
    fragment TaskStatusDropdown_Project on ProjectType {
  id
  name
  pmDisplayRole
  currentUserProjectContext
  projectManager {
    firstName
    lastName
  }
}
    `;
export const TemplateBulkEditFormTemplateFragmentDoc = gql`
    fragment TemplateBulkEditForm_Template on TemplateType {
  id
  organization {
    id
  }
}
    `;
export const TemplateBulkEditDrawerTemplateFragmentDoc = gql`
    fragment TemplateBulkEditDrawer_Template on TemplateType {
  id
  ...TemplateBulkEditForm_Template
}
    ${TemplateBulkEditFormTemplateFragmentDoc}`;
export const TemplatePlanTemplateV2FragmentDoc = gql`
    fragment TemplatePlan_TemplateV2 on TemplateType {
  id
  ...TemplateBulkEditDrawer_Template
  organization {
    id
    defaultTaskVisibility
  }
}
    ${TemplateBulkEditDrawerTemplateFragmentDoc}`;
export const TagColorItemTagFragmentDoc = gql`
    fragment TagColorItem_Tag on TagType {
  id
  color
  name
  internalOnly
}
    `;
export const TagsAvailableTagsFragmentDoc = gql`
    fragment Tags_AvailableTags on TagType {
  id
  ...TagColorItem_Tag
}
    ${TagColorItemTagFragmentDoc}`;
export const TemplatePlanAvailableTagsFragmentDoc = gql`
    fragment TemplatePlan_AvailableTags on TagType {
  id
  ...Tags_AvailableTags
}
    ${TagsAvailableTagsFragmentDoc}`;
export const TemplateBulkEditFormTaskFragmentDoc = gql`
    fragment TemplateBulkEditForm_Task on TaskType {
  id
  status
  priority
  responsibility
  taskType
  visibility
}
    `;
export const TemplateBulkEditDrawerTaskFragmentDoc = gql`
    fragment TemplateBulkEditDrawer_Task on TaskType {
  id
  ...TemplateBulkEditForm_Task
}
    ${TemplateBulkEditFormTaskFragmentDoc}`;
export const TemplateBulkEditFormMilestoneFragmentDoc = gql`
    fragment TemplateBulkEditForm_Milestone on MilestoneType {
  id
}
    `;
export const TemplateBulkEditDrawerMilestoneFragmentDoc = gql`
    fragment TemplateBulkEditDrawer_Milestone on MilestoneType {
  id
  ...TemplateBulkEditForm_Milestone
}
    ${TemplateBulkEditFormMilestoneFragmentDoc}`;
export const TemplateMilestoneHeaderMilestoneFragmentDoc = gql`
    fragment TemplateMilestoneHeader_Milestone on MilestoneType {
  id
  name
  startedOn
  forecastedEndOn
  completedAt
  active
  sortOrder
  summaryBank {
    id
    totalTasks
    totalCompleteTasks
    totalRemainingTasks
    duration
  }
  dependentTasks {
    id
  }
  template {
    id
    hardDependency
  }
}
    `;
export const TemplateHeaderMenuTaskFragmentDoc = gql`
    fragment TemplateHeaderMenu_Task on TaskType {
  id
  name
  status
  sortOrder
  responsibility
  taskType
  assignee {
    id
  }
  milestone {
    id
  }
}
    `;
export const TemplateTaskCardHeaderTaskFragmentDoc = gql`
    fragment TemplateTaskCardHeader_Task on TaskType {
  id
  name
  taskType
  status
  milestone {
    id
  }
  ...TemplateHeaderMenu_Task
}
    ${TemplateHeaderMenuTaskFragmentDoc}`;
export const TemplateStatusDropDownTaskFragmentDoc = gql`
    fragment TemplateStatusDropDown_Task on TaskType {
  id
  status
  taskType
  signOffRequired
  shouldWarnUpdateStatus
  taskGroup {
    id
  }
  template {
    id
    hardDependency
  }
  assignee {
    id
  }
  dependency {
    ... on MilestoneType {
      id
      completed
    }
    ... on TaskType {
      id
      completed
    }
    ... on TemplateType {
      id
      completed
    }
    ... on TaskGroupType {
      id
      completed
    }
  }
  ...ChangeStatusDropdown_Task
}
    ${ChangeStatusDropdownTaskFragmentDoc}`;
export const TemplateTaskInsightsTaskFragmentDoc = gql`
    fragment TemplateTaskInsights_Task on TaskType {
  id
  taskType
  completeSubtasksCount
  incompleteSubtasksCount
  actionItemsCount
  internalNotesCount
  publicNotesCount
  internalFilesCount
  publicFilesCount
  taskParticipants {
    id
    completed
    user {
      id
      firstName
      lastName
      avatar {
        originalUrl
      }
    }
  }
  assignee {
    id
  }
}
    `;
export const TemplateTaskBodyFooterTaskFragmentDoc = gql`
    fragment TemplateTaskBodyFooter_Task on TaskType {
  id
  name
  taskType
  responsibility
  visibility
  signOffRequired
  invitationGroupSentAt
  eventDatetime
  eventInformation
  participantCallToAction
  shouldWarnUpdateStatus
  currentUserTaskContext
  assignee {
    id
  }
  taskParticipants {
    id
    invitationSentAt
  }
  dependency {
    ... on MilestoneType {
      id
      completed
    }
    ... on TaskType {
      id
      completed
    }
    ... on TemplateType {
      id
      completed
    }
    ... on TaskGroupType {
      id
      completed
    }
  }
}
    `;
export const TemplateTaskCardBodyTaskFragmentDoc = gql`
    fragment TemplateTaskCardBody_Task on TaskType {
  id
  taskType
  signOffRequired
  signer {
    id
    firstName
    lastName
    email
  }
  assignee {
    id
  }
  ...TemplateStatusDropDown_Task
  ...TemplateTaskInsights_Task
  ...TemplateTaskBodyFooter_Task
}
    ${TemplateStatusDropDownTaskFragmentDoc}
${TemplateTaskInsightsTaskFragmentDoc}
${TemplateTaskBodyFooterTaskFragmentDoc}`;
export const TemplateTaskCardFooterDatesTaskFragmentDoc = gql`
    fragment TemplateTaskCardFooterDates_Task on TaskType {
  id
  name
  taskType
  meetingLength
  eventDatetime
  dueOn
  startOn
  duration
  completedAt
  dependency {
    ... on MilestoneType {
      id
      completed
    }
    ... on TaskType {
      id
      completed
    }
    ... on TemplateType {
      id
      completed
    }
    ... on TaskGroupType {
      id
      completed
    }
  }
}
    `;
export const TemplateTaskCardFooterTaskFragmentDoc = gql`
    fragment TemplateTaskCardFooter_Task on TaskType {
  id
  dependency {
    ...DependencyIcon_Task
    ...DependencyIcon_Milestone
    ...DependencyIcon_Template
    ...DependencyIcon_TaskGroup
  }
  tags {
    ...TagsBar_Tag
  }
  assignee {
    ...AssigneeAvatar_User
  }
  ...TemplateTaskCardFooterDates_Task
}
    ${DependencyIconTaskFragmentDoc}
${DependencyIconMilestoneFragmentDoc}
${DependencyIconTemplateFragmentDoc}
${DependencyIconTaskGroupFragmentDoc}
${TagsBarTagFragmentDoc}
${AssigneeAvatarUserFragmentDoc}
${TemplateTaskCardFooterDatesTaskFragmentDoc}`;
export const TemplateTaskCardTaskFragmentDoc = gql`
    fragment TemplateTaskCard_Task on TaskType {
  id
  status
  visibility
  responsibility
  ...TemplateTaskCardHeader_Task
  ...TemplateTaskCardBody_Task
  ...TemplateTaskCardFooter_Task
}
    ${TemplateTaskCardHeaderTaskFragmentDoc}
${TemplateTaskCardBodyTaskFragmentDoc}
${TemplateTaskCardFooterTaskFragmentDoc}`;
export const TemplateTaskGroupCardTaskGroupFragmentDoc = gql`
    fragment TemplateTaskGroupCard_TaskGroup on TaskGroupType {
  id
  name
  taskCount
  __typename
  sortOrder
  startedOn
  forecastedEndOn
  completedAt
  summaryBank {
    id
    totalTasks
    totalCompleteTasks
    totalRemainingTasks
    duration
  }
  tasks {
    ...TemplateTaskCard_Task
    ...TaskVisibilityProvider_Task
    taskGroup {
      id
    }
  }
}
    ${TemplateTaskCardTaskFragmentDoc}
${TaskVisibilityProviderTaskFragmentDoc}`;
export const TemplateMilestoneColumnMilestoneFragmentDoc = gql`
    fragment TemplateMilestoneColumn_Milestone on MilestoneType {
  id
  template {
    id
    hardDependency
  }
  ...TemplateMilestoneHeader_Milestone
  tasksAndGroups {
    ... on TaskType {
      id
      ...TemplateTaskCard_Task
      ...TaskVisibilityProvider_Task
    }
    ... on TaskGroupType {
      ...TemplateTaskGroupCard_TaskGroup
    }
  }
}
    ${TemplateMilestoneHeaderMilestoneFragmentDoc}
${TemplateTaskCardTaskFragmentDoc}
${TaskVisibilityProviderTaskFragmentDoc}
${TemplateTaskGroupCardTaskGroupFragmentDoc}`;
export const TemplateMilestoneColumnTaskFragmentDoc = gql`
    fragment TemplateMilestoneColumn_Task on TaskType {
  id
  ...TemplateTaskCard_Task
  ...TaskVisibilityProvider_Task
}
    ${TemplateTaskCardTaskFragmentDoc}
${TaskVisibilityProviderTaskFragmentDoc}`;
export const TemplateMilestoneColumnTaskGroupFragmentDoc = gql`
    fragment TemplateMilestoneColumn_TaskGroup on TaskGroupType {
  id
  ...TemplateTaskGroupCard_TaskGroup
}
    ${TemplateTaskGroupCardTaskGroupFragmentDoc}`;
export const TemplateMilestoneBoardMilestoneFragmentDoc = gql`
    fragment TemplateMilestoneBoard_Milestone on MilestoneType {
  id
  sortOrder
  ...TemplateMilestoneColumn_Milestone
  tasksAndGroups {
    ... on TaskType {
      id
      sortOrder
      ...TemplateMilestoneColumn_Task
    }
    ... on TaskGroupType {
      ...TemplateMilestoneColumn_TaskGroup
      tasks {
        id
        sortOrder
        ...TemplateMilestoneColumn_Task
      }
    }
  }
}
    ${TemplateMilestoneColumnMilestoneFragmentDoc}
${TemplateMilestoneColumnTaskFragmentDoc}
${TemplateMilestoneColumnTaskGroupFragmentDoc}`;
export const TemplateMilestoneBoardTaskFragmentDoc = gql`
    fragment TemplateMilestoneBoard_Task on TaskType {
  id
  ...TemplateMilestoneColumn_Task
}
    ${TemplateMilestoneColumnTaskFragmentDoc}`;
export const TemplateAddTaskDrawerTaskFragmentDoc = gql`
    fragment TemplateAddTaskDrawer_Task on TaskType {
  id
  ...TaskFormContext_Task
}
    ${TaskFormContextTaskFragmentDoc}`;
export const TemplateEditTaskDrawerTaskFragmentDoc = gql`
    fragment TemplateEditTaskDrawer_Task on TaskType {
  id
  ...TaskFormContext_Task
}
    ${TaskFormContextTaskFragmentDoc}`;
export const TemplateMilestoneHeaderMilestoneStatsFragmentDoc = gql`
    fragment TemplateMilestoneHeader_MilestoneStats on MilestoneStats {
  id
  totalTasks
  totalCompleteTasks
  totalRemainingTasks
  duration
}
    `;
export const NewMilestoneFragmentDoc = gql`
    fragment NewMilestone on MilestoneType {
  id
}
    `;
export const ProjectReassignProjectFragmentDoc = gql`
    fragment ProjectReassignProject on ProjectType {
  id
  name
  projectManager {
    id
    firstName
    lastName
    status
  }
  status
  customerV2 {
    id
    name
    logo {
      originalUrl
    }
  }
}
    `;
export const TaskReassignTaskFragmentDoc = gql`
    fragment TaskReassignTask on TaskType {
  id
  name
  description
  status
  project {
    id
    name
    status
    organization {
      id
    }
  }
}
    `;
export const UserMenuOptionUserWithCapacityFragmentDoc = gql`
    fragment UserMenuOption_UserWithCapacity on UserType {
  id
  firstName
  lastName
  email
  jobRole
  capacity
  projectsCount
  organization {
    id
    name
  }
  organizationName
  avatar {
    originalUrl
  }
  displayOrganization {
    name
  }
}
    `;
export const BrandTableRowTemplateFragmentDoc = gql`
    fragment BrandTableRowTemplate on BrandType {
  id
  name
  logo {
    originalUrl
  }
  primaryColor
  headerLogo {
    originalUrl
  }
}
    `;
export const NewBrandFragmentDoc = gql`
    fragment NewBrand on BrandType {
  id
  name
  logo {
    originalUrl
  }
}
    `;
export const ConfirmDeleteFilterDialogUserFilterViewFragmentDoc = gql`
    fragment ConfirmDeleteFilterDialog_UserFilterView on UserFilterViewType {
  id
  name
}
    `;
export const NewUserFragmentDoc = gql`
    fragment NewUser on UserType {
  id
}
    `;
export const AddUserFormOrganizationFragmentDoc = gql`
    fragment AddUserForm_Organization on OrganizationType {
  id
  type
  billableUsersCount
  maxBillableUsers
  ratePerUser
}
    `;
export const SecureLinksSettingsOrganizationFragmentDoc = gql`
    fragment SecureLinksSettings_Organization on OrganizationType {
  id
  name
  secureLinksEnabled
  secureLinksTtl
}
    `;
export const SingleSignOnSettingsOrganizationFragmentDoc = gql`
    fragment SingleSignOnSettings_Organization on OrganizationType {
  id
  ssoEnabled
  identityProvider {
    id
    active
    certificate
    issuer
    jitProvisioning
    strictMode
    targetUrl
    entityId
    attributeConsumeServiceEndpoint
  }
}
    `;
export const AuthenticationSettingsOrganizationFragmentDoc = gql`
    fragment AuthenticationSettings_Organization on OrganizationType {
  id
  ...SecureLinksSettings_Organization
  ...SingleSignOnSettings_Organization
}
    ${SecureLinksSettingsOrganizationFragmentDoc}
${SingleSignOnSettingsOrganizationFragmentDoc}`;
export const OrganizationTableRowOrganizationFragmentDoc = gql`
    fragment OrganizationTableRowOrganization on OrganizationType {
  id
  logo {
    originalUrl
  }
  name
  type
  participatingAs
  primaryContact {
    firstName
    lastName
  }
  usersCount
  billableUsersCount
  createdAt
  thirdPartyConnectionsCount
}
    `;
export const CompanyIndexOrganizationFragmentDoc = gql`
    fragment CompanyIndexOrganization on OrganizationType {
  ...OrganizationTableRowOrganization
}
    ${OrganizationTableRowOrganizationFragmentDoc}`;
export const GlobalTimeTrackingCategoriesCategoryFragmentDoc = gql`
    fragment GlobalTimeTrackingCategories_Category on TimeTrackingCategory {
  name
  description
  billable
  billableRate
  id
}
    `;
export const EditCustomFieldFormMergeTagFragmentDoc = gql`
    fragment EditCustomFieldForm_MergeTag on MergeTag {
  id
  name
  sortOrder
}
    `;
export const EditCustomFieldDrawerMergeTagFragmentDoc = gql`
    fragment EditCustomFieldDrawer_MergeTag on MergeTag {
  id
  ...EditCustomFieldForm_MergeTag
}
    ${EditCustomFieldFormMergeTagFragmentDoc}`;
export const DomainVerificationFormDomainFragmentDoc = gql`
    fragment DomainVerificationForm_Domain on DomainVerificationRecordsType {
  id
  domain
  record1
  record2
  record3
  sendgridWhitelabelId
}
    `;
export const DomainVerificationDrawerDomainFragmentDoc = gql`
    fragment DomainVerificationDrawer_Domain on DomainVerificationRecordsType {
  id
  ...DomainVerificationForm_Domain
}
    ${DomainVerificationFormDomainFragmentDoc}`;
export const EmailSettingsDomainFragmentDoc = gql`
    fragment EmailSettings_Domain on DomainVerificationRecordsType {
  id
  domain
  status
  ...DomainVerificationDrawer_Domain
}
    ${DomainVerificationDrawerDomainFragmentDoc}`;
export const HubSpotIntegrationOrganizationFragmentDoc = gql`
    fragment HubSpotIntegration_Organization on OrganizationType {
  id
  hubspotEnabled
  hubSpotIntegration {
    id
    hubSpotPortalId
  }
}
    `;
export const JiraIntegrationOrganizationFragmentDoc = gql`
    fragment JiraIntegration_Organization on OrganizationType {
  id
  jiraEnabled
  jiraIntegration {
    id
    siteName
    siteUrl
  }
}
    `;
export const DeliveriesViewWebhookDeliveryFragmentDoc = gql`
    fragment DeliveriesView_WebhookDelivery on WebhookDeliveryType {
  id
  action
  responseCode
  details
  attempts
  status
}
    `;
export const OpenApiSettingsOrganizationFragmentDoc = gql`
    fragment OpenApiSettings_Organization on OrganizationType {
  id
  openApiEnabled
  openApiData {
    openApiToken
    webhooks {
      id
      url
      secret
      active
    }
  }
}
    `;
export const ProjectMenuOptionProjectFragmentDoc = gql`
    fragment ProjectMenuOption_Project on ProjectType {
  id
  name
  customerV2 {
    id
    name
    logo {
      originalUrl
    }
  }
}
    `;
export const TriggerWebhookAlertDialogProjectFragmentDoc = gql`
    fragment TriggerWebhookAlertDialog_Project on ProjectType {
  id
  ...ProjectMenuOption_Project
}
    ${ProjectMenuOptionProjectFragmentDoc}`;
export const FeaturesFeaturesFragmentDoc = gql`
    fragment Features_Features on OrganizationType {
  id
  timeTrackingEnabled
  brandsEnabled
  hubspotEnabled
  jiraEnabled
  openApiEnabled
  resourceManagementEnabled
  salesforceEnabled
  ssoEnabled
  whiteLabelingEnabled
  customerDashboardEnabled
}
    `;
export const OrganizationFormOrganizationFragmentDoc = gql`
    fragment OrganizationForm_Organization on OrganizationType {
  id
  name
  domain
  type
  maxBillableUsers
  ratePerUser
  logo {
    originalUrl
  }
  adminSettings {
    uploadLimitMb
  }
  ipaasAccountExists
  currencyCode
  ...Features_Features
}
    ${FeaturesFeaturesFragmentDoc}`;
export const ProjectProviderSettingsOrganizationFragmentDoc = gql`
    fragment ProjectProviderSettings_Organization on OrganizationType {
  id
  defaultTaskVisibility
  billableRate
  timeTrackingEnabled
  showShareableLink
  isCsatSurveyEnabled
  internalNotesDefault
  taskFilterByFunction
  currencyCode
  countryCode
  uploadsEnabled
  setting {
    useStatusChangeReasons
  }
}
    `;
export const SalesforceIntegrationOrganizationFragmentDoc = gql`
    fragment SalesforceIntegration_Organization on OrganizationType {
  id
  salesforceEnabled
  salesforceIntegration {
    id
    username
    organizationName
    host
  }
}
    `;
export const EditDialogChannelFragmentDoc = gql`
    fragment EditDialog_Channel on SlackIntegrationType {
  id
  channelName
  channelId
  url
  teamName
}
    `;
export const SlackIntegrationOrganizationFragmentDoc = gql`
    fragment SlackIntegration_Organization on OrganizationType {
  id
  projectUpdatedSlackDaysPref
  slackIntegrations {
    ...EditDialog_Channel
  }
}
    ${EditDialogChannelFragmentDoc}`;
export const UserTableRowUserFragmentDoc = gql`
    fragment UserTableRowUser on UserType {
  id
  firstName
  lastName
  email
  role
  status
  createdAt
  costRate
  avatar {
    originalUrl
  }
}
    `;
export const WhiteLabelingSettingsOrganizationFragmentDoc = gql`
    fragment WhiteLabelingSettings_Organization on OrganizationType {
  id
  whiteLabelingEnabled
  primaryColor
  headerLogo {
    originalUrl
  }
}
    `;
export const ConnectedUserTableRowUserFragmentDoc = gql`
    fragment ConnectedUserTableRow_User on UserType {
  id
  firstName
  lastName
  email
  role
  status
  avatar {
    originalUrl
  }
  organization {
    id
    name
  }
  organizationName
}
    `;
export const MilestoneFormMilestoneFragmentDoc = gql`
    fragment MilestoneForm_Milestone on MilestoneType {
  id
  name
  sortOrder
  description
  completionMessage
  enableCompletionNotification
  enableSendSurvey
  files {
    id
    ...MultipleFileList_File
  }
}
    ${MultipleFileListFileFragmentDoc}`;
export const FormAssigneeFieldUserFragmentDoc = gql`
    fragment FormAssigneeField_User on UserType {
  id
  firstName
  lastName
  email
  projectContext
  skills {
    id
  }
  organization {
    id
    type
  }
  ...UserMenuOption_User
}
    ${UserMenuOptionUserFragmentDoc}`;
export const SharedFieldsJiraIntegrationFragmentDoc = gql`
    fragment SharedFields_JiraIntegrationFragment on JiraIntegrationType {
  defaultProjectId
  defaultIssueTypeId
  apiProjects {
    id
    externalId
    name
    issueTypes {
      id
      externalId
      name
    }
  }
}
    `;
export const TaskOwnerFieldsProjectFragmentDoc = gql`
    fragment TaskOwnerFields_Project on ProjectType {
  id
  pmDisplayRole
  projectManager {
    id
    firstName
    lastName
  }
}
    `;
export const DeleteTimeEntryDialogTimeRecordFragmentDoc = gql`
    fragment DeleteTimeEntryDialog_TimeRecord on TimeRecordType {
  id
  taskId
  billable
  hours
}
    `;
export const TimeEntryTableTimeRecordFragmentDoc = gql`
    fragment TimeEntryTable_TimeRecord on TimeRecordType {
  id
  dateWorked
  description
  billable
  hours
  worker {
    id
    firstName
    lastName
    ...Avatar_User
  }
  taskId
  projectId
  workerId
  categoryId
  category {
    id
    name
  }
  ...DeleteTimeEntryDialog_TimeRecord
}
    ${AvatarUserFragmentDoc}
${DeleteTimeEntryDialogTimeRecordFragmentDoc}`;
export const FormRoleMultiSelectSkillFragmentDoc = gql`
    fragment FormRoleMultiSelect_Skill on Skill {
  id
  name
  category {
    id
  }
}
    `;
export const ParticipantAvatarListUserFragmentDoc = gql`
    fragment ParticipantAvatarList_User on UserType {
  id
  firstName
  lastName
  email
  jobRole
  projectContext
  ...Avatar_User
}
    ${AvatarUserFragmentDoc}`;
export const PaginatedAssigneeMultiSelectUserFragmentDoc = gql`
    fragment PaginatedAssigneeMultiSelect_User on UserType {
  id
  ...UserMenuOption_User
  email
}
    ${UserMenuOptionUserFragmentDoc}`;
export const RoleMultiSelectSkillFragmentDoc = gql`
    fragment RoleMultiSelect_Skill on Skill {
  id
  name
  category {
    id
  }
}
    `;
export const RoleMultiSelectOrganizationFragmentDoc = gql`
    fragment RoleMultiSelect_Organization on OrganizationType {
  id
  skillCategories {
    id
    name
    skills {
      id
      ...RoleMultiSelect_Skill
    }
  }
}
    ${RoleMultiSelectSkillFragmentDoc}`;
export const TaskFormContextUserFragmentDoc = gql`
    fragment TaskFormContext_User on UserType {
  id
  firstName
  lastName
  email
  jobRole
  projectContext
  role
  avatar {
    originalUrl
  }
  displayOrganization {
    name
  }
  organization {
    id
    name
    type
  }
  skills {
    id
  }
}
    `;
export const NotesNoteFragmentDoc = gql`
    fragment Notes_Note on NoteType {
  id
  raw
  createdAt
  deletable
  internalOnly
  user {
    id
    firstName
    lastName
    avatar {
      originalUrl
    }
  }
  attachments {
    id
    fileName
    url
    internalOnly
  }
}
    `;
export const MentionControlProjectTeamFragmentDoc = gql`
    fragment MentionControl_ProjectTeam on UserType {
  id
  firstName
  lastName
  email
  projectContext
  avatar {
    originalUrl
  }
  organization {
    id
  }
}
    `;
export const NotesProjectTeamFragmentDoc = gql`
    fragment Notes_ProjectTeam on UserType {
  ...MentionControl_ProjectTeam
}
    ${MentionControlProjectTeamFragmentDoc}`;
export const NotesListNoteFragmentDoc = gql`
    fragment NotesList_Note on NoteType {
  id
  raw
  createdAt
  internalOnly
  user {
    id
    firstName
    lastName
    avatar {
      originalUrl
    }
  }
  attachments {
    id
    fileName
    url
    internalOnly
  }
}
    `;
export const NotesListItemNoteFragmentDoc = gql`
    fragment NotesListItem_Note on NoteType {
  id
  raw
  createdAt
  internalOnly
  user {
    id
    firstName
    lastName
    avatar {
      originalUrl
    }
  }
  attachments {
    id
    fileName
    url
    internalOnly
  }
  noteable {
    ... on TaskType {
      id
      name
      status
      milestone {
        id
      }
      project {
        id
      }
      template {
        id
      }
    }
    ... on ProjectType {
      id
      name
      status
    }
  }
}
    `;
export const NotesListItemUserFragmentDoc = gql`
    fragment NotesListItem_User on UserType {
  id
  firstName
  lastName
  email
  projectContext
  avatar {
    originalUrl
  }
  organization {
    id
  }
}
    `;
export const AddCustomerUsersCustomerUserFragmentDoc = gql`
    fragment AddCustomerUsers_CustomerUser on UserType {
  id
  firstName
  lastName
  email
}
    `;
export const AddInternalUsersUserFragmentDoc = gql`
    fragment AddInternalUsers_User on UserType {
  id
  firstName
  lastName
  email
  role
}
    `;
export const AddTeamMemberDrawerProjectFragmentDoc = gql`
    fragment AddTeamMemberDrawer_Project on ProjectType {
  id
  creating
  customerV2 {
    id
    name
  }
  projectType
}
    `;
export const AddThirdPartyUserFragmentDoc = gql`
    fragment AddThirdParty_User on UserType {
  id
  firstName
  lastName
  email
}
    `;
export const BillableRatesSummarySkillCategoryFragmentDoc = gql`
    fragment Billable_Rates_Summary_SkillCategory on SkillCategory {
  id
  name
  userCount
  skillCount
}
    `;
export const BillableRatesDetailSkillFragmentDoc = gql`
    fragment Billable_Rates_Detail_Skill on Skill {
  id
  billableRate
  name
  users {
    id
    jobRole
    ...Avatar_User
  }
}
    ${AvatarUserFragmentDoc}`;
export const BillableRatesCategoryListSkillCategoryFragmentDoc = gql`
    fragment Billable_Rates_CategoryList_SkillCategory on SkillCategory {
  id
  ...Billable_Rates_Summary_SkillCategory
  skills {
    id
    ...Billable_Rates_Detail_Skill
  }
}
    ${BillableRatesSummarySkillCategoryFragmentDoc}
${BillableRatesDetailSkillFragmentDoc}`;
export const ConfirmCreateTemplateDialogFragmentDoc = gql`
    fragment ConfirmCreateTemplateDialog on TemplateType {
  id
  name
}
    `;
export const BillingProfileInputProjectFragmentDoc = gql`
    fragment BillingProfileInput_Project on ProjectType {
  id
  name
  projectBillRate {
    id
    timeTrackingCategory {
      id
      name
      billableRate
    }
    rateType
    dollars
    hours
    rate
    billingProfileId
    billingProfileName
    allottedHours
    secondaryDollars
    secondaryRateType
    allowOverages
  }
}
    `;
export const PurchasedInputHistoryFragmentDoc = gql`
    fragment PurchasedInput_History on PurchasedHoursHistory {
  date
  purchasedHours
}
    `;
export const PurchasedInputProjectFragmentDoc = gql`
    fragment PurchasedInput_Project on ProjectType {
  id
  projectBillRate {
    id
    hours
    rateType
    purchasedHoursRemaining
    purchasedHoursHistory {
      ...PurchasedInput_History
    }
  }
}
    ${PurchasedInputHistoryFragmentDoc}`;
export const FlatFeeInputDollarsHistoryFragmentDoc = gql`
    fragment FlatFeeInput_DollarsHistory on DollarsHistory {
  date
  dollars
}
    `;
export const FlatFeeInputProjectFragmentDoc = gql`
    fragment FlatFeeInput_Project on ProjectType {
  id
  projectBillRate {
    id
    hours
    showHoursToCustomers
    rateType
    dollarsHistory {
      ...FlatFeeInput_DollarsHistory
    }
  }
}
    ${FlatFeeInputDollarsHistoryFragmentDoc}`;
export const FormTimePreferencesProjectFragmentDoc = gql`
    fragment FormTimePreferences_Project on ProjectType {
  id
  projectBillRate {
    id
    requireTimeEntry
  }
}
    `;
export const ProjectInfoFormProjectFragmentDoc = gql`
    fragment ProjectInfoForm_Project on ProjectType {
  id
  name
  externalId
  startOn
  endOn
  doneTasksCount
  showForecast
  projectManager {
    id
  }
  brand {
    id
  }
  cashValue
  files {
    id
    fileName
    size
    url
    internalOnly
    isExternalHyperlink
    uploader {
      id
      firstName
      lastName
      avatar {
        originalUrl
      }
    }
  }
  bccToProjectManager
  bccEmails
  bccEmailsEnabled
  salesforceOpportunityName
  salesforceObjectLink
  jiraEpicLink
  hubspotObjectLink
  hubspotDealName
  customerV2 {
    id
  }
  organization {
    id
    salesforceEnabled
    hubspotEnabled
    defaultTaskVisibility
    timeTrackingEnabled
  }
  ...BillingProfileInput_Project
  ...PurchasedInput_Project
  ...FlatFeeInput_Project
  ...FormTimePreferences_Project
}
    ${BillingProfileInputProjectFragmentDoc}
${PurchasedInputProjectFragmentDoc}
${FlatFeeInputProjectFragmentDoc}
${FormTimePreferencesProjectFragmentDoc}`;
export const PmNoteFormProjectFragmentDoc = gql`
    fragment PMNoteForm_Project on ProjectType {
  id
  pmDisplayRole
  pmNote
  pmNoteInternalOnly
}
    `;
export const EditProjectDrawerProjectFragmentDoc = gql`
    fragment EditProjectDrawer_Project on ProjectType {
  id
  tags {
    id
    name
    color
    internalOnly
  }
  organization {
    id
    showShareableLink
  }
  projectType
  customerV2 {
    id
  }
  ...ProjectInfoForm_Project
  ...PMNoteForm_Project
}
    ${ProjectInfoFormProjectFragmentDoc}
${PmNoteFormProjectFragmentDoc}`;
export const EditTemplatesDrawerProjectFragmentDoc = gql`
    fragment EditTemplatesDrawer_Project on ProjectType {
  id
  templates {
    id
    name
    videoUrl
    experienceOverview
    sortOrder
    duration
    hardDependency
    videoPlaceholderImage {
      originalUrl
    }
    milestones {
      duration
    }
  }
}
    `;
export const EditTemplatesDrawerTemplateFragmentDoc = gql`
    fragment EditTemplatesDrawer_Template on TemplateType {
  id
  name
  videoUrl
  experienceOverview
  sortOrder
  duration
  hardDependency
  videoPlaceholderImage {
    originalUrl
  }
  milestones {
    duration
  }
}
    `;
export const EventInformationTaskFragmentDoc = gql`
    fragment EventInformation_Task on TaskType {
  id
  eventDatetime
  eventInformation
  assignee {
    id
  }
  name
  milestone {
    id
  }
  template {
    id
  }
  project {
    id
  }
  taskParticipants {
    id
    completed
    user {
      id
      email
      firstName
      lastName
      avatar {
        originalUrl
      }
    }
  }
}
    `;
export const FilterActionItemFormTaskFragmentDoc = gql`
    fragment FilterActionItemForm_Task on TaskType {
  id
  name
}
    `;
export const FilterActionItemDrawerTaskFragmentDoc = gql`
    fragment FilterActionItemDrawer_Task on TaskType {
  id
  ...FilterActionItemForm_Task
}
    ${FilterActionItemFormTaskFragmentDoc}`;
export const FormAssigneeMultiSelectUserFragmentDoc = gql`
    fragment FormAssigneeMultiSelect_User on UserType {
  id
  ...UserMenuOption_User
}
    ${UserMenuOptionUserFragmentDoc}`;
export const FilterPlanFormAssigneeFragmentDoc = gql`
    fragment FilterPlanForm_Assignee on UserType {
  id
  ...FormAssigneeMultiSelect_User
  email
}
    ${FormAssigneeMultiSelectUserFragmentDoc}`;
export const FilterProjectPlanDrawerAssigneeFragmentDoc = gql`
    fragment FilterProjectPlanDrawer_Assignee on UserType {
  id
  ...FilterPlanForm_Assignee
}
    ${FilterPlanFormAssigneeFragmentDoc}`;
export const RequireTimeEntriesFormProjectBillRateFragmentDoc = gql`
    fragment RequireTimeEntriesForm_ProjectBillRate on ProjectBillRateType {
  id
  requireTimeEntry
}
    `;
export const GroupTaskInformationTaskFragmentDoc = gql`
    fragment GroupTaskInformation_Task on TaskType {
  id
  participantCallToAction
  invitationGroupSentAt
  name
  currentUserTaskContext
  assignee {
    id
  }
  taskParticipants {
    id
    invitationSentAt
    completed
    user {
      id
      firstName
      lastName
      avatar {
        originalUrl
      }
    }
  }
  milestone {
    id
  }
  template {
    id
  }
  project {
    id
  }
}
    `;
export const MyTasksAttachmentsTaskFragmentDoc = gql`
    fragment MyTasksAttachments_Task on TaskType {
  id
  milestone {
    id
  }
}
    `;
export const MyTasksNoteNoteFragmentDoc = gql`
    fragment MyTasksNote_Note on NoteType {
  id
  raw
  createdAt
  user {
    id
    firstName
    lastName
    avatar {
      originalUrl
    }
  }
}
    `;
export const ActionItemFormTaskFragmentDoc = gql`
    fragment ActionItemForm_Task on TaskType {
  id
  name
}
    `;
export const ActionItemDrawerTaskFragmentDoc = gql`
    fragment ActionItemDrawer_Task on TaskType {
  id
  ...ActionItemForm_Task
}
    ${ActionItemFormTaskFragmentDoc}`;
export const ActionItemFormActionItemFragmentDoc = gql`
    fragment ActionItemForm_ActionItem on ActionItemType {
  id
  name
  createdOn
  description
  priority
  status
  startOn
  dueOn
  visibility
  tags {
    id
  }
  assignee {
    id
    firstName
  }
  relatedTask {
    id
    name
    milestone {
      id
      name
    }
  }
}
    `;
export const AssigneeAvatarAssigneeAvatarFragmentDoc = gql`
    fragment AssigneeAvatar_AssigneeAvatar on UserType {
  id
  firstName
  lastName
  email
  jobRole
  avatar {
    originalUrl
  }
}
    `;
export const ActionItemRowActionItemRowFragmentDoc = gql`
    fragment ActionItemRow_ActionItemRow on ActionItemType {
  id
  name
  createdOn
  priority
  status
  dueOn
  visibility
  internalNotesCount
  relatedTask {
    id
    name
    milestone {
      id
      name
    }
  }
  assignee {
    ...AssigneeAvatar_AssigneeAvatar
  }
  tags {
    ...Tags_AvailableTags
  }
}
    ${AssigneeAvatarAssigneeAvatarFragmentDoc}
${TagsAvailableTagsFragmentDoc}`;
export const AssigneeMultiSelectUserFragmentDoc = gql`
    fragment AssigneeMultiSelect_User on UserType {
  id
  ...UserMenuOption_User
  email
}
    ${UserMenuOptionUserFragmentDoc}`;
export const FilterActionItemFormUserFragmentDoc = gql`
    fragment FilterActionItemForm_User on UserType {
  ...AssigneeMultiSelect_User
}
    ${AssigneeMultiSelectUserFragmentDoc}`;
export const FilterActionItemDrawerUserFragmentDoc = gql`
    fragment FilterActionItemDrawer_User on UserType {
  id
  ...FilterActionItemForm_User
}
    ${FilterActionItemFormUserFragmentDoc}`;
export const ActionItemFormUserFragmentDoc = gql`
    fragment ActionItemForm_User on UserType {
  ...AssigneeField_User
}
    ${AssigneeFieldUserFragmentDoc}`;
export const ActionItemDrawerUserFragmentDoc = gql`
    fragment ActionItemDrawer_User on UserType {
  id
  ...ActionItemForm_User
}
    ${ActionItemFormUserFragmentDoc}`;
export const ProjectActionItemsProjectTeamFragmentDoc = gql`
    fragment ProjectActionItems_ProjectTeam on UserType {
  id
  ...FilterActionItemDrawer_User
  ...ActionItemDrawer_User
}
    ${FilterActionItemDrawerUserFragmentDoc}
${ActionItemDrawerUserFragmentDoc}`;
export const ProjectFilesProjectFragmentDoc = gql`
    fragment ProjectFiles_Project on ProjectType {
  id
  name
}
    `;
export const ProjectFilesFileFragmentDoc = gql`
    fragment ProjectFiles_File on FileType {
  id
  url
  fileName
  size
  milestoneName
  deletable
  taskName
  createdAt
  internalOnly
  isExternalHyperlink
  uploader {
    id
    firstName
    lastName
  }
  assetable {
    ... on TaskType {
      id
      milestone {
        id
      }
      project {
        id
      }
      template {
        id
      }
    }
  }
}
    `;
export const ProjectInfoFormTemplateFragmentDoc = gql`
    fragment ProjectInfoForm_Template on TemplateType {
  id
  name
  duration
  experienceOverview
  description
  videoUrl
  sortOrder
  videoPlaceholderImage {
    originalUrl
  }
}
    `;
export const ProjectTableRowProjectFragmentDoc = gql`
    fragment ProjectTableRow_Project on ProjectType {
  id
  name
  cashValue
  totalTasksCount
  openTasksCount
  openActionItemsCount
  overdueTasksCount
  startOn
  endOn
  projectStatusChangeReasons {
    id
    name
    description
    createdAt
    updatedAt
    user {
      id
      firstName
      lastName
      avatar {
        originalUrl
      }
    }
    statusChangeReason {
      id
      name
      statusChangeReasonGroup {
        id
        name
      }
    }
  }
  completedAt
  forecastedEndOn
  deletedAt
  archivedAt
  currentUserProjectContext
  currentUserRestrictedAccess
  currentUserSettings {
    projectView
    restrictAccess
  }
  lastActivityAt
  projectManager {
    id
    firstName
    lastName
    status
    avatar {
      originalUrl
    }
  }
  status
  customerV2 {
    id
    name
    logo {
      originalUrl
    }
  }
  projectType
  templates {
    id
    milestones {
      id
      name
      active
    }
  }
  organization {
    id
    name
  }
  displayOrganization {
    name
  }
  brand {
    id
    name
    logo {
      originalUrl
    }
  }
  tags {
    ...Tags_AvailableTags
    __typename
  }
  errorsCount
}
    ${TagsAvailableTagsFragmentDoc}`;
export const ProjectListTableProjectFragmentDoc = gql`
    fragment ProjectListTable_Project on ProjectType {
  id
  deletedAt
  errorsCount
  ...ProjectTableRow_Project
}
    ${ProjectTableRowProjectFragmentDoc}`;
export const SideBarUserFragmentDoc = gql`
    fragment SideBar_User on UserType {
  id
  firstName
  lastName
  avatar {
    originalUrl
  }
  capacity
  projectsCount
}
    `;
export const ProjectNotesProjectFragmentDoc = gql`
    fragment ProjectNotes_Project on ProjectType {
  id
  __typename
  organization {
    id
    internalNotesDefault
  }
}
    `;
export const ProjectSnapshotProjectFragmentDoc = gql`
    fragment ProjectSnapshot_Project on ProjectType {
  id
  startOn
  endOn
  completedAt
  forecastedEndOn
}
    `;
export const ProjectSnapshotStatsFragmentDoc = gql`
    fragment ProjectSnapshot_Stats on ProjectStats {
  totalTasks
  totalDoneTasks
}
    `;
export const MyTasksAttachmentsFileFragmentDoc = gql`
    fragment MyTasksAttachments_File on FileType {
  id
  fileName
  size
  url
}
    `;
export const ProjectTaskCardTaskFragmentDoc = gql`
    fragment ProjectTaskCard_Task on TaskType {
  id
  name
  responsibility
  visibility
  shouldWarnUpdateStatus
  description
  signOffRequired
  taskType
  completedAt
  eventInformation
  eventDatetime
  participantCallToAction
  invitationGroupSentAt
  currentUserTaskContext
  taskParticipants {
    id
    completed
    invitationSentAt
    user {
      id
      firstName
      lastName
      email
      avatar {
        originalUrl
        __typename
      }
      __typename
    }
  }
  template {
    id
    name
    hardDependency
  }
  milestone {
    id
    name
    sortOrder
    status
  }
  status
  dueOn
  tags {
    id
    color
    internalOnly
    name
  }
  project {
    id
    organization {
      id
      name
    }
    customerV2 {
      id
      name
    }
    projectType
    projectManager {
      id
      firstName
      lastName
      calendarLink
      meetingLink
    }
    organization {
      id
      defaultTaskVisibility
    }
  }
  notes {
    id
    raw
    createdAt
    user {
      id
      firstName
      lastName
      avatar {
        originalUrl
      }
    }
  }
  files {
    id
    ...MyTasksAttachments_File
  }
  assignee {
    id
    firstName
    lastName
    calendarLink
    meetingLink
  }
  dependency {
    ... on MilestoneType {
      id
      name
      completed
    }
    ... on TaskType {
      id
      name
      completed
      visibility
      shouldWarnUpdateStatus
    }
    ... on TaskGroupType {
      id
      name
      completed
    }
    ... on MilestoneType {
      id
      name
      completed
    }
    ... on TemplateType {
      id
      name
      completed
    }
  }
  subtasks {
    id
    ...SubtaskFragment
  }
  subtasksGroups {
    id
    name
  }
}
    ${MyTasksAttachmentsFileFragmentDoc}
${SubtaskFragmentDoc}`;
export const TeamMemberSkillsSkillFragmentDoc = gql`
    fragment TeamMemberSkills_Skill on Skill {
  id
  name
  category {
    id
    name
  }
}
    `;
export const TeamCardUserFragmentDoc = gql`
    fragment TeamCard_User on UserType {
  id
  firstName
  lastName
  lastActivityAt
  notificationPreferences {
    projectOverviewEmailPref
    taskReminderEmailPref
  }
  status
  avatar {
    originalUrl
  }
  jobRole
  organization {
    id
    name
    type
    logo {
      originalUrl
    }
  }
  organizationName
  notificationPreferences {
    projectOverviewEmailPref
    taskReminderEmailPref
    overdueEmailPref
    stuckEmailPref
    doneEmailPref
    overduePref
    stuckPref
    donePref
  }
  displayOrganization {
    name
    logo {
      originalUrl
    }
  }
  phone
  email
  hidePhone
  hideEmail
  projectContext
  projectSettings {
    projectView
    restrictAccess
  }
  skills {
    ...TeamMemberSkills_Skill
  }
}
    ${TeamMemberSkillsSkillFragmentDoc}`;
export const ProjectTeamUserFragmentDoc = gql`
    fragment ProjectTeam_User on UserType {
  id
  ...TeamCard_User
}
    ${TeamCardUserFragmentDoc}`;
export const UserProgressBarUserProjectStatsFragmentDoc = gql`
    fragment UserProgressBar_UserProjectStats on UserProjectStatsType {
  totalDoneTasks
  totalRemainingTasks
  totalPlannedTasks
  activeOverdueTasks
}
    `;
export const UserViewInformationUserFragmentDoc = gql`
    fragment UserViewInformation_User on UserType {
  id
  addedToQualtricsAt
  projectSettings {
    projectView
    restrictAccess
  }
  lastActivityAt
  notificationPreferences {
    taskReminderEmailPref
    projectOverviewEmailPref
  }
  projectContext
}
    `;
export const UserWithRolesUserFragmentDoc = gql`
    fragment UserWithRoles_User on UserType {
  id
  firstName
  lastName
  status
  hidePhone
  phone
  hideEmail
  email
  avatar {
    originalUrl
  }
  organizationName
  displayOrganization {
    name
    logo {
      originalUrl
    }
  }
  organization {
    id
    type
  }
  projectStats {
    ...UserProgressBar_UserProjectStats
  }
  ...UserViewInformation_User
}
    ${UserProgressBarUserProjectStatsFragmentDoc}
${UserViewInformationUserFragmentDoc}`;
export const ProjectTeamGroupedRoleListUserFragmentDoc = gql`
    fragment ProjectTeamGroupedRoleList_User on UserType {
  id
  ...UserWithRoles_User
}
    ${UserWithRolesUserFragmentDoc}`;
export const RolesHeaderRolesFragmentDoc = gql`
    fragment RolesHeader_Roles on Skill {
  id
  name
  category {
    id
    name
  }
}
    `;
export const ProjectTeamGroupedRoleListRolesFragmentDoc = gql`
    fragment ProjectTeamGroupedRoleList_Roles on Skill {
  id
  ...RolesHeader_Roles
}
    ${RolesHeaderRolesFragmentDoc}`;
export const EmptyRolesBoxRolesFragmentDoc = gql`
    fragment EmptyRolesBox_Roles on Skill {
  id
}
    `;
export const UserInviteInformationUserFragmentDoc = gql`
    fragment UserInviteInformation_User on UserType {
  id
  status
  email
  firstAccessWithSecureLink
}
    `;
export const DraggableTemplateTemplateFragmentDoc = gql`
    fragment DraggableTemplate_Template on TemplateType {
  id
  name
  duration
}
    `;
export const ProjectTemplatesTemplateFragmentDoc = gql`
    fragment ProjectTemplates_Template on TemplateType {
  id
  ...DraggableTemplate_Template
}
    ${DraggableTemplateTemplateFragmentDoc}`;
export const ProjectTimelineItemProjectFragmentDoc = gql`
    fragment ProjectTimelineItem_Project on ProjectType {
  id
  name
  totalTasksCount
  doneTasksCount
  startOn
  endOn
  forecastedEndOn
  status
  customerV2 {
    id
    name
    logo {
      originalUrl
    }
  }
  displayOrganization {
    name
    logo {
      originalUrl
    }
  }
  projectType
}
    `;
export const TemplateInfoRowTemplateFragmentDoc = gql`
    fragment TemplateInfoRow_Template on TemplateType {
  id
  name
  experienceOverview
  videoUrl
  hardDependency
  videoPlaceholderImage {
    originalUrl
  }
}
    `;
export const TemplateInfoFormTemplateFragmentDoc = gql`
    fragment TemplateInfoForm_Template on TemplateType {
  id
  ...TemplateInfoRow_Template
}
    ${TemplateInfoRowTemplateFragmentDoc}`;
export const CapacityBoxUserFragmentDoc = gql`
    fragment CapacityBox_User on UserType {
  id
}
    `;
export const CapacityBoxCapacityFragmentDoc = gql`
    fragment CapacityBox_Capacity on CapacityType {
  actualHours
  capacityHours
  projectCount
  taskCount
  indeterminate
  startDate
  endDate
  percentage
}
    `;
export const CapacityBoxProjectFragmentDoc = gql`
    fragment CapacityBox_Project on ProjectType {
  id
  userTimeCapacities(filters: $filters, groupBy: $groupBy, userId: $userId) {
    ...CapacityBox_Capacity
  }
}
    ${CapacityBoxCapacityFragmentDoc}`;
export const UserDropdownSkillFragmentDoc = gql`
    fragment UserDropdown_Skill on Skill {
  id
  name
}
    `;
export const TaskPillTaskFragmentDoc = gql`
    fragment TaskPill_Task on TaskType {
  id
  name
  startOn
  dueOn
  status
  estimatedHours
  template {
    id
  }
  milestone {
    id
  }
  skill {
    id
    name
    ...UserDropdown_Skill
  }
  timePeriodUtilization(startDate: $startDate, endDate: $endDate) {
    hours
    userCapacity
    utilization
  }
}
    ${UserDropdownSkillFragmentDoc}`;
export const CapacityDetailsModalTaskFragmentDoc = gql`
    fragment CapacityDetailsModal_Task on TaskType {
  id
  startOn
  dueOn
  completedAt
  estimatedHours
  ...TaskPill_Task
}
    ${TaskPillTaskFragmentDoc}`;
export const TaskPillProjectFragmentDoc = gql`
    fragment TaskPill_Project on ProjectType {
  id
}
    `;
export const CapacityDetailsModalProjectFragmentDoc = gql`
    fragment CapacityDetailsModal_Project on ProjectType {
  id
  name
  status
  projectManager {
    id
  }
  endOn
  forecastedEndOn
  totalTasksCount
  openTasksCount
  ...TaskPill_Project
}
    ${TaskPillProjectFragmentDoc}`;
export const TaskPillUserFragmentDoc = gql`
    fragment TaskPill_User on UserType {
  id
  firstName
  lastName
  skills {
    id
  }
}
    `;
export const CapacityDetailsModalUserFragmentDoc = gql`
    fragment CapacityDetailsModal_User on UserType {
  id
  ...TaskPill_User
}
    ${TaskPillUserFragmentDoc}`;
export const CapacityDetailsModalHeaderQueriedUserFragmentDoc = gql`
    fragment CapacityDetailsModalHeader_QueriedUser on UserType {
  id
  firstName
  lastName
  avatar {
    originalUrl
  }
  timeCapacities(groupBy: WEEK, filters: $filters) {
    actualHours
    capacityHours
    percentage
  }
}
    `;
export const UserDropdownUserFragmentDoc = gql`
    fragment UserDropdown_User on UserType {
  id
  firstName
  lastName
  email
  avatar {
    originalUrl
  }
  skills {
    id
  }
  timeCapacities(groupBy: WEEK, filters: $filters) {
    actualHours
    capacityHours
    percentage
  }
}
    `;
export const CapacityListBoxCapacityFragmentDoc = gql`
    fragment CapacityListBox_Capacity on CapacityType {
  actualHours
  capacityHours
  projectCount
  taskCount
  indeterminate
  startDate
  endDate
  percentage
}
    `;
export const TimeCapacityUserFragmentDoc = gql`
    fragment TimeCapacity_User on UserType {
  id
  timeCapacities(groupBy: $groupBy, filters: $filters) {
    ...CapacityListBox_Capacity
  }
}
    ${CapacityListBoxCapacityFragmentDoc}`;
export const CapacityListUserCellUserFragmentDoc = gql`
    fragment CapacityListUserCell_User on UserType {
  id
  firstName
  lastName
  avatar {
    originalUrl
  }
}
    `;
export const CapacityListUserFragmentDoc = gql`
    fragment CapacityList_User on UserType {
  id
  ...TimeCapacity_User
  ...CapacityListUserCell_User
}
    ${TimeCapacityUserFragmentDoc}
${CapacityListUserCellUserFragmentDoc}`;
export const CapacityPlanningUserFragmentDoc = gql`
    fragment CapacityPlanning_User on UserType {
  id
  ...CapacityList_User
}
    ${CapacityListUserFragmentDoc}`;
export const SummarySkillCategoryFragmentDoc = gql`
    fragment Summary_SkillCategory on SkillCategory {
  id
  name
  userCount
  skillCount
}
    `;
export const AvatarListUserFragmentDoc = gql`
    fragment AvatarList_User on UserType {
  id
  firstName
  lastName
  email
  jobRole
  ...Avatar_User
}
    ${AvatarUserFragmentDoc}`;
export const DetailSkillFragmentDoc = gql`
    fragment Detail_Skill on Skill {
  id
  billableRate
  name
  category {
    id
    skillCount
    userCount
  }
  users {
    ...AvatarList_User
  }
}
    ${AvatarListUserFragmentDoc}`;
export const CategoryListSkillCategoryFragmentDoc = gql`
    fragment CategoryList_SkillCategory on SkillCategory {
  id
  ...Summary_SkillCategory
  skills {
    id
    ...Detail_Skill
  }
}
    ${SummarySkillCategoryFragmentDoc}
${DetailSkillFragmentDoc}`;
export const SkillsListSkillFragmentDoc = gql`
    fragment SkillsList_Skill on Skill {
  id
  name
  category {
    id
    name
  }
}
    `;
export const SkillsListUserFragmentDoc = gql`
    fragment SkillsList_User on UserType {
  id
  firstName
  lastName
  email
  jobRole
  ...Avatar_User
  skills {
    ...SkillsList_Skill
  }
}
    ${AvatarUserFragmentDoc}
${SkillsListSkillFragmentDoc}`;
export const CurrentCategoryFragmentDoc = gql`
    fragment Current_Category on SkillCategory {
  id
  skills {
    id
    users {
      id
    }
  }
}
    `;
export const GetCurrentCategoryFragmentDoc = gql`
    fragment GetCurrentCategory on SkillCategory {
  id
  skills {
    id
    users {
      id
    }
  }
}
    `;
export const ProjectCapacityUserFragmentDoc = gql`
    fragment ProjectCapacity_User on UserType {
  id
}
    `;
export const EditTaskDrawerProjectSnapshotFragmentDoc = gql`
    fragment EditTaskDrawer_ProjectSnapshotFragment on ProjectType {
  id
  startOn
  endOn
  completedAt
  forecastedEndOn
}
    `;
export const EditTaskDrawerProjectStatsFragmentDoc = gql`
    fragment EditTaskDrawer_ProjectStatsFragment on ProjectStats {
  totalTasks
  totalDoneTasks
  totalAssignedTasks
  totalTasksWithUnestimatedHoursCount
  totalActualHours
  totalInternalEstimatedHours
}
    `;
export const FilterOptionsCustomerFilterFragmentDoc = gql`
    fragment FilterOptions_CustomerFilter on CustomerType {
  id
  name
  logo {
    originalUrl
  }
}
    `;
export const TaskIndexTableRowTaskFragmentDoc = gql`
    fragment TaskIndexTableRow_Task on TaskType {
  id
  name
  taskType
  visibility
  currentUserTaskContext
  priority
  shouldWarnUpdateStatus
  template {
    id
    name
    hardDependency
  }
  assignee {
    id
    ...AssigneeAvatar_User
  }
  status
  dueOn
  signOffRequired
  milestone {
    id
    name
    sortOrder
  }
  taskGroup {
    id
  }
  dependency {
    ...DependencyIcon_Milestone
    ...DependencyIcon_Task
    ...DependencyIcon_Template
    ...DependencyIcon_TaskGroup
  }
  tags {
    ...Tags_AvailableTags
    __typename
  }
  project {
    id
    name
    currentUserProjectContext
    startOn
    endOn
    pmDisplayRole
    organization {
      id
    }
    customerV2 {
      id
      name
      logo {
        originalUrl
      }
    }
    projectType
  }
}
    ${AssigneeAvatarUserFragmentDoc}
${DependencyIconMilestoneFragmentDoc}
${DependencyIconTaskFragmentDoc}
${DependencyIconTemplateFragmentDoc}
${DependencyIconTaskGroupFragmentDoc}
${TagsAvailableTagsFragmentDoc}`;
export const TaskMilestoneFragmentDoc = gql`
    fragment taskMilestone on TaskType {
  milestone {
    id
  }
}
    `;
export const DeleteTaskDialogProjectSnapshotFragmentDoc = gql`
    fragment DeleteTaskDialog_ProjectSnapshotFragment on ProjectType {
  id
  startOn
  endOn
  completedAt
  forecastedEndOn
}
    `;
export const DeleteTaskDialogProjectStatsFragmentDoc = gql`
    fragment DeleteTaskDialog_ProjectStatsFragment on ProjectStats {
  totalTasks
  totalDoneTasks
  totalAssignedTasks
  totalTasksWithUnestimatedHoursCount
  totalActualHours
  totalInternalEstimatedHours
}
    `;
export const EditTemplateFormEditTemplateV2FragmentDoc = gql`
    fragment EditTemplateForm_EditTemplateV2 on TemplateType {
  id
  name
  sku
  description
  videoUrl
  experienceOverview
  hardDependency
  published
  videoPlaceholderImage {
    originalUrl
  }
  files {
    id
    fileName
    size
    url
    internalOnly
    isExternalHyperlink
  }
  milestones {
    id
    duration
    tasks {
      id
      duration
      dependency {
        ... on MilestoneType {
          id
          name
          completed
        }
        ... on TaskType {
          id
          name
          completed
        }
        ... on TemplateType {
          id
          name
          completed
        }
        ... on TaskGroupType {
          id
          name
          completed
        }
      }
    }
  }
}
    `;
export const FilterTemplatePlanDrawerAssigneeFragmentDoc = gql`
    fragment FilterTemplatePlanDrawer_Assignee on UserType {
  id
  ...FilterPlanForm_Assignee
}
    ${FilterPlanFormAssigneeFragmentDoc}`;
export const TemplateTableRowTemplateFragmentDoc = gql`
    fragment TemplateTableRowTemplate on TemplateType {
  id
  name
  sku
  description
  hardDependency
  videoUrl
  experienceOverview
  videoPlaceholderImage {
    originalUrl
  }
  published
  createdAt
  updatedAt
  creator {
    id
    firstName
    lastName
    avatar {
      originalUrl
    }
  }
  lastEditedBy {
    id
    firstName
    lastName
    avatar {
      originalUrl
    }
  }
}
    `;
export const TemplateIndexTemplateFragmentDoc = gql`
    fragment TemplateIndexTemplate on TemplateType {
  ...TemplateTableRowTemplate
}
    ${TemplateTableRowTemplateFragmentDoc}`;
export const TemplateFilesFileFragmentDoc = gql`
    fragment TemplateFiles_File on FileType {
  id
  url
  fileName
  size
  milestoneName
  deletable
  taskName
  uploader {
    id
    firstName
    lastName
  }
  createdAt
  internalOnly
  isExternalHyperlink
}
    `;
export const AddEditTimeEntryTimeRecordFragmentDoc = gql`
    fragment AddEditTimeEntryTimeRecordFragment on TimeRecordType {
  id
  dateWorked
  description
  billable
  hours
  categoryId
  worker {
    id
    firstName
    lastName
    avatar {
      originalUrl
    }
  }
  category {
    id
    name
  }
  taskId
  projectId
  workerId
}
    `;
export const AddEditTimeEntryTimeRecordPageFragmentDoc = gql`
    fragment AddEditTimeEntryTimeRecordPageFragment on PageInfoType {
  currentPage
  isOutOfBounds
  limit
  totalPages
  totalResults
}
    `;
export const CategoryOptionTimeTrackingCategoryFragmentDoc = gql`
    fragment CategoryOption_TimeTrackingCategory on TimeTrackingCategory {
  id
  name
  billable
}
    `;
export const PageInfoFragmentDoc = gql`
    fragment PageInfoFragment on PageInfoType {
  totalPages
  totalResults
  currentPage
  limit
  isOutOfBounds
}
    `;
export const CategoryInfinitySelectorOrganizationTypeFragmentDoc = gql`
    fragment CategoryInfinitySelector_OrganizationType on OrganizationType {
  id
  timeTrackingCategoryConnections(listInputs: $listInputs) {
    categories {
      id
      ...CategoryOption_TimeTrackingCategory
    }
    pageInfo {
      ...PageInfoFragment
    }
  }
}
    ${CategoryOptionTimeTrackingCategoryFragmentDoc}
${PageInfoFragmentDoc}`;
export const SummaryRowMilestoneFragmentDoc = gql`
    fragment SummaryRow_Milestone on MilestoneType {
  id
  status
}
    `;
export const TimeReportColumnsTimeReportFragmentDoc = gql`
    fragment TimeReportColumns_TimeReport on TimeReport {
  estimatedHours
  nonBillableHours
  billableHours
  totalHours
  totalCost
  totalBilled
  revenue
  allTimeUserProjectTotalHours
}
    `;
export const MilestoneRowMilestoneFragmentDoc = gql`
    fragment MilestoneRow_Milestone on MilestoneType {
  id
  name
  timeReport(startDate: $startDate, endDate: $endDate, filters: $filters) {
    ...TimeReportColumns_TimeReport
  }
}
    ${TimeReportColumnsTimeReportFragmentDoc}`;
export const MilestoneAccordionMilestoneFragmentDoc = gql`
    fragment MilestoneAccordion_Milestone on MilestoneType {
  id
  taskCount(taskResponsibilities: $taskResponsibilities)
  ...SummaryRow_Milestone
  ...MilestoneRow_Milestone
}
    ${SummaryRowMilestoneFragmentDoc}
${MilestoneRowMilestoneFragmentDoc}`;
export const SummaryRowTaskFragmentDoc = gql`
    fragment SummaryRow_Task on TaskType {
  id
  status
}
    `;
export const PaginatedUsersForTimeRecordsUserFragmentDoc = gql`
    fragment PaginatedUsersForTimeRecords_User on UserType {
  id
  firstName
  lastName
  jobRole
  ...Avatar_User
}
    ${AvatarUserFragmentDoc}`;
export const TaskRowTaskFragmentDoc = gql`
    fragment TaskRow_Task on TaskType {
  id
  name
  taskType
  dueOn
  project {
    id
    projectBillRate {
      rateType
    }
  }
  paginatedUsersForTimeRecords(startDate: $startDate, endDate: $endDate) {
    users {
      ...PaginatedUsersForTimeRecords_User
      email
    }
    pageInfo {
      ...PageInfoFragment
      __typename
    }
  }
  milestone {
    id
    name
  }
  timeReport(
    startDate: $startDate
    endDate: $endDate
    filters: $filters
    userId: $userId
  ) {
    ...TimeReportColumns_TimeReport
  }
  timeRecordsPeriod(startDate: $startDate, endDate: $endDate, userId: $userId) @include(if: $includeTimeRecords) {
    id
    billable
    dateWorked
    hours
  }
}
    ${PaginatedUsersForTimeRecordsUserFragmentDoc}
${PageInfoFragmentDoc}
${TimeReportColumnsTimeReportFragmentDoc}`;
export const MilestoneAccordionTaskFragmentDoc = gql`
    fragment MilestoneAccordion_Task on TaskType {
  id
  ...SummaryRow_Task
  ...TaskRow_Task
}
    ${SummaryRowTaskFragmentDoc}
${TaskRowTaskFragmentDoc}`;
export const SummaryRowProjectFragmentDoc = gql`
    fragment SummaryRow_Project on ProjectType {
  id
  status
}
    `;
export const ProjectRowProjectFragmentDoc = gql`
    fragment ProjectRow_Project on ProjectType {
  id
  name
  projectBillRate {
    rateType
  }
  timeReport(
    startDate: $startDate
    endDate: $endDate
    filters: $filters
    userId: $userId
    includeGeneric: $includeGeneric
  ) {
    ...TimeReportColumns_TimeReport
  }
  genericTimeReport(
    startDate: $startDate
    endDate: $endDate
    filters: $filters
    userId: $userId
  ) @include(if: $includeGeneric) {
    ...TimeReportColumns_TimeReport
  }
  timeRecordsPeriod(userId: $userId, startDate: $startDate, endDate: $endDate) @include(if: $includeTimeRecords) {
    id
    billable
    dateWorked
    hours
  }
}
    ${TimeReportColumnsTimeReportFragmentDoc}`;
export const MilestoneDetailsProjectFragmentDoc = gql`
    fragment MilestoneDetails_Project on ProjectType {
  id
  milestoneCount
}
    `;
export const TaskDetailsProjectFragmentDoc = gql`
    fragment TaskDetails_Project on ProjectType {
  id
  timeReportingTasksCount(
    userId: $userId
    filters: $filters
    startDate: $startDate
    endDate: $endDate
  ) @include(if: $includeTimeRecords)
}
    `;
export const ProjectAccordionProjectFragmentDoc = gql`
    fragment ProjectAccordion_Project on ProjectType {
  id
  ...SummaryRow_Project
  ...ProjectRow_Project
  ...MilestoneDetails_Project @include(if: $isRootView)
  ...TaskDetails_Project
}
    ${SummaryRowProjectFragmentDoc}
${ProjectRowProjectFragmentDoc}
${MilestoneDetailsProjectFragmentDoc}
${TaskDetailsProjectFragmentDoc}`;
export const TaskDetailTaskFragmentDoc = gql`
    fragment TaskDetail_Task on TaskType {
  id
  ...SummaryRow_Task
  ...TaskRow_Task
}
    ${SummaryRowTaskFragmentDoc}
${TaskRowTaskFragmentDoc}`;
export const DateFieldProjectTypeFragmentDoc = gql`
    fragment DateField_ProjectType on ProjectType {
  id
  organization {
    id
    disableTimeEntryForPastMonths
    disableTimeEntryForCompletedProjects
  }
}
    `;
export const TimeEntryDialogProjectTypeFragmentDoc = gql`
    fragment TimeEntryDialog_ProjectType on ProjectType {
  id
  name
  status
  projectBillRate {
    id
    rateType
  }
  ...DateField_ProjectType
}
    ${DateFieldProjectTypeFragmentDoc}`;
export const AutoFillButtonTaskTypeFragmentDoc = gql`
    fragment AutoFillButton_TaskType on TaskType {
  id
  estimatedHours
  totalHours
}
    `;
export const TimeFieldsTaskTypeFragmentDoc = gql`
    fragment TimeFields_TaskType on TaskType {
  id
  ...AutoFillButton_TaskType
}
    ${AutoFillButtonTaskTypeFragmentDoc}`;
export const TimeEntryDialogTaskTypeFragmentDoc = gql`
    fragment TimeEntryDialog_TaskType on TaskType {
  id
  name
  milestone {
    id
  }
  project {
    id
    status
    projectBillRate {
      id
      rateType
    }
    ...DateField_ProjectType
  }
  ...TimeFields_TaskType
}
    ${DateFieldProjectTypeFragmentDoc}
${TimeFieldsTaskTypeFragmentDoc}`;
export const TimeReportSummaryTimeReportSummaryFragmentDoc = gql`
    fragment TimeReportSummary_TimeReportSummary on TimeReportSummary {
  billableHours
  estimatedHours
  nonBillableHours
  totalHours
  totalCost
  totalBilled
  warning
}
    `;
export const UserRowUserFragmentDoc = gql`
    fragment UserRow_User on UserType {
  id
  firstName
  lastName
  timeReport(
    startDate: $startDate
    endDate: $endDate
    filters: $filters
    includeGeneric: $includeGeneric
  ) {
    ...TimeReportColumns_TimeReport
  }
}
    ${TimeReportColumnsTimeReportFragmentDoc}`;
export const SummaryRowUserFragmentDoc = gql`
    fragment SummaryRow_User on UserType {
  id
  ...Avatar_User
}
    ${AvatarUserFragmentDoc}`;
export const UserAccordionUserFragmentDoc = gql`
    fragment UserAccordion_User on UserType {
  id
  timeReportingProjectsCount(
    filters: $filters
    startDate: $startDate
    endDate: $endDate
  )
  ...UserRow_User
  ...SummaryRow_User
}
    ${UserRowUserFragmentDoc}
${SummaryRowUserFragmentDoc}`;
export const CurrentUserFragmentDoc = gql`
    fragment CurrentUser on UserType {
  id
  firstName
  lastName
  email
  role
  adminTeamsEnabled
  createdAt
  hasAccount
  onlyNotificationsTeamsEnabled
  projectsCount
  weeklyHours
  avatar {
    originalUrl
  }
  organization {
    id
    billableRate
    brandsEnabled
    countryCode
    createdAt
    currencyCode
    customerDashboardEnabled
    defaultTaskVisibility
    domain
    jiraEnabled
    name
    pmCanEditSkills
    primaryColor
    resourceManagementEnabled
    secureLinksEnabled
    taskFilterByFunction
    timeTrackingEnabled
    trial
    type
    whiteLabelingEnabled
    adminSettings {
      uploadLimitMb
    }
    logo {
      originalUrl
    }
    setting {
      useStatusChangeReasons
    }
  }
}
    `;
export const ResourceUserFragmentDoc = gql`
    fragment ResourceUser on UserType {
  id
  firstName
  lastName
  email
  role
  status
  createdAt
  jobRole
  isThirdParty
  skills {
    id
    name
  }
  skills {
    id
    name
    category {
      id
    }
  }
  avatar {
    originalUrl
  }
}
    `;
export const ProjectReassignFragmentDoc = gql`
    fragment ProjectReassign on ProjectType {
  id
  name
  projectManager {
    id
    firstName
    lastName
  }
  status
  customerV2 {
    id
    logo {
      originalUrl
    }
  }
}
    `;
export const TaskReassignFragmentDoc = gql`
    fragment TaskReassign on TaskType {
  id
  name
  description
  status
  project {
    id
    name
    status
    organization {
      id
    }
  }
}
    `;
export const CompanyDetailLayoutOrganizationFragmentDoc = gql`
    fragment CompanyDetailLayout_Organization on OrganizationType {
  id
  name
  domain
  deactivated
  logo {
    originalUrl
  }
}
    `;
export const CurrentUserProjectContextProviderProjectFragmentDoc = gql`
    fragment CurrentUserProjectContextProvider_Project on ProjectType {
  currentUserProjectContext
  organization {
    name
    resourceManagementEnabled
  }
}
    `;
export const TabsProjectFragmentDoc = gql`
    fragment Tabs_Project on ProjectType {
  id
  currentUserRestrictedAccess
  currentUserProjectContext
  usesCategories
  status
  organization {
    id
    resourceManagementEnabled
    timeTrackingEnabled
  }
}
    `;
export const ProjectLayoutProjectFragmentDoc = gql`
    fragment ProjectLayout_Project on ProjectType {
  id
  name
  currentUserRestrictedAccess
  currentUserProjectContext
  creating
  displayOrganization {
    name
    logo {
      originalUrl
    }
  }
  profitabilitySummary {
    totalCost
    totalBilledAmount
    totalProfit
    budgetedCost
    forecastedCost
  }
  users {
    id
    firstName
    lastName
    jobRole
    avatar {
      originalUrl
    }
  }
  pmDisplayRole
  pmNote
  projectManager {
    id
    firstName
    lastName
    avatar {
      originalUrl
    }
  }
  archivedAt
  ...CurrentUserProjectContextProvider_Project
  ...Tabs_Project
}
    ${CurrentUserProjectContextProviderProjectFragmentDoc}
${TabsProjectFragmentDoc}`;
export const EditTemplateFormTemplateFragmentDoc = gql`
    fragment EditTemplateForm_Template on TemplateType {
  id
  name
  sku
  description
  videoUrl
  experienceOverview
  hardDependency
  published
  videoPlaceholderImage {
    originalUrl
  }
  files {
    id
    fileName
    size
    url
    deletable
    internalOnly
    isExternalHyperlink
    uploader {
      id
      firstName
      lastName
      avatar {
        originalUrl
      }
    }
  }
}
    `;
export const EditTemplateDrawerTemplateFragmentDoc = gql`
    fragment EditTemplateDrawer_Template on TemplateType {
  ...EditTemplateForm_Template
}
    ${EditTemplateFormTemplateFragmentDoc}`;
export const ConfirmDuplicateTemplateDialogFragmentDoc = gql`
    fragment ConfirmDuplicateTemplateDialog on TemplateType {
  id
  name
}
    `;
export const ConfirmDeleteTemplateDialogTemplateFragmentDoc = gql`
    fragment ConfirmDeleteTemplateDialogTemplate on TemplateType {
  id
  name
}
    `;
export const TemplateShowLayoutTemplateFragmentDoc = gql`
    fragment TemplateShowLayout_Template on TemplateType {
  id
  name
  ...EditTemplateDrawer_Template
  ...ConfirmDuplicateTemplateDialog
  ...ConfirmDeleteTemplateDialogTemplate
}
    ${EditTemplateDrawerTemplateFragmentDoc}
${ConfirmDuplicateTemplateDialogFragmentDoc}
${ConfirmDeleteTemplateDialogTemplateFragmentDoc}`;
export const BulkAssignmentMutationBulkAssignmentDocument = gql`
    mutation BulkAssignmentMutation_BulkAssignment($taskIds: [ID!]!, $responsibility: TaskResponsibilityEnumType!, $assigneeId: ID) {
  bulkEditTasks(
    input: {taskIds: $taskIds, responsibility: $responsibility, assigneeId: $assigneeId}
  ) {
    updatedTasks {
      __typename
    }
  }
}
    `;
export type BulkAssignmentMutationBulkAssignmentMutationFn = Apollo.MutationFunction<BulkAssignmentMutationBulkAssignmentMutation, BulkAssignmentMutationBulkAssignmentMutationVariables>;

/**
 * __useBulkAssignmentMutationBulkAssignment__
 *
 * To run a mutation, you first call `useBulkAssignmentMutationBulkAssignment` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkAssignmentMutationBulkAssignment` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkAssignmentMutationBulkAssignment, { data, loading, error }] = useBulkAssignmentMutationBulkAssignment({
 *   variables: {
 *      taskIds: // value for 'taskIds'
 *      responsibility: // value for 'responsibility'
 *      assigneeId: // value for 'assigneeId'
 *   },
 * });
 */
export function useBulkAssignmentMutationBulkAssignment(baseOptions?: Apollo.MutationHookOptions<BulkAssignmentMutationBulkAssignmentMutation, BulkAssignmentMutationBulkAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkAssignmentMutationBulkAssignmentMutation, BulkAssignmentMutationBulkAssignmentMutationVariables>(BulkAssignmentMutationBulkAssignmentDocument, options);
      }
export type BulkAssignmentMutationBulkAssignmentHookResult = ReturnType<typeof useBulkAssignmentMutationBulkAssignment>;
export type BulkAssignmentMutationBulkAssignmentMutationResult = Apollo.MutationResult<BulkAssignmentMutationBulkAssignmentMutation>;
export type BulkAssignmentMutationBulkAssignmentMutationOptions = Apollo.BaseMutationOptions<BulkAssignmentMutationBulkAssignmentMutation, BulkAssignmentMutationBulkAssignmentMutationVariables>;
export const ActionItemQueryActionItemDocument = gql`
    query ActionItemQuery_ActionItem($id: ID!) {
  actionItem(id: $id) {
    ...ActionItemForm_ActionItem
  }
}
    ${ActionItemFormActionItemFragmentDoc}`;

/**
 * __useActionItemQueryActionItem__
 *
 * To run a query within a React component, call `useActionItemQueryActionItem` and pass it any options that fit your needs.
 * When your component renders, `useActionItemQueryActionItem` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionItemQueryActionItem({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActionItemQueryActionItem(baseOptions: Apollo.QueryHookOptions<ActionItemQueryActionItemQuery, ActionItemQueryActionItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActionItemQueryActionItemQuery, ActionItemQueryActionItemQueryVariables>(ActionItemQueryActionItemDocument, options);
      }
export function useActionItemQueryActionItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActionItemQueryActionItemQuery, ActionItemQueryActionItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActionItemQueryActionItemQuery, ActionItemQueryActionItemQueryVariables>(ActionItemQueryActionItemDocument, options);
        }
export type ActionItemQueryActionItemHookResult = ReturnType<typeof useActionItemQueryActionItem>;
export type ActionItemQueryActionItemLazyQueryHookResult = ReturnType<typeof useActionItemQueryActionItemLazyQuery>;
export type ActionItemQueryActionItemQueryResult = Apollo.QueryResult<ActionItemQueryActionItemQuery, ActionItemQueryActionItemQueryVariables>;
export const ProjectFilterOptionsProjectFilterOptionsDocument = gql`
    query ProjectFilterOptions_ProjectFilterOptions {
  projectManagers {
    ...UserMenuOption_User
  }
  projectTemplates {
    id
    name
  }
  projectBrands
  projectActiveMilestones
  userDefaultFilterView(category: "project") {
    id
    jsonFilterBlob
  }
  availableTags: currentUserTags(type: "Project") {
    id
    color
    name
    internalOnly
  }
}
    ${UserMenuOptionUserFragmentDoc}`;

/**
 * __useProjectFilterOptionsProjectFilterOptionsQuery__
 *
 * To run a query within a React component, call `useProjectFilterOptionsProjectFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectFilterOptionsProjectFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectFilterOptionsProjectFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProjectFilterOptionsProjectFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<ProjectFilterOptionsProjectFilterOptionsQuery, ProjectFilterOptionsProjectFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectFilterOptionsProjectFilterOptionsQuery, ProjectFilterOptionsProjectFilterOptionsQueryVariables>(ProjectFilterOptionsProjectFilterOptionsDocument, options);
      }
export function useProjectFilterOptionsProjectFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectFilterOptionsProjectFilterOptionsQuery, ProjectFilterOptionsProjectFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectFilterOptionsProjectFilterOptionsQuery, ProjectFilterOptionsProjectFilterOptionsQueryVariables>(ProjectFilterOptionsProjectFilterOptionsDocument, options);
        }
export type ProjectFilterOptionsProjectFilterOptionsQueryHookResult = ReturnType<typeof useProjectFilterOptionsProjectFilterOptionsQuery>;
export type ProjectFilterOptionsProjectFilterOptionsLazyQueryHookResult = ReturnType<typeof useProjectFilterOptionsProjectFilterOptionsLazyQuery>;
export type ProjectFilterOptionsProjectFilterOptionsQueryResult = Apollo.QueryResult<ProjectFilterOptionsProjectFilterOptionsQuery, ProjectFilterOptionsProjectFilterOptionsQueryVariables>;
export const CustomFieldsInfoFieldsDocument = gql`
    query CustomFields_InfoFields($organizationId: ID!) {
  infoFields(organizationId: $organizationId) {
    id
    ...EditCustomFieldDrawer_MergeTag
  }
}
    ${EditCustomFieldDrawerMergeTagFragmentDoc}`;

/**
 * __useCustomFieldsInfoFieldsQuery__
 *
 * To run a query within a React component, call `useCustomFieldsInfoFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomFieldsInfoFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomFieldsInfoFieldsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useCustomFieldsInfoFieldsQuery(baseOptions: Apollo.QueryHookOptions<CustomFieldsInfoFieldsQuery, CustomFieldsInfoFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomFieldsInfoFieldsQuery, CustomFieldsInfoFieldsQueryVariables>(CustomFieldsInfoFieldsDocument, options);
      }
export function useCustomFieldsInfoFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomFieldsInfoFieldsQuery, CustomFieldsInfoFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomFieldsInfoFieldsQuery, CustomFieldsInfoFieldsQueryVariables>(CustomFieldsInfoFieldsDocument, options);
        }
export type CustomFieldsInfoFieldsQueryHookResult = ReturnType<typeof useCustomFieldsInfoFieldsQuery>;
export type CustomFieldsInfoFieldsLazyQueryHookResult = ReturnType<typeof useCustomFieldsInfoFieldsLazyQuery>;
export type CustomFieldsInfoFieldsQueryResult = Apollo.QueryResult<CustomFieldsInfoFieldsQuery, CustomFieldsInfoFieldsQueryVariables>;
export const CustomFieldsUpsertInfoFieldDocument = gql`
    mutation CustomFields_UpsertInfoField($input: upsertInfoFieldInput!) {
  upsertInfoField(input: $input) {
    infoField {
      id
      ...EditCustomFieldDrawer_MergeTag
    }
  }
}
    ${EditCustomFieldDrawerMergeTagFragmentDoc}`;
export type CustomFieldsUpsertInfoFieldMutationFn = Apollo.MutationFunction<CustomFieldsUpsertInfoFieldMutation, CustomFieldsUpsertInfoFieldMutationVariables>;

/**
 * __useCustomFieldsUpsertInfoFieldMutation__
 *
 * To run a mutation, you first call `useCustomFieldsUpsertInfoFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomFieldsUpsertInfoFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customFieldsUpsertInfoFieldMutation, { data, loading, error }] = useCustomFieldsUpsertInfoFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomFieldsUpsertInfoFieldMutation(baseOptions?: Apollo.MutationHookOptions<CustomFieldsUpsertInfoFieldMutation, CustomFieldsUpsertInfoFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomFieldsUpsertInfoFieldMutation, CustomFieldsUpsertInfoFieldMutationVariables>(CustomFieldsUpsertInfoFieldDocument, options);
      }
export type CustomFieldsUpsertInfoFieldMutationHookResult = ReturnType<typeof useCustomFieldsUpsertInfoFieldMutation>;
export type CustomFieldsUpsertInfoFieldMutationResult = Apollo.MutationResult<CustomFieldsUpsertInfoFieldMutation>;
export type CustomFieldsUpsertInfoFieldMutationOptions = Apollo.BaseMutationOptions<CustomFieldsUpsertInfoFieldMutation, CustomFieldsUpsertInfoFieldMutationVariables>;
export const CustomFieldsRemoveCustomFieldDocument = gql`
    mutation CustomFields_RemoveCustomField($customField: removeCustomFieldInput!) {
  removeCustomField(input: $customField) {
    success
  }
}
    `;
export type CustomFieldsRemoveCustomFieldMutationFn = Apollo.MutationFunction<CustomFieldsRemoveCustomFieldMutation, CustomFieldsRemoveCustomFieldMutationVariables>;

/**
 * __useCustomFieldsRemoveCustomFieldMutation__
 *
 * To run a mutation, you first call `useCustomFieldsRemoveCustomFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomFieldsRemoveCustomFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customFieldsRemoveCustomFieldMutation, { data, loading, error }] = useCustomFieldsRemoveCustomFieldMutation({
 *   variables: {
 *      customField: // value for 'customField'
 *   },
 * });
 */
export function useCustomFieldsRemoveCustomFieldMutation(baseOptions?: Apollo.MutationHookOptions<CustomFieldsRemoveCustomFieldMutation, CustomFieldsRemoveCustomFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomFieldsRemoveCustomFieldMutation, CustomFieldsRemoveCustomFieldMutationVariables>(CustomFieldsRemoveCustomFieldDocument, options);
      }
export type CustomFieldsRemoveCustomFieldMutationHookResult = ReturnType<typeof useCustomFieldsRemoveCustomFieldMutation>;
export type CustomFieldsRemoveCustomFieldMutationResult = Apollo.MutationResult<CustomFieldsRemoveCustomFieldMutation>;
export type CustomFieldsRemoveCustomFieldMutationOptions = Apollo.BaseMutationOptions<CustomFieldsRemoveCustomFieldMutation, CustomFieldsRemoveCustomFieldMutationVariables>;
export const CustomFieldsRemoveMergeTagDocument = gql`
    mutation CustomFields_RemoveMergeTag($mergeTagId: ID!) {
  deleteMergeTag(id: $mergeTagId) {
    success
  }
}
    `;
export type CustomFieldsRemoveMergeTagMutationFn = Apollo.MutationFunction<CustomFieldsRemoveMergeTagMutation, CustomFieldsRemoveMergeTagMutationVariables>;

/**
 * __useCustomFieldsRemoveMergeTagMutation__
 *
 * To run a mutation, you first call `useCustomFieldsRemoveMergeTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomFieldsRemoveMergeTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customFieldsRemoveMergeTagMutation, { data, loading, error }] = useCustomFieldsRemoveMergeTagMutation({
 *   variables: {
 *      mergeTagId: // value for 'mergeTagId'
 *   },
 * });
 */
export function useCustomFieldsRemoveMergeTagMutation(baseOptions?: Apollo.MutationHookOptions<CustomFieldsRemoveMergeTagMutation, CustomFieldsRemoveMergeTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomFieldsRemoveMergeTagMutation, CustomFieldsRemoveMergeTagMutationVariables>(CustomFieldsRemoveMergeTagDocument, options);
      }
export type CustomFieldsRemoveMergeTagMutationHookResult = ReturnType<typeof useCustomFieldsRemoveMergeTagMutation>;
export type CustomFieldsRemoveMergeTagMutationResult = Apollo.MutationResult<CustomFieldsRemoveMergeTagMutation>;
export type CustomFieldsRemoveMergeTagMutationOptions = Apollo.BaseMutationOptions<CustomFieldsRemoveMergeTagMutation, CustomFieldsRemoveMergeTagMutationVariables>;
export const CustomFieldsReorderInfoFieldsDocument = gql`
    mutation CustomFields_ReorderInfoFields($input: ReorderInfoFieldInput!) {
  reorderInfoField(input: $input) {
    infoField {
      id
      sortOrder
    }
  }
}
    `;
export type CustomFieldsReorderInfoFieldsMutationFn = Apollo.MutationFunction<CustomFieldsReorderInfoFieldsMutation, CustomFieldsReorderInfoFieldsMutationVariables>;

/**
 * __useCustomFieldsReorderInfoFieldsMutation__
 *
 * To run a mutation, you first call `useCustomFieldsReorderInfoFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomFieldsReorderInfoFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customFieldsReorderInfoFieldsMutation, { data, loading, error }] = useCustomFieldsReorderInfoFieldsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomFieldsReorderInfoFieldsMutation(baseOptions?: Apollo.MutationHookOptions<CustomFieldsReorderInfoFieldsMutation, CustomFieldsReorderInfoFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomFieldsReorderInfoFieldsMutation, CustomFieldsReorderInfoFieldsMutationVariables>(CustomFieldsReorderInfoFieldsDocument, options);
      }
export type CustomFieldsReorderInfoFieldsMutationHookResult = ReturnType<typeof useCustomFieldsReorderInfoFieldsMutation>;
export type CustomFieldsReorderInfoFieldsMutationResult = Apollo.MutationResult<CustomFieldsReorderInfoFieldsMutation>;
export type CustomFieldsReorderInfoFieldsMutationOptions = Apollo.BaseMutationOptions<CustomFieldsReorderInfoFieldsMutation, CustomFieldsReorderInfoFieldsMutationVariables>;
export const CompanyIntegrationsOrganizationDocument = gql`
    query CompanyIntegrations_Organization($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    ...OpenApiSettings_Organization
    ...JiraIntegration_Organization
    ...HubSpotIntegration_Organization
    ...SlackIntegration_Organization
    ...SalesforceIntegration_Organization
  }
}
    ${OpenApiSettingsOrganizationFragmentDoc}
${JiraIntegrationOrganizationFragmentDoc}
${HubSpotIntegrationOrganizationFragmentDoc}
${SlackIntegrationOrganizationFragmentDoc}
${SalesforceIntegrationOrganizationFragmentDoc}`;

/**
 * __useCompanyIntegrationsOrganizationQuery__
 *
 * To run a query within a React component, call `useCompanyIntegrationsOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyIntegrationsOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyIntegrationsOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useCompanyIntegrationsOrganizationQuery(baseOptions: Apollo.QueryHookOptions<CompanyIntegrationsOrganizationQuery, CompanyIntegrationsOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyIntegrationsOrganizationQuery, CompanyIntegrationsOrganizationQueryVariables>(CompanyIntegrationsOrganizationDocument, options);
      }
export function useCompanyIntegrationsOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyIntegrationsOrganizationQuery, CompanyIntegrationsOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyIntegrationsOrganizationQuery, CompanyIntegrationsOrganizationQueryVariables>(CompanyIntegrationsOrganizationDocument, options);
        }
export type CompanyIntegrationsOrganizationQueryHookResult = ReturnType<typeof useCompanyIntegrationsOrganizationQuery>;
export type CompanyIntegrationsOrganizationLazyQueryHookResult = ReturnType<typeof useCompanyIntegrationsOrganizationLazyQuery>;
export type CompanyIntegrationsOrganizationQueryResult = Apollo.QueryResult<CompanyIntegrationsOrganizationQuery, CompanyIntegrationsOrganizationQueryVariables>;
export const CompanyOpenApiOrganizationDocument = gql`
    query CompanyOpenApi_Organization($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    ...OpenApiSettings_Organization
  }
}
    ${OpenApiSettingsOrganizationFragmentDoc}`;

/**
 * __useCompanyOpenApiOrganizationQuery__
 *
 * To run a query within a React component, call `useCompanyOpenApiOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyOpenApiOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyOpenApiOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useCompanyOpenApiOrganizationQuery(baseOptions: Apollo.QueryHookOptions<CompanyOpenApiOrganizationQuery, CompanyOpenApiOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyOpenApiOrganizationQuery, CompanyOpenApiOrganizationQueryVariables>(CompanyOpenApiOrganizationDocument, options);
      }
export function useCompanyOpenApiOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyOpenApiOrganizationQuery, CompanyOpenApiOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyOpenApiOrganizationQuery, CompanyOpenApiOrganizationQueryVariables>(CompanyOpenApiOrganizationDocument, options);
        }
export type CompanyOpenApiOrganizationQueryHookResult = ReturnType<typeof useCompanyOpenApiOrganizationQuery>;
export type CompanyOpenApiOrganizationLazyQueryHookResult = ReturnType<typeof useCompanyOpenApiOrganizationLazyQuery>;
export type CompanyOpenApiOrganizationQueryResult = Apollo.QueryResult<CompanyOpenApiOrganizationQuery, CompanyOpenApiOrganizationQueryVariables>;
export const CompanySettingsOrganizationDetailsDocument = gql`
    query CompanySettings_OrganizationDetails($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    bccEmail
    uploadsViaEmailEnabled
    setting {
      brandedEmailSenderEnabled
    }
    ...ProjectProviderSettings_Organization
    ...WhiteLabelingSettings_Organization
    ...AuthenticationSettings_Organization
  }
}
    ${ProjectProviderSettingsOrganizationFragmentDoc}
${WhiteLabelingSettingsOrganizationFragmentDoc}
${AuthenticationSettingsOrganizationFragmentDoc}`;

/**
 * __useCompanySettingsOrganizationDetailsQuery__
 *
 * To run a query within a React component, call `useCompanySettingsOrganizationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanySettingsOrganizationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanySettingsOrganizationDetailsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useCompanySettingsOrganizationDetailsQuery(baseOptions: Apollo.QueryHookOptions<CompanySettingsOrganizationDetailsQuery, CompanySettingsOrganizationDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanySettingsOrganizationDetailsQuery, CompanySettingsOrganizationDetailsQueryVariables>(CompanySettingsOrganizationDetailsDocument, options);
      }
export function useCompanySettingsOrganizationDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanySettingsOrganizationDetailsQuery, CompanySettingsOrganizationDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanySettingsOrganizationDetailsQuery, CompanySettingsOrganizationDetailsQueryVariables>(CompanySettingsOrganizationDetailsDocument, options);
        }
export type CompanySettingsOrganizationDetailsQueryHookResult = ReturnType<typeof useCompanySettingsOrganizationDetailsQuery>;
export type CompanySettingsOrganizationDetailsLazyQueryHookResult = ReturnType<typeof useCompanySettingsOrganizationDetailsLazyQuery>;
export type CompanySettingsOrganizationDetailsQueryResult = Apollo.QueryResult<CompanySettingsOrganizationDetailsQuery, CompanySettingsOrganizationDetailsQueryVariables>;
export const CompanySettingsUpdateSettingsDocument = gql`
    mutation CompanySettings_UpdateSettings($organization: updateOrganizationInput!) {
  updateOrganization(input: $organization) {
    organization {
      id
      bccEmail
      uploadsViaEmailEnabled
      ...ProjectProviderSettings_Organization
      ...WhiteLabelingSettings_Organization
      ...AuthenticationSettings_Organization
    }
  }
}
    ${ProjectProviderSettingsOrganizationFragmentDoc}
${WhiteLabelingSettingsOrganizationFragmentDoc}
${AuthenticationSettingsOrganizationFragmentDoc}`;
export type CompanySettingsUpdateSettingsMutationFn = Apollo.MutationFunction<CompanySettingsUpdateSettingsMutation, CompanySettingsUpdateSettingsMutationVariables>;

/**
 * __useCompanySettingsUpdateSettingsMutation__
 *
 * To run a mutation, you first call `useCompanySettingsUpdateSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanySettingsUpdateSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companySettingsUpdateSettingsMutation, { data, loading, error }] = useCompanySettingsUpdateSettingsMutation({
 *   variables: {
 *      organization: // value for 'organization'
 *   },
 * });
 */
export function useCompanySettingsUpdateSettingsMutation(baseOptions?: Apollo.MutationHookOptions<CompanySettingsUpdateSettingsMutation, CompanySettingsUpdateSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanySettingsUpdateSettingsMutation, CompanySettingsUpdateSettingsMutationVariables>(CompanySettingsUpdateSettingsDocument, options);
      }
export type CompanySettingsUpdateSettingsMutationHookResult = ReturnType<typeof useCompanySettingsUpdateSettingsMutation>;
export type CompanySettingsUpdateSettingsMutationResult = Apollo.MutationResult<CompanySettingsUpdateSettingsMutation>;
export type CompanySettingsUpdateSettingsMutationOptions = Apollo.BaseMutationOptions<CompanySettingsUpdateSettingsMutation, CompanySettingsUpdateSettingsMutationVariables>;
export const CompanySettingsOrganizationDomainsDocument = gql`
    query CompanySettings_OrganizationDomains($organizationId: ID!) {
  getOrganizationDomains(organizationId: $organizationId) {
    ...EmailSettings_Domain
  }
}
    ${EmailSettingsDomainFragmentDoc}`;

/**
 * __useCompanySettingsOrganizationDomainsQuery__
 *
 * To run a query within a React component, call `useCompanySettingsOrganizationDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanySettingsOrganizationDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanySettingsOrganizationDomainsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useCompanySettingsOrganizationDomainsQuery(baseOptions: Apollo.QueryHookOptions<CompanySettingsOrganizationDomainsQuery, CompanySettingsOrganizationDomainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanySettingsOrganizationDomainsQuery, CompanySettingsOrganizationDomainsQueryVariables>(CompanySettingsOrganizationDomainsDocument, options);
      }
export function useCompanySettingsOrganizationDomainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanySettingsOrganizationDomainsQuery, CompanySettingsOrganizationDomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanySettingsOrganizationDomainsQuery, CompanySettingsOrganizationDomainsQueryVariables>(CompanySettingsOrganizationDomainsDocument, options);
        }
export type CompanySettingsOrganizationDomainsQueryHookResult = ReturnType<typeof useCompanySettingsOrganizationDomainsQuery>;
export type CompanySettingsOrganizationDomainsLazyQueryHookResult = ReturnType<typeof useCompanySettingsOrganizationDomainsLazyQuery>;
export type CompanySettingsOrganizationDomainsQueryResult = Apollo.QueryResult<CompanySettingsOrganizationDomainsQuery, CompanySettingsOrganizationDomainsQueryVariables>;
export const CompanySettingsUpdateDomainRecordsDocument = gql`
    mutation CompanySettings_UpdateDomainRecords($domainAuthValues: updateDomainAuthRecordsInput!) {
  updateDomainAuthRecords(input: $domainAuthValues) {
    domainVerification {
      ...EmailSettings_Domain
    }
  }
}
    ${EmailSettingsDomainFragmentDoc}`;
export type CompanySettingsUpdateDomainRecordsMutationFn = Apollo.MutationFunction<CompanySettingsUpdateDomainRecordsMutation, CompanySettingsUpdateDomainRecordsMutationVariables>;

/**
 * __useCompanySettingsUpdateDomainRecordsMutation__
 *
 * To run a mutation, you first call `useCompanySettingsUpdateDomainRecordsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanySettingsUpdateDomainRecordsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companySettingsUpdateDomainRecordsMutation, { data, loading, error }] = useCompanySettingsUpdateDomainRecordsMutation({
 *   variables: {
 *      domainAuthValues: // value for 'domainAuthValues'
 *   },
 * });
 */
export function useCompanySettingsUpdateDomainRecordsMutation(baseOptions?: Apollo.MutationHookOptions<CompanySettingsUpdateDomainRecordsMutation, CompanySettingsUpdateDomainRecordsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanySettingsUpdateDomainRecordsMutation, CompanySettingsUpdateDomainRecordsMutationVariables>(CompanySettingsUpdateDomainRecordsDocument, options);
      }
export type CompanySettingsUpdateDomainRecordsMutationHookResult = ReturnType<typeof useCompanySettingsUpdateDomainRecordsMutation>;
export type CompanySettingsUpdateDomainRecordsMutationResult = Apollo.MutationResult<CompanySettingsUpdateDomainRecordsMutation>;
export type CompanySettingsUpdateDomainRecordsMutationOptions = Apollo.BaseMutationOptions<CompanySettingsUpdateDomainRecordsMutation, CompanySettingsUpdateDomainRecordsMutationVariables>;
export const CompanySettingsSendVerificationInstructionsDocument = gql`
    mutation CompanySettings_SendVerificationInstructions($input: domainVerificationInstructionsInput!) {
  domainVerificationInstructions(input: $input) {
    success
  }
}
    `;
export type CompanySettingsSendVerificationInstructionsMutationFn = Apollo.MutationFunction<CompanySettingsSendVerificationInstructionsMutation, CompanySettingsSendVerificationInstructionsMutationVariables>;

/**
 * __useCompanySettingsSendVerificationInstructionsMutation__
 *
 * To run a mutation, you first call `useCompanySettingsSendVerificationInstructionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanySettingsSendVerificationInstructionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companySettingsSendVerificationInstructionsMutation, { data, loading, error }] = useCompanySettingsSendVerificationInstructionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompanySettingsSendVerificationInstructionsMutation(baseOptions?: Apollo.MutationHookOptions<CompanySettingsSendVerificationInstructionsMutation, CompanySettingsSendVerificationInstructionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanySettingsSendVerificationInstructionsMutation, CompanySettingsSendVerificationInstructionsMutationVariables>(CompanySettingsSendVerificationInstructionsDocument, options);
      }
export type CompanySettingsSendVerificationInstructionsMutationHookResult = ReturnType<typeof useCompanySettingsSendVerificationInstructionsMutation>;
export type CompanySettingsSendVerificationInstructionsMutationResult = Apollo.MutationResult<CompanySettingsSendVerificationInstructionsMutation>;
export type CompanySettingsSendVerificationInstructionsMutationOptions = Apollo.BaseMutationOptions<CompanySettingsSendVerificationInstructionsMutation, CompanySettingsSendVerificationInstructionsMutationVariables>;
export const ProjectActivityLogProjectActivitiesConnectionsDocument = gql`
    query ProjectActivityLog_ProjectActivitiesConnections($projectId: ID!, $activityRelated: ID!, $listInputs: ListInput) {
  projectActivitiesConnections(
    projectId: $projectId
    activityRelated: $activityRelated
    listInputs: $listInputs
  ) {
    pageInfo {
      ...PageInfoFragment
    }
    activities {
      id
      text
      createdAt
      internalOnly
      userNotRelevant
      user {
        ... on UserType {
          id
          firstName
          lastName
          avatar {
            originalUrl
          }
        }
        ... on SignerType {
          id
          firstName
          lastName
        }
        ... on DefaultActivityOwnerType {
          firstName
          lastName
        }
      }
    }
  }
  project(id: $projectId) {
    ...ProjectCreatedAt
  }
}
    ${PageInfoFragmentDoc}
${ProjectCreatedAtFragmentDoc}`;

/**
 * __useProjectActivityLogProjectActivitiesConnectionsQuery__
 *
 * To run a query within a React component, call `useProjectActivityLogProjectActivitiesConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectActivityLogProjectActivitiesConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectActivityLogProjectActivitiesConnectionsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      activityRelated: // value for 'activityRelated'
 *      listInputs: // value for 'listInputs'
 *   },
 * });
 */
export function useProjectActivityLogProjectActivitiesConnectionsQuery(baseOptions: Apollo.QueryHookOptions<ProjectActivityLogProjectActivitiesConnectionsQuery, ProjectActivityLogProjectActivitiesConnectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectActivityLogProjectActivitiesConnectionsQuery, ProjectActivityLogProjectActivitiesConnectionsQueryVariables>(ProjectActivityLogProjectActivitiesConnectionsDocument, options);
      }
export function useProjectActivityLogProjectActivitiesConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectActivityLogProjectActivitiesConnectionsQuery, ProjectActivityLogProjectActivitiesConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectActivityLogProjectActivitiesConnectionsQuery, ProjectActivityLogProjectActivitiesConnectionsQueryVariables>(ProjectActivityLogProjectActivitiesConnectionsDocument, options);
        }
export type ProjectActivityLogProjectActivitiesConnectionsQueryHookResult = ReturnType<typeof useProjectActivityLogProjectActivitiesConnectionsQuery>;
export type ProjectActivityLogProjectActivitiesConnectionsLazyQueryHookResult = ReturnType<typeof useProjectActivityLogProjectActivitiesConnectionsLazyQuery>;
export type ProjectActivityLogProjectActivitiesConnectionsQueryResult = Apollo.QueryResult<ProjectActivityLogProjectActivitiesConnectionsQuery, ProjectActivityLogProjectActivitiesConnectionsQueryVariables>;
export const CategoryListProjectSkillCategoriesDocument = gql`
    query CategoryList_Project_SkillCategories($projectId: ID!) {
  project(id: $projectId) {
    id
    skillCategories {
      id
      ...Billable_Rates_CategoryList_SkillCategory
    }
  }
}
    ${BillableRatesCategoryListSkillCategoryFragmentDoc}`;

/**
 * __useCategoryListProjectSkillCategoriesQuery__
 *
 * To run a query within a React component, call `useCategoryListProjectSkillCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryListProjectSkillCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryListProjectSkillCategoriesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useCategoryListProjectSkillCategoriesQuery(baseOptions: Apollo.QueryHookOptions<CategoryListProjectSkillCategoriesQuery, CategoryListProjectSkillCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoryListProjectSkillCategoriesQuery, CategoryListProjectSkillCategoriesQueryVariables>(CategoryListProjectSkillCategoriesDocument, options);
      }
export function useCategoryListProjectSkillCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoryListProjectSkillCategoriesQuery, CategoryListProjectSkillCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoryListProjectSkillCategoriesQuery, CategoryListProjectSkillCategoriesQueryVariables>(CategoryListProjectSkillCategoriesDocument, options);
        }
export type CategoryListProjectSkillCategoriesQueryHookResult = ReturnType<typeof useCategoryListProjectSkillCategoriesQuery>;
export type CategoryListProjectSkillCategoriesLazyQueryHookResult = ReturnType<typeof useCategoryListProjectSkillCategoriesLazyQuery>;
export type CategoryListProjectSkillCategoriesQueryResult = Apollo.QueryResult<CategoryListProjectSkillCategoriesQuery, CategoryListProjectSkillCategoriesQueryVariables>;
export const UpdateBillableOverrideDocument = gql`
    mutation updateBillableOverride($input: updateBillableOverrideInput!) {
  updateBillableOverride(input: $input) {
    success
  }
}
    `;
export type UpdateBillableOverrideMutationFn = Apollo.MutationFunction<UpdateBillableOverrideMutation, UpdateBillableOverrideMutationVariables>;

/**
 * __useUpdateBillableOverrideMutation__
 *
 * To run a mutation, you first call `useUpdateBillableOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBillableOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBillableOverrideMutation, { data, loading, error }] = useUpdateBillableOverrideMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBillableOverrideMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBillableOverrideMutation, UpdateBillableOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBillableOverrideMutation, UpdateBillableOverrideMutationVariables>(UpdateBillableOverrideDocument, options);
      }
export type UpdateBillableOverrideMutationHookResult = ReturnType<typeof useUpdateBillableOverrideMutation>;
export type UpdateBillableOverrideMutationResult = Apollo.MutationResult<UpdateBillableOverrideMutation>;
export type UpdateBillableOverrideMutationOptions = Apollo.BaseMutationOptions<UpdateBillableOverrideMutation, UpdateBillableOverrideMutationVariables>;
export const ProjectCustomFieldsProjectInfoFieldsDocument = gql`
    query ProjectCustomFields_ProjectInfoFields($projectId: ID!) {
  projectInfoFields(projectId: $projectId) {
    id
    value
    mergeTag {
      id
      name
    }
  }
}
    `;

/**
 * __useProjectCustomFieldsProjectInfoFieldsQuery__
 *
 * To run a query within a React component, call `useProjectCustomFieldsProjectInfoFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectCustomFieldsProjectInfoFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectCustomFieldsProjectInfoFieldsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectCustomFieldsProjectInfoFieldsQuery(baseOptions: Apollo.QueryHookOptions<ProjectCustomFieldsProjectInfoFieldsQuery, ProjectCustomFieldsProjectInfoFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectCustomFieldsProjectInfoFieldsQuery, ProjectCustomFieldsProjectInfoFieldsQueryVariables>(ProjectCustomFieldsProjectInfoFieldsDocument, options);
      }
export function useProjectCustomFieldsProjectInfoFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectCustomFieldsProjectInfoFieldsQuery, ProjectCustomFieldsProjectInfoFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectCustomFieldsProjectInfoFieldsQuery, ProjectCustomFieldsProjectInfoFieldsQueryVariables>(ProjectCustomFieldsProjectInfoFieldsDocument, options);
        }
export type ProjectCustomFieldsProjectInfoFieldsQueryHookResult = ReturnType<typeof useProjectCustomFieldsProjectInfoFieldsQuery>;
export type ProjectCustomFieldsProjectInfoFieldsLazyQueryHookResult = ReturnType<typeof useProjectCustomFieldsProjectInfoFieldsLazyQuery>;
export type ProjectCustomFieldsProjectInfoFieldsQueryResult = Apollo.QueryResult<ProjectCustomFieldsProjectInfoFieldsQuery, ProjectCustomFieldsProjectInfoFieldsQueryVariables>;
export const ProjectCustomFieldsProjectOrganizationDocument = gql`
    query ProjectCustomFields_ProjectOrganization($projectId: ID!) {
  project(id: $projectId) {
    id
    organization {
      id
    }
  }
}
    `;

/**
 * __useProjectCustomFieldsProjectOrganizationQuery__
 *
 * To run a query within a React component, call `useProjectCustomFieldsProjectOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectCustomFieldsProjectOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectCustomFieldsProjectOrganizationQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectCustomFieldsProjectOrganizationQuery(baseOptions: Apollo.QueryHookOptions<ProjectCustomFieldsProjectOrganizationQuery, ProjectCustomFieldsProjectOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectCustomFieldsProjectOrganizationQuery, ProjectCustomFieldsProjectOrganizationQueryVariables>(ProjectCustomFieldsProjectOrganizationDocument, options);
      }
export function useProjectCustomFieldsProjectOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectCustomFieldsProjectOrganizationQuery, ProjectCustomFieldsProjectOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectCustomFieldsProjectOrganizationQuery, ProjectCustomFieldsProjectOrganizationQueryVariables>(ProjectCustomFieldsProjectOrganizationDocument, options);
        }
export type ProjectCustomFieldsProjectOrganizationQueryHookResult = ReturnType<typeof useProjectCustomFieldsProjectOrganizationQuery>;
export type ProjectCustomFieldsProjectOrganizationLazyQueryHookResult = ReturnType<typeof useProjectCustomFieldsProjectOrganizationLazyQuery>;
export type ProjectCustomFieldsProjectOrganizationQueryResult = Apollo.QueryResult<ProjectCustomFieldsProjectOrganizationQuery, ProjectCustomFieldsProjectOrganizationQueryVariables>;
export const ProjectFilesProjectDocument = gql`
    query ProjectFiles_Project($projectId: ID!) {
  project(id: $projectId) {
    id
    ...ProjectFiles_Project
  }
}
    ${ProjectFilesProjectFragmentDoc}`;

/**
 * __useProjectFilesProjectQuery__
 *
 * To run a query within a React component, call `useProjectFilesProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectFilesProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectFilesProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectFilesProjectQuery(baseOptions: Apollo.QueryHookOptions<ProjectFilesProjectQuery, ProjectFilesProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectFilesProjectQuery, ProjectFilesProjectQueryVariables>(ProjectFilesProjectDocument, options);
      }
export function useProjectFilesProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectFilesProjectQuery, ProjectFilesProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectFilesProjectQuery, ProjectFilesProjectQueryVariables>(ProjectFilesProjectDocument, options);
        }
export type ProjectFilesProjectQueryHookResult = ReturnType<typeof useProjectFilesProjectQuery>;
export type ProjectFilesProjectLazyQueryHookResult = ReturnType<typeof useProjectFilesProjectLazyQuery>;
export type ProjectFilesProjectQueryResult = Apollo.QueryResult<ProjectFilesProjectQuery, ProjectFilesProjectQueryVariables>;
export const ProjectNotesProjectDocument = gql`
    query ProjectNotes_Project($projectId: ID!) {
  project(id: $projectId) {
    id
    ...ProjectNotes_Project
  }
  projectTeam(projectId: $projectId) {
    id
    ...Notes_ProjectTeam
  }
}
    ${ProjectNotesProjectFragmentDoc}
${NotesProjectTeamFragmentDoc}`;

/**
 * __useProjectNotesProjectQuery__
 *
 * To run a query within a React component, call `useProjectNotesProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectNotesProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectNotesProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectNotesProjectQuery(baseOptions: Apollo.QueryHookOptions<ProjectNotesProjectQuery, ProjectNotesProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectNotesProjectQuery, ProjectNotesProjectQueryVariables>(ProjectNotesProjectDocument, options);
      }
export function useProjectNotesProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectNotesProjectQuery, ProjectNotesProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectNotesProjectQuery, ProjectNotesProjectQueryVariables>(ProjectNotesProjectDocument, options);
        }
export type ProjectNotesProjectQueryHookResult = ReturnType<typeof useProjectNotesProjectQuery>;
export type ProjectNotesProjectLazyQueryHookResult = ReturnType<typeof useProjectNotesProjectLazyQuery>;
export type ProjectNotesProjectQueryResult = Apollo.QueryResult<ProjectNotesProjectQuery, ProjectNotesProjectQueryVariables>;
export const ProjectOverviewProjectUpdatedDocument = gql`
    subscription ProjectOverview_ProjectUpdated($projectId: ID!) {
  projectUpdated(projectId: $projectId) {
    project {
      id
      status
      forecastedEndOn
    }
    projectStats {
      id
      totalTasks
      totalDoneTasks
      totalSignOffTasks
      totalStuckTasks
      totalWorkingOnItTasks
      totalNotStartedTasks
      totalAssignedTasks
    }
  }
}
    `;

/**
 * __useProjectOverviewProjectUpdatedSubscription__
 *
 * To run a query within a React component, call `useProjectOverviewProjectUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useProjectOverviewProjectUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectOverviewProjectUpdatedSubscription({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectOverviewProjectUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<ProjectOverviewProjectUpdatedSubscription, ProjectOverviewProjectUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ProjectOverviewProjectUpdatedSubscription, ProjectOverviewProjectUpdatedSubscriptionVariables>(ProjectOverviewProjectUpdatedDocument, options);
      }
export type ProjectOverviewProjectUpdatedSubscriptionHookResult = ReturnType<typeof useProjectOverviewProjectUpdatedSubscription>;
export type ProjectOverviewProjectUpdatedSubscriptionResult = Apollo.SubscriptionResult<ProjectOverviewProjectUpdatedSubscription>;
export const ProjectPlanProjectDocument = gql`
    query ProjectPlan_Project($projectId: ID!) {
  project(id: $projectId) {
    id
    ...ProjectPlan_Project
  }
  projectTeam(projectId: $projectId) {
    id
    ...ProjectPlan_User
  }
  stats(objId: $projectId, objType: PROJECT) {
    ... on ProjectStats {
      id
      ...ProjectPlan_Stats
    }
  }
}
    ${ProjectPlanProjectFragmentDoc}
${ProjectPlanUserFragmentDoc}
${ProjectPlanStatsFragmentDoc}`;

/**
 * __useProjectPlanProjectQuery__
 *
 * To run a query within a React component, call `useProjectPlanProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectPlanProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectPlanProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectPlanProjectQuery(baseOptions: Apollo.QueryHookOptions<ProjectPlanProjectQuery, ProjectPlanProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectPlanProjectQuery, ProjectPlanProjectQueryVariables>(ProjectPlanProjectDocument, options);
      }
export function useProjectPlanProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectPlanProjectQuery, ProjectPlanProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectPlanProjectQuery, ProjectPlanProjectQueryVariables>(ProjectPlanProjectDocument, options);
        }
export type ProjectPlanProjectQueryHookResult = ReturnType<typeof useProjectPlanProjectQuery>;
export type ProjectPlanProjectLazyQueryHookResult = ReturnType<typeof useProjectPlanProjectLazyQuery>;
export type ProjectPlanProjectQueryResult = Apollo.QueryResult<ProjectPlanProjectQuery, ProjectPlanProjectQueryVariables>;
export const ProjectTeamProjectDocument = gql`
    query ProjectTeam_Project($projectId: ID!) {
  project(id: $projectId) {
    id
    name
    status
    currentUserProjectContext
    projectType
    firstActiveTemplate
    organization {
      id
      resourceManagementEnabled
    }
    customerV2 {
      id
      name
    }
  }
}
    `;

/**
 * __useProjectTeamProjectQuery__
 *
 * To run a query within a React component, call `useProjectTeamProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectTeamProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectTeamProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectTeamProjectQuery(baseOptions: Apollo.QueryHookOptions<ProjectTeamProjectQuery, ProjectTeamProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectTeamProjectQuery, ProjectTeamProjectQueryVariables>(ProjectTeamProjectDocument, options);
      }
export function useProjectTeamProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectTeamProjectQuery, ProjectTeamProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectTeamProjectQuery, ProjectTeamProjectQueryVariables>(ProjectTeamProjectDocument, options);
        }
export type ProjectTeamProjectQueryHookResult = ReturnType<typeof useProjectTeamProjectQuery>;
export type ProjectTeamProjectLazyQueryHookResult = ReturnType<typeof useProjectTeamProjectLazyQuery>;
export type ProjectTeamProjectQueryResult = Apollo.QueryResult<ProjectTeamProjectQuery, ProjectTeamProjectQueryVariables>;
export const CategoryListSkillCategoriesDocument = gql`
    query CategoryList_SkillCategories($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    skillCategories {
      id
      ...CategoryList_SkillCategory
    }
  }
}
    ${CategoryListSkillCategoryFragmentDoc}`;

/**
 * __useCategoryListSkillCategoriesQuery__
 *
 * To run a query within a React component, call `useCategoryListSkillCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryListSkillCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryListSkillCategoriesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useCategoryListSkillCategoriesQuery(baseOptions: Apollo.QueryHookOptions<CategoryListSkillCategoriesQuery, CategoryListSkillCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoryListSkillCategoriesQuery, CategoryListSkillCategoriesQueryVariables>(CategoryListSkillCategoriesDocument, options);
      }
export function useCategoryListSkillCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoryListSkillCategoriesQuery, CategoryListSkillCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoryListSkillCategoriesQuery, CategoryListSkillCategoriesQueryVariables>(CategoryListSkillCategoriesDocument, options);
        }
export type CategoryListSkillCategoriesQueryHookResult = ReturnType<typeof useCategoryListSkillCategoriesQuery>;
export type CategoryListSkillCategoriesLazyQueryHookResult = ReturnType<typeof useCategoryListSkillCategoriesLazyQuery>;
export type CategoryListSkillCategoriesQueryResult = Apollo.QueryResult<CategoryListSkillCategoriesQuery, CategoryListSkillCategoriesQueryVariables>;
export const SkillSetsCreateCategoryDocument = gql`
    mutation SkillSets_CreateCategory($input: createSkillCategoryInput!) {
  createSkillCategory(input: $input) {
    skillCategory {
      id
      name
    }
  }
}
    `;
export type SkillSetsCreateCategoryMutationFn = Apollo.MutationFunction<SkillSetsCreateCategoryMutation, SkillSetsCreateCategoryMutationVariables>;

/**
 * __useSkillSetsCreateCategoryMutation__
 *
 * To run a mutation, you first call `useSkillSetsCreateCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkillSetsCreateCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skillSetsCreateCategoryMutation, { data, loading, error }] = useSkillSetsCreateCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSkillSetsCreateCategoryMutation(baseOptions?: Apollo.MutationHookOptions<SkillSetsCreateCategoryMutation, SkillSetsCreateCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SkillSetsCreateCategoryMutation, SkillSetsCreateCategoryMutationVariables>(SkillSetsCreateCategoryDocument, options);
      }
export type SkillSetsCreateCategoryMutationHookResult = ReturnType<typeof useSkillSetsCreateCategoryMutation>;
export type SkillSetsCreateCategoryMutationResult = Apollo.MutationResult<SkillSetsCreateCategoryMutation>;
export type SkillSetsCreateCategoryMutationOptions = Apollo.BaseMutationOptions<SkillSetsCreateCategoryMutation, SkillSetsCreateCategoryMutationVariables>;
export const DeleteSkillCategoryDocument = gql`
    mutation deleteSkillCategory($id: ID!) {
  deleteSkillCategory(id: $id) {
    success
  }
}
    `;
export type DeleteSkillCategoryMutationFn = Apollo.MutationFunction<DeleteSkillCategoryMutation, DeleteSkillCategoryMutationVariables>;

/**
 * __useDeleteSkillCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteSkillCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSkillCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSkillCategoryMutation, { data, loading, error }] = useDeleteSkillCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSkillCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSkillCategoryMutation, DeleteSkillCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSkillCategoryMutation, DeleteSkillCategoryMutationVariables>(DeleteSkillCategoryDocument, options);
      }
export type DeleteSkillCategoryMutationHookResult = ReturnType<typeof useDeleteSkillCategoryMutation>;
export type DeleteSkillCategoryMutationResult = Apollo.MutationResult<DeleteSkillCategoryMutation>;
export type DeleteSkillCategoryMutationOptions = Apollo.BaseMutationOptions<DeleteSkillCategoryMutation, DeleteSkillCategoryMutationVariables>;
export const SupportProductBoardTokenDocument = gql`
    mutation SupportProductBoardToken {
  productboardToken {
    accessToken
  }
}
    `;
export type SupportProductBoardTokenMutationFn = Apollo.MutationFunction<SupportProductBoardTokenMutation, SupportProductBoardTokenMutationVariables>;

/**
 * __useSupportProductBoardTokenMutation__
 *
 * To run a mutation, you first call `useSupportProductBoardTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSupportProductBoardTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [supportProductBoardTokenMutation, { data, loading, error }] = useSupportProductBoardTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useSupportProductBoardTokenMutation(baseOptions?: Apollo.MutationHookOptions<SupportProductBoardTokenMutation, SupportProductBoardTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SupportProductBoardTokenMutation, SupportProductBoardTokenMutationVariables>(SupportProductBoardTokenDocument, options);
      }
export type SupportProductBoardTokenMutationHookResult = ReturnType<typeof useSupportProductBoardTokenMutation>;
export type SupportProductBoardTokenMutationResult = Apollo.MutationResult<SupportProductBoardTokenMutation>;
export type SupportProductBoardTokenMutationOptions = Apollo.BaseMutationOptions<SupportProductBoardTokenMutation, SupportProductBoardTokenMutationVariables>;
export const TemplateFilesFilesPageDocument = gql`
    query TemplateFiles_Files_Page($templateId: ID!, $listInputs: ListInput) {
  templatesById(ids: [$templateId]) {
    id
    name
  }
  files(objId: $templateId, objType: BLUEPRINT_TEMPLATE, listInputs: $listInputs) {
    pageInfo {
      ...PageInfoFragment
    }
    assets {
      id
      ...TemplateFiles_File_Page
    }
  }
}
    ${PageInfoFragmentDoc}
${TemplateFilesFilePageFragmentDoc}`;

/**
 * __useTemplateFilesFilesPageQuery__
 *
 * To run a query within a React component, call `useTemplateFilesFilesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateFilesFilesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateFilesFilesPageQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      listInputs: // value for 'listInputs'
 *   },
 * });
 */
export function useTemplateFilesFilesPageQuery(baseOptions: Apollo.QueryHookOptions<TemplateFilesFilesPageQuery, TemplateFilesFilesPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplateFilesFilesPageQuery, TemplateFilesFilesPageQueryVariables>(TemplateFilesFilesPageDocument, options);
      }
export function useTemplateFilesFilesPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplateFilesFilesPageQuery, TemplateFilesFilesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplateFilesFilesPageQuery, TemplateFilesFilesPageQueryVariables>(TemplateFilesFilesPageDocument, options);
        }
export type TemplateFilesFilesPageQueryHookResult = ReturnType<typeof useTemplateFilesFilesPageQuery>;
export type TemplateFilesFilesPageLazyQueryHookResult = ReturnType<typeof useTemplateFilesFilesPageLazyQuery>;
export type TemplateFilesFilesPageQueryResult = Apollo.QueryResult<TemplateFilesFilesPageQuery, TemplateFilesFilesPageQueryVariables>;
export const TemplateFilesDeleteFilePageDocument = gql`
    mutation TemplateFiles_DeleteFile_Page($deleteFileInput: DeleteFileInput!) {
  deleteFile(input: $deleteFileInput) {
    success
  }
}
    `;
export type TemplateFilesDeleteFilePageMutationFn = Apollo.MutationFunction<TemplateFilesDeleteFilePageMutation, TemplateFilesDeleteFilePageMutationVariables>;

/**
 * __useTemplateFilesDeleteFilePageMutation__
 *
 * To run a mutation, you first call `useTemplateFilesDeleteFilePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTemplateFilesDeleteFilePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [templateFilesDeleteFilePageMutation, { data, loading, error }] = useTemplateFilesDeleteFilePageMutation({
 *   variables: {
 *      deleteFileInput: // value for 'deleteFileInput'
 *   },
 * });
 */
export function useTemplateFilesDeleteFilePageMutation(baseOptions?: Apollo.MutationHookOptions<TemplateFilesDeleteFilePageMutation, TemplateFilesDeleteFilePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TemplateFilesDeleteFilePageMutation, TemplateFilesDeleteFilePageMutationVariables>(TemplateFilesDeleteFilePageDocument, options);
      }
export type TemplateFilesDeleteFilePageMutationHookResult = ReturnType<typeof useTemplateFilesDeleteFilePageMutation>;
export type TemplateFilesDeleteFilePageMutationResult = Apollo.MutationResult<TemplateFilesDeleteFilePageMutation>;
export type TemplateFilesDeleteFilePageMutationOptions = Apollo.BaseMutationOptions<TemplateFilesDeleteFilePageMutation, TemplateFilesDeleteFilePageMutationVariables>;
export const TemplateFilesUpdateTemplatePageDocument = gql`
    mutation TemplateFiles_UpdateTemplate_Page($input: updateTemplateInput!) {
  updateTemplate(input: $input) {
    template {
      id
      files {
        id
        ...TemplateFiles_File_Page
      }
    }
  }
}
    ${TemplateFilesFilePageFragmentDoc}`;
export type TemplateFilesUpdateTemplatePageMutationFn = Apollo.MutationFunction<TemplateFilesUpdateTemplatePageMutation, TemplateFilesUpdateTemplatePageMutationVariables>;

/**
 * __useTemplateFilesUpdateTemplatePageMutation__
 *
 * To run a mutation, you first call `useTemplateFilesUpdateTemplatePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTemplateFilesUpdateTemplatePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [templateFilesUpdateTemplatePageMutation, { data, loading, error }] = useTemplateFilesUpdateTemplatePageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTemplateFilesUpdateTemplatePageMutation(baseOptions?: Apollo.MutationHookOptions<TemplateFilesUpdateTemplatePageMutation, TemplateFilesUpdateTemplatePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TemplateFilesUpdateTemplatePageMutation, TemplateFilesUpdateTemplatePageMutationVariables>(TemplateFilesUpdateTemplatePageDocument, options);
      }
export type TemplateFilesUpdateTemplatePageMutationHookResult = ReturnType<typeof useTemplateFilesUpdateTemplatePageMutation>;
export type TemplateFilesUpdateTemplatePageMutationResult = Apollo.MutationResult<TemplateFilesUpdateTemplatePageMutation>;
export type TemplateFilesUpdateTemplatePageMutationOptions = Apollo.BaseMutationOptions<TemplateFilesUpdateTemplatePageMutation, TemplateFilesUpdateTemplatePageMutationVariables>;
export const TemplateOverviewTemplateStatsDocument = gql`
    query TemplateOverview_TemplateStats($templateId: ID!) {
  stats(objId: $templateId, objType: BLUEPRINT_TEMPLATE) {
    ...TemplateOverview_TemplateStats
  }
}
    ${TemplateOverviewTemplateStatsFragmentDoc}`;

/**
 * __useTemplateOverviewTemplateStatsQuery__
 *
 * To run a query within a React component, call `useTemplateOverviewTemplateStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateOverviewTemplateStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateOverviewTemplateStatsQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useTemplateOverviewTemplateStatsQuery(baseOptions: Apollo.QueryHookOptions<TemplateOverviewTemplateStatsQuery, TemplateOverviewTemplateStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplateOverviewTemplateStatsQuery, TemplateOverviewTemplateStatsQueryVariables>(TemplateOverviewTemplateStatsDocument, options);
      }
export function useTemplateOverviewTemplateStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplateOverviewTemplateStatsQuery, TemplateOverviewTemplateStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplateOverviewTemplateStatsQuery, TemplateOverviewTemplateStatsQueryVariables>(TemplateOverviewTemplateStatsDocument, options);
        }
export type TemplateOverviewTemplateStatsQueryHookResult = ReturnType<typeof useTemplateOverviewTemplateStatsQuery>;
export type TemplateOverviewTemplateStatsLazyQueryHookResult = ReturnType<typeof useTemplateOverviewTemplateStatsLazyQuery>;
export type TemplateOverviewTemplateStatsQueryResult = Apollo.QueryResult<TemplateOverviewTemplateStatsQuery, TemplateOverviewTemplateStatsQueryVariables>;
export const TemplateOverviewTemplateDocument = gql`
    query TemplateOverview_Template($templateId: ID!) {
  blueprintTemplate(id: $templateId) {
    id
    ...TemplateOverview_Template
  }
}
    ${TemplateOverviewTemplateFragmentDoc}`;

/**
 * __useTemplateOverviewTemplateQuery__
 *
 * To run a query within a React component, call `useTemplateOverviewTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateOverviewTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateOverviewTemplateQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useTemplateOverviewTemplateQuery(baseOptions: Apollo.QueryHookOptions<TemplateOverviewTemplateQuery, TemplateOverviewTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplateOverviewTemplateQuery, TemplateOverviewTemplateQueryVariables>(TemplateOverviewTemplateDocument, options);
      }
export function useTemplateOverviewTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplateOverviewTemplateQuery, TemplateOverviewTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplateOverviewTemplateQuery, TemplateOverviewTemplateQueryVariables>(TemplateOverviewTemplateDocument, options);
        }
export type TemplateOverviewTemplateQueryHookResult = ReturnType<typeof useTemplateOverviewTemplateQuery>;
export type TemplateOverviewTemplateLazyQueryHookResult = ReturnType<typeof useTemplateOverviewTemplateLazyQuery>;
export type TemplateOverviewTemplateQueryResult = Apollo.QueryResult<TemplateOverviewTemplateQuery, TemplateOverviewTemplateQueryVariables>;
export const ReportingIndexTimeReportSummaryDocument = gql`
    query ReportingIndex_TimeReportSummary($start: DateType!, $end: DateType!, $filters: TimeReportFiltersInput, $reportScope: ReportScopeEnumType!, $includeGeneric: Boolean!, $keyword: String) {
  timeReportSummary(
    startDate: $start
    endDate: $end
    reportingFilters: $filters
    reportScope: $reportScope
    includeGeneric: $includeGeneric
    keyword: $keyword
  ) {
    ...TimeReportSummary_TimeReportSummary
  }
}
    ${TimeReportSummaryTimeReportSummaryFragmentDoc}`;

/**
 * __useReportingIndexTimeReportSummaryQuery__
 *
 * To run a query within a React component, call `useReportingIndexTimeReportSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportingIndexTimeReportSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingIndexTimeReportSummaryQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      filters: // value for 'filters'
 *      reportScope: // value for 'reportScope'
 *      includeGeneric: // value for 'includeGeneric'
 *      keyword: // value for 'keyword'
 *   },
 * });
 */
export function useReportingIndexTimeReportSummaryQuery(baseOptions: Apollo.QueryHookOptions<ReportingIndexTimeReportSummaryQuery, ReportingIndexTimeReportSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportingIndexTimeReportSummaryQuery, ReportingIndexTimeReportSummaryQueryVariables>(ReportingIndexTimeReportSummaryDocument, options);
      }
export function useReportingIndexTimeReportSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportingIndexTimeReportSummaryQuery, ReportingIndexTimeReportSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportingIndexTimeReportSummaryQuery, ReportingIndexTimeReportSummaryQueryVariables>(ReportingIndexTimeReportSummaryDocument, options);
        }
export type ReportingIndexTimeReportSummaryQueryHookResult = ReturnType<typeof useReportingIndexTimeReportSummaryQuery>;
export type ReportingIndexTimeReportSummaryLazyQueryHookResult = ReturnType<typeof useReportingIndexTimeReportSummaryLazyQuery>;
export type ReportingIndexTimeReportSummaryQueryResult = Apollo.QueryResult<ReportingIndexTimeReportSummaryQuery, ReportingIndexTimeReportSummaryQueryVariables>;
export const UserIndexUsersDocument = gql`
    query UserIndex_Users($listInputs: ListInput) {
  allUsers(listInputs: $listInputs) {
    pageInfo {
      ...PageInfoFragment
    }
    users {
      id
      ...CompanyUsers
    }
  }
}
    ${PageInfoFragmentDoc}
${CompanyUsersFragmentDoc}`;

/**
 * __useUserIndexUsersQuery__
 *
 * To run a query within a React component, call `useUserIndexUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserIndexUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserIndexUsersQuery({
 *   variables: {
 *      listInputs: // value for 'listInputs'
 *   },
 * });
 */
export function useUserIndexUsersQuery(baseOptions?: Apollo.QueryHookOptions<UserIndexUsersQuery, UserIndexUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserIndexUsersQuery, UserIndexUsersQueryVariables>(UserIndexUsersDocument, options);
      }
export function useUserIndexUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserIndexUsersQuery, UserIndexUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserIndexUsersQuery, UserIndexUsersQueryVariables>(UserIndexUsersDocument, options);
        }
export type UserIndexUsersQueryHookResult = ReturnType<typeof useUserIndexUsersQuery>;
export type UserIndexUsersLazyQueryHookResult = ReturnType<typeof useUserIndexUsersLazyQuery>;
export type UserIndexUsersQueryResult = Apollo.QueryResult<UserIndexUsersQuery, UserIndexUsersQueryVariables>;
export const ResendInviteToEmailResendInvitationDocument = gql`
    mutation ResendInviteToEmail_ResendInvitation($email: String!) {
  resendInviteToUser(input: {email: $email}) {
    success
  }
}
    `;
export type ResendInviteToEmailResendInvitationMutationFn = Apollo.MutationFunction<ResendInviteToEmailResendInvitationMutation, ResendInviteToEmailResendInvitationMutationVariables>;

/**
 * __useResendInviteToEmailResendInvitationMutation__
 *
 * To run a mutation, you first call `useResendInviteToEmailResendInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInviteToEmailResendInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInviteToEmailResendInvitationMutation, { data, loading, error }] = useResendInviteToEmailResendInvitationMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResendInviteToEmailResendInvitationMutation(baseOptions?: Apollo.MutationHookOptions<ResendInviteToEmailResendInvitationMutation, ResendInviteToEmailResendInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendInviteToEmailResendInvitationMutation, ResendInviteToEmailResendInvitationMutationVariables>(ResendInviteToEmailResendInvitationDocument, options);
      }
export type ResendInviteToEmailResendInvitationMutationHookResult = ReturnType<typeof useResendInviteToEmailResendInvitationMutation>;
export type ResendInviteToEmailResendInvitationMutationResult = Apollo.MutationResult<ResendInviteToEmailResendInvitationMutation>;
export type ResendInviteToEmailResendInvitationMutationOptions = Apollo.BaseMutationOptions<ResendInviteToEmailResendInvitationMutation, ResendInviteToEmailResendInvitationMutationVariables>;
export const ResendInviteResendInvitationDocument = gql`
    mutation ResendInvite_ResendInvitation($email: String!) {
  resendInviteToUser(input: {email: $email}) {
    success
  }
}
    `;
export type ResendInviteResendInvitationMutationFn = Apollo.MutationFunction<ResendInviteResendInvitationMutation, ResendInviteResendInvitationMutationVariables>;

/**
 * __useResendInviteResendInvitationMutation__
 *
 * To run a mutation, you first call `useResendInviteResendInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInviteResendInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInviteResendInvitationMutation, { data, loading, error }] = useResendInviteResendInvitationMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResendInviteResendInvitationMutation(baseOptions?: Apollo.MutationHookOptions<ResendInviteResendInvitationMutation, ResendInviteResendInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendInviteResendInvitationMutation, ResendInviteResendInvitationMutationVariables>(ResendInviteResendInvitationDocument, options);
      }
export type ResendInviteResendInvitationMutationHookResult = ReturnType<typeof useResendInviteResendInvitationMutation>;
export type ResendInviteResendInvitationMutationResult = Apollo.MutationResult<ResendInviteResendInvitationMutation>;
export type ResendInviteResendInvitationMutationOptions = Apollo.BaseMutationOptions<ResendInviteResendInvitationMutation, ResendInviteResendInvitationMutationVariables>;
export const TaskActionsTaskDocument = gql`
    query TaskActions_Task($id: ID!) {
  taskActions(id: $id) {
    ...TaskActions_Task
  }
}
    ${TaskActionsTaskFragmentDoc}`;

/**
 * __useTaskActionsTaskQuery__
 *
 * To run a query within a React component, call `useTaskActionsTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskActionsTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskActionsTaskQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTaskActionsTaskQuery(baseOptions: Apollo.QueryHookOptions<TaskActionsTaskQuery, TaskActionsTaskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskActionsTaskQuery, TaskActionsTaskQueryVariables>(TaskActionsTaskDocument, options);
      }
export function useTaskActionsTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskActionsTaskQuery, TaskActionsTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskActionsTaskQuery, TaskActionsTaskQueryVariables>(TaskActionsTaskDocument, options);
        }
export type TaskActionsTaskQueryHookResult = ReturnType<typeof useTaskActionsTaskQuery>;
export type TaskActionsTaskLazyQueryHookResult = ReturnType<typeof useTaskActionsTaskLazyQuery>;
export type TaskActionsTaskQueryResult = Apollo.QueryResult<TaskActionsTaskQuery, TaskActionsTaskQueryVariables>;
export const TaskActionsUpdateSignOffDocument = gql`
    mutation TaskActions_UpdateSignOff($taskId: ID!, $action: signOffActionEnumType!) {
  updateSignOff(input: {taskId: $taskId, action: $action}) {
    task {
      ...TaskActions_Task
    }
  }
}
    ${TaskActionsTaskFragmentDoc}`;
export type TaskActionsUpdateSignOffMutationFn = Apollo.MutationFunction<TaskActionsUpdateSignOffMutation, TaskActionsUpdateSignOffMutationVariables>;

/**
 * __useTaskActionsUpdateSignOffMutation__
 *
 * To run a mutation, you first call `useTaskActionsUpdateSignOffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskActionsUpdateSignOffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskActionsUpdateSignOffMutation, { data, loading, error }] = useTaskActionsUpdateSignOffMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      action: // value for 'action'
 *   },
 * });
 */
export function useTaskActionsUpdateSignOffMutation(baseOptions?: Apollo.MutationHookOptions<TaskActionsUpdateSignOffMutation, TaskActionsUpdateSignOffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskActionsUpdateSignOffMutation, TaskActionsUpdateSignOffMutationVariables>(TaskActionsUpdateSignOffDocument, options);
      }
export type TaskActionsUpdateSignOffMutationHookResult = ReturnType<typeof useTaskActionsUpdateSignOffMutation>;
export type TaskActionsUpdateSignOffMutationResult = Apollo.MutationResult<TaskActionsUpdateSignOffMutation>;
export type TaskActionsUpdateSignOffMutationOptions = Apollo.BaseMutationOptions<TaskActionsUpdateSignOffMutation, TaskActionsUpdateSignOffMutationVariables>;
export const TaskActionsChangeStatusDocument = gql`
    mutation TaskActions_ChangeStatus($changeStatusInput: changeStatusInput!) {
  changeStatus(input: $changeStatusInput) {
    task {
      ...TaskActions_Task
    }
  }
}
    ${TaskActionsTaskFragmentDoc}`;
export type TaskActionsChangeStatusMutationFn = Apollo.MutationFunction<TaskActionsChangeStatusMutation, TaskActionsChangeStatusMutationVariables>;

/**
 * __useTaskActionsChangeStatusMutation__
 *
 * To run a mutation, you first call `useTaskActionsChangeStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskActionsChangeStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskActionsChangeStatusMutation, { data, loading, error }] = useTaskActionsChangeStatusMutation({
 *   variables: {
 *      changeStatusInput: // value for 'changeStatusInput'
 *   },
 * });
 */
export function useTaskActionsChangeStatusMutation(baseOptions?: Apollo.MutationHookOptions<TaskActionsChangeStatusMutation, TaskActionsChangeStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskActionsChangeStatusMutation, TaskActionsChangeStatusMutationVariables>(TaskActionsChangeStatusDocument, options);
      }
export type TaskActionsChangeStatusMutationHookResult = ReturnType<typeof useTaskActionsChangeStatusMutation>;
export type TaskActionsChangeStatusMutationResult = Apollo.MutationResult<TaskActionsChangeStatusMutation>;
export type TaskActionsChangeStatusMutationOptions = Apollo.BaseMutationOptions<TaskActionsChangeStatusMutation, TaskActionsChangeStatusMutationVariables>;
export const TaskActionsToggleGroupTaskCompletedDocument = gql`
    mutation TaskActions_ToggleGroupTaskCompleted($taskInput: toggleGroupTaskCompletedInput!) {
  toggleGroupTaskCompleted(input: $taskInput) {
    task {
      ...TaskActions_Task
    }
  }
}
    ${TaskActionsTaskFragmentDoc}`;
export type TaskActionsToggleGroupTaskCompletedMutationFn = Apollo.MutationFunction<TaskActionsToggleGroupTaskCompletedMutation, TaskActionsToggleGroupTaskCompletedMutationVariables>;

/**
 * __useTaskActionsToggleGroupTaskCompletedMutation__
 *
 * To run a mutation, you first call `useTaskActionsToggleGroupTaskCompletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskActionsToggleGroupTaskCompletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskActionsToggleGroupTaskCompletedMutation, { data, loading, error }] = useTaskActionsToggleGroupTaskCompletedMutation({
 *   variables: {
 *      taskInput: // value for 'taskInput'
 *   },
 * });
 */
export function useTaskActionsToggleGroupTaskCompletedMutation(baseOptions?: Apollo.MutationHookOptions<TaskActionsToggleGroupTaskCompletedMutation, TaskActionsToggleGroupTaskCompletedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskActionsToggleGroupTaskCompletedMutation, TaskActionsToggleGroupTaskCompletedMutationVariables>(TaskActionsToggleGroupTaskCompletedDocument, options);
      }
export type TaskActionsToggleGroupTaskCompletedMutationHookResult = ReturnType<typeof useTaskActionsToggleGroupTaskCompletedMutation>;
export type TaskActionsToggleGroupTaskCompletedMutationResult = Apollo.MutationResult<TaskActionsToggleGroupTaskCompletedMutation>;
export type TaskActionsToggleGroupTaskCompletedMutationOptions = Apollo.BaseMutationOptions<TaskActionsToggleGroupTaskCompletedMutation, TaskActionsToggleGroupTaskCompletedMutationVariables>;
export const UnsubscribeUserUpdateUserNotificationPreferencesDocument = gql`
    mutation UnsubscribeUser_UpdateUserNotificationPreferences($user: updateUserNotificationPreferencesInput!) {
  updateUserNotificationPreferences(input: $user) {
    user {
      id
      ...NotificationsForm_User
    }
  }
}
    ${NotificationsFormUserFragmentDoc}`;
export type UnsubscribeUserUpdateUserNotificationPreferencesMutationFn = Apollo.MutationFunction<UnsubscribeUserUpdateUserNotificationPreferencesMutation, UnsubscribeUserUpdateUserNotificationPreferencesMutationVariables>;

/**
 * __useUnsubscribeUserUpdateUserNotificationPreferencesMutation__
 *
 * To run a mutation, you first call `useUnsubscribeUserUpdateUserNotificationPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeUserUpdateUserNotificationPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsubscribeUserUpdateUserNotificationPreferencesMutation, { data, loading, error }] = useUnsubscribeUserUpdateUserNotificationPreferencesMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUnsubscribeUserUpdateUserNotificationPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<UnsubscribeUserUpdateUserNotificationPreferencesMutation, UnsubscribeUserUpdateUserNotificationPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsubscribeUserUpdateUserNotificationPreferencesMutation, UnsubscribeUserUpdateUserNotificationPreferencesMutationVariables>(UnsubscribeUserUpdateUserNotificationPreferencesDocument, options);
      }
export type UnsubscribeUserUpdateUserNotificationPreferencesMutationHookResult = ReturnType<typeof useUnsubscribeUserUpdateUserNotificationPreferencesMutation>;
export type UnsubscribeUserUpdateUserNotificationPreferencesMutationResult = Apollo.MutationResult<UnsubscribeUserUpdateUserNotificationPreferencesMutation>;
export type UnsubscribeUserUpdateUserNotificationPreferencesMutationOptions = Apollo.BaseMutationOptions<UnsubscribeUserUpdateUserNotificationPreferencesMutation, UnsubscribeUserUpdateUserNotificationPreferencesMutationVariables>;
export const UnsubscribeWatcherTaskDocument = gql`
    query UnsubscribeWatcher_Task($taskId: ID!) {
  task(id: $taskId) {
    id
    name
    watchers {
      id
    }
  }
}
    `;

/**
 * __useUnsubscribeWatcherTaskQuery__
 *
 * To run a query within a React component, call `useUnsubscribeWatcherTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeWatcherTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnsubscribeWatcherTaskQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useUnsubscribeWatcherTaskQuery(baseOptions: Apollo.QueryHookOptions<UnsubscribeWatcherTaskQuery, UnsubscribeWatcherTaskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnsubscribeWatcherTaskQuery, UnsubscribeWatcherTaskQueryVariables>(UnsubscribeWatcherTaskDocument, options);
      }
export function useUnsubscribeWatcherTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnsubscribeWatcherTaskQuery, UnsubscribeWatcherTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnsubscribeWatcherTaskQuery, UnsubscribeWatcherTaskQueryVariables>(UnsubscribeWatcherTaskDocument, options);
        }
export type UnsubscribeWatcherTaskQueryHookResult = ReturnType<typeof useUnsubscribeWatcherTaskQuery>;
export type UnsubscribeWatcherTaskLazyQueryHookResult = ReturnType<typeof useUnsubscribeWatcherTaskLazyQuery>;
export type UnsubscribeWatcherTaskQueryResult = Apollo.QueryResult<UnsubscribeWatcherTaskQuery, UnsubscribeWatcherTaskQueryVariables>;
export const UnsubscribeWatcherRemoveWatcherDocument = gql`
    mutation UnsubscribeWatcher_RemoveWatcher($variables: removeWatcherInput!) {
  removeWatcher(input: $variables) {
    success
  }
}
    `;
export type UnsubscribeWatcherRemoveWatcherMutationFn = Apollo.MutationFunction<UnsubscribeWatcherRemoveWatcherMutation, UnsubscribeWatcherRemoveWatcherMutationVariables>;

/**
 * __useUnsubscribeWatcherRemoveWatcherMutation__
 *
 * To run a mutation, you first call `useUnsubscribeWatcherRemoveWatcherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeWatcherRemoveWatcherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsubscribeWatcherRemoveWatcherMutation, { data, loading, error }] = useUnsubscribeWatcherRemoveWatcherMutation({
 *   variables: {
 *      variables: // value for 'variables'
 *   },
 * });
 */
export function useUnsubscribeWatcherRemoveWatcherMutation(baseOptions?: Apollo.MutationHookOptions<UnsubscribeWatcherRemoveWatcherMutation, UnsubscribeWatcherRemoveWatcherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsubscribeWatcherRemoveWatcherMutation, UnsubscribeWatcherRemoveWatcherMutationVariables>(UnsubscribeWatcherRemoveWatcherDocument, options);
      }
export type UnsubscribeWatcherRemoveWatcherMutationHookResult = ReturnType<typeof useUnsubscribeWatcherRemoveWatcherMutation>;
export type UnsubscribeWatcherRemoveWatcherMutationResult = Apollo.MutationResult<UnsubscribeWatcherRemoveWatcherMutation>;
export type UnsubscribeWatcherRemoveWatcherMutationOptions = Apollo.BaseMutationOptions<UnsubscribeWatcherRemoveWatcherMutation, UnsubscribeWatcherRemoveWatcherMutationVariables>;
export const AddCustomerPromptAddCustomerUsersToProjectDocument = gql`
    mutation AddCustomerPrompt_AddCustomerUsersToProject($projectId: ID!, $users: [ProjectUserInput!]) {
  addCustomerUsersToProject(input: {id: $projectId, users: $users}) {
    project {
      id
      users {
        id
        ...ProjectTeam_User
      }
      organization {
        id
      }
    }
  }
}
    ${ProjectTeamUserFragmentDoc}`;
export type AddCustomerPromptAddCustomerUsersToProjectMutationFn = Apollo.MutationFunction<AddCustomerPromptAddCustomerUsersToProjectMutation, AddCustomerPromptAddCustomerUsersToProjectMutationVariables>;

/**
 * __useAddCustomerPromptAddCustomerUsersToProjectMutation__
 *
 * To run a mutation, you first call `useAddCustomerPromptAddCustomerUsersToProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCustomerPromptAddCustomerUsersToProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCustomerPromptAddCustomerUsersToProjectMutation, { data, loading, error }] = useAddCustomerPromptAddCustomerUsersToProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      users: // value for 'users'
 *   },
 * });
 */
export function useAddCustomerPromptAddCustomerUsersToProjectMutation(baseOptions?: Apollo.MutationHookOptions<AddCustomerPromptAddCustomerUsersToProjectMutation, AddCustomerPromptAddCustomerUsersToProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCustomerPromptAddCustomerUsersToProjectMutation, AddCustomerPromptAddCustomerUsersToProjectMutationVariables>(AddCustomerPromptAddCustomerUsersToProjectDocument, options);
      }
export type AddCustomerPromptAddCustomerUsersToProjectMutationHookResult = ReturnType<typeof useAddCustomerPromptAddCustomerUsersToProjectMutation>;
export type AddCustomerPromptAddCustomerUsersToProjectMutationResult = Apollo.MutationResult<AddCustomerPromptAddCustomerUsersToProjectMutation>;
export type AddCustomerPromptAddCustomerUsersToProjectMutationOptions = Apollo.BaseMutationOptions<AddCustomerPromptAddCustomerUsersToProjectMutation, AddCustomerPromptAddCustomerUsersToProjectMutationVariables>;
export const ContextualizedAddTeamMemberDrawerProjectDocument = gql`
    query ContextualizedAddTeamMemberDrawer_Project($projectId: ID!) {
  project(id: $projectId) {
    id
    ...AddCustomerPrompt_Project
  }
}
    ${AddCustomerPromptProjectFragmentDoc}`;

/**
 * __useContextualizedAddTeamMemberDrawerProjectQuery__
 *
 * To run a query within a React component, call `useContextualizedAddTeamMemberDrawerProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useContextualizedAddTeamMemberDrawerProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContextualizedAddTeamMemberDrawerProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useContextualizedAddTeamMemberDrawerProjectQuery(baseOptions: Apollo.QueryHookOptions<ContextualizedAddTeamMemberDrawerProjectQuery, ContextualizedAddTeamMemberDrawerProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContextualizedAddTeamMemberDrawerProjectQuery, ContextualizedAddTeamMemberDrawerProjectQueryVariables>(ContextualizedAddTeamMemberDrawerProjectDocument, options);
      }
export function useContextualizedAddTeamMemberDrawerProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContextualizedAddTeamMemberDrawerProjectQuery, ContextualizedAddTeamMemberDrawerProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContextualizedAddTeamMemberDrawerProjectQuery, ContextualizedAddTeamMemberDrawerProjectQueryVariables>(ContextualizedAddTeamMemberDrawerProjectDocument, options);
        }
export type ContextualizedAddTeamMemberDrawerProjectQueryHookResult = ReturnType<typeof useContextualizedAddTeamMemberDrawerProjectQuery>;
export type ContextualizedAddTeamMemberDrawerProjectLazyQueryHookResult = ReturnType<typeof useContextualizedAddTeamMemberDrawerProjectLazyQuery>;
export type ContextualizedAddTeamMemberDrawerProjectQueryResult = Apollo.QueryResult<ContextualizedAddTeamMemberDrawerProjectQuery, ContextualizedAddTeamMemberDrawerProjectQueryVariables>;
export const AddCustomerPromptPmProjectDocument = gql`
    query AddCustomerPromptPM_Project($projectId: ID!) {
  project(id: $projectId) {
    id
    ...AddCustomerPromptA_Project
  }
}
    ${AddCustomerPromptAProjectFragmentDoc}`;

/**
 * __useAddCustomerPromptPmProjectQuery__
 *
 * To run a query within a React component, call `useAddCustomerPromptPmProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddCustomerPromptPmProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddCustomerPromptPmProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useAddCustomerPromptPmProjectQuery(baseOptions: Apollo.QueryHookOptions<AddCustomerPromptPmProjectQuery, AddCustomerPromptPmProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddCustomerPromptPmProjectQuery, AddCustomerPromptPmProjectQueryVariables>(AddCustomerPromptPmProjectDocument, options);
      }
export function useAddCustomerPromptPmProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddCustomerPromptPmProjectQuery, AddCustomerPromptPmProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddCustomerPromptPmProjectQuery, AddCustomerPromptPmProjectQueryVariables>(AddCustomerPromptPmProjectDocument, options);
        }
export type AddCustomerPromptPmProjectQueryHookResult = ReturnType<typeof useAddCustomerPromptPmProjectQuery>;
export type AddCustomerPromptPmProjectLazyQueryHookResult = ReturnType<typeof useAddCustomerPromptPmProjectLazyQuery>;
export type AddCustomerPromptPmProjectQueryResult = Apollo.QueryResult<AddCustomerPromptPmProjectQuery, AddCustomerPromptPmProjectQueryVariables>;
export const AttachmentsUpdateAttachmentSortOrderDocument = gql`
    mutation Attachments_UpdateAttachmentSortOrder($input: updateAttachmentSortOrderInput!) {
  updateAttachmentSortOrder(input: $input) {
    task {
      id
      files {
        id
        ...Attachments_File
      }
    }
  }
}
    ${AttachmentsFileFragmentDoc}`;
export type AttachmentsUpdateAttachmentSortOrderMutationFn = Apollo.MutationFunction<AttachmentsUpdateAttachmentSortOrderMutation, AttachmentsUpdateAttachmentSortOrderMutationVariables>;

/**
 * __useAttachmentsUpdateAttachmentSortOrderMutation__
 *
 * To run a mutation, you first call `useAttachmentsUpdateAttachmentSortOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachmentsUpdateAttachmentSortOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachmentsUpdateAttachmentSortOrderMutation, { data, loading, error }] = useAttachmentsUpdateAttachmentSortOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttachmentsUpdateAttachmentSortOrderMutation(baseOptions?: Apollo.MutationHookOptions<AttachmentsUpdateAttachmentSortOrderMutation, AttachmentsUpdateAttachmentSortOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AttachmentsUpdateAttachmentSortOrderMutation, AttachmentsUpdateAttachmentSortOrderMutationVariables>(AttachmentsUpdateAttachmentSortOrderDocument, options);
      }
export type AttachmentsUpdateAttachmentSortOrderMutationHookResult = ReturnType<typeof useAttachmentsUpdateAttachmentSortOrderMutation>;
export type AttachmentsUpdateAttachmentSortOrderMutationResult = Apollo.MutationResult<AttachmentsUpdateAttachmentSortOrderMutation>;
export type AttachmentsUpdateAttachmentSortOrderMutationOptions = Apollo.BaseMutationOptions<AttachmentsUpdateAttachmentSortOrderMutation, AttachmentsUpdateAttachmentSortOrderMutationVariables>;
export const ChangeStatusDropdownUpdateNodeStatusDocument = gql`
    mutation ChangeStatusDropdown_UpdateNodeStatus($id: ID!, $status: StatusEnumType!, $objectType: StatusObjectEnumType!) {
  updateObjectStatus(input: {id: $id, status: $status, objectType: $objectType}) {
    resolveObject {
      ... on ProjectType {
        id
        status
      }
      ... on TaskType {
        id
        status
        completedAt
        completed
        project {
          id
          startOn
          endOn
          completedAt
          forecastedEndOn
          stats {
            totalTasks
            totalDoneTasks
            totalAssignedTasks
            totalTasksWithUnestimatedHoursCount
            totalActualHours
            totalInternalEstimatedHours
          }
          profitabilitySummary {
            forecastedCost
            budgetedCost
          }
        }
      }
    }
  }
}
    `;
export type ChangeStatusDropdownUpdateNodeStatusMutationFn = Apollo.MutationFunction<ChangeStatusDropdownUpdateNodeStatusMutation, ChangeStatusDropdownUpdateNodeStatusMutationVariables>;

/**
 * __useChangeStatusDropdownUpdateNodeStatusMutation__
 *
 * To run a mutation, you first call `useChangeStatusDropdownUpdateNodeStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeStatusDropdownUpdateNodeStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeStatusDropdownUpdateNodeStatusMutation, { data, loading, error }] = useChangeStatusDropdownUpdateNodeStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      objectType: // value for 'objectType'
 *   },
 * });
 */
export function useChangeStatusDropdownUpdateNodeStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChangeStatusDropdownUpdateNodeStatusMutation, ChangeStatusDropdownUpdateNodeStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeStatusDropdownUpdateNodeStatusMutation, ChangeStatusDropdownUpdateNodeStatusMutationVariables>(ChangeStatusDropdownUpdateNodeStatusDocument, options);
      }
export type ChangeStatusDropdownUpdateNodeStatusMutationHookResult = ReturnType<typeof useChangeStatusDropdownUpdateNodeStatusMutation>;
export type ChangeStatusDropdownUpdateNodeStatusMutationResult = Apollo.MutationResult<ChangeStatusDropdownUpdateNodeStatusMutation>;
export type ChangeStatusDropdownUpdateNodeStatusMutationOptions = Apollo.BaseMutationOptions<ChangeStatusDropdownUpdateNodeStatusMutation, ChangeStatusDropdownUpdateNodeStatusMutationVariables>;
export const ChecklistAddSubtaskDocument = gql`
    mutation Checklist_AddSubtask($input: createSubtaskInput!) {
  createSubtask(input: $input) {
    task {
      id
      incompleteSubtasksCount
      completeSubtasksCount
      subtasksGroups {
        id
        name
      }
      subtasks {
        ...SubtaskFragment
      }
    }
  }
}
    ${SubtaskFragmentDoc}`;
export type ChecklistAddSubtaskMutationFn = Apollo.MutationFunction<ChecklistAddSubtaskMutation, ChecklistAddSubtaskMutationVariables>;

/**
 * __useChecklistAddSubtaskMutation__
 *
 * To run a mutation, you first call `useChecklistAddSubtaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChecklistAddSubtaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checklistAddSubtaskMutation, { data, loading, error }] = useChecklistAddSubtaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChecklistAddSubtaskMutation(baseOptions?: Apollo.MutationHookOptions<ChecklistAddSubtaskMutation, ChecklistAddSubtaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChecklistAddSubtaskMutation, ChecklistAddSubtaskMutationVariables>(ChecklistAddSubtaskDocument, options);
      }
export type ChecklistAddSubtaskMutationHookResult = ReturnType<typeof useChecklistAddSubtaskMutation>;
export type ChecklistAddSubtaskMutationResult = Apollo.MutationResult<ChecklistAddSubtaskMutation>;
export type ChecklistAddSubtaskMutationOptions = Apollo.BaseMutationOptions<ChecklistAddSubtaskMutation, ChecklistAddSubtaskMutationVariables>;
export const ChecklistAddGroupDocument = gql`
    mutation Checklist_AddGroup($input: createSubtaskGroupInput!) {
  createSubtasksGroup(input: $input) {
    task {
      id
      subtasksGroups {
        id
        name
      }
      subtasks {
        ...SubtaskFragment
      }
    }
  }
}
    ${SubtaskFragmentDoc}`;
export type ChecklistAddGroupMutationFn = Apollo.MutationFunction<ChecklistAddGroupMutation, ChecklistAddGroupMutationVariables>;

/**
 * __useChecklistAddGroupMutation__
 *
 * To run a mutation, you first call `useChecklistAddGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChecklistAddGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checklistAddGroupMutation, { data, loading, error }] = useChecklistAddGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChecklistAddGroupMutation(baseOptions?: Apollo.MutationHookOptions<ChecklistAddGroupMutation, ChecklistAddGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChecklistAddGroupMutation, ChecklistAddGroupMutationVariables>(ChecklistAddGroupDocument, options);
      }
export type ChecklistAddGroupMutationHookResult = ReturnType<typeof useChecklistAddGroupMutation>;
export type ChecklistAddGroupMutationResult = Apollo.MutationResult<ChecklistAddGroupMutation>;
export type ChecklistAddGroupMutationOptions = Apollo.BaseMutationOptions<ChecklistAddGroupMutation, ChecklistAddGroupMutationVariables>;
export const ChecklistGroupUpdateSubtasksGroupDocument = gql`
    mutation ChecklistGroup_UpdateSubtasksGroup($input: updateSubtaskGroupInput!) {
  updateSubtasksGroup(input: $input) {
    success
  }
}
    `;
export type ChecklistGroupUpdateSubtasksGroupMutationFn = Apollo.MutationFunction<ChecklistGroupUpdateSubtasksGroupMutation, ChecklistGroupUpdateSubtasksGroupMutationVariables>;

/**
 * __useChecklistGroupUpdateSubtasksGroupMutation__
 *
 * To run a mutation, you first call `useChecklistGroupUpdateSubtasksGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChecklistGroupUpdateSubtasksGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checklistGroupUpdateSubtasksGroupMutation, { data, loading, error }] = useChecklistGroupUpdateSubtasksGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChecklistGroupUpdateSubtasksGroupMutation(baseOptions?: Apollo.MutationHookOptions<ChecklistGroupUpdateSubtasksGroupMutation, ChecklistGroupUpdateSubtasksGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChecklistGroupUpdateSubtasksGroupMutation, ChecklistGroupUpdateSubtasksGroupMutationVariables>(ChecklistGroupUpdateSubtasksGroupDocument, options);
      }
export type ChecklistGroupUpdateSubtasksGroupMutationHookResult = ReturnType<typeof useChecklistGroupUpdateSubtasksGroupMutation>;
export type ChecklistGroupUpdateSubtasksGroupMutationResult = Apollo.MutationResult<ChecklistGroupUpdateSubtasksGroupMutation>;
export type ChecklistGroupUpdateSubtasksGroupMutationOptions = Apollo.BaseMutationOptions<ChecklistGroupUpdateSubtasksGroupMutation, ChecklistGroupUpdateSubtasksGroupMutationVariables>;
export const ChecklistGroupDeleteSubtasksGroupDocument = gql`
    mutation ChecklistGroup_DeleteSubtasksGroup($input: deleteSubtaskGroupInput!) {
  deleteSubtasksGroup(input: $input) {
    task {
      id
      subtasks {
        ...SubtaskFragment
      }
      subtasksGroups {
        id
        name
      }
    }
  }
}
    ${SubtaskFragmentDoc}`;
export type ChecklistGroupDeleteSubtasksGroupMutationFn = Apollo.MutationFunction<ChecklistGroupDeleteSubtasksGroupMutation, ChecklistGroupDeleteSubtasksGroupMutationVariables>;

/**
 * __useChecklistGroupDeleteSubtasksGroupMutation__
 *
 * To run a mutation, you first call `useChecklistGroupDeleteSubtasksGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChecklistGroupDeleteSubtasksGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checklistGroupDeleteSubtasksGroupMutation, { data, loading, error }] = useChecklistGroupDeleteSubtasksGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChecklistGroupDeleteSubtasksGroupMutation(baseOptions?: Apollo.MutationHookOptions<ChecklistGroupDeleteSubtasksGroupMutation, ChecklistGroupDeleteSubtasksGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChecklistGroupDeleteSubtasksGroupMutation, ChecklistGroupDeleteSubtasksGroupMutationVariables>(ChecklistGroupDeleteSubtasksGroupDocument, options);
      }
export type ChecklistGroupDeleteSubtasksGroupMutationHookResult = ReturnType<typeof useChecklistGroupDeleteSubtasksGroupMutation>;
export type ChecklistGroupDeleteSubtasksGroupMutationResult = Apollo.MutationResult<ChecklistGroupDeleteSubtasksGroupMutation>;
export type ChecklistGroupDeleteSubtasksGroupMutationOptions = Apollo.BaseMutationOptions<ChecklistGroupDeleteSubtasksGroupMutation, ChecklistGroupDeleteSubtasksGroupMutationVariables>;
export const ChecklistPortalUpdateSubTaskNameDocument = gql`
    mutation ChecklistPortal_UpdateSubTaskName($input: updateSubTaskNameInput!) {
  updateSubTaskName(input: $input) {
    subtask {
      id
      task {
        id
        incompleteSubtasksCount
        completeSubtasksCount
      }
      ...SubtaskFragment
    }
  }
}
    ${SubtaskFragmentDoc}`;
export type ChecklistPortalUpdateSubTaskNameMutationFn = Apollo.MutationFunction<ChecklistPortalUpdateSubTaskNameMutation, ChecklistPortalUpdateSubTaskNameMutationVariables>;

/**
 * __useChecklistPortalUpdateSubTaskNameMutation__
 *
 * To run a mutation, you first call `useChecklistPortalUpdateSubTaskNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChecklistPortalUpdateSubTaskNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checklistPortalUpdateSubTaskNameMutation, { data, loading, error }] = useChecklistPortalUpdateSubTaskNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChecklistPortalUpdateSubTaskNameMutation(baseOptions?: Apollo.MutationHookOptions<ChecklistPortalUpdateSubTaskNameMutation, ChecklistPortalUpdateSubTaskNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChecklistPortalUpdateSubTaskNameMutation, ChecklistPortalUpdateSubTaskNameMutationVariables>(ChecklistPortalUpdateSubTaskNameDocument, options);
      }
export type ChecklistPortalUpdateSubTaskNameMutationHookResult = ReturnType<typeof useChecklistPortalUpdateSubTaskNameMutation>;
export type ChecklistPortalUpdateSubTaskNameMutationResult = Apollo.MutationResult<ChecklistPortalUpdateSubTaskNameMutation>;
export type ChecklistPortalUpdateSubTaskNameMutationOptions = Apollo.BaseMutationOptions<ChecklistPortalUpdateSubTaskNameMutation, ChecklistPortalUpdateSubTaskNameMutationVariables>;
export const ChecklistPortalToggleDocument = gql`
    mutation ChecklistPortal_Toggle($input: toggleSubtaskDoneInput!) {
  toggleSubtask(input: $input) {
    subtask {
      id
      task {
        id
        incompleteSubtasksCount
        completeSubtasksCount
      }
      ...SubtaskFragment
    }
  }
}
    ${SubtaskFragmentDoc}`;
export type ChecklistPortalToggleMutationFn = Apollo.MutationFunction<ChecklistPortalToggleMutation, ChecklistPortalToggleMutationVariables>;

/**
 * __useChecklistPortalToggleMutation__
 *
 * To run a mutation, you first call `useChecklistPortalToggleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChecklistPortalToggleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checklistPortalToggleMutation, { data, loading, error }] = useChecklistPortalToggleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChecklistPortalToggleMutation(baseOptions?: Apollo.MutationHookOptions<ChecklistPortalToggleMutation, ChecklistPortalToggleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChecklistPortalToggleMutation, ChecklistPortalToggleMutationVariables>(ChecklistPortalToggleDocument, options);
      }
export type ChecklistPortalToggleMutationHookResult = ReturnType<typeof useChecklistPortalToggleMutation>;
export type ChecklistPortalToggleMutationResult = Apollo.MutationResult<ChecklistPortalToggleMutation>;
export type ChecklistPortalToggleMutationOptions = Apollo.BaseMutationOptions<ChecklistPortalToggleMutation, ChecklistPortalToggleMutationVariables>;
export const ChecklistPortalDeleteSubtaskDocument = gql`
    mutation ChecklistPortal_DeleteSubtask($input: deleteSubtaskInput!) {
  deleteSubtask(input: $input) {
    task {
      id
      incompleteSubtasksCount
      completeSubtasksCount
      subtasks {
        ...SubtaskFragment
      }
    }
  }
}
    ${SubtaskFragmentDoc}`;
export type ChecklistPortalDeleteSubtaskMutationFn = Apollo.MutationFunction<ChecklistPortalDeleteSubtaskMutation, ChecklistPortalDeleteSubtaskMutationVariables>;

/**
 * __useChecklistPortalDeleteSubtaskMutation__
 *
 * To run a mutation, you first call `useChecklistPortalDeleteSubtaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChecklistPortalDeleteSubtaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checklistPortalDeleteSubtaskMutation, { data, loading, error }] = useChecklistPortalDeleteSubtaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChecklistPortalDeleteSubtaskMutation(baseOptions?: Apollo.MutationHookOptions<ChecklistPortalDeleteSubtaskMutation, ChecklistPortalDeleteSubtaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChecklistPortalDeleteSubtaskMutation, ChecklistPortalDeleteSubtaskMutationVariables>(ChecklistPortalDeleteSubtaskDocument, options);
      }
export type ChecklistPortalDeleteSubtaskMutationHookResult = ReturnType<typeof useChecklistPortalDeleteSubtaskMutation>;
export type ChecklistPortalDeleteSubtaskMutationResult = Apollo.MutationResult<ChecklistPortalDeleteSubtaskMutation>;
export type ChecklistPortalDeleteSubtaskMutationOptions = Apollo.BaseMutationOptions<ChecklistPortalDeleteSubtaskMutation, ChecklistPortalDeleteSubtaskMutationVariables>;
export const ConfirmUpdateStatusDialogUpdateNodeStatusDocument = gql`
    mutation ConfirmUpdateStatusDialog_UpdateNodeStatus($id: ID!, $status: StatusEnumType!, $objectType: StatusObjectEnumType!) {
  updateObjectStatus(input: {id: $id, status: $status, objectType: $objectType}) {
    resolveObject {
      ... on TaskType {
        id
        status
        project {
          id
          startOn
          endOn
          completedAt
          forecastedEndOn
          stats {
            totalTasks
            totalDoneTasks
            totalAssignedTasks
            totalTasksWithUnestimatedHoursCount
            totalActualHours
            totalInternalEstimatedHours
          }
          profitabilitySummary {
            forecastedCost
            budgetedCost
          }
        }
        __typename
      }
    }
  }
}
    `;
export type ConfirmUpdateStatusDialogUpdateNodeStatusMutationFn = Apollo.MutationFunction<ConfirmUpdateStatusDialogUpdateNodeStatusMutation, ConfirmUpdateStatusDialogUpdateNodeStatusMutationVariables>;

/**
 * __useConfirmUpdateStatusDialogUpdateNodeStatusMutation__
 *
 * To run a mutation, you first call `useConfirmUpdateStatusDialogUpdateNodeStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmUpdateStatusDialogUpdateNodeStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmUpdateStatusDialogUpdateNodeStatusMutation, { data, loading, error }] = useConfirmUpdateStatusDialogUpdateNodeStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      objectType: // value for 'objectType'
 *   },
 * });
 */
export function useConfirmUpdateStatusDialogUpdateNodeStatusMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmUpdateStatusDialogUpdateNodeStatusMutation, ConfirmUpdateStatusDialogUpdateNodeStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmUpdateStatusDialogUpdateNodeStatusMutation, ConfirmUpdateStatusDialogUpdateNodeStatusMutationVariables>(ConfirmUpdateStatusDialogUpdateNodeStatusDocument, options);
      }
export type ConfirmUpdateStatusDialogUpdateNodeStatusMutationHookResult = ReturnType<typeof useConfirmUpdateStatusDialogUpdateNodeStatusMutation>;
export type ConfirmUpdateStatusDialogUpdateNodeStatusMutationResult = Apollo.MutationResult<ConfirmUpdateStatusDialogUpdateNodeStatusMutation>;
export type ConfirmUpdateStatusDialogUpdateNodeStatusMutationOptions = Apollo.BaseMutationOptions<ConfirmUpdateStatusDialogUpdateNodeStatusMutation, ConfirmUpdateStatusDialogUpdateNodeStatusMutationVariables>;
export const SaveFilterDialogSaveFilterDocument = gql`
    mutation SaveFilterDialog_SaveFilter($input: createUserFilterViewInput!) {
  createUserFilterView(input: $input) {
    userFilterView {
      id
      name
      category
      jsonFilterBlob
    }
  }
}
    `;
export type SaveFilterDialogSaveFilterMutationFn = Apollo.MutationFunction<SaveFilterDialogSaveFilterMutation, SaveFilterDialogSaveFilterMutationVariables>;

/**
 * __useSaveFilterDialogSaveFilterMutation__
 *
 * To run a mutation, you first call `useSaveFilterDialogSaveFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveFilterDialogSaveFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveFilterDialogSaveFilterMutation, { data, loading, error }] = useSaveFilterDialogSaveFilterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveFilterDialogSaveFilterMutation(baseOptions?: Apollo.MutationHookOptions<SaveFilterDialogSaveFilterMutation, SaveFilterDialogSaveFilterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveFilterDialogSaveFilterMutation, SaveFilterDialogSaveFilterMutationVariables>(SaveFilterDialogSaveFilterDocument, options);
      }
export type SaveFilterDialogSaveFilterMutationHookResult = ReturnType<typeof useSaveFilterDialogSaveFilterMutation>;
export type SaveFilterDialogSaveFilterMutationResult = Apollo.MutationResult<SaveFilterDialogSaveFilterMutation>;
export type SaveFilterDialogSaveFilterMutationOptions = Apollo.BaseMutationOptions<SaveFilterDialogSaveFilterMutation, SaveFilterDialogSaveFilterMutationVariables>;
export const StuckTaskMessageDialogUpdateNodeStatusDocument = gql`
    mutation StuckTaskMessageDialog_UpdateNodeStatus($id: ID!, $status: StatusEnumType!, $stuckMessage: String, $objectType: StatusObjectEnumType!) {
  updateObjectStatus(
    input: {id: $id, status: $status, stuckMessage: $stuckMessage, objectType: $objectType}
  ) {
    resolveObject {
      ... on TaskType {
        id
        status
        project {
          id
          startOn
          endOn
          completedAt
          forecastedEndOn
          stats {
            totalTasks
            totalDoneTasks
            totalAssignedTasks
            totalTasksWithUnestimatedHoursCount
            totalActualHours
            totalInternalEstimatedHours
          }
          profitabilitySummary {
            forecastedCost
            budgetedCost
          }
        }
        __typename
      }
    }
  }
}
    `;
export type StuckTaskMessageDialogUpdateNodeStatusMutationFn = Apollo.MutationFunction<StuckTaskMessageDialogUpdateNodeStatusMutation, StuckTaskMessageDialogUpdateNodeStatusMutationVariables>;

/**
 * __useStuckTaskMessageDialogUpdateNodeStatusMutation__
 *
 * To run a mutation, you first call `useStuckTaskMessageDialogUpdateNodeStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStuckTaskMessageDialogUpdateNodeStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stuckTaskMessageDialogUpdateNodeStatusMutation, { data, loading, error }] = useStuckTaskMessageDialogUpdateNodeStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      stuckMessage: // value for 'stuckMessage'
 *      objectType: // value for 'objectType'
 *   },
 * });
 */
export function useStuckTaskMessageDialogUpdateNodeStatusMutation(baseOptions?: Apollo.MutationHookOptions<StuckTaskMessageDialogUpdateNodeStatusMutation, StuckTaskMessageDialogUpdateNodeStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StuckTaskMessageDialogUpdateNodeStatusMutation, StuckTaskMessageDialogUpdateNodeStatusMutationVariables>(StuckTaskMessageDialogUpdateNodeStatusDocument, options);
      }
export type StuckTaskMessageDialogUpdateNodeStatusMutationHookResult = ReturnType<typeof useStuckTaskMessageDialogUpdateNodeStatusMutation>;
export type StuckTaskMessageDialogUpdateNodeStatusMutationResult = Apollo.MutationResult<StuckTaskMessageDialogUpdateNodeStatusMutation>;
export type StuckTaskMessageDialogUpdateNodeStatusMutationOptions = Apollo.BaseMutationOptions<StuckTaskMessageDialogUpdateNodeStatusMutation, StuckTaskMessageDialogUpdateNodeStatusMutationVariables>;
export const AdminTeamFormProjectManagersDocument = gql`
    query AdminTeamForm_ProjectManagers {
  projectManagers(excludeAdmins: false) {
    id
    firstName
    lastName
    role
  }
}
    `;

/**
 * __useAdminTeamFormProjectManagersQuery__
 *
 * To run a query within a React component, call `useAdminTeamFormProjectManagersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminTeamFormProjectManagersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminTeamFormProjectManagersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminTeamFormProjectManagersQuery(baseOptions?: Apollo.QueryHookOptions<AdminTeamFormProjectManagersQuery, AdminTeamFormProjectManagersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminTeamFormProjectManagersQuery, AdminTeamFormProjectManagersQueryVariables>(AdminTeamFormProjectManagersDocument, options);
      }
export function useAdminTeamFormProjectManagersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminTeamFormProjectManagersQuery, AdminTeamFormProjectManagersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminTeamFormProjectManagersQuery, AdminTeamFormProjectManagersQueryVariables>(AdminTeamFormProjectManagersDocument, options);
        }
export type AdminTeamFormProjectManagersQueryHookResult = ReturnType<typeof useAdminTeamFormProjectManagersQuery>;
export type AdminTeamFormProjectManagersLazyQueryHookResult = ReturnType<typeof useAdminTeamFormProjectManagersLazyQuery>;
export type AdminTeamFormProjectManagersQueryResult = Apollo.QueryResult<AdminTeamFormProjectManagersQuery, AdminTeamFormProjectManagersQueryVariables>;
export const AdminTeamFormAdminTeamMembersDocument = gql`
    query AdminTeamForm_AdminTeamMembers($userId: ID!) {
  adminTeam(userId: $userId) {
    id
    firstName
    lastName
    role
  }
}
    `;

/**
 * __useAdminTeamFormAdminTeamMembersQuery__
 *
 * To run a query within a React component, call `useAdminTeamFormAdminTeamMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminTeamFormAdminTeamMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminTeamFormAdminTeamMembersQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminTeamFormAdminTeamMembersQuery(baseOptions: Apollo.QueryHookOptions<AdminTeamFormAdminTeamMembersQuery, AdminTeamFormAdminTeamMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminTeamFormAdminTeamMembersQuery, AdminTeamFormAdminTeamMembersQueryVariables>(AdminTeamFormAdminTeamMembersDocument, options);
      }
export function useAdminTeamFormAdminTeamMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminTeamFormAdminTeamMembersQuery, AdminTeamFormAdminTeamMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminTeamFormAdminTeamMembersQuery, AdminTeamFormAdminTeamMembersQueryVariables>(AdminTeamFormAdminTeamMembersDocument, options);
        }
export type AdminTeamFormAdminTeamMembersQueryHookResult = ReturnType<typeof useAdminTeamFormAdminTeamMembersQuery>;
export type AdminTeamFormAdminTeamMembersLazyQueryHookResult = ReturnType<typeof useAdminTeamFormAdminTeamMembersLazyQuery>;
export type AdminTeamFormAdminTeamMembersQueryResult = Apollo.QueryResult<AdminTeamFormAdminTeamMembersQuery, AdminTeamFormAdminTeamMembersQueryVariables>;
export const AdminTeamFormUserDocument = gql`
    query AdminTeamForm_User($userId: ID!) {
  user(id: $userId) {
    id
    email
    role
  }
}
    `;

/**
 * __useAdminTeamFormUserQuery__
 *
 * To run a query within a React component, call `useAdminTeamFormUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminTeamFormUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminTeamFormUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminTeamFormUserQuery(baseOptions: Apollo.QueryHookOptions<AdminTeamFormUserQuery, AdminTeamFormUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminTeamFormUserQuery, AdminTeamFormUserQueryVariables>(AdminTeamFormUserDocument, options);
      }
export function useAdminTeamFormUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminTeamFormUserQuery, AdminTeamFormUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminTeamFormUserQuery, AdminTeamFormUserQueryVariables>(AdminTeamFormUserDocument, options);
        }
export type AdminTeamFormUserQueryHookResult = ReturnType<typeof useAdminTeamFormUserQuery>;
export type AdminTeamFormUserLazyQueryHookResult = ReturnType<typeof useAdminTeamFormUserLazyQuery>;
export type AdminTeamFormUserQueryResult = Apollo.QueryResult<AdminTeamFormUserQuery, AdminTeamFormUserQueryVariables>;
export const AdminTeamFormUpdateAdminTeamDocument = gql`
    mutation AdminTeamForm_UpdateAdminTeam($data: updateAdminTeamInput!) {
  updateAdminTeam(input: $data) {
    success
  }
}
    `;
export type AdminTeamFormUpdateAdminTeamMutationFn = Apollo.MutationFunction<AdminTeamFormUpdateAdminTeamMutation, AdminTeamFormUpdateAdminTeamMutationVariables>;

/**
 * __useAdminTeamFormUpdateAdminTeamMutation__
 *
 * To run a mutation, you first call `useAdminTeamFormUpdateAdminTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminTeamFormUpdateAdminTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminTeamFormUpdateAdminTeamMutation, { data, loading, error }] = useAdminTeamFormUpdateAdminTeamMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAdminTeamFormUpdateAdminTeamMutation(baseOptions?: Apollo.MutationHookOptions<AdminTeamFormUpdateAdminTeamMutation, AdminTeamFormUpdateAdminTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminTeamFormUpdateAdminTeamMutation, AdminTeamFormUpdateAdminTeamMutationVariables>(AdminTeamFormUpdateAdminTeamDocument, options);
      }
export type AdminTeamFormUpdateAdminTeamMutationHookResult = ReturnType<typeof useAdminTeamFormUpdateAdminTeamMutation>;
export type AdminTeamFormUpdateAdminTeamMutationResult = Apollo.MutationResult<AdminTeamFormUpdateAdminTeamMutation>;
export type AdminTeamFormUpdateAdminTeamMutationOptions = Apollo.BaseMutationOptions<AdminTeamFormUpdateAdminTeamMutation, AdminTeamFormUpdateAdminTeamMutationVariables>;
export const EditUserFormUserDocument = gql`
    query EditUserForm_User($userId: ID!) {
  user(id: $userId) {
    id
    ...EditUserForm_User
  }
}
    ${EditUserFormUserFragmentDoc}`;

/**
 * __useEditUserFormUserQuery__
 *
 * To run a query within a React component, call `useEditUserFormUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditUserFormUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditUserFormUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useEditUserFormUserQuery(baseOptions: Apollo.QueryHookOptions<EditUserFormUserQuery, EditUserFormUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditUserFormUserQuery, EditUserFormUserQueryVariables>(EditUserFormUserDocument, options);
      }
export function useEditUserFormUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditUserFormUserQuery, EditUserFormUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditUserFormUserQuery, EditUserFormUserQueryVariables>(EditUserFormUserDocument, options);
        }
export type EditUserFormUserQueryHookResult = ReturnType<typeof useEditUserFormUserQuery>;
export type EditUserFormUserLazyQueryHookResult = ReturnType<typeof useEditUserFormUserLazyQuery>;
export type EditUserFormUserQueryResult = Apollo.QueryResult<EditUserFormUserQuery, EditUserFormUserQueryVariables>;
export const EditUserFormUserTasksDocument = gql`
    query EditUserForm_UserTasks($userId: ID!, $listInputs: ListInput) {
  userTasksConnections(userId: $userId, listInputs: $listInputs) {
    tasks {
      id
      ...TaskReassignTask
    }
  }
}
    ${TaskReassignTaskFragmentDoc}`;

/**
 * __useEditUserFormUserTasksQuery__
 *
 * To run a query within a React component, call `useEditUserFormUserTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditUserFormUserTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditUserFormUserTasksQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      listInputs: // value for 'listInputs'
 *   },
 * });
 */
export function useEditUserFormUserTasksQuery(baseOptions: Apollo.QueryHookOptions<EditUserFormUserTasksQuery, EditUserFormUserTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditUserFormUserTasksQuery, EditUserFormUserTasksQueryVariables>(EditUserFormUserTasksDocument, options);
      }
export function useEditUserFormUserTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditUserFormUserTasksQuery, EditUserFormUserTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditUserFormUserTasksQuery, EditUserFormUserTasksQueryVariables>(EditUserFormUserTasksDocument, options);
        }
export type EditUserFormUserTasksQueryHookResult = ReturnType<typeof useEditUserFormUserTasksQuery>;
export type EditUserFormUserTasksLazyQueryHookResult = ReturnType<typeof useEditUserFormUserTasksLazyQuery>;
export type EditUserFormUserTasksQueryResult = Apollo.QueryResult<EditUserFormUserTasksQuery, EditUserFormUserTasksQueryVariables>;
export const EditUserFormProjectsDocument = gql`
    query EditUserForm_Projects($projectFilters: ProjectFilters, $listInputs: ListInput) {
  projectsConnections(projectFilters: $projectFilters, listInputs: $listInputs) {
    projects {
      id
      ...ProjectReassignProject
    }
  }
}
    ${ProjectReassignProjectFragmentDoc}`;

/**
 * __useEditUserFormProjectsQuery__
 *
 * To run a query within a React component, call `useEditUserFormProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditUserFormProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditUserFormProjectsQuery({
 *   variables: {
 *      projectFilters: // value for 'projectFilters'
 *      listInputs: // value for 'listInputs'
 *   },
 * });
 */
export function useEditUserFormProjectsQuery(baseOptions?: Apollo.QueryHookOptions<EditUserFormProjectsQuery, EditUserFormProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditUserFormProjectsQuery, EditUserFormProjectsQueryVariables>(EditUserFormProjectsDocument, options);
      }
export function useEditUserFormProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditUserFormProjectsQuery, EditUserFormProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditUserFormProjectsQuery, EditUserFormProjectsQueryVariables>(EditUserFormProjectsDocument, options);
        }
export type EditUserFormProjectsQueryHookResult = ReturnType<typeof useEditUserFormProjectsQuery>;
export type EditUserFormProjectsLazyQueryHookResult = ReturnType<typeof useEditUserFormProjectsLazyQuery>;
export type EditUserFormProjectsQueryResult = Apollo.QueryResult<EditUserFormProjectsQuery, EditUserFormProjectsQueryVariables>;
export const EditUserFormUpdateUserDocument = gql`
    mutation EditUserForm_UpdateUser($user: updateUserInput!) {
  updateUser(input: $user) {
    user {
      id
      ...EditUserForm_User
      organization {
        id
        adminUsersCount
        pmUsersCount
        guideUsersCount
        contributorUsersCount
        taskOwnerUsersCount
        managerUsersCount
      }
    }
  }
}
    ${EditUserFormUserFragmentDoc}`;
export type EditUserFormUpdateUserMutationFn = Apollo.MutationFunction<EditUserFormUpdateUserMutation, EditUserFormUpdateUserMutationVariables>;

/**
 * __useEditUserFormUpdateUserMutation__
 *
 * To run a mutation, you first call `useEditUserFormUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditUserFormUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editUserFormUpdateUserMutation, { data, loading, error }] = useEditUserFormUpdateUserMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useEditUserFormUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<EditUserFormUpdateUserMutation, EditUserFormUpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditUserFormUpdateUserMutation, EditUserFormUpdateUserMutationVariables>(EditUserFormUpdateUserDocument, options);
      }
export type EditUserFormUpdateUserMutationHookResult = ReturnType<typeof useEditUserFormUpdateUserMutation>;
export type EditUserFormUpdateUserMutationResult = Apollo.MutationResult<EditUserFormUpdateUserMutation>;
export type EditUserFormUpdateUserMutationOptions = Apollo.BaseMutationOptions<EditUserFormUpdateUserMutation, EditUserFormUpdateUserMutationVariables>;
export const EditUserFormResendInvitationDocument = gql`
    mutation EditUserForm_ResendInvitation($email: String!) {
  resendInviteToUser(input: {email: $email}) {
    success
  }
}
    `;
export type EditUserFormResendInvitationMutationFn = Apollo.MutationFunction<EditUserFormResendInvitationMutation, EditUserFormResendInvitationMutationVariables>;

/**
 * __useEditUserFormResendInvitationMutation__
 *
 * To run a mutation, you first call `useEditUserFormResendInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditUserFormResendInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editUserFormResendInvitationMutation, { data, loading, error }] = useEditUserFormResendInvitationMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useEditUserFormResendInvitationMutation(baseOptions?: Apollo.MutationHookOptions<EditUserFormResendInvitationMutation, EditUserFormResendInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditUserFormResendInvitationMutation, EditUserFormResendInvitationMutationVariables>(EditUserFormResendInvitationDocument, options);
      }
export type EditUserFormResendInvitationMutationHookResult = ReturnType<typeof useEditUserFormResendInvitationMutation>;
export type EditUserFormResendInvitationMutationResult = Apollo.MutationResult<EditUserFormResendInvitationMutation>;
export type EditUserFormResendInvitationMutationOptions = Apollo.BaseMutationOptions<EditUserFormResendInvitationMutation, EditUserFormResendInvitationMutationVariables>;
export const NotificationsFormUserQueryDocument = gql`
    query NotificationsForm_UserQuery($userId: ID!) {
  user(id: $userId) {
    id
    ...NotificationsForm_User
  }
}
    ${NotificationsFormUserFragmentDoc}`;

/**
 * __useNotificationsFormUserQuery__
 *
 * To run a query within a React component, call `useNotificationsFormUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsFormUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsFormUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useNotificationsFormUserQuery(baseOptions: Apollo.QueryHookOptions<NotificationsFormUserQuery, NotificationsFormUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsFormUserQuery, NotificationsFormUserQueryVariables>(NotificationsFormUserQueryDocument, options);
      }
export function useNotificationsFormUserQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsFormUserQuery, NotificationsFormUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsFormUserQuery, NotificationsFormUserQueryVariables>(NotificationsFormUserQueryDocument, options);
        }
export type NotificationsFormUserQueryHookResult = ReturnType<typeof useNotificationsFormUserQuery>;
export type NotificationsFormUserQueryLazyQueryHookResult = ReturnType<typeof useNotificationsFormUserQueryLazyQuery>;
export type NotificationsFormUserQueryQueryResult = Apollo.QueryResult<NotificationsFormUserQuery, NotificationsFormUserQueryVariables>;
export const NotificationsFormUpdateUserDocument = gql`
    mutation NotificationsForm_UpdateUser($user: updateUserInput!) {
  updateUser(input: $user) {
    user {
      id
      ...NotificationsForm_User
    }
  }
}
    ${NotificationsFormUserFragmentDoc}`;
export type NotificationsFormUpdateUserMutationFn = Apollo.MutationFunction<NotificationsFormUpdateUserMutation, NotificationsFormUpdateUserMutationVariables>;

/**
 * __useNotificationsFormUpdateUserMutation__
 *
 * To run a mutation, you first call `useNotificationsFormUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotificationsFormUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notificationsFormUpdateUserMutation, { data, loading, error }] = useNotificationsFormUpdateUserMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useNotificationsFormUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<NotificationsFormUpdateUserMutation, NotificationsFormUpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotificationsFormUpdateUserMutation, NotificationsFormUpdateUserMutationVariables>(NotificationsFormUpdateUserDocument, options);
      }
export type NotificationsFormUpdateUserMutationHookResult = ReturnType<typeof useNotificationsFormUpdateUserMutation>;
export type NotificationsFormUpdateUserMutationResult = Apollo.MutationResult<NotificationsFormUpdateUserMutation>;
export type NotificationsFormUpdateUserMutationOptions = Apollo.BaseMutationOptions<NotificationsFormUpdateUserMutation, NotificationsFormUpdateUserMutationVariables>;
export const SetupAccountFormSendSetupEmailDocument = gql`
    mutation SetupAccountForm_SendSetupEmail($email: String!) {
  sendSetupEmail(input: {email: $email}) {
    success
  }
}
    `;
export type SetupAccountFormSendSetupEmailMutationFn = Apollo.MutationFunction<SetupAccountFormSendSetupEmailMutation, SetupAccountFormSendSetupEmailMutationVariables>;

/**
 * __useSetupAccountFormSendSetupEmailMutation__
 *
 * To run a mutation, you first call `useSetupAccountFormSendSetupEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupAccountFormSendSetupEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupAccountFormSendSetupEmailMutation, { data, loading, error }] = useSetupAccountFormSendSetupEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSetupAccountFormSendSetupEmailMutation(baseOptions?: Apollo.MutationHookOptions<SetupAccountFormSendSetupEmailMutation, SetupAccountFormSendSetupEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetupAccountFormSendSetupEmailMutation, SetupAccountFormSendSetupEmailMutationVariables>(SetupAccountFormSendSetupEmailDocument, options);
      }
export type SetupAccountFormSendSetupEmailMutationHookResult = ReturnType<typeof useSetupAccountFormSendSetupEmailMutation>;
export type SetupAccountFormSendSetupEmailMutationResult = Apollo.MutationResult<SetupAccountFormSendSetupEmailMutation>;
export type SetupAccountFormSendSetupEmailMutationOptions = Apollo.BaseMutationOptions<SetupAccountFormSendSetupEmailMutation, SetupAccountFormSendSetupEmailMutationVariables>;
export const FileTableRowUpdateFileDocument = gql`
    mutation FileTableRow_UpdateFile($updateFileInput: UpdateFileInput!) {
  updateFile(input: $updateFileInput) {
    file {
      id
      deletable
      ...ProjectFiles_File
    }
  }
}
    ${ProjectFilesFileFragmentDoc}`;
export type FileTableRowUpdateFileMutationFn = Apollo.MutationFunction<FileTableRowUpdateFileMutation, FileTableRowUpdateFileMutationVariables>;

/**
 * __useFileTableRowUpdateFileMutation__
 *
 * To run a mutation, you first call `useFileTableRowUpdateFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFileTableRowUpdateFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fileTableRowUpdateFileMutation, { data, loading, error }] = useFileTableRowUpdateFileMutation({
 *   variables: {
 *      updateFileInput: // value for 'updateFileInput'
 *   },
 * });
 */
export function useFileTableRowUpdateFileMutation(baseOptions?: Apollo.MutationHookOptions<FileTableRowUpdateFileMutation, FileTableRowUpdateFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FileTableRowUpdateFileMutation, FileTableRowUpdateFileMutationVariables>(FileTableRowUpdateFileDocument, options);
      }
export type FileTableRowUpdateFileMutationHookResult = ReturnType<typeof useFileTableRowUpdateFileMutation>;
export type FileTableRowUpdateFileMutationResult = Apollo.MutationResult<FileTableRowUpdateFileMutation>;
export type FileTableRowUpdateFileMutationOptions = Apollo.BaseMutationOptions<FileTableRowUpdateFileMutation, FileTableRowUpdateFileMutationVariables>;
export const MyTasksTasksDocument = gql`
    query MyTasks_Tasks($projectId: ID!, $listInputs: ListInput) {
  userProjectTasks(projectId: $projectId, listInputs: $listInputs) {
    id
    ...ProjectTaskCard_Task
  }
}
    ${ProjectTaskCardTaskFragmentDoc}`;

/**
 * __useMyTasksTasksQuery__
 *
 * To run a query within a React component, call `useMyTasksTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTasksTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTasksTasksQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      listInputs: // value for 'listInputs'
 *   },
 * });
 */
export function useMyTasksTasksQuery(baseOptions: Apollo.QueryHookOptions<MyTasksTasksQuery, MyTasksTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyTasksTasksQuery, MyTasksTasksQueryVariables>(MyTasksTasksDocument, options);
      }
export function useMyTasksTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTasksTasksQuery, MyTasksTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyTasksTasksQuery, MyTasksTasksQueryVariables>(MyTasksTasksDocument, options);
        }
export type MyTasksTasksQueryHookResult = ReturnType<typeof useMyTasksTasksQuery>;
export type MyTasksTasksLazyQueryHookResult = ReturnType<typeof useMyTasksTasksLazyQuery>;
export type MyTasksTasksQueryResult = Apollo.QueryResult<MyTasksTasksQuery, MyTasksTasksQueryVariables>;
export const MyTasksProjectDocument = gql`
    query MyTasks_Project($projectId: ID!) {
  project(id: $projectId) {
    id
    organization {
      id
    }
    ...TaskStatusDropdown_Project
  }
  projectTeam(projectId: $projectId) {
    id
    ...Notes_ProjectTeam
  }
}
    ${TaskStatusDropdownProjectFragmentDoc}
${NotesProjectTeamFragmentDoc}`;

/**
 * __useMyTasksProjectQuery__
 *
 * To run a query within a React component, call `useMyTasksProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTasksProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTasksProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useMyTasksProjectQuery(baseOptions: Apollo.QueryHookOptions<MyTasksProjectQuery, MyTasksProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyTasksProjectQuery, MyTasksProjectQueryVariables>(MyTasksProjectDocument, options);
      }
export function useMyTasksProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTasksProjectQuery, MyTasksProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyTasksProjectQuery, MyTasksProjectQueryVariables>(MyTasksProjectDocument, options);
        }
export type MyTasksProjectQueryHookResult = ReturnType<typeof useMyTasksProjectQuery>;
export type MyTasksProjectLazyQueryHookResult = ReturnType<typeof useMyTasksProjectLazyQuery>;
export type MyTasksProjectQueryResult = Apollo.QueryResult<MyTasksProjectQuery, MyTasksProjectQueryVariables>;
export const MyTasksEditTaskDrawerUpdateTaskGroupTaskMutationDocument = gql`
    mutation MyTasksEditTaskDrawer_UpdateTaskGroupTaskMutation($task: updateTaskInput!) {
  updateTaskGroupTask(input: $task) {
    taskReturnData {
      task {
        id
        taskType
        name
        description
        startOn
        dueOn
        estimatedHours
        actualHours
        billableHours
        nonBillableHours
        estimatedPoints
        duration
        sortOrder
        priority
        responsibility
        signOffRequired
        status
        shouldWarnUpdateStatus
        currentUserTaskContext
        eventDatetime
        participantCallToAction
        invitationGroupSentAt
        ...TaskFormContext_Task
        dependency {
          ... on MilestoneType {
            id
            completed
            tasks {
              id
              shouldWarnUpdateStatus
            }
          }
          ... on TaskType {
            id
            completed
            shouldWarnUpdateStatus
          }
          ... on TemplateType {
            id
            completed
          }
          ... on TaskGroupType {
            id
            completed
            tasks {
              id
              shouldWarnUpdateStatus
            }
          }
        }
        assignee {
          id
          firstName
          lastName
          jobRole
          avatar {
            originalUrl
          }
        }
        signer {
          id
          firstName
          lastName
          email
        }
        notes {
          id
        }
        jiraTask {
          id
          externalId
          externalProjectId
          externalTypeId
          components
        }
        files {
          id
          ...Attachments_File
        }
        subtasks {
          ...SubtaskFragment
        }
        taskParticipants {
          id
          completed
          invitationSentAt
          user {
            id
          }
        }
        template {
          id
          duration
        }
        project {
          id
          ...MyTasksEditTaskDrawer_ProjectSnapshotFragment
          stats {
            ...MyTasksEditTaskDrawer_ProjectStatsFragment
          }
          profitabilitySummary {
            forecastedCost
            budgetedCost
          }
        }
      }
    }
  }
}
    ${TaskFormContextTaskFragmentDoc}
${AttachmentsFileFragmentDoc}
${SubtaskFragmentDoc}
${MyTasksEditTaskDrawerProjectSnapshotFragmentDoc}
${MyTasksEditTaskDrawerProjectStatsFragmentDoc}`;
export type MyTasksEditTaskDrawerUpdateTaskGroupTaskMutationMutationFn = Apollo.MutationFunction<MyTasksEditTaskDrawerUpdateTaskGroupTaskMutation, MyTasksEditTaskDrawerUpdateTaskGroupTaskMutationVariables>;

/**
 * __useMyTasksEditTaskDrawerUpdateTaskGroupTaskMutation__
 *
 * To run a mutation, you first call `useMyTasksEditTaskDrawerUpdateTaskGroupTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMyTasksEditTaskDrawerUpdateTaskGroupTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [myTasksEditTaskDrawerUpdateTaskGroupTaskMutation, { data, loading, error }] = useMyTasksEditTaskDrawerUpdateTaskGroupTaskMutation({
 *   variables: {
 *      task: // value for 'task'
 *   },
 * });
 */
export function useMyTasksEditTaskDrawerUpdateTaskGroupTaskMutation(baseOptions?: Apollo.MutationHookOptions<MyTasksEditTaskDrawerUpdateTaskGroupTaskMutation, MyTasksEditTaskDrawerUpdateTaskGroupTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MyTasksEditTaskDrawerUpdateTaskGroupTaskMutation, MyTasksEditTaskDrawerUpdateTaskGroupTaskMutationVariables>(MyTasksEditTaskDrawerUpdateTaskGroupTaskMutationDocument, options);
      }
export type MyTasksEditTaskDrawerUpdateTaskGroupTaskMutationHookResult = ReturnType<typeof useMyTasksEditTaskDrawerUpdateTaskGroupTaskMutation>;
export type MyTasksEditTaskDrawerUpdateTaskGroupTaskMutationMutationResult = Apollo.MutationResult<MyTasksEditTaskDrawerUpdateTaskGroupTaskMutation>;
export type MyTasksEditTaskDrawerUpdateTaskGroupTaskMutationMutationOptions = Apollo.BaseMutationOptions<MyTasksEditTaskDrawerUpdateTaskGroupTaskMutation, MyTasksEditTaskDrawerUpdateTaskGroupTaskMutationVariables>;
export const MyTasksEditTaskDrawerGetAvailableTaskTagsDocument = gql`
    query MyTasksEditTaskDrawer_GetAvailableTaskTags($taggableId: ID!, $taggableType: TaggableEnumType!) {
  availableTags(taggableId: $taggableId, taggableType: $taggableType) {
    ...Tags_AvailableTags
  }
}
    ${TagsAvailableTagsFragmentDoc}`;

/**
 * __useMyTasksEditTaskDrawerGetAvailableTaskTagsQuery__
 *
 * To run a query within a React component, call `useMyTasksEditTaskDrawerGetAvailableTaskTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTasksEditTaskDrawerGetAvailableTaskTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTasksEditTaskDrawerGetAvailableTaskTagsQuery({
 *   variables: {
 *      taggableId: // value for 'taggableId'
 *      taggableType: // value for 'taggableType'
 *   },
 * });
 */
export function useMyTasksEditTaskDrawerGetAvailableTaskTagsQuery(baseOptions: Apollo.QueryHookOptions<MyTasksEditTaskDrawerGetAvailableTaskTagsQuery, MyTasksEditTaskDrawerGetAvailableTaskTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyTasksEditTaskDrawerGetAvailableTaskTagsQuery, MyTasksEditTaskDrawerGetAvailableTaskTagsQueryVariables>(MyTasksEditTaskDrawerGetAvailableTaskTagsDocument, options);
      }
export function useMyTasksEditTaskDrawerGetAvailableTaskTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTasksEditTaskDrawerGetAvailableTaskTagsQuery, MyTasksEditTaskDrawerGetAvailableTaskTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyTasksEditTaskDrawerGetAvailableTaskTagsQuery, MyTasksEditTaskDrawerGetAvailableTaskTagsQueryVariables>(MyTasksEditTaskDrawerGetAvailableTaskTagsDocument, options);
        }
export type MyTasksEditTaskDrawerGetAvailableTaskTagsQueryHookResult = ReturnType<typeof useMyTasksEditTaskDrawerGetAvailableTaskTagsQuery>;
export type MyTasksEditTaskDrawerGetAvailableTaskTagsLazyQueryHookResult = ReturnType<typeof useMyTasksEditTaskDrawerGetAvailableTaskTagsLazyQuery>;
export type MyTasksEditTaskDrawerGetAvailableTaskTagsQueryResult = Apollo.QueryResult<MyTasksEditTaskDrawerGetAvailableTaskTagsQuery, MyTasksEditTaskDrawerGetAvailableTaskTagsQueryVariables>;
export const MyTasksEditTaskDrawerProjectTeamDocument = gql`
    query MyTasksEditTaskDrawer_ProjectTeam($projectId: ID!) {
  projectTeam(projectId: $projectId) {
    id
    ...Notes_ProjectTeam
  }
}
    ${NotesProjectTeamFragmentDoc}`;

/**
 * __useMyTasksEditTaskDrawerProjectTeamQuery__
 *
 * To run a query within a React component, call `useMyTasksEditTaskDrawerProjectTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTasksEditTaskDrawerProjectTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTasksEditTaskDrawerProjectTeamQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useMyTasksEditTaskDrawerProjectTeamQuery(baseOptions: Apollo.QueryHookOptions<MyTasksEditTaskDrawerProjectTeamQuery, MyTasksEditTaskDrawerProjectTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyTasksEditTaskDrawerProjectTeamQuery, MyTasksEditTaskDrawerProjectTeamQueryVariables>(MyTasksEditTaskDrawerProjectTeamDocument, options);
      }
export function useMyTasksEditTaskDrawerProjectTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTasksEditTaskDrawerProjectTeamQuery, MyTasksEditTaskDrawerProjectTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyTasksEditTaskDrawerProjectTeamQuery, MyTasksEditTaskDrawerProjectTeamQueryVariables>(MyTasksEditTaskDrawerProjectTeamDocument, options);
        }
export type MyTasksEditTaskDrawerProjectTeamQueryHookResult = ReturnType<typeof useMyTasksEditTaskDrawerProjectTeamQuery>;
export type MyTasksEditTaskDrawerProjectTeamLazyQueryHookResult = ReturnType<typeof useMyTasksEditTaskDrawerProjectTeamLazyQuery>;
export type MyTasksEditTaskDrawerProjectTeamQueryResult = Apollo.QueryResult<MyTasksEditTaskDrawerProjectTeamQuery, MyTasksEditTaskDrawerProjectTeamQueryVariables>;
export const MyTasksEditTaskDrawerCurrentUserSkillsDocument = gql`
    query MyTasksEditTaskDrawer_CurrentUserSkills {
  currentUser {
    skills {
      id
    }
  }
}
    `;

/**
 * __useMyTasksEditTaskDrawerCurrentUserSkillsQuery__
 *
 * To run a query within a React component, call `useMyTasksEditTaskDrawerCurrentUserSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTasksEditTaskDrawerCurrentUserSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTasksEditTaskDrawerCurrentUserSkillsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyTasksEditTaskDrawerCurrentUserSkillsQuery(baseOptions?: Apollo.QueryHookOptions<MyTasksEditTaskDrawerCurrentUserSkillsQuery, MyTasksEditTaskDrawerCurrentUserSkillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyTasksEditTaskDrawerCurrentUserSkillsQuery, MyTasksEditTaskDrawerCurrentUserSkillsQueryVariables>(MyTasksEditTaskDrawerCurrentUserSkillsDocument, options);
      }
export function useMyTasksEditTaskDrawerCurrentUserSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTasksEditTaskDrawerCurrentUserSkillsQuery, MyTasksEditTaskDrawerCurrentUserSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyTasksEditTaskDrawerCurrentUserSkillsQuery, MyTasksEditTaskDrawerCurrentUserSkillsQueryVariables>(MyTasksEditTaskDrawerCurrentUserSkillsDocument, options);
        }
export type MyTasksEditTaskDrawerCurrentUserSkillsQueryHookResult = ReturnType<typeof useMyTasksEditTaskDrawerCurrentUserSkillsQuery>;
export type MyTasksEditTaskDrawerCurrentUserSkillsLazyQueryHookResult = ReturnType<typeof useMyTasksEditTaskDrawerCurrentUserSkillsLazyQuery>;
export type MyTasksEditTaskDrawerCurrentUserSkillsQueryResult = Apollo.QueryResult<MyTasksEditTaskDrawerCurrentUserSkillsQuery, MyTasksEditTaskDrawerCurrentUserSkillsQueryVariables>;
export const MyTasksEditTaskDrawerRemoveWatcherDocument = gql`
    mutation MyTasksEditTaskDrawer_RemoveWatcher($taskId: ID!, $watcherId: ID!) {
  removeWatcher(input: {taskId: $taskId, watcherId: $watcherId}) {
    success
  }
}
    `;
export type MyTasksEditTaskDrawerRemoveWatcherMutationFn = Apollo.MutationFunction<MyTasksEditTaskDrawerRemoveWatcherMutation, MyTasksEditTaskDrawerRemoveWatcherMutationVariables>;

/**
 * __useMyTasksEditTaskDrawerRemoveWatcherMutation__
 *
 * To run a mutation, you first call `useMyTasksEditTaskDrawerRemoveWatcherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMyTasksEditTaskDrawerRemoveWatcherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [myTasksEditTaskDrawerRemoveWatcherMutation, { data, loading, error }] = useMyTasksEditTaskDrawerRemoveWatcherMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      watcherId: // value for 'watcherId'
 *   },
 * });
 */
export function useMyTasksEditTaskDrawerRemoveWatcherMutation(baseOptions?: Apollo.MutationHookOptions<MyTasksEditTaskDrawerRemoveWatcherMutation, MyTasksEditTaskDrawerRemoveWatcherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MyTasksEditTaskDrawerRemoveWatcherMutation, MyTasksEditTaskDrawerRemoveWatcherMutationVariables>(MyTasksEditTaskDrawerRemoveWatcherDocument, options);
      }
export type MyTasksEditTaskDrawerRemoveWatcherMutationHookResult = ReturnType<typeof useMyTasksEditTaskDrawerRemoveWatcherMutation>;
export type MyTasksEditTaskDrawerRemoveWatcherMutationResult = Apollo.MutationResult<MyTasksEditTaskDrawerRemoveWatcherMutation>;
export type MyTasksEditTaskDrawerRemoveWatcherMutationOptions = Apollo.BaseMutationOptions<MyTasksEditTaskDrawerRemoveWatcherMutation, MyTasksEditTaskDrawerRemoveWatcherMutationVariables>;
export const TeamCardProjectTeamDocument = gql`
    query TeamCard_ProjectTeam($projectId: ID!) {
  projectTeam(projectId: $projectId) {
    id
    firstName
    lastName
    email
    jobRole
    avatar {
      originalUrl
    }
    projectContext
  }
}
    `;

/**
 * __useTeamCardProjectTeamQuery__
 *
 * To run a query within a React component, call `useTeamCardProjectTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamCardProjectTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamCardProjectTeamQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useTeamCardProjectTeamQuery(baseOptions: Apollo.QueryHookOptions<TeamCardProjectTeamQuery, TeamCardProjectTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamCardProjectTeamQuery, TeamCardProjectTeamQueryVariables>(TeamCardProjectTeamDocument, options);
      }
export function useTeamCardProjectTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamCardProjectTeamQuery, TeamCardProjectTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamCardProjectTeamQuery, TeamCardProjectTeamQueryVariables>(TeamCardProjectTeamDocument, options);
        }
export type TeamCardProjectTeamQueryHookResult = ReturnType<typeof useTeamCardProjectTeamQuery>;
export type TeamCardProjectTeamLazyQueryHookResult = ReturnType<typeof useTeamCardProjectTeamLazyQuery>;
export type TeamCardProjectTeamQueryResult = Apollo.QueryResult<TeamCardProjectTeamQuery, TeamCardProjectTeamQueryVariables>;
export const ProjectPlanTemplateUpdatedV2Document = gql`
    subscription ProjectPlan_TemplateUpdatedV2($templateId: ID!) {
  templateUpdated(templateId: $templateId) {
    template {
      id
      summaryBank {
        ...TemplateOverview_TemplateStats
        ...ProjectTemplateHoverInfo_SummaryBank
      }
      milestones {
        id
        ...ProjectMilestoneBoard_Milestone
      }
    }
  }
}
    ${TemplateOverviewTemplateStatsFragmentDoc}
${ProjectTemplateHoverInfoSummaryBankFragmentDoc}
${ProjectMilestoneBoardMilestoneFragmentDoc}`;

/**
 * __useProjectPlanTemplateUpdatedV2Subscription__
 *
 * To run a query within a React component, call `useProjectPlanTemplateUpdatedV2Subscription` and pass it any options that fit your needs.
 * When your component renders, `useProjectPlanTemplateUpdatedV2Subscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectPlanTemplateUpdatedV2Subscription({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useProjectPlanTemplateUpdatedV2Subscription(baseOptions: Apollo.SubscriptionHookOptions<ProjectPlanTemplateUpdatedV2Subscription, ProjectPlanTemplateUpdatedV2SubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ProjectPlanTemplateUpdatedV2Subscription, ProjectPlanTemplateUpdatedV2SubscriptionVariables>(ProjectPlanTemplateUpdatedV2Document, options);
      }
export type ProjectPlanTemplateUpdatedV2SubscriptionHookResult = ReturnType<typeof useProjectPlanTemplateUpdatedV2Subscription>;
export type ProjectPlanTemplateUpdatedV2SubscriptionResult = Apollo.SubscriptionResult<ProjectPlanTemplateUpdatedV2Subscription>;
export const ProjectPlanCreateTaskV2Document = gql`
    mutation ProjectPlan_CreateTaskV2($taskInputs: createTaskInput!) {
  createTask(input: $taskInputs) {
    taskReturnData {
      task {
        id
        milestone {
          startedOn
          forecastedEndOn
          completedAt
          completed
          summaryBank {
            id
            totalTasks
            totalCompleteTasks
            totalRemainingTasks
            duration
          }
        }
        taskGroup {
          startedOn
          forecastedEndOn
          completedAt
          completed
          summaryBank {
            id
            totalTasks
            totalCompleteTasks
            totalRemainingTasks
            duration
          }
        }
        template {
          id
          summaryBank {
            id
            ...TemplateOverview_TemplateStats
            ...ProjectTemplateHoverInfo_SummaryBank
          }
        }
        project {
          id
          ...ProjectPlan_ProjectSnapshotFragment
          stats {
            ...ProjectPlan_ProjectStatsFragment
          }
          profitabilitySummary {
            forecastedCost
            budgetedCost
          }
        }
        ...ProjectMilestoneBoard_Task
        ...ProjectBulkEditDrawer_Task
      }
    }
  }
}
    ${TemplateOverviewTemplateStatsFragmentDoc}
${ProjectTemplateHoverInfoSummaryBankFragmentDoc}
${ProjectPlanProjectSnapshotFragmentDoc}
${ProjectPlanProjectStatsFragmentDoc}
${ProjectMilestoneBoardTaskFragmentDoc}
${ProjectBulkEditDrawerTaskFragmentDoc}`;
export type ProjectPlanCreateTaskV2MutationFn = Apollo.MutationFunction<ProjectPlanCreateTaskV2Mutation, ProjectPlanCreateTaskV2MutationVariables>;

/**
 * __useProjectPlanCreateTaskV2Mutation__
 *
 * To run a mutation, you first call `useProjectPlanCreateTaskV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectPlanCreateTaskV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectPlanCreateTaskV2Mutation, { data, loading, error }] = useProjectPlanCreateTaskV2Mutation({
 *   variables: {
 *      taskInputs: // value for 'taskInputs'
 *   },
 * });
 */
export function useProjectPlanCreateTaskV2Mutation(baseOptions?: Apollo.MutationHookOptions<ProjectPlanCreateTaskV2Mutation, ProjectPlanCreateTaskV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectPlanCreateTaskV2Mutation, ProjectPlanCreateTaskV2MutationVariables>(ProjectPlanCreateTaskV2Document, options);
      }
export type ProjectPlanCreateTaskV2MutationHookResult = ReturnType<typeof useProjectPlanCreateTaskV2Mutation>;
export type ProjectPlanCreateTaskV2MutationResult = Apollo.MutationResult<ProjectPlanCreateTaskV2Mutation>;
export type ProjectPlanCreateTaskV2MutationOptions = Apollo.BaseMutationOptions<ProjectPlanCreateTaskV2Mutation, ProjectPlanCreateTaskV2MutationVariables>;
export const ProjectPlanReadNotificationErrorDocument = gql`
    mutation ProjectPlan_ReadNotificationError($id: ID!) {
  readNotificationError(id: $id) {
    success
  }
}
    `;
export type ProjectPlanReadNotificationErrorMutationFn = Apollo.MutationFunction<ProjectPlanReadNotificationErrorMutation, ProjectPlanReadNotificationErrorMutationVariables>;

/**
 * __useProjectPlanReadNotificationErrorMutation__
 *
 * To run a mutation, you first call `useProjectPlanReadNotificationErrorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectPlanReadNotificationErrorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectPlanReadNotificationErrorMutation, { data, loading, error }] = useProjectPlanReadNotificationErrorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectPlanReadNotificationErrorMutation(baseOptions?: Apollo.MutationHookOptions<ProjectPlanReadNotificationErrorMutation, ProjectPlanReadNotificationErrorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectPlanReadNotificationErrorMutation, ProjectPlanReadNotificationErrorMutationVariables>(ProjectPlanReadNotificationErrorDocument, options);
      }
export type ProjectPlanReadNotificationErrorMutationHookResult = ReturnType<typeof useProjectPlanReadNotificationErrorMutation>;
export type ProjectPlanReadNotificationErrorMutationResult = Apollo.MutationResult<ProjectPlanReadNotificationErrorMutation>;
export type ProjectPlanReadNotificationErrorMutationOptions = Apollo.BaseMutationOptions<ProjectPlanReadNotificationErrorMutation, ProjectPlanReadNotificationErrorMutationVariables>;
export const ProjectPlanMarkAllErrorsReadDocument = gql`
    mutation ProjectPlan_MarkAllErrorsRead($id: ID!) {
  markAllErrorsRead(id: $id) {
    success
  }
}
    `;
export type ProjectPlanMarkAllErrorsReadMutationFn = Apollo.MutationFunction<ProjectPlanMarkAllErrorsReadMutation, ProjectPlanMarkAllErrorsReadMutationVariables>;

/**
 * __useProjectPlanMarkAllErrorsReadMutation__
 *
 * To run a mutation, you first call `useProjectPlanMarkAllErrorsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectPlanMarkAllErrorsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectPlanMarkAllErrorsReadMutation, { data, loading, error }] = useProjectPlanMarkAllErrorsReadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectPlanMarkAllErrorsReadMutation(baseOptions?: Apollo.MutationHookOptions<ProjectPlanMarkAllErrorsReadMutation, ProjectPlanMarkAllErrorsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectPlanMarkAllErrorsReadMutation, ProjectPlanMarkAllErrorsReadMutationVariables>(ProjectPlanMarkAllErrorsReadDocument, options);
      }
export type ProjectPlanMarkAllErrorsReadMutationHookResult = ReturnType<typeof useProjectPlanMarkAllErrorsReadMutation>;
export type ProjectPlanMarkAllErrorsReadMutationResult = Apollo.MutationResult<ProjectPlanMarkAllErrorsReadMutation>;
export type ProjectPlanMarkAllErrorsReadMutationOptions = Apollo.BaseMutationOptions<ProjectPlanMarkAllErrorsReadMutation, ProjectPlanMarkAllErrorsReadMutationVariables>;
export const ProjectPlanProjectErrorsDocument = gql`
    query ProjectPlan_ProjectErrors($projectId: ID!) {
  notificationErrors(projectId: $projectId) {
    notifications {
      id
      text
    }
    totalErrors
  }
}
    `;

/**
 * __useProjectPlanProjectErrorsQuery__
 *
 * To run a query within a React component, call `useProjectPlanProjectErrorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectPlanProjectErrorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectPlanProjectErrorsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectPlanProjectErrorsQuery(baseOptions: Apollo.QueryHookOptions<ProjectPlanProjectErrorsQuery, ProjectPlanProjectErrorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectPlanProjectErrorsQuery, ProjectPlanProjectErrorsQueryVariables>(ProjectPlanProjectErrorsDocument, options);
      }
export function useProjectPlanProjectErrorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectPlanProjectErrorsQuery, ProjectPlanProjectErrorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectPlanProjectErrorsQuery, ProjectPlanProjectErrorsQueryVariables>(ProjectPlanProjectErrorsDocument, options);
        }
export type ProjectPlanProjectErrorsQueryHookResult = ReturnType<typeof useProjectPlanProjectErrorsQuery>;
export type ProjectPlanProjectErrorsLazyQueryHookResult = ReturnType<typeof useProjectPlanProjectErrorsLazyQuery>;
export type ProjectPlanProjectErrorsQueryResult = Apollo.QueryResult<ProjectPlanProjectErrorsQuery, ProjectPlanProjectErrorsQueryVariables>;
export const ProjectBulkEditFormTaskGroupDependenciesConflictV2Document = gql`
    query ProjectBulkEditForm_TaskGroupDependenciesConflictV2($taskGroupId: ID!, $taskIds: [ID!]!) {
  taskGroupDependenciesConflict(taskGroupId: $taskGroupId, taskIds: $taskIds)
}
    `;

/**
 * __useProjectBulkEditFormTaskGroupDependenciesConflictV2Query__
 *
 * To run a query within a React component, call `useProjectBulkEditFormTaskGroupDependenciesConflictV2Query` and pass it any options that fit your needs.
 * When your component renders, `useProjectBulkEditFormTaskGroupDependenciesConflictV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectBulkEditFormTaskGroupDependenciesConflictV2Query({
 *   variables: {
 *      taskGroupId: // value for 'taskGroupId'
 *      taskIds: // value for 'taskIds'
 *   },
 * });
 */
export function useProjectBulkEditFormTaskGroupDependenciesConflictV2Query(baseOptions: Apollo.QueryHookOptions<ProjectBulkEditFormTaskGroupDependenciesConflictV2Query, ProjectBulkEditFormTaskGroupDependenciesConflictV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectBulkEditFormTaskGroupDependenciesConflictV2Query, ProjectBulkEditFormTaskGroupDependenciesConflictV2QueryVariables>(ProjectBulkEditFormTaskGroupDependenciesConflictV2Document, options);
      }
export function useProjectBulkEditFormTaskGroupDependenciesConflictV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectBulkEditFormTaskGroupDependenciesConflictV2Query, ProjectBulkEditFormTaskGroupDependenciesConflictV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectBulkEditFormTaskGroupDependenciesConflictV2Query, ProjectBulkEditFormTaskGroupDependenciesConflictV2QueryVariables>(ProjectBulkEditFormTaskGroupDependenciesConflictV2Document, options);
        }
export type ProjectBulkEditFormTaskGroupDependenciesConflictV2QueryHookResult = ReturnType<typeof useProjectBulkEditFormTaskGroupDependenciesConflictV2Query>;
export type ProjectBulkEditFormTaskGroupDependenciesConflictV2LazyQueryHookResult = ReturnType<typeof useProjectBulkEditFormTaskGroupDependenciesConflictV2LazyQuery>;
export type ProjectBulkEditFormTaskGroupDependenciesConflictV2QueryResult = Apollo.QueryResult<ProjectBulkEditFormTaskGroupDependenciesConflictV2Query, ProjectBulkEditFormTaskGroupDependenciesConflictV2QueryVariables>;
export const ProjectBulkEditFormBulkEditTasksDocument = gql`
    mutation ProjectBulkEditForm_BulkEditTasks($input: bulkEditTasksInput!) {
  bulkEditTasks(input: $input) {
    updatedTasks {
      ...ProjectBulkEditForm_Task
      assignee {
        id
      }
      tags {
        id
      }
      watchers {
        id
      }
      skill {
        id
        name
        category {
          id
          name
        }
      }
      skills {
        id
        name
        category {
          id
          name
        }
      }
    }
  }
}
    ${ProjectBulkEditFormTaskFragmentDoc}`;
export type ProjectBulkEditFormBulkEditTasksMutationFn = Apollo.MutationFunction<ProjectBulkEditFormBulkEditTasksMutation, ProjectBulkEditFormBulkEditTasksMutationVariables>;

/**
 * __useProjectBulkEditFormBulkEditTasksMutation__
 *
 * To run a mutation, you first call `useProjectBulkEditFormBulkEditTasksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectBulkEditFormBulkEditTasksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectBulkEditFormBulkEditTasksMutation, { data, loading, error }] = useProjectBulkEditFormBulkEditTasksMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProjectBulkEditFormBulkEditTasksMutation(baseOptions?: Apollo.MutationHookOptions<ProjectBulkEditFormBulkEditTasksMutation, ProjectBulkEditFormBulkEditTasksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectBulkEditFormBulkEditTasksMutation, ProjectBulkEditFormBulkEditTasksMutationVariables>(ProjectBulkEditFormBulkEditTasksDocument, options);
      }
export type ProjectBulkEditFormBulkEditTasksMutationHookResult = ReturnType<typeof useProjectBulkEditFormBulkEditTasksMutation>;
export type ProjectBulkEditFormBulkEditTasksMutationResult = Apollo.MutationResult<ProjectBulkEditFormBulkEditTasksMutation>;
export type ProjectBulkEditFormBulkEditTasksMutationOptions = Apollo.BaseMutationOptions<ProjectBulkEditFormBulkEditTasksMutation, ProjectBulkEditFormBulkEditTasksMutationVariables>;
export const ProjectBulkEditFormAssigneesDocument = gql`
    query ProjectBulkEditForm_Assignees($projectId: ID, $milestoneId: ID!, $organizationId: ID) {
  potentialTaskAssignees(
    projectId: $projectId
    milestoneId: $milestoneId
    organizationId: $organizationId
  ) {
    id
    ...AssigneeField_User
  }
}
    ${AssigneeFieldUserFragmentDoc}`;

/**
 * __useProjectBulkEditFormAssigneesQuery__
 *
 * To run a query within a React component, call `useProjectBulkEditFormAssigneesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectBulkEditFormAssigneesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectBulkEditFormAssigneesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      milestoneId: // value for 'milestoneId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useProjectBulkEditFormAssigneesQuery(baseOptions: Apollo.QueryHookOptions<ProjectBulkEditFormAssigneesQuery, ProjectBulkEditFormAssigneesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectBulkEditFormAssigneesQuery, ProjectBulkEditFormAssigneesQueryVariables>(ProjectBulkEditFormAssigneesDocument, options);
      }
export function useProjectBulkEditFormAssigneesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectBulkEditFormAssigneesQuery, ProjectBulkEditFormAssigneesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectBulkEditFormAssigneesQuery, ProjectBulkEditFormAssigneesQueryVariables>(ProjectBulkEditFormAssigneesDocument, options);
        }
export type ProjectBulkEditFormAssigneesQueryHookResult = ReturnType<typeof useProjectBulkEditFormAssigneesQuery>;
export type ProjectBulkEditFormAssigneesLazyQueryHookResult = ReturnType<typeof useProjectBulkEditFormAssigneesLazyQuery>;
export type ProjectBulkEditFormAssigneesQueryResult = Apollo.QueryResult<ProjectBulkEditFormAssigneesQuery, ProjectBulkEditFormAssigneesQueryVariables>;
export const ProjectBulkEditFormPaginatedAssigneesDocument = gql`
    query ProjectBulkEditForm_PaginatedAssignees($projectId: ID, $milestoneId: ID!, $skillIds: [ID!], $listInput: ListInput, $responsibility: TaskResponsibilityEnumType) {
  paginatedPotentialTaskAssignees(
    projectId: $projectId
    milestoneId: $milestoneId
    skillIds: $skillIds
    listInputs: $listInput
    responsibility: $responsibility
  ) {
    users {
      id
      ...AssigneeField_User
    }
    pageInfo {
      ...PageInfoFragment
      __typename
    }
  }
}
    ${AssigneeFieldUserFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useProjectBulkEditFormPaginatedAssigneesQuery__
 *
 * To run a query within a React component, call `useProjectBulkEditFormPaginatedAssigneesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectBulkEditFormPaginatedAssigneesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectBulkEditFormPaginatedAssigneesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      milestoneId: // value for 'milestoneId'
 *      skillIds: // value for 'skillIds'
 *      listInput: // value for 'listInput'
 *      responsibility: // value for 'responsibility'
 *   },
 * });
 */
export function useProjectBulkEditFormPaginatedAssigneesQuery(baseOptions: Apollo.QueryHookOptions<ProjectBulkEditFormPaginatedAssigneesQuery, ProjectBulkEditFormPaginatedAssigneesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectBulkEditFormPaginatedAssigneesQuery, ProjectBulkEditFormPaginatedAssigneesQueryVariables>(ProjectBulkEditFormPaginatedAssigneesDocument, options);
      }
export function useProjectBulkEditFormPaginatedAssigneesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectBulkEditFormPaginatedAssigneesQuery, ProjectBulkEditFormPaginatedAssigneesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectBulkEditFormPaginatedAssigneesQuery, ProjectBulkEditFormPaginatedAssigneesQueryVariables>(ProjectBulkEditFormPaginatedAssigneesDocument, options);
        }
export type ProjectBulkEditFormPaginatedAssigneesQueryHookResult = ReturnType<typeof useProjectBulkEditFormPaginatedAssigneesQuery>;
export type ProjectBulkEditFormPaginatedAssigneesLazyQueryHookResult = ReturnType<typeof useProjectBulkEditFormPaginatedAssigneesLazyQuery>;
export type ProjectBulkEditFormPaginatedAssigneesQueryResult = Apollo.QueryResult<ProjectBulkEditFormPaginatedAssigneesQuery, ProjectBulkEditFormPaginatedAssigneesQueryVariables>;
export const ProjectBulkEditFormCommonTaskWatchersDocument = gql`
    query ProjectBulkEditForm_CommonTaskWatchers($taskIds: [ID!]!) {
  commonTaskWatchers(taskIds: $taskIds) {
    id
    ...AssigneeMultiSelect_User
  }
}
    ${AssigneeMultiSelectUserFragmentDoc}`;

/**
 * __useProjectBulkEditFormCommonTaskWatchersQuery__
 *
 * To run a query within a React component, call `useProjectBulkEditFormCommonTaskWatchersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectBulkEditFormCommonTaskWatchersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectBulkEditFormCommonTaskWatchersQuery({
 *   variables: {
 *      taskIds: // value for 'taskIds'
 *   },
 * });
 */
export function useProjectBulkEditFormCommonTaskWatchersQuery(baseOptions: Apollo.QueryHookOptions<ProjectBulkEditFormCommonTaskWatchersQuery, ProjectBulkEditFormCommonTaskWatchersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectBulkEditFormCommonTaskWatchersQuery, ProjectBulkEditFormCommonTaskWatchersQueryVariables>(ProjectBulkEditFormCommonTaskWatchersDocument, options);
      }
export function useProjectBulkEditFormCommonTaskWatchersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectBulkEditFormCommonTaskWatchersQuery, ProjectBulkEditFormCommonTaskWatchersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectBulkEditFormCommonTaskWatchersQuery, ProjectBulkEditFormCommonTaskWatchersQueryVariables>(ProjectBulkEditFormCommonTaskWatchersDocument, options);
        }
export type ProjectBulkEditFormCommonTaskWatchersQueryHookResult = ReturnType<typeof useProjectBulkEditFormCommonTaskWatchersQuery>;
export type ProjectBulkEditFormCommonTaskWatchersLazyQueryHookResult = ReturnType<typeof useProjectBulkEditFormCommonTaskWatchersLazyQuery>;
export type ProjectBulkEditFormCommonTaskWatchersQueryResult = Apollo.QueryResult<ProjectBulkEditFormCommonTaskWatchersQuery, ProjectBulkEditFormCommonTaskWatchersQueryVariables>;
export const ProjectBulkEditFormTagsDocument = gql`
    query ProjectBulkEditForm_Tags($taggableId: ID!, $type: String, $taggableType: TaggableEnumType!) {
  availableTags(taggableId: $taggableId, type: $type, taggableType: $taggableType) {
    id
    name
    color
  }
}
    `;

/**
 * __useProjectBulkEditFormTagsQuery__
 *
 * To run a query within a React component, call `useProjectBulkEditFormTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectBulkEditFormTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectBulkEditFormTagsQuery({
 *   variables: {
 *      taggableId: // value for 'taggableId'
 *      type: // value for 'type'
 *      taggableType: // value for 'taggableType'
 *   },
 * });
 */
export function useProjectBulkEditFormTagsQuery(baseOptions: Apollo.QueryHookOptions<ProjectBulkEditFormTagsQuery, ProjectBulkEditFormTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectBulkEditFormTagsQuery, ProjectBulkEditFormTagsQueryVariables>(ProjectBulkEditFormTagsDocument, options);
      }
export function useProjectBulkEditFormTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectBulkEditFormTagsQuery, ProjectBulkEditFormTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectBulkEditFormTagsQuery, ProjectBulkEditFormTagsQueryVariables>(ProjectBulkEditFormTagsDocument, options);
        }
export type ProjectBulkEditFormTagsQueryHookResult = ReturnType<typeof useProjectBulkEditFormTagsQuery>;
export type ProjectBulkEditFormTagsLazyQueryHookResult = ReturnType<typeof useProjectBulkEditFormTagsLazyQuery>;
export type ProjectBulkEditFormTagsQueryResult = Apollo.QueryResult<ProjectBulkEditFormTagsQuery, ProjectBulkEditFormTagsQueryVariables>;
export const BulkEditFormUserDocument = gql`
    query BulkEditForm_User($userId: ID!) {
  user(id: $userId) {
    id
    ...BulkEditForm_User
  }
}
    ${BulkEditFormUserFragmentDoc}`;

/**
 * __useBulkEditFormUserQuery__
 *
 * To run a query within a React component, call `useBulkEditFormUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkEditFormUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkEditFormUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useBulkEditFormUserQuery(baseOptions: Apollo.QueryHookOptions<BulkEditFormUserQuery, BulkEditFormUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BulkEditFormUserQuery, BulkEditFormUserQueryVariables>(BulkEditFormUserDocument, options);
      }
export function useBulkEditFormUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BulkEditFormUserQuery, BulkEditFormUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BulkEditFormUserQuery, BulkEditFormUserQueryVariables>(BulkEditFormUserDocument, options);
        }
export type BulkEditFormUserQueryHookResult = ReturnType<typeof useBulkEditFormUserQuery>;
export type BulkEditFormUserLazyQueryHookResult = ReturnType<typeof useBulkEditFormUserLazyQuery>;
export type BulkEditFormUserQueryResult = Apollo.QueryResult<BulkEditFormUserQuery, BulkEditFormUserQueryVariables>;
export const ProjectMilestoneBoardMilestoneUpdatedDocument = gql`
    subscription ProjectMilestoneBoard_MilestoneUpdated($templateId: ID!) {
  milestoneUpdated(templateId: $templateId) {
    milestone {
      id
      duration
      completed
      startedOn
      ...ProjectMilestoneHeader_Milestone
    }
    milestoneStats {
      id
      totalTasks
      totalCompleteTasks
      totalRemainingTasks
      duration
    }
  }
}
    ${ProjectMilestoneHeaderMilestoneFragmentDoc}`;

/**
 * __useProjectMilestoneBoardMilestoneUpdatedSubscription__
 *
 * To run a query within a React component, call `useProjectMilestoneBoardMilestoneUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useProjectMilestoneBoardMilestoneUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectMilestoneBoardMilestoneUpdatedSubscription({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useProjectMilestoneBoardMilestoneUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<ProjectMilestoneBoardMilestoneUpdatedSubscription, ProjectMilestoneBoardMilestoneUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ProjectMilestoneBoardMilestoneUpdatedSubscription, ProjectMilestoneBoardMilestoneUpdatedSubscriptionVariables>(ProjectMilestoneBoardMilestoneUpdatedDocument, options);
      }
export type ProjectMilestoneBoardMilestoneUpdatedSubscriptionHookResult = ReturnType<typeof useProjectMilestoneBoardMilestoneUpdatedSubscription>;
export type ProjectMilestoneBoardMilestoneUpdatedSubscriptionResult = Apollo.SubscriptionResult<ProjectMilestoneBoardMilestoneUpdatedSubscription>;
export const ProjectUseMilestonesCreateMilestoneDocument = gql`
    mutation ProjectUseMilestones_CreateMilestone($milestoneVars: createTemplateMilestoneInput!) {
  createTemplateMilestone(input: $milestoneVars) {
    milestone {
      id
      ...ProjectMilestoneColumn_Milestone
    }
  }
}
    ${ProjectMilestoneColumnMilestoneFragmentDoc}`;
export type ProjectUseMilestonesCreateMilestoneMutationFn = Apollo.MutationFunction<ProjectUseMilestonesCreateMilestoneMutation, ProjectUseMilestonesCreateMilestoneMutationVariables>;

/**
 * __useProjectUseMilestonesCreateMilestoneMutation__
 *
 * To run a mutation, you first call `useProjectUseMilestonesCreateMilestoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectUseMilestonesCreateMilestoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectUseMilestonesCreateMilestoneMutation, { data, loading, error }] = useProjectUseMilestonesCreateMilestoneMutation({
 *   variables: {
 *      milestoneVars: // value for 'milestoneVars'
 *   },
 * });
 */
export function useProjectUseMilestonesCreateMilestoneMutation(baseOptions?: Apollo.MutationHookOptions<ProjectUseMilestonesCreateMilestoneMutation, ProjectUseMilestonesCreateMilestoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectUseMilestonesCreateMilestoneMutation, ProjectUseMilestonesCreateMilestoneMutationVariables>(ProjectUseMilestonesCreateMilestoneDocument, options);
      }
export type ProjectUseMilestonesCreateMilestoneMutationHookResult = ReturnType<typeof useProjectUseMilestonesCreateMilestoneMutation>;
export type ProjectUseMilestonesCreateMilestoneMutationResult = Apollo.MutationResult<ProjectUseMilestonesCreateMilestoneMutation>;
export type ProjectUseMilestonesCreateMilestoneMutationOptions = Apollo.BaseMutationOptions<ProjectUseMilestonesCreateMilestoneMutation, ProjectUseMilestonesCreateMilestoneMutationVariables>;
export const ProjectEditMilestoneDrawerUpdateMilestoneDocument = gql`
    mutation ProjectEditMilestoneDrawer_UpdateMilestone($milestone: updateTemplateMilestoneInput!) {
  updateTemplateMilestone(input: $milestone) {
    milestone {
      id
      ...MilestoneForm_Milestone
    }
  }
}
    ${MilestoneFormMilestoneFragmentDoc}`;
export type ProjectEditMilestoneDrawerUpdateMilestoneMutationFn = Apollo.MutationFunction<ProjectEditMilestoneDrawerUpdateMilestoneMutation, ProjectEditMilestoneDrawerUpdateMilestoneMutationVariables>;

/**
 * __useProjectEditMilestoneDrawerUpdateMilestoneMutation__
 *
 * To run a mutation, you first call `useProjectEditMilestoneDrawerUpdateMilestoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectEditMilestoneDrawerUpdateMilestoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectEditMilestoneDrawerUpdateMilestoneMutation, { data, loading, error }] = useProjectEditMilestoneDrawerUpdateMilestoneMutation({
 *   variables: {
 *      milestone: // value for 'milestone'
 *   },
 * });
 */
export function useProjectEditMilestoneDrawerUpdateMilestoneMutation(baseOptions?: Apollo.MutationHookOptions<ProjectEditMilestoneDrawerUpdateMilestoneMutation, ProjectEditMilestoneDrawerUpdateMilestoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectEditMilestoneDrawerUpdateMilestoneMutation, ProjectEditMilestoneDrawerUpdateMilestoneMutationVariables>(ProjectEditMilestoneDrawerUpdateMilestoneDocument, options);
      }
export type ProjectEditMilestoneDrawerUpdateMilestoneMutationHookResult = ReturnType<typeof useProjectEditMilestoneDrawerUpdateMilestoneMutation>;
export type ProjectEditMilestoneDrawerUpdateMilestoneMutationResult = Apollo.MutationResult<ProjectEditMilestoneDrawerUpdateMilestoneMutation>;
export type ProjectEditMilestoneDrawerUpdateMilestoneMutationOptions = Apollo.BaseMutationOptions<ProjectEditMilestoneDrawerUpdateMilestoneMutation, ProjectEditMilestoneDrawerUpdateMilestoneMutationVariables>;
export const ProjectPlanEditTaskDrawerUpdateTaskGroupTaskMutationDocument = gql`
    mutation ProjectPlanEditTaskDrawer_UpdateTaskGroupTaskMutation($task: updateTaskInput!) {
  updateTaskGroupTask(input: $task) {
    taskReturnData {
      task {
        id
        taskType
        name
        description
        startOn
        dueOn
        estimatedHours
        actualHours
        billableHours
        nonBillableHours
        estimatedPoints
        duration
        sortOrder
        priority
        responsibility
        signOffRequired
        status
        shouldWarnUpdateStatus
        currentUserTaskContext
        eventDatetime
        participantCallToAction
        invitationGroupSentAt
        ...TaskFormContext_Task
        dependency {
          ... on MilestoneType {
            id
            completed
            tasks {
              id
              shouldWarnUpdateStatus
            }
          }
          ... on TaskType {
            id
            completed
            shouldWarnUpdateStatus
          }
          ... on TemplateType {
            id
            completed
          }
          ... on TaskGroupType {
            id
            completed
            tasks {
              id
              shouldWarnUpdateStatus
            }
          }
        }
        assignee {
          id
          firstName
          lastName
          jobRole
          avatar {
            originalUrl
          }
        }
        signer {
          id
          firstName
          lastName
          email
        }
        notes {
          id
        }
        jiraTask {
          id
          externalId
          externalProjectId
          externalTypeId
          components
        }
        files {
          id
          ...Attachments_File
        }
        subtasks {
          ...SubtaskFragment
        }
        taskParticipants {
          id
          completed
          invitationSentAt
          user {
            id
          }
        }
        template {
          id
          duration
        }
        project {
          id
          status
          ...ProjectPlanEditTaskDrawer_ProjectSnapshotFragment
          stats {
            ...ProjectPlanEditTaskDrawer_ProjectStatsFragment
          }
          profitabilitySummary {
            forecastedCost
            budgetedCost
          }
        }
      }
    }
  }
}
    ${TaskFormContextTaskFragmentDoc}
${AttachmentsFileFragmentDoc}
${SubtaskFragmentDoc}
${ProjectPlanEditTaskDrawerProjectSnapshotFragmentDoc}
${ProjectPlanEditTaskDrawerProjectStatsFragmentDoc}`;
export type ProjectPlanEditTaskDrawerUpdateTaskGroupTaskMutationMutationFn = Apollo.MutationFunction<ProjectPlanEditTaskDrawerUpdateTaskGroupTaskMutation, ProjectPlanEditTaskDrawerUpdateTaskGroupTaskMutationVariables>;

/**
 * __useProjectPlanEditTaskDrawerUpdateTaskGroupTaskMutation__
 *
 * To run a mutation, you first call `useProjectPlanEditTaskDrawerUpdateTaskGroupTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectPlanEditTaskDrawerUpdateTaskGroupTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectPlanEditTaskDrawerUpdateTaskGroupTaskMutation, { data, loading, error }] = useProjectPlanEditTaskDrawerUpdateTaskGroupTaskMutation({
 *   variables: {
 *      task: // value for 'task'
 *   },
 * });
 */
export function useProjectPlanEditTaskDrawerUpdateTaskGroupTaskMutation(baseOptions?: Apollo.MutationHookOptions<ProjectPlanEditTaskDrawerUpdateTaskGroupTaskMutation, ProjectPlanEditTaskDrawerUpdateTaskGroupTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectPlanEditTaskDrawerUpdateTaskGroupTaskMutation, ProjectPlanEditTaskDrawerUpdateTaskGroupTaskMutationVariables>(ProjectPlanEditTaskDrawerUpdateTaskGroupTaskMutationDocument, options);
      }
export type ProjectPlanEditTaskDrawerUpdateTaskGroupTaskMutationHookResult = ReturnType<typeof useProjectPlanEditTaskDrawerUpdateTaskGroupTaskMutation>;
export type ProjectPlanEditTaskDrawerUpdateTaskGroupTaskMutationMutationResult = Apollo.MutationResult<ProjectPlanEditTaskDrawerUpdateTaskGroupTaskMutation>;
export type ProjectPlanEditTaskDrawerUpdateTaskGroupTaskMutationMutationOptions = Apollo.BaseMutationOptions<ProjectPlanEditTaskDrawerUpdateTaskGroupTaskMutation, ProjectPlanEditTaskDrawerUpdateTaskGroupTaskMutationVariables>;
export const EditTaskDrawerGetAvailableTaskTagsDocument = gql`
    query EditTaskDrawer_GetAvailableTaskTags($taggableId: ID!, $taggableType: TaggableEnumType!) {
  availableTags(taggableId: $taggableId, taggableType: $taggableType) {
    ...Tags_AvailableTags
  }
}
    ${TagsAvailableTagsFragmentDoc}`;

/**
 * __useEditTaskDrawerGetAvailableTaskTagsQuery__
 *
 * To run a query within a React component, call `useEditTaskDrawerGetAvailableTaskTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditTaskDrawerGetAvailableTaskTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditTaskDrawerGetAvailableTaskTagsQuery({
 *   variables: {
 *      taggableId: // value for 'taggableId'
 *      taggableType: // value for 'taggableType'
 *   },
 * });
 */
export function useEditTaskDrawerGetAvailableTaskTagsQuery(baseOptions: Apollo.QueryHookOptions<EditTaskDrawerGetAvailableTaskTagsQuery, EditTaskDrawerGetAvailableTaskTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditTaskDrawerGetAvailableTaskTagsQuery, EditTaskDrawerGetAvailableTaskTagsQueryVariables>(EditTaskDrawerGetAvailableTaskTagsDocument, options);
      }
export function useEditTaskDrawerGetAvailableTaskTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditTaskDrawerGetAvailableTaskTagsQuery, EditTaskDrawerGetAvailableTaskTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditTaskDrawerGetAvailableTaskTagsQuery, EditTaskDrawerGetAvailableTaskTagsQueryVariables>(EditTaskDrawerGetAvailableTaskTagsDocument, options);
        }
export type EditTaskDrawerGetAvailableTaskTagsQueryHookResult = ReturnType<typeof useEditTaskDrawerGetAvailableTaskTagsQuery>;
export type EditTaskDrawerGetAvailableTaskTagsLazyQueryHookResult = ReturnType<typeof useEditTaskDrawerGetAvailableTaskTagsLazyQuery>;
export type EditTaskDrawerGetAvailableTaskTagsQueryResult = Apollo.QueryResult<EditTaskDrawerGetAvailableTaskTagsQuery, EditTaskDrawerGetAvailableTaskTagsQueryVariables>;
export const ProjectPlanEditTaskDrawerCurrentUserSkillsDocument = gql`
    query ProjectPlanEditTaskDrawer_CurrentUserSkills {
  currentUser {
    skills {
      id
    }
  }
}
    `;

/**
 * __useProjectPlanEditTaskDrawerCurrentUserSkillsQuery__
 *
 * To run a query within a React component, call `useProjectPlanEditTaskDrawerCurrentUserSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectPlanEditTaskDrawerCurrentUserSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectPlanEditTaskDrawerCurrentUserSkillsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProjectPlanEditTaskDrawerCurrentUserSkillsQuery(baseOptions?: Apollo.QueryHookOptions<ProjectPlanEditTaskDrawerCurrentUserSkillsQuery, ProjectPlanEditTaskDrawerCurrentUserSkillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectPlanEditTaskDrawerCurrentUserSkillsQuery, ProjectPlanEditTaskDrawerCurrentUserSkillsQueryVariables>(ProjectPlanEditTaskDrawerCurrentUserSkillsDocument, options);
      }
export function useProjectPlanEditTaskDrawerCurrentUserSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectPlanEditTaskDrawerCurrentUserSkillsQuery, ProjectPlanEditTaskDrawerCurrentUserSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectPlanEditTaskDrawerCurrentUserSkillsQuery, ProjectPlanEditTaskDrawerCurrentUserSkillsQueryVariables>(ProjectPlanEditTaskDrawerCurrentUserSkillsDocument, options);
        }
export type ProjectPlanEditTaskDrawerCurrentUserSkillsQueryHookResult = ReturnType<typeof useProjectPlanEditTaskDrawerCurrentUserSkillsQuery>;
export type ProjectPlanEditTaskDrawerCurrentUserSkillsLazyQueryHookResult = ReturnType<typeof useProjectPlanEditTaskDrawerCurrentUserSkillsLazyQuery>;
export type ProjectPlanEditTaskDrawerCurrentUserSkillsQueryResult = Apollo.QueryResult<ProjectPlanEditTaskDrawerCurrentUserSkillsQuery, ProjectPlanEditTaskDrawerCurrentUserSkillsQueryVariables>;
export const ProjectPlanEditTaskDrawerRemoveWatcherDocument = gql`
    mutation ProjectPlanEditTaskDrawer_RemoveWatcher($taskId: ID!, $watcherId: ID!) {
  removeWatcher(input: {taskId: $taskId, watcherId: $watcherId}) {
    success
  }
}
    `;
export type ProjectPlanEditTaskDrawerRemoveWatcherMutationFn = Apollo.MutationFunction<ProjectPlanEditTaskDrawerRemoveWatcherMutation, ProjectPlanEditTaskDrawerRemoveWatcherMutationVariables>;

/**
 * __useProjectPlanEditTaskDrawerRemoveWatcherMutation__
 *
 * To run a mutation, you first call `useProjectPlanEditTaskDrawerRemoveWatcherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectPlanEditTaskDrawerRemoveWatcherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectPlanEditTaskDrawerRemoveWatcherMutation, { data, loading, error }] = useProjectPlanEditTaskDrawerRemoveWatcherMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      watcherId: // value for 'watcherId'
 *   },
 * });
 */
export function useProjectPlanEditTaskDrawerRemoveWatcherMutation(baseOptions?: Apollo.MutationHookOptions<ProjectPlanEditTaskDrawerRemoveWatcherMutation, ProjectPlanEditTaskDrawerRemoveWatcherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectPlanEditTaskDrawerRemoveWatcherMutation, ProjectPlanEditTaskDrawerRemoveWatcherMutationVariables>(ProjectPlanEditTaskDrawerRemoveWatcherDocument, options);
      }
export type ProjectPlanEditTaskDrawerRemoveWatcherMutationHookResult = ReturnType<typeof useProjectPlanEditTaskDrawerRemoveWatcherMutation>;
export type ProjectPlanEditTaskDrawerRemoveWatcherMutationResult = Apollo.MutationResult<ProjectPlanEditTaskDrawerRemoveWatcherMutation>;
export type ProjectPlanEditTaskDrawerRemoveWatcherMutationOptions = Apollo.BaseMutationOptions<ProjectPlanEditTaskDrawerRemoveWatcherMutation, ProjectPlanEditTaskDrawerRemoveWatcherMutationVariables>;
export const ProjectPlanEditTaskDrawerProjectTeamDocument = gql`
    query ProjectPlanEditTaskDrawer_ProjectTeam($projectId: ID!) {
  projectTeam(projectId: $projectId) {
    id
    ...Notes_ProjectTeam
  }
}
    ${NotesProjectTeamFragmentDoc}`;

/**
 * __useProjectPlanEditTaskDrawerProjectTeamQuery__
 *
 * To run a query within a React component, call `useProjectPlanEditTaskDrawerProjectTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectPlanEditTaskDrawerProjectTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectPlanEditTaskDrawerProjectTeamQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectPlanEditTaskDrawerProjectTeamQuery(baseOptions: Apollo.QueryHookOptions<ProjectPlanEditTaskDrawerProjectTeamQuery, ProjectPlanEditTaskDrawerProjectTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectPlanEditTaskDrawerProjectTeamQuery, ProjectPlanEditTaskDrawerProjectTeamQueryVariables>(ProjectPlanEditTaskDrawerProjectTeamDocument, options);
      }
export function useProjectPlanEditTaskDrawerProjectTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectPlanEditTaskDrawerProjectTeamQuery, ProjectPlanEditTaskDrawerProjectTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectPlanEditTaskDrawerProjectTeamQuery, ProjectPlanEditTaskDrawerProjectTeamQueryVariables>(ProjectPlanEditTaskDrawerProjectTeamDocument, options);
        }
export type ProjectPlanEditTaskDrawerProjectTeamQueryHookResult = ReturnType<typeof useProjectPlanEditTaskDrawerProjectTeamQuery>;
export type ProjectPlanEditTaskDrawerProjectTeamLazyQueryHookResult = ReturnType<typeof useProjectPlanEditTaskDrawerProjectTeamLazyQuery>;
export type ProjectPlanEditTaskDrawerProjectTeamQueryResult = Apollo.QueryResult<ProjectPlanEditTaskDrawerProjectTeamQuery, ProjectPlanEditTaskDrawerProjectTeamQueryVariables>;
export const ProjectMilestoneColumnDuplicateMilestoneDocument = gql`
    mutation ProjectMilestoneColumn_DuplicateMilestone($id: ID!, $sortOrder: Float!) {
  duplicateMilestone(input: {id: $id, sortOrder: $sortOrder}) {
    milestone {
      ...UseMilestone_Milestone
      template {
        id
        summaryBank {
          id
          ...TemplateOverview_TemplateStats
          ...ProjectTemplateHoverInfo_SummaryBank
        }
      }
      project {
        id
        ...MilestoneColumn_ProjectSnapshotFragment
        stats {
          ...MilestoneColumn_ProjectStatsFragment
        }
        profitabilitySummary {
          forecastedCost
          budgetedCost
        }
      }
    }
  }
}
    ${UseMilestoneMilestoneFragmentDoc}
${TemplateOverviewTemplateStatsFragmentDoc}
${ProjectTemplateHoverInfoSummaryBankFragmentDoc}
${MilestoneColumnProjectSnapshotFragmentDoc}
${MilestoneColumnProjectStatsFragmentDoc}`;
export type ProjectMilestoneColumnDuplicateMilestoneMutationFn = Apollo.MutationFunction<ProjectMilestoneColumnDuplicateMilestoneMutation, ProjectMilestoneColumnDuplicateMilestoneMutationVariables>;

/**
 * __useProjectMilestoneColumnDuplicateMilestoneMutation__
 *
 * To run a mutation, you first call `useProjectMilestoneColumnDuplicateMilestoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectMilestoneColumnDuplicateMilestoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectMilestoneColumnDuplicateMilestoneMutation, { data, loading, error }] = useProjectMilestoneColumnDuplicateMilestoneMutation({
 *   variables: {
 *      id: // value for 'id'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useProjectMilestoneColumnDuplicateMilestoneMutation(baseOptions?: Apollo.MutationHookOptions<ProjectMilestoneColumnDuplicateMilestoneMutation, ProjectMilestoneColumnDuplicateMilestoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectMilestoneColumnDuplicateMilestoneMutation, ProjectMilestoneColumnDuplicateMilestoneMutationVariables>(ProjectMilestoneColumnDuplicateMilestoneDocument, options);
      }
export type ProjectMilestoneColumnDuplicateMilestoneMutationHookResult = ReturnType<typeof useProjectMilestoneColumnDuplicateMilestoneMutation>;
export type ProjectMilestoneColumnDuplicateMilestoneMutationResult = Apollo.MutationResult<ProjectMilestoneColumnDuplicateMilestoneMutation>;
export type ProjectMilestoneColumnDuplicateMilestoneMutationOptions = Apollo.BaseMutationOptions<ProjectMilestoneColumnDuplicateMilestoneMutation, ProjectMilestoneColumnDuplicateMilestoneMutationVariables>;
export const ProjectMilestoneColumnDuplicateTaskDocument = gql`
    mutation ProjectMilestoneColumn_DuplicateTask($id: ID!) {
  duplicateTask(input: {id: $id}) {
    taskReturnData {
      task {
        id
        milestone {
          startedOn
          forecastedEndOn
          completedAt
          completed
          summaryBank {
            id
            totalTasks
            totalCompleteTasks
            totalRemainingTasks
            duration
          }
        }
        taskGroup {
          startedOn
          forecastedEndOn
          completedAt
          completed
          summaryBank {
            id
            totalTasks
            totalCompleteTasks
            totalRemainingTasks
            duration
          }
        }
        template {
          id
          summaryBank {
            id
            ...TemplateOverview_TemplateStats
            ...ProjectTemplateHoverInfo_SummaryBank
          }
        }
        project {
          id
          ...MilestoneColumn_ProjectSnapshotFragment
          stats {
            ...MilestoneColumn_ProjectStatsFragment
          }
          profitabilitySummary {
            forecastedCost
            budgetedCost
          }
        }
        ...ProjectBulkEditDrawer_Task
        ...ProjectPlanTaskCard_Task
      }
    }
  }
}
    ${TemplateOverviewTemplateStatsFragmentDoc}
${ProjectTemplateHoverInfoSummaryBankFragmentDoc}
${MilestoneColumnProjectSnapshotFragmentDoc}
${MilestoneColumnProjectStatsFragmentDoc}
${ProjectBulkEditDrawerTaskFragmentDoc}
${ProjectPlanTaskCardTaskFragmentDoc}`;
export type ProjectMilestoneColumnDuplicateTaskMutationFn = Apollo.MutationFunction<ProjectMilestoneColumnDuplicateTaskMutation, ProjectMilestoneColumnDuplicateTaskMutationVariables>;

/**
 * __useProjectMilestoneColumnDuplicateTaskMutation__
 *
 * To run a mutation, you first call `useProjectMilestoneColumnDuplicateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectMilestoneColumnDuplicateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectMilestoneColumnDuplicateTaskMutation, { data, loading, error }] = useProjectMilestoneColumnDuplicateTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectMilestoneColumnDuplicateTaskMutation(baseOptions?: Apollo.MutationHookOptions<ProjectMilestoneColumnDuplicateTaskMutation, ProjectMilestoneColumnDuplicateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectMilestoneColumnDuplicateTaskMutation, ProjectMilestoneColumnDuplicateTaskMutationVariables>(ProjectMilestoneColumnDuplicateTaskDocument, options);
      }
export type ProjectMilestoneColumnDuplicateTaskMutationHookResult = ReturnType<typeof useProjectMilestoneColumnDuplicateTaskMutation>;
export type ProjectMilestoneColumnDuplicateTaskMutationResult = Apollo.MutationResult<ProjectMilestoneColumnDuplicateTaskMutation>;
export type ProjectMilestoneColumnDuplicateTaskMutationOptions = Apollo.BaseMutationOptions<ProjectMilestoneColumnDuplicateTaskMutation, ProjectMilestoneColumnDuplicateTaskMutationVariables>;
export const ProjectUseMilestonesDeleteMilestoneDocument = gql`
    mutation ProjectUseMilestones_DeleteMilestone($deleteMilestoneInput: deleteMilestoneInput!) {
  deleteMilestone(input: $deleteMilestoneInput) {
    deleteMilestoneReturnData {
      milestones {
        id
      }
    }
  }
}
    `;
export type ProjectUseMilestonesDeleteMilestoneMutationFn = Apollo.MutationFunction<ProjectUseMilestonesDeleteMilestoneMutation, ProjectUseMilestonesDeleteMilestoneMutationVariables>;

/**
 * __useProjectUseMilestonesDeleteMilestoneMutation__
 *
 * To run a mutation, you first call `useProjectUseMilestonesDeleteMilestoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectUseMilestonesDeleteMilestoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectUseMilestonesDeleteMilestoneMutation, { data, loading, error }] = useProjectUseMilestonesDeleteMilestoneMutation({
 *   variables: {
 *      deleteMilestoneInput: // value for 'deleteMilestoneInput'
 *   },
 * });
 */
export function useProjectUseMilestonesDeleteMilestoneMutation(baseOptions?: Apollo.MutationHookOptions<ProjectUseMilestonesDeleteMilestoneMutation, ProjectUseMilestonesDeleteMilestoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectUseMilestonesDeleteMilestoneMutation, ProjectUseMilestonesDeleteMilestoneMutationVariables>(ProjectUseMilestonesDeleteMilestoneDocument, options);
      }
export type ProjectUseMilestonesDeleteMilestoneMutationHookResult = ReturnType<typeof useProjectUseMilestonesDeleteMilestoneMutation>;
export type ProjectUseMilestonesDeleteMilestoneMutationResult = Apollo.MutationResult<ProjectUseMilestonesDeleteMilestoneMutation>;
export type ProjectUseMilestonesDeleteMilestoneMutationOptions = Apollo.BaseMutationOptions<ProjectUseMilestonesDeleteMilestoneMutation, ProjectUseMilestonesDeleteMilestoneMutationVariables>;
export const ProjectHeaderMenuDeleteTaskDocument = gql`
    mutation ProjectHeaderMenu_DeleteTask($deleteTaskInput: deleteTaskInput!) {
  deleteTask(input: $deleteTaskInput) {
    taskReturnData {
      milestone {
        summaryBank {
          id
          totalTasks
          totalCompleteTasks
          totalRemainingTasks
          duration
        }
        id
      }
    }
  }
}
    `;
export type ProjectHeaderMenuDeleteTaskMutationFn = Apollo.MutationFunction<ProjectHeaderMenuDeleteTaskMutation, ProjectHeaderMenuDeleteTaskMutationVariables>;

/**
 * __useProjectHeaderMenuDeleteTaskMutation__
 *
 * To run a mutation, you first call `useProjectHeaderMenuDeleteTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectHeaderMenuDeleteTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectHeaderMenuDeleteTaskMutation, { data, loading, error }] = useProjectHeaderMenuDeleteTaskMutation({
 *   variables: {
 *      deleteTaskInput: // value for 'deleteTaskInput'
 *   },
 * });
 */
export function useProjectHeaderMenuDeleteTaskMutation(baseOptions?: Apollo.MutationHookOptions<ProjectHeaderMenuDeleteTaskMutation, ProjectHeaderMenuDeleteTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectHeaderMenuDeleteTaskMutation, ProjectHeaderMenuDeleteTaskMutationVariables>(ProjectHeaderMenuDeleteTaskDocument, options);
      }
export type ProjectHeaderMenuDeleteTaskMutationHookResult = ReturnType<typeof useProjectHeaderMenuDeleteTaskMutation>;
export type ProjectHeaderMenuDeleteTaskMutationResult = Apollo.MutationResult<ProjectHeaderMenuDeleteTaskMutation>;
export type ProjectHeaderMenuDeleteTaskMutationOptions = Apollo.BaseMutationOptions<ProjectHeaderMenuDeleteTaskMutation, ProjectHeaderMenuDeleteTaskMutationVariables>;
export const ProjectHeaderMenuSendAssigmentEmailDocument = gql`
    mutation ProjectHeaderMenu_SendAssigmentEmail($taskId: ID!) {
  sendAssignmentEmail(input: {id: $taskId}) {
    success
  }
}
    `;
export type ProjectHeaderMenuSendAssigmentEmailMutationFn = Apollo.MutationFunction<ProjectHeaderMenuSendAssigmentEmailMutation, ProjectHeaderMenuSendAssigmentEmailMutationVariables>;

/**
 * __useProjectHeaderMenuSendAssigmentEmailMutation__
 *
 * To run a mutation, you first call `useProjectHeaderMenuSendAssigmentEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectHeaderMenuSendAssigmentEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectHeaderMenuSendAssigmentEmailMutation, { data, loading, error }] = useProjectHeaderMenuSendAssigmentEmailMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useProjectHeaderMenuSendAssigmentEmailMutation(baseOptions?: Apollo.MutationHookOptions<ProjectHeaderMenuSendAssigmentEmailMutation, ProjectHeaderMenuSendAssigmentEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectHeaderMenuSendAssigmentEmailMutation, ProjectHeaderMenuSendAssigmentEmailMutationVariables>(ProjectHeaderMenuSendAssigmentEmailDocument, options);
      }
export type ProjectHeaderMenuSendAssigmentEmailMutationHookResult = ReturnType<typeof useProjectHeaderMenuSendAssigmentEmailMutation>;
export type ProjectHeaderMenuSendAssigmentEmailMutationResult = Apollo.MutationResult<ProjectHeaderMenuSendAssigmentEmailMutation>;
export type ProjectHeaderMenuSendAssigmentEmailMutationOptions = Apollo.BaseMutationOptions<ProjectHeaderMenuSendAssigmentEmailMutation, ProjectHeaderMenuSendAssigmentEmailMutationVariables>;
export const UseMilestonesFirstActiveTemplateMilestonesDocument = gql`
    query UseMilestones_FirstActiveTemplateMilestones($projectId: ID!) {
  firstActiveTemplateMilestones(projectId: $projectId) {
    ...UseMilestone_Milestone
  }
}
    ${UseMilestoneMilestoneFragmentDoc}`;

/**
 * __useUseMilestonesFirstActiveTemplateMilestonesQuery__
 *
 * To run a query within a React component, call `useUseMilestonesFirstActiveTemplateMilestonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseMilestonesFirstActiveTemplateMilestonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseMilestonesFirstActiveTemplateMilestonesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useUseMilestonesFirstActiveTemplateMilestonesQuery(baseOptions: Apollo.QueryHookOptions<UseMilestonesFirstActiveTemplateMilestonesQuery, UseMilestonesFirstActiveTemplateMilestonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseMilestonesFirstActiveTemplateMilestonesQuery, UseMilestonesFirstActiveTemplateMilestonesQueryVariables>(UseMilestonesFirstActiveTemplateMilestonesDocument, options);
      }
export function useUseMilestonesFirstActiveTemplateMilestonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseMilestonesFirstActiveTemplateMilestonesQuery, UseMilestonesFirstActiveTemplateMilestonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseMilestonesFirstActiveTemplateMilestonesQuery, UseMilestonesFirstActiveTemplateMilestonesQueryVariables>(UseMilestonesFirstActiveTemplateMilestonesDocument, options);
        }
export type UseMilestonesFirstActiveTemplateMilestonesQueryHookResult = ReturnType<typeof useUseMilestonesFirstActiveTemplateMilestonesQuery>;
export type UseMilestonesFirstActiveTemplateMilestonesLazyQueryHookResult = ReturnType<typeof useUseMilestonesFirstActiveTemplateMilestonesLazyQuery>;
export type UseMilestonesFirstActiveTemplateMilestonesQueryResult = Apollo.QueryResult<UseMilestonesFirstActiveTemplateMilestonesQuery, UseMilestonesFirstActiveTemplateMilestonesQueryVariables>;
export const UseMilestonesProjectMilestonesDocument = gql`
    query UseMilestones_ProjectMilestones($templateId: ID!, $taskFilters: TaskFilters, $handleExactMultiRoles: Boolean) {
  projectMilestones(
    templateId: $templateId
    taskFilters: $taskFilters
    handleExactMultiRoles: $handleExactMultiRoles
  ) {
    ...UseMilestone_Milestone
  }
}
    ${UseMilestoneMilestoneFragmentDoc}`;

/**
 * __useUseMilestonesProjectMilestonesQuery__
 *
 * To run a query within a React component, call `useUseMilestonesProjectMilestonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseMilestonesProjectMilestonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseMilestonesProjectMilestonesQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      taskFilters: // value for 'taskFilters'
 *      handleExactMultiRoles: // value for 'handleExactMultiRoles'
 *   },
 * });
 */
export function useUseMilestonesProjectMilestonesQuery(baseOptions: Apollo.QueryHookOptions<UseMilestonesProjectMilestonesQuery, UseMilestonesProjectMilestonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseMilestonesProjectMilestonesQuery, UseMilestonesProjectMilestonesQueryVariables>(UseMilestonesProjectMilestonesDocument, options);
      }
export function useUseMilestonesProjectMilestonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseMilestonesProjectMilestonesQuery, UseMilestonesProjectMilestonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseMilestonesProjectMilestonesQuery, UseMilestonesProjectMilestonesQueryVariables>(UseMilestonesProjectMilestonesDocument, options);
        }
export type UseMilestonesProjectMilestonesQueryHookResult = ReturnType<typeof useUseMilestonesProjectMilestonesQuery>;
export type UseMilestonesProjectMilestonesLazyQueryHookResult = ReturnType<typeof useUseMilestonesProjectMilestonesLazyQuery>;
export type UseMilestonesProjectMilestonesQueryResult = Apollo.QueryResult<UseMilestonesProjectMilestonesQuery, UseMilestonesProjectMilestonesQueryVariables>;
export const MoveTasksWithinTaskGroupInProjectDocument = gql`
    mutation moveTasksWithinTaskGroupInProject($input: SortTaskTaskGroupInput!) {
  sortProjectTaskTaskGroup(input: $input) {
    sortedElement {
      ... on TaskType {
        id
        sortOrder
        ...ProjectMilestoneColumn_Task
      }
    }
  }
}
    ${ProjectMilestoneColumnTaskFragmentDoc}`;
export type MoveTasksWithinTaskGroupInProjectMutationFn = Apollo.MutationFunction<MoveTasksWithinTaskGroupInProjectMutation, MoveTasksWithinTaskGroupInProjectMutationVariables>;

/**
 * __useMoveTasksWithinTaskGroupInProjectMutation__
 *
 * To run a mutation, you first call `useMoveTasksWithinTaskGroupInProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveTasksWithinTaskGroupInProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveTasksWithinTaskGroupInProjectMutation, { data, loading, error }] = useMoveTasksWithinTaskGroupInProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveTasksWithinTaskGroupInProjectMutation(baseOptions?: Apollo.MutationHookOptions<MoveTasksWithinTaskGroupInProjectMutation, MoveTasksWithinTaskGroupInProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveTasksWithinTaskGroupInProjectMutation, MoveTasksWithinTaskGroupInProjectMutationVariables>(MoveTasksWithinTaskGroupInProjectDocument, options);
      }
export type MoveTasksWithinTaskGroupInProjectMutationHookResult = ReturnType<typeof useMoveTasksWithinTaskGroupInProjectMutation>;
export type MoveTasksWithinTaskGroupInProjectMutationResult = Apollo.MutationResult<MoveTasksWithinTaskGroupInProjectMutation>;
export type MoveTasksWithinTaskGroupInProjectMutationOptions = Apollo.BaseMutationOptions<MoveTasksWithinTaskGroupInProjectMutation, MoveTasksWithinTaskGroupInProjectMutationVariables>;
export const MoveTaskGroupToAnotherMilestoneInProjectDocument = gql`
    mutation moveTaskGroupToAnotherMilestoneInProject($input: moveTaskGroupInput!) {
  moveToAnotherProjectMilestone(input: $input) {
    taskGroup {
      id
      sortOrder
    }
  }
}
    `;
export type MoveTaskGroupToAnotherMilestoneInProjectMutationFn = Apollo.MutationFunction<MoveTaskGroupToAnotherMilestoneInProjectMutation, MoveTaskGroupToAnotherMilestoneInProjectMutationVariables>;

/**
 * __useMoveTaskGroupToAnotherMilestoneInProjectMutation__
 *
 * To run a mutation, you first call `useMoveTaskGroupToAnotherMilestoneInProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveTaskGroupToAnotherMilestoneInProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveTaskGroupToAnotherMilestoneInProjectMutation, { data, loading, error }] = useMoveTaskGroupToAnotherMilestoneInProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveTaskGroupToAnotherMilestoneInProjectMutation(baseOptions?: Apollo.MutationHookOptions<MoveTaskGroupToAnotherMilestoneInProjectMutation, MoveTaskGroupToAnotherMilestoneInProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveTaskGroupToAnotherMilestoneInProjectMutation, MoveTaskGroupToAnotherMilestoneInProjectMutationVariables>(MoveTaskGroupToAnotherMilestoneInProjectDocument, options);
      }
export type MoveTaskGroupToAnotherMilestoneInProjectMutationHookResult = ReturnType<typeof useMoveTaskGroupToAnotherMilestoneInProjectMutation>;
export type MoveTaskGroupToAnotherMilestoneInProjectMutationResult = Apollo.MutationResult<MoveTaskGroupToAnotherMilestoneInProjectMutation>;
export type MoveTaskGroupToAnotherMilestoneInProjectMutationOptions = Apollo.BaseMutationOptions<MoveTaskGroupToAnotherMilestoneInProjectMutation, MoveTaskGroupToAnotherMilestoneInProjectMutationVariables>;
export const ProjectUseSortingUpdateProjectTaskDocument = gql`
    mutation ProjectUseSorting_UpdateProjectTask($input: updateTaskInput!) {
  updateProjectTaskGroupTask(input: $input) {
    taskReturnData {
      task {
        name
      }
    }
  }
}
    `;
export type ProjectUseSortingUpdateProjectTaskMutationFn = Apollo.MutationFunction<ProjectUseSortingUpdateProjectTaskMutation, ProjectUseSortingUpdateProjectTaskMutationVariables>;

/**
 * __useProjectUseSortingUpdateProjectTaskMutation__
 *
 * To run a mutation, you first call `useProjectUseSortingUpdateProjectTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectUseSortingUpdateProjectTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectUseSortingUpdateProjectTaskMutation, { data, loading, error }] = useProjectUseSortingUpdateProjectTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProjectUseSortingUpdateProjectTaskMutation(baseOptions?: Apollo.MutationHookOptions<ProjectUseSortingUpdateProjectTaskMutation, ProjectUseSortingUpdateProjectTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectUseSortingUpdateProjectTaskMutation, ProjectUseSortingUpdateProjectTaskMutationVariables>(ProjectUseSortingUpdateProjectTaskDocument, options);
      }
export type ProjectUseSortingUpdateProjectTaskMutationHookResult = ReturnType<typeof useProjectUseSortingUpdateProjectTaskMutation>;
export type ProjectUseSortingUpdateProjectTaskMutationResult = Apollo.MutationResult<ProjectUseSortingUpdateProjectTaskMutation>;
export type ProjectUseSortingUpdateProjectTaskMutationOptions = Apollo.BaseMutationOptions<ProjectUseSortingUpdateProjectTaskMutation, ProjectUseSortingUpdateProjectTaskMutationVariables>;
export const ProjectUseSortingUpdateMilestoneDocument = gql`
    mutation ProjectUseSorting_UpdateMilestone($milestone: updateTemplateMilestoneInput!) {
  updateTemplateMilestone(input: $milestone) {
    milestone {
      id
      sortOrder
    }
  }
}
    `;
export type ProjectUseSortingUpdateMilestoneMutationFn = Apollo.MutationFunction<ProjectUseSortingUpdateMilestoneMutation, ProjectUseSortingUpdateMilestoneMutationVariables>;

/**
 * __useProjectUseSortingUpdateMilestoneMutation__
 *
 * To run a mutation, you first call `useProjectUseSortingUpdateMilestoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectUseSortingUpdateMilestoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectUseSortingUpdateMilestoneMutation, { data, loading, error }] = useProjectUseSortingUpdateMilestoneMutation({
 *   variables: {
 *      milestone: // value for 'milestone'
 *   },
 * });
 */
export function useProjectUseSortingUpdateMilestoneMutation(baseOptions?: Apollo.MutationHookOptions<ProjectUseSortingUpdateMilestoneMutation, ProjectUseSortingUpdateMilestoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectUseSortingUpdateMilestoneMutation, ProjectUseSortingUpdateMilestoneMutationVariables>(ProjectUseSortingUpdateMilestoneDocument, options);
      }
export type ProjectUseSortingUpdateMilestoneMutationHookResult = ReturnType<typeof useProjectUseSortingUpdateMilestoneMutation>;
export type ProjectUseSortingUpdateMilestoneMutationResult = Apollo.MutationResult<ProjectUseSortingUpdateMilestoneMutation>;
export type ProjectUseSortingUpdateMilestoneMutationOptions = Apollo.BaseMutationOptions<ProjectUseSortingUpdateMilestoneMutation, ProjectUseSortingUpdateMilestoneMutationVariables>;
export const ProjectUseSortingCheckDropEligibilityDocument = gql`
    query ProjectUseSorting_CheckDropEligibility($input: DropInput!) {
  dropEligibility(dropInputs: $input) {
    eligibility
    message
  }
}
    `;

/**
 * __useProjectUseSortingCheckDropEligibilityQuery__
 *
 * To run a query within a React component, call `useProjectUseSortingCheckDropEligibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectUseSortingCheckDropEligibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectUseSortingCheckDropEligibilityQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProjectUseSortingCheckDropEligibilityQuery(baseOptions: Apollo.QueryHookOptions<ProjectUseSortingCheckDropEligibilityQuery, ProjectUseSortingCheckDropEligibilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectUseSortingCheckDropEligibilityQuery, ProjectUseSortingCheckDropEligibilityQueryVariables>(ProjectUseSortingCheckDropEligibilityDocument, options);
      }
export function useProjectUseSortingCheckDropEligibilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectUseSortingCheckDropEligibilityQuery, ProjectUseSortingCheckDropEligibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectUseSortingCheckDropEligibilityQuery, ProjectUseSortingCheckDropEligibilityQueryVariables>(ProjectUseSortingCheckDropEligibilityDocument, options);
        }
export type ProjectUseSortingCheckDropEligibilityQueryHookResult = ReturnType<typeof useProjectUseSortingCheckDropEligibilityQuery>;
export type ProjectUseSortingCheckDropEligibilityLazyQueryHookResult = ReturnType<typeof useProjectUseSortingCheckDropEligibilityLazyQuery>;
export type ProjectUseSortingCheckDropEligibilityQueryResult = Apollo.QueryResult<ProjectUseSortingCheckDropEligibilityQuery, ProjectUseSortingCheckDropEligibilityQueryVariables>;
export const PublicProjectOverviewRequestAccessDocument = gql`
    mutation PublicProjectOverview_RequestAccess($userData: submitRequestAccessInput!) {
  submitRequestAccess(input: $userData) {
    success
  }
}
    `;
export type PublicProjectOverviewRequestAccessMutationFn = Apollo.MutationFunction<PublicProjectOverviewRequestAccessMutation, PublicProjectOverviewRequestAccessMutationVariables>;

/**
 * __usePublicProjectOverviewRequestAccessMutation__
 *
 * To run a mutation, you first call `usePublicProjectOverviewRequestAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublicProjectOverviewRequestAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publicProjectOverviewRequestAccessMutation, { data, loading, error }] = usePublicProjectOverviewRequestAccessMutation({
 *   variables: {
 *      userData: // value for 'userData'
 *   },
 * });
 */
export function usePublicProjectOverviewRequestAccessMutation(baseOptions?: Apollo.MutationHookOptions<PublicProjectOverviewRequestAccessMutation, PublicProjectOverviewRequestAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublicProjectOverviewRequestAccessMutation, PublicProjectOverviewRequestAccessMutationVariables>(PublicProjectOverviewRequestAccessDocument, options);
      }
export type PublicProjectOverviewRequestAccessMutationHookResult = ReturnType<typeof usePublicProjectOverviewRequestAccessMutation>;
export type PublicProjectOverviewRequestAccessMutationResult = Apollo.MutationResult<PublicProjectOverviewRequestAccessMutation>;
export type PublicProjectOverviewRequestAccessMutationOptions = Apollo.BaseMutationOptions<PublicProjectOverviewRequestAccessMutation, PublicProjectOverviewRequestAccessMutationVariables>;
export const SkillDialogSkillCategoriesDocument = gql`
    query SkillDialog_SkillCategories($organizationId: ID!) {
  organization(id: $organizationId) {
    skillCategories {
      id
      name
      skillCount
      userCount
    }
  }
}
    `;

/**
 * __useSkillDialogSkillCategoriesQuery__
 *
 * To run a query within a React component, call `useSkillDialogSkillCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkillDialogSkillCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkillDialogSkillCategoriesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useSkillDialogSkillCategoriesQuery(baseOptions: Apollo.QueryHookOptions<SkillDialogSkillCategoriesQuery, SkillDialogSkillCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SkillDialogSkillCategoriesQuery, SkillDialogSkillCategoriesQueryVariables>(SkillDialogSkillCategoriesDocument, options);
      }
export function useSkillDialogSkillCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SkillDialogSkillCategoriesQuery, SkillDialogSkillCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SkillDialogSkillCategoriesQuery, SkillDialogSkillCategoriesQueryVariables>(SkillDialogSkillCategoriesDocument, options);
        }
export type SkillDialogSkillCategoriesQueryHookResult = ReturnType<typeof useSkillDialogSkillCategoriesQuery>;
export type SkillDialogSkillCategoriesLazyQueryHookResult = ReturnType<typeof useSkillDialogSkillCategoriesLazyQuery>;
export type SkillDialogSkillCategoriesQueryResult = Apollo.QueryResult<SkillDialogSkillCategoriesQuery, SkillDialogSkillCategoriesQueryVariables>;
export const SkillDialogUpsertSkillDocument = gql`
    mutation SkillDialog_UpsertSkill($input: upsertSkillInput!) {
  upsertSkill(input: $input) {
    skill {
      ...SkillDialog
    }
  }
}
    ${SkillDialogFragmentDoc}`;
export type SkillDialogUpsertSkillMutationFn = Apollo.MutationFunction<SkillDialogUpsertSkillMutation, SkillDialogUpsertSkillMutationVariables>;

/**
 * __useSkillDialogUpsertSkillMutation__
 *
 * To run a mutation, you first call `useSkillDialogUpsertSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkillDialogUpsertSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skillDialogUpsertSkillMutation, { data, loading, error }] = useSkillDialogUpsertSkillMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSkillDialogUpsertSkillMutation(baseOptions?: Apollo.MutationHookOptions<SkillDialogUpsertSkillMutation, SkillDialogUpsertSkillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SkillDialogUpsertSkillMutation, SkillDialogUpsertSkillMutationVariables>(SkillDialogUpsertSkillDocument, options);
      }
export type SkillDialogUpsertSkillMutationHookResult = ReturnType<typeof useSkillDialogUpsertSkillMutation>;
export type SkillDialogUpsertSkillMutationResult = Apollo.MutationResult<SkillDialogUpsertSkillMutation>;
export type SkillDialogUpsertSkillMutationOptions = Apollo.BaseMutationOptions<SkillDialogUpsertSkillMutation, SkillDialogUpsertSkillMutationVariables>;
export const SkillDialogSkillDocument = gql`
    query SkillDialog_Skill($skillId: ID!) {
  skill(id: $skillId) {
    id
    ...SkillDialog
  }
}
    ${SkillDialogFragmentDoc}`;

/**
 * __useSkillDialogSkillQuery__
 *
 * To run a query within a React component, call `useSkillDialogSkillQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkillDialogSkillQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkillDialogSkillQuery({
 *   variables: {
 *      skillId: // value for 'skillId'
 *   },
 * });
 */
export function useSkillDialogSkillQuery(baseOptions: Apollo.QueryHookOptions<SkillDialogSkillQuery, SkillDialogSkillQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SkillDialogSkillQuery, SkillDialogSkillQueryVariables>(SkillDialogSkillDocument, options);
      }
export function useSkillDialogSkillLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SkillDialogSkillQuery, SkillDialogSkillQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SkillDialogSkillQuery, SkillDialogSkillQueryVariables>(SkillDialogSkillDocument, options);
        }
export type SkillDialogSkillQueryHookResult = ReturnType<typeof useSkillDialogSkillQuery>;
export type SkillDialogSkillLazyQueryHookResult = ReturnType<typeof useSkillDialogSkillLazyQuery>;
export type SkillDialogSkillQueryResult = Apollo.QueryResult<SkillDialogSkillQuery, SkillDialogSkillQueryVariables>;
export const SkillDialogCheckPendingTasksRoleDocument = gql`
    query SkillDialog_CheckPendingTasksRole($roleId: ID!, $unassignUserIds: [ID!]) {
  checkPendingTasksRole(roleId: $roleId, unassignUserIds: $unassignUserIds) {
    id
    firstName
  }
}
    `;

/**
 * __useSkillDialogCheckPendingTasksRoleQuery__
 *
 * To run a query within a React component, call `useSkillDialogCheckPendingTasksRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkillDialogCheckPendingTasksRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkillDialogCheckPendingTasksRoleQuery({
 *   variables: {
 *      roleId: // value for 'roleId'
 *      unassignUserIds: // value for 'unassignUserIds'
 *   },
 * });
 */
export function useSkillDialogCheckPendingTasksRoleQuery(baseOptions: Apollo.QueryHookOptions<SkillDialogCheckPendingTasksRoleQuery, SkillDialogCheckPendingTasksRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SkillDialogCheckPendingTasksRoleQuery, SkillDialogCheckPendingTasksRoleQueryVariables>(SkillDialogCheckPendingTasksRoleDocument, options);
      }
export function useSkillDialogCheckPendingTasksRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SkillDialogCheckPendingTasksRoleQuery, SkillDialogCheckPendingTasksRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SkillDialogCheckPendingTasksRoleQuery, SkillDialogCheckPendingTasksRoleQueryVariables>(SkillDialogCheckPendingTasksRoleDocument, options);
        }
export type SkillDialogCheckPendingTasksRoleQueryHookResult = ReturnType<typeof useSkillDialogCheckPendingTasksRoleQuery>;
export type SkillDialogCheckPendingTasksRoleLazyQueryHookResult = ReturnType<typeof useSkillDialogCheckPendingTasksRoleLazyQuery>;
export type SkillDialogCheckPendingTasksRoleQueryResult = Apollo.QueryResult<SkillDialogCheckPendingTasksRoleQuery, SkillDialogCheckPendingTasksRoleQueryVariables>;
export const SkillDialogDeleteSkillDocument = gql`
    mutation SkillDialog_DeleteSkill($skillId: ID!) {
  deleteSkill(id: $skillId) {
    success
  }
}
    `;
export type SkillDialogDeleteSkillMutationFn = Apollo.MutationFunction<SkillDialogDeleteSkillMutation, SkillDialogDeleteSkillMutationVariables>;

/**
 * __useSkillDialogDeleteSkillMutation__
 *
 * To run a mutation, you first call `useSkillDialogDeleteSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkillDialogDeleteSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skillDialogDeleteSkillMutation, { data, loading, error }] = useSkillDialogDeleteSkillMutation({
 *   variables: {
 *      skillId: // value for 'skillId'
 *   },
 * });
 */
export function useSkillDialogDeleteSkillMutation(baseOptions?: Apollo.MutationHookOptions<SkillDialogDeleteSkillMutation, SkillDialogDeleteSkillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SkillDialogDeleteSkillMutation, SkillDialogDeleteSkillMutationVariables>(SkillDialogDeleteSkillDocument, options);
      }
export type SkillDialogDeleteSkillMutationHookResult = ReturnType<typeof useSkillDialogDeleteSkillMutation>;
export type SkillDialogDeleteSkillMutationResult = Apollo.MutationResult<SkillDialogDeleteSkillMutation>;
export type SkillDialogDeleteSkillMutationOptions = Apollo.BaseMutationOptions<SkillDialogDeleteSkillMutation, SkillDialogDeleteSkillMutationVariables>;
export const TagsAvailableTagsDocument = gql`
    query Tags_AvailableTags($taggableId: ID!, $type: String, $taggableType: TaggableEnumType!) {
  availableTags(taggableId: $taggableId, type: $type, taggableType: $taggableType) {
    ...Tags_AvailableTags
  }
}
    ${TagsAvailableTagsFragmentDoc}`;

/**
 * __useTagsAvailableTagsQuery__
 *
 * To run a query within a React component, call `useTagsAvailableTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsAvailableTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsAvailableTagsQuery({
 *   variables: {
 *      taggableId: // value for 'taggableId'
 *      type: // value for 'type'
 *      taggableType: // value for 'taggableType'
 *   },
 * });
 */
export function useTagsAvailableTagsQuery(baseOptions: Apollo.QueryHookOptions<TagsAvailableTagsQuery, TagsAvailableTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagsAvailableTagsQuery, TagsAvailableTagsQueryVariables>(TagsAvailableTagsDocument, options);
      }
export function useTagsAvailableTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagsAvailableTagsQuery, TagsAvailableTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagsAvailableTagsQuery, TagsAvailableTagsQueryVariables>(TagsAvailableTagsDocument, options);
        }
export type TagsAvailableTagsQueryHookResult = ReturnType<typeof useTagsAvailableTagsQuery>;
export type TagsAvailableTagsLazyQueryHookResult = ReturnType<typeof useTagsAvailableTagsLazyQuery>;
export type TagsAvailableTagsQueryResult = Apollo.QueryResult<TagsAvailableTagsQuery, TagsAvailableTagsQueryVariables>;
export const TagColorItemAddTagDocument = gql`
    mutation TagColorItem_AddTag($tagInput: addTagInput!) {
  addTag(input: $tagInput) {
    taggable {
      ... on TaskType {
        id
        tags {
          ...TagColorItem_Tag
        }
      }
      ... on ProjectType {
        id
        tags {
          ...TagColorItem_Tag
        }
      }
      ... on ActionItemType {
        id
        tags {
          ...TagColorItem_Tag
        }
      }
    }
  }
}
    ${TagColorItemTagFragmentDoc}`;
export type TagColorItemAddTagMutationFn = Apollo.MutationFunction<TagColorItemAddTagMutation, TagColorItemAddTagMutationVariables>;

/**
 * __useTagColorItemAddTagMutation__
 *
 * To run a mutation, you first call `useTagColorItemAddTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagColorItemAddTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagColorItemAddTagMutation, { data, loading, error }] = useTagColorItemAddTagMutation({
 *   variables: {
 *      tagInput: // value for 'tagInput'
 *   },
 * });
 */
export function useTagColorItemAddTagMutation(baseOptions?: Apollo.MutationHookOptions<TagColorItemAddTagMutation, TagColorItemAddTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TagColorItemAddTagMutation, TagColorItemAddTagMutationVariables>(TagColorItemAddTagDocument, options);
      }
export type TagColorItemAddTagMutationHookResult = ReturnType<typeof useTagColorItemAddTagMutation>;
export type TagColorItemAddTagMutationResult = Apollo.MutationResult<TagColorItemAddTagMutation>;
export type TagColorItemAddTagMutationOptions = Apollo.BaseMutationOptions<TagColorItemAddTagMutation, TagColorItemAddTagMutationVariables>;
export const TagsCreateAvailableTagDocument = gql`
    mutation Tags_CreateAvailableTag($availableTagInput: createAvailableTagInput!) {
  createAvailableTag(input: $availableTagInput) {
    tag {
      ...Tags_AvailableTags
    }
  }
}
    ${TagsAvailableTagsFragmentDoc}`;
export type TagsCreateAvailableTagMutationFn = Apollo.MutationFunction<TagsCreateAvailableTagMutation, TagsCreateAvailableTagMutationVariables>;

/**
 * __useTagsCreateAvailableTagMutation__
 *
 * To run a mutation, you first call `useTagsCreateAvailableTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagsCreateAvailableTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagsCreateAvailableTagMutation, { data, loading, error }] = useTagsCreateAvailableTagMutation({
 *   variables: {
 *      availableTagInput: // value for 'availableTagInput'
 *   },
 * });
 */
export function useTagsCreateAvailableTagMutation(baseOptions?: Apollo.MutationHookOptions<TagsCreateAvailableTagMutation, TagsCreateAvailableTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TagsCreateAvailableTagMutation, TagsCreateAvailableTagMutationVariables>(TagsCreateAvailableTagDocument, options);
      }
export type TagsCreateAvailableTagMutationHookResult = ReturnType<typeof useTagsCreateAvailableTagMutation>;
export type TagsCreateAvailableTagMutationResult = Apollo.MutationResult<TagsCreateAvailableTagMutation>;
export type TagsCreateAvailableTagMutationOptions = Apollo.BaseMutationOptions<TagsCreateAvailableTagMutation, TagsCreateAvailableTagMutationVariables>;
export const TagColorItemDeleteAvailableTagDocument = gql`
    mutation TagColorItem_DeleteAvailableTag($availableTagInput: deleteAvailableTagInput!) {
  deleteAvailableTag(input: $availableTagInput) {
    tag {
      id
      ...TagColorItem_Tag
    }
  }
}
    ${TagColorItemTagFragmentDoc}`;
export type TagColorItemDeleteAvailableTagMutationFn = Apollo.MutationFunction<TagColorItemDeleteAvailableTagMutation, TagColorItemDeleteAvailableTagMutationVariables>;

/**
 * __useTagColorItemDeleteAvailableTagMutation__
 *
 * To run a mutation, you first call `useTagColorItemDeleteAvailableTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagColorItemDeleteAvailableTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagColorItemDeleteAvailableTagMutation, { data, loading, error }] = useTagColorItemDeleteAvailableTagMutation({
 *   variables: {
 *      availableTagInput: // value for 'availableTagInput'
 *   },
 * });
 */
export function useTagColorItemDeleteAvailableTagMutation(baseOptions?: Apollo.MutationHookOptions<TagColorItemDeleteAvailableTagMutation, TagColorItemDeleteAvailableTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TagColorItemDeleteAvailableTagMutation, TagColorItemDeleteAvailableTagMutationVariables>(TagColorItemDeleteAvailableTagDocument, options);
      }
export type TagColorItemDeleteAvailableTagMutationHookResult = ReturnType<typeof useTagColorItemDeleteAvailableTagMutation>;
export type TagColorItemDeleteAvailableTagMutationResult = Apollo.MutationResult<TagColorItemDeleteAvailableTagMutation>;
export type TagColorItemDeleteAvailableTagMutationOptions = Apollo.BaseMutationOptions<TagColorItemDeleteAvailableTagMutation, TagColorItemDeleteAvailableTagMutationVariables>;
export const TagColorItemEditAvailableTagDocument = gql`
    mutation TagColorItem_EditAvailableTag($availableTagInput: updateAvailableTagInput!) {
  updateAvailableTag(input: $availableTagInput) {
    tag {
      id
      ...TagColorItem_Tag
    }
  }
}
    ${TagColorItemTagFragmentDoc}`;
export type TagColorItemEditAvailableTagMutationFn = Apollo.MutationFunction<TagColorItemEditAvailableTagMutation, TagColorItemEditAvailableTagMutationVariables>;

/**
 * __useTagColorItemEditAvailableTagMutation__
 *
 * To run a mutation, you first call `useTagColorItemEditAvailableTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagColorItemEditAvailableTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagColorItemEditAvailableTagMutation, { data, loading, error }] = useTagColorItemEditAvailableTagMutation({
 *   variables: {
 *      availableTagInput: // value for 'availableTagInput'
 *   },
 * });
 */
export function useTagColorItemEditAvailableTagMutation(baseOptions?: Apollo.MutationHookOptions<TagColorItemEditAvailableTagMutation, TagColorItemEditAvailableTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TagColorItemEditAvailableTagMutation, TagColorItemEditAvailableTagMutationVariables>(TagColorItemEditAvailableTagDocument, options);
      }
export type TagColorItemEditAvailableTagMutationHookResult = ReturnType<typeof useTagColorItemEditAvailableTagMutation>;
export type TagColorItemEditAvailableTagMutationResult = Apollo.MutationResult<TagColorItemEditAvailableTagMutation>;
export type TagColorItemEditAvailableTagMutationOptions = Apollo.BaseMutationOptions<TagColorItemEditAvailableTagMutation, TagColorItemEditAvailableTagMutationVariables>;
export const TagColorItemRemoveTagDocument = gql`
    mutation TagColorItem_RemoveTag($tagInput: removeTagInput!) {
  removeTag(input: $tagInput) {
    taggable {
      ... on TaskType {
        id
        tags {
          ...TagColorItem_Tag
        }
      }
      ... on ProjectType {
        id
        tags {
          ...TagColorItem_Tag
        }
      }
      ... on ActionItemType {
        id
        tags {
          ...TagColorItem_Tag
        }
      }
    }
  }
}
    ${TagColorItemTagFragmentDoc}`;
export type TagColorItemRemoveTagMutationFn = Apollo.MutationFunction<TagColorItemRemoveTagMutation, TagColorItemRemoveTagMutationVariables>;

/**
 * __useTagColorItemRemoveTagMutation__
 *
 * To run a mutation, you first call `useTagColorItemRemoveTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagColorItemRemoveTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagColorItemRemoveTagMutation, { data, loading, error }] = useTagColorItemRemoveTagMutation({
 *   variables: {
 *      tagInput: // value for 'tagInput'
 *   },
 * });
 */
export function useTagColorItemRemoveTagMutation(baseOptions?: Apollo.MutationHookOptions<TagColorItemRemoveTagMutation, TagColorItemRemoveTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TagColorItemRemoveTagMutation, TagColorItemRemoveTagMutationVariables>(TagColorItemRemoveTagDocument, options);
      }
export type TagColorItemRemoveTagMutationHookResult = ReturnType<typeof useTagColorItemRemoveTagMutation>;
export type TagColorItemRemoveTagMutationResult = Apollo.MutationResult<TagColorItemRemoveTagMutation>;
export type TagColorItemRemoveTagMutationOptions = Apollo.BaseMutationOptions<TagColorItemRemoveTagMutation, TagColorItemRemoveTagMutationVariables>;
export const DeleteUserDialogUserTasksConnectionsDocument = gql`
    query DeleteUserDialog_UserTasksConnections($userId: ID!, $taskFilters: TaskFilters, $listInputs: ListInput) {
  userTasksConnections(
    userId: $userId
    taskFilters: $taskFilters
    listInputs: $listInputs
  ) {
    tasks {
      id
      ...TaskReassignTask
    }
  }
}
    ${TaskReassignTaskFragmentDoc}`;

/**
 * __useDeleteUserDialogUserTasksConnectionsQuery__
 *
 * To run a query within a React component, call `useDeleteUserDialogUserTasksConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserDialogUserTasksConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeleteUserDialogUserTasksConnectionsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      taskFilters: // value for 'taskFilters'
 *      listInputs: // value for 'listInputs'
 *   },
 * });
 */
export function useDeleteUserDialogUserTasksConnectionsQuery(baseOptions: Apollo.QueryHookOptions<DeleteUserDialogUserTasksConnectionsQuery, DeleteUserDialogUserTasksConnectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeleteUserDialogUserTasksConnectionsQuery, DeleteUserDialogUserTasksConnectionsQueryVariables>(DeleteUserDialogUserTasksConnectionsDocument, options);
      }
export function useDeleteUserDialogUserTasksConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeleteUserDialogUserTasksConnectionsQuery, DeleteUserDialogUserTasksConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeleteUserDialogUserTasksConnectionsQuery, DeleteUserDialogUserTasksConnectionsQueryVariables>(DeleteUserDialogUserTasksConnectionsDocument, options);
        }
export type DeleteUserDialogUserTasksConnectionsQueryHookResult = ReturnType<typeof useDeleteUserDialogUserTasksConnectionsQuery>;
export type DeleteUserDialogUserTasksConnectionsLazyQueryHookResult = ReturnType<typeof useDeleteUserDialogUserTasksConnectionsLazyQuery>;
export type DeleteUserDialogUserTasksConnectionsQueryResult = Apollo.QueryResult<DeleteUserDialogUserTasksConnectionsQuery, DeleteUserDialogUserTasksConnectionsQueryVariables>;
export const TeamCardUserProjectStatsDocument = gql`
    query TeamCard_UserProjectStats($userId: ID!, $projectId: ID!) {
  userProjectStats(userId: $userId, projectId: $projectId) {
    totalDoneTasks
    totalRemainingTasks
    totalPlannedTasks
    totalOverdueTasks
    activeOverdueTasks
  }
}
    `;

/**
 * __useTeamCardUserProjectStatsQuery__
 *
 * To run a query within a React component, call `useTeamCardUserProjectStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamCardUserProjectStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamCardUserProjectStatsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useTeamCardUserProjectStatsQuery(baseOptions: Apollo.QueryHookOptions<TeamCardUserProjectStatsQuery, TeamCardUserProjectStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamCardUserProjectStatsQuery, TeamCardUserProjectStatsQueryVariables>(TeamCardUserProjectStatsDocument, options);
      }
export function useTeamCardUserProjectStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamCardUserProjectStatsQuery, TeamCardUserProjectStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamCardUserProjectStatsQuery, TeamCardUserProjectStatsQueryVariables>(TeamCardUserProjectStatsDocument, options);
        }
export type TeamCardUserProjectStatsQueryHookResult = ReturnType<typeof useTeamCardUserProjectStatsQuery>;
export type TeamCardUserProjectStatsLazyQueryHookResult = ReturnType<typeof useTeamCardUserProjectStatsLazyQuery>;
export type TeamCardUserProjectStatsQueryResult = Apollo.QueryResult<TeamCardUserProjectStatsQuery, TeamCardUserProjectStatsQueryVariables>;
export const TeamCardResendInvitationDocument = gql`
    mutation TeamCard_ResendInvitation($email: String!, $projectId: ID) {
  resendInviteToUser(input: {email: $email, projectId: $projectId}) {
    success
  }
}
    `;
export type TeamCardResendInvitationMutationFn = Apollo.MutationFunction<TeamCardResendInvitationMutation, TeamCardResendInvitationMutationVariables>;

/**
 * __useTeamCardResendInvitationMutation__
 *
 * To run a mutation, you first call `useTeamCardResendInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTeamCardResendInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [teamCardResendInvitationMutation, { data, loading, error }] = useTeamCardResendInvitationMutation({
 *   variables: {
 *      email: // value for 'email'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useTeamCardResendInvitationMutation(baseOptions?: Apollo.MutationHookOptions<TeamCardResendInvitationMutation, TeamCardResendInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeamCardResendInvitationMutation, TeamCardResendInvitationMutationVariables>(TeamCardResendInvitationDocument, options);
      }
export type TeamCardResendInvitationMutationHookResult = ReturnType<typeof useTeamCardResendInvitationMutation>;
export type TeamCardResendInvitationMutationResult = Apollo.MutationResult<TeamCardResendInvitationMutation>;
export type TeamCardResendInvitationMutationOptions = Apollo.BaseMutationOptions<TeamCardResendInvitationMutation, TeamCardResendInvitationMutationVariables>;
export const TemplatePlanAvailableTagsDocument = gql`
    query TemplatePlan_AvailableTags($taggableId: ID!, $type: String, $taggableType: TaggableEnumType!) {
  availableTags(taggableId: $taggableId, type: $type, taggableType: $taggableType) {
    ...TemplatePlan_AvailableTags
  }
}
    ${TemplatePlanAvailableTagsFragmentDoc}`;

/**
 * __useTemplatePlanAvailableTagsQuery__
 *
 * To run a query within a React component, call `useTemplatePlanAvailableTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplatePlanAvailableTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplatePlanAvailableTagsQuery({
 *   variables: {
 *      taggableId: // value for 'taggableId'
 *      type: // value for 'type'
 *      taggableType: // value for 'taggableType'
 *   },
 * });
 */
export function useTemplatePlanAvailableTagsQuery(baseOptions: Apollo.QueryHookOptions<TemplatePlanAvailableTagsQuery, TemplatePlanAvailableTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplatePlanAvailableTagsQuery, TemplatePlanAvailableTagsQueryVariables>(TemplatePlanAvailableTagsDocument, options);
      }
export function useTemplatePlanAvailableTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplatePlanAvailableTagsQuery, TemplatePlanAvailableTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplatePlanAvailableTagsQuery, TemplatePlanAvailableTagsQueryVariables>(TemplatePlanAvailableTagsDocument, options);
        }
export type TemplatePlanAvailableTagsQueryHookResult = ReturnType<typeof useTemplatePlanAvailableTagsQuery>;
export type TemplatePlanAvailableTagsLazyQueryHookResult = ReturnType<typeof useTemplatePlanAvailableTagsLazyQuery>;
export type TemplatePlanAvailableTagsQueryResult = Apollo.QueryResult<TemplatePlanAvailableTagsQuery, TemplatePlanAvailableTagsQueryVariables>;
export const TemplatePlanTemplateDocument = gql`
    query TemplatePlan_Template($templateId: ID!) {
  blueprintTemplate(id: $templateId) {
    id
    ...TemplatePlan_TemplateV2
  }
}
    ${TemplatePlanTemplateV2FragmentDoc}`;

/**
 * __useTemplatePlanTemplateQuery__
 *
 * To run a query within a React component, call `useTemplatePlanTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplatePlanTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplatePlanTemplateQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useTemplatePlanTemplateQuery(baseOptions: Apollo.QueryHookOptions<TemplatePlanTemplateQuery, TemplatePlanTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplatePlanTemplateQuery, TemplatePlanTemplateQueryVariables>(TemplatePlanTemplateDocument, options);
      }
export function useTemplatePlanTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplatePlanTemplateQuery, TemplatePlanTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplatePlanTemplateQuery, TemplatePlanTemplateQueryVariables>(TemplatePlanTemplateDocument, options);
        }
export type TemplatePlanTemplateQueryHookResult = ReturnType<typeof useTemplatePlanTemplateQuery>;
export type TemplatePlanTemplateLazyQueryHookResult = ReturnType<typeof useTemplatePlanTemplateLazyQuery>;
export type TemplatePlanTemplateQueryResult = Apollo.QueryResult<TemplatePlanTemplateQuery, TemplatePlanTemplateQueryVariables>;
export const TemplatePlanCreateTaskV2Document = gql`
    mutation TemplatePlan_CreateTaskV2($taskInputs: createTaskInput!) {
  createTask(input: $taskInputs) {
    taskReturnData {
      task {
        id
        ...TemplateMilestoneBoard_Task
        ...TemplateBulkEditDrawer_Task
        template {
          id
          duration
        }
      }
    }
  }
}
    ${TemplateMilestoneBoardTaskFragmentDoc}
${TemplateBulkEditDrawerTaskFragmentDoc}`;
export type TemplatePlanCreateTaskV2MutationFn = Apollo.MutationFunction<TemplatePlanCreateTaskV2Mutation, TemplatePlanCreateTaskV2MutationVariables>;

/**
 * __useTemplatePlanCreateTaskV2Mutation__
 *
 * To run a mutation, you first call `useTemplatePlanCreateTaskV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTemplatePlanCreateTaskV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [templatePlanCreateTaskV2Mutation, { data, loading, error }] = useTemplatePlanCreateTaskV2Mutation({
 *   variables: {
 *      taskInputs: // value for 'taskInputs'
 *   },
 * });
 */
export function useTemplatePlanCreateTaskV2Mutation(baseOptions?: Apollo.MutationHookOptions<TemplatePlanCreateTaskV2Mutation, TemplatePlanCreateTaskV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TemplatePlanCreateTaskV2Mutation, TemplatePlanCreateTaskV2MutationVariables>(TemplatePlanCreateTaskV2Document, options);
      }
export type TemplatePlanCreateTaskV2MutationHookResult = ReturnType<typeof useTemplatePlanCreateTaskV2Mutation>;
export type TemplatePlanCreateTaskV2MutationResult = Apollo.MutationResult<TemplatePlanCreateTaskV2Mutation>;
export type TemplatePlanCreateTaskV2MutationOptions = Apollo.BaseMutationOptions<TemplatePlanCreateTaskV2Mutation, TemplatePlanCreateTaskV2MutationVariables>;
export const TemplateBulkEditFormTaskGroupDependenciesConflictDocument = gql`
    query TemplateBulkEditForm_TaskGroupDependenciesConflict($taskGroupId: ID!, $taskIds: [ID!]!) {
  taskGroupDependenciesConflict(taskGroupId: $taskGroupId, taskIds: $taskIds)
}
    `;

/**
 * __useTemplateBulkEditFormTaskGroupDependenciesConflictQuery__
 *
 * To run a query within a React component, call `useTemplateBulkEditFormTaskGroupDependenciesConflictQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateBulkEditFormTaskGroupDependenciesConflictQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateBulkEditFormTaskGroupDependenciesConflictQuery({
 *   variables: {
 *      taskGroupId: // value for 'taskGroupId'
 *      taskIds: // value for 'taskIds'
 *   },
 * });
 */
export function useTemplateBulkEditFormTaskGroupDependenciesConflictQuery(baseOptions: Apollo.QueryHookOptions<TemplateBulkEditFormTaskGroupDependenciesConflictQuery, TemplateBulkEditFormTaskGroupDependenciesConflictQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplateBulkEditFormTaskGroupDependenciesConflictQuery, TemplateBulkEditFormTaskGroupDependenciesConflictQueryVariables>(TemplateBulkEditFormTaskGroupDependenciesConflictDocument, options);
      }
export function useTemplateBulkEditFormTaskGroupDependenciesConflictLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplateBulkEditFormTaskGroupDependenciesConflictQuery, TemplateBulkEditFormTaskGroupDependenciesConflictQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplateBulkEditFormTaskGroupDependenciesConflictQuery, TemplateBulkEditFormTaskGroupDependenciesConflictQueryVariables>(TemplateBulkEditFormTaskGroupDependenciesConflictDocument, options);
        }
export type TemplateBulkEditFormTaskGroupDependenciesConflictQueryHookResult = ReturnType<typeof useTemplateBulkEditFormTaskGroupDependenciesConflictQuery>;
export type TemplateBulkEditFormTaskGroupDependenciesConflictLazyQueryHookResult = ReturnType<typeof useTemplateBulkEditFormTaskGroupDependenciesConflictLazyQuery>;
export type TemplateBulkEditFormTaskGroupDependenciesConflictQueryResult = Apollo.QueryResult<TemplateBulkEditFormTaskGroupDependenciesConflictQuery, TemplateBulkEditFormTaskGroupDependenciesConflictQueryVariables>;
export const TemplateBulkEditFormBulkEditTasksDocument = gql`
    mutation TemplateBulkEditForm_BulkEditTasks($input: bulkEditTasksInput!) {
  bulkEditTasks(input: $input) {
    updatedTasks {
      ...TemplateBulkEditForm_Task
      assignee {
        id
      }
      tags {
        id
      }
      watchers {
        id
      }
      skill {
        id
        name
        category {
          id
          name
        }
      }
    }
  }
}
    ${TemplateBulkEditFormTaskFragmentDoc}`;
export type TemplateBulkEditFormBulkEditTasksMutationFn = Apollo.MutationFunction<TemplateBulkEditFormBulkEditTasksMutation, TemplateBulkEditFormBulkEditTasksMutationVariables>;

/**
 * __useTemplateBulkEditFormBulkEditTasksMutation__
 *
 * To run a mutation, you first call `useTemplateBulkEditFormBulkEditTasksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTemplateBulkEditFormBulkEditTasksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [templateBulkEditFormBulkEditTasksMutation, { data, loading, error }] = useTemplateBulkEditFormBulkEditTasksMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTemplateBulkEditFormBulkEditTasksMutation(baseOptions?: Apollo.MutationHookOptions<TemplateBulkEditFormBulkEditTasksMutation, TemplateBulkEditFormBulkEditTasksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TemplateBulkEditFormBulkEditTasksMutation, TemplateBulkEditFormBulkEditTasksMutationVariables>(TemplateBulkEditFormBulkEditTasksDocument, options);
      }
export type TemplateBulkEditFormBulkEditTasksMutationHookResult = ReturnType<typeof useTemplateBulkEditFormBulkEditTasksMutation>;
export type TemplateBulkEditFormBulkEditTasksMutationResult = Apollo.MutationResult<TemplateBulkEditFormBulkEditTasksMutation>;
export type TemplateBulkEditFormBulkEditTasksMutationOptions = Apollo.BaseMutationOptions<TemplateBulkEditFormBulkEditTasksMutation, TemplateBulkEditFormBulkEditTasksMutationVariables>;
export const TemplateBulkEditFormAssigneesDocument = gql`
    query TemplateBulkEditForm_Assignees($milestoneId: ID!, $organizationId: ID) {
  potentialTaskAssignees(
    milestoneId: $milestoneId
    organizationId: $organizationId
  ) {
    id
    ...AssigneeField_User
  }
}
    ${AssigneeFieldUserFragmentDoc}`;

/**
 * __useTemplateBulkEditFormAssigneesQuery__
 *
 * To run a query within a React component, call `useTemplateBulkEditFormAssigneesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateBulkEditFormAssigneesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateBulkEditFormAssigneesQuery({
 *   variables: {
 *      milestoneId: // value for 'milestoneId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useTemplateBulkEditFormAssigneesQuery(baseOptions: Apollo.QueryHookOptions<TemplateBulkEditFormAssigneesQuery, TemplateBulkEditFormAssigneesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplateBulkEditFormAssigneesQuery, TemplateBulkEditFormAssigneesQueryVariables>(TemplateBulkEditFormAssigneesDocument, options);
      }
export function useTemplateBulkEditFormAssigneesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplateBulkEditFormAssigneesQuery, TemplateBulkEditFormAssigneesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplateBulkEditFormAssigneesQuery, TemplateBulkEditFormAssigneesQueryVariables>(TemplateBulkEditFormAssigneesDocument, options);
        }
export type TemplateBulkEditFormAssigneesQueryHookResult = ReturnType<typeof useTemplateBulkEditFormAssigneesQuery>;
export type TemplateBulkEditFormAssigneesLazyQueryHookResult = ReturnType<typeof useTemplateBulkEditFormAssigneesLazyQuery>;
export type TemplateBulkEditFormAssigneesQueryResult = Apollo.QueryResult<TemplateBulkEditFormAssigneesQuery, TemplateBulkEditFormAssigneesQueryVariables>;
export const TemplateBulkEditFormCommonTaskWatchersDocument = gql`
    query TemplateBulkEditForm_CommonTaskWatchers($taskIds: [ID!]!) {
  commonTaskWatchers(taskIds: $taskIds) {
    id
    ...AssigneeMultiSelect_User
  }
}
    ${AssigneeMultiSelectUserFragmentDoc}`;

/**
 * __useTemplateBulkEditFormCommonTaskWatchersQuery__
 *
 * To run a query within a React component, call `useTemplateBulkEditFormCommonTaskWatchersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateBulkEditFormCommonTaskWatchersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateBulkEditFormCommonTaskWatchersQuery({
 *   variables: {
 *      taskIds: // value for 'taskIds'
 *   },
 * });
 */
export function useTemplateBulkEditFormCommonTaskWatchersQuery(baseOptions: Apollo.QueryHookOptions<TemplateBulkEditFormCommonTaskWatchersQuery, TemplateBulkEditFormCommonTaskWatchersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplateBulkEditFormCommonTaskWatchersQuery, TemplateBulkEditFormCommonTaskWatchersQueryVariables>(TemplateBulkEditFormCommonTaskWatchersDocument, options);
      }
export function useTemplateBulkEditFormCommonTaskWatchersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplateBulkEditFormCommonTaskWatchersQuery, TemplateBulkEditFormCommonTaskWatchersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplateBulkEditFormCommonTaskWatchersQuery, TemplateBulkEditFormCommonTaskWatchersQueryVariables>(TemplateBulkEditFormCommonTaskWatchersDocument, options);
        }
export type TemplateBulkEditFormCommonTaskWatchersQueryHookResult = ReturnType<typeof useTemplateBulkEditFormCommonTaskWatchersQuery>;
export type TemplateBulkEditFormCommonTaskWatchersLazyQueryHookResult = ReturnType<typeof useTemplateBulkEditFormCommonTaskWatchersLazyQuery>;
export type TemplateBulkEditFormCommonTaskWatchersQueryResult = Apollo.QueryResult<TemplateBulkEditFormCommonTaskWatchersQuery, TemplateBulkEditFormCommonTaskWatchersQueryVariables>;
export const TemplateBulkEditFormTagsDocument = gql`
    query TemplateBulkEditForm_Tags($taggableId: ID!, $type: String, $taggableType: TaggableEnumType!) {
  availableTags(taggableId: $taggableId, type: $type, taggableType: $taggableType) {
    id
    name
    color
  }
}
    `;

/**
 * __useTemplateBulkEditFormTagsQuery__
 *
 * To run a query within a React component, call `useTemplateBulkEditFormTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateBulkEditFormTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateBulkEditFormTagsQuery({
 *   variables: {
 *      taggableId: // value for 'taggableId'
 *      type: // value for 'type'
 *      taggableType: // value for 'taggableType'
 *   },
 * });
 */
export function useTemplateBulkEditFormTagsQuery(baseOptions: Apollo.QueryHookOptions<TemplateBulkEditFormTagsQuery, TemplateBulkEditFormTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplateBulkEditFormTagsQuery, TemplateBulkEditFormTagsQueryVariables>(TemplateBulkEditFormTagsDocument, options);
      }
export function useTemplateBulkEditFormTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplateBulkEditFormTagsQuery, TemplateBulkEditFormTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplateBulkEditFormTagsQuery, TemplateBulkEditFormTagsQueryVariables>(TemplateBulkEditFormTagsDocument, options);
        }
export type TemplateBulkEditFormTagsQueryHookResult = ReturnType<typeof useTemplateBulkEditFormTagsQuery>;
export type TemplateBulkEditFormTagsLazyQueryHookResult = ReturnType<typeof useTemplateBulkEditFormTagsLazyQuery>;
export type TemplateBulkEditFormTagsQueryResult = Apollo.QueryResult<TemplateBulkEditFormTagsQuery, TemplateBulkEditFormTagsQueryVariables>;
export const TemplateMilestoneBoardMilestoneUpdatedDocument = gql`
    subscription TemplateMilestoneBoard_MilestoneUpdated($templateId: ID!) {
  milestoneUpdated(templateId: $templateId) {
    milestone {
      id
      duration
      completed
      startedOn
      ...TemplateMilestoneHeader_Milestone
    }
    milestoneStats {
      id
      totalTasks
      totalCompleteTasks
      totalRemainingTasks
      duration
    }
  }
}
    ${TemplateMilestoneHeaderMilestoneFragmentDoc}`;

/**
 * __useTemplateMilestoneBoardMilestoneUpdatedSubscription__
 *
 * To run a query within a React component, call `useTemplateMilestoneBoardMilestoneUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTemplateMilestoneBoardMilestoneUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateMilestoneBoardMilestoneUpdatedSubscription({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useTemplateMilestoneBoardMilestoneUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<TemplateMilestoneBoardMilestoneUpdatedSubscription, TemplateMilestoneBoardMilestoneUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<TemplateMilestoneBoardMilestoneUpdatedSubscription, TemplateMilestoneBoardMilestoneUpdatedSubscriptionVariables>(TemplateMilestoneBoardMilestoneUpdatedDocument, options);
      }
export type TemplateMilestoneBoardMilestoneUpdatedSubscriptionHookResult = ReturnType<typeof useTemplateMilestoneBoardMilestoneUpdatedSubscription>;
export type TemplateMilestoneBoardMilestoneUpdatedSubscriptionResult = Apollo.SubscriptionResult<TemplateMilestoneBoardMilestoneUpdatedSubscription>;
export const TemplateEditMilestoneDrawerUpdateMilestoneDocument = gql`
    mutation TemplateEditMilestoneDrawer_UpdateMilestone($milestone: updateTemplateMilestoneInput!) {
  updateTemplateMilestone(input: $milestone) {
    milestone {
      id
      ...MilestoneForm_Milestone
    }
  }
}
    ${MilestoneFormMilestoneFragmentDoc}`;
export type TemplateEditMilestoneDrawerUpdateMilestoneMutationFn = Apollo.MutationFunction<TemplateEditMilestoneDrawerUpdateMilestoneMutation, TemplateEditMilestoneDrawerUpdateMilestoneMutationVariables>;

/**
 * __useTemplateEditMilestoneDrawerUpdateMilestoneMutation__
 *
 * To run a mutation, you first call `useTemplateEditMilestoneDrawerUpdateMilestoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTemplateEditMilestoneDrawerUpdateMilestoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [templateEditMilestoneDrawerUpdateMilestoneMutation, { data, loading, error }] = useTemplateEditMilestoneDrawerUpdateMilestoneMutation({
 *   variables: {
 *      milestone: // value for 'milestone'
 *   },
 * });
 */
export function useTemplateEditMilestoneDrawerUpdateMilestoneMutation(baseOptions?: Apollo.MutationHookOptions<TemplateEditMilestoneDrawerUpdateMilestoneMutation, TemplateEditMilestoneDrawerUpdateMilestoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TemplateEditMilestoneDrawerUpdateMilestoneMutation, TemplateEditMilestoneDrawerUpdateMilestoneMutationVariables>(TemplateEditMilestoneDrawerUpdateMilestoneDocument, options);
      }
export type TemplateEditMilestoneDrawerUpdateMilestoneMutationHookResult = ReturnType<typeof useTemplateEditMilestoneDrawerUpdateMilestoneMutation>;
export type TemplateEditMilestoneDrawerUpdateMilestoneMutationResult = Apollo.MutationResult<TemplateEditMilestoneDrawerUpdateMilestoneMutation>;
export type TemplateEditMilestoneDrawerUpdateMilestoneMutationOptions = Apollo.BaseMutationOptions<TemplateEditMilestoneDrawerUpdateMilestoneMutation, TemplateEditMilestoneDrawerUpdateMilestoneMutationVariables>;
export const TemplateEditTaskDrawerUpdateTaskGroupTaskMutationDocument = gql`
    mutation TemplateEditTaskDrawer_UpdateTaskGroupTaskMutation($task: updateTaskInput!) {
  updateTaskGroupTask(input: $task) {
    taskReturnData {
      task {
        id
        taskType
        name
        description
        startOn
        dueOn
        estimatedHours
        actualHours
        billableHours
        nonBillableHours
        estimatedPoints
        duration
        sortOrder
        priority
        responsibility
        signOffRequired
        status
        shouldWarnUpdateStatus
        currentUserTaskContext
        eventDatetime
        participantCallToAction
        invitationGroupSentAt
        ...TaskFormContext_Task
        dependency {
          ... on MilestoneType {
            id
            completed
            tasks {
              id
              shouldWarnUpdateStatus
            }
          }
          ... on TaskType {
            id
            completed
            shouldWarnUpdateStatus
          }
          ... on TemplateType {
            id
            completed
          }
          ... on TaskGroupType {
            id
            completed
            tasks {
              id
              shouldWarnUpdateStatus
            }
          }
        }
        assignee {
          id
          firstName
          lastName
          jobRole
          avatar {
            originalUrl
          }
        }
        signer {
          id
          firstName
          lastName
          email
        }
        jiraTask {
          id
          externalId
          externalProjectId
          externalTypeId
          components
        }
        files {
          id
          ...Attachments_File
        }
        subtasks {
          ...SubtaskFragment
        }
        taskParticipants {
          id
          completed
          invitationSentAt
          user {
            id
          }
        }
        template {
          id
          duration
        }
      }
    }
  }
}
    ${TaskFormContextTaskFragmentDoc}
${AttachmentsFileFragmentDoc}
${SubtaskFragmentDoc}`;
export type TemplateEditTaskDrawerUpdateTaskGroupTaskMutationMutationFn = Apollo.MutationFunction<TemplateEditTaskDrawerUpdateTaskGroupTaskMutation, TemplateEditTaskDrawerUpdateTaskGroupTaskMutationVariables>;

/**
 * __useTemplateEditTaskDrawerUpdateTaskGroupTaskMutation__
 *
 * To run a mutation, you first call `useTemplateEditTaskDrawerUpdateTaskGroupTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTemplateEditTaskDrawerUpdateTaskGroupTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [templateEditTaskDrawerUpdateTaskGroupTaskMutation, { data, loading, error }] = useTemplateEditTaskDrawerUpdateTaskGroupTaskMutation({
 *   variables: {
 *      task: // value for 'task'
 *   },
 * });
 */
export function useTemplateEditTaskDrawerUpdateTaskGroupTaskMutation(baseOptions?: Apollo.MutationHookOptions<TemplateEditTaskDrawerUpdateTaskGroupTaskMutation, TemplateEditTaskDrawerUpdateTaskGroupTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TemplateEditTaskDrawerUpdateTaskGroupTaskMutation, TemplateEditTaskDrawerUpdateTaskGroupTaskMutationVariables>(TemplateEditTaskDrawerUpdateTaskGroupTaskMutationDocument, options);
      }
export type TemplateEditTaskDrawerUpdateTaskGroupTaskMutationHookResult = ReturnType<typeof useTemplateEditTaskDrawerUpdateTaskGroupTaskMutation>;
export type TemplateEditTaskDrawerUpdateTaskGroupTaskMutationMutationResult = Apollo.MutationResult<TemplateEditTaskDrawerUpdateTaskGroupTaskMutation>;
export type TemplateEditTaskDrawerUpdateTaskGroupTaskMutationMutationOptions = Apollo.BaseMutationOptions<TemplateEditTaskDrawerUpdateTaskGroupTaskMutation, TemplateEditTaskDrawerUpdateTaskGroupTaskMutationVariables>;
export const TemplateEditTaskDrawerGetAvailableTaskTagsDocument = gql`
    query TemplateEditTaskDrawer_GetAvailableTaskTags($taggableId: ID!, $taggableType: TaggableEnumType!) {
  availableTags(taggableId: $taggableId, taggableType: $taggableType) {
    ...Tags_AvailableTags
  }
}
    ${TagsAvailableTagsFragmentDoc}`;

/**
 * __useTemplateEditTaskDrawerGetAvailableTaskTagsQuery__
 *
 * To run a query within a React component, call `useTemplateEditTaskDrawerGetAvailableTaskTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateEditTaskDrawerGetAvailableTaskTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateEditTaskDrawerGetAvailableTaskTagsQuery({
 *   variables: {
 *      taggableId: // value for 'taggableId'
 *      taggableType: // value for 'taggableType'
 *   },
 * });
 */
export function useTemplateEditTaskDrawerGetAvailableTaskTagsQuery(baseOptions: Apollo.QueryHookOptions<TemplateEditTaskDrawerGetAvailableTaskTagsQuery, TemplateEditTaskDrawerGetAvailableTaskTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplateEditTaskDrawerGetAvailableTaskTagsQuery, TemplateEditTaskDrawerGetAvailableTaskTagsQueryVariables>(TemplateEditTaskDrawerGetAvailableTaskTagsDocument, options);
      }
export function useTemplateEditTaskDrawerGetAvailableTaskTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplateEditTaskDrawerGetAvailableTaskTagsQuery, TemplateEditTaskDrawerGetAvailableTaskTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplateEditTaskDrawerGetAvailableTaskTagsQuery, TemplateEditTaskDrawerGetAvailableTaskTagsQueryVariables>(TemplateEditTaskDrawerGetAvailableTaskTagsDocument, options);
        }
export type TemplateEditTaskDrawerGetAvailableTaskTagsQueryHookResult = ReturnType<typeof useTemplateEditTaskDrawerGetAvailableTaskTagsQuery>;
export type TemplateEditTaskDrawerGetAvailableTaskTagsLazyQueryHookResult = ReturnType<typeof useTemplateEditTaskDrawerGetAvailableTaskTagsLazyQuery>;
export type TemplateEditTaskDrawerGetAvailableTaskTagsQueryResult = Apollo.QueryResult<TemplateEditTaskDrawerGetAvailableTaskTagsQuery, TemplateEditTaskDrawerGetAvailableTaskTagsQueryVariables>;
export const TemplateEditTaskDrawerCurrentUserSkillsDocument = gql`
    query TemplateEditTaskDrawer_CurrentUserSkills {
  currentUser {
    skills {
      id
    }
  }
}
    `;

/**
 * __useTemplateEditTaskDrawerCurrentUserSkillsQuery__
 *
 * To run a query within a React component, call `useTemplateEditTaskDrawerCurrentUserSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateEditTaskDrawerCurrentUserSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateEditTaskDrawerCurrentUserSkillsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTemplateEditTaskDrawerCurrentUserSkillsQuery(baseOptions?: Apollo.QueryHookOptions<TemplateEditTaskDrawerCurrentUserSkillsQuery, TemplateEditTaskDrawerCurrentUserSkillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplateEditTaskDrawerCurrentUserSkillsQuery, TemplateEditTaskDrawerCurrentUserSkillsQueryVariables>(TemplateEditTaskDrawerCurrentUserSkillsDocument, options);
      }
export function useTemplateEditTaskDrawerCurrentUserSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplateEditTaskDrawerCurrentUserSkillsQuery, TemplateEditTaskDrawerCurrentUserSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplateEditTaskDrawerCurrentUserSkillsQuery, TemplateEditTaskDrawerCurrentUserSkillsQueryVariables>(TemplateEditTaskDrawerCurrentUserSkillsDocument, options);
        }
export type TemplateEditTaskDrawerCurrentUserSkillsQueryHookResult = ReturnType<typeof useTemplateEditTaskDrawerCurrentUserSkillsQuery>;
export type TemplateEditTaskDrawerCurrentUserSkillsLazyQueryHookResult = ReturnType<typeof useTemplateEditTaskDrawerCurrentUserSkillsLazyQuery>;
export type TemplateEditTaskDrawerCurrentUserSkillsQueryResult = Apollo.QueryResult<TemplateEditTaskDrawerCurrentUserSkillsQuery, TemplateEditTaskDrawerCurrentUserSkillsQueryVariables>;
export const TemplateWatchersRemoveWatcherDocument = gql`
    mutation TemplateWatchers_RemoveWatcher($variables: removeWatcherInput!) {
  removeWatcher(input: $variables) {
    success
  }
}
    `;
export type TemplateWatchersRemoveWatcherMutationFn = Apollo.MutationFunction<TemplateWatchersRemoveWatcherMutation, TemplateWatchersRemoveWatcherMutationVariables>;

/**
 * __useTemplateWatchersRemoveWatcherMutation__
 *
 * To run a mutation, you first call `useTemplateWatchersRemoveWatcherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTemplateWatchersRemoveWatcherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [templateWatchersRemoveWatcherMutation, { data, loading, error }] = useTemplateWatchersRemoveWatcherMutation({
 *   variables: {
 *      variables: // value for 'variables'
 *   },
 * });
 */
export function useTemplateWatchersRemoveWatcherMutation(baseOptions?: Apollo.MutationHookOptions<TemplateWatchersRemoveWatcherMutation, TemplateWatchersRemoveWatcherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TemplateWatchersRemoveWatcherMutation, TemplateWatchersRemoveWatcherMutationVariables>(TemplateWatchersRemoveWatcherDocument, options);
      }
export type TemplateWatchersRemoveWatcherMutationHookResult = ReturnType<typeof useTemplateWatchersRemoveWatcherMutation>;
export type TemplateWatchersRemoveWatcherMutationResult = Apollo.MutationResult<TemplateWatchersRemoveWatcherMutation>;
export type TemplateWatchersRemoveWatcherMutationOptions = Apollo.BaseMutationOptions<TemplateWatchersRemoveWatcherMutation, TemplateWatchersRemoveWatcherMutationVariables>;
export const TaskFormTaskDocument = gql`
    query TaskForm_Task($id: ID!, $noProjectContext: Boolean = false) {
  task(id: $id) {
    id
    ...TaskFormContext_Task
    project @include(if: $noProjectContext) {
      currentUserProjectContext
    }
  }
}
    ${TaskFormContextTaskFragmentDoc}`;

/**
 * __useTaskFormTaskQuery__
 *
 * To run a query within a React component, call `useTaskFormTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskFormTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskFormTaskQuery({
 *   variables: {
 *      id: // value for 'id'
 *      noProjectContext: // value for 'noProjectContext'
 *   },
 * });
 */
export function useTaskFormTaskQuery(baseOptions: Apollo.QueryHookOptions<TaskFormTaskQuery, TaskFormTaskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskFormTaskQuery, TaskFormTaskQueryVariables>(TaskFormTaskDocument, options);
      }
export function useTaskFormTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskFormTaskQuery, TaskFormTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskFormTaskQuery, TaskFormTaskQueryVariables>(TaskFormTaskDocument, options);
        }
export type TaskFormTaskQueryHookResult = ReturnType<typeof useTaskFormTaskQuery>;
export type TaskFormTaskLazyQueryHookResult = ReturnType<typeof useTaskFormTaskLazyQuery>;
export type TaskFormTaskQueryResult = Apollo.QueryResult<TaskFormTaskQuery, TaskFormTaskQueryVariables>;
export const TaskFormTaskV2Document = gql`
    query TaskForm_TaskV2($id: ID!, $noProjectContext: Boolean = false) {
  task(id: $id) {
    id
    ...TaskFormContext_Task
    project @include(if: $noProjectContext) {
      currentUserProjectContext
    }
  }
}
    ${TaskFormContextTaskFragmentDoc}`;

/**
 * __useTaskFormTaskV2Query__
 *
 * To run a query within a React component, call `useTaskFormTaskV2Query` and pass it any options that fit your needs.
 * When your component renders, `useTaskFormTaskV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskFormTaskV2Query({
 *   variables: {
 *      id: // value for 'id'
 *      noProjectContext: // value for 'noProjectContext'
 *   },
 * });
 */
export function useTaskFormTaskV2Query(baseOptions: Apollo.QueryHookOptions<TaskFormTaskV2Query, TaskFormTaskV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskFormTaskV2Query, TaskFormTaskV2QueryVariables>(TaskFormTaskV2Document, options);
      }
export function useTaskFormTaskV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskFormTaskV2Query, TaskFormTaskV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskFormTaskV2Query, TaskFormTaskV2QueryVariables>(TaskFormTaskV2Document, options);
        }
export type TaskFormTaskV2QueryHookResult = ReturnType<typeof useTaskFormTaskV2Query>;
export type TaskFormTaskV2LazyQueryHookResult = ReturnType<typeof useTaskFormTaskV2LazyQuery>;
export type TaskFormTaskV2QueryResult = Apollo.QueryResult<TaskFormTaskV2Query, TaskFormTaskV2QueryVariables>;
export const TemplateMilestoneColumnDuplicateMilestoneDocument = gql`
    mutation TemplateMilestoneColumn_DuplicateMilestone($id: ID!, $sortOrder: Float!) {
  duplicateMilestone(input: {id: $id, sortOrder: $sortOrder}) {
    milestone {
      id
      sortOrder
      tasksAndGroups {
        ... on TaskType {
          id
          ...TemplateBulkEditDrawer_Task
          ...TemplateTaskCard_Task
        }
        ... on TaskGroupType {
          ...TemplateTaskGroupCard_TaskGroup
          tasks {
            id
            ...TemplateBulkEditDrawer_Task
            ...TemplateTaskCard_Task
          }
        }
      }
      ...TemplateMilestoneHeader_Milestone
    }
  }
}
    ${TemplateBulkEditDrawerTaskFragmentDoc}
${TemplateTaskCardTaskFragmentDoc}
${TemplateTaskGroupCardTaskGroupFragmentDoc}
${TemplateMilestoneHeaderMilestoneFragmentDoc}`;
export type TemplateMilestoneColumnDuplicateMilestoneMutationFn = Apollo.MutationFunction<TemplateMilestoneColumnDuplicateMilestoneMutation, TemplateMilestoneColumnDuplicateMilestoneMutationVariables>;

/**
 * __useTemplateMilestoneColumnDuplicateMilestoneMutation__
 *
 * To run a mutation, you first call `useTemplateMilestoneColumnDuplicateMilestoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTemplateMilestoneColumnDuplicateMilestoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [templateMilestoneColumnDuplicateMilestoneMutation, { data, loading, error }] = useTemplateMilestoneColumnDuplicateMilestoneMutation({
 *   variables: {
 *      id: // value for 'id'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useTemplateMilestoneColumnDuplicateMilestoneMutation(baseOptions?: Apollo.MutationHookOptions<TemplateMilestoneColumnDuplicateMilestoneMutation, TemplateMilestoneColumnDuplicateMilestoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TemplateMilestoneColumnDuplicateMilestoneMutation, TemplateMilestoneColumnDuplicateMilestoneMutationVariables>(TemplateMilestoneColumnDuplicateMilestoneDocument, options);
      }
export type TemplateMilestoneColumnDuplicateMilestoneMutationHookResult = ReturnType<typeof useTemplateMilestoneColumnDuplicateMilestoneMutation>;
export type TemplateMilestoneColumnDuplicateMilestoneMutationResult = Apollo.MutationResult<TemplateMilestoneColumnDuplicateMilestoneMutation>;
export type TemplateMilestoneColumnDuplicateMilestoneMutationOptions = Apollo.BaseMutationOptions<TemplateMilestoneColumnDuplicateMilestoneMutation, TemplateMilestoneColumnDuplicateMilestoneMutationVariables>;
export const TemplateMilestoneColumnDuplicateTaskDocument = gql`
    mutation TemplateMilestoneColumn_DuplicateTask($id: ID!) {
  duplicateTask(input: {id: $id}) {
    taskReturnData {
      task {
        id
        ...TemplateBulkEditDrawer_Task
        ...TemplateTaskCard_Task
      }
    }
  }
}
    ${TemplateBulkEditDrawerTaskFragmentDoc}
${TemplateTaskCardTaskFragmentDoc}`;
export type TemplateMilestoneColumnDuplicateTaskMutationFn = Apollo.MutationFunction<TemplateMilestoneColumnDuplicateTaskMutation, TemplateMilestoneColumnDuplicateTaskMutationVariables>;

/**
 * __useTemplateMilestoneColumnDuplicateTaskMutation__
 *
 * To run a mutation, you first call `useTemplateMilestoneColumnDuplicateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTemplateMilestoneColumnDuplicateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [templateMilestoneColumnDuplicateTaskMutation, { data, loading, error }] = useTemplateMilestoneColumnDuplicateTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTemplateMilestoneColumnDuplicateTaskMutation(baseOptions?: Apollo.MutationHookOptions<TemplateMilestoneColumnDuplicateTaskMutation, TemplateMilestoneColumnDuplicateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TemplateMilestoneColumnDuplicateTaskMutation, TemplateMilestoneColumnDuplicateTaskMutationVariables>(TemplateMilestoneColumnDuplicateTaskDocument, options);
      }
export type TemplateMilestoneColumnDuplicateTaskMutationHookResult = ReturnType<typeof useTemplateMilestoneColumnDuplicateTaskMutation>;
export type TemplateMilestoneColumnDuplicateTaskMutationResult = Apollo.MutationResult<TemplateMilestoneColumnDuplicateTaskMutation>;
export type TemplateMilestoneColumnDuplicateTaskMutationOptions = Apollo.BaseMutationOptions<TemplateMilestoneColumnDuplicateTaskMutation, TemplateMilestoneColumnDuplicateTaskMutationVariables>;
export const TemplateHeaderMenuSendAssigmentEmailDocument = gql`
    mutation TemplateHeaderMenu_SendAssigmentEmail($taskId: ID!) {
  sendAssignmentEmail(input: {id: $taskId}) {
    success
  }
}
    `;
export type TemplateHeaderMenuSendAssigmentEmailMutationFn = Apollo.MutationFunction<TemplateHeaderMenuSendAssigmentEmailMutation, TemplateHeaderMenuSendAssigmentEmailMutationVariables>;

/**
 * __useTemplateHeaderMenuSendAssigmentEmailMutation__
 *
 * To run a mutation, you first call `useTemplateHeaderMenuSendAssigmentEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTemplateHeaderMenuSendAssigmentEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [templateHeaderMenuSendAssigmentEmailMutation, { data, loading, error }] = useTemplateHeaderMenuSendAssigmentEmailMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useTemplateHeaderMenuSendAssigmentEmailMutation(baseOptions?: Apollo.MutationHookOptions<TemplateHeaderMenuSendAssigmentEmailMutation, TemplateHeaderMenuSendAssigmentEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TemplateHeaderMenuSendAssigmentEmailMutation, TemplateHeaderMenuSendAssigmentEmailMutationVariables>(TemplateHeaderMenuSendAssigmentEmailDocument, options);
      }
export type TemplateHeaderMenuSendAssigmentEmailMutationHookResult = ReturnType<typeof useTemplateHeaderMenuSendAssigmentEmailMutation>;
export type TemplateHeaderMenuSendAssigmentEmailMutationResult = Apollo.MutationResult<TemplateHeaderMenuSendAssigmentEmailMutation>;
export type TemplateHeaderMenuSendAssigmentEmailMutationOptions = Apollo.BaseMutationOptions<TemplateHeaderMenuSendAssigmentEmailMutation, TemplateHeaderMenuSendAssigmentEmailMutationVariables>;
export const UseMilestonesTemplateMilestonesDocument = gql`
    query UseMilestones_TemplateMilestones($templateId: ID!, $taskFilters: TaskFilters) {
  templateMilestones(templateId: $templateId, taskFilters: $taskFilters) {
    id
    ...TemplateMilestoneBoard_Milestone
    ...TemplateBulkEditDrawer_Milestone
    tasksAndGroups {
      ... on TaskType {
        id
        sortOrder
        assignee {
          avatar {
            originalUrl
          }
        }
        ...TemplateBulkEditDrawer_Task
      }
      ... on TaskGroupType {
        id
        sortOrder
        name
        tasks {
          id
          sortOrder
          assignee {
            avatar {
              originalUrl
            }
          }
          ...TemplateBulkEditDrawer_Task
        }
        __typename
      }
    }
  }
}
    ${TemplateMilestoneBoardMilestoneFragmentDoc}
${TemplateBulkEditDrawerMilestoneFragmentDoc}
${TemplateBulkEditDrawerTaskFragmentDoc}`;

/**
 * __useUseMilestonesTemplateMilestonesQuery__
 *
 * To run a query within a React component, call `useUseMilestonesTemplateMilestonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseMilestonesTemplateMilestonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseMilestonesTemplateMilestonesQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      taskFilters: // value for 'taskFilters'
 *   },
 * });
 */
export function useUseMilestonesTemplateMilestonesQuery(baseOptions: Apollo.QueryHookOptions<UseMilestonesTemplateMilestonesQuery, UseMilestonesTemplateMilestonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseMilestonesTemplateMilestonesQuery, UseMilestonesTemplateMilestonesQueryVariables>(UseMilestonesTemplateMilestonesDocument, options);
      }
export function useUseMilestonesTemplateMilestonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseMilestonesTemplateMilestonesQuery, UseMilestonesTemplateMilestonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseMilestonesTemplateMilestonesQuery, UseMilestonesTemplateMilestonesQueryVariables>(UseMilestonesTemplateMilestonesDocument, options);
        }
export type UseMilestonesTemplateMilestonesQueryHookResult = ReturnType<typeof useUseMilestonesTemplateMilestonesQuery>;
export type UseMilestonesTemplateMilestonesLazyQueryHookResult = ReturnType<typeof useUseMilestonesTemplateMilestonesLazyQuery>;
export type UseMilestonesTemplateMilestonesQueryResult = Apollo.QueryResult<UseMilestonesTemplateMilestonesQuery, UseMilestonesTemplateMilestonesQueryVariables>;
export const TemplateUseMilestonesCreateMilestoneDocument = gql`
    mutation TemplateUseMilestones_CreateMilestone($milestoneVars: createTemplateMilestoneInput!) {
  createTemplateMilestone(input: $milestoneVars) {
    milestone {
      id
      ...TemplateMilestoneColumn_Milestone
    }
  }
}
    ${TemplateMilestoneColumnMilestoneFragmentDoc}`;
export type TemplateUseMilestonesCreateMilestoneMutationFn = Apollo.MutationFunction<TemplateUseMilestonesCreateMilestoneMutation, TemplateUseMilestonesCreateMilestoneMutationVariables>;

/**
 * __useTemplateUseMilestonesCreateMilestoneMutation__
 *
 * To run a mutation, you first call `useTemplateUseMilestonesCreateMilestoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTemplateUseMilestonesCreateMilestoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [templateUseMilestonesCreateMilestoneMutation, { data, loading, error }] = useTemplateUseMilestonesCreateMilestoneMutation({
 *   variables: {
 *      milestoneVars: // value for 'milestoneVars'
 *   },
 * });
 */
export function useTemplateUseMilestonesCreateMilestoneMutation(baseOptions?: Apollo.MutationHookOptions<TemplateUseMilestonesCreateMilestoneMutation, TemplateUseMilestonesCreateMilestoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TemplateUseMilestonesCreateMilestoneMutation, TemplateUseMilestonesCreateMilestoneMutationVariables>(TemplateUseMilestonesCreateMilestoneDocument, options);
      }
export type TemplateUseMilestonesCreateMilestoneMutationHookResult = ReturnType<typeof useTemplateUseMilestonesCreateMilestoneMutation>;
export type TemplateUseMilestonesCreateMilestoneMutationResult = Apollo.MutationResult<TemplateUseMilestonesCreateMilestoneMutation>;
export type TemplateUseMilestonesCreateMilestoneMutationOptions = Apollo.BaseMutationOptions<TemplateUseMilestonesCreateMilestoneMutation, TemplateUseMilestonesCreateMilestoneMutationVariables>;
export const TemplateUseMilestonesDeleteMilestoneDocument = gql`
    mutation TemplateUseMilestones_DeleteMilestone($deleteMilestoneInput: deleteMilestoneInput!) {
  deleteMilestone(input: $deleteMilestoneInput) {
    deleteMilestoneReturnData {
      milestones {
        id
        tasks {
          id
          dependency {
            ... on MilestoneType {
              id
              completed
            }
            ... on TaskType {
              id
              completed
              visibility
            }
            ... on TemplateType {
              id
              completed
            }
            ... on TaskGroupType {
              id
              completed
            }
          }
        }
      }
      templateStats {
        id
        ...TemplateOverview_TemplateStats
      }
    }
  }
}
    ${TemplateOverviewTemplateStatsFragmentDoc}`;
export type TemplateUseMilestonesDeleteMilestoneMutationFn = Apollo.MutationFunction<TemplateUseMilestonesDeleteMilestoneMutation, TemplateUseMilestonesDeleteMilestoneMutationVariables>;

/**
 * __useTemplateUseMilestonesDeleteMilestoneMutation__
 *
 * To run a mutation, you first call `useTemplateUseMilestonesDeleteMilestoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTemplateUseMilestonesDeleteMilestoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [templateUseMilestonesDeleteMilestoneMutation, { data, loading, error }] = useTemplateUseMilestonesDeleteMilestoneMutation({
 *   variables: {
 *      deleteMilestoneInput: // value for 'deleteMilestoneInput'
 *   },
 * });
 */
export function useTemplateUseMilestonesDeleteMilestoneMutation(baseOptions?: Apollo.MutationHookOptions<TemplateUseMilestonesDeleteMilestoneMutation, TemplateUseMilestonesDeleteMilestoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TemplateUseMilestonesDeleteMilestoneMutation, TemplateUseMilestonesDeleteMilestoneMutationVariables>(TemplateUseMilestonesDeleteMilestoneDocument, options);
      }
export type TemplateUseMilestonesDeleteMilestoneMutationHookResult = ReturnType<typeof useTemplateUseMilestonesDeleteMilestoneMutation>;
export type TemplateUseMilestonesDeleteMilestoneMutationResult = Apollo.MutationResult<TemplateUseMilestonesDeleteMilestoneMutation>;
export type TemplateUseMilestonesDeleteMilestoneMutationOptions = Apollo.BaseMutationOptions<TemplateUseMilestonesDeleteMilestoneMutation, TemplateUseMilestonesDeleteMilestoneMutationVariables>;
export const MoveTasksWithinTaskGroupInTemplateDocument = gql`
    mutation moveTasksWithinTaskGroupInTemplate($input: SortTaskTaskGroupInput!) {
  sortTaskTaskGroup(input: $input) {
    sortedElement {
      ... on TaskType {
        id
        sortOrder
        ...TemplateMilestoneColumn_Task
      }
    }
  }
}
    ${TemplateMilestoneColumnTaskFragmentDoc}`;
export type MoveTasksWithinTaskGroupInTemplateMutationFn = Apollo.MutationFunction<MoveTasksWithinTaskGroupInTemplateMutation, MoveTasksWithinTaskGroupInTemplateMutationVariables>;

/**
 * __useMoveTasksWithinTaskGroupInTemplateMutation__
 *
 * To run a mutation, you first call `useMoveTasksWithinTaskGroupInTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveTasksWithinTaskGroupInTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveTasksWithinTaskGroupInTemplateMutation, { data, loading, error }] = useMoveTasksWithinTaskGroupInTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveTasksWithinTaskGroupInTemplateMutation(baseOptions?: Apollo.MutationHookOptions<MoveTasksWithinTaskGroupInTemplateMutation, MoveTasksWithinTaskGroupInTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveTasksWithinTaskGroupInTemplateMutation, MoveTasksWithinTaskGroupInTemplateMutationVariables>(MoveTasksWithinTaskGroupInTemplateDocument, options);
      }
export type MoveTasksWithinTaskGroupInTemplateMutationHookResult = ReturnType<typeof useMoveTasksWithinTaskGroupInTemplateMutation>;
export type MoveTasksWithinTaskGroupInTemplateMutationResult = Apollo.MutationResult<MoveTasksWithinTaskGroupInTemplateMutation>;
export type MoveTasksWithinTaskGroupInTemplateMutationOptions = Apollo.BaseMutationOptions<MoveTasksWithinTaskGroupInTemplateMutation, MoveTasksWithinTaskGroupInTemplateMutationVariables>;
export const MoveTaskGroupToAnotherMilestoneInTemplateDocument = gql`
    mutation moveTaskGroupToAnotherMilestoneInTemplate($input: moveTaskGroupInput!) {
  moveToAnotherMilestone(input: $input) {
    taskGroup {
      id
      sortOrder
    }
  }
}
    `;
export type MoveTaskGroupToAnotherMilestoneInTemplateMutationFn = Apollo.MutationFunction<MoveTaskGroupToAnotherMilestoneInTemplateMutation, MoveTaskGroupToAnotherMilestoneInTemplateMutationVariables>;

/**
 * __useMoveTaskGroupToAnotherMilestoneInTemplateMutation__
 *
 * To run a mutation, you first call `useMoveTaskGroupToAnotherMilestoneInTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveTaskGroupToAnotherMilestoneInTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveTaskGroupToAnotherMilestoneInTemplateMutation, { data, loading, error }] = useMoveTaskGroupToAnotherMilestoneInTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveTaskGroupToAnotherMilestoneInTemplateMutation(baseOptions?: Apollo.MutationHookOptions<MoveTaskGroupToAnotherMilestoneInTemplateMutation, MoveTaskGroupToAnotherMilestoneInTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveTaskGroupToAnotherMilestoneInTemplateMutation, MoveTaskGroupToAnotherMilestoneInTemplateMutationVariables>(MoveTaskGroupToAnotherMilestoneInTemplateDocument, options);
      }
export type MoveTaskGroupToAnotherMilestoneInTemplateMutationHookResult = ReturnType<typeof useMoveTaskGroupToAnotherMilestoneInTemplateMutation>;
export type MoveTaskGroupToAnotherMilestoneInTemplateMutationResult = Apollo.MutationResult<MoveTaskGroupToAnotherMilestoneInTemplateMutation>;
export type MoveTaskGroupToAnotherMilestoneInTemplateMutationOptions = Apollo.BaseMutationOptions<MoveTaskGroupToAnotherMilestoneInTemplateMutation, MoveTaskGroupToAnotherMilestoneInTemplateMutationVariables>;
export const TemplateUseSortingUpdateTaskDocument = gql`
    mutation TemplateUseSorting_UpdateTask($input: updateTaskInput!) {
  updateTaskGroupTask(input: $input) {
    taskReturnData {
      task {
        name
      }
    }
  }
}
    `;
export type TemplateUseSortingUpdateTaskMutationFn = Apollo.MutationFunction<TemplateUseSortingUpdateTaskMutation, TemplateUseSortingUpdateTaskMutationVariables>;

/**
 * __useTemplateUseSortingUpdateTaskMutation__
 *
 * To run a mutation, you first call `useTemplateUseSortingUpdateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTemplateUseSortingUpdateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [templateUseSortingUpdateTaskMutation, { data, loading, error }] = useTemplateUseSortingUpdateTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTemplateUseSortingUpdateTaskMutation(baseOptions?: Apollo.MutationHookOptions<TemplateUseSortingUpdateTaskMutation, TemplateUseSortingUpdateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TemplateUseSortingUpdateTaskMutation, TemplateUseSortingUpdateTaskMutationVariables>(TemplateUseSortingUpdateTaskDocument, options);
      }
export type TemplateUseSortingUpdateTaskMutationHookResult = ReturnType<typeof useTemplateUseSortingUpdateTaskMutation>;
export type TemplateUseSortingUpdateTaskMutationResult = Apollo.MutationResult<TemplateUseSortingUpdateTaskMutation>;
export type TemplateUseSortingUpdateTaskMutationOptions = Apollo.BaseMutationOptions<TemplateUseSortingUpdateTaskMutation, TemplateUseSortingUpdateTaskMutationVariables>;
export const TemplateUseSortingUpdateMilestoneDocument = gql`
    mutation TemplateUseSorting_UpdateMilestone($milestone: updateTemplateMilestoneInput!) {
  updateTemplateMilestone(input: $milestone) {
    milestone {
      id
      sortOrder
    }
  }
}
    `;
export type TemplateUseSortingUpdateMilestoneMutationFn = Apollo.MutationFunction<TemplateUseSortingUpdateMilestoneMutation, TemplateUseSortingUpdateMilestoneMutationVariables>;

/**
 * __useTemplateUseSortingUpdateMilestoneMutation__
 *
 * To run a mutation, you first call `useTemplateUseSortingUpdateMilestoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTemplateUseSortingUpdateMilestoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [templateUseSortingUpdateMilestoneMutation, { data, loading, error }] = useTemplateUseSortingUpdateMilestoneMutation({
 *   variables: {
 *      milestone: // value for 'milestone'
 *   },
 * });
 */
export function useTemplateUseSortingUpdateMilestoneMutation(baseOptions?: Apollo.MutationHookOptions<TemplateUseSortingUpdateMilestoneMutation, TemplateUseSortingUpdateMilestoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TemplateUseSortingUpdateMilestoneMutation, TemplateUseSortingUpdateMilestoneMutationVariables>(TemplateUseSortingUpdateMilestoneDocument, options);
      }
export type TemplateUseSortingUpdateMilestoneMutationHookResult = ReturnType<typeof useTemplateUseSortingUpdateMilestoneMutation>;
export type TemplateUseSortingUpdateMilestoneMutationResult = Apollo.MutationResult<TemplateUseSortingUpdateMilestoneMutation>;
export type TemplateUseSortingUpdateMilestoneMutationOptions = Apollo.BaseMutationOptions<TemplateUseSortingUpdateMilestoneMutation, TemplateUseSortingUpdateMilestoneMutationVariables>;
export const TemplateUseSortingCheckDropEligibilityDocument = gql`
    query TemplateUseSorting_CheckDropEligibility($input: DropInput!) {
  dropEligibility(dropInputs: $input) {
    eligibility
    message
  }
}
    `;

/**
 * __useTemplateUseSortingCheckDropEligibilityQuery__
 *
 * To run a query within a React component, call `useTemplateUseSortingCheckDropEligibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateUseSortingCheckDropEligibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateUseSortingCheckDropEligibilityQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTemplateUseSortingCheckDropEligibilityQuery(baseOptions: Apollo.QueryHookOptions<TemplateUseSortingCheckDropEligibilityQuery, TemplateUseSortingCheckDropEligibilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplateUseSortingCheckDropEligibilityQuery, TemplateUseSortingCheckDropEligibilityQueryVariables>(TemplateUseSortingCheckDropEligibilityDocument, options);
      }
export function useTemplateUseSortingCheckDropEligibilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplateUseSortingCheckDropEligibilityQuery, TemplateUseSortingCheckDropEligibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplateUseSortingCheckDropEligibilityQuery, TemplateUseSortingCheckDropEligibilityQueryVariables>(TemplateUseSortingCheckDropEligibilityDocument, options);
        }
export type TemplateUseSortingCheckDropEligibilityQueryHookResult = ReturnType<typeof useTemplateUseSortingCheckDropEligibilityQuery>;
export type TemplateUseSortingCheckDropEligibilityLazyQueryHookResult = ReturnType<typeof useTemplateUseSortingCheckDropEligibilityLazyQuery>;
export type TemplateUseSortingCheckDropEligibilityQueryResult = Apollo.QueryResult<TemplateUseSortingCheckDropEligibilityQuery, TemplateUseSortingCheckDropEligibilityQueryVariables>;
export const ConnectedUsersUsersDocument = gql`
    query ConnectedUsers_Users($listInputs: ListInput!) {
  organizationConnectedUsers(listInputs: $listInputs) {
    pageInfo {
      ...PageInfoFragment
    }
    users {
      id
      ...ConnectedUserTableRow_User
    }
  }
}
    ${PageInfoFragmentDoc}
${ConnectedUserTableRowUserFragmentDoc}`;

/**
 * __useConnectedUsersUsersQuery__
 *
 * To run a query within a React component, call `useConnectedUsersUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectedUsersUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectedUsersUsersQuery({
 *   variables: {
 *      listInputs: // value for 'listInputs'
 *   },
 * });
 */
export function useConnectedUsersUsersQuery(baseOptions: Apollo.QueryHookOptions<ConnectedUsersUsersQuery, ConnectedUsersUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectedUsersUsersQuery, ConnectedUsersUsersQueryVariables>(ConnectedUsersUsersDocument, options);
      }
export function useConnectedUsersUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectedUsersUsersQuery, ConnectedUsersUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectedUsersUsersQuery, ConnectedUsersUsersQueryVariables>(ConnectedUsersUsersDocument, options);
        }
export type ConnectedUsersUsersQueryHookResult = ReturnType<typeof useConnectedUsersUsersQuery>;
export type ConnectedUsersUsersLazyQueryHookResult = ReturnType<typeof useConnectedUsersUsersLazyQuery>;
export type ConnectedUsersUsersQueryResult = Apollo.QueryResult<ConnectedUsersUsersQuery, ConnectedUsersUsersQueryVariables>;
export const ProjectReassignProjectManagersDocument = gql`
    query ProjectReassign_ProjectManagers($organizationId: ID!) {
  projectManagers(organizationId: $organizationId) {
    id
    ...UserMenuOption_UserWithCapacity
  }
}
    ${UserMenuOptionUserWithCapacityFragmentDoc}`;

/**
 * __useProjectReassignProjectManagersQuery__
 *
 * To run a query within a React component, call `useProjectReassignProjectManagersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectReassignProjectManagersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectReassignProjectManagersQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useProjectReassignProjectManagersQuery(baseOptions: Apollo.QueryHookOptions<ProjectReassignProjectManagersQuery, ProjectReassignProjectManagersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectReassignProjectManagersQuery, ProjectReassignProjectManagersQueryVariables>(ProjectReassignProjectManagersDocument, options);
      }
export function useProjectReassignProjectManagersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectReassignProjectManagersQuery, ProjectReassignProjectManagersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectReassignProjectManagersQuery, ProjectReassignProjectManagersQueryVariables>(ProjectReassignProjectManagersDocument, options);
        }
export type ProjectReassignProjectManagersQueryHookResult = ReturnType<typeof useProjectReassignProjectManagersQuery>;
export type ProjectReassignProjectManagersLazyQueryHookResult = ReturnType<typeof useProjectReassignProjectManagersLazyQuery>;
export type ProjectReassignProjectManagersQueryResult = Apollo.QueryResult<ProjectReassignProjectManagersQuery, ProjectReassignProjectManagersQueryVariables>;
export const ProjectReassignBulkProjectAssignmentMutationDocument = gql`
    mutation ProjectReassign_BulkProjectAssignmentMutation($projectsIds: [ID!]!, $projectManagerId: ID) {
  bulkAssignProjects(
    input: {projectsIds: $projectsIds, projectManagerId: $projectManagerId}
  ) {
    success
  }
}
    `;
export type ProjectReassignBulkProjectAssignmentMutationMutationFn = Apollo.MutationFunction<ProjectReassignBulkProjectAssignmentMutation, ProjectReassignBulkProjectAssignmentMutationVariables>;

/**
 * __useProjectReassignBulkProjectAssignmentMutation__
 *
 * To run a mutation, you first call `useProjectReassignBulkProjectAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectReassignBulkProjectAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectReassignBulkProjectAssignmentMutation, { data, loading, error }] = useProjectReassignBulkProjectAssignmentMutation({
 *   variables: {
 *      projectsIds: // value for 'projectsIds'
 *      projectManagerId: // value for 'projectManagerId'
 *   },
 * });
 */
export function useProjectReassignBulkProjectAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<ProjectReassignBulkProjectAssignmentMutation, ProjectReassignBulkProjectAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectReassignBulkProjectAssignmentMutation, ProjectReassignBulkProjectAssignmentMutationVariables>(ProjectReassignBulkProjectAssignmentMutationDocument, options);
      }
export type ProjectReassignBulkProjectAssignmentMutationHookResult = ReturnType<typeof useProjectReassignBulkProjectAssignmentMutation>;
export type ProjectReassignBulkProjectAssignmentMutationMutationResult = Apollo.MutationResult<ProjectReassignBulkProjectAssignmentMutation>;
export type ProjectReassignBulkProjectAssignmentMutationMutationOptions = Apollo.BaseMutationOptions<ProjectReassignBulkProjectAssignmentMutation, ProjectReassignBulkProjectAssignmentMutationVariables>;
export const TaskAssigneesPotentialTaskAssigneesDocument = gql`
    query TaskAssignees_PotentialTaskAssignees($milestoneId: ID!, $organizationId: ID, $projectId: ID) {
  potentialTaskAssignees(
    milestoneId: $milestoneId
    organizationId: $organizationId
    projectId: $projectId
  ) {
    id
    firstName
    lastName
    email
    projectContext
    role
    skills {
      id
    }
    organization {
      id
      type
      name
    }
    jobRole
    organizationName
    displayOrganization {
      name
    }
  }
}
    `;

/**
 * __useTaskAssigneesPotentialTaskAssigneesQuery__
 *
 * To run a query within a React component, call `useTaskAssigneesPotentialTaskAssigneesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskAssigneesPotentialTaskAssigneesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskAssigneesPotentialTaskAssigneesQuery({
 *   variables: {
 *      milestoneId: // value for 'milestoneId'
 *      organizationId: // value for 'organizationId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useTaskAssigneesPotentialTaskAssigneesQuery(baseOptions: Apollo.QueryHookOptions<TaskAssigneesPotentialTaskAssigneesQuery, TaskAssigneesPotentialTaskAssigneesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskAssigneesPotentialTaskAssigneesQuery, TaskAssigneesPotentialTaskAssigneesQueryVariables>(TaskAssigneesPotentialTaskAssigneesDocument, options);
      }
export function useTaskAssigneesPotentialTaskAssigneesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskAssigneesPotentialTaskAssigneesQuery, TaskAssigneesPotentialTaskAssigneesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskAssigneesPotentialTaskAssigneesQuery, TaskAssigneesPotentialTaskAssigneesQueryVariables>(TaskAssigneesPotentialTaskAssigneesDocument, options);
        }
export type TaskAssigneesPotentialTaskAssigneesQueryHookResult = ReturnType<typeof useTaskAssigneesPotentialTaskAssigneesQuery>;
export type TaskAssigneesPotentialTaskAssigneesLazyQueryHookResult = ReturnType<typeof useTaskAssigneesPotentialTaskAssigneesLazyQuery>;
export type TaskAssigneesPotentialTaskAssigneesQueryResult = Apollo.QueryResult<TaskAssigneesPotentialTaskAssigneesQuery, TaskAssigneesPotentialTaskAssigneesQueryVariables>;
export const TaskReassignProjectTeamDocument = gql`
    query TaskReassign_ProjectTeam($projectId: ID!) {
  projectTeam(projectId: $projectId) {
    id
    firstName
    lastName
    email
    jobRole
    avatar {
      originalUrl
    }
    organization {
      id
      name
    }
  }
}
    `;

/**
 * __useTaskReassignProjectTeamQuery__
 *
 * To run a query within a React component, call `useTaskReassignProjectTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskReassignProjectTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskReassignProjectTeamQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useTaskReassignProjectTeamQuery(baseOptions: Apollo.QueryHookOptions<TaskReassignProjectTeamQuery, TaskReassignProjectTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskReassignProjectTeamQuery, TaskReassignProjectTeamQueryVariables>(TaskReassignProjectTeamDocument, options);
      }
export function useTaskReassignProjectTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskReassignProjectTeamQuery, TaskReassignProjectTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskReassignProjectTeamQuery, TaskReassignProjectTeamQueryVariables>(TaskReassignProjectTeamDocument, options);
        }
export type TaskReassignProjectTeamQueryHookResult = ReturnType<typeof useTaskReassignProjectTeamQuery>;
export type TaskReassignProjectTeamLazyQueryHookResult = ReturnType<typeof useTaskReassignProjectTeamLazyQuery>;
export type TaskReassignProjectTeamQueryResult = Apollo.QueryResult<TaskReassignProjectTeamQuery, TaskReassignProjectTeamQueryVariables>;
export const WatchersPotentialTaskWatchersDocument = gql`
    query Watchers_PotentialTaskWatchers($taskId: ID!) {
  potentialTaskWatchers(taskId: $taskId) {
    id
    ...UserMenuOption_User
  }
}
    ${UserMenuOptionUserFragmentDoc}`;

/**
 * __useWatchersPotentialTaskWatchersQuery__
 *
 * To run a query within a React component, call `useWatchersPotentialTaskWatchersQuery` and pass it any options that fit your needs.
 * When your component renders, `useWatchersPotentialTaskWatchersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchersPotentialTaskWatchersQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useWatchersPotentialTaskWatchersQuery(baseOptions: Apollo.QueryHookOptions<WatchersPotentialTaskWatchersQuery, WatchersPotentialTaskWatchersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WatchersPotentialTaskWatchersQuery, WatchersPotentialTaskWatchersQueryVariables>(WatchersPotentialTaskWatchersDocument, options);
      }
export function useWatchersPotentialTaskWatchersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WatchersPotentialTaskWatchersQuery, WatchersPotentialTaskWatchersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WatchersPotentialTaskWatchersQuery, WatchersPotentialTaskWatchersQueryVariables>(WatchersPotentialTaskWatchersDocument, options);
        }
export type WatchersPotentialTaskWatchersQueryHookResult = ReturnType<typeof useWatchersPotentialTaskWatchersQuery>;
export type WatchersPotentialTaskWatchersLazyQueryHookResult = ReturnType<typeof useWatchersPotentialTaskWatchersLazyQuery>;
export type WatchersPotentialTaskWatchersQueryResult = Apollo.QueryResult<WatchersPotentialTaskWatchersQuery, WatchersPotentialTaskWatchersQueryVariables>;
export const WatchersWatchersQueryDocument = gql`
    query Watchers_WatchersQuery($taskId: ID!) {
  task(id: $taskId) {
    id
    watchers {
      id
    }
  }
}
    `;

/**
 * __useWatchersWatchersQuery__
 *
 * To run a query within a React component, call `useWatchersWatchersQuery` and pass it any options that fit your needs.
 * When your component renders, `useWatchersWatchersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchersWatchersQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useWatchersWatchersQuery(baseOptions: Apollo.QueryHookOptions<WatchersWatchersQuery, WatchersWatchersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WatchersWatchersQuery, WatchersWatchersQueryVariables>(WatchersWatchersQueryDocument, options);
      }
export function useWatchersWatchersQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WatchersWatchersQuery, WatchersWatchersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WatchersWatchersQuery, WatchersWatchersQueryVariables>(WatchersWatchersQueryDocument, options);
        }
export type WatchersWatchersQueryHookResult = ReturnType<typeof useWatchersWatchersQuery>;
export type WatchersWatchersQueryLazyQueryHookResult = ReturnType<typeof useWatchersWatchersQueryLazyQuery>;
export type WatchersWatchersQueryQueryResult = Apollo.QueryResult<WatchersWatchersQuery, WatchersWatchersQueryVariables>;
export const WatchersAddWatcherDocument = gql`
    mutation Watchers_AddWatcher($variables: addWatcherInput!) {
  addWatcher(input: $variables) {
    success
  }
}
    `;
export type WatchersAddWatcherMutationFn = Apollo.MutationFunction<WatchersAddWatcherMutation, WatchersAddWatcherMutationVariables>;

/**
 * __useWatchersAddWatcherMutation__
 *
 * To run a mutation, you first call `useWatchersAddWatcherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWatchersAddWatcherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [watchersAddWatcherMutation, { data, loading, error }] = useWatchersAddWatcherMutation({
 *   variables: {
 *      variables: // value for 'variables'
 *   },
 * });
 */
export function useWatchersAddWatcherMutation(baseOptions?: Apollo.MutationHookOptions<WatchersAddWatcherMutation, WatchersAddWatcherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WatchersAddWatcherMutation, WatchersAddWatcherMutationVariables>(WatchersAddWatcherDocument, options);
      }
export type WatchersAddWatcherMutationHookResult = ReturnType<typeof useWatchersAddWatcherMutation>;
export type WatchersAddWatcherMutationResult = Apollo.MutationResult<WatchersAddWatcherMutation>;
export type WatchersAddWatcherMutationOptions = Apollo.BaseMutationOptions<WatchersAddWatcherMutation, WatchersAddWatcherMutationVariables>;
export const WatchersRemoveWatcherDocument = gql`
    mutation Watchers_RemoveWatcher($variables: removeWatcherInput!) {
  removeWatcher(input: $variables) {
    success
  }
}
    `;
export type WatchersRemoveWatcherMutationFn = Apollo.MutationFunction<WatchersRemoveWatcherMutation, WatchersRemoveWatcherMutationVariables>;

/**
 * __useWatchersRemoveWatcherMutation__
 *
 * To run a mutation, you first call `useWatchersRemoveWatcherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWatchersRemoveWatcherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [watchersRemoveWatcherMutation, { data, loading, error }] = useWatchersRemoveWatcherMutation({
 *   variables: {
 *      variables: // value for 'variables'
 *   },
 * });
 */
export function useWatchersRemoveWatcherMutation(baseOptions?: Apollo.MutationHookOptions<WatchersRemoveWatcherMutation, WatchersRemoveWatcherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WatchersRemoveWatcherMutation, WatchersRemoveWatcherMutationVariables>(WatchersRemoveWatcherDocument, options);
      }
export type WatchersRemoveWatcherMutationHookResult = ReturnType<typeof useWatchersRemoveWatcherMutation>;
export type WatchersRemoveWatcherMutationResult = Apollo.MutationResult<WatchersRemoveWatcherMutation>;
export type WatchersRemoveWatcherMutationOptions = Apollo.BaseMutationOptions<WatchersRemoveWatcherMutation, WatchersRemoveWatcherMutationVariables>;
export const BrandViewBrandListDocument = gql`
    query BrandView_BrandList($listInputs: ListInput) {
  brands(listInputs: $listInputs) {
    id
    ...BrandTableRowTemplate
  }
}
    ${BrandTableRowTemplateFragmentDoc}`;

/**
 * __useBrandViewBrandListQuery__
 *
 * To run a query within a React component, call `useBrandViewBrandListQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandViewBrandListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandViewBrandListQuery({
 *   variables: {
 *      listInputs: // value for 'listInputs'
 *   },
 * });
 */
export function useBrandViewBrandListQuery(baseOptions?: Apollo.QueryHookOptions<BrandViewBrandListQuery, BrandViewBrandListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandViewBrandListQuery, BrandViewBrandListQueryVariables>(BrandViewBrandListDocument, options);
      }
export function useBrandViewBrandListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandViewBrandListQuery, BrandViewBrandListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandViewBrandListQuery, BrandViewBrandListQueryVariables>(BrandViewBrandListDocument, options);
        }
export type BrandViewBrandListQueryHookResult = ReturnType<typeof useBrandViewBrandListQuery>;
export type BrandViewBrandListLazyQueryHookResult = ReturnType<typeof useBrandViewBrandListLazyQuery>;
export type BrandViewBrandListQueryResult = Apollo.QueryResult<BrandViewBrandListQuery, BrandViewBrandListQueryVariables>;
export const BrandViewCreateBrandDocument = gql`
    mutation BrandView_CreateBrand($brand: createBrandInput!) {
  createBrand(input: $brand) {
    brand {
      id
      ...BrandTableRowTemplate
    }
  }
}
    ${BrandTableRowTemplateFragmentDoc}`;
export type BrandViewCreateBrandMutationFn = Apollo.MutationFunction<BrandViewCreateBrandMutation, BrandViewCreateBrandMutationVariables>;

/**
 * __useBrandViewCreateBrandMutation__
 *
 * To run a mutation, you first call `useBrandViewCreateBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandViewCreateBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandViewCreateBrandMutation, { data, loading, error }] = useBrandViewCreateBrandMutation({
 *   variables: {
 *      brand: // value for 'brand'
 *   },
 * });
 */
export function useBrandViewCreateBrandMutation(baseOptions?: Apollo.MutationHookOptions<BrandViewCreateBrandMutation, BrandViewCreateBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandViewCreateBrandMutation, BrandViewCreateBrandMutationVariables>(BrandViewCreateBrandDocument, options);
      }
export type BrandViewCreateBrandMutationHookResult = ReturnType<typeof useBrandViewCreateBrandMutation>;
export type BrandViewCreateBrandMutationResult = Apollo.MutationResult<BrandViewCreateBrandMutation>;
export type BrandViewCreateBrandMutationOptions = Apollo.BaseMutationOptions<BrandViewCreateBrandMutation, BrandViewCreateBrandMutationVariables>;
export const BrandViewUpdateBrandDocument = gql`
    mutation BrandView_UpdateBrand($brand: updateBrandInput!) {
  updateBrand(input: $brand) {
    brand {
      id
      ...BrandTableRowTemplate
    }
  }
}
    ${BrandTableRowTemplateFragmentDoc}`;
export type BrandViewUpdateBrandMutationFn = Apollo.MutationFunction<BrandViewUpdateBrandMutation, BrandViewUpdateBrandMutationVariables>;

/**
 * __useBrandViewUpdateBrandMutation__
 *
 * To run a mutation, you first call `useBrandViewUpdateBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandViewUpdateBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandViewUpdateBrandMutation, { data, loading, error }] = useBrandViewUpdateBrandMutation({
 *   variables: {
 *      brand: // value for 'brand'
 *   },
 * });
 */
export function useBrandViewUpdateBrandMutation(baseOptions?: Apollo.MutationHookOptions<BrandViewUpdateBrandMutation, BrandViewUpdateBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandViewUpdateBrandMutation, BrandViewUpdateBrandMutationVariables>(BrandViewUpdateBrandDocument, options);
      }
export type BrandViewUpdateBrandMutationHookResult = ReturnType<typeof useBrandViewUpdateBrandMutation>;
export type BrandViewUpdateBrandMutationResult = Apollo.MutationResult<BrandViewUpdateBrandMutation>;
export type BrandViewUpdateBrandMutationOptions = Apollo.BaseMutationOptions<BrandViewUpdateBrandMutation, BrandViewUpdateBrandMutationVariables>;
export const RemoveBrandDialogDeleteBrandDocument = gql`
    mutation RemoveBrandDialog_DeleteBrand($id: ID!) {
  deleteBrand(input: {id: $id}) {
    success
  }
}
    `;
export type RemoveBrandDialogDeleteBrandMutationFn = Apollo.MutationFunction<RemoveBrandDialogDeleteBrandMutation, RemoveBrandDialogDeleteBrandMutationVariables>;

/**
 * __useRemoveBrandDialogDeleteBrandMutation__
 *
 * To run a mutation, you first call `useRemoveBrandDialogDeleteBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveBrandDialogDeleteBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeBrandDialogDeleteBrandMutation, { data, loading, error }] = useRemoveBrandDialogDeleteBrandMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveBrandDialogDeleteBrandMutation(baseOptions?: Apollo.MutationHookOptions<RemoveBrandDialogDeleteBrandMutation, RemoveBrandDialogDeleteBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveBrandDialogDeleteBrandMutation, RemoveBrandDialogDeleteBrandMutationVariables>(RemoveBrandDialogDeleteBrandDocument, options);
      }
export type RemoveBrandDialogDeleteBrandMutationHookResult = ReturnType<typeof useRemoveBrandDialogDeleteBrandMutation>;
export type RemoveBrandDialogDeleteBrandMutationResult = Apollo.MutationResult<RemoveBrandDialogDeleteBrandMutation>;
export type RemoveBrandDialogDeleteBrandMutationOptions = Apollo.BaseMutationOptions<RemoveBrandDialogDeleteBrandMutation, RemoveBrandDialogDeleteBrandMutationVariables>;
export const MyFiltersButtonUserProjectFilterViewsDocument = gql`
    query MyFiltersButton_UserProjectFilterViews($category: String!) {
  userFilterViews(category: $category) {
    id
    name
    jsonFilterBlob
    category
    isDefault
    customers {
      id
      name
    }
  }
}
    `;

/**
 * __useMyFiltersButtonUserProjectFilterViewsQuery__
 *
 * To run a query within a React component, call `useMyFiltersButtonUserProjectFilterViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyFiltersButtonUserProjectFilterViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyFiltersButtonUserProjectFilterViewsQuery({
 *   variables: {
 *      category: // value for 'category'
 *   },
 * });
 */
export function useMyFiltersButtonUserProjectFilterViewsQuery(baseOptions: Apollo.QueryHookOptions<MyFiltersButtonUserProjectFilterViewsQuery, MyFiltersButtonUserProjectFilterViewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyFiltersButtonUserProjectFilterViewsQuery, MyFiltersButtonUserProjectFilterViewsQueryVariables>(MyFiltersButtonUserProjectFilterViewsDocument, options);
      }
export function useMyFiltersButtonUserProjectFilterViewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyFiltersButtonUserProjectFilterViewsQuery, MyFiltersButtonUserProjectFilterViewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyFiltersButtonUserProjectFilterViewsQuery, MyFiltersButtonUserProjectFilterViewsQueryVariables>(MyFiltersButtonUserProjectFilterViewsDocument, options);
        }
export type MyFiltersButtonUserProjectFilterViewsQueryHookResult = ReturnType<typeof useMyFiltersButtonUserProjectFilterViewsQuery>;
export type MyFiltersButtonUserProjectFilterViewsLazyQueryHookResult = ReturnType<typeof useMyFiltersButtonUserProjectFilterViewsLazyQuery>;
export type MyFiltersButtonUserProjectFilterViewsQueryResult = Apollo.QueryResult<MyFiltersButtonUserProjectFilterViewsQuery, MyFiltersButtonUserProjectFilterViewsQueryVariables>;
export const ConfirmDeleteFilterDialogDeleteFilterViewDocument = gql`
    mutation ConfirmDeleteFilterDialog_DeleteFilterView($input: deleteUserFilterViewInput!) {
  deleteFilterView(input: $input) {
    success
  }
}
    `;
export type ConfirmDeleteFilterDialogDeleteFilterViewMutationFn = Apollo.MutationFunction<ConfirmDeleteFilterDialogDeleteFilterViewMutation, ConfirmDeleteFilterDialogDeleteFilterViewMutationVariables>;

/**
 * __useConfirmDeleteFilterDialogDeleteFilterViewMutation__
 *
 * To run a mutation, you first call `useConfirmDeleteFilterDialogDeleteFilterViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmDeleteFilterDialogDeleteFilterViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmDeleteFilterDialogDeleteFilterViewMutation, { data, loading, error }] = useConfirmDeleteFilterDialogDeleteFilterViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmDeleteFilterDialogDeleteFilterViewMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmDeleteFilterDialogDeleteFilterViewMutation, ConfirmDeleteFilterDialogDeleteFilterViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmDeleteFilterDialogDeleteFilterViewMutation, ConfirmDeleteFilterDialogDeleteFilterViewMutationVariables>(ConfirmDeleteFilterDialogDeleteFilterViewDocument, options);
      }
export type ConfirmDeleteFilterDialogDeleteFilterViewMutationHookResult = ReturnType<typeof useConfirmDeleteFilterDialogDeleteFilterViewMutation>;
export type ConfirmDeleteFilterDialogDeleteFilterViewMutationResult = Apollo.MutationResult<ConfirmDeleteFilterDialogDeleteFilterViewMutation>;
export type ConfirmDeleteFilterDialogDeleteFilterViewMutationOptions = Apollo.BaseMutationOptions<ConfirmDeleteFilterDialogDeleteFilterViewMutation, ConfirmDeleteFilterDialogDeleteFilterViewMutationVariables>;
export const FilterMenuItemToggleDefaultFilterDocument = gql`
    mutation FilterMenuItem_ToggleDefaultFilter($input: changeDefaultUserFilterInput!) {
  changeDefaultUserFilter(input: $input) {
    userFilterViews {
      id
      name
      isDefault
    }
  }
}
    `;
export type FilterMenuItemToggleDefaultFilterMutationFn = Apollo.MutationFunction<FilterMenuItemToggleDefaultFilterMutation, FilterMenuItemToggleDefaultFilterMutationVariables>;

/**
 * __useFilterMenuItemToggleDefaultFilterMutation__
 *
 * To run a mutation, you first call `useFilterMenuItemToggleDefaultFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFilterMenuItemToggleDefaultFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [filterMenuItemToggleDefaultFilterMutation, { data, loading, error }] = useFilterMenuItemToggleDefaultFilterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFilterMenuItemToggleDefaultFilterMutation(baseOptions?: Apollo.MutationHookOptions<FilterMenuItemToggleDefaultFilterMutation, FilterMenuItemToggleDefaultFilterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FilterMenuItemToggleDefaultFilterMutation, FilterMenuItemToggleDefaultFilterMutationVariables>(FilterMenuItemToggleDefaultFilterDocument, options);
      }
export type FilterMenuItemToggleDefaultFilterMutationHookResult = ReturnType<typeof useFilterMenuItemToggleDefaultFilterMutation>;
export type FilterMenuItemToggleDefaultFilterMutationResult = Apollo.MutationResult<FilterMenuItemToggleDefaultFilterMutation>;
export type FilterMenuItemToggleDefaultFilterMutationOptions = Apollo.BaseMutationOptions<FilterMenuItemToggleDefaultFilterMutation, FilterMenuItemToggleDefaultFilterMutationVariables>;
export const AddUserDrawerOrganizationDocument = gql`
    query AddUserDrawer_Organization($id: ID!) {
  organization(id: $id) {
    id
    ...AddUserForm_Organization
  }
}
    ${AddUserFormOrganizationFragmentDoc}`;

/**
 * __useAddUserDrawerOrganizationQuery__
 *
 * To run a query within a React component, call `useAddUserDrawerOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddUserDrawerOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddUserDrawerOrganizationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAddUserDrawerOrganizationQuery(baseOptions: Apollo.QueryHookOptions<AddUserDrawerOrganizationQuery, AddUserDrawerOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddUserDrawerOrganizationQuery, AddUserDrawerOrganizationQueryVariables>(AddUserDrawerOrganizationDocument, options);
      }
export function useAddUserDrawerOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddUserDrawerOrganizationQuery, AddUserDrawerOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddUserDrawerOrganizationQuery, AddUserDrawerOrganizationQueryVariables>(AddUserDrawerOrganizationDocument, options);
        }
export type AddUserDrawerOrganizationQueryHookResult = ReturnType<typeof useAddUserDrawerOrganizationQuery>;
export type AddUserDrawerOrganizationLazyQueryHookResult = ReturnType<typeof useAddUserDrawerOrganizationLazyQuery>;
export type AddUserDrawerOrganizationQueryResult = Apollo.QueryResult<AddUserDrawerOrganizationQuery, AddUserDrawerOrganizationQueryVariables>;
export const AddUserDrawerInviteUserToOrganizationDocument = gql`
    mutation AddUserDrawer_InviteUserToOrganization($user: inviteUserToOrganizationInput!) {
  inviteUserToOrganization(input: $user) {
    user {
      id
      firstName
      lastName
      email
      role
    }
  }
}
    `;
export type AddUserDrawerInviteUserToOrganizationMutationFn = Apollo.MutationFunction<AddUserDrawerInviteUserToOrganizationMutation, AddUserDrawerInviteUserToOrganizationMutationVariables>;

/**
 * __useAddUserDrawerInviteUserToOrganizationMutation__
 *
 * To run a mutation, you first call `useAddUserDrawerInviteUserToOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserDrawerInviteUserToOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserDrawerInviteUserToOrganizationMutation, { data, loading, error }] = useAddUserDrawerInviteUserToOrganizationMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useAddUserDrawerInviteUserToOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<AddUserDrawerInviteUserToOrganizationMutation, AddUserDrawerInviteUserToOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserDrawerInviteUserToOrganizationMutation, AddUserDrawerInviteUserToOrganizationMutationVariables>(AddUserDrawerInviteUserToOrganizationDocument, options);
      }
export type AddUserDrawerInviteUserToOrganizationMutationHookResult = ReturnType<typeof useAddUserDrawerInviteUserToOrganizationMutation>;
export type AddUserDrawerInviteUserToOrganizationMutationResult = Apollo.MutationResult<AddUserDrawerInviteUserToOrganizationMutation>;
export type AddUserDrawerInviteUserToOrganizationMutationOptions = Apollo.BaseMutationOptions<AddUserDrawerInviteUserToOrganizationMutation, AddUserDrawerInviteUserToOrganizationMutationVariables>;
export const CompanyIndexOrganizationsDocument = gql`
    query CompanyIndex_Organizations($listInputs: ListInput) {
  organizationConnections(listInputs: $listInputs) {
    pageInfo {
      ...PageInfoFragment
    }
    organizations {
      id
      logo {
        originalUrl
      }
      ...OrganizationTableRowOrganization
    }
  }
}
    ${PageInfoFragmentDoc}
${OrganizationTableRowOrganizationFragmentDoc}`;

/**
 * __useCompanyIndexOrganizationsQuery__
 *
 * To run a query within a React component, call `useCompanyIndexOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyIndexOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyIndexOrganizationsQuery({
 *   variables: {
 *      listInputs: // value for 'listInputs'
 *   },
 * });
 */
export function useCompanyIndexOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<CompanyIndexOrganizationsQuery, CompanyIndexOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyIndexOrganizationsQuery, CompanyIndexOrganizationsQueryVariables>(CompanyIndexOrganizationsDocument, options);
      }
export function useCompanyIndexOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyIndexOrganizationsQuery, CompanyIndexOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyIndexOrganizationsQuery, CompanyIndexOrganizationsQueryVariables>(CompanyIndexOrganizationsDocument, options);
        }
export type CompanyIndexOrganizationsQueryHookResult = ReturnType<typeof useCompanyIndexOrganizationsQuery>;
export type CompanyIndexOrganizationsLazyQueryHookResult = ReturnType<typeof useCompanyIndexOrganizationsLazyQuery>;
export type CompanyIndexOrganizationsQueryResult = Apollo.QueryResult<CompanyIndexOrganizationsQuery, CompanyIndexOrganizationsQueryVariables>;
export const CompanyIndexCreateOrganizationDocument = gql`
    mutation CompanyIndex_CreateOrganization($organization: createOrganizationInput!) {
  createOrganization(input: $organization) {
    organization {
      id
      logo {
        originalUrl
      }
      ...OrganizationTableRowOrganization
    }
  }
}
    ${OrganizationTableRowOrganizationFragmentDoc}`;
export type CompanyIndexCreateOrganizationMutationFn = Apollo.MutationFunction<CompanyIndexCreateOrganizationMutation, CompanyIndexCreateOrganizationMutationVariables>;

/**
 * __useCompanyIndexCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCompanyIndexCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyIndexCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyIndexCreateOrganizationMutation, { data, loading, error }] = useCompanyIndexCreateOrganizationMutation({
 *   variables: {
 *      organization: // value for 'organization'
 *   },
 * });
 */
export function useCompanyIndexCreateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<CompanyIndexCreateOrganizationMutation, CompanyIndexCreateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanyIndexCreateOrganizationMutation, CompanyIndexCreateOrganizationMutationVariables>(CompanyIndexCreateOrganizationDocument, options);
      }
export type CompanyIndexCreateOrganizationMutationHookResult = ReturnType<typeof useCompanyIndexCreateOrganizationMutation>;
export type CompanyIndexCreateOrganizationMutationResult = Apollo.MutationResult<CompanyIndexCreateOrganizationMutation>;
export type CompanyIndexCreateOrganizationMutationOptions = Apollo.BaseMutationOptions<CompanyIndexCreateOrganizationMutation, CompanyIndexCreateOrganizationMutationVariables>;
export const CreateBillingProfileDocument = gql`
    mutation CreateBillingProfile($input: createBillingProfileInput!) {
  createBillingProfile(input: $input) {
    billingProfile {
      id
      name
    }
  }
}
    `;
export type CreateBillingProfileMutationFn = Apollo.MutationFunction<CreateBillingProfileMutation, CreateBillingProfileMutationVariables>;

/**
 * __useCreateBillingProfileMutation__
 *
 * To run a mutation, you first call `useCreateBillingProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBillingProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBillingProfileMutation, { data, loading, error }] = useCreateBillingProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBillingProfileMutation(baseOptions?: Apollo.MutationHookOptions<CreateBillingProfileMutation, CreateBillingProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBillingProfileMutation, CreateBillingProfileMutationVariables>(CreateBillingProfileDocument, options);
      }
export type CreateBillingProfileMutationHookResult = ReturnType<typeof useCreateBillingProfileMutation>;
export type CreateBillingProfileMutationResult = Apollo.MutationResult<CreateBillingProfileMutation>;
export type CreateBillingProfileMutationOptions = Apollo.BaseMutationOptions<CreateBillingProfileMutation, CreateBillingProfileMutationVariables>;
export const UpdateBillingProfileDocument = gql`
    mutation UpdateBillingProfile($input: updateBillingProfileInput!) {
  updateBillingProfile(input: $input) {
    billingProfile {
      id
      name
    }
  }
}
    `;
export type UpdateBillingProfileMutationFn = Apollo.MutationFunction<UpdateBillingProfileMutation, UpdateBillingProfileMutationVariables>;

/**
 * __useUpdateBillingProfileMutation__
 *
 * To run a mutation, you first call `useUpdateBillingProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBillingProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBillingProfileMutation, { data, loading, error }] = useUpdateBillingProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBillingProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBillingProfileMutation, UpdateBillingProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBillingProfileMutation, UpdateBillingProfileMutationVariables>(UpdateBillingProfileDocument, options);
      }
export type UpdateBillingProfileMutationHookResult = ReturnType<typeof useUpdateBillingProfileMutation>;
export type UpdateBillingProfileMutationResult = Apollo.MutationResult<UpdateBillingProfileMutation>;
export type UpdateBillingProfileMutationOptions = Apollo.BaseMutationOptions<UpdateBillingProfileMutation, UpdateBillingProfileMutationVariables>;
export const DeleteBillingProfileDocument = gql`
    mutation DeleteBillingProfile($input: deleteBillingProfileInput!) {
  deleteBillingProfile(input: $input) {
    success
  }
}
    `;
export type DeleteBillingProfileMutationFn = Apollo.MutationFunction<DeleteBillingProfileMutation, DeleteBillingProfileMutationVariables>;

/**
 * __useDeleteBillingProfileMutation__
 *
 * To run a mutation, you first call `useDeleteBillingProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBillingProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBillingProfileMutation, { data, loading, error }] = useDeleteBillingProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteBillingProfileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBillingProfileMutation, DeleteBillingProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBillingProfileMutation, DeleteBillingProfileMutationVariables>(DeleteBillingProfileDocument, options);
      }
export type DeleteBillingProfileMutationHookResult = ReturnType<typeof useDeleteBillingProfileMutation>;
export type DeleteBillingProfileMutationResult = Apollo.MutationResult<DeleteBillingProfileMutation>;
export type DeleteBillingProfileMutationOptions = Apollo.BaseMutationOptions<DeleteBillingProfileMutation, DeleteBillingProfileMutationVariables>;
export const BillingProfilesDocument = gql`
    query BillingProfiles($listInputs: ListInput!) {
  billingProfileConnections(listInputs: $listInputs) {
    billingProfiles {
      allottedHours
      allowOverages
      description
      dollars
      name
      rateType
      secondaryDollars
      secondaryRateType
      id
    }
    pageInfo {
      ...PageInfoFragment
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useBillingProfilesQuery__
 *
 * To run a query within a React component, call `useBillingProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingProfilesQuery({
 *   variables: {
 *      listInputs: // value for 'listInputs'
 *   },
 * });
 */
export function useBillingProfilesQuery(baseOptions: Apollo.QueryHookOptions<BillingProfilesQuery, BillingProfilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillingProfilesQuery, BillingProfilesQueryVariables>(BillingProfilesDocument, options);
      }
export function useBillingProfilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillingProfilesQuery, BillingProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillingProfilesQuery, BillingProfilesQueryVariables>(BillingProfilesDocument, options);
        }
export type BillingProfilesQueryHookResult = ReturnType<typeof useBillingProfilesQuery>;
export type BillingProfilesLazyQueryHookResult = ReturnType<typeof useBillingProfilesLazyQuery>;
export type BillingProfilesQueryResult = Apollo.QueryResult<BillingProfilesQuery, BillingProfilesQueryVariables>;
export const ValidateBillingProfileNameDocument = gql`
    query ValidateBillingProfileName($name: String!) {
  billingProfileNameExists(name: $name) {
    exists
  }
}
    `;

/**
 * __useValidateBillingProfileNameQuery__
 *
 * To run a query within a React component, call `useValidateBillingProfileNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateBillingProfileNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateBillingProfileNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useValidateBillingProfileNameQuery(baseOptions: Apollo.QueryHookOptions<ValidateBillingProfileNameQuery, ValidateBillingProfileNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateBillingProfileNameQuery, ValidateBillingProfileNameQueryVariables>(ValidateBillingProfileNameDocument, options);
      }
export function useValidateBillingProfileNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateBillingProfileNameQuery, ValidateBillingProfileNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateBillingProfileNameQuery, ValidateBillingProfileNameQueryVariables>(ValidateBillingProfileNameDocument, options);
        }
export type ValidateBillingProfileNameQueryHookResult = ReturnType<typeof useValidateBillingProfileNameQuery>;
export type ValidateBillingProfileNameLazyQueryHookResult = ReturnType<typeof useValidateBillingProfileNameLazyQuery>;
export type ValidateBillingProfileNameQueryResult = Apollo.QueryResult<ValidateBillingProfileNameQuery, ValidateBillingProfileNameQueryVariables>;
export const DeleteTimeCategoryDialogDeleteCategoryMutationDocument = gql`
    mutation DeleteTimeCategoryDialog_DeleteCategoryMutation($id: ID!) {
  deleteTimeTrackingCategory(id: $id) {
    success
  }
}
    `;
export type DeleteTimeCategoryDialogDeleteCategoryMutationMutationFn = Apollo.MutationFunction<DeleteTimeCategoryDialogDeleteCategoryMutation, DeleteTimeCategoryDialogDeleteCategoryMutationVariables>;

/**
 * __useDeleteTimeCategoryDialogDeleteCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteTimeCategoryDialogDeleteCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTimeCategoryDialogDeleteCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTimeCategoryDialogDeleteCategoryMutation, { data, loading, error }] = useDeleteTimeCategoryDialogDeleteCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTimeCategoryDialogDeleteCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTimeCategoryDialogDeleteCategoryMutation, DeleteTimeCategoryDialogDeleteCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTimeCategoryDialogDeleteCategoryMutation, DeleteTimeCategoryDialogDeleteCategoryMutationVariables>(DeleteTimeCategoryDialogDeleteCategoryMutationDocument, options);
      }
export type DeleteTimeCategoryDialogDeleteCategoryMutationHookResult = ReturnType<typeof useDeleteTimeCategoryDialogDeleteCategoryMutation>;
export type DeleteTimeCategoryDialogDeleteCategoryMutationMutationResult = Apollo.MutationResult<DeleteTimeCategoryDialogDeleteCategoryMutation>;
export type DeleteTimeCategoryDialogDeleteCategoryMutationMutationOptions = Apollo.BaseMutationOptions<DeleteTimeCategoryDialogDeleteCategoryMutation, DeleteTimeCategoryDialogDeleteCategoryMutationVariables>;
export const GlobalTimeTrackingCategoriesOrganizationDocument = gql`
    query GlobalTimeTrackingCategories_Organization($organizationId: ID!, $listInputs: ListInput!) {
  organization(id: $organizationId) {
    timeTrackingCategoryConnections(listInputs: $listInputs) {
      pageInfo {
        totalPages
        totalResults
        currentPage
        limit
        isOutOfBounds
      }
      categories {
        ...GlobalTimeTrackingCategories_Category
      }
    }
  }
}
    ${GlobalTimeTrackingCategoriesCategoryFragmentDoc}`;

/**
 * __useGlobalTimeTrackingCategoriesOrganizationQuery__
 *
 * To run a query within a React component, call `useGlobalTimeTrackingCategoriesOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalTimeTrackingCategoriesOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalTimeTrackingCategoriesOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      listInputs: // value for 'listInputs'
 *   },
 * });
 */
export function useGlobalTimeTrackingCategoriesOrganizationQuery(baseOptions: Apollo.QueryHookOptions<GlobalTimeTrackingCategoriesOrganizationQuery, GlobalTimeTrackingCategoriesOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GlobalTimeTrackingCategoriesOrganizationQuery, GlobalTimeTrackingCategoriesOrganizationQueryVariables>(GlobalTimeTrackingCategoriesOrganizationDocument, options);
      }
export function useGlobalTimeTrackingCategoriesOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlobalTimeTrackingCategoriesOrganizationQuery, GlobalTimeTrackingCategoriesOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GlobalTimeTrackingCategoriesOrganizationQuery, GlobalTimeTrackingCategoriesOrganizationQueryVariables>(GlobalTimeTrackingCategoriesOrganizationDocument, options);
        }
export type GlobalTimeTrackingCategoriesOrganizationQueryHookResult = ReturnType<typeof useGlobalTimeTrackingCategoriesOrganizationQuery>;
export type GlobalTimeTrackingCategoriesOrganizationLazyQueryHookResult = ReturnType<typeof useGlobalTimeTrackingCategoriesOrganizationLazyQuery>;
export type GlobalTimeTrackingCategoriesOrganizationQueryResult = Apollo.QueryResult<GlobalTimeTrackingCategoriesOrganizationQuery, GlobalTimeTrackingCategoriesOrganizationQueryVariables>;
export const CompanyUsersUsersDocument = gql`
    query CompanyUsers_Users($organizationId: ID!, $listInputs: ListInput, $userState: String) {
  organization(id: $organizationId) {
    id
    timeTrackingEnabled
    adminUsersCount
    pmUsersCount
    guideUsersCount
    contributorUsersCount
    taskOwnerUsersCount
    managerUsersCount
    maxBillableUsers
    billableUsersCount
    type
    paginatedUsers(listInputs: $listInputs, userState: $userState) {
      pageInfo {
        ...PageInfoFragment
      }
      users {
        id
        ...UserTableRowUser
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${UserTableRowUserFragmentDoc}`;

/**
 * __useCompanyUsersUsersQuery__
 *
 * To run a query within a React component, call `useCompanyUsersUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyUsersUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyUsersUsersQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      listInputs: // value for 'listInputs'
 *      userState: // value for 'userState'
 *   },
 * });
 */
export function useCompanyUsersUsersQuery(baseOptions: Apollo.QueryHookOptions<CompanyUsersUsersQuery, CompanyUsersUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyUsersUsersQuery, CompanyUsersUsersQueryVariables>(CompanyUsersUsersDocument, options);
      }
export function useCompanyUsersUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyUsersUsersQuery, CompanyUsersUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyUsersUsersQuery, CompanyUsersUsersQueryVariables>(CompanyUsersUsersDocument, options);
        }
export type CompanyUsersUsersQueryHookResult = ReturnType<typeof useCompanyUsersUsersQuery>;
export type CompanyUsersUsersLazyQueryHookResult = ReturnType<typeof useCompanyUsersUsersLazyQuery>;
export type CompanyUsersUsersQueryResult = Apollo.QueryResult<CompanyUsersUsersQuery, CompanyUsersUsersQueryVariables>;
export const ConnectHubSpotDocument = gql`
    mutation ConnectHubSpot($organizationId: ID!, $code: String!) {
  connectHubSpot(input: {organizationId: $organizationId, code: $code}) {
    organization {
      id
      hubSpotIntegration {
        id
        hubSpotPortalId
      }
    }
  }
}
    `;
export type ConnectHubSpotMutationFn = Apollo.MutationFunction<ConnectHubSpotMutation, ConnectHubSpotMutationVariables>;

/**
 * __useConnectHubSpotMutation__
 *
 * To run a mutation, you first call `useConnectHubSpotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectHubSpotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectHubSpotMutation, { data, loading, error }] = useConnectHubSpotMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useConnectHubSpotMutation(baseOptions?: Apollo.MutationHookOptions<ConnectHubSpotMutation, ConnectHubSpotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectHubSpotMutation, ConnectHubSpotMutationVariables>(ConnectHubSpotDocument, options);
      }
export type ConnectHubSpotMutationHookResult = ReturnType<typeof useConnectHubSpotMutation>;
export type ConnectHubSpotMutationResult = Apollo.MutationResult<ConnectHubSpotMutation>;
export type ConnectHubSpotMutationOptions = Apollo.BaseMutationOptions<ConnectHubSpotMutation, ConnectHubSpotMutationVariables>;
export const ConnectSalesforceDocument = gql`
    mutation ConnectSalesforce($organizationId: ID!, $code: String!, $host: SalesforceHostEnum) {
  connectSalesforce(
    input: {organizationId: $organizationId, code: $code, host: $host}
  ) {
    organization {
      id
      salesforceIntegration {
        id
        username
        organizationName
      }
    }
  }
}
    `;
export type ConnectSalesforceMutationFn = Apollo.MutationFunction<ConnectSalesforceMutation, ConnectSalesforceMutationVariables>;

/**
 * __useConnectSalesforceMutation__
 *
 * To run a mutation, you first call `useConnectSalesforceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectSalesforceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectSalesforceMutation, { data, loading, error }] = useConnectSalesforceMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      code: // value for 'code'
 *      host: // value for 'host'
 *   },
 * });
 */
export function useConnectSalesforceMutation(baseOptions?: Apollo.MutationHookOptions<ConnectSalesforceMutation, ConnectSalesforceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectSalesforceMutation, ConnectSalesforceMutationVariables>(ConnectSalesforceDocument, options);
      }
export type ConnectSalesforceMutationHookResult = ReturnType<typeof useConnectSalesforceMutation>;
export type ConnectSalesforceMutationResult = Apollo.MutationResult<ConnectSalesforceMutation>;
export type ConnectSalesforceMutationOptions = Apollo.BaseMutationOptions<ConnectSalesforceMutation, ConnectSalesforceMutationVariables>;
export const ConnectSalesforcePollStatusDocument = gql`
    query ConnectSalesforce_PollStatus($organizationId: ID!) {
  getSalesforcePackageInstallationStatus(organizationId: $organizationId) {
    status
  }
}
    `;

/**
 * __useConnectSalesforcePollStatusQuery__
 *
 * To run a query within a React component, call `useConnectSalesforcePollStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectSalesforcePollStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectSalesforcePollStatusQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useConnectSalesforcePollStatusQuery(baseOptions: Apollo.QueryHookOptions<ConnectSalesforcePollStatusQuery, ConnectSalesforcePollStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectSalesforcePollStatusQuery, ConnectSalesforcePollStatusQueryVariables>(ConnectSalesforcePollStatusDocument, options);
      }
export function useConnectSalesforcePollStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectSalesforcePollStatusQuery, ConnectSalesforcePollStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectSalesforcePollStatusQuery, ConnectSalesforcePollStatusQueryVariables>(ConnectSalesforcePollStatusDocument, options);
        }
export type ConnectSalesforcePollStatusQueryHookResult = ReturnType<typeof useConnectSalesforcePollStatusQuery>;
export type ConnectSalesforcePollStatusLazyQueryHookResult = ReturnType<typeof useConnectSalesforcePollStatusLazyQuery>;
export type ConnectSalesforcePollStatusQueryResult = Apollo.QueryResult<ConnectSalesforcePollStatusQuery, ConnectSalesforcePollStatusQueryVariables>;
export const EditCompanyDrawerOrganizationDocument = gql`
    query EditCompanyDrawer_Organization($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    ...OrganizationForm_Organization
  }
}
    ${OrganizationFormOrganizationFragmentDoc}`;

/**
 * __useEditCompanyDrawerOrganizationQuery__
 *
 * To run a query within a React component, call `useEditCompanyDrawerOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditCompanyDrawerOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditCompanyDrawerOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useEditCompanyDrawerOrganizationQuery(baseOptions: Apollo.QueryHookOptions<EditCompanyDrawerOrganizationQuery, EditCompanyDrawerOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditCompanyDrawerOrganizationQuery, EditCompanyDrawerOrganizationQueryVariables>(EditCompanyDrawerOrganizationDocument, options);
      }
export function useEditCompanyDrawerOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditCompanyDrawerOrganizationQuery, EditCompanyDrawerOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditCompanyDrawerOrganizationQuery, EditCompanyDrawerOrganizationQueryVariables>(EditCompanyDrawerOrganizationDocument, options);
        }
export type EditCompanyDrawerOrganizationQueryHookResult = ReturnType<typeof useEditCompanyDrawerOrganizationQuery>;
export type EditCompanyDrawerOrganizationLazyQueryHookResult = ReturnType<typeof useEditCompanyDrawerOrganizationLazyQuery>;
export type EditCompanyDrawerOrganizationQueryResult = Apollo.QueryResult<EditCompanyDrawerOrganizationQuery, EditCompanyDrawerOrganizationQueryVariables>;
export const EditCompanyDrawerUpdateOrganizationDocument = gql`
    mutation EditCompanyDrawer_UpdateOrganization($input: updateOrganizationInput!) {
  updateOrganization(input: $input) {
    organization {
      id
      ...OrganizationForm_Organization
    }
  }
}
    ${OrganizationFormOrganizationFragmentDoc}`;
export type EditCompanyDrawerUpdateOrganizationMutationFn = Apollo.MutationFunction<EditCompanyDrawerUpdateOrganizationMutation, EditCompanyDrawerUpdateOrganizationMutationVariables>;

/**
 * __useEditCompanyDrawerUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useEditCompanyDrawerUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCompanyDrawerUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCompanyDrawerUpdateOrganizationMutation, { data, loading, error }] = useEditCompanyDrawerUpdateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditCompanyDrawerUpdateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<EditCompanyDrawerUpdateOrganizationMutation, EditCompanyDrawerUpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCompanyDrawerUpdateOrganizationMutation, EditCompanyDrawerUpdateOrganizationMutationVariables>(EditCompanyDrawerUpdateOrganizationDocument, options);
      }
export type EditCompanyDrawerUpdateOrganizationMutationHookResult = ReturnType<typeof useEditCompanyDrawerUpdateOrganizationMutation>;
export type EditCompanyDrawerUpdateOrganizationMutationResult = Apollo.MutationResult<EditCompanyDrawerUpdateOrganizationMutation>;
export type EditCompanyDrawerUpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<EditCompanyDrawerUpdateOrganizationMutation, EditCompanyDrawerUpdateOrganizationMutationVariables>;
export const HubSpotIntegrationGetOAuthHubSpotLinkDocument = gql`
    query HubSpotIntegration_GetOAuthHubSpotLink {
  getHubSpotOAuthLink
}
    `;

/**
 * __useHubSpotIntegrationGetOAuthHubSpotLinkQuery__
 *
 * To run a query within a React component, call `useHubSpotIntegrationGetOAuthHubSpotLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useHubSpotIntegrationGetOAuthHubSpotLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHubSpotIntegrationGetOAuthHubSpotLinkQuery({
 *   variables: {
 *   },
 * });
 */
export function useHubSpotIntegrationGetOAuthHubSpotLinkQuery(baseOptions?: Apollo.QueryHookOptions<HubSpotIntegrationGetOAuthHubSpotLinkQuery, HubSpotIntegrationGetOAuthHubSpotLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HubSpotIntegrationGetOAuthHubSpotLinkQuery, HubSpotIntegrationGetOAuthHubSpotLinkQueryVariables>(HubSpotIntegrationGetOAuthHubSpotLinkDocument, options);
      }
export function useHubSpotIntegrationGetOAuthHubSpotLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HubSpotIntegrationGetOAuthHubSpotLinkQuery, HubSpotIntegrationGetOAuthHubSpotLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HubSpotIntegrationGetOAuthHubSpotLinkQuery, HubSpotIntegrationGetOAuthHubSpotLinkQueryVariables>(HubSpotIntegrationGetOAuthHubSpotLinkDocument, options);
        }
export type HubSpotIntegrationGetOAuthHubSpotLinkQueryHookResult = ReturnType<typeof useHubSpotIntegrationGetOAuthHubSpotLinkQuery>;
export type HubSpotIntegrationGetOAuthHubSpotLinkLazyQueryHookResult = ReturnType<typeof useHubSpotIntegrationGetOAuthHubSpotLinkLazyQuery>;
export type HubSpotIntegrationGetOAuthHubSpotLinkQueryResult = Apollo.QueryResult<HubSpotIntegrationGetOAuthHubSpotLinkQuery, HubSpotIntegrationGetOAuthHubSpotLinkQueryVariables>;
export const HubSpotIntegrationDisconnectHubSpotDocument = gql`
    mutation HubSpotIntegration_DisconnectHubSpot($organizationId: ID!) {
  disconnectHubSpot(input: {organizationId: $organizationId}) {
    organization {
      id
      hubSpotIntegration {
        id
        hubSpotPortalId
      }
    }
  }
}
    `;
export type HubSpotIntegrationDisconnectHubSpotMutationFn = Apollo.MutationFunction<HubSpotIntegrationDisconnectHubSpotMutation, HubSpotIntegrationDisconnectHubSpotMutationVariables>;

/**
 * __useHubSpotIntegrationDisconnectHubSpotMutation__
 *
 * To run a mutation, you first call `useHubSpotIntegrationDisconnectHubSpotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHubSpotIntegrationDisconnectHubSpotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hubSpotIntegrationDisconnectHubSpotMutation, { data, loading, error }] = useHubSpotIntegrationDisconnectHubSpotMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useHubSpotIntegrationDisconnectHubSpotMutation(baseOptions?: Apollo.MutationHookOptions<HubSpotIntegrationDisconnectHubSpotMutation, HubSpotIntegrationDisconnectHubSpotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HubSpotIntegrationDisconnectHubSpotMutation, HubSpotIntegrationDisconnectHubSpotMutationVariables>(HubSpotIntegrationDisconnectHubSpotDocument, options);
      }
export type HubSpotIntegrationDisconnectHubSpotMutationHookResult = ReturnType<typeof useHubSpotIntegrationDisconnectHubSpotMutation>;
export type HubSpotIntegrationDisconnectHubSpotMutationResult = Apollo.MutationResult<HubSpotIntegrationDisconnectHubSpotMutation>;
export type HubSpotIntegrationDisconnectHubSpotMutationOptions = Apollo.BaseMutationOptions<HubSpotIntegrationDisconnectHubSpotMutation, HubSpotIntegrationDisconnectHubSpotMutationVariables>;
export const JiraIntegrationDisconnectJiraDocument = gql`
    mutation JiraIntegration_DisconnectJira($organizationId: ID!) {
  disconnectJira(input: {organizationId: $organizationId}) {
    organization {
      id
      ...JiraIntegration_Organization
    }
  }
}
    ${JiraIntegrationOrganizationFragmentDoc}`;
export type JiraIntegrationDisconnectJiraMutationFn = Apollo.MutationFunction<JiraIntegrationDisconnectJiraMutation, JiraIntegrationDisconnectJiraMutationVariables>;

/**
 * __useJiraIntegrationDisconnectJiraMutation__
 *
 * To run a mutation, you first call `useJiraIntegrationDisconnectJiraMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJiraIntegrationDisconnectJiraMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jiraIntegrationDisconnectJiraMutation, { data, loading, error }] = useJiraIntegrationDisconnectJiraMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useJiraIntegrationDisconnectJiraMutation(baseOptions?: Apollo.MutationHookOptions<JiraIntegrationDisconnectJiraMutation, JiraIntegrationDisconnectJiraMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JiraIntegrationDisconnectJiraMutation, JiraIntegrationDisconnectJiraMutationVariables>(JiraIntegrationDisconnectJiraDocument, options);
      }
export type JiraIntegrationDisconnectJiraMutationHookResult = ReturnType<typeof useJiraIntegrationDisconnectJiraMutation>;
export type JiraIntegrationDisconnectJiraMutationResult = Apollo.MutationResult<JiraIntegrationDisconnectJiraMutation>;
export type JiraIntegrationDisconnectJiraMutationOptions = Apollo.BaseMutationOptions<JiraIntegrationDisconnectJiraMutation, JiraIntegrationDisconnectJiraMutationVariables>;
export const DeliveriesLastWebhookDeliveriesDocument = gql`
    query Deliveries_LastWebhookDeliveries($webhookId: ID!) {
  getLastWebhookDeliveries(webhookId: $webhookId) {
    ...DeliveriesView_WebhookDelivery
  }
}
    ${DeliveriesViewWebhookDeliveryFragmentDoc}`;

/**
 * __useDeliveriesLastWebhookDeliveriesQuery__
 *
 * To run a query within a React component, call `useDeliveriesLastWebhookDeliveriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveriesLastWebhookDeliveriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveriesLastWebhookDeliveriesQuery({
 *   variables: {
 *      webhookId: // value for 'webhookId'
 *   },
 * });
 */
export function useDeliveriesLastWebhookDeliveriesQuery(baseOptions: Apollo.QueryHookOptions<DeliveriesLastWebhookDeliveriesQuery, DeliveriesLastWebhookDeliveriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeliveriesLastWebhookDeliveriesQuery, DeliveriesLastWebhookDeliveriesQueryVariables>(DeliveriesLastWebhookDeliveriesDocument, options);
      }
export function useDeliveriesLastWebhookDeliveriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeliveriesLastWebhookDeliveriesQuery, DeliveriesLastWebhookDeliveriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeliveriesLastWebhookDeliveriesQuery, DeliveriesLastWebhookDeliveriesQueryVariables>(DeliveriesLastWebhookDeliveriesDocument, options);
        }
export type DeliveriesLastWebhookDeliveriesQueryHookResult = ReturnType<typeof useDeliveriesLastWebhookDeliveriesQuery>;
export type DeliveriesLastWebhookDeliveriesLazyQueryHookResult = ReturnType<typeof useDeliveriesLastWebhookDeliveriesLazyQuery>;
export type DeliveriesLastWebhookDeliveriesQueryResult = Apollo.QueryResult<DeliveriesLastWebhookDeliveriesQuery, DeliveriesLastWebhookDeliveriesQueryVariables>;
export const OpenApiSettingsProjectListDocument = gql`
    query OpenApiSettings_ProjectList($listInputs: ListInput, $projectFilters: ProjectFilters) {
  projectsConnections(listInputs: $listInputs, projectFilters: $projectFilters) {
    projects {
      id
      ...TriggerWebhookAlertDialog_Project
    }
  }
}
    ${TriggerWebhookAlertDialogProjectFragmentDoc}`;

/**
 * __useOpenApiSettingsProjectListQuery__
 *
 * To run a query within a React component, call `useOpenApiSettingsProjectListQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpenApiSettingsProjectListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpenApiSettingsProjectListQuery({
 *   variables: {
 *      listInputs: // value for 'listInputs'
 *      projectFilters: // value for 'projectFilters'
 *   },
 * });
 */
export function useOpenApiSettingsProjectListQuery(baseOptions?: Apollo.QueryHookOptions<OpenApiSettingsProjectListQuery, OpenApiSettingsProjectListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpenApiSettingsProjectListQuery, OpenApiSettingsProjectListQueryVariables>(OpenApiSettingsProjectListDocument, options);
      }
export function useOpenApiSettingsProjectListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpenApiSettingsProjectListQuery, OpenApiSettingsProjectListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpenApiSettingsProjectListQuery, OpenApiSettingsProjectListQueryVariables>(OpenApiSettingsProjectListDocument, options);
        }
export type OpenApiSettingsProjectListQueryHookResult = ReturnType<typeof useOpenApiSettingsProjectListQuery>;
export type OpenApiSettingsProjectListLazyQueryHookResult = ReturnType<typeof useOpenApiSettingsProjectListLazyQuery>;
export type OpenApiSettingsProjectListQueryResult = Apollo.QueryResult<OpenApiSettingsProjectListQuery, OpenApiSettingsProjectListQueryVariables>;
export const OpenApiSettingsCreateWebhookDocument = gql`
    mutation OpenApiSettings_CreateWebhook($input: createWebhookInput!) {
  createWebhook(input: $input) {
    organization {
      ...OpenApiSettings_Organization
    }
  }
}
    ${OpenApiSettingsOrganizationFragmentDoc}`;
export type OpenApiSettingsCreateWebhookMutationFn = Apollo.MutationFunction<OpenApiSettingsCreateWebhookMutation, OpenApiSettingsCreateWebhookMutationVariables>;

/**
 * __useOpenApiSettingsCreateWebhookMutation__
 *
 * To run a mutation, you first call `useOpenApiSettingsCreateWebhookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOpenApiSettingsCreateWebhookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [openApiSettingsCreateWebhookMutation, { data, loading, error }] = useOpenApiSettingsCreateWebhookMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOpenApiSettingsCreateWebhookMutation(baseOptions?: Apollo.MutationHookOptions<OpenApiSettingsCreateWebhookMutation, OpenApiSettingsCreateWebhookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OpenApiSettingsCreateWebhookMutation, OpenApiSettingsCreateWebhookMutationVariables>(OpenApiSettingsCreateWebhookDocument, options);
      }
export type OpenApiSettingsCreateWebhookMutationHookResult = ReturnType<typeof useOpenApiSettingsCreateWebhookMutation>;
export type OpenApiSettingsCreateWebhookMutationResult = Apollo.MutationResult<OpenApiSettingsCreateWebhookMutation>;
export type OpenApiSettingsCreateWebhookMutationOptions = Apollo.BaseMutationOptions<OpenApiSettingsCreateWebhookMutation, OpenApiSettingsCreateWebhookMutationVariables>;
export const OpenApiSettingsUpdateWebhookDocument = gql`
    mutation OpenApiSettings_UpdateWebhook($input: updateWebhookInput!) {
  updateWebhook(input: $input) {
    organization {
      ...OpenApiSettings_Organization
    }
  }
}
    ${OpenApiSettingsOrganizationFragmentDoc}`;
export type OpenApiSettingsUpdateWebhookMutationFn = Apollo.MutationFunction<OpenApiSettingsUpdateWebhookMutation, OpenApiSettingsUpdateWebhookMutationVariables>;

/**
 * __useOpenApiSettingsUpdateWebhookMutation__
 *
 * To run a mutation, you first call `useOpenApiSettingsUpdateWebhookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOpenApiSettingsUpdateWebhookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [openApiSettingsUpdateWebhookMutation, { data, loading, error }] = useOpenApiSettingsUpdateWebhookMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOpenApiSettingsUpdateWebhookMutation(baseOptions?: Apollo.MutationHookOptions<OpenApiSettingsUpdateWebhookMutation, OpenApiSettingsUpdateWebhookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OpenApiSettingsUpdateWebhookMutation, OpenApiSettingsUpdateWebhookMutationVariables>(OpenApiSettingsUpdateWebhookDocument, options);
      }
export type OpenApiSettingsUpdateWebhookMutationHookResult = ReturnType<typeof useOpenApiSettingsUpdateWebhookMutation>;
export type OpenApiSettingsUpdateWebhookMutationResult = Apollo.MutationResult<OpenApiSettingsUpdateWebhookMutation>;
export type OpenApiSettingsUpdateWebhookMutationOptions = Apollo.BaseMutationOptions<OpenApiSettingsUpdateWebhookMutation, OpenApiSettingsUpdateWebhookMutationVariables>;
export const OpenApiSettingsDeleteWebhookDocument = gql`
    mutation OpenApiSettings_DeleteWebhook($input: deleteWebhookInput!) {
  deleteWebhook(input: $input) {
    organization {
      ...OpenApiSettings_Organization
    }
  }
}
    ${OpenApiSettingsOrganizationFragmentDoc}`;
export type OpenApiSettingsDeleteWebhookMutationFn = Apollo.MutationFunction<OpenApiSettingsDeleteWebhookMutation, OpenApiSettingsDeleteWebhookMutationVariables>;

/**
 * __useOpenApiSettingsDeleteWebhookMutation__
 *
 * To run a mutation, you first call `useOpenApiSettingsDeleteWebhookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOpenApiSettingsDeleteWebhookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [openApiSettingsDeleteWebhookMutation, { data, loading, error }] = useOpenApiSettingsDeleteWebhookMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOpenApiSettingsDeleteWebhookMutation(baseOptions?: Apollo.MutationHookOptions<OpenApiSettingsDeleteWebhookMutation, OpenApiSettingsDeleteWebhookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OpenApiSettingsDeleteWebhookMutation, OpenApiSettingsDeleteWebhookMutationVariables>(OpenApiSettingsDeleteWebhookDocument, options);
      }
export type OpenApiSettingsDeleteWebhookMutationHookResult = ReturnType<typeof useOpenApiSettingsDeleteWebhookMutation>;
export type OpenApiSettingsDeleteWebhookMutationResult = Apollo.MutationResult<OpenApiSettingsDeleteWebhookMutation>;
export type OpenApiSettingsDeleteWebhookMutationOptions = Apollo.BaseMutationOptions<OpenApiSettingsDeleteWebhookMutation, OpenApiSettingsDeleteWebhookMutationVariables>;
export const OpenApiSettingsTriggerWebhookDocument = gql`
    mutation OpenApiSettings_TriggerWebhook($input: triggerWebhookInput!) {
  triggerWebhook(input: $input) {
    success
  }
}
    `;
export type OpenApiSettingsTriggerWebhookMutationFn = Apollo.MutationFunction<OpenApiSettingsTriggerWebhookMutation, OpenApiSettingsTriggerWebhookMutationVariables>;

/**
 * __useOpenApiSettingsTriggerWebhookMutation__
 *
 * To run a mutation, you first call `useOpenApiSettingsTriggerWebhookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOpenApiSettingsTriggerWebhookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [openApiSettingsTriggerWebhookMutation, { data, loading, error }] = useOpenApiSettingsTriggerWebhookMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOpenApiSettingsTriggerWebhookMutation(baseOptions?: Apollo.MutationHookOptions<OpenApiSettingsTriggerWebhookMutation, OpenApiSettingsTriggerWebhookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OpenApiSettingsTriggerWebhookMutation, OpenApiSettingsTriggerWebhookMutationVariables>(OpenApiSettingsTriggerWebhookDocument, options);
      }
export type OpenApiSettingsTriggerWebhookMutationHookResult = ReturnType<typeof useOpenApiSettingsTriggerWebhookMutation>;
export type OpenApiSettingsTriggerWebhookMutationResult = Apollo.MutationResult<OpenApiSettingsTriggerWebhookMutation>;
export type OpenApiSettingsTriggerWebhookMutationOptions = Apollo.BaseMutationOptions<OpenApiSettingsTriggerWebhookMutation, OpenApiSettingsTriggerWebhookMutationVariables>;
export const OrganizationTableRowRemoveOrgConnectionDocument = gql`
    mutation OrganizationTableRow_RemoveOrgConnection($org: removeOrgConnectionInput!) {
  removeOrgConnection(input: $org) {
    ... on removeOrgConnectionPayload {
      organization {
        id
      }
    }
  }
}
    `;
export type OrganizationTableRowRemoveOrgConnectionMutationFn = Apollo.MutationFunction<OrganizationTableRowRemoveOrgConnectionMutation, OrganizationTableRowRemoveOrgConnectionMutationVariables>;

/**
 * __useOrganizationTableRowRemoveOrgConnectionMutation__
 *
 * To run a mutation, you first call `useOrganizationTableRowRemoveOrgConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationTableRowRemoveOrgConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationTableRowRemoveOrgConnectionMutation, { data, loading, error }] = useOrganizationTableRowRemoveOrgConnectionMutation({
 *   variables: {
 *      org: // value for 'org'
 *   },
 * });
 */
export function useOrganizationTableRowRemoveOrgConnectionMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationTableRowRemoveOrgConnectionMutation, OrganizationTableRowRemoveOrgConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationTableRowRemoveOrgConnectionMutation, OrganizationTableRowRemoveOrgConnectionMutationVariables>(OrganizationTableRowRemoveOrgConnectionDocument, options);
      }
export type OrganizationTableRowRemoveOrgConnectionMutationHookResult = ReturnType<typeof useOrganizationTableRowRemoveOrgConnectionMutation>;
export type OrganizationTableRowRemoveOrgConnectionMutationResult = Apollo.MutationResult<OrganizationTableRowRemoveOrgConnectionMutation>;
export type OrganizationTableRowRemoveOrgConnectionMutationOptions = Apollo.BaseMutationOptions<OrganizationTableRowRemoveOrgConnectionMutation, OrganizationTableRowRemoveOrgConnectionMutationVariables>;
export const SalesforceIntegrationDisconnectSalesforceDocument = gql`
    mutation SalesforceIntegration_DisconnectSalesforce($organizationId: ID!) {
  disconnectSalesforce(input: {organizationId: $organizationId}) {
    organization {
      id
      salesforceIntegration {
        id
        username
        organizationName
      }
    }
  }
}
    `;
export type SalesforceIntegrationDisconnectSalesforceMutationFn = Apollo.MutationFunction<SalesforceIntegrationDisconnectSalesforceMutation, SalesforceIntegrationDisconnectSalesforceMutationVariables>;

/**
 * __useSalesforceIntegrationDisconnectSalesforceMutation__
 *
 * To run a mutation, you first call `useSalesforceIntegrationDisconnectSalesforceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalesforceIntegrationDisconnectSalesforceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salesforceIntegrationDisconnectSalesforceMutation, { data, loading, error }] = useSalesforceIntegrationDisconnectSalesforceMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useSalesforceIntegrationDisconnectSalesforceMutation(baseOptions?: Apollo.MutationHookOptions<SalesforceIntegrationDisconnectSalesforceMutation, SalesforceIntegrationDisconnectSalesforceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SalesforceIntegrationDisconnectSalesforceMutation, SalesforceIntegrationDisconnectSalesforceMutationVariables>(SalesforceIntegrationDisconnectSalesforceDocument, options);
      }
export type SalesforceIntegrationDisconnectSalesforceMutationHookResult = ReturnType<typeof useSalesforceIntegrationDisconnectSalesforceMutation>;
export type SalesforceIntegrationDisconnectSalesforceMutationResult = Apollo.MutationResult<SalesforceIntegrationDisconnectSalesforceMutation>;
export type SalesforceIntegrationDisconnectSalesforceMutationOptions = Apollo.BaseMutationOptions<SalesforceIntegrationDisconnectSalesforceMutation, SalesforceIntegrationDisconnectSalesforceMutationVariables>;
export const LogInSettingsUpdateSecureLinksDocument = gql`
    mutation LogInSettings_UpdateSecureLinks($inputs: updateOrganizationInput!) {
  updateOrganization(input: $inputs) {
    organization {
      id
      ...SecureLinksSettings_Organization
    }
  }
}
    ${SecureLinksSettingsOrganizationFragmentDoc}`;
export type LogInSettingsUpdateSecureLinksMutationFn = Apollo.MutationFunction<LogInSettingsUpdateSecureLinksMutation, LogInSettingsUpdateSecureLinksMutationVariables>;

/**
 * __useLogInSettingsUpdateSecureLinksMutation__
 *
 * To run a mutation, you first call `useLogInSettingsUpdateSecureLinksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogInSettingsUpdateSecureLinksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logInSettingsUpdateSecureLinksMutation, { data, loading, error }] = useLogInSettingsUpdateSecureLinksMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useLogInSettingsUpdateSecureLinksMutation(baseOptions?: Apollo.MutationHookOptions<LogInSettingsUpdateSecureLinksMutation, LogInSettingsUpdateSecureLinksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogInSettingsUpdateSecureLinksMutation, LogInSettingsUpdateSecureLinksMutationVariables>(LogInSettingsUpdateSecureLinksDocument, options);
      }
export type LogInSettingsUpdateSecureLinksMutationHookResult = ReturnType<typeof useLogInSettingsUpdateSecureLinksMutation>;
export type LogInSettingsUpdateSecureLinksMutationResult = Apollo.MutationResult<LogInSettingsUpdateSecureLinksMutation>;
export type LogInSettingsUpdateSecureLinksMutationOptions = Apollo.BaseMutationOptions<LogInSettingsUpdateSecureLinksMutation, LogInSettingsUpdateSecureLinksMutationVariables>;
export const SingleSignOnSettingsDeleteIdentityProviderDocument = gql`
    mutation SingleSignOnSettings_DeleteIdentityProvider($inputs: deleteIdentityProviderInput!) {
  deleteIdentityProvider(input: $inputs) {
    success
  }
}
    `;
export type SingleSignOnSettingsDeleteIdentityProviderMutationFn = Apollo.MutationFunction<SingleSignOnSettingsDeleteIdentityProviderMutation, SingleSignOnSettingsDeleteIdentityProviderMutationVariables>;

/**
 * __useSingleSignOnSettingsDeleteIdentityProviderMutation__
 *
 * To run a mutation, you first call `useSingleSignOnSettingsDeleteIdentityProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSingleSignOnSettingsDeleteIdentityProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [singleSignOnSettingsDeleteIdentityProviderMutation, { data, loading, error }] = useSingleSignOnSettingsDeleteIdentityProviderMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useSingleSignOnSettingsDeleteIdentityProviderMutation(baseOptions?: Apollo.MutationHookOptions<SingleSignOnSettingsDeleteIdentityProviderMutation, SingleSignOnSettingsDeleteIdentityProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SingleSignOnSettingsDeleteIdentityProviderMutation, SingleSignOnSettingsDeleteIdentityProviderMutationVariables>(SingleSignOnSettingsDeleteIdentityProviderDocument, options);
      }
export type SingleSignOnSettingsDeleteIdentityProviderMutationHookResult = ReturnType<typeof useSingleSignOnSettingsDeleteIdentityProviderMutation>;
export type SingleSignOnSettingsDeleteIdentityProviderMutationResult = Apollo.MutationResult<SingleSignOnSettingsDeleteIdentityProviderMutation>;
export type SingleSignOnSettingsDeleteIdentityProviderMutationOptions = Apollo.BaseMutationOptions<SingleSignOnSettingsDeleteIdentityProviderMutation, SingleSignOnSettingsDeleteIdentityProviderMutationVariables>;
export const SingleSignOnSettingsToggleIdentityProviderDocument = gql`
    mutation SingleSignOnSettings_ToggleIdentityProvider($inputs: toggleIdentityProviderInput!) {
  toggleIdentityProvider(input: $inputs) {
    active
  }
}
    `;
export type SingleSignOnSettingsToggleIdentityProviderMutationFn = Apollo.MutationFunction<SingleSignOnSettingsToggleIdentityProviderMutation, SingleSignOnSettingsToggleIdentityProviderMutationVariables>;

/**
 * __useSingleSignOnSettingsToggleIdentityProviderMutation__
 *
 * To run a mutation, you first call `useSingleSignOnSettingsToggleIdentityProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSingleSignOnSettingsToggleIdentityProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [singleSignOnSettingsToggleIdentityProviderMutation, { data, loading, error }] = useSingleSignOnSettingsToggleIdentityProviderMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useSingleSignOnSettingsToggleIdentityProviderMutation(baseOptions?: Apollo.MutationHookOptions<SingleSignOnSettingsToggleIdentityProviderMutation, SingleSignOnSettingsToggleIdentityProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SingleSignOnSettingsToggleIdentityProviderMutation, SingleSignOnSettingsToggleIdentityProviderMutationVariables>(SingleSignOnSettingsToggleIdentityProviderDocument, options);
      }
export type SingleSignOnSettingsToggleIdentityProviderMutationHookResult = ReturnType<typeof useSingleSignOnSettingsToggleIdentityProviderMutation>;
export type SingleSignOnSettingsToggleIdentityProviderMutationResult = Apollo.MutationResult<SingleSignOnSettingsToggleIdentityProviderMutation>;
export type SingleSignOnSettingsToggleIdentityProviderMutationOptions = Apollo.BaseMutationOptions<SingleSignOnSettingsToggleIdentityProviderMutation, SingleSignOnSettingsToggleIdentityProviderMutationVariables>;
export const SingleSignOnSettingsUpdateIdentityProviderDocument = gql`
    mutation SingleSignOnSettings_UpdateIdentityProvider($inputs: updateIdentityProviderInput!) {
  updateIdentityProvider(input: $inputs) {
    organization {
      id
      ...SingleSignOnSettings_Organization
    }
  }
}
    ${SingleSignOnSettingsOrganizationFragmentDoc}`;
export type SingleSignOnSettingsUpdateIdentityProviderMutationFn = Apollo.MutationFunction<SingleSignOnSettingsUpdateIdentityProviderMutation, SingleSignOnSettingsUpdateIdentityProviderMutationVariables>;

/**
 * __useSingleSignOnSettingsUpdateIdentityProviderMutation__
 *
 * To run a mutation, you first call `useSingleSignOnSettingsUpdateIdentityProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSingleSignOnSettingsUpdateIdentityProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [singleSignOnSettingsUpdateIdentityProviderMutation, { data, loading, error }] = useSingleSignOnSettingsUpdateIdentityProviderMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useSingleSignOnSettingsUpdateIdentityProviderMutation(baseOptions?: Apollo.MutationHookOptions<SingleSignOnSettingsUpdateIdentityProviderMutation, SingleSignOnSettingsUpdateIdentityProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SingleSignOnSettingsUpdateIdentityProviderMutation, SingleSignOnSettingsUpdateIdentityProviderMutationVariables>(SingleSignOnSettingsUpdateIdentityProviderDocument, options);
      }
export type SingleSignOnSettingsUpdateIdentityProviderMutationHookResult = ReturnType<typeof useSingleSignOnSettingsUpdateIdentityProviderMutation>;
export type SingleSignOnSettingsUpdateIdentityProviderMutationResult = Apollo.MutationResult<SingleSignOnSettingsUpdateIdentityProviderMutation>;
export type SingleSignOnSettingsUpdateIdentityProviderMutationOptions = Apollo.BaseMutationOptions<SingleSignOnSettingsUpdateIdentityProviderMutation, SingleSignOnSettingsUpdateIdentityProviderMutationVariables>;
export const SlackIntegrationDisconnectSlackDocument = gql`
    mutation SlackIntegration_DisconnectSlack($input: disconnectSlackInput!) {
  disconnectSlack(input: $input) {
    organization {
      ...SlackIntegration_Organization
    }
  }
}
    ${SlackIntegrationOrganizationFragmentDoc}`;
export type SlackIntegrationDisconnectSlackMutationFn = Apollo.MutationFunction<SlackIntegrationDisconnectSlackMutation, SlackIntegrationDisconnectSlackMutationVariables>;

/**
 * __useSlackIntegrationDisconnectSlackMutation__
 *
 * To run a mutation, you first call `useSlackIntegrationDisconnectSlackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSlackIntegrationDisconnectSlackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [slackIntegrationDisconnectSlackMutation, { data, loading, error }] = useSlackIntegrationDisconnectSlackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSlackIntegrationDisconnectSlackMutation(baseOptions?: Apollo.MutationHookOptions<SlackIntegrationDisconnectSlackMutation, SlackIntegrationDisconnectSlackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SlackIntegrationDisconnectSlackMutation, SlackIntegrationDisconnectSlackMutationVariables>(SlackIntegrationDisconnectSlackDocument, options);
      }
export type SlackIntegrationDisconnectSlackMutationHookResult = ReturnType<typeof useSlackIntegrationDisconnectSlackMutation>;
export type SlackIntegrationDisconnectSlackMutationResult = Apollo.MutationResult<SlackIntegrationDisconnectSlackMutation>;
export type SlackIntegrationDisconnectSlackMutationOptions = Apollo.BaseMutationOptions<SlackIntegrationDisconnectSlackMutation, SlackIntegrationDisconnectSlackMutationVariables>;
export const SlackIntegrationDisconnectSlackChannelDocument = gql`
    mutation SlackIntegration_DisconnectSlackChannel($slackChannelId: disconnectSlackChannelInput!) {
  disconnectSlackChannel(input: $slackChannelId) {
    organization {
      id
      ...SlackIntegration_Organization
    }
  }
}
    ${SlackIntegrationOrganizationFragmentDoc}`;
export type SlackIntegrationDisconnectSlackChannelMutationFn = Apollo.MutationFunction<SlackIntegrationDisconnectSlackChannelMutation, SlackIntegrationDisconnectSlackChannelMutationVariables>;

/**
 * __useSlackIntegrationDisconnectSlackChannelMutation__
 *
 * To run a mutation, you first call `useSlackIntegrationDisconnectSlackChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSlackIntegrationDisconnectSlackChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [slackIntegrationDisconnectSlackChannelMutation, { data, loading, error }] = useSlackIntegrationDisconnectSlackChannelMutation({
 *   variables: {
 *      slackChannelId: // value for 'slackChannelId'
 *   },
 * });
 */
export function useSlackIntegrationDisconnectSlackChannelMutation(baseOptions?: Apollo.MutationHookOptions<SlackIntegrationDisconnectSlackChannelMutation, SlackIntegrationDisconnectSlackChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SlackIntegrationDisconnectSlackChannelMutation, SlackIntegrationDisconnectSlackChannelMutationVariables>(SlackIntegrationDisconnectSlackChannelDocument, options);
      }
export type SlackIntegrationDisconnectSlackChannelMutationHookResult = ReturnType<typeof useSlackIntegrationDisconnectSlackChannelMutation>;
export type SlackIntegrationDisconnectSlackChannelMutationResult = Apollo.MutationResult<SlackIntegrationDisconnectSlackChannelMutation>;
export type SlackIntegrationDisconnectSlackChannelMutationOptions = Apollo.BaseMutationOptions<SlackIntegrationDisconnectSlackChannelMutation, SlackIntegrationDisconnectSlackChannelMutationVariables>;
export const SlackIntegrationUpdateOrganizationDocument = gql`
    mutation SlackIntegration_UpdateOrganization($organization: updateOrganizationInput!) {
  updateOrganization(input: $organization) {
    organization {
      id
      projectUpdatedSlackDaysPref
    }
  }
}
    `;
export type SlackIntegrationUpdateOrganizationMutationFn = Apollo.MutationFunction<SlackIntegrationUpdateOrganizationMutation, SlackIntegrationUpdateOrganizationMutationVariables>;

/**
 * __useSlackIntegrationUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useSlackIntegrationUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSlackIntegrationUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [slackIntegrationUpdateOrganizationMutation, { data, loading, error }] = useSlackIntegrationUpdateOrganizationMutation({
 *   variables: {
 *      organization: // value for 'organization'
 *   },
 * });
 */
export function useSlackIntegrationUpdateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<SlackIntegrationUpdateOrganizationMutation, SlackIntegrationUpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SlackIntegrationUpdateOrganizationMutation, SlackIntegrationUpdateOrganizationMutationVariables>(SlackIntegrationUpdateOrganizationDocument, options);
      }
export type SlackIntegrationUpdateOrganizationMutationHookResult = ReturnType<typeof useSlackIntegrationUpdateOrganizationMutation>;
export type SlackIntegrationUpdateOrganizationMutationResult = Apollo.MutationResult<SlackIntegrationUpdateOrganizationMutation>;
export type SlackIntegrationUpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<SlackIntegrationUpdateOrganizationMutation, SlackIntegrationUpdateOrganizationMutationVariables>;
export const AddConnectedUserDrawerDocument = gql`
    mutation AddConnectedUserDrawer($input: addUserConnectionInput!) {
  addUserConnection(input: $input) {
    user {
      id
    }
  }
}
    `;
export type AddConnectedUserDrawerMutationFn = Apollo.MutationFunction<AddConnectedUserDrawerMutation, AddConnectedUserDrawerMutationVariables>;

/**
 * __useAddConnectedUserDrawerMutation__
 *
 * To run a mutation, you first call `useAddConnectedUserDrawerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddConnectedUserDrawerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addConnectedUserDrawerMutation, { data, loading, error }] = useAddConnectedUserDrawerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddConnectedUserDrawerMutation(baseOptions?: Apollo.MutationHookOptions<AddConnectedUserDrawerMutation, AddConnectedUserDrawerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddConnectedUserDrawerMutation, AddConnectedUserDrawerMutationVariables>(AddConnectedUserDrawerDocument, options);
      }
export type AddConnectedUserDrawerMutationHookResult = ReturnType<typeof useAddConnectedUserDrawerMutation>;
export type AddConnectedUserDrawerMutationResult = Apollo.MutationResult<AddConnectedUserDrawerMutation>;
export type AddConnectedUserDrawerMutationOptions = Apollo.BaseMutationOptions<AddConnectedUserDrawerMutation, AddConnectedUserDrawerMutationVariables>;
export const ConnectedUserTableRowRemoveUserConnectionDocument = gql`
    mutation ConnectedUserTableRow_RemoveUserConnection($user: removeUserConnectionInput!) {
  removeUserConnection(input: $user) {
    organizationConnectedUsers {
      id
    }
  }
}
    `;
export type ConnectedUserTableRowRemoveUserConnectionMutationFn = Apollo.MutationFunction<ConnectedUserTableRowRemoveUserConnectionMutation, ConnectedUserTableRowRemoveUserConnectionMutationVariables>;

/**
 * __useConnectedUserTableRowRemoveUserConnectionMutation__
 *
 * To run a mutation, you first call `useConnectedUserTableRowRemoveUserConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectedUserTableRowRemoveUserConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectedUserTableRowRemoveUserConnectionMutation, { data, loading, error }] = useConnectedUserTableRowRemoveUserConnectionMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useConnectedUserTableRowRemoveUserConnectionMutation(baseOptions?: Apollo.MutationHookOptions<ConnectedUserTableRowRemoveUserConnectionMutation, ConnectedUserTableRowRemoveUserConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectedUserTableRowRemoveUserConnectionMutation, ConnectedUserTableRowRemoveUserConnectionMutationVariables>(ConnectedUserTableRowRemoveUserConnectionDocument, options);
      }
export type ConnectedUserTableRowRemoveUserConnectionMutationHookResult = ReturnType<typeof useConnectedUserTableRowRemoveUserConnectionMutation>;
export type ConnectedUserTableRowRemoveUserConnectionMutationResult = Apollo.MutationResult<ConnectedUserTableRowRemoveUserConnectionMutation>;
export type ConnectedUserTableRowRemoveUserConnectionMutationOptions = Apollo.BaseMutationOptions<ConnectedUserTableRowRemoveUserConnectionMutation, ConnectedUserTableRowRemoveUserConnectionMutationVariables>;
export const MergeCustomerDocument = gql`
    mutation MergeCustomer($customerToDeleteId: ID!, $reassignToCustomerId: ID!) {
  mergeCustomer(
    input: {customerToDeleteId: $customerToDeleteId, reassignToCustomerId: $reassignToCustomerId}
  ) {
    success
    errors
  }
}
    `;
export type MergeCustomerMutationFn = Apollo.MutationFunction<MergeCustomerMutation, MergeCustomerMutationVariables>;

/**
 * __useMergeCustomerMutation__
 *
 * To run a mutation, you first call `useMergeCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeCustomerMutation, { data, loading, error }] = useMergeCustomerMutation({
 *   variables: {
 *      customerToDeleteId: // value for 'customerToDeleteId'
 *      reassignToCustomerId: // value for 'reassignToCustomerId'
 *   },
 * });
 */
export function useMergeCustomerMutation(baseOptions?: Apollo.MutationHookOptions<MergeCustomerMutation, MergeCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeCustomerMutation, MergeCustomerMutationVariables>(MergeCustomerDocument, options);
      }
export type MergeCustomerMutationHookResult = ReturnType<typeof useMergeCustomerMutation>;
export type MergeCustomerMutationResult = Apollo.MutationResult<MergeCustomerMutation>;
export type MergeCustomerMutationOptions = Apollo.BaseMutationOptions<MergeCustomerMutation, MergeCustomerMutationVariables>;
export const FiltersCapacitySkillCategoriesDocument = gql`
    query FiltersCapacity_SkillCategories($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    skillCategories {
      id
      name
      skills {
        id
        name
        category {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useFiltersCapacitySkillCategoriesQuery__
 *
 * To run a query within a React component, call `useFiltersCapacitySkillCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFiltersCapacitySkillCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFiltersCapacitySkillCategoriesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useFiltersCapacitySkillCategoriesQuery(baseOptions: Apollo.QueryHookOptions<FiltersCapacitySkillCategoriesQuery, FiltersCapacitySkillCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FiltersCapacitySkillCategoriesQuery, FiltersCapacitySkillCategoriesQueryVariables>(FiltersCapacitySkillCategoriesDocument, options);
      }
export function useFiltersCapacitySkillCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FiltersCapacitySkillCategoriesQuery, FiltersCapacitySkillCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FiltersCapacitySkillCategoriesQuery, FiltersCapacitySkillCategoriesQueryVariables>(FiltersCapacitySkillCategoriesDocument, options);
        }
export type FiltersCapacitySkillCategoriesQueryHookResult = ReturnType<typeof useFiltersCapacitySkillCategoriesQuery>;
export type FiltersCapacitySkillCategoriesLazyQueryHookResult = ReturnType<typeof useFiltersCapacitySkillCategoriesLazyQuery>;
export type FiltersCapacitySkillCategoriesQueryResult = Apollo.QueryResult<FiltersCapacitySkillCategoriesQuery, FiltersCapacitySkillCategoriesQueryVariables>;
export const AddCompanyFormOrganizationByDomainDocument = gql`
    query AddCompanyForm_OrganizationByDomain($domain: String) {
  organizationByDomain(domain: $domain) {
    name
    logo
    domain
    type
    isStored
    isEditable
  }
}
    `;

/**
 * __useAddCompanyFormOrganizationByDomainQuery__
 *
 * To run a query within a React component, call `useAddCompanyFormOrganizationByDomainQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyFormOrganizationByDomainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddCompanyFormOrganizationByDomainQuery({
 *   variables: {
 *      domain: // value for 'domain'
 *   },
 * });
 */
export function useAddCompanyFormOrganizationByDomainQuery(baseOptions?: Apollo.QueryHookOptions<AddCompanyFormOrganizationByDomainQuery, AddCompanyFormOrganizationByDomainQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddCompanyFormOrganizationByDomainQuery, AddCompanyFormOrganizationByDomainQueryVariables>(AddCompanyFormOrganizationByDomainDocument, options);
      }
export function useAddCompanyFormOrganizationByDomainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddCompanyFormOrganizationByDomainQuery, AddCompanyFormOrganizationByDomainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddCompanyFormOrganizationByDomainQuery, AddCompanyFormOrganizationByDomainQueryVariables>(AddCompanyFormOrganizationByDomainDocument, options);
        }
export type AddCompanyFormOrganizationByDomainQueryHookResult = ReturnType<typeof useAddCompanyFormOrganizationByDomainQuery>;
export type AddCompanyFormOrganizationByDomainLazyQueryHookResult = ReturnType<typeof useAddCompanyFormOrganizationByDomainLazyQuery>;
export type AddCompanyFormOrganizationByDomainQueryResult = Apollo.QueryResult<AddCompanyFormOrganizationByDomainQuery, AddCompanyFormOrganizationByDomainQueryVariables>;
export const MilestoneFormMilestoneFormQueryDocument = gql`
    query MilestoneForm_MilestoneFormQuery($milestoneId: ID!) {
  milestone(id: $milestoneId) {
    id
    ...MilestoneForm_Milestone
  }
}
    ${MilestoneFormMilestoneFragmentDoc}`;

/**
 * __useMilestoneFormMilestoneFormQuery__
 *
 * To run a query within a React component, call `useMilestoneFormMilestoneFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useMilestoneFormMilestoneFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMilestoneFormMilestoneFormQuery({
 *   variables: {
 *      milestoneId: // value for 'milestoneId'
 *   },
 * });
 */
export function useMilestoneFormMilestoneFormQuery(baseOptions: Apollo.QueryHookOptions<MilestoneFormMilestoneFormQuery, MilestoneFormMilestoneFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MilestoneFormMilestoneFormQuery, MilestoneFormMilestoneFormQueryVariables>(MilestoneFormMilestoneFormQueryDocument, options);
      }
export function useMilestoneFormMilestoneFormQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MilestoneFormMilestoneFormQuery, MilestoneFormMilestoneFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MilestoneFormMilestoneFormQuery, MilestoneFormMilestoneFormQueryVariables>(MilestoneFormMilestoneFormQueryDocument, options);
        }
export type MilestoneFormMilestoneFormQueryHookResult = ReturnType<typeof useMilestoneFormMilestoneFormQuery>;
export type MilestoneFormMilestoneFormQueryLazyQueryHookResult = ReturnType<typeof useMilestoneFormMilestoneFormQueryLazyQuery>;
export type MilestoneFormMilestoneFormQueryQueryResult = Apollo.QueryResult<MilestoneFormMilestoneFormQuery, MilestoneFormMilestoneFormQueryVariables>;
export const SharedFieldsJiraSettingsDocument = gql`
    query SharedFields_JiraSettings($organizationId: ID!, $projectId: String = "", $shouldSkip: Boolean = true) {
  organization(id: $organizationId) {
    id
    jiraIntegration {
      id
      defaultProjectId
      defaultIssueTypeId
      ...SharedFields_JiraIntegrationFragment @include(if: $shouldSkip)
      apiProjectComponents(projectId: $projectId) @skip(if: $shouldSkip) {
        externalId
        id
        name
      }
    }
  }
}
    ${SharedFieldsJiraIntegrationFragmentDoc}`;

/**
 * __useSharedFieldsJiraSettingsQuery__
 *
 * To run a query within a React component, call `useSharedFieldsJiraSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharedFieldsJiraSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharedFieldsJiraSettingsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      projectId: // value for 'projectId'
 *      shouldSkip: // value for 'shouldSkip'
 *   },
 * });
 */
export function useSharedFieldsJiraSettingsQuery(baseOptions: Apollo.QueryHookOptions<SharedFieldsJiraSettingsQuery, SharedFieldsJiraSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SharedFieldsJiraSettingsQuery, SharedFieldsJiraSettingsQueryVariables>(SharedFieldsJiraSettingsDocument, options);
      }
export function useSharedFieldsJiraSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SharedFieldsJiraSettingsQuery, SharedFieldsJiraSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SharedFieldsJiraSettingsQuery, SharedFieldsJiraSettingsQueryVariables>(SharedFieldsJiraSettingsDocument, options);
        }
export type SharedFieldsJiraSettingsQueryHookResult = ReturnType<typeof useSharedFieldsJiraSettingsQuery>;
export type SharedFieldsJiraSettingsLazyQueryHookResult = ReturnType<typeof useSharedFieldsJiraSettingsLazyQuery>;
export type SharedFieldsJiraSettingsQueryResult = Apollo.QueryResult<SharedFieldsJiraSettingsQuery, SharedFieldsJiraSettingsQueryVariables>;
export const PaginatedAssigneeFieldCurrentUserDocument = gql`
    query PaginatedAssigneeField_CurrentUser {
  currentUser {
    id
    skills {
      id
    }
  }
}
    `;

/**
 * __usePaginatedAssigneeFieldCurrentUserQuery__
 *
 * To run a query within a React component, call `usePaginatedAssigneeFieldCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedAssigneeFieldCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedAssigneeFieldCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaginatedAssigneeFieldCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<PaginatedAssigneeFieldCurrentUserQuery, PaginatedAssigneeFieldCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaginatedAssigneeFieldCurrentUserQuery, PaginatedAssigneeFieldCurrentUserQueryVariables>(PaginatedAssigneeFieldCurrentUserDocument, options);
      }
export function usePaginatedAssigneeFieldCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedAssigneeFieldCurrentUserQuery, PaginatedAssigneeFieldCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaginatedAssigneeFieldCurrentUserQuery, PaginatedAssigneeFieldCurrentUserQueryVariables>(PaginatedAssigneeFieldCurrentUserDocument, options);
        }
export type PaginatedAssigneeFieldCurrentUserQueryHookResult = ReturnType<typeof usePaginatedAssigneeFieldCurrentUserQuery>;
export type PaginatedAssigneeFieldCurrentUserLazyQueryHookResult = ReturnType<typeof usePaginatedAssigneeFieldCurrentUserLazyQuery>;
export type PaginatedAssigneeFieldCurrentUserQueryResult = Apollo.QueryResult<PaginatedAssigneeFieldCurrentUserQuery, PaginatedAssigneeFieldCurrentUserQueryVariables>;
export const DeleteTimeEntryDialogDeleteTimeRecordDocument = gql`
    mutation DeleteTimeEntryDialog_DeleteTimeRecord($id: ID!) {
  deleteTimeRecord(input: {id: $id}) {
    success
  }
}
    `;
export type DeleteTimeEntryDialogDeleteTimeRecordMutationFn = Apollo.MutationFunction<DeleteTimeEntryDialogDeleteTimeRecordMutation, DeleteTimeEntryDialogDeleteTimeRecordMutationVariables>;

/**
 * __useDeleteTimeEntryDialogDeleteTimeRecordMutation__
 *
 * To run a mutation, you first call `useDeleteTimeEntryDialogDeleteTimeRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTimeEntryDialogDeleteTimeRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTimeEntryDialogDeleteTimeRecordMutation, { data, loading, error }] = useDeleteTimeEntryDialogDeleteTimeRecordMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTimeEntryDialogDeleteTimeRecordMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTimeEntryDialogDeleteTimeRecordMutation, DeleteTimeEntryDialogDeleteTimeRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTimeEntryDialogDeleteTimeRecordMutation, DeleteTimeEntryDialogDeleteTimeRecordMutationVariables>(DeleteTimeEntryDialogDeleteTimeRecordDocument, options);
      }
export type DeleteTimeEntryDialogDeleteTimeRecordMutationHookResult = ReturnType<typeof useDeleteTimeEntryDialogDeleteTimeRecordMutation>;
export type DeleteTimeEntryDialogDeleteTimeRecordMutationResult = Apollo.MutationResult<DeleteTimeEntryDialogDeleteTimeRecordMutation>;
export type DeleteTimeEntryDialogDeleteTimeRecordMutationOptions = Apollo.BaseMutationOptions<DeleteTimeEntryDialogDeleteTimeRecordMutation, DeleteTimeEntryDialogDeleteTimeRecordMutationVariables>;
export const TimeEntryTableTaskTimeRecordsDocument = gql`
    query TimeEntryTable_TaskTimeRecords($taskId: ID!, $listInputs: ListInput) {
  task(id: $taskId) {
    id
    actualHours
    estimatedHours
  }
  taskTimeRecords(taskId: $taskId, listInputs: $listInputs) {
    pageInfo {
      ...PageInfoFragment
      __typename
    }
    timeRecords {
      id
      ...TimeEntryTable_TimeRecord
    }
  }
}
    ${PageInfoFragmentDoc}
${TimeEntryTableTimeRecordFragmentDoc}`;

/**
 * __useTimeEntryTableTaskTimeRecordsQuery__
 *
 * To run a query within a React component, call `useTimeEntryTableTaskTimeRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeEntryTableTaskTimeRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeEntryTableTaskTimeRecordsQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      listInputs: // value for 'listInputs'
 *   },
 * });
 */
export function useTimeEntryTableTaskTimeRecordsQuery(baseOptions: Apollo.QueryHookOptions<TimeEntryTableTaskTimeRecordsQuery, TimeEntryTableTaskTimeRecordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeEntryTableTaskTimeRecordsQuery, TimeEntryTableTaskTimeRecordsQueryVariables>(TimeEntryTableTaskTimeRecordsDocument, options);
      }
export function useTimeEntryTableTaskTimeRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeEntryTableTaskTimeRecordsQuery, TimeEntryTableTaskTimeRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeEntryTableTaskTimeRecordsQuery, TimeEntryTableTaskTimeRecordsQueryVariables>(TimeEntryTableTaskTimeRecordsDocument, options);
        }
export type TimeEntryTableTaskTimeRecordsQueryHookResult = ReturnType<typeof useTimeEntryTableTaskTimeRecordsQuery>;
export type TimeEntryTableTaskTimeRecordsLazyQueryHookResult = ReturnType<typeof useTimeEntryTableTaskTimeRecordsLazyQuery>;
export type TimeEntryTableTaskTimeRecordsQueryResult = Apollo.QueryResult<TimeEntryTableTaskTimeRecordsQuery, TimeEntryTableTaskTimeRecordsQueryVariables>;
export const FormRoleMultiSelectSkillCategoriesDocument = gql`
    query FormRoleMultiSelect_SkillCategories($id: ID!, $objectType: ProjectOrTemplateEnumType!) {
  projectOrTemplateSkills(id: $id, objectType: $objectType) {
    skillCategories {
      id
      name
      skills {
        ...FormRoleMultiSelect_Skill
      }
    }
  }
}
    ${FormRoleMultiSelectSkillFragmentDoc}`;

/**
 * __useFormRoleMultiSelectSkillCategoriesQuery__
 *
 * To run a query within a React component, call `useFormRoleMultiSelectSkillCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormRoleMultiSelectSkillCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormRoleMultiSelectSkillCategoriesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      objectType: // value for 'objectType'
 *   },
 * });
 */
export function useFormRoleMultiSelectSkillCategoriesQuery(baseOptions: Apollo.QueryHookOptions<FormRoleMultiSelectSkillCategoriesQuery, FormRoleMultiSelectSkillCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormRoleMultiSelectSkillCategoriesQuery, FormRoleMultiSelectSkillCategoriesQueryVariables>(FormRoleMultiSelectSkillCategoriesDocument, options);
      }
export function useFormRoleMultiSelectSkillCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormRoleMultiSelectSkillCategoriesQuery, FormRoleMultiSelectSkillCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormRoleMultiSelectSkillCategoriesQuery, FormRoleMultiSelectSkillCategoriesQueryVariables>(FormRoleMultiSelectSkillCategoriesDocument, options);
        }
export type FormRoleMultiSelectSkillCategoriesQueryHookResult = ReturnType<typeof useFormRoleMultiSelectSkillCategoriesQuery>;
export type FormRoleMultiSelectSkillCategoriesLazyQueryHookResult = ReturnType<typeof useFormRoleMultiSelectSkillCategoriesLazyQuery>;
export type FormRoleMultiSelectSkillCategoriesQueryResult = Apollo.QueryResult<FormRoleMultiSelectSkillCategoriesQuery, FormRoleMultiSelectSkillCategoriesQueryVariables>;
export const ParticipantsTaskParticipantsUsersDocument = gql`
    query Participants_TaskParticipantsUsers($organizationId: ID!, $projectId: ID, $type: TaskResponsibilityEnumType!, $listInputs: ListInput) {
  taskParticipantsUsers(
    organizationId: $organizationId
    projectId: $projectId
    type: $type
    listInputs: $listInputs
  ) {
    users {
      id
      ...AssigneeField_User
      __typename
    }
    pageInfo {
      ...PageInfoFragment
      __typename
    }
    __typename
  }
}
    ${AssigneeFieldUserFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useParticipantsTaskParticipantsUsersQuery__
 *
 * To run a query within a React component, call `useParticipantsTaskParticipantsUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useParticipantsTaskParticipantsUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParticipantsTaskParticipantsUsersQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      projectId: // value for 'projectId'
 *      type: // value for 'type'
 *      listInputs: // value for 'listInputs'
 *   },
 * });
 */
export function useParticipantsTaskParticipantsUsersQuery(baseOptions: Apollo.QueryHookOptions<ParticipantsTaskParticipantsUsersQuery, ParticipantsTaskParticipantsUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ParticipantsTaskParticipantsUsersQuery, ParticipantsTaskParticipantsUsersQueryVariables>(ParticipantsTaskParticipantsUsersDocument, options);
      }
export function useParticipantsTaskParticipantsUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParticipantsTaskParticipantsUsersQuery, ParticipantsTaskParticipantsUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ParticipantsTaskParticipantsUsersQuery, ParticipantsTaskParticipantsUsersQueryVariables>(ParticipantsTaskParticipantsUsersDocument, options);
        }
export type ParticipantsTaskParticipantsUsersQueryHookResult = ReturnType<typeof useParticipantsTaskParticipantsUsersQuery>;
export type ParticipantsTaskParticipantsUsersLazyQueryHookResult = ReturnType<typeof useParticipantsTaskParticipantsUsersLazyQuery>;
export type ParticipantsTaskParticipantsUsersQueryResult = Apollo.QueryResult<ParticipantsTaskParticipantsUsersQuery, ParticipantsTaskParticipantsUsersQueryVariables>;
export const RoleMultiSelectSkillCategoriesDocument = gql`
    query RoleMultiSelect_SkillCategories($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    ...RoleMultiSelect_Organization
  }
}
    ${RoleMultiSelectOrganizationFragmentDoc}`;

/**
 * __useRoleMultiSelectSkillCategoriesQuery__
 *
 * To run a query within a React component, call `useRoleMultiSelectSkillCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoleMultiSelectSkillCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoleMultiSelectSkillCategoriesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useRoleMultiSelectSkillCategoriesQuery(baseOptions: Apollo.QueryHookOptions<RoleMultiSelectSkillCategoriesQuery, RoleMultiSelectSkillCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoleMultiSelectSkillCategoriesQuery, RoleMultiSelectSkillCategoriesQueryVariables>(RoleMultiSelectSkillCategoriesDocument, options);
      }
export function useRoleMultiSelectSkillCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoleMultiSelectSkillCategoriesQuery, RoleMultiSelectSkillCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoleMultiSelectSkillCategoriesQuery, RoleMultiSelectSkillCategoriesQueryVariables>(RoleMultiSelectSkillCategoriesDocument, options);
        }
export type RoleMultiSelectSkillCategoriesQueryHookResult = ReturnType<typeof useRoleMultiSelectSkillCategoriesQuery>;
export type RoleMultiSelectSkillCategoriesLazyQueryHookResult = ReturnType<typeof useRoleMultiSelectSkillCategoriesLazyQuery>;
export type RoleMultiSelectSkillCategoriesQueryResult = Apollo.QueryResult<RoleMultiSelectSkillCategoriesQuery, RoleMultiSelectSkillCategoriesQueryVariables>;
export const TaskFormContextProjectTeamByParticipantsDocument = gql`
    query TaskFormContext_ProjectTeamByParticipants($projectId: ID!) {
  projectTeam(projectId: $projectId) {
    id
    ...TaskFormContext_User
  }
}
    ${TaskFormContextUserFragmentDoc}`;

/**
 * __useTaskFormContextProjectTeamByParticipantsQuery__
 *
 * To run a query within a React component, call `useTaskFormContextProjectTeamByParticipantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskFormContextProjectTeamByParticipantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskFormContextProjectTeamByParticipantsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useTaskFormContextProjectTeamByParticipantsQuery(baseOptions: Apollo.QueryHookOptions<TaskFormContextProjectTeamByParticipantsQuery, TaskFormContextProjectTeamByParticipantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskFormContextProjectTeamByParticipantsQuery, TaskFormContextProjectTeamByParticipantsQueryVariables>(TaskFormContextProjectTeamByParticipantsDocument, options);
      }
export function useTaskFormContextProjectTeamByParticipantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskFormContextProjectTeamByParticipantsQuery, TaskFormContextProjectTeamByParticipantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskFormContextProjectTeamByParticipantsQuery, TaskFormContextProjectTeamByParticipantsQueryVariables>(TaskFormContextProjectTeamByParticipantsDocument, options);
        }
export type TaskFormContextProjectTeamByParticipantsQueryHookResult = ReturnType<typeof useTaskFormContextProjectTeamByParticipantsQuery>;
export type TaskFormContextProjectTeamByParticipantsLazyQueryHookResult = ReturnType<typeof useTaskFormContextProjectTeamByParticipantsLazyQuery>;
export type TaskFormContextProjectTeamByParticipantsQueryResult = Apollo.QueryResult<TaskFormContextProjectTeamByParticipantsQuery, TaskFormContextProjectTeamByParticipantsQueryVariables>;
export const TaskFormContextPotentialTaskDependenciesDocument = gql`
    query TaskFormContext_PotentialTaskDependencies($taskId: ID, $milestoneId: ID!, $taskGroupId: ID) {
  potentialDependentTasks(
    taskId: $taskId
    milestoneId: $milestoneId
    taskGroupId: $taskGroupId
  ) {
    id
    name
    completed
    dueOn
  }
}
    `;

/**
 * __useTaskFormContextPotentialTaskDependenciesQuery__
 *
 * To run a query within a React component, call `useTaskFormContextPotentialTaskDependenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskFormContextPotentialTaskDependenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskFormContextPotentialTaskDependenciesQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      milestoneId: // value for 'milestoneId'
 *      taskGroupId: // value for 'taskGroupId'
 *   },
 * });
 */
export function useTaskFormContextPotentialTaskDependenciesQuery(baseOptions: Apollo.QueryHookOptions<TaskFormContextPotentialTaskDependenciesQuery, TaskFormContextPotentialTaskDependenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskFormContextPotentialTaskDependenciesQuery, TaskFormContextPotentialTaskDependenciesQueryVariables>(TaskFormContextPotentialTaskDependenciesDocument, options);
      }
export function useTaskFormContextPotentialTaskDependenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskFormContextPotentialTaskDependenciesQuery, TaskFormContextPotentialTaskDependenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskFormContextPotentialTaskDependenciesQuery, TaskFormContextPotentialTaskDependenciesQueryVariables>(TaskFormContextPotentialTaskDependenciesDocument, options);
        }
export type TaskFormContextPotentialTaskDependenciesQueryHookResult = ReturnType<typeof useTaskFormContextPotentialTaskDependenciesQuery>;
export type TaskFormContextPotentialTaskDependenciesLazyQueryHookResult = ReturnType<typeof useTaskFormContextPotentialTaskDependenciesLazyQuery>;
export type TaskFormContextPotentialTaskDependenciesQueryResult = Apollo.QueryResult<TaskFormContextPotentialTaskDependenciesQuery, TaskFormContextPotentialTaskDependenciesQueryVariables>;
export const TaskFormContextPotentialMilestoneDependenciesDocument = gql`
    query TaskFormContext_PotentialMilestoneDependencies($milestoneId: ID!) {
  potentialDependentMilestones(milestoneId: $milestoneId) {
    id
    name
    completed
    forecastedEndOn
  }
}
    `;

/**
 * __useTaskFormContextPotentialMilestoneDependenciesQuery__
 *
 * To run a query within a React component, call `useTaskFormContextPotentialMilestoneDependenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskFormContextPotentialMilestoneDependenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskFormContextPotentialMilestoneDependenciesQuery({
 *   variables: {
 *      milestoneId: // value for 'milestoneId'
 *   },
 * });
 */
export function useTaskFormContextPotentialMilestoneDependenciesQuery(baseOptions: Apollo.QueryHookOptions<TaskFormContextPotentialMilestoneDependenciesQuery, TaskFormContextPotentialMilestoneDependenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskFormContextPotentialMilestoneDependenciesQuery, TaskFormContextPotentialMilestoneDependenciesQueryVariables>(TaskFormContextPotentialMilestoneDependenciesDocument, options);
      }
export function useTaskFormContextPotentialMilestoneDependenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskFormContextPotentialMilestoneDependenciesQuery, TaskFormContextPotentialMilestoneDependenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskFormContextPotentialMilestoneDependenciesQuery, TaskFormContextPotentialMilestoneDependenciesQueryVariables>(TaskFormContextPotentialMilestoneDependenciesDocument, options);
        }
export type TaskFormContextPotentialMilestoneDependenciesQueryHookResult = ReturnType<typeof useTaskFormContextPotentialMilestoneDependenciesQuery>;
export type TaskFormContextPotentialMilestoneDependenciesLazyQueryHookResult = ReturnType<typeof useTaskFormContextPotentialMilestoneDependenciesLazyQuery>;
export type TaskFormContextPotentialMilestoneDependenciesQueryResult = Apollo.QueryResult<TaskFormContextPotentialMilestoneDependenciesQuery, TaskFormContextPotentialMilestoneDependenciesQueryVariables>;
export const TaskFormContextPotentialTaskGroupDependenciesDocument = gql`
    query TaskFormContext_PotentialTaskGroupDependencies($taskId: ID, $milestoneId: ID!, $taskGroupId: ID) {
  potentialDependentTaskGroups(
    taskId: $taskId
    milestoneId: $milestoneId
    taskGroupId: $taskGroupId
  ) {
    id
    name
    completed
    forecastedEndOn
  }
}
    `;

/**
 * __useTaskFormContextPotentialTaskGroupDependenciesQuery__
 *
 * To run a query within a React component, call `useTaskFormContextPotentialTaskGroupDependenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskFormContextPotentialTaskGroupDependenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskFormContextPotentialTaskGroupDependenciesQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      milestoneId: // value for 'milestoneId'
 *      taskGroupId: // value for 'taskGroupId'
 *   },
 * });
 */
export function useTaskFormContextPotentialTaskGroupDependenciesQuery(baseOptions: Apollo.QueryHookOptions<TaskFormContextPotentialTaskGroupDependenciesQuery, TaskFormContextPotentialTaskGroupDependenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskFormContextPotentialTaskGroupDependenciesQuery, TaskFormContextPotentialTaskGroupDependenciesQueryVariables>(TaskFormContextPotentialTaskGroupDependenciesDocument, options);
      }
export function useTaskFormContextPotentialTaskGroupDependenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskFormContextPotentialTaskGroupDependenciesQuery, TaskFormContextPotentialTaskGroupDependenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskFormContextPotentialTaskGroupDependenciesQuery, TaskFormContextPotentialTaskGroupDependenciesQueryVariables>(TaskFormContextPotentialTaskGroupDependenciesDocument, options);
        }
export type TaskFormContextPotentialTaskGroupDependenciesQueryHookResult = ReturnType<typeof useTaskFormContextPotentialTaskGroupDependenciesQuery>;
export type TaskFormContextPotentialTaskGroupDependenciesLazyQueryHookResult = ReturnType<typeof useTaskFormContextPotentialTaskGroupDependenciesLazyQuery>;
export type TaskFormContextPotentialTaskGroupDependenciesQueryResult = Apollo.QueryResult<TaskFormContextPotentialTaskGroupDependenciesQuery, TaskFormContextPotentialTaskGroupDependenciesQueryVariables>;
export const TaskFormContextPotentialTemplateDependencyDocument = gql`
    query TaskFormContext_PotentialTemplateDependency($milestoneId: ID!) {
  potentialDependentTemplate(milestoneId: $milestoneId) {
    id
    name
    completed
    milestones {
      forecastedEndOn
    }
  }
}
    `;

/**
 * __useTaskFormContextPotentialTemplateDependencyQuery__
 *
 * To run a query within a React component, call `useTaskFormContextPotentialTemplateDependencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskFormContextPotentialTemplateDependencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskFormContextPotentialTemplateDependencyQuery({
 *   variables: {
 *      milestoneId: // value for 'milestoneId'
 *   },
 * });
 */
export function useTaskFormContextPotentialTemplateDependencyQuery(baseOptions: Apollo.QueryHookOptions<TaskFormContextPotentialTemplateDependencyQuery, TaskFormContextPotentialTemplateDependencyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskFormContextPotentialTemplateDependencyQuery, TaskFormContextPotentialTemplateDependencyQueryVariables>(TaskFormContextPotentialTemplateDependencyDocument, options);
      }
export function useTaskFormContextPotentialTemplateDependencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskFormContextPotentialTemplateDependencyQuery, TaskFormContextPotentialTemplateDependencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskFormContextPotentialTemplateDependencyQuery, TaskFormContextPotentialTemplateDependencyQueryVariables>(TaskFormContextPotentialTemplateDependencyDocument, options);
        }
export type TaskFormContextPotentialTemplateDependencyQueryHookResult = ReturnType<typeof useTaskFormContextPotentialTemplateDependencyQuery>;
export type TaskFormContextPotentialTemplateDependencyLazyQueryHookResult = ReturnType<typeof useTaskFormContextPotentialTemplateDependencyLazyQuery>;
export type TaskFormContextPotentialTemplateDependencyQueryResult = Apollo.QueryResult<TaskFormContextPotentialTemplateDependencyQuery, TaskFormContextPotentialTemplateDependencyQueryVariables>;
export const TaskFormContextPotentialTaskAssigneesDocument = gql`
    query TaskFormContext_PotentialTaskAssignees($milestoneId: ID!) {
  potentialTaskAssignees(milestoneId: $milestoneId) {
    id
    ...AssigneeField_User
  }
}
    ${AssigneeFieldUserFragmentDoc}`;

/**
 * __useTaskFormContextPotentialTaskAssigneesQuery__
 *
 * To run a query within a React component, call `useTaskFormContextPotentialTaskAssigneesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskFormContextPotentialTaskAssigneesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskFormContextPotentialTaskAssigneesQuery({
 *   variables: {
 *      milestoneId: // value for 'milestoneId'
 *   },
 * });
 */
export function useTaskFormContextPotentialTaskAssigneesQuery(baseOptions: Apollo.QueryHookOptions<TaskFormContextPotentialTaskAssigneesQuery, TaskFormContextPotentialTaskAssigneesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskFormContextPotentialTaskAssigneesQuery, TaskFormContextPotentialTaskAssigneesQueryVariables>(TaskFormContextPotentialTaskAssigneesDocument, options);
      }
export function useTaskFormContextPotentialTaskAssigneesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskFormContextPotentialTaskAssigneesQuery, TaskFormContextPotentialTaskAssigneesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskFormContextPotentialTaskAssigneesQuery, TaskFormContextPotentialTaskAssigneesQueryVariables>(TaskFormContextPotentialTaskAssigneesDocument, options);
        }
export type TaskFormContextPotentialTaskAssigneesQueryHookResult = ReturnType<typeof useTaskFormContextPotentialTaskAssigneesQuery>;
export type TaskFormContextPotentialTaskAssigneesLazyQueryHookResult = ReturnType<typeof useTaskFormContextPotentialTaskAssigneesLazyQuery>;
export type TaskFormContextPotentialTaskAssigneesQueryResult = Apollo.QueryResult<TaskFormContextPotentialTaskAssigneesQuery, TaskFormContextPotentialTaskAssigneesQueryVariables>;
export const TaskFormContextPaginatedPotentialSingleTaskAssigneesDocument = gql`
    query TaskFormContext_PaginatedPotentialSingleTaskAssignees($milestoneId: ID!, $listInput: ListInput, $responsibility: TaskResponsibilityEnumType, $skillId: ID, $skillIds: [ID!]) {
  paginatedPotentialTaskAssignees(
    milestoneId: $milestoneId
    listInputs: $listInput
    responsibility: $responsibility
    skillId: $skillId
    skillIds: $skillIds
  ) {
    users {
      id
      ...AssigneeField_User
    }
    pageInfo {
      ...PageInfoFragment
      __typename
    }
  }
}
    ${AssigneeFieldUserFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useTaskFormContextPaginatedPotentialSingleTaskAssigneesQuery__
 *
 * To run a query within a React component, call `useTaskFormContextPaginatedPotentialSingleTaskAssigneesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskFormContextPaginatedPotentialSingleTaskAssigneesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskFormContextPaginatedPotentialSingleTaskAssigneesQuery({
 *   variables: {
 *      milestoneId: // value for 'milestoneId'
 *      listInput: // value for 'listInput'
 *      responsibility: // value for 'responsibility'
 *      skillId: // value for 'skillId'
 *      skillIds: // value for 'skillIds'
 *   },
 * });
 */
export function useTaskFormContextPaginatedPotentialSingleTaskAssigneesQuery(baseOptions: Apollo.QueryHookOptions<TaskFormContextPaginatedPotentialSingleTaskAssigneesQuery, TaskFormContextPaginatedPotentialSingleTaskAssigneesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskFormContextPaginatedPotentialSingleTaskAssigneesQuery, TaskFormContextPaginatedPotentialSingleTaskAssigneesQueryVariables>(TaskFormContextPaginatedPotentialSingleTaskAssigneesDocument, options);
      }
export function useTaskFormContextPaginatedPotentialSingleTaskAssigneesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskFormContextPaginatedPotentialSingleTaskAssigneesQuery, TaskFormContextPaginatedPotentialSingleTaskAssigneesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskFormContextPaginatedPotentialSingleTaskAssigneesQuery, TaskFormContextPaginatedPotentialSingleTaskAssigneesQueryVariables>(TaskFormContextPaginatedPotentialSingleTaskAssigneesDocument, options);
        }
export type TaskFormContextPaginatedPotentialSingleTaskAssigneesQueryHookResult = ReturnType<typeof useTaskFormContextPaginatedPotentialSingleTaskAssigneesQuery>;
export type TaskFormContextPaginatedPotentialSingleTaskAssigneesLazyQueryHookResult = ReturnType<typeof useTaskFormContextPaginatedPotentialSingleTaskAssigneesLazyQuery>;
export type TaskFormContextPaginatedPotentialSingleTaskAssigneesQueryResult = Apollo.QueryResult<TaskFormContextPaginatedPotentialSingleTaskAssigneesQuery, TaskFormContextPaginatedPotentialSingleTaskAssigneesQueryVariables>;
export const TaskFormContextMilestoneInfoDocument = gql`
    query TaskFormContext_MilestoneInfo($milestoneId: ID!) {
  milestone(id: $milestoneId) {
    id
    isFirstOfProject
    isFirstOfTemplate
  }
}
    `;

/**
 * __useTaskFormContextMilestoneInfoQuery__
 *
 * To run a query within a React component, call `useTaskFormContextMilestoneInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskFormContextMilestoneInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskFormContextMilestoneInfoQuery({
 *   variables: {
 *      milestoneId: // value for 'milestoneId'
 *   },
 * });
 */
export function useTaskFormContextMilestoneInfoQuery(baseOptions: Apollo.QueryHookOptions<TaskFormContextMilestoneInfoQuery, TaskFormContextMilestoneInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskFormContextMilestoneInfoQuery, TaskFormContextMilestoneInfoQueryVariables>(TaskFormContextMilestoneInfoDocument, options);
      }
export function useTaskFormContextMilestoneInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskFormContextMilestoneInfoQuery, TaskFormContextMilestoneInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskFormContextMilestoneInfoQuery, TaskFormContextMilestoneInfoQueryVariables>(TaskFormContextMilestoneInfoDocument, options);
        }
export type TaskFormContextMilestoneInfoQueryHookResult = ReturnType<typeof useTaskFormContextMilestoneInfoQuery>;
export type TaskFormContextMilestoneInfoLazyQueryHookResult = ReturnType<typeof useTaskFormContextMilestoneInfoLazyQuery>;
export type TaskFormContextMilestoneInfoQueryResult = Apollo.QueryResult<TaskFormContextMilestoneInfoQuery, TaskFormContextMilestoneInfoQueryVariables>;
export const TaskFormContextTaskCountQueryDocument = gql`
    query TaskFormContext_TaskCountQuery($milestoneId: ID!) {
  milestoneTaskCount(milestoneId: $milestoneId)
}
    `;

/**
 * __useTaskFormContextTaskCountQuery__
 *
 * To run a query within a React component, call `useTaskFormContextTaskCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskFormContextTaskCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskFormContextTaskCountQuery({
 *   variables: {
 *      milestoneId: // value for 'milestoneId'
 *   },
 * });
 */
export function useTaskFormContextTaskCountQuery(baseOptions: Apollo.QueryHookOptions<TaskFormContextTaskCountQuery, TaskFormContextTaskCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskFormContextTaskCountQuery, TaskFormContextTaskCountQueryVariables>(TaskFormContextTaskCountQueryDocument, options);
      }
export function useTaskFormContextTaskCountQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskFormContextTaskCountQuery, TaskFormContextTaskCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskFormContextTaskCountQuery, TaskFormContextTaskCountQueryVariables>(TaskFormContextTaskCountQueryDocument, options);
        }
export type TaskFormContextTaskCountQueryHookResult = ReturnType<typeof useTaskFormContextTaskCountQuery>;
export type TaskFormContextTaskCountQueryLazyQueryHookResult = ReturnType<typeof useTaskFormContextTaskCountQueryLazyQuery>;
export type TaskFormContextTaskCountQueryQueryResult = Apollo.QueryResult<TaskFormContextTaskCountQuery, TaskFormContextTaskCountQueryVariables>;
export const NotesOnNoteAddedSubscriptionDocument = gql`
    subscription Notes_OnNoteAddedSubscription($noteableId: ID!) {
  noteAdded(noteableId: $noteableId) {
    id
    ...NotesList_Note
  }
}
    ${NotesListNoteFragmentDoc}`;

/**
 * __useNotesOnNoteAddedSubscription__
 *
 * To run a query within a React component, call `useNotesOnNoteAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNotesOnNoteAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotesOnNoteAddedSubscription({
 *   variables: {
 *      noteableId: // value for 'noteableId'
 *   },
 * });
 */
export function useNotesOnNoteAddedSubscription(baseOptions: Apollo.SubscriptionHookOptions<NotesOnNoteAddedSubscription, NotesOnNoteAddedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NotesOnNoteAddedSubscription, NotesOnNoteAddedSubscriptionVariables>(NotesOnNoteAddedSubscriptionDocument, options);
      }
export type NotesOnNoteAddedSubscriptionHookResult = ReturnType<typeof useNotesOnNoteAddedSubscription>;
export type NotesOnNoteAddedSubscriptionSubscriptionResult = Apollo.SubscriptionResult<NotesOnNoteAddedSubscription>;
export const NotesPaginatedNotesDocument = gql`
    query Notes_PaginatedNotes($noteableId: ID!, $noteableType: NoteableEnumType!, $listInput: ListInput) {
  noteablePaginatedNotes(
    noteableId: $noteableId
    noteableType: $noteableType
    listInputs: $listInput
  ) {
    pageInfo {
      ...PageInfoFragment
    }
    notes {
      id
      ...Notes_Note
    }
  }
}
    ${PageInfoFragmentDoc}
${NotesNoteFragmentDoc}`;

/**
 * __useNotesPaginatedNotesQuery__
 *
 * To run a query within a React component, call `useNotesPaginatedNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotesPaginatedNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotesPaginatedNotesQuery({
 *   variables: {
 *      noteableId: // value for 'noteableId'
 *      noteableType: // value for 'noteableType'
 *      listInput: // value for 'listInput'
 *   },
 * });
 */
export function useNotesPaginatedNotesQuery(baseOptions: Apollo.QueryHookOptions<NotesPaginatedNotesQuery, NotesPaginatedNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotesPaginatedNotesQuery, NotesPaginatedNotesQueryVariables>(NotesPaginatedNotesDocument, options);
      }
export function useNotesPaginatedNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotesPaginatedNotesQuery, NotesPaginatedNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotesPaginatedNotesQuery, NotesPaginatedNotesQueryVariables>(NotesPaginatedNotesDocument, options);
        }
export type NotesPaginatedNotesQueryHookResult = ReturnType<typeof useNotesPaginatedNotesQuery>;
export type NotesPaginatedNotesLazyQueryHookResult = ReturnType<typeof useNotesPaginatedNotesLazyQuery>;
export type NotesPaginatedNotesQueryResult = Apollo.QueryResult<NotesPaginatedNotesQuery, NotesPaginatedNotesQueryVariables>;
export const CreateProjectNoteDocument = gql`
    mutation createProjectNote($note: createNoteInput!) {
  createNote(input: $note) {
    note {
      ...Notes_Note
    }
  }
}
    ${NotesNoteFragmentDoc}`;
export type CreateProjectNoteMutationFn = Apollo.MutationFunction<CreateProjectNoteMutation, CreateProjectNoteMutationVariables>;

/**
 * __useCreateProjectNoteMutation__
 *
 * To run a mutation, you first call `useCreateProjectNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectNoteMutation, { data, loading, error }] = useCreateProjectNoteMutation({
 *   variables: {
 *      note: // value for 'note'
 *   },
 * });
 */
export function useCreateProjectNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectNoteMutation, CreateProjectNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectNoteMutation, CreateProjectNoteMutationVariables>(CreateProjectNoteDocument, options);
      }
export type CreateProjectNoteMutationHookResult = ReturnType<typeof useCreateProjectNoteMutation>;
export type CreateProjectNoteMutationResult = Apollo.MutationResult<CreateProjectNoteMutation>;
export type CreateProjectNoteMutationOptions = Apollo.BaseMutationOptions<CreateProjectNoteMutation, CreateProjectNoteMutationVariables>;
export const UpdateNoteToProjectUpdateNoteDocument = gql`
    mutation UpdateNoteToProject_UpdateNote($note: updateNoteInput!) {
  updateNote(input: $note) {
    note {
      id
      raw
      createdAt
      deletable
      internalOnly
      user {
        id
        firstName
        lastName
        avatar {
          originalUrl
        }
      }
      attachments {
        id
        fileName
        url
        internalOnly
      }
    }
  }
}
    `;
export type UpdateNoteToProjectUpdateNoteMutationFn = Apollo.MutationFunction<UpdateNoteToProjectUpdateNoteMutation, UpdateNoteToProjectUpdateNoteMutationVariables>;

/**
 * __useUpdateNoteToProjectUpdateNoteMutation__
 *
 * To run a mutation, you first call `useUpdateNoteToProjectUpdateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNoteToProjectUpdateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNoteToProjectUpdateNoteMutation, { data, loading, error }] = useUpdateNoteToProjectUpdateNoteMutation({
 *   variables: {
 *      note: // value for 'note'
 *   },
 * });
 */
export function useUpdateNoteToProjectUpdateNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNoteToProjectUpdateNoteMutation, UpdateNoteToProjectUpdateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNoteToProjectUpdateNoteMutation, UpdateNoteToProjectUpdateNoteMutationVariables>(UpdateNoteToProjectUpdateNoteDocument, options);
      }
export type UpdateNoteToProjectUpdateNoteMutationHookResult = ReturnType<typeof useUpdateNoteToProjectUpdateNoteMutation>;
export type UpdateNoteToProjectUpdateNoteMutationResult = Apollo.MutationResult<UpdateNoteToProjectUpdateNoteMutation>;
export type UpdateNoteToProjectUpdateNoteMutationOptions = Apollo.BaseMutationOptions<UpdateNoteToProjectUpdateNoteMutation, UpdateNoteToProjectUpdateNoteMutationVariables>;
export const RemoveNoteDialogDeleteNoteDocument = gql`
    mutation RemoveNoteDialog_DeleteNote($id: ID!) {
  deleteNote(id: $id) {
    success
  }
}
    `;
export type RemoveNoteDialogDeleteNoteMutationFn = Apollo.MutationFunction<RemoveNoteDialogDeleteNoteMutation, RemoveNoteDialogDeleteNoteMutationVariables>;

/**
 * __useRemoveNoteDialogDeleteNoteMutation__
 *
 * To run a mutation, you first call `useRemoveNoteDialogDeleteNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveNoteDialogDeleteNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeNoteDialogDeleteNoteMutation, { data, loading, error }] = useRemoveNoteDialogDeleteNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveNoteDialogDeleteNoteMutation(baseOptions?: Apollo.MutationHookOptions<RemoveNoteDialogDeleteNoteMutation, RemoveNoteDialogDeleteNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveNoteDialogDeleteNoteMutation, RemoveNoteDialogDeleteNoteMutationVariables>(RemoveNoteDialogDeleteNoteDocument, options);
      }
export type RemoveNoteDialogDeleteNoteMutationHookResult = ReturnType<typeof useRemoveNoteDialogDeleteNoteMutation>;
export type RemoveNoteDialogDeleteNoteMutationResult = Apollo.MutationResult<RemoveNoteDialogDeleteNoteMutation>;
export type RemoveNoteDialogDeleteNoteMutationOptions = Apollo.BaseMutationOptions<RemoveNoteDialogDeleteNoteMutation, RemoveNoteDialogDeleteNoteMutationVariables>;
export const NotesListItemUpdateNoteDocument = gql`
    mutation NotesListItem_UpdateNote($note: updateNoteInput!) {
  updateNote(input: $note) {
    note {
      id
      ...NotesListItem_Note
    }
  }
}
    ${NotesListItemNoteFragmentDoc}`;
export type NotesListItemUpdateNoteMutationFn = Apollo.MutationFunction<NotesListItemUpdateNoteMutation, NotesListItemUpdateNoteMutationVariables>;

/**
 * __useNotesListItemUpdateNoteMutation__
 *
 * To run a mutation, you first call `useNotesListItemUpdateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotesListItemUpdateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notesListItemUpdateNoteMutation, { data, loading, error }] = useNotesListItemUpdateNoteMutation({
 *   variables: {
 *      note: // value for 'note'
 *   },
 * });
 */
export function useNotesListItemUpdateNoteMutation(baseOptions?: Apollo.MutationHookOptions<NotesListItemUpdateNoteMutation, NotesListItemUpdateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotesListItemUpdateNoteMutation, NotesListItemUpdateNoteMutationVariables>(NotesListItemUpdateNoteDocument, options);
      }
export type NotesListItemUpdateNoteMutationHookResult = ReturnType<typeof useNotesListItemUpdateNoteMutation>;
export type NotesListItemUpdateNoteMutationResult = Apollo.MutationResult<NotesListItemUpdateNoteMutation>;
export type NotesListItemUpdateNoteMutationOptions = Apollo.BaseMutationOptions<NotesListItemUpdateNoteMutation, NotesListItemUpdateNoteMutationVariables>;
export const NotesListItemCreateNoteDocument = gql`
    mutation NotesListItem_CreateNote($note: createNoteInput!) {
  createNote(input: $note) {
    note {
      id
      ...NotesListItem_Note
    }
  }
}
    ${NotesListItemNoteFragmentDoc}`;
export type NotesListItemCreateNoteMutationFn = Apollo.MutationFunction<NotesListItemCreateNoteMutation, NotesListItemCreateNoteMutationVariables>;

/**
 * __useNotesListItemCreateNoteMutation__
 *
 * To run a mutation, you first call `useNotesListItemCreateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotesListItemCreateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notesListItemCreateNoteMutation, { data, loading, error }] = useNotesListItemCreateNoteMutation({
 *   variables: {
 *      note: // value for 'note'
 *   },
 * });
 */
export function useNotesListItemCreateNoteMutation(baseOptions?: Apollo.MutationHookOptions<NotesListItemCreateNoteMutation, NotesListItemCreateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotesListItemCreateNoteMutation, NotesListItemCreateNoteMutationVariables>(NotesListItemCreateNoteDocument, options);
      }
export type NotesListItemCreateNoteMutationHookResult = ReturnType<typeof useNotesListItemCreateNoteMutation>;
export type NotesListItemCreateNoteMutationResult = Apollo.MutationResult<NotesListItemCreateNoteMutation>;
export type NotesListItemCreateNoteMutationOptions = Apollo.BaseMutationOptions<NotesListItemCreateNoteMutation, NotesListItemCreateNoteMutationVariables>;
export const AddCustomerUsersPotentialProjectUsersDocument = gql`
    query AddCustomerUsers_PotentialProjectUsers($projectId: ID!, $organizationId: ID!) {
  potentialProjectUsers(projectId: $projectId, organizationId: $organizationId) {
    id
    ...AddCustomerUsers_CustomerUser
  }
}
    ${AddCustomerUsersCustomerUserFragmentDoc}`;

/**
 * __useAddCustomerUsersPotentialProjectUsersQuery__
 *
 * To run a query within a React component, call `useAddCustomerUsersPotentialProjectUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddCustomerUsersPotentialProjectUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddCustomerUsersPotentialProjectUsersQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useAddCustomerUsersPotentialProjectUsersQuery(baseOptions: Apollo.QueryHookOptions<AddCustomerUsersPotentialProjectUsersQuery, AddCustomerUsersPotentialProjectUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddCustomerUsersPotentialProjectUsersQuery, AddCustomerUsersPotentialProjectUsersQueryVariables>(AddCustomerUsersPotentialProjectUsersDocument, options);
      }
export function useAddCustomerUsersPotentialProjectUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddCustomerUsersPotentialProjectUsersQuery, AddCustomerUsersPotentialProjectUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddCustomerUsersPotentialProjectUsersQuery, AddCustomerUsersPotentialProjectUsersQueryVariables>(AddCustomerUsersPotentialProjectUsersDocument, options);
        }
export type AddCustomerUsersPotentialProjectUsersQueryHookResult = ReturnType<typeof useAddCustomerUsersPotentialProjectUsersQuery>;
export type AddCustomerUsersPotentialProjectUsersLazyQueryHookResult = ReturnType<typeof useAddCustomerUsersPotentialProjectUsersLazyQuery>;
export type AddCustomerUsersPotentialProjectUsersQueryResult = Apollo.QueryResult<AddCustomerUsersPotentialProjectUsersQuery, AddCustomerUsersPotentialProjectUsersQueryVariables>;
export const AddCustomerUsersSendWelcomeEmailPreviewDocument = gql`
    mutation AddCustomerUsers_SendWelcomeEmailPreview($projectId: ID!) {
  sendWelcomeEmailPreview(input: {projectId: $projectId}) {
    success
  }
}
    `;
export type AddCustomerUsersSendWelcomeEmailPreviewMutationFn = Apollo.MutationFunction<AddCustomerUsersSendWelcomeEmailPreviewMutation, AddCustomerUsersSendWelcomeEmailPreviewMutationVariables>;

/**
 * __useAddCustomerUsersSendWelcomeEmailPreviewMutation__
 *
 * To run a mutation, you first call `useAddCustomerUsersSendWelcomeEmailPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCustomerUsersSendWelcomeEmailPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCustomerUsersSendWelcomeEmailPreviewMutation, { data, loading, error }] = useAddCustomerUsersSendWelcomeEmailPreviewMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useAddCustomerUsersSendWelcomeEmailPreviewMutation(baseOptions?: Apollo.MutationHookOptions<AddCustomerUsersSendWelcomeEmailPreviewMutation, AddCustomerUsersSendWelcomeEmailPreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCustomerUsersSendWelcomeEmailPreviewMutation, AddCustomerUsersSendWelcomeEmailPreviewMutationVariables>(AddCustomerUsersSendWelcomeEmailPreviewDocument, options);
      }
export type AddCustomerUsersSendWelcomeEmailPreviewMutationHookResult = ReturnType<typeof useAddCustomerUsersSendWelcomeEmailPreviewMutation>;
export type AddCustomerUsersSendWelcomeEmailPreviewMutationResult = Apollo.MutationResult<AddCustomerUsersSendWelcomeEmailPreviewMutation>;
export type AddCustomerUsersSendWelcomeEmailPreviewMutationOptions = Apollo.BaseMutationOptions<AddCustomerUsersSendWelcomeEmailPreviewMutation, AddCustomerUsersSendWelcomeEmailPreviewMutationVariables>;
export const AddInternalUsersPotentialInternalProjectUsersDocument = gql`
    query AddInternalUsers_PotentialInternalProjectUsers($projectId: ID!) {
  potentialProjectUsers(projectId: $projectId) {
    id
    ...AddInternalUsers_User
    ...UserMenuOption_User
  }
}
    ${AddInternalUsersUserFragmentDoc}
${UserMenuOptionUserFragmentDoc}`;

/**
 * __useAddInternalUsersPotentialInternalProjectUsersQuery__
 *
 * To run a query within a React component, call `useAddInternalUsersPotentialInternalProjectUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddInternalUsersPotentialInternalProjectUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddInternalUsersPotentialInternalProjectUsersQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useAddInternalUsersPotentialInternalProjectUsersQuery(baseOptions: Apollo.QueryHookOptions<AddInternalUsersPotentialInternalProjectUsersQuery, AddInternalUsersPotentialInternalProjectUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddInternalUsersPotentialInternalProjectUsersQuery, AddInternalUsersPotentialInternalProjectUsersQueryVariables>(AddInternalUsersPotentialInternalProjectUsersDocument, options);
      }
export function useAddInternalUsersPotentialInternalProjectUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddInternalUsersPotentialInternalProjectUsersQuery, AddInternalUsersPotentialInternalProjectUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddInternalUsersPotentialInternalProjectUsersQuery, AddInternalUsersPotentialInternalProjectUsersQueryVariables>(AddInternalUsersPotentialInternalProjectUsersDocument, options);
        }
export type AddInternalUsersPotentialInternalProjectUsersQueryHookResult = ReturnType<typeof useAddInternalUsersPotentialInternalProjectUsersQuery>;
export type AddInternalUsersPotentialInternalProjectUsersLazyQueryHookResult = ReturnType<typeof useAddInternalUsersPotentialInternalProjectUsersLazyQuery>;
export type AddInternalUsersPotentialInternalProjectUsersQueryResult = Apollo.QueryResult<AddInternalUsersPotentialInternalProjectUsersQuery, AddInternalUsersPotentialInternalProjectUsersQueryVariables>;
export const AddProjectCustomFieldsFormInfoFieldsDocument = gql`
    query AddProjectCustomFieldsForm_InfoFields($organizationId: ID!) {
  infoFields(organizationId: $organizationId) {
    id
    name
  }
}
    `;

/**
 * __useAddProjectCustomFieldsFormInfoFieldsQuery__
 *
 * To run a query within a React component, call `useAddProjectCustomFieldsFormInfoFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddProjectCustomFieldsFormInfoFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddProjectCustomFieldsFormInfoFieldsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useAddProjectCustomFieldsFormInfoFieldsQuery(baseOptions: Apollo.QueryHookOptions<AddProjectCustomFieldsFormInfoFieldsQuery, AddProjectCustomFieldsFormInfoFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddProjectCustomFieldsFormInfoFieldsQuery, AddProjectCustomFieldsFormInfoFieldsQueryVariables>(AddProjectCustomFieldsFormInfoFieldsDocument, options);
      }
export function useAddProjectCustomFieldsFormInfoFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddProjectCustomFieldsFormInfoFieldsQuery, AddProjectCustomFieldsFormInfoFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddProjectCustomFieldsFormInfoFieldsQuery, AddProjectCustomFieldsFormInfoFieldsQueryVariables>(AddProjectCustomFieldsFormInfoFieldsDocument, options);
        }
export type AddProjectCustomFieldsFormInfoFieldsQueryHookResult = ReturnType<typeof useAddProjectCustomFieldsFormInfoFieldsQuery>;
export type AddProjectCustomFieldsFormInfoFieldsLazyQueryHookResult = ReturnType<typeof useAddProjectCustomFieldsFormInfoFieldsLazyQuery>;
export type AddProjectCustomFieldsFormInfoFieldsQueryResult = Apollo.QueryResult<AddProjectCustomFieldsFormInfoFieldsQuery, AddProjectCustomFieldsFormInfoFieldsQueryVariables>;
export const AddRemoveTemplatesFormUpdateProjectDocument = gql`
    mutation AddRemoveTemplatesForm_UpdateProject($project: updateProjectInput!) {
  updateProject(input: $project) {
    project {
      id
      forecastedEndOn
    }
  }
}
    `;
export type AddRemoveTemplatesFormUpdateProjectMutationFn = Apollo.MutationFunction<AddRemoveTemplatesFormUpdateProjectMutation, AddRemoveTemplatesFormUpdateProjectMutationVariables>;

/**
 * __useAddRemoveTemplatesFormUpdateProjectMutation__
 *
 * To run a mutation, you first call `useAddRemoveTemplatesFormUpdateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRemoveTemplatesFormUpdateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRemoveTemplatesFormUpdateProjectMutation, { data, loading, error }] = useAddRemoveTemplatesFormUpdateProjectMutation({
 *   variables: {
 *      project: // value for 'project'
 *   },
 * });
 */
export function useAddRemoveTemplatesFormUpdateProjectMutation(baseOptions?: Apollo.MutationHookOptions<AddRemoveTemplatesFormUpdateProjectMutation, AddRemoveTemplatesFormUpdateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddRemoveTemplatesFormUpdateProjectMutation, AddRemoveTemplatesFormUpdateProjectMutationVariables>(AddRemoveTemplatesFormUpdateProjectDocument, options);
      }
export type AddRemoveTemplatesFormUpdateProjectMutationHookResult = ReturnType<typeof useAddRemoveTemplatesFormUpdateProjectMutation>;
export type AddRemoveTemplatesFormUpdateProjectMutationResult = Apollo.MutationResult<AddRemoveTemplatesFormUpdateProjectMutation>;
export type AddRemoveTemplatesFormUpdateProjectMutationOptions = Apollo.BaseMutationOptions<AddRemoveTemplatesFormUpdateProjectMutation, AddRemoveTemplatesFormUpdateProjectMutationVariables>;
export const AddRemoveTemplatesFormAddTemplatesDocument = gql`
    mutation AddRemoveTemplatesForm_AddTemplates($input: removeTemplateFromProjectInput!) {
  removeTemplateFromProject(input: $input) {
    success
  }
}
    `;
export type AddRemoveTemplatesFormAddTemplatesMutationFn = Apollo.MutationFunction<AddRemoveTemplatesFormAddTemplatesMutation, AddRemoveTemplatesFormAddTemplatesMutationVariables>;

/**
 * __useAddRemoveTemplatesFormAddTemplatesMutation__
 *
 * To run a mutation, you first call `useAddRemoveTemplatesFormAddTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRemoveTemplatesFormAddTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRemoveTemplatesFormAddTemplatesMutation, { data, loading, error }] = useAddRemoveTemplatesFormAddTemplatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddRemoveTemplatesFormAddTemplatesMutation(baseOptions?: Apollo.MutationHookOptions<AddRemoveTemplatesFormAddTemplatesMutation, AddRemoveTemplatesFormAddTemplatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddRemoveTemplatesFormAddTemplatesMutation, AddRemoveTemplatesFormAddTemplatesMutationVariables>(AddRemoveTemplatesFormAddTemplatesDocument, options);
      }
export type AddRemoveTemplatesFormAddTemplatesMutationHookResult = ReturnType<typeof useAddRemoveTemplatesFormAddTemplatesMutation>;
export type AddRemoveTemplatesFormAddTemplatesMutationResult = Apollo.MutationResult<AddRemoveTemplatesFormAddTemplatesMutation>;
export type AddRemoveTemplatesFormAddTemplatesMutationOptions = Apollo.BaseMutationOptions<AddRemoveTemplatesFormAddTemplatesMutation, AddRemoveTemplatesFormAddTemplatesMutationVariables>;
export const AddThirdPartyUsersPotentialInternalProjectUsersDocument = gql`
    query AddThirdPartyUsers_PotentialInternalProjectUsers($projectId: ID!) {
  potentialThirdPartyUsers(projectId: $projectId) {
    id
    ...AddThirdParty_User
    ...UserMenuOption_User
  }
}
    ${AddThirdPartyUserFragmentDoc}
${UserMenuOptionUserFragmentDoc}`;

/**
 * __useAddThirdPartyUsersPotentialInternalProjectUsersQuery__
 *
 * To run a query within a React component, call `useAddThirdPartyUsersPotentialInternalProjectUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddThirdPartyUsersPotentialInternalProjectUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddThirdPartyUsersPotentialInternalProjectUsersQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useAddThirdPartyUsersPotentialInternalProjectUsersQuery(baseOptions: Apollo.QueryHookOptions<AddThirdPartyUsersPotentialInternalProjectUsersQuery, AddThirdPartyUsersPotentialInternalProjectUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddThirdPartyUsersPotentialInternalProjectUsersQuery, AddThirdPartyUsersPotentialInternalProjectUsersQueryVariables>(AddThirdPartyUsersPotentialInternalProjectUsersDocument, options);
      }
export function useAddThirdPartyUsersPotentialInternalProjectUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddThirdPartyUsersPotentialInternalProjectUsersQuery, AddThirdPartyUsersPotentialInternalProjectUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddThirdPartyUsersPotentialInternalProjectUsersQuery, AddThirdPartyUsersPotentialInternalProjectUsersQueryVariables>(AddThirdPartyUsersPotentialInternalProjectUsersDocument, options);
        }
export type AddThirdPartyUsersPotentialInternalProjectUsersQueryHookResult = ReturnType<typeof useAddThirdPartyUsersPotentialInternalProjectUsersQuery>;
export type AddThirdPartyUsersPotentialInternalProjectUsersLazyQueryHookResult = ReturnType<typeof useAddThirdPartyUsersPotentialInternalProjectUsersLazyQuery>;
export type AddThirdPartyUsersPotentialInternalProjectUsersQueryResult = Apollo.QueryResult<AddThirdPartyUsersPotentialInternalProjectUsersQuery, AddThirdPartyUsersPotentialInternalProjectUsersQueryVariables>;
export const ArchiveProjectConfirmationArchiveProjectDocument = gql`
    mutation ArchiveProjectConfirmation_ArchiveProject($project: archiveProjectInput!) {
  archiveProject(input: $project) {
    project {
      id
      archivedAt
    }
  }
}
    `;
export type ArchiveProjectConfirmationArchiveProjectMutationFn = Apollo.MutationFunction<ArchiveProjectConfirmationArchiveProjectMutation, ArchiveProjectConfirmationArchiveProjectMutationVariables>;

/**
 * __useArchiveProjectConfirmationArchiveProjectMutation__
 *
 * To run a mutation, you first call `useArchiveProjectConfirmationArchiveProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveProjectConfirmationArchiveProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveProjectConfirmationArchiveProjectMutation, { data, loading, error }] = useArchiveProjectConfirmationArchiveProjectMutation({
 *   variables: {
 *      project: // value for 'project'
 *   },
 * });
 */
export function useArchiveProjectConfirmationArchiveProjectMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveProjectConfirmationArchiveProjectMutation, ArchiveProjectConfirmationArchiveProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveProjectConfirmationArchiveProjectMutation, ArchiveProjectConfirmationArchiveProjectMutationVariables>(ArchiveProjectConfirmationArchiveProjectDocument, options);
      }
export type ArchiveProjectConfirmationArchiveProjectMutationHookResult = ReturnType<typeof useArchiveProjectConfirmationArchiveProjectMutation>;
export type ArchiveProjectConfirmationArchiveProjectMutationResult = Apollo.MutationResult<ArchiveProjectConfirmationArchiveProjectMutation>;
export type ArchiveProjectConfirmationArchiveProjectMutationOptions = Apollo.BaseMutationOptions<ArchiveProjectConfirmationArchiveProjectMutation, ArchiveProjectConfirmationArchiveProjectMutationVariables>;
export const ConfirmCreateTemplateDialogCreateTemplateFromProjectPlanMutationDocument = gql`
    mutation ConfirmCreateTemplateDialog_CreateTemplateFromProjectPlanMutation($id: ID!, $duplicateName: String!, $templateType: TemplateEnumType!) {
  duplicateTemplate(
    input: {id: $id, duplicateName: $duplicateName, templateType: $templateType}
  ) {
    success
  }
}
    `;
export type ConfirmCreateTemplateDialogCreateTemplateFromProjectPlanMutationMutationFn = Apollo.MutationFunction<ConfirmCreateTemplateDialogCreateTemplateFromProjectPlanMutation, ConfirmCreateTemplateDialogCreateTemplateFromProjectPlanMutationVariables>;

/**
 * __useConfirmCreateTemplateDialogCreateTemplateFromProjectPlanMutation__
 *
 * To run a mutation, you first call `useConfirmCreateTemplateDialogCreateTemplateFromProjectPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmCreateTemplateDialogCreateTemplateFromProjectPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmCreateTemplateDialogCreateTemplateFromProjectPlanMutation, { data, loading, error }] = useConfirmCreateTemplateDialogCreateTemplateFromProjectPlanMutation({
 *   variables: {
 *      id: // value for 'id'
 *      duplicateName: // value for 'duplicateName'
 *      templateType: // value for 'templateType'
 *   },
 * });
 */
export function useConfirmCreateTemplateDialogCreateTemplateFromProjectPlanMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmCreateTemplateDialogCreateTemplateFromProjectPlanMutation, ConfirmCreateTemplateDialogCreateTemplateFromProjectPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmCreateTemplateDialogCreateTemplateFromProjectPlanMutation, ConfirmCreateTemplateDialogCreateTemplateFromProjectPlanMutationVariables>(ConfirmCreateTemplateDialogCreateTemplateFromProjectPlanMutationDocument, options);
      }
export type ConfirmCreateTemplateDialogCreateTemplateFromProjectPlanMutationHookResult = ReturnType<typeof useConfirmCreateTemplateDialogCreateTemplateFromProjectPlanMutation>;
export type ConfirmCreateTemplateDialogCreateTemplateFromProjectPlanMutationMutationResult = Apollo.MutationResult<ConfirmCreateTemplateDialogCreateTemplateFromProjectPlanMutation>;
export type ConfirmCreateTemplateDialogCreateTemplateFromProjectPlanMutationMutationOptions = Apollo.BaseMutationOptions<ConfirmCreateTemplateDialogCreateTemplateFromProjectPlanMutation, ConfirmCreateTemplateDialogCreateTemplateFromProjectPlanMutationVariables>;
export const DeleteProjectConfirmationRestoreProjectDocument = gql`
    mutation DeleteProjectConfirmation_RestoreProject($id: ID!) {
  restoreProject(input: {id: $id}) {
    project {
      id
      deletedAt
    }
  }
}
    `;
export type DeleteProjectConfirmationRestoreProjectMutationFn = Apollo.MutationFunction<DeleteProjectConfirmationRestoreProjectMutation, DeleteProjectConfirmationRestoreProjectMutationVariables>;

/**
 * __useDeleteProjectConfirmationRestoreProjectMutation__
 *
 * To run a mutation, you first call `useDeleteProjectConfirmationRestoreProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectConfirmationRestoreProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectConfirmationRestoreProjectMutation, { data, loading, error }] = useDeleteProjectConfirmationRestoreProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectConfirmationRestoreProjectMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectConfirmationRestoreProjectMutation, DeleteProjectConfirmationRestoreProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectConfirmationRestoreProjectMutation, DeleteProjectConfirmationRestoreProjectMutationVariables>(DeleteProjectConfirmationRestoreProjectDocument, options);
      }
export type DeleteProjectConfirmationRestoreProjectMutationHookResult = ReturnType<typeof useDeleteProjectConfirmationRestoreProjectMutation>;
export type DeleteProjectConfirmationRestoreProjectMutationResult = Apollo.MutationResult<DeleteProjectConfirmationRestoreProjectMutation>;
export type DeleteProjectConfirmationRestoreProjectMutationOptions = Apollo.BaseMutationOptions<DeleteProjectConfirmationRestoreProjectMutation, DeleteProjectConfirmationRestoreProjectMutationVariables>;
export const DeleteProjectConfirmationDeleteProjectDocument = gql`
    mutation DeleteProjectConfirmation_DeleteProject($id: ID!) {
  deleteProject(input: {hardDelete: true, id: $id}) {
    deletedProjectId
  }
}
    `;
export type DeleteProjectConfirmationDeleteProjectMutationFn = Apollo.MutationFunction<DeleteProjectConfirmationDeleteProjectMutation, DeleteProjectConfirmationDeleteProjectMutationVariables>;

/**
 * __useDeleteProjectConfirmationDeleteProjectMutation__
 *
 * To run a mutation, you first call `useDeleteProjectConfirmationDeleteProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectConfirmationDeleteProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectConfirmationDeleteProjectMutation, { data, loading, error }] = useDeleteProjectConfirmationDeleteProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectConfirmationDeleteProjectMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectConfirmationDeleteProjectMutation, DeleteProjectConfirmationDeleteProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectConfirmationDeleteProjectMutation, DeleteProjectConfirmationDeleteProjectMutationVariables>(DeleteProjectConfirmationDeleteProjectDocument, options);
      }
export type DeleteProjectConfirmationDeleteProjectMutationHookResult = ReturnType<typeof useDeleteProjectConfirmationDeleteProjectMutation>;
export type DeleteProjectConfirmationDeleteProjectMutationResult = Apollo.MutationResult<DeleteProjectConfirmationDeleteProjectMutation>;
export type DeleteProjectConfirmationDeleteProjectMutationOptions = Apollo.BaseMutationOptions<DeleteProjectConfirmationDeleteProjectMutation, DeleteProjectConfirmationDeleteProjectMutationVariables>;
export const DownloadArchivedActivitiesDocument = gql`
    mutation DownloadArchivedActivities($projectId: ID!) {
  downloadArchivedActivities(input: {projectId: $projectId}) {
    success
  }
}
    `;
export type DownloadArchivedActivitiesMutationFn = Apollo.MutationFunction<DownloadArchivedActivitiesMutation, DownloadArchivedActivitiesMutationVariables>;

/**
 * __useDownloadArchivedActivitiesMutation__
 *
 * To run a mutation, you first call `useDownloadArchivedActivitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadArchivedActivitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadArchivedActivitiesMutation, { data, loading, error }] = useDownloadArchivedActivitiesMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useDownloadArchivedActivitiesMutation(baseOptions?: Apollo.MutationHookOptions<DownloadArchivedActivitiesMutation, DownloadArchivedActivitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadArchivedActivitiesMutation, DownloadArchivedActivitiesMutationVariables>(DownloadArchivedActivitiesDocument, options);
      }
export type DownloadArchivedActivitiesMutationHookResult = ReturnType<typeof useDownloadArchivedActivitiesMutation>;
export type DownloadArchivedActivitiesMutationResult = Apollo.MutationResult<DownloadArchivedActivitiesMutation>;
export type DownloadArchivedActivitiesMutationOptions = Apollo.BaseMutationOptions<DownloadArchivedActivitiesMutation, DownloadArchivedActivitiesMutationVariables>;
export const EditProjectDrawerProjectDocument = gql`
    query EditProjectDrawer_Project($projectId: ID!) {
  project(id: $projectId) {
    id
    ...EditProjectDrawer_Project
  }
}
    ${EditProjectDrawerProjectFragmentDoc}`;

/**
 * __useEditProjectDrawerProjectQuery__
 *
 * To run a query within a React component, call `useEditProjectDrawerProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditProjectDrawerProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditProjectDrawerProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useEditProjectDrawerProjectQuery(baseOptions: Apollo.QueryHookOptions<EditProjectDrawerProjectQuery, EditProjectDrawerProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditProjectDrawerProjectQuery, EditProjectDrawerProjectQueryVariables>(EditProjectDrawerProjectDocument, options);
      }
export function useEditProjectDrawerProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditProjectDrawerProjectQuery, EditProjectDrawerProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditProjectDrawerProjectQuery, EditProjectDrawerProjectQueryVariables>(EditProjectDrawerProjectDocument, options);
        }
export type EditProjectDrawerProjectQueryHookResult = ReturnType<typeof useEditProjectDrawerProjectQuery>;
export type EditProjectDrawerProjectLazyQueryHookResult = ReturnType<typeof useEditProjectDrawerProjectLazyQuery>;
export type EditProjectDrawerProjectQueryResult = Apollo.QueryResult<EditProjectDrawerProjectQuery, EditProjectDrawerProjectQueryVariables>;
export const EditProjectDrawerGetAvailableProjectTagsDocument = gql`
    query EditProjectDrawer_GetAvailableProjectTags($taggableId: ID!, $taggableType: TaggableEnumType!) {
  availableTags(taggableId: $taggableId, taggableType: $taggableType) {
    ...Tags_AvailableTags
  }
}
    ${TagsAvailableTagsFragmentDoc}`;

/**
 * __useEditProjectDrawerGetAvailableProjectTagsQuery__
 *
 * To run a query within a React component, call `useEditProjectDrawerGetAvailableProjectTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditProjectDrawerGetAvailableProjectTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditProjectDrawerGetAvailableProjectTagsQuery({
 *   variables: {
 *      taggableId: // value for 'taggableId'
 *      taggableType: // value for 'taggableType'
 *   },
 * });
 */
export function useEditProjectDrawerGetAvailableProjectTagsQuery(baseOptions: Apollo.QueryHookOptions<EditProjectDrawerGetAvailableProjectTagsQuery, EditProjectDrawerGetAvailableProjectTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditProjectDrawerGetAvailableProjectTagsQuery, EditProjectDrawerGetAvailableProjectTagsQueryVariables>(EditProjectDrawerGetAvailableProjectTagsDocument, options);
      }
export function useEditProjectDrawerGetAvailableProjectTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditProjectDrawerGetAvailableProjectTagsQuery, EditProjectDrawerGetAvailableProjectTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditProjectDrawerGetAvailableProjectTagsQuery, EditProjectDrawerGetAvailableProjectTagsQueryVariables>(EditProjectDrawerGetAvailableProjectTagsDocument, options);
        }
export type EditProjectDrawerGetAvailableProjectTagsQueryHookResult = ReturnType<typeof useEditProjectDrawerGetAvailableProjectTagsQuery>;
export type EditProjectDrawerGetAvailableProjectTagsLazyQueryHookResult = ReturnType<typeof useEditProjectDrawerGetAvailableProjectTagsLazyQuery>;
export type EditProjectDrawerGetAvailableProjectTagsQueryResult = Apollo.QueryResult<EditProjectDrawerGetAvailableProjectTagsQuery, EditProjectDrawerGetAvailableProjectTagsQueryVariables>;
export const EditTemplatesDrawerProjectDocument = gql`
    query EditTemplatesDrawer_Project($projectId: ID!) {
  project(id: $projectId) {
    id
    ...EditTemplatesDrawer_Project
  }
}
    ${EditTemplatesDrawerProjectFragmentDoc}`;

/**
 * __useEditTemplatesDrawerProjectQuery__
 *
 * To run a query within a React component, call `useEditTemplatesDrawerProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditTemplatesDrawerProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditTemplatesDrawerProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useEditTemplatesDrawerProjectQuery(baseOptions: Apollo.QueryHookOptions<EditTemplatesDrawerProjectQuery, EditTemplatesDrawerProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditTemplatesDrawerProjectQuery, EditTemplatesDrawerProjectQueryVariables>(EditTemplatesDrawerProjectDocument, options);
      }
export function useEditTemplatesDrawerProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditTemplatesDrawerProjectQuery, EditTemplatesDrawerProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditTemplatesDrawerProjectQuery, EditTemplatesDrawerProjectQueryVariables>(EditTemplatesDrawerProjectDocument, options);
        }
export type EditTemplatesDrawerProjectQueryHookResult = ReturnType<typeof useEditTemplatesDrawerProjectQuery>;
export type EditTemplatesDrawerProjectLazyQueryHookResult = ReturnType<typeof useEditTemplatesDrawerProjectLazyQuery>;
export type EditTemplatesDrawerProjectQueryResult = Apollo.QueryResult<EditTemplatesDrawerProjectQuery, EditTemplatesDrawerProjectQueryVariables>;
export const EditTemplatesDrawerUpdateTemplateDocument = gql`
    mutation EditTemplatesDrawer_UpdateTemplate($template: updateTemplateInput!) {
  updateTemplate(input: $template) {
    template {
      id
      name
      videoUrl
      experienceOverview
      sortOrder
      duration
      videoPlaceholderImage {
        originalUrl
      }
      milestones {
        duration
      }
    }
  }
}
    `;
export type EditTemplatesDrawerUpdateTemplateMutationFn = Apollo.MutationFunction<EditTemplatesDrawerUpdateTemplateMutation, EditTemplatesDrawerUpdateTemplateMutationVariables>;

/**
 * __useEditTemplatesDrawerUpdateTemplateMutation__
 *
 * To run a mutation, you first call `useEditTemplatesDrawerUpdateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTemplatesDrawerUpdateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTemplatesDrawerUpdateTemplateMutation, { data, loading, error }] = useEditTemplatesDrawerUpdateTemplateMutation({
 *   variables: {
 *      template: // value for 'template'
 *   },
 * });
 */
export function useEditTemplatesDrawerUpdateTemplateMutation(baseOptions?: Apollo.MutationHookOptions<EditTemplatesDrawerUpdateTemplateMutation, EditTemplatesDrawerUpdateTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditTemplatesDrawerUpdateTemplateMutation, EditTemplatesDrawerUpdateTemplateMutationVariables>(EditTemplatesDrawerUpdateTemplateDocument, options);
      }
export type EditTemplatesDrawerUpdateTemplateMutationHookResult = ReturnType<typeof useEditTemplatesDrawerUpdateTemplateMutation>;
export type EditTemplatesDrawerUpdateTemplateMutationResult = Apollo.MutationResult<EditTemplatesDrawerUpdateTemplateMutation>;
export type EditTemplatesDrawerUpdateTemplateMutationOptions = Apollo.BaseMutationOptions<EditTemplatesDrawerUpdateTemplateMutation, EditTemplatesDrawerUpdateTemplateMutationVariables>;
export const EditTemplatesDrawerAddTemplatesDocument = gql`
    mutation EditTemplatesDrawer_AddTemplates($input: addTemplatesToProjectInput!) {
  addTemplatesToProject(input: $input) {
    success
  }
}
    `;
export type EditTemplatesDrawerAddTemplatesMutationFn = Apollo.MutationFunction<EditTemplatesDrawerAddTemplatesMutation, EditTemplatesDrawerAddTemplatesMutationVariables>;

/**
 * __useEditTemplatesDrawerAddTemplatesMutation__
 *
 * To run a mutation, you first call `useEditTemplatesDrawerAddTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTemplatesDrawerAddTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTemplatesDrawerAddTemplatesMutation, { data, loading, error }] = useEditTemplatesDrawerAddTemplatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditTemplatesDrawerAddTemplatesMutation(baseOptions?: Apollo.MutationHookOptions<EditTemplatesDrawerAddTemplatesMutation, EditTemplatesDrawerAddTemplatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditTemplatesDrawerAddTemplatesMutation, EditTemplatesDrawerAddTemplatesMutationVariables>(EditTemplatesDrawerAddTemplatesDocument, options);
      }
export type EditTemplatesDrawerAddTemplatesMutationHookResult = ReturnType<typeof useEditTemplatesDrawerAddTemplatesMutation>;
export type EditTemplatesDrawerAddTemplatesMutationResult = Apollo.MutationResult<EditTemplatesDrawerAddTemplatesMutation>;
export type EditTemplatesDrawerAddTemplatesMutationOptions = Apollo.BaseMutationOptions<EditTemplatesDrawerAddTemplatesMutation, EditTemplatesDrawerAddTemplatesMutationVariables>;
export const FilterProjectPlanDrawerAvailableTagsDocument = gql`
    query FilterProjectPlanDrawer_AvailableTags($taggableId: ID!, $type: String, $taggableType: TaggableEnumType!) {
  availableTags(taggableId: $taggableId, type: $type, taggableType: $taggableType) {
    ...Tags_AvailableTags
  }
}
    ${TagsAvailableTagsFragmentDoc}`;

/**
 * __useFilterProjectPlanDrawerAvailableTagsQuery__
 *
 * To run a query within a React component, call `useFilterProjectPlanDrawerAvailableTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterProjectPlanDrawerAvailableTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterProjectPlanDrawerAvailableTagsQuery({
 *   variables: {
 *      taggableId: // value for 'taggableId'
 *      type: // value for 'type'
 *      taggableType: // value for 'taggableType'
 *   },
 * });
 */
export function useFilterProjectPlanDrawerAvailableTagsQuery(baseOptions: Apollo.QueryHookOptions<FilterProjectPlanDrawerAvailableTagsQuery, FilterProjectPlanDrawerAvailableTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilterProjectPlanDrawerAvailableTagsQuery, FilterProjectPlanDrawerAvailableTagsQueryVariables>(FilterProjectPlanDrawerAvailableTagsDocument, options);
      }
export function useFilterProjectPlanDrawerAvailableTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterProjectPlanDrawerAvailableTagsQuery, FilterProjectPlanDrawerAvailableTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilterProjectPlanDrawerAvailableTagsQuery, FilterProjectPlanDrawerAvailableTagsQueryVariables>(FilterProjectPlanDrawerAvailableTagsDocument, options);
        }
export type FilterProjectPlanDrawerAvailableTagsQueryHookResult = ReturnType<typeof useFilterProjectPlanDrawerAvailableTagsQuery>;
export type FilterProjectPlanDrawerAvailableTagsLazyQueryHookResult = ReturnType<typeof useFilterProjectPlanDrawerAvailableTagsLazyQuery>;
export type FilterProjectPlanDrawerAvailableTagsQueryResult = Apollo.QueryResult<FilterProjectPlanDrawerAvailableTagsQuery, FilterProjectPlanDrawerAvailableTagsQueryVariables>;
export const GroupTaskInformationToggleGroupTaskCompletedDocument = gql`
    mutation GroupTaskInformation_ToggleGroupTaskCompleted($taskInputs: toggleGroupTaskCompletedInput!) {
  toggleGroupTaskCompleted(input: $taskInputs) {
    task {
      id
      taskParticipants {
        id
        completed
      }
    }
  }
}
    `;
export type GroupTaskInformationToggleGroupTaskCompletedMutationFn = Apollo.MutationFunction<GroupTaskInformationToggleGroupTaskCompletedMutation, GroupTaskInformationToggleGroupTaskCompletedMutationVariables>;

/**
 * __useGroupTaskInformationToggleGroupTaskCompletedMutation__
 *
 * To run a mutation, you first call `useGroupTaskInformationToggleGroupTaskCompletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGroupTaskInformationToggleGroupTaskCompletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [groupTaskInformationToggleGroupTaskCompletedMutation, { data, loading, error }] = useGroupTaskInformationToggleGroupTaskCompletedMutation({
 *   variables: {
 *      taskInputs: // value for 'taskInputs'
 *   },
 * });
 */
export function useGroupTaskInformationToggleGroupTaskCompletedMutation(baseOptions?: Apollo.MutationHookOptions<GroupTaskInformationToggleGroupTaskCompletedMutation, GroupTaskInformationToggleGroupTaskCompletedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GroupTaskInformationToggleGroupTaskCompletedMutation, GroupTaskInformationToggleGroupTaskCompletedMutationVariables>(GroupTaskInformationToggleGroupTaskCompletedDocument, options);
      }
export type GroupTaskInformationToggleGroupTaskCompletedMutationHookResult = ReturnType<typeof useGroupTaskInformationToggleGroupTaskCompletedMutation>;
export type GroupTaskInformationToggleGroupTaskCompletedMutationResult = Apollo.MutationResult<GroupTaskInformationToggleGroupTaskCompletedMutation>;
export type GroupTaskInformationToggleGroupTaskCompletedMutationOptions = Apollo.BaseMutationOptions<GroupTaskInformationToggleGroupTaskCompletedMutation, GroupTaskInformationToggleGroupTaskCompletedMutationVariables>;
export const MyTaskChecklistGroupToggleDocument = gql`
    mutation MyTaskChecklistGroup_Toggle($input: toggleSubtaskDoneInput!) {
  toggleSubtask(input: $input) {
    subtask {
      id
      ...SubtaskFragment
    }
  }
}
    ${SubtaskFragmentDoc}`;
export type MyTaskChecklistGroupToggleMutationFn = Apollo.MutationFunction<MyTaskChecklistGroupToggleMutation, MyTaskChecklistGroupToggleMutationVariables>;

/**
 * __useMyTaskChecklistGroupToggleMutation__
 *
 * To run a mutation, you first call `useMyTaskChecklistGroupToggleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMyTaskChecklistGroupToggleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [myTaskChecklistGroupToggleMutation, { data, loading, error }] = useMyTaskChecklistGroupToggleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMyTaskChecklistGroupToggleMutation(baseOptions?: Apollo.MutationHookOptions<MyTaskChecklistGroupToggleMutation, MyTaskChecklistGroupToggleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MyTaskChecklistGroupToggleMutation, MyTaskChecklistGroupToggleMutationVariables>(MyTaskChecklistGroupToggleDocument, options);
      }
export type MyTaskChecklistGroupToggleMutationHookResult = ReturnType<typeof useMyTaskChecklistGroupToggleMutation>;
export type MyTaskChecklistGroupToggleMutationResult = Apollo.MutationResult<MyTaskChecklistGroupToggleMutation>;
export type MyTaskChecklistGroupToggleMutationOptions = Apollo.BaseMutationOptions<MyTaskChecklistGroupToggleMutation, MyTaskChecklistGroupToggleMutationVariables>;
export const ProjectActionItemsUpdateActionItemDocument = gql`
    mutation ProjectActionItems_UpdateActionItem($input: updateActionItemInput!) {
  updateActionItem(input: $input) {
    actionItem {
      ...ActionItemForm_ActionItem
    }
  }
}
    ${ActionItemFormActionItemFragmentDoc}`;
export type ProjectActionItemsUpdateActionItemMutationFn = Apollo.MutationFunction<ProjectActionItemsUpdateActionItemMutation, ProjectActionItemsUpdateActionItemMutationVariables>;

/**
 * __useProjectActionItemsUpdateActionItemMutation__
 *
 * To run a mutation, you first call `useProjectActionItemsUpdateActionItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectActionItemsUpdateActionItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectActionItemsUpdateActionItemMutation, { data, loading, error }] = useProjectActionItemsUpdateActionItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProjectActionItemsUpdateActionItemMutation(baseOptions?: Apollo.MutationHookOptions<ProjectActionItemsUpdateActionItemMutation, ProjectActionItemsUpdateActionItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectActionItemsUpdateActionItemMutation, ProjectActionItemsUpdateActionItemMutationVariables>(ProjectActionItemsUpdateActionItemDocument, options);
      }
export type ProjectActionItemsUpdateActionItemMutationHookResult = ReturnType<typeof useProjectActionItemsUpdateActionItemMutation>;
export type ProjectActionItemsUpdateActionItemMutationResult = Apollo.MutationResult<ProjectActionItemsUpdateActionItemMutation>;
export type ProjectActionItemsUpdateActionItemMutationOptions = Apollo.BaseMutationOptions<ProjectActionItemsUpdateActionItemMutation, ProjectActionItemsUpdateActionItemMutationVariables>;
export const ProjectActionItemsActionItemsDocument = gql`
    query ProjectActionItems_ActionItems($projectId: ID!, $listInputs: ListInputTypeV2, $actionItemFilters: FiltersInput) {
  project(id: $projectId) {
    id
    actionItems(listInputs: $listInputs, actionItemFilters: $actionItemFilters) {
      ...ActionItemRow_ActionItemRow
    }
  }
}
    ${ActionItemRowActionItemRowFragmentDoc}`;

/**
 * __useProjectActionItemsActionItemsQuery__
 *
 * To run a query within a React component, call `useProjectActionItemsActionItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectActionItemsActionItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectActionItemsActionItemsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      listInputs: // value for 'listInputs'
 *      actionItemFilters: // value for 'actionItemFilters'
 *   },
 * });
 */
export function useProjectActionItemsActionItemsQuery(baseOptions: Apollo.QueryHookOptions<ProjectActionItemsActionItemsQuery, ProjectActionItemsActionItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectActionItemsActionItemsQuery, ProjectActionItemsActionItemsQueryVariables>(ProjectActionItemsActionItemsDocument, options);
      }
export function useProjectActionItemsActionItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectActionItemsActionItemsQuery, ProjectActionItemsActionItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectActionItemsActionItemsQuery, ProjectActionItemsActionItemsQueryVariables>(ProjectActionItemsActionItemsDocument, options);
        }
export type ProjectActionItemsActionItemsQueryHookResult = ReturnType<typeof useProjectActionItemsActionItemsQuery>;
export type ProjectActionItemsActionItemsLazyQueryHookResult = ReturnType<typeof useProjectActionItemsActionItemsLazyQuery>;
export type ProjectActionItemsActionItemsQueryResult = Apollo.QueryResult<ProjectActionItemsActionItemsQuery, ProjectActionItemsActionItemsQueryVariables>;
export const ProjectActionItemsProjectTeamDocument = gql`
    query ProjectActionItems_ProjectTeam($projectId: ID!, $internalOnly: Boolean) {
  projectTeam(projectId: $projectId, internalOnly: $internalOnly) {
    ...FilterActionItemDrawer_User
    ...ActionItemDrawer_User
  }
}
    ${FilterActionItemDrawerUserFragmentDoc}
${ActionItemDrawerUserFragmentDoc}`;

/**
 * __useProjectActionItemsProjectTeamQuery__
 *
 * To run a query within a React component, call `useProjectActionItemsProjectTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectActionItemsProjectTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectActionItemsProjectTeamQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      internalOnly: // value for 'internalOnly'
 *   },
 * });
 */
export function useProjectActionItemsProjectTeamQuery(baseOptions: Apollo.QueryHookOptions<ProjectActionItemsProjectTeamQuery, ProjectActionItemsProjectTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectActionItemsProjectTeamQuery, ProjectActionItemsProjectTeamQueryVariables>(ProjectActionItemsProjectTeamDocument, options);
      }
export function useProjectActionItemsProjectTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectActionItemsProjectTeamQuery, ProjectActionItemsProjectTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectActionItemsProjectTeamQuery, ProjectActionItemsProjectTeamQueryVariables>(ProjectActionItemsProjectTeamDocument, options);
        }
export type ProjectActionItemsProjectTeamQueryHookResult = ReturnType<typeof useProjectActionItemsProjectTeamQuery>;
export type ProjectActionItemsProjectTeamLazyQueryHookResult = ReturnType<typeof useProjectActionItemsProjectTeamLazyQuery>;
export type ProjectActionItemsProjectTeamQueryResult = Apollo.QueryResult<ProjectActionItemsProjectTeamQuery, ProjectActionItemsProjectTeamQueryVariables>;
export const ProjectActionItemsProjectTasksDocument = gql`
    query ProjectActionItems_ProjectTasks($projectId: ID!) {
  projectTasks(projectId: $projectId) {
    ...FilterActionItemDrawer_Task
    ...ActionItemDrawer_Task
  }
}
    ${FilterActionItemDrawerTaskFragmentDoc}
${ActionItemDrawerTaskFragmentDoc}`;

/**
 * __useProjectActionItemsProjectTasksQuery__
 *
 * To run a query within a React component, call `useProjectActionItemsProjectTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectActionItemsProjectTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectActionItemsProjectTasksQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectActionItemsProjectTasksQuery(baseOptions: Apollo.QueryHookOptions<ProjectActionItemsProjectTasksQuery, ProjectActionItemsProjectTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectActionItemsProjectTasksQuery, ProjectActionItemsProjectTasksQueryVariables>(ProjectActionItemsProjectTasksDocument, options);
      }
export function useProjectActionItemsProjectTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectActionItemsProjectTasksQuery, ProjectActionItemsProjectTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectActionItemsProjectTasksQuery, ProjectActionItemsProjectTasksQueryVariables>(ProjectActionItemsProjectTasksDocument, options);
        }
export type ProjectActionItemsProjectTasksQueryHookResult = ReturnType<typeof useProjectActionItemsProjectTasksQuery>;
export type ProjectActionItemsProjectTasksLazyQueryHookResult = ReturnType<typeof useProjectActionItemsProjectTasksLazyQuery>;
export type ProjectActionItemsProjectTasksQueryResult = Apollo.QueryResult<ProjectActionItemsProjectTasksQuery, ProjectActionItemsProjectTasksQueryVariables>;
export const ProjectActionItemsCreateActionItemDocument = gql`
    mutation ProjectActionItems_CreateActionItem($input: createActionItemInput!) {
  createActionItem(input: $input) {
    actionItem {
      ...ActionItemRow_ActionItemRow
    }
  }
}
    ${ActionItemRowActionItemRowFragmentDoc}`;
export type ProjectActionItemsCreateActionItemMutationFn = Apollo.MutationFunction<ProjectActionItemsCreateActionItemMutation, ProjectActionItemsCreateActionItemMutationVariables>;

/**
 * __useProjectActionItemsCreateActionItemMutation__
 *
 * To run a mutation, you first call `useProjectActionItemsCreateActionItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectActionItemsCreateActionItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectActionItemsCreateActionItemMutation, { data, loading, error }] = useProjectActionItemsCreateActionItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProjectActionItemsCreateActionItemMutation(baseOptions?: Apollo.MutationHookOptions<ProjectActionItemsCreateActionItemMutation, ProjectActionItemsCreateActionItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectActionItemsCreateActionItemMutation, ProjectActionItemsCreateActionItemMutationVariables>(ProjectActionItemsCreateActionItemDocument, options);
      }
export type ProjectActionItemsCreateActionItemMutationHookResult = ReturnType<typeof useProjectActionItemsCreateActionItemMutation>;
export type ProjectActionItemsCreateActionItemMutationResult = Apollo.MutationResult<ProjectActionItemsCreateActionItemMutation>;
export type ProjectActionItemsCreateActionItemMutationOptions = Apollo.BaseMutationOptions<ProjectActionItemsCreateActionItemMutation, ProjectActionItemsCreateActionItemMutationVariables>;
export const ProjectActionItemsDeleteActionItemDocument = gql`
    mutation ProjectActionItems_DeleteActionItem($input: deleteActionItemInput!) {
  deleteActionItem(input: $input) {
    actionItemId
  }
}
    `;
export type ProjectActionItemsDeleteActionItemMutationFn = Apollo.MutationFunction<ProjectActionItemsDeleteActionItemMutation, ProjectActionItemsDeleteActionItemMutationVariables>;

/**
 * __useProjectActionItemsDeleteActionItemMutation__
 *
 * To run a mutation, you first call `useProjectActionItemsDeleteActionItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectActionItemsDeleteActionItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectActionItemsDeleteActionItemMutation, { data, loading, error }] = useProjectActionItemsDeleteActionItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProjectActionItemsDeleteActionItemMutation(baseOptions?: Apollo.MutationHookOptions<ProjectActionItemsDeleteActionItemMutation, ProjectActionItemsDeleteActionItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectActionItemsDeleteActionItemMutation, ProjectActionItemsDeleteActionItemMutationVariables>(ProjectActionItemsDeleteActionItemDocument, options);
      }
export type ProjectActionItemsDeleteActionItemMutationHookResult = ReturnType<typeof useProjectActionItemsDeleteActionItemMutation>;
export type ProjectActionItemsDeleteActionItemMutationResult = Apollo.MutationResult<ProjectActionItemsDeleteActionItemMutation>;
export type ProjectActionItemsDeleteActionItemMutationOptions = Apollo.BaseMutationOptions<ProjectActionItemsDeleteActionItemMutation, ProjectActionItemsDeleteActionItemMutationVariables>;
export const ProjectFilesFilesDocument = gql`
    query ProjectFiles_Files($projectId: ID!, $listInputs: ListInput) {
  files(objId: $projectId, objType: PROJECT, listInputs: $listInputs) {
    pageInfo {
      ...PageInfoFragment
    }
    assets {
      id
      ...ProjectFiles_File
    }
  }
}
    ${PageInfoFragmentDoc}
${ProjectFilesFileFragmentDoc}`;

/**
 * __useProjectFilesFilesQuery__
 *
 * To run a query within a React component, call `useProjectFilesFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectFilesFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectFilesFilesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      listInputs: // value for 'listInputs'
 *   },
 * });
 */
export function useProjectFilesFilesQuery(baseOptions: Apollo.QueryHookOptions<ProjectFilesFilesQuery, ProjectFilesFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectFilesFilesQuery, ProjectFilesFilesQueryVariables>(ProjectFilesFilesDocument, options);
      }
export function useProjectFilesFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectFilesFilesQuery, ProjectFilesFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectFilesFilesQuery, ProjectFilesFilesQueryVariables>(ProjectFilesFilesDocument, options);
        }
export type ProjectFilesFilesQueryHookResult = ReturnType<typeof useProjectFilesFilesQuery>;
export type ProjectFilesFilesLazyQueryHookResult = ReturnType<typeof useProjectFilesFilesLazyQuery>;
export type ProjectFilesFilesQueryResult = Apollo.QueryResult<ProjectFilesFilesQuery, ProjectFilesFilesQueryVariables>;
export const ProjectFilesSendAttachmentsDocument = gql`
    mutation ProjectFiles_SendAttachments($projectId: ID!) {
  sendProjectAttachments(input: {projectId: $projectId}) {
    success
  }
}
    `;
export type ProjectFilesSendAttachmentsMutationFn = Apollo.MutationFunction<ProjectFilesSendAttachmentsMutation, ProjectFilesSendAttachmentsMutationVariables>;

/**
 * __useProjectFilesSendAttachmentsMutation__
 *
 * To run a mutation, you first call `useProjectFilesSendAttachmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectFilesSendAttachmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectFilesSendAttachmentsMutation, { data, loading, error }] = useProjectFilesSendAttachmentsMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectFilesSendAttachmentsMutation(baseOptions?: Apollo.MutationHookOptions<ProjectFilesSendAttachmentsMutation, ProjectFilesSendAttachmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectFilesSendAttachmentsMutation, ProjectFilesSendAttachmentsMutationVariables>(ProjectFilesSendAttachmentsDocument, options);
      }
export type ProjectFilesSendAttachmentsMutationHookResult = ReturnType<typeof useProjectFilesSendAttachmentsMutation>;
export type ProjectFilesSendAttachmentsMutationResult = Apollo.MutationResult<ProjectFilesSendAttachmentsMutation>;
export type ProjectFilesSendAttachmentsMutationOptions = Apollo.BaseMutationOptions<ProjectFilesSendAttachmentsMutation, ProjectFilesSendAttachmentsMutationVariables>;
export const ProjectFilesDeleteFileDocument = gql`
    mutation ProjectFiles_DeleteFile($deleteFileInput: DeleteFileInput!) {
  deleteFile(input: $deleteFileInput) {
    success
  }
}
    `;
export type ProjectFilesDeleteFileMutationFn = Apollo.MutationFunction<ProjectFilesDeleteFileMutation, ProjectFilesDeleteFileMutationVariables>;

/**
 * __useProjectFilesDeleteFileMutation__
 *
 * To run a mutation, you first call `useProjectFilesDeleteFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectFilesDeleteFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectFilesDeleteFileMutation, { data, loading, error }] = useProjectFilesDeleteFileMutation({
 *   variables: {
 *      deleteFileInput: // value for 'deleteFileInput'
 *   },
 * });
 */
export function useProjectFilesDeleteFileMutation(baseOptions?: Apollo.MutationHookOptions<ProjectFilesDeleteFileMutation, ProjectFilesDeleteFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectFilesDeleteFileMutation, ProjectFilesDeleteFileMutationVariables>(ProjectFilesDeleteFileDocument, options);
      }
export type ProjectFilesDeleteFileMutationHookResult = ReturnType<typeof useProjectFilesDeleteFileMutation>;
export type ProjectFilesDeleteFileMutationResult = Apollo.MutationResult<ProjectFilesDeleteFileMutation>;
export type ProjectFilesDeleteFileMutationOptions = Apollo.BaseMutationOptions<ProjectFilesDeleteFileMutation, ProjectFilesDeleteFileMutationVariables>;
export const ProjectInfoFormProjectManagersDocument = gql`
    query ProjectInfoForm_ProjectManagers {
  projectManagers {
    id
    ...UserMenuOption_UserWithCapacity
  }
}
    ${UserMenuOptionUserWithCapacityFragmentDoc}`;

/**
 * __useProjectInfoFormProjectManagersQuery__
 *
 * To run a query within a React component, call `useProjectInfoFormProjectManagersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectInfoFormProjectManagersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectInfoFormProjectManagersQuery({
 *   variables: {
 *   },
 * });
 */
export function useProjectInfoFormProjectManagersQuery(baseOptions?: Apollo.QueryHookOptions<ProjectInfoFormProjectManagersQuery, ProjectInfoFormProjectManagersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectInfoFormProjectManagersQuery, ProjectInfoFormProjectManagersQueryVariables>(ProjectInfoFormProjectManagersDocument, options);
      }
export function useProjectInfoFormProjectManagersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectInfoFormProjectManagersQuery, ProjectInfoFormProjectManagersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectInfoFormProjectManagersQuery, ProjectInfoFormProjectManagersQueryVariables>(ProjectInfoFormProjectManagersDocument, options);
        }
export type ProjectInfoFormProjectManagersQueryHookResult = ReturnType<typeof useProjectInfoFormProjectManagersQuery>;
export type ProjectInfoFormProjectManagersLazyQueryHookResult = ReturnType<typeof useProjectInfoFormProjectManagersLazyQuery>;
export type ProjectInfoFormProjectManagersQueryResult = Apollo.QueryResult<ProjectInfoFormProjectManagersQuery, ProjectInfoFormProjectManagersQueryVariables>;
export const ProjectInfoFormBrandListDocument = gql`
    query ProjectInfoForm_BrandList {
  brands {
    id
    name
    logo {
      originalUrl
    }
  }
}
    `;

/**
 * __useProjectInfoFormBrandListQuery__
 *
 * To run a query within a React component, call `useProjectInfoFormBrandListQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectInfoFormBrandListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectInfoFormBrandListQuery({
 *   variables: {
 *   },
 * });
 */
export function useProjectInfoFormBrandListQuery(baseOptions?: Apollo.QueryHookOptions<ProjectInfoFormBrandListQuery, ProjectInfoFormBrandListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectInfoFormBrandListQuery, ProjectInfoFormBrandListQueryVariables>(ProjectInfoFormBrandListDocument, options);
      }
export function useProjectInfoFormBrandListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectInfoFormBrandListQuery, ProjectInfoFormBrandListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectInfoFormBrandListQuery, ProjectInfoFormBrandListQueryVariables>(ProjectInfoFormBrandListDocument, options);
        }
export type ProjectInfoFormBrandListQueryHookResult = ReturnType<typeof useProjectInfoFormBrandListQuery>;
export type ProjectInfoFormBrandListLazyQueryHookResult = ReturnType<typeof useProjectInfoFormBrandListLazyQuery>;
export type ProjectInfoFormBrandListQueryResult = Apollo.QueryResult<ProjectInfoFormBrandListQuery, ProjectInfoFormBrandListQueryVariables>;
export const ProjectInfoFormInfoFieldsDocument = gql`
    query ProjectInfoForm_InfoFields($organizationId: ID!) {
  infoFields(organizationId: $organizationId) {
    id
    name
  }
}
    `;

/**
 * __useProjectInfoFormInfoFieldsQuery__
 *
 * To run a query within a React component, call `useProjectInfoFormInfoFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectInfoFormInfoFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectInfoFormInfoFieldsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useProjectInfoFormInfoFieldsQuery(baseOptions: Apollo.QueryHookOptions<ProjectInfoFormInfoFieldsQuery, ProjectInfoFormInfoFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectInfoFormInfoFieldsQuery, ProjectInfoFormInfoFieldsQueryVariables>(ProjectInfoFormInfoFieldsDocument, options);
      }
export function useProjectInfoFormInfoFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectInfoFormInfoFieldsQuery, ProjectInfoFormInfoFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectInfoFormInfoFieldsQuery, ProjectInfoFormInfoFieldsQueryVariables>(ProjectInfoFormInfoFieldsDocument, options);
        }
export type ProjectInfoFormInfoFieldsQueryHookResult = ReturnType<typeof useProjectInfoFormInfoFieldsQuery>;
export type ProjectInfoFormInfoFieldsLazyQueryHookResult = ReturnType<typeof useProjectInfoFormInfoFieldsLazyQuery>;
export type ProjectInfoFormInfoFieldsQueryResult = Apollo.QueryResult<ProjectInfoFormInfoFieldsQuery, ProjectInfoFormInfoFieldsQueryVariables>;
export const ProjectInfoFormUpsertInfoFieldsDocument = gql`
    mutation ProjectInfoForm_UpsertInfoFields($input: UpsertProjectInfoFieldInput!) {
  upsertProjectInfoField(input: $input) {
    success
  }
}
    `;
export type ProjectInfoFormUpsertInfoFieldsMutationFn = Apollo.MutationFunction<ProjectInfoFormUpsertInfoFieldsMutation, ProjectInfoFormUpsertInfoFieldsMutationVariables>;

/**
 * __useProjectInfoFormUpsertInfoFieldsMutation__
 *
 * To run a mutation, you first call `useProjectInfoFormUpsertInfoFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectInfoFormUpsertInfoFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectInfoFormUpsertInfoFieldsMutation, { data, loading, error }] = useProjectInfoFormUpsertInfoFieldsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProjectInfoFormUpsertInfoFieldsMutation(baseOptions?: Apollo.MutationHookOptions<ProjectInfoFormUpsertInfoFieldsMutation, ProjectInfoFormUpsertInfoFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectInfoFormUpsertInfoFieldsMutation, ProjectInfoFormUpsertInfoFieldsMutationVariables>(ProjectInfoFormUpsertInfoFieldsDocument, options);
      }
export type ProjectInfoFormUpsertInfoFieldsMutationHookResult = ReturnType<typeof useProjectInfoFormUpsertInfoFieldsMutation>;
export type ProjectInfoFormUpsertInfoFieldsMutationResult = Apollo.MutationResult<ProjectInfoFormUpsertInfoFieldsMutation>;
export type ProjectInfoFormUpsertInfoFieldsMutationOptions = Apollo.BaseMutationOptions<ProjectInfoFormUpsertInfoFieldsMutation, ProjectInfoFormUpsertInfoFieldsMutationVariables>;
export const PendingProjectDetailDocument = gql`
    query PendingProjectDetail($id: ID!) {
  pendingProject(id: $id) {
    id
    name
    domain
    provider
    organization {
      id
      name
      hubspotEnabled
      salesforceEnabled
      openApiEnabled
      hubSpotIntegration {
        id
      }
      salesforceIntegration {
        id
      }
    }
    projectManager {
      id
    }
    externalId
    templates {
      id
    }
    customFields {
      id
      value
    }
    startOn
    endOn
    cashValue
    customerUsersBlob
    apiProjectId
  }
}
    `;

/**
 * __usePendingProjectDetailQuery__
 *
 * To run a query within a React component, call `usePendingProjectDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingProjectDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingProjectDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePendingProjectDetailQuery(baseOptions: Apollo.QueryHookOptions<PendingProjectDetailQuery, PendingProjectDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PendingProjectDetailQuery, PendingProjectDetailQueryVariables>(PendingProjectDetailDocument, options);
      }
export function usePendingProjectDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PendingProjectDetailQuery, PendingProjectDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PendingProjectDetailQuery, PendingProjectDetailQueryVariables>(PendingProjectDetailDocument, options);
        }
export type PendingProjectDetailQueryHookResult = ReturnType<typeof usePendingProjectDetailQuery>;
export type PendingProjectDetailLazyQueryHookResult = ReturnType<typeof usePendingProjectDetailLazyQuery>;
export type PendingProjectDetailQueryResult = Apollo.QueryResult<PendingProjectDetailQuery, PendingProjectDetailQueryVariables>;
export const ProjectSnapshotProjectDocument = gql`
    query ProjectSnapshot_Project($projectId: ID!) {
  project(id: $projectId) {
    id
    ...ProjectSnapshot_Project
  }
}
    ${ProjectSnapshotProjectFragmentDoc}`;

/**
 * __useProjectSnapshotProjectQuery__
 *
 * To run a query within a React component, call `useProjectSnapshotProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectSnapshotProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectSnapshotProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectSnapshotProjectQuery(baseOptions: Apollo.QueryHookOptions<ProjectSnapshotProjectQuery, ProjectSnapshotProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectSnapshotProjectQuery, ProjectSnapshotProjectQueryVariables>(ProjectSnapshotProjectDocument, options);
      }
export function useProjectSnapshotProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectSnapshotProjectQuery, ProjectSnapshotProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectSnapshotProjectQuery, ProjectSnapshotProjectQueryVariables>(ProjectSnapshotProjectDocument, options);
        }
export type ProjectSnapshotProjectQueryHookResult = ReturnType<typeof useProjectSnapshotProjectQuery>;
export type ProjectSnapshotProjectLazyQueryHookResult = ReturnType<typeof useProjectSnapshotProjectLazyQuery>;
export type ProjectSnapshotProjectQueryResult = Apollo.QueryResult<ProjectSnapshotProjectQuery, ProjectSnapshotProjectQueryVariables>;
export const ProjectSnapshotStatsDocument = gql`
    query ProjectSnapshot_Stats($projectId: ID!) {
  stats(objId: $projectId, objType: PROJECT) {
    ... on ProjectStats {
      id
      ...ProjectSnapshot_Stats
    }
  }
}
    ${ProjectSnapshotStatsFragmentDoc}`;

/**
 * __useProjectSnapshotStatsQuery__
 *
 * To run a query within a React component, call `useProjectSnapshotStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectSnapshotStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectSnapshotStatsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectSnapshotStatsQuery(baseOptions: Apollo.QueryHookOptions<ProjectSnapshotStatsQuery, ProjectSnapshotStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectSnapshotStatsQuery, ProjectSnapshotStatsQueryVariables>(ProjectSnapshotStatsDocument, options);
      }
export function useProjectSnapshotStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectSnapshotStatsQuery, ProjectSnapshotStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectSnapshotStatsQuery, ProjectSnapshotStatsQueryVariables>(ProjectSnapshotStatsDocument, options);
        }
export type ProjectSnapshotStatsQueryHookResult = ReturnType<typeof useProjectSnapshotStatsQuery>;
export type ProjectSnapshotStatsLazyQueryHookResult = ReturnType<typeof useProjectSnapshotStatsLazyQuery>;
export type ProjectSnapshotStatsQueryResult = Apollo.QueryResult<ProjectSnapshotStatsQuery, ProjectSnapshotStatsQueryVariables>;
export const ProjectSnapshotStatusUpdatedDocument = gql`
    subscription ProjectSnapshot_StatusUpdated($projectId: ID!) {
  projectUpdated(projectId: $projectId) {
    project {
      id
      ...ProjectSnapshot_Project
    }
    projectStats {
      ...ProjectSnapshot_Stats
    }
  }
}
    ${ProjectSnapshotProjectFragmentDoc}
${ProjectSnapshotStatsFragmentDoc}`;

/**
 * __useProjectSnapshotStatusUpdatedSubscription__
 *
 * To run a query within a React component, call `useProjectSnapshotStatusUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useProjectSnapshotStatusUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectSnapshotStatusUpdatedSubscription({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectSnapshotStatusUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<ProjectSnapshotStatusUpdatedSubscription, ProjectSnapshotStatusUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ProjectSnapshotStatusUpdatedSubscription, ProjectSnapshotStatusUpdatedSubscriptionVariables>(ProjectSnapshotStatusUpdatedDocument, options);
      }
export type ProjectSnapshotStatusUpdatedSubscriptionHookResult = ReturnType<typeof useProjectSnapshotStatusUpdatedSubscription>;
export type ProjectSnapshotStatusUpdatedSubscriptionResult = Apollo.SubscriptionResult<ProjectSnapshotStatusUpdatedSubscription>;
export const ProjectTeamProjectTeamDocument = gql`
    query ProjectTeam_ProjectTeam($projectId: ID!) {
  projectTeam(projectId: $projectId) {
    id
    ...ProjectTeam_User
  }
}
    ${ProjectTeamUserFragmentDoc}`;

/**
 * __useProjectTeamProjectTeamQuery__
 *
 * To run a query within a React component, call `useProjectTeamProjectTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectTeamProjectTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectTeamProjectTeamQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectTeamProjectTeamQuery(baseOptions: Apollo.QueryHookOptions<ProjectTeamProjectTeamQuery, ProjectTeamProjectTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectTeamProjectTeamQuery, ProjectTeamProjectTeamQueryVariables>(ProjectTeamProjectTeamDocument, options);
      }
export function useProjectTeamProjectTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectTeamProjectTeamQuery, ProjectTeamProjectTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectTeamProjectTeamQuery, ProjectTeamProjectTeamQueryVariables>(ProjectTeamProjectTeamDocument, options);
        }
export type ProjectTeamProjectTeamQueryHookResult = ReturnType<typeof useProjectTeamProjectTeamQuery>;
export type ProjectTeamProjectTeamLazyQueryHookResult = ReturnType<typeof useProjectTeamProjectTeamLazyQuery>;
export type ProjectTeamProjectTeamQueryResult = Apollo.QueryResult<ProjectTeamProjectTeamQuery, ProjectTeamProjectTeamQueryVariables>;
export const ProjectTeamRemoveTeamMemberDocument = gql`
    mutation ProjectTeam_RemoveTeamMember($user: removeUserFromProjectInput!) {
  removeUserFromProject(input: $user) {
    projectTeam {
      id
      ...ProjectTeam_User
    }
  }
}
    ${ProjectTeamUserFragmentDoc}`;
export type ProjectTeamRemoveTeamMemberMutationFn = Apollo.MutationFunction<ProjectTeamRemoveTeamMemberMutation, ProjectTeamRemoveTeamMemberMutationVariables>;

/**
 * __useProjectTeamRemoveTeamMemberMutation__
 *
 * To run a mutation, you first call `useProjectTeamRemoveTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectTeamRemoveTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectTeamRemoveTeamMemberMutation, { data, loading, error }] = useProjectTeamRemoveTeamMemberMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useProjectTeamRemoveTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<ProjectTeamRemoveTeamMemberMutation, ProjectTeamRemoveTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectTeamRemoveTeamMemberMutation, ProjectTeamRemoveTeamMemberMutationVariables>(ProjectTeamRemoveTeamMemberDocument, options);
      }
export type ProjectTeamRemoveTeamMemberMutationHookResult = ReturnType<typeof useProjectTeamRemoveTeamMemberMutation>;
export type ProjectTeamRemoveTeamMemberMutationResult = Apollo.MutationResult<ProjectTeamRemoveTeamMemberMutation>;
export type ProjectTeamRemoveTeamMemberMutationOptions = Apollo.BaseMutationOptions<ProjectTeamRemoveTeamMemberMutation, ProjectTeamRemoveTeamMemberMutationVariables>;
export const ProjectTeamAddInternalUsersToProjectDocument = gql`
    mutation ProjectTeam_AddInternalUsersToProject($projectId: ID!, $userIds: [String]!, $defaultAssigneeId: ID) {
  addInternalUsersToProject(
    input: {id: $projectId, ids: $userIds, defaultAssigneeId: $defaultAssigneeId, overrideAssignedTasks: true}
  ) {
    project {
      id
      users {
        id
        ...ProjectTeam_User
      }
    }
  }
}
    ${ProjectTeamUserFragmentDoc}`;
export type ProjectTeamAddInternalUsersToProjectMutationFn = Apollo.MutationFunction<ProjectTeamAddInternalUsersToProjectMutation, ProjectTeamAddInternalUsersToProjectMutationVariables>;

/**
 * __useProjectTeamAddInternalUsersToProjectMutation__
 *
 * To run a mutation, you first call `useProjectTeamAddInternalUsersToProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectTeamAddInternalUsersToProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectTeamAddInternalUsersToProjectMutation, { data, loading, error }] = useProjectTeamAddInternalUsersToProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      userIds: // value for 'userIds'
 *      defaultAssigneeId: // value for 'defaultAssigneeId'
 *   },
 * });
 */
export function useProjectTeamAddInternalUsersToProjectMutation(baseOptions?: Apollo.MutationHookOptions<ProjectTeamAddInternalUsersToProjectMutation, ProjectTeamAddInternalUsersToProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectTeamAddInternalUsersToProjectMutation, ProjectTeamAddInternalUsersToProjectMutationVariables>(ProjectTeamAddInternalUsersToProjectDocument, options);
      }
export type ProjectTeamAddInternalUsersToProjectMutationHookResult = ReturnType<typeof useProjectTeamAddInternalUsersToProjectMutation>;
export type ProjectTeamAddInternalUsersToProjectMutationResult = Apollo.MutationResult<ProjectTeamAddInternalUsersToProjectMutation>;
export type ProjectTeamAddInternalUsersToProjectMutationOptions = Apollo.BaseMutationOptions<ProjectTeamAddInternalUsersToProjectMutation, ProjectTeamAddInternalUsersToProjectMutationVariables>;
export const ProjectTeamAddCustomerUsersToProjectDocument = gql`
    mutation ProjectTeam_AddCustomerUsersToProject($projectId: ID!, $users: [ProjectUserInput!], $defaultAssigneeIndex: Int) {
  addCustomerUsersToProject(
    input: {id: $projectId, users: $users, defaultAssigneeIndex: $defaultAssigneeIndex}
  ) {
    project {
      id
      users {
        id
        ...ProjectTeam_User
      }
    }
  }
}
    ${ProjectTeamUserFragmentDoc}`;
export type ProjectTeamAddCustomerUsersToProjectMutationFn = Apollo.MutationFunction<ProjectTeamAddCustomerUsersToProjectMutation, ProjectTeamAddCustomerUsersToProjectMutationVariables>;

/**
 * __useProjectTeamAddCustomerUsersToProjectMutation__
 *
 * To run a mutation, you first call `useProjectTeamAddCustomerUsersToProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectTeamAddCustomerUsersToProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectTeamAddCustomerUsersToProjectMutation, { data, loading, error }] = useProjectTeamAddCustomerUsersToProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      users: // value for 'users'
 *      defaultAssigneeIndex: // value for 'defaultAssigneeIndex'
 *   },
 * });
 */
export function useProjectTeamAddCustomerUsersToProjectMutation(baseOptions?: Apollo.MutationHookOptions<ProjectTeamAddCustomerUsersToProjectMutation, ProjectTeamAddCustomerUsersToProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectTeamAddCustomerUsersToProjectMutation, ProjectTeamAddCustomerUsersToProjectMutationVariables>(ProjectTeamAddCustomerUsersToProjectDocument, options);
      }
export type ProjectTeamAddCustomerUsersToProjectMutationHookResult = ReturnType<typeof useProjectTeamAddCustomerUsersToProjectMutation>;
export type ProjectTeamAddCustomerUsersToProjectMutationResult = Apollo.MutationResult<ProjectTeamAddCustomerUsersToProjectMutation>;
export type ProjectTeamAddCustomerUsersToProjectMutationOptions = Apollo.BaseMutationOptions<ProjectTeamAddCustomerUsersToProjectMutation, ProjectTeamAddCustomerUsersToProjectMutationVariables>;
export const ProjectTeamAddThirdPartyUsersToProjectDocument = gql`
    mutation ProjectTeam_AddThirdPartyUsersToProject($projectId: ID!, $users: [ProjectUserInput]!) {
  addThirdPartyUsersToProject(input: {id: $projectId, users: $users}) {
    project {
      id
      users {
        id
        ...ProjectTeam_User
      }
    }
  }
}
    ${ProjectTeamUserFragmentDoc}`;
export type ProjectTeamAddThirdPartyUsersToProjectMutationFn = Apollo.MutationFunction<ProjectTeamAddThirdPartyUsersToProjectMutation, ProjectTeamAddThirdPartyUsersToProjectMutationVariables>;

/**
 * __useProjectTeamAddThirdPartyUsersToProjectMutation__
 *
 * To run a mutation, you first call `useProjectTeamAddThirdPartyUsersToProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectTeamAddThirdPartyUsersToProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectTeamAddThirdPartyUsersToProjectMutation, { data, loading, error }] = useProjectTeamAddThirdPartyUsersToProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      users: // value for 'users'
 *   },
 * });
 */
export function useProjectTeamAddThirdPartyUsersToProjectMutation(baseOptions?: Apollo.MutationHookOptions<ProjectTeamAddThirdPartyUsersToProjectMutation, ProjectTeamAddThirdPartyUsersToProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectTeamAddThirdPartyUsersToProjectMutation, ProjectTeamAddThirdPartyUsersToProjectMutationVariables>(ProjectTeamAddThirdPartyUsersToProjectDocument, options);
      }
export type ProjectTeamAddThirdPartyUsersToProjectMutationHookResult = ReturnType<typeof useProjectTeamAddThirdPartyUsersToProjectMutation>;
export type ProjectTeamAddThirdPartyUsersToProjectMutationResult = Apollo.MutationResult<ProjectTeamAddThirdPartyUsersToProjectMutation>;
export type ProjectTeamAddThirdPartyUsersToProjectMutationOptions = Apollo.BaseMutationOptions<ProjectTeamAddThirdPartyUsersToProjectMutation, ProjectTeamAddThirdPartyUsersToProjectMutationVariables>;
export const ProjectTeamUpdateUserProjectDocument = gql`
    mutation ProjectTeam_UpdateUserProject($projectId: ID!, $userId: ID!, $arguments: UpdateUserProjectArguments!) {
  updateUserProject(projectId: $projectId, userId: $userId, arguments: $arguments) {
    projectView
    restrictAccess
  }
}
    `;
export type ProjectTeamUpdateUserProjectMutationFn = Apollo.MutationFunction<ProjectTeamUpdateUserProjectMutation, ProjectTeamUpdateUserProjectMutationVariables>;

/**
 * __useProjectTeamUpdateUserProjectMutation__
 *
 * To run a mutation, you first call `useProjectTeamUpdateUserProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectTeamUpdateUserProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectTeamUpdateUserProjectMutation, { data, loading, error }] = useProjectTeamUpdateUserProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      userId: // value for 'userId'
 *      arguments: // value for 'arguments'
 *   },
 * });
 */
export function useProjectTeamUpdateUserProjectMutation(baseOptions?: Apollo.MutationHookOptions<ProjectTeamUpdateUserProjectMutation, ProjectTeamUpdateUserProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectTeamUpdateUserProjectMutation, ProjectTeamUpdateUserProjectMutationVariables>(ProjectTeamUpdateUserProjectDocument, options);
      }
export type ProjectTeamUpdateUserProjectMutationHookResult = ReturnType<typeof useProjectTeamUpdateUserProjectMutation>;
export type ProjectTeamUpdateUserProjectMutationResult = Apollo.MutationResult<ProjectTeamUpdateUserProjectMutation>;
export type ProjectTeamUpdateUserProjectMutationOptions = Apollo.BaseMutationOptions<ProjectTeamUpdateUserProjectMutation, ProjectTeamUpdateUserProjectMutationVariables>;
export const GetProjectTeamFunctionsDocument = gql`
    query GetProjectTeamFunctions($projectId: ID!) {
  projectTeamFunctions(projectId: $projectId) {
    users {
      id
      ...ProjectTeamGroupedRoleList_User
    }
    roles {
      id
      ...ProjectTeamGroupedRoleList_Roles
    }
    hasUnassignedUsers
  }
}
    ${ProjectTeamGroupedRoleListUserFragmentDoc}
${ProjectTeamGroupedRoleListRolesFragmentDoc}`;

/**
 * __useGetProjectTeamFunctionsQuery__
 *
 * To run a query within a React component, call `useGetProjectTeamFunctionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectTeamFunctionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectTeamFunctionsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectTeamFunctionsQuery(baseOptions: Apollo.QueryHookOptions<GetProjectTeamFunctionsQuery, GetProjectTeamFunctionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectTeamFunctionsQuery, GetProjectTeamFunctionsQueryVariables>(GetProjectTeamFunctionsDocument, options);
      }
export function useGetProjectTeamFunctionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectTeamFunctionsQuery, GetProjectTeamFunctionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectTeamFunctionsQuery, GetProjectTeamFunctionsQueryVariables>(GetProjectTeamFunctionsDocument, options);
        }
export type GetProjectTeamFunctionsQueryHookResult = ReturnType<typeof useGetProjectTeamFunctionsQuery>;
export type GetProjectTeamFunctionsLazyQueryHookResult = ReturnType<typeof useGetProjectTeamFunctionsLazyQuery>;
export type GetProjectTeamFunctionsQueryResult = Apollo.QueryResult<GetProjectTeamFunctionsQuery, GetProjectTeamFunctionsQueryVariables>;
export const AddWatchersFormRolesTaskWatchersDocument = gql`
    query AddWatchersForm_RolesTaskWatchers($projectId: ID!, $roleIds: [ID!]!) {
  rolesTaskWatchers(projectId: $projectId, roleIds: $roleIds) {
    id
    firstName
    lastName
    avatar {
      originalUrl
    }
  }
}
    `;

/**
 * __useAddWatchersFormRolesTaskWatchersQuery__
 *
 * To run a query within a React component, call `useAddWatchersFormRolesTaskWatchersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddWatchersFormRolesTaskWatchersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddWatchersFormRolesTaskWatchersQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      roleIds: // value for 'roleIds'
 *   },
 * });
 */
export function useAddWatchersFormRolesTaskWatchersQuery(baseOptions: Apollo.QueryHookOptions<AddWatchersFormRolesTaskWatchersQuery, AddWatchersFormRolesTaskWatchersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddWatchersFormRolesTaskWatchersQuery, AddWatchersFormRolesTaskWatchersQueryVariables>(AddWatchersFormRolesTaskWatchersDocument, options);
      }
export function useAddWatchersFormRolesTaskWatchersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddWatchersFormRolesTaskWatchersQuery, AddWatchersFormRolesTaskWatchersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddWatchersFormRolesTaskWatchersQuery, AddWatchersFormRolesTaskWatchersQueryVariables>(AddWatchersFormRolesTaskWatchersDocument, options);
        }
export type AddWatchersFormRolesTaskWatchersQueryHookResult = ReturnType<typeof useAddWatchersFormRolesTaskWatchersQuery>;
export type AddWatchersFormRolesTaskWatchersLazyQueryHookResult = ReturnType<typeof useAddWatchersFormRolesTaskWatchersLazyQuery>;
export type AddWatchersFormRolesTaskWatchersQueryResult = Apollo.QueryResult<AddWatchersFormRolesTaskWatchersQuery, AddWatchersFormRolesTaskWatchersQueryVariables>;
export const AssignRolesFormAssignUserToRolesDocument = gql`
    mutation AssignRolesForm_AssignUserToRoles($input: assignUserToRolesInput!) {
  assignUserToRoles(input: $input) {
    teamMember {
      id
      ...AssigneeField_User
    }
  }
}
    ${AssigneeFieldUserFragmentDoc}`;
export type AssignRolesFormAssignUserToRolesMutationFn = Apollo.MutationFunction<AssignRolesFormAssignUserToRolesMutation, AssignRolesFormAssignUserToRolesMutationVariables>;

/**
 * __useAssignRolesFormAssignUserToRolesMutation__
 *
 * To run a mutation, you first call `useAssignRolesFormAssignUserToRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignRolesFormAssignUserToRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignRolesFormAssignUserToRolesMutation, { data, loading, error }] = useAssignRolesFormAssignUserToRolesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignRolesFormAssignUserToRolesMutation(baseOptions?: Apollo.MutationHookOptions<AssignRolesFormAssignUserToRolesMutation, AssignRolesFormAssignUserToRolesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignRolesFormAssignUserToRolesMutation, AssignRolesFormAssignUserToRolesMutationVariables>(AssignRolesFormAssignUserToRolesDocument, options);
      }
export type AssignRolesFormAssignUserToRolesMutationHookResult = ReturnType<typeof useAssignRolesFormAssignUserToRolesMutation>;
export type AssignRolesFormAssignUserToRolesMutationResult = Apollo.MutationResult<AssignRolesFormAssignUserToRolesMutation>;
export type AssignRolesFormAssignUserToRolesMutationOptions = Apollo.BaseMutationOptions<AssignRolesFormAssignUserToRolesMutation, AssignRolesFormAssignUserToRolesMutationVariables>;
export const MultipleResourcesDropdownUsersBySkillsDocument = gql`
    query MultipleResourcesDropdown_UsersBySkills($skillIds: [ID!]!) {
  usersBySkills(skillIds: $skillIds) {
    id
    ...AssigneeField_User
  }
}
    ${AssigneeFieldUserFragmentDoc}`;

/**
 * __useMultipleResourcesDropdownUsersBySkillsQuery__
 *
 * To run a query within a React component, call `useMultipleResourcesDropdownUsersBySkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMultipleResourcesDropdownUsersBySkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMultipleResourcesDropdownUsersBySkillsQuery({
 *   variables: {
 *      skillIds: // value for 'skillIds'
 *   },
 * });
 */
export function useMultipleResourcesDropdownUsersBySkillsQuery(baseOptions: Apollo.QueryHookOptions<MultipleResourcesDropdownUsersBySkillsQuery, MultipleResourcesDropdownUsersBySkillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MultipleResourcesDropdownUsersBySkillsQuery, MultipleResourcesDropdownUsersBySkillsQueryVariables>(MultipleResourcesDropdownUsersBySkillsDocument, options);
      }
export function useMultipleResourcesDropdownUsersBySkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MultipleResourcesDropdownUsersBySkillsQuery, MultipleResourcesDropdownUsersBySkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MultipleResourcesDropdownUsersBySkillsQuery, MultipleResourcesDropdownUsersBySkillsQueryVariables>(MultipleResourcesDropdownUsersBySkillsDocument, options);
        }
export type MultipleResourcesDropdownUsersBySkillsQueryHookResult = ReturnType<typeof useMultipleResourcesDropdownUsersBySkillsQuery>;
export type MultipleResourcesDropdownUsersBySkillsLazyQueryHookResult = ReturnType<typeof useMultipleResourcesDropdownUsersBySkillsLazyQuery>;
export type MultipleResourcesDropdownUsersBySkillsQueryResult = Apollo.QueryResult<MultipleResourcesDropdownUsersBySkillsQuery, MultipleResourcesDropdownUsersBySkillsQueryVariables>;
export const UserInviteInformationResendInvitationDocument = gql`
    mutation UserInviteInformation_ResendInvitation($email: String!, $projectId: ID) {
  resendInviteToUser(input: {email: $email, projectId: $projectId}) {
    success
  }
}
    `;
export type UserInviteInformationResendInvitationMutationFn = Apollo.MutationFunction<UserInviteInformationResendInvitationMutation, UserInviteInformationResendInvitationMutationVariables>;

/**
 * __useUserInviteInformationResendInvitationMutation__
 *
 * To run a mutation, you first call `useUserInviteInformationResendInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserInviteInformationResendInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userInviteInformationResendInvitationMutation, { data, loading, error }] = useUserInviteInformationResendInvitationMutation({
 *   variables: {
 *      email: // value for 'email'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useUserInviteInformationResendInvitationMutation(baseOptions?: Apollo.MutationHookOptions<UserInviteInformationResendInvitationMutation, UserInviteInformationResendInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserInviteInformationResendInvitationMutation, UserInviteInformationResendInvitationMutationVariables>(UserInviteInformationResendInvitationDocument, options);
      }
export type UserInviteInformationResendInvitationMutationHookResult = ReturnType<typeof useUserInviteInformationResendInvitationMutation>;
export type UserInviteInformationResendInvitationMutationResult = Apollo.MutationResult<UserInviteInformationResendInvitationMutation>;
export type UserInviteInformationResendInvitationMutationOptions = Apollo.BaseMutationOptions<UserInviteInformationResendInvitationMutation, UserInviteInformationResendInvitationMutationVariables>;
export const TeamCardCastListResendInvitationDocument = gql`
    mutation TeamCardCastList_ResendInvitation($email: String!, $projectId: ID) {
  resendInviteToUser(input: {email: $email, projectId: $projectId}) {
    success
  }
}
    `;
export type TeamCardCastListResendInvitationMutationFn = Apollo.MutationFunction<TeamCardCastListResendInvitationMutation, TeamCardCastListResendInvitationMutationVariables>;

/**
 * __useTeamCardCastListResendInvitationMutation__
 *
 * To run a mutation, you first call `useTeamCardCastListResendInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTeamCardCastListResendInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [teamCardCastListResendInvitationMutation, { data, loading, error }] = useTeamCardCastListResendInvitationMutation({
 *   variables: {
 *      email: // value for 'email'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useTeamCardCastListResendInvitationMutation(baseOptions?: Apollo.MutationHookOptions<TeamCardCastListResendInvitationMutation, TeamCardCastListResendInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeamCardCastListResendInvitationMutation, TeamCardCastListResendInvitationMutationVariables>(TeamCardCastListResendInvitationDocument, options);
      }
export type TeamCardCastListResendInvitationMutationHookResult = ReturnType<typeof useTeamCardCastListResendInvitationMutation>;
export type TeamCardCastListResendInvitationMutationResult = Apollo.MutationResult<TeamCardCastListResendInvitationMutation>;
export type TeamCardCastListResendInvitationMutationOptions = Apollo.BaseMutationOptions<TeamCardCastListResendInvitationMutation, TeamCardCastListResendInvitationMutationVariables>;
export const ProjectTemplatesDropEligibilityDocument = gql`
    query ProjectTemplates_DropEligibility($input: DropInput!) {
  dropEligibility(dropInputs: $input) {
    eligibility
    message
  }
}
    `;

/**
 * __useProjectTemplatesDropEligibilityQuery__
 *
 * To run a query within a React component, call `useProjectTemplatesDropEligibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectTemplatesDropEligibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectTemplatesDropEligibilityQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProjectTemplatesDropEligibilityQuery(baseOptions: Apollo.QueryHookOptions<ProjectTemplatesDropEligibilityQuery, ProjectTemplatesDropEligibilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectTemplatesDropEligibilityQuery, ProjectTemplatesDropEligibilityQueryVariables>(ProjectTemplatesDropEligibilityDocument, options);
      }
export function useProjectTemplatesDropEligibilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectTemplatesDropEligibilityQuery, ProjectTemplatesDropEligibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectTemplatesDropEligibilityQuery, ProjectTemplatesDropEligibilityQueryVariables>(ProjectTemplatesDropEligibilityDocument, options);
        }
export type ProjectTemplatesDropEligibilityQueryHookResult = ReturnType<typeof useProjectTemplatesDropEligibilityQuery>;
export type ProjectTemplatesDropEligibilityLazyQueryHookResult = ReturnType<typeof useProjectTemplatesDropEligibilityLazyQuery>;
export type ProjectTemplatesDropEligibilityQueryResult = Apollo.QueryResult<ProjectTemplatesDropEligibilityQuery, ProjectTemplatesDropEligibilityQueryVariables>;
export const ProjectTimelineTimelineProjectsDocument = gql`
    query ProjectTimeline_TimelineProjects($startDate: DateType, $endDate: DateType, $searchTerm: String, $projectFilters: ProjectFilters) {
  timelineProjects(
    startDate: $startDate
    endDate: $endDate
    keyword: $searchTerm
    projectFilters: $projectFilters
  ) {
    startDate
    endDate
    projectsByProjectManager {
      projectManager {
        id
        ...SideBar_User
      }
      projects {
        id
        ...ProjectTimelineItem_Project
      }
      projectCountPerDay {
        projectsCount
        sequentialDate
      }
      projectCountPerWeek {
        projectsCount
        sequentialDate
        sequentialWeek
      }
    }
  }
}
    ${SideBarUserFragmentDoc}
${ProjectTimelineItemProjectFragmentDoc}`;

/**
 * __useProjectTimelineTimelineProjectsQuery__
 *
 * To run a query within a React component, call `useProjectTimelineTimelineProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectTimelineTimelineProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectTimelineTimelineProjectsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      searchTerm: // value for 'searchTerm'
 *      projectFilters: // value for 'projectFilters'
 *   },
 * });
 */
export function useProjectTimelineTimelineProjectsQuery(baseOptions?: Apollo.QueryHookOptions<ProjectTimelineTimelineProjectsQuery, ProjectTimelineTimelineProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectTimelineTimelineProjectsQuery, ProjectTimelineTimelineProjectsQueryVariables>(ProjectTimelineTimelineProjectsDocument, options);
      }
export function useProjectTimelineTimelineProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectTimelineTimelineProjectsQuery, ProjectTimelineTimelineProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectTimelineTimelineProjectsQuery, ProjectTimelineTimelineProjectsQueryVariables>(ProjectTimelineTimelineProjectsDocument, options);
        }
export type ProjectTimelineTimelineProjectsQueryHookResult = ReturnType<typeof useProjectTimelineTimelineProjectsQuery>;
export type ProjectTimelineTimelineProjectsLazyQueryHookResult = ReturnType<typeof useProjectTimelineTimelineProjectsLazyQuery>;
export type ProjectTimelineTimelineProjectsQueryResult = Apollo.QueryResult<ProjectTimelineTimelineProjectsQuery, ProjectTimelineTimelineProjectsQueryVariables>;
export const SoftDeleteProjectConfirmationDeleteProjectDocument = gql`
    mutation SoftDeleteProjectConfirmation_DeleteProject($id: ID!, $hardDelete: Boolean!) {
  deleteProject(input: {id: $id, hardDelete: $hardDelete}) {
    deletedProjectId
  }
}
    `;
export type SoftDeleteProjectConfirmationDeleteProjectMutationFn = Apollo.MutationFunction<SoftDeleteProjectConfirmationDeleteProjectMutation, SoftDeleteProjectConfirmationDeleteProjectMutationVariables>;

/**
 * __useSoftDeleteProjectConfirmationDeleteProjectMutation__
 *
 * To run a mutation, you first call `useSoftDeleteProjectConfirmationDeleteProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftDeleteProjectConfirmationDeleteProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softDeleteProjectConfirmationDeleteProjectMutation, { data, loading, error }] = useSoftDeleteProjectConfirmationDeleteProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *      hardDelete: // value for 'hardDelete'
 *   },
 * });
 */
export function useSoftDeleteProjectConfirmationDeleteProjectMutation(baseOptions?: Apollo.MutationHookOptions<SoftDeleteProjectConfirmationDeleteProjectMutation, SoftDeleteProjectConfirmationDeleteProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftDeleteProjectConfirmationDeleteProjectMutation, SoftDeleteProjectConfirmationDeleteProjectMutationVariables>(SoftDeleteProjectConfirmationDeleteProjectDocument, options);
      }
export type SoftDeleteProjectConfirmationDeleteProjectMutationHookResult = ReturnType<typeof useSoftDeleteProjectConfirmationDeleteProjectMutation>;
export type SoftDeleteProjectConfirmationDeleteProjectMutationResult = Apollo.MutationResult<SoftDeleteProjectConfirmationDeleteProjectMutation>;
export type SoftDeleteProjectConfirmationDeleteProjectMutationOptions = Apollo.BaseMutationOptions<SoftDeleteProjectConfirmationDeleteProjectMutation, SoftDeleteProjectConfirmationDeleteProjectMutationVariables>;
export const StatusDropDownUpdateNodeStatusDocument = gql`
    mutation StatusDropDown_UpdateNodeStatus($id: ID!, $status: StatusEnumType!, $objectType: StatusObjectEnumType!) {
  updateObjectStatus(input: {id: $id, status: $status, objectType: $objectType}) {
    resolveObject {
      ... on ActionItemType {
        id
        status
        __typename
      }
    }
  }
}
    `;
export type StatusDropDownUpdateNodeStatusMutationFn = Apollo.MutationFunction<StatusDropDownUpdateNodeStatusMutation, StatusDropDownUpdateNodeStatusMutationVariables>;

/**
 * __useStatusDropDownUpdateNodeStatusMutation__
 *
 * To run a mutation, you first call `useStatusDropDownUpdateNodeStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStatusDropDownUpdateNodeStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [statusDropDownUpdateNodeStatusMutation, { data, loading, error }] = useStatusDropDownUpdateNodeStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      objectType: // value for 'objectType'
 *   },
 * });
 */
export function useStatusDropDownUpdateNodeStatusMutation(baseOptions?: Apollo.MutationHookOptions<StatusDropDownUpdateNodeStatusMutation, StatusDropDownUpdateNodeStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StatusDropDownUpdateNodeStatusMutation, StatusDropDownUpdateNodeStatusMutationVariables>(StatusDropDownUpdateNodeStatusDocument, options);
      }
export type StatusDropDownUpdateNodeStatusMutationHookResult = ReturnType<typeof useStatusDropDownUpdateNodeStatusMutation>;
export type StatusDropDownUpdateNodeStatusMutationResult = Apollo.MutationResult<StatusDropDownUpdateNodeStatusMutation>;
export type StatusDropDownUpdateNodeStatusMutationOptions = Apollo.BaseMutationOptions<StatusDropDownUpdateNodeStatusMutation, StatusDropDownUpdateNodeStatusMutationVariables>;
export const CapacityBoxProjectsDocument = gql`
    query CapacityBox_Projects($filters: CapacityFilterInput!, $groupBy: CapacityGroupByEnum!, $userId: ID!) {
  projectsConnections(
    userId: $userId
    listInputs: {paginated: false}
    projectFilters: {context: RESOURCE_MANAGEMENT, strict: true}
  ) {
    projects {
      id
      name
      status
      ...CapacityBox_Project
    }
  }
}
    ${CapacityBoxProjectFragmentDoc}`;

/**
 * __useCapacityBoxProjectsQuery__
 *
 * To run a query within a React component, call `useCapacityBoxProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCapacityBoxProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCapacityBoxProjectsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      groupBy: // value for 'groupBy'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCapacityBoxProjectsQuery(baseOptions: Apollo.QueryHookOptions<CapacityBoxProjectsQuery, CapacityBoxProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CapacityBoxProjectsQuery, CapacityBoxProjectsQueryVariables>(CapacityBoxProjectsDocument, options);
      }
export function useCapacityBoxProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CapacityBoxProjectsQuery, CapacityBoxProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CapacityBoxProjectsQuery, CapacityBoxProjectsQueryVariables>(CapacityBoxProjectsDocument, options);
        }
export type CapacityBoxProjectsQueryHookResult = ReturnType<typeof useCapacityBoxProjectsQuery>;
export type CapacityBoxProjectsLazyQueryHookResult = ReturnType<typeof useCapacityBoxProjectsLazyQuery>;
export type CapacityBoxProjectsQueryResult = Apollo.QueryResult<CapacityBoxProjectsQuery, CapacityBoxProjectsQueryVariables>;
export const CapacityDetailsModalProjectsDocument = gql`
    query CapacityDetailsModal_Projects($userId: ID!, $startDate: DateType!, $endDate: DateType!, $filters: ProjectFilters!) {
  projectsConnections(
    listInputs: {paginated: false}
    userId: $userId
    projectFilters: $filters
  ) {
    projects {
      id
      ...CapacityDetailsModal_Project
      tasks(taskFilters: {assigneeIds: [$userId]}, context: RESOURCE_MANAGEMENT) {
        id
        ...CapacityDetailsModal_Task
      }
    }
  }
}
    ${CapacityDetailsModalProjectFragmentDoc}
${CapacityDetailsModalTaskFragmentDoc}`;

/**
 * __useCapacityDetailsModalProjectsQuery__
 *
 * To run a query within a React component, call `useCapacityDetailsModalProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCapacityDetailsModalProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCapacityDetailsModalProjectsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCapacityDetailsModalProjectsQuery(baseOptions: Apollo.QueryHookOptions<CapacityDetailsModalProjectsQuery, CapacityDetailsModalProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CapacityDetailsModalProjectsQuery, CapacityDetailsModalProjectsQueryVariables>(CapacityDetailsModalProjectsDocument, options);
      }
export function useCapacityDetailsModalProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CapacityDetailsModalProjectsQuery, CapacityDetailsModalProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CapacityDetailsModalProjectsQuery, CapacityDetailsModalProjectsQueryVariables>(CapacityDetailsModalProjectsDocument, options);
        }
export type CapacityDetailsModalProjectsQueryHookResult = ReturnType<typeof useCapacityDetailsModalProjectsQuery>;
export type CapacityDetailsModalProjectsLazyQueryHookResult = ReturnType<typeof useCapacityDetailsModalProjectsLazyQuery>;
export type CapacityDetailsModalProjectsQueryResult = Apollo.QueryResult<CapacityDetailsModalProjectsQuery, CapacityDetailsModalProjectsQueryVariables>;
export const CapacityDetailsModalHeaderUserDocument = gql`
    query CapacityDetailsModalHeader_User($id: ID!, $filters: CapacityFilterInput!) {
  user(id: $id) {
    id
    ...CapacityDetailsModalHeader_QueriedUser
  }
}
    ${CapacityDetailsModalHeaderQueriedUserFragmentDoc}`;

/**
 * __useCapacityDetailsModalHeaderUserQuery__
 *
 * To run a query within a React component, call `useCapacityDetailsModalHeaderUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCapacityDetailsModalHeaderUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCapacityDetailsModalHeaderUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCapacityDetailsModalHeaderUserQuery(baseOptions: Apollo.QueryHookOptions<CapacityDetailsModalHeaderUserQuery, CapacityDetailsModalHeaderUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CapacityDetailsModalHeaderUserQuery, CapacityDetailsModalHeaderUserQueryVariables>(CapacityDetailsModalHeaderUserDocument, options);
      }
export function useCapacityDetailsModalHeaderUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CapacityDetailsModalHeaderUserQuery, CapacityDetailsModalHeaderUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CapacityDetailsModalHeaderUserQuery, CapacityDetailsModalHeaderUserQueryVariables>(CapacityDetailsModalHeaderUserDocument, options);
        }
export type CapacityDetailsModalHeaderUserQueryHookResult = ReturnType<typeof useCapacityDetailsModalHeaderUserQuery>;
export type CapacityDetailsModalHeaderUserLazyQueryHookResult = ReturnType<typeof useCapacityDetailsModalHeaderUserLazyQuery>;
export type CapacityDetailsModalHeaderUserQueryResult = Apollo.QueryResult<CapacityDetailsModalHeaderUserQuery, CapacityDetailsModalHeaderUserQueryVariables>;
export const CapacityDetailsModalHeaderUserUpdatedDocument = gql`
    subscription CapacityDetailsModalHeader_UserUpdated($id: ID!, $filters: CapacityFilterInput!) {
  userUpdated(userId: $id) {
    id
    ...CapacityDetailsModalHeader_QueriedUser
  }
}
    ${CapacityDetailsModalHeaderQueriedUserFragmentDoc}`;

/**
 * __useCapacityDetailsModalHeaderUserUpdatedSubscription__
 *
 * To run a query within a React component, call `useCapacityDetailsModalHeaderUserUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCapacityDetailsModalHeaderUserUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCapacityDetailsModalHeaderUserUpdatedSubscription({
 *   variables: {
 *      id: // value for 'id'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCapacityDetailsModalHeaderUserUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<CapacityDetailsModalHeaderUserUpdatedSubscription, CapacityDetailsModalHeaderUserUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CapacityDetailsModalHeaderUserUpdatedSubscription, CapacityDetailsModalHeaderUserUpdatedSubscriptionVariables>(CapacityDetailsModalHeaderUserUpdatedDocument, options);
      }
export type CapacityDetailsModalHeaderUserUpdatedSubscriptionHookResult = ReturnType<typeof useCapacityDetailsModalHeaderUserUpdatedSubscription>;
export type CapacityDetailsModalHeaderUserUpdatedSubscriptionResult = Apollo.SubscriptionResult<CapacityDetailsModalHeaderUserUpdatedSubscription>;
export const TaskPillUpdateTaskDocument = gql`
    mutation TaskPill_UpdateTask($inputs: updateTaskInput!) {
  updateTask(input: $inputs) {
    taskReturnData {
      task {
        id
        assignee {
          id
          ...TaskPill_User
        }
      }
    }
  }
}
    ${TaskPillUserFragmentDoc}`;
export type TaskPillUpdateTaskMutationFn = Apollo.MutationFunction<TaskPillUpdateTaskMutation, TaskPillUpdateTaskMutationVariables>;

/**
 * __useTaskPillUpdateTaskMutation__
 *
 * To run a mutation, you first call `useTaskPillUpdateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskPillUpdateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskPillUpdateTaskMutation, { data, loading, error }] = useTaskPillUpdateTaskMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useTaskPillUpdateTaskMutation(baseOptions?: Apollo.MutationHookOptions<TaskPillUpdateTaskMutation, TaskPillUpdateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskPillUpdateTaskMutation, TaskPillUpdateTaskMutationVariables>(TaskPillUpdateTaskDocument, options);
      }
export type TaskPillUpdateTaskMutationHookResult = ReturnType<typeof useTaskPillUpdateTaskMutation>;
export type TaskPillUpdateTaskMutationResult = Apollo.MutationResult<TaskPillUpdateTaskMutation>;
export type TaskPillUpdateTaskMutationOptions = Apollo.BaseMutationOptions<TaskPillUpdateTaskMutation, TaskPillUpdateTaskMutationVariables>;
export const TaskPillTaskUpdatedDocument = gql`
    subscription TaskPill_TaskUpdated($taskId: ID!, $startDate: DateType!, $endDate: DateType!) {
  taskUpdated(taskId: $taskId) {
    id
    ...TaskPill_Task
  }
}
    ${TaskPillTaskFragmentDoc}`;

/**
 * __useTaskPillTaskUpdatedSubscription__
 *
 * To run a query within a React component, call `useTaskPillTaskUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTaskPillTaskUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskPillTaskUpdatedSubscription({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useTaskPillTaskUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<TaskPillTaskUpdatedSubscription, TaskPillTaskUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<TaskPillTaskUpdatedSubscription, TaskPillTaskUpdatedSubscriptionVariables>(TaskPillTaskUpdatedDocument, options);
      }
export type TaskPillTaskUpdatedSubscriptionHookResult = ReturnType<typeof useTaskPillTaskUpdatedSubscription>;
export type TaskPillTaskUpdatedSubscriptionResult = Apollo.SubscriptionResult<TaskPillTaskUpdatedSubscription>;
export const UserDropdownResourceManagementUsersDocument = gql`
    query UserDropdown_ResourceManagementUsers($filters: CapacityFilterInput!, $listInputs: ListInput) {
  resourceManagementUsers(listInputs: $listInputs) {
    users {
      id
      ...UserDropdown_User
    }
  }
}
    ${UserDropdownUserFragmentDoc}`;

/**
 * __useUserDropdownResourceManagementUsersQuery__
 *
 * To run a query within a React component, call `useUserDropdownResourceManagementUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDropdownResourceManagementUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDropdownResourceManagementUsersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      listInputs: // value for 'listInputs'
 *   },
 * });
 */
export function useUserDropdownResourceManagementUsersQuery(baseOptions: Apollo.QueryHookOptions<UserDropdownResourceManagementUsersQuery, UserDropdownResourceManagementUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserDropdownResourceManagementUsersQuery, UserDropdownResourceManagementUsersQueryVariables>(UserDropdownResourceManagementUsersDocument, options);
      }
export function useUserDropdownResourceManagementUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserDropdownResourceManagementUsersQuery, UserDropdownResourceManagementUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserDropdownResourceManagementUsersQuery, UserDropdownResourceManagementUsersQueryVariables>(UserDropdownResourceManagementUsersDocument, options);
        }
export type UserDropdownResourceManagementUsersQueryHookResult = ReturnType<typeof useUserDropdownResourceManagementUsersQuery>;
export type UserDropdownResourceManagementUsersLazyQueryHookResult = ReturnType<typeof useUserDropdownResourceManagementUsersLazyQuery>;
export type UserDropdownResourceManagementUsersQueryResult = Apollo.QueryResult<UserDropdownResourceManagementUsersQuery, UserDropdownResourceManagementUsersQueryVariables>;
export const CapacityPlanningUsersDocument = gql`
    query CapacityPlanning_Users($listInputs: ListInput!, $groupBy: CapacityGroupByEnum!, $filters: CapacityFilterInput!) {
  timeCapacityUsers(listInputs: $listInputs, filters: $filters) {
    pageInfo {
      ...PageInfoFragment
    }
    users {
      id
      ...CapacityPlanning_User
    }
  }
}
    ${PageInfoFragmentDoc}
${CapacityPlanningUserFragmentDoc}`;

/**
 * __useCapacityPlanningUsersQuery__
 *
 * To run a query within a React component, call `useCapacityPlanningUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCapacityPlanningUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCapacityPlanningUsersQuery({
 *   variables: {
 *      listInputs: // value for 'listInputs'
 *      groupBy: // value for 'groupBy'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCapacityPlanningUsersQuery(baseOptions: Apollo.QueryHookOptions<CapacityPlanningUsersQuery, CapacityPlanningUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CapacityPlanningUsersQuery, CapacityPlanningUsersQueryVariables>(CapacityPlanningUsersDocument, options);
      }
export function useCapacityPlanningUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CapacityPlanningUsersQuery, CapacityPlanningUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CapacityPlanningUsersQuery, CapacityPlanningUsersQueryVariables>(CapacityPlanningUsersDocument, options);
        }
export type CapacityPlanningUsersQueryHookResult = ReturnType<typeof useCapacityPlanningUsersQuery>;
export type CapacityPlanningUsersLazyQueryHookResult = ReturnType<typeof useCapacityPlanningUsersLazyQuery>;
export type CapacityPlanningUsersQueryResult = Apollo.QueryResult<CapacityPlanningUsersQuery, CapacityPlanningUsersQueryVariables>;
export const ResourceEditDialogUserDocument = gql`
    query ResourceEditDialog_User($userId: ID!) {
  user(id: $userId) {
    id
    ...SkillsList_User
  }
}
    ${SkillsListUserFragmentDoc}`;

/**
 * __useResourceEditDialogUserQuery__
 *
 * To run a query within a React component, call `useResourceEditDialogUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceEditDialogUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceEditDialogUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useResourceEditDialogUserQuery(baseOptions: Apollo.QueryHookOptions<ResourceEditDialogUserQuery, ResourceEditDialogUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourceEditDialogUserQuery, ResourceEditDialogUserQueryVariables>(ResourceEditDialogUserDocument, options);
      }
export function useResourceEditDialogUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourceEditDialogUserQuery, ResourceEditDialogUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourceEditDialogUserQuery, ResourceEditDialogUserQueryVariables>(ResourceEditDialogUserDocument, options);
        }
export type ResourceEditDialogUserQueryHookResult = ReturnType<typeof useResourceEditDialogUserQuery>;
export type ResourceEditDialogUserLazyQueryHookResult = ReturnType<typeof useResourceEditDialogUserLazyQuery>;
export type ResourceEditDialogUserQueryResult = Apollo.QueryResult<ResourceEditDialogUserQuery, ResourceEditDialogUserQueryVariables>;
export const ResourceEditDialogUpdateResourceDocument = gql`
    mutation ResourceEditDialog_UpdateResource($input: updateResourceInput!) {
  updateResource(input: $input) {
    resource {
      ...SkillsList_User
    }
  }
}
    ${SkillsListUserFragmentDoc}`;
export type ResourceEditDialogUpdateResourceMutationFn = Apollo.MutationFunction<ResourceEditDialogUpdateResourceMutation, ResourceEditDialogUpdateResourceMutationVariables>;

/**
 * __useResourceEditDialogUpdateResourceMutation__
 *
 * To run a mutation, you first call `useResourceEditDialogUpdateResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResourceEditDialogUpdateResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resourceEditDialogUpdateResourceMutation, { data, loading, error }] = useResourceEditDialogUpdateResourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResourceEditDialogUpdateResourceMutation(baseOptions?: Apollo.MutationHookOptions<ResourceEditDialogUpdateResourceMutation, ResourceEditDialogUpdateResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResourceEditDialogUpdateResourceMutation, ResourceEditDialogUpdateResourceMutationVariables>(ResourceEditDialogUpdateResourceDocument, options);
      }
export type ResourceEditDialogUpdateResourceMutationHookResult = ReturnType<typeof useResourceEditDialogUpdateResourceMutation>;
export type ResourceEditDialogUpdateResourceMutationResult = Apollo.MutationResult<ResourceEditDialogUpdateResourceMutation>;
export type ResourceEditDialogUpdateResourceMutationOptions = Apollo.BaseMutationOptions<ResourceEditDialogUpdateResourceMutation, ResourceEditDialogUpdateResourceMutationVariables>;
export const ResourcesTableSkillCategoriesDocument = gql`
    query ResourcesTable_SkillCategories($organizationId: ID!) {
  organization(id: $organizationId) {
    skillCategories {
      id
      name
      skillCount
      userCount
    }
  }
}
    `;

/**
 * __useResourcesTableSkillCategoriesQuery__
 *
 * To run a query within a React component, call `useResourcesTableSkillCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcesTableSkillCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourcesTableSkillCategoriesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useResourcesTableSkillCategoriesQuery(baseOptions: Apollo.QueryHookOptions<ResourcesTableSkillCategoriesQuery, ResourcesTableSkillCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourcesTableSkillCategoriesQuery, ResourcesTableSkillCategoriesQueryVariables>(ResourcesTableSkillCategoriesDocument, options);
      }
export function useResourcesTableSkillCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourcesTableSkillCategoriesQuery, ResourcesTableSkillCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourcesTableSkillCategoriesQuery, ResourcesTableSkillCategoriesQueryVariables>(ResourcesTableSkillCategoriesDocument, options);
        }
export type ResourcesTableSkillCategoriesQueryHookResult = ReturnType<typeof useResourcesTableSkillCategoriesQuery>;
export type ResourcesTableSkillCategoriesLazyQueryHookResult = ReturnType<typeof useResourcesTableSkillCategoriesLazyQuery>;
export type ResourcesTableSkillCategoriesQueryResult = Apollo.QueryResult<ResourcesTableSkillCategoriesQuery, ResourcesTableSkillCategoriesQueryVariables>;
export const SkillsListSkillsConnectionsDocument = gql`
    query skillsList_SkillsConnections($listInputs: ListInput) {
  skillsConnections(listInputs: $listInputs) {
    pageInfo {
      ...PageInfoFragment
      __typename
    }
    skills {
      id
      ...SkillsList_Skill
    }
  }
}
    ${PageInfoFragmentDoc}
${SkillsListSkillFragmentDoc}`;

/**
 * __useSkillsListSkillsConnectionsQuery__
 *
 * To run a query within a React component, call `useSkillsListSkillsConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkillsListSkillsConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkillsListSkillsConnectionsQuery({
 *   variables: {
 *      listInputs: // value for 'listInputs'
 *   },
 * });
 */
export function useSkillsListSkillsConnectionsQuery(baseOptions?: Apollo.QueryHookOptions<SkillsListSkillsConnectionsQuery, SkillsListSkillsConnectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SkillsListSkillsConnectionsQuery, SkillsListSkillsConnectionsQueryVariables>(SkillsListSkillsConnectionsDocument, options);
      }
export function useSkillsListSkillsConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SkillsListSkillsConnectionsQuery, SkillsListSkillsConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SkillsListSkillsConnectionsQuery, SkillsListSkillsConnectionsQueryVariables>(SkillsListSkillsConnectionsDocument, options);
        }
export type SkillsListSkillsConnectionsQueryHookResult = ReturnType<typeof useSkillsListSkillsConnectionsQuery>;
export type SkillsListSkillsConnectionsLazyQueryHookResult = ReturnType<typeof useSkillsListSkillsConnectionsLazyQuery>;
export type SkillsListSkillsConnectionsQueryResult = Apollo.QueryResult<SkillsListSkillsConnectionsQuery, SkillsListSkillsConnectionsQueryVariables>;
export const UpdateCategoryNameDocument = gql`
    mutation updateCategoryName($input: updateSkillCategoryInput!) {
  updateSkillCategory(input: $input) {
    skillCategory {
      id
      name
    }
  }
}
    `;
export type UpdateCategoryNameMutationFn = Apollo.MutationFunction<UpdateCategoryNameMutation, UpdateCategoryNameMutationVariables>;

/**
 * __useUpdateCategoryNameMutation__
 *
 * To run a mutation, you first call `useUpdateCategoryNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCategoryNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCategoryNameMutation, { data, loading, error }] = useUpdateCategoryNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCategoryNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCategoryNameMutation, UpdateCategoryNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCategoryNameMutation, UpdateCategoryNameMutationVariables>(UpdateCategoryNameDocument, options);
      }
export type UpdateCategoryNameMutationHookResult = ReturnType<typeof useUpdateCategoryNameMutation>;
export type UpdateCategoryNameMutationResult = Apollo.MutationResult<UpdateCategoryNameMutation>;
export type UpdateCategoryNameMutationOptions = Apollo.BaseMutationOptions<UpdateCategoryNameMutation, UpdateCategoryNameMutationVariables>;
export const SettingsUpdateCapacitiesDocument = gql`
    mutation Settings_UpdateCapacities($input: updateCapacitiesInput!) {
  updateCapacities(input: $input) {
    updatedUsers {
      id
      capacityHours
    }
  }
}
    `;
export type SettingsUpdateCapacitiesMutationFn = Apollo.MutationFunction<SettingsUpdateCapacitiesMutation, SettingsUpdateCapacitiesMutationVariables>;

/**
 * __useSettingsUpdateCapacitiesMutation__
 *
 * To run a mutation, you first call `useSettingsUpdateCapacitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSettingsUpdateCapacitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [settingsUpdateCapacitiesMutation, { data, loading, error }] = useSettingsUpdateCapacitiesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSettingsUpdateCapacitiesMutation(baseOptions?: Apollo.MutationHookOptions<SettingsUpdateCapacitiesMutation, SettingsUpdateCapacitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SettingsUpdateCapacitiesMutation, SettingsUpdateCapacitiesMutationVariables>(SettingsUpdateCapacitiesDocument, options);
      }
export type SettingsUpdateCapacitiesMutationHookResult = ReturnType<typeof useSettingsUpdateCapacitiesMutation>;
export type SettingsUpdateCapacitiesMutationResult = Apollo.MutationResult<SettingsUpdateCapacitiesMutation>;
export type SettingsUpdateCapacitiesMutationOptions = Apollo.BaseMutationOptions<SettingsUpdateCapacitiesMutation, SettingsUpdateCapacitiesMutationVariables>;
export const CapacityUpdateOrganizationDocument = gql`
    mutation Capacity_UpdateOrganization($organization: updateOrganizationInput!) {
  updateOrganization(input: $organization) {
    organization {
      id
      defaultCapacityHours
      pmCanEditSkills
    }
  }
}
    `;
export type CapacityUpdateOrganizationMutationFn = Apollo.MutationFunction<CapacityUpdateOrganizationMutation, CapacityUpdateOrganizationMutationVariables>;

/**
 * __useCapacityUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useCapacityUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCapacityUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [capacityUpdateOrganizationMutation, { data, loading, error }] = useCapacityUpdateOrganizationMutation({
 *   variables: {
 *      organization: // value for 'organization'
 *   },
 * });
 */
export function useCapacityUpdateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<CapacityUpdateOrganizationMutation, CapacityUpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CapacityUpdateOrganizationMutation, CapacityUpdateOrganizationMutationVariables>(CapacityUpdateOrganizationDocument, options);
      }
export type CapacityUpdateOrganizationMutationHookResult = ReturnType<typeof useCapacityUpdateOrganizationMutation>;
export type CapacityUpdateOrganizationMutationResult = Apollo.MutationResult<CapacityUpdateOrganizationMutation>;
export type CapacityUpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<CapacityUpdateOrganizationMutation, CapacityUpdateOrganizationMutationVariables>;
export const EditTaskDrawerUpdateTaskGroupTaskMutationDocument = gql`
    mutation EditTaskDrawer_UpdateTaskGroupTaskMutation($task: updateTaskInput!) {
  updateTaskGroupTask(input: $task) {
    taskReturnData {
      task {
        id
        taskType
        name
        description
        startOn
        dueOn
        estimatedHours
        actualHours
        billableHours
        nonBillableHours
        estimatedPoints
        duration
        sortOrder
        priority
        responsibility
        signOffRequired
        status
        shouldWarnUpdateStatus
        currentUserTaskContext
        eventDatetime
        participantCallToAction
        invitationGroupSentAt
        ...TaskFormContext_Task
        dependency {
          ... on MilestoneType {
            id
            completed
            tasks {
              id
              shouldWarnUpdateStatus
            }
          }
          ... on TaskType {
            id
            completed
            shouldWarnUpdateStatus
          }
          ... on TemplateType {
            id
            completed
          }
          ... on TaskGroupType {
            id
            completed
            tasks {
              id
              shouldWarnUpdateStatus
            }
          }
        }
        assignee {
          id
          firstName
          lastName
          jobRole
          avatar {
            originalUrl
          }
        }
        signer {
          id
          firstName
          lastName
          email
        }
        notes {
          id
        }
        jiraTask {
          id
          externalId
          externalProjectId
          externalTypeId
          components
        }
        files {
          id
          ...Attachments_File
        }
        subtasks {
          ...SubtaskFragment
        }
        taskParticipants {
          id
          completed
          invitationSentAt
          user {
            id
          }
        }
        template {
          id
          duration
        }
        project {
          id
          status
          ...EditTaskDrawer_ProjectSnapshotFragment
          stats {
            ...EditTaskDrawer_ProjectStatsFragment
          }
          profitabilitySummary {
            forecastedCost
            budgetedCost
          }
        }
      }
    }
  }
}
    ${TaskFormContextTaskFragmentDoc}
${AttachmentsFileFragmentDoc}
${SubtaskFragmentDoc}
${EditTaskDrawerProjectSnapshotFragmentDoc}
${EditTaskDrawerProjectStatsFragmentDoc}`;
export type EditTaskDrawerUpdateTaskGroupTaskMutationMutationFn = Apollo.MutationFunction<EditTaskDrawerUpdateTaskGroupTaskMutation, EditTaskDrawerUpdateTaskGroupTaskMutationVariables>;

/**
 * __useEditTaskDrawerUpdateTaskGroupTaskMutation__
 *
 * To run a mutation, you first call `useEditTaskDrawerUpdateTaskGroupTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTaskDrawerUpdateTaskGroupTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTaskDrawerUpdateTaskGroupTaskMutation, { data, loading, error }] = useEditTaskDrawerUpdateTaskGroupTaskMutation({
 *   variables: {
 *      task: // value for 'task'
 *   },
 * });
 */
export function useEditTaskDrawerUpdateTaskGroupTaskMutation(baseOptions?: Apollo.MutationHookOptions<EditTaskDrawerUpdateTaskGroupTaskMutation, EditTaskDrawerUpdateTaskGroupTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditTaskDrawerUpdateTaskGroupTaskMutation, EditTaskDrawerUpdateTaskGroupTaskMutationVariables>(EditTaskDrawerUpdateTaskGroupTaskMutationDocument, options);
      }
export type EditTaskDrawerUpdateTaskGroupTaskMutationHookResult = ReturnType<typeof useEditTaskDrawerUpdateTaskGroupTaskMutation>;
export type EditTaskDrawerUpdateTaskGroupTaskMutationMutationResult = Apollo.MutationResult<EditTaskDrawerUpdateTaskGroupTaskMutation>;
export type EditTaskDrawerUpdateTaskGroupTaskMutationMutationOptions = Apollo.BaseMutationOptions<EditTaskDrawerUpdateTaskGroupTaskMutation, EditTaskDrawerUpdateTaskGroupTaskMutationVariables>;
export const EditTaskDrawerProjectTeamDocument = gql`
    query EditTaskDrawer_ProjectTeam($projectId: ID!) {
  projectTeam(projectId: $projectId) {
    id
    ...Notes_ProjectTeam
  }
}
    ${NotesProjectTeamFragmentDoc}`;

/**
 * __useEditTaskDrawerProjectTeamQuery__
 *
 * To run a query within a React component, call `useEditTaskDrawerProjectTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditTaskDrawerProjectTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditTaskDrawerProjectTeamQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useEditTaskDrawerProjectTeamQuery(baseOptions: Apollo.QueryHookOptions<EditTaskDrawerProjectTeamQuery, EditTaskDrawerProjectTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditTaskDrawerProjectTeamQuery, EditTaskDrawerProjectTeamQueryVariables>(EditTaskDrawerProjectTeamDocument, options);
      }
export function useEditTaskDrawerProjectTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditTaskDrawerProjectTeamQuery, EditTaskDrawerProjectTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditTaskDrawerProjectTeamQuery, EditTaskDrawerProjectTeamQueryVariables>(EditTaskDrawerProjectTeamDocument, options);
        }
export type EditTaskDrawerProjectTeamQueryHookResult = ReturnType<typeof useEditTaskDrawerProjectTeamQuery>;
export type EditTaskDrawerProjectTeamLazyQueryHookResult = ReturnType<typeof useEditTaskDrawerProjectTeamLazyQuery>;
export type EditTaskDrawerProjectTeamQueryResult = Apollo.QueryResult<EditTaskDrawerProjectTeamQuery, EditTaskDrawerProjectTeamQueryVariables>;
export const EditTaskDrawerCurrentUserSkillsDocument = gql`
    query EditTaskDrawer_CurrentUserSkills {
  currentUser {
    skills {
      id
    }
  }
}
    `;

/**
 * __useEditTaskDrawerCurrentUserSkillsQuery__
 *
 * To run a query within a React component, call `useEditTaskDrawerCurrentUserSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditTaskDrawerCurrentUserSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditTaskDrawerCurrentUserSkillsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEditTaskDrawerCurrentUserSkillsQuery(baseOptions?: Apollo.QueryHookOptions<EditTaskDrawerCurrentUserSkillsQuery, EditTaskDrawerCurrentUserSkillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditTaskDrawerCurrentUserSkillsQuery, EditTaskDrawerCurrentUserSkillsQueryVariables>(EditTaskDrawerCurrentUserSkillsDocument, options);
      }
export function useEditTaskDrawerCurrentUserSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditTaskDrawerCurrentUserSkillsQuery, EditTaskDrawerCurrentUserSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditTaskDrawerCurrentUserSkillsQuery, EditTaskDrawerCurrentUserSkillsQueryVariables>(EditTaskDrawerCurrentUserSkillsDocument, options);
        }
export type EditTaskDrawerCurrentUserSkillsQueryHookResult = ReturnType<typeof useEditTaskDrawerCurrentUserSkillsQuery>;
export type EditTaskDrawerCurrentUserSkillsLazyQueryHookResult = ReturnType<typeof useEditTaskDrawerCurrentUserSkillsLazyQuery>;
export type EditTaskDrawerCurrentUserSkillsQueryResult = Apollo.QueryResult<EditTaskDrawerCurrentUserSkillsQuery, EditTaskDrawerCurrentUserSkillsQueryVariables>;
export const EditTaskDrawerRemoveWatcherDocument = gql`
    mutation EditTaskDrawer_RemoveWatcher($taskId: ID!, $watcherId: ID!) {
  removeWatcher(input: {taskId: $taskId, watcherId: $watcherId}) {
    success
  }
}
    `;
export type EditTaskDrawerRemoveWatcherMutationFn = Apollo.MutationFunction<EditTaskDrawerRemoveWatcherMutation, EditTaskDrawerRemoveWatcherMutationVariables>;

/**
 * __useEditTaskDrawerRemoveWatcherMutation__
 *
 * To run a mutation, you first call `useEditTaskDrawerRemoveWatcherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTaskDrawerRemoveWatcherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTaskDrawerRemoveWatcherMutation, { data, loading, error }] = useEditTaskDrawerRemoveWatcherMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      watcherId: // value for 'watcherId'
 *   },
 * });
 */
export function useEditTaskDrawerRemoveWatcherMutation(baseOptions?: Apollo.MutationHookOptions<EditTaskDrawerRemoveWatcherMutation, EditTaskDrawerRemoveWatcherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditTaskDrawerRemoveWatcherMutation, EditTaskDrawerRemoveWatcherMutationVariables>(EditTaskDrawerRemoveWatcherDocument, options);
      }
export type EditTaskDrawerRemoveWatcherMutationHookResult = ReturnType<typeof useEditTaskDrawerRemoveWatcherMutation>;
export type EditTaskDrawerRemoveWatcherMutationResult = Apollo.MutationResult<EditTaskDrawerRemoveWatcherMutation>;
export type EditTaskDrawerRemoveWatcherMutationOptions = Apollo.BaseMutationOptions<EditTaskDrawerRemoveWatcherMutation, EditTaskDrawerRemoveWatcherMutationVariables>;
export const FilterTasksFormPaginatedUserTaskAssigneesDocument = gql`
    query FilterTasksForm_PaginatedUserTaskAssignees($listInput: ListInput, $ids: [ID!]) {
  paginatedUserTaskAssignees(listInputs: $listInput, ids: $ids) {
    users {
      id
      ...PaginatedAssigneeMultiSelect_User
    }
    pageInfo {
      ...PageInfoFragment
      __typename
    }
  }
}
    ${PaginatedAssigneeMultiSelectUserFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useFilterTasksFormPaginatedUserTaskAssigneesQuery__
 *
 * To run a query within a React component, call `useFilterTasksFormPaginatedUserTaskAssigneesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterTasksFormPaginatedUserTaskAssigneesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterTasksFormPaginatedUserTaskAssigneesQuery({
 *   variables: {
 *      listInput: // value for 'listInput'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useFilterTasksFormPaginatedUserTaskAssigneesQuery(baseOptions?: Apollo.QueryHookOptions<FilterTasksFormPaginatedUserTaskAssigneesQuery, FilterTasksFormPaginatedUserTaskAssigneesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilterTasksFormPaginatedUserTaskAssigneesQuery, FilterTasksFormPaginatedUserTaskAssigneesQueryVariables>(FilterTasksFormPaginatedUserTaskAssigneesDocument, options);
      }
export function useFilterTasksFormPaginatedUserTaskAssigneesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterTasksFormPaginatedUserTaskAssigneesQuery, FilterTasksFormPaginatedUserTaskAssigneesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilterTasksFormPaginatedUserTaskAssigneesQuery, FilterTasksFormPaginatedUserTaskAssigneesQueryVariables>(FilterTasksFormPaginatedUserTaskAssigneesDocument, options);
        }
export type FilterTasksFormPaginatedUserTaskAssigneesQueryHookResult = ReturnType<typeof useFilterTasksFormPaginatedUserTaskAssigneesQuery>;
export type FilterTasksFormPaginatedUserTaskAssigneesLazyQueryHookResult = ReturnType<typeof useFilterTasksFormPaginatedUserTaskAssigneesLazyQuery>;
export type FilterTasksFormPaginatedUserTaskAssigneesQueryResult = Apollo.QueryResult<FilterTasksFormPaginatedUserTaskAssigneesQuery, FilterTasksFormPaginatedUserTaskAssigneesQueryVariables>;
export const TaskIndexExportGlobalTasksListDocument = gql`
    mutation TaskIndex_ExportGlobalTasksList($taskFilters: TaskFilters) {
  exportGlobalTasksList(input: {taskFilters: $taskFilters}) {
    success
  }
}
    `;
export type TaskIndexExportGlobalTasksListMutationFn = Apollo.MutationFunction<TaskIndexExportGlobalTasksListMutation, TaskIndexExportGlobalTasksListMutationVariables>;

/**
 * __useTaskIndexExportGlobalTasksListMutation__
 *
 * To run a mutation, you first call `useTaskIndexExportGlobalTasksListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskIndexExportGlobalTasksListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskIndexExportGlobalTasksListMutation, { data, loading, error }] = useTaskIndexExportGlobalTasksListMutation({
 *   variables: {
 *      taskFilters: // value for 'taskFilters'
 *   },
 * });
 */
export function useTaskIndexExportGlobalTasksListMutation(baseOptions?: Apollo.MutationHookOptions<TaskIndexExportGlobalTasksListMutation, TaskIndexExportGlobalTasksListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskIndexExportGlobalTasksListMutation, TaskIndexExportGlobalTasksListMutationVariables>(TaskIndexExportGlobalTasksListDocument, options);
      }
export type TaskIndexExportGlobalTasksListMutationHookResult = ReturnType<typeof useTaskIndexExportGlobalTasksListMutation>;
export type TaskIndexExportGlobalTasksListMutationResult = Apollo.MutationResult<TaskIndexExportGlobalTasksListMutation>;
export type TaskIndexExportGlobalTasksListMutationOptions = Apollo.BaseMutationOptions<TaskIndexExportGlobalTasksListMutation, TaskIndexExportGlobalTasksListMutationVariables>;
export const TaskListTableTaskListDocument = gql`
    query TaskListTable_TaskList($listInputs: ListInput, $taskFilters: TaskFilters) {
  userTasksConnections(listInputs: $listInputs, taskFilters: $taskFilters) {
    pageInfo {
      totalPages
      totalResults
      currentPage
      limit
      isOutOfBounds
    }
    tasks {
      id
      ...TaskIndexTableRow_Task
    }
  }
}
    ${TaskIndexTableRowTaskFragmentDoc}`;

/**
 * __useTaskListTableTaskListQuery__
 *
 * To run a query within a React component, call `useTaskListTableTaskListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskListTableTaskListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskListTableTaskListQuery({
 *   variables: {
 *      listInputs: // value for 'listInputs'
 *      taskFilters: // value for 'taskFilters'
 *   },
 * });
 */
export function useTaskListTableTaskListQuery(baseOptions?: Apollo.QueryHookOptions<TaskListTableTaskListQuery, TaskListTableTaskListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskListTableTaskListQuery, TaskListTableTaskListQueryVariables>(TaskListTableTaskListDocument, options);
      }
export function useTaskListTableTaskListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskListTableTaskListQuery, TaskListTableTaskListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskListTableTaskListQuery, TaskListTableTaskListQueryVariables>(TaskListTableTaskListDocument, options);
        }
export type TaskListTableTaskListQueryHookResult = ReturnType<typeof useTaskListTableTaskListQuery>;
export type TaskListTableTaskListLazyQueryHookResult = ReturnType<typeof useTaskListTableTaskListLazyQuery>;
export type TaskListTableTaskListQueryResult = Apollo.QueryResult<TaskListTableTaskListQuery, TaskListTableTaskListQueryVariables>;
export const ProjectDeleteTaskDialogDeleteTaskDocument = gql`
    mutation ProjectDeleteTaskDialog_DeleteTask($deleteTaskInput: deleteTaskInput!) {
  deleteTask(input: $deleteTaskInput) {
    taskReturnData {
      milestone {
        id
      }
      project {
        id
        ...DeleteTaskDialog_ProjectSnapshotFragment
        stats {
          ...DeleteTaskDialog_ProjectStatsFragment
        }
        profitabilitySummary {
          forecastedCost
          budgetedCost
        }
      }
    }
  }
}
    ${DeleteTaskDialogProjectSnapshotFragmentDoc}
${DeleteTaskDialogProjectStatsFragmentDoc}`;
export type ProjectDeleteTaskDialogDeleteTaskMutationFn = Apollo.MutationFunction<ProjectDeleteTaskDialogDeleteTaskMutation, ProjectDeleteTaskDialogDeleteTaskMutationVariables>;

/**
 * __useProjectDeleteTaskDialogDeleteTaskMutation__
 *
 * To run a mutation, you first call `useProjectDeleteTaskDialogDeleteTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectDeleteTaskDialogDeleteTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectDeleteTaskDialogDeleteTaskMutation, { data, loading, error }] = useProjectDeleteTaskDialogDeleteTaskMutation({
 *   variables: {
 *      deleteTaskInput: // value for 'deleteTaskInput'
 *   },
 * });
 */
export function useProjectDeleteTaskDialogDeleteTaskMutation(baseOptions?: Apollo.MutationHookOptions<ProjectDeleteTaskDialogDeleteTaskMutation, ProjectDeleteTaskDialogDeleteTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectDeleteTaskDialogDeleteTaskMutation, ProjectDeleteTaskDialogDeleteTaskMutationVariables>(ProjectDeleteTaskDialogDeleteTaskDocument, options);
      }
export type ProjectDeleteTaskDialogDeleteTaskMutationHookResult = ReturnType<typeof useProjectDeleteTaskDialogDeleteTaskMutation>;
export type ProjectDeleteTaskDialogDeleteTaskMutationResult = Apollo.MutationResult<ProjectDeleteTaskDialogDeleteTaskMutation>;
export type ProjectDeleteTaskDialogDeleteTaskMutationOptions = Apollo.BaseMutationOptions<ProjectDeleteTaskDialogDeleteTaskMutation, ProjectDeleteTaskDialogDeleteTaskMutationVariables>;
export const TemplateDialogContextDeleteTaskDocument = gql`
    mutation TemplateDialogContext_DeleteTask($deleteTaskInput: deleteTaskInput!) {
  deleteTask(input: $deleteTaskInput) {
    taskReturnData {
      milestone {
        summaryBank {
          id
          totalTasks
          totalCompleteTasks
          totalRemainingTasks
          duration
        }
        id
      }
    }
  }
}
    `;
export type TemplateDialogContextDeleteTaskMutationFn = Apollo.MutationFunction<TemplateDialogContextDeleteTaskMutation, TemplateDialogContextDeleteTaskMutationVariables>;

/**
 * __useTemplateDialogContextDeleteTaskMutation__
 *
 * To run a mutation, you first call `useTemplateDialogContextDeleteTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTemplateDialogContextDeleteTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [templateDialogContextDeleteTaskMutation, { data, loading, error }] = useTemplateDialogContextDeleteTaskMutation({
 *   variables: {
 *      deleteTaskInput: // value for 'deleteTaskInput'
 *   },
 * });
 */
export function useTemplateDialogContextDeleteTaskMutation(baseOptions?: Apollo.MutationHookOptions<TemplateDialogContextDeleteTaskMutation, TemplateDialogContextDeleteTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TemplateDialogContextDeleteTaskMutation, TemplateDialogContextDeleteTaskMutationVariables>(TemplateDialogContextDeleteTaskDocument, options);
      }
export type TemplateDialogContextDeleteTaskMutationHookResult = ReturnType<typeof useTemplateDialogContextDeleteTaskMutation>;
export type TemplateDialogContextDeleteTaskMutationResult = Apollo.MutationResult<TemplateDialogContextDeleteTaskMutation>;
export type TemplateDialogContextDeleteTaskMutationOptions = Apollo.BaseMutationOptions<TemplateDialogContextDeleteTaskMutation, TemplateDialogContextDeleteTaskMutationVariables>;
export const SendActionParticipantsDialogEventInviteDocument = gql`
    mutation SendActionParticipantsDialog_EventInvite($taskId: ID!, $resendInvitation: Boolean) {
  sendEventInvite(input: {taskId: $taskId, resendInvitation: $resendInvitation}) {
    task {
      id
      invitationGroupSentAt
      taskParticipants {
        id
        invitationSentAt
      }
    }
  }
}
    `;
export type SendActionParticipantsDialogEventInviteMutationFn = Apollo.MutationFunction<SendActionParticipantsDialogEventInviteMutation, SendActionParticipantsDialogEventInviteMutationVariables>;

/**
 * __useSendActionParticipantsDialogEventInviteMutation__
 *
 * To run a mutation, you first call `useSendActionParticipantsDialogEventInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendActionParticipantsDialogEventInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendActionParticipantsDialogEventInviteMutation, { data, loading, error }] = useSendActionParticipantsDialogEventInviteMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      resendInvitation: // value for 'resendInvitation'
 *   },
 * });
 */
export function useSendActionParticipantsDialogEventInviteMutation(baseOptions?: Apollo.MutationHookOptions<SendActionParticipantsDialogEventInviteMutation, SendActionParticipantsDialogEventInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendActionParticipantsDialogEventInviteMutation, SendActionParticipantsDialogEventInviteMutationVariables>(SendActionParticipantsDialogEventInviteDocument, options);
      }
export type SendActionParticipantsDialogEventInviteMutationHookResult = ReturnType<typeof useSendActionParticipantsDialogEventInviteMutation>;
export type SendActionParticipantsDialogEventInviteMutationResult = Apollo.MutationResult<SendActionParticipantsDialogEventInviteMutation>;
export type SendActionParticipantsDialogEventInviteMutationOptions = Apollo.BaseMutationOptions<SendActionParticipantsDialogEventInviteMutation, SendActionParticipantsDialogEventInviteMutationVariables>;
export const SendSignOffDialogSendSignOffDocument = gql`
    mutation SendSignOffDialog_SendSignOff($taskId: ID!, $message: String!) {
  sendSignOff(input: {taskId: $taskId, message: $message}) {
    sendSignOffReturnData {
      ...ChangeStatus_TaskReturn
    }
  }
}
    ${ChangeStatusTaskReturnFragmentDoc}`;
export type SendSignOffDialogSendSignOffMutationFn = Apollo.MutationFunction<SendSignOffDialogSendSignOffMutation, SendSignOffDialogSendSignOffMutationVariables>;

/**
 * __useSendSignOffDialogSendSignOffMutation__
 *
 * To run a mutation, you first call `useSendSignOffDialogSendSignOffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSignOffDialogSendSignOffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSignOffDialogSendSignOffMutation, { data, loading, error }] = useSendSignOffDialogSendSignOffMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSendSignOffDialogSendSignOffMutation(baseOptions?: Apollo.MutationHookOptions<SendSignOffDialogSendSignOffMutation, SendSignOffDialogSendSignOffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendSignOffDialogSendSignOffMutation, SendSignOffDialogSendSignOffMutationVariables>(SendSignOffDialogSendSignOffDocument, options);
      }
export type SendSignOffDialogSendSignOffMutationHookResult = ReturnType<typeof useSendSignOffDialogSendSignOffMutation>;
export type SendSignOffDialogSendSignOffMutationResult = Apollo.MutationResult<SendSignOffDialogSendSignOffMutation>;
export type SendSignOffDialogSendSignOffMutationOptions = Apollo.BaseMutationOptions<SendSignOffDialogSendSignOffMutation, SendSignOffDialogSendSignOffMutationVariables>;
export const ConfirmDeleteTemplateDialogDeleteTemplateMutationDocument = gql`
    mutation ConfirmDeleteTemplateDialog_DeleteTemplateMutation($id: ID!, $templateType: TemplateEnumType!) {
  deleteTemplate(input: {id: $id, templateType: $templateType}) {
    success
  }
}
    `;
export type ConfirmDeleteTemplateDialogDeleteTemplateMutationMutationFn = Apollo.MutationFunction<ConfirmDeleteTemplateDialogDeleteTemplateMutation, ConfirmDeleteTemplateDialogDeleteTemplateMutationVariables>;

/**
 * __useConfirmDeleteTemplateDialogDeleteTemplateMutation__
 *
 * To run a mutation, you first call `useConfirmDeleteTemplateDialogDeleteTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmDeleteTemplateDialogDeleteTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmDeleteTemplateDialogDeleteTemplateMutation, { data, loading, error }] = useConfirmDeleteTemplateDialogDeleteTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      templateType: // value for 'templateType'
 *   },
 * });
 */
export function useConfirmDeleteTemplateDialogDeleteTemplateMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmDeleteTemplateDialogDeleteTemplateMutation, ConfirmDeleteTemplateDialogDeleteTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmDeleteTemplateDialogDeleteTemplateMutation, ConfirmDeleteTemplateDialogDeleteTemplateMutationVariables>(ConfirmDeleteTemplateDialogDeleteTemplateMutationDocument, options);
      }
export type ConfirmDeleteTemplateDialogDeleteTemplateMutationHookResult = ReturnType<typeof useConfirmDeleteTemplateDialogDeleteTemplateMutation>;
export type ConfirmDeleteTemplateDialogDeleteTemplateMutationMutationResult = Apollo.MutationResult<ConfirmDeleteTemplateDialogDeleteTemplateMutation>;
export type ConfirmDeleteTemplateDialogDeleteTemplateMutationMutationOptions = Apollo.BaseMutationOptions<ConfirmDeleteTemplateDialogDeleteTemplateMutation, ConfirmDeleteTemplateDialogDeleteTemplateMutationVariables>;
export const ConfirmDuplicateTemplateDialogDuplicateTemplateMutationDocument = gql`
    mutation ConfirmDuplicateTemplateDialog_DuplicateTemplateMutation($id: ID!, $duplicateName: String!, $templateType: TemplateEnumType!) {
  duplicateTemplate(
    input: {id: $id, duplicateName: $duplicateName, templateType: $templateType}
  ) {
    success
  }
}
    `;
export type ConfirmDuplicateTemplateDialogDuplicateTemplateMutationMutationFn = Apollo.MutationFunction<ConfirmDuplicateTemplateDialogDuplicateTemplateMutation, ConfirmDuplicateTemplateDialogDuplicateTemplateMutationVariables>;

/**
 * __useConfirmDuplicateTemplateDialogDuplicateTemplateMutation__
 *
 * To run a mutation, you first call `useConfirmDuplicateTemplateDialogDuplicateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmDuplicateTemplateDialogDuplicateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmDuplicateTemplateDialogDuplicateTemplateMutation, { data, loading, error }] = useConfirmDuplicateTemplateDialogDuplicateTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      duplicateName: // value for 'duplicateName'
 *      templateType: // value for 'templateType'
 *   },
 * });
 */
export function useConfirmDuplicateTemplateDialogDuplicateTemplateMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmDuplicateTemplateDialogDuplicateTemplateMutation, ConfirmDuplicateTemplateDialogDuplicateTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmDuplicateTemplateDialogDuplicateTemplateMutation, ConfirmDuplicateTemplateDialogDuplicateTemplateMutationVariables>(ConfirmDuplicateTemplateDialogDuplicateTemplateMutationDocument, options);
      }
export type ConfirmDuplicateTemplateDialogDuplicateTemplateMutationHookResult = ReturnType<typeof useConfirmDuplicateTemplateDialogDuplicateTemplateMutation>;
export type ConfirmDuplicateTemplateDialogDuplicateTemplateMutationMutationResult = Apollo.MutationResult<ConfirmDuplicateTemplateDialogDuplicateTemplateMutation>;
export type ConfirmDuplicateTemplateDialogDuplicateTemplateMutationMutationOptions = Apollo.BaseMutationOptions<ConfirmDuplicateTemplateDialogDuplicateTemplateMutation, ConfirmDuplicateTemplateDialogDuplicateTemplateMutationVariables>;
export const EditTemplateFormUpdateTemplateV2Document = gql`
    mutation EditTemplateForm_UpdateTemplateV2($template: updateTemplateInput!) {
  updateTemplate(input: $template) {
    template {
      id
      ...EditTemplateForm_EditTemplateV2
    }
  }
}
    ${EditTemplateFormEditTemplateV2FragmentDoc}`;
export type EditTemplateFormUpdateTemplateV2MutationFn = Apollo.MutationFunction<EditTemplateFormUpdateTemplateV2Mutation, EditTemplateFormUpdateTemplateV2MutationVariables>;

/**
 * __useEditTemplateFormUpdateTemplateV2Mutation__
 *
 * To run a mutation, you first call `useEditTemplateFormUpdateTemplateV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTemplateFormUpdateTemplateV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTemplateFormUpdateTemplateV2Mutation, { data, loading, error }] = useEditTemplateFormUpdateTemplateV2Mutation({
 *   variables: {
 *      template: // value for 'template'
 *   },
 * });
 */
export function useEditTemplateFormUpdateTemplateV2Mutation(baseOptions?: Apollo.MutationHookOptions<EditTemplateFormUpdateTemplateV2Mutation, EditTemplateFormUpdateTemplateV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditTemplateFormUpdateTemplateV2Mutation, EditTemplateFormUpdateTemplateV2MutationVariables>(EditTemplateFormUpdateTemplateV2Document, options);
      }
export type EditTemplateFormUpdateTemplateV2MutationHookResult = ReturnType<typeof useEditTemplateFormUpdateTemplateV2Mutation>;
export type EditTemplateFormUpdateTemplateV2MutationResult = Apollo.MutationResult<EditTemplateFormUpdateTemplateV2Mutation>;
export type EditTemplateFormUpdateTemplateV2MutationOptions = Apollo.BaseMutationOptions<EditTemplateFormUpdateTemplateV2Mutation, EditTemplateFormUpdateTemplateV2MutationVariables>;
export const TemplateIndexTemplateListDocument = gql`
    query TemplateIndex_TemplateList($listInputs: ListInput) {
  templateConnections(listInputs: $listInputs) {
    pageInfo {
      ...PageInfoFragment
    }
    templates {
      id
      ...TemplateIndexTemplate
    }
  }
}
    ${PageInfoFragmentDoc}
${TemplateIndexTemplateFragmentDoc}`;

/**
 * __useTemplateIndexTemplateListQuery__
 *
 * To run a query within a React component, call `useTemplateIndexTemplateListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateIndexTemplateListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateIndexTemplateListQuery({
 *   variables: {
 *      listInputs: // value for 'listInputs'
 *   },
 * });
 */
export function useTemplateIndexTemplateListQuery(baseOptions?: Apollo.QueryHookOptions<TemplateIndexTemplateListQuery, TemplateIndexTemplateListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplateIndexTemplateListQuery, TemplateIndexTemplateListQueryVariables>(TemplateIndexTemplateListDocument, options);
      }
export function useTemplateIndexTemplateListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplateIndexTemplateListQuery, TemplateIndexTemplateListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplateIndexTemplateListQuery, TemplateIndexTemplateListQueryVariables>(TemplateIndexTemplateListDocument, options);
        }
export type TemplateIndexTemplateListQueryHookResult = ReturnType<typeof useTemplateIndexTemplateListQuery>;
export type TemplateIndexTemplateListLazyQueryHookResult = ReturnType<typeof useTemplateIndexTemplateListLazyQuery>;
export type TemplateIndexTemplateListQueryResult = Apollo.QueryResult<TemplateIndexTemplateListQuery, TemplateIndexTemplateListQueryVariables>;
export const TemplateIndexCreateTemplateDocument = gql`
    mutation TemplateIndex_CreateTemplate($template: createTemplateInput!) {
  createTemplate(input: $template) {
    template {
      id
      ...TemplateIndexTemplate
    }
  }
}
    ${TemplateIndexTemplateFragmentDoc}`;
export type TemplateIndexCreateTemplateMutationFn = Apollo.MutationFunction<TemplateIndexCreateTemplateMutation, TemplateIndexCreateTemplateMutationVariables>;

/**
 * __useTemplateIndexCreateTemplateMutation__
 *
 * To run a mutation, you first call `useTemplateIndexCreateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTemplateIndexCreateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [templateIndexCreateTemplateMutation, { data, loading, error }] = useTemplateIndexCreateTemplateMutation({
 *   variables: {
 *      template: // value for 'template'
 *   },
 * });
 */
export function useTemplateIndexCreateTemplateMutation(baseOptions?: Apollo.MutationHookOptions<TemplateIndexCreateTemplateMutation, TemplateIndexCreateTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TemplateIndexCreateTemplateMutation, TemplateIndexCreateTemplateMutationVariables>(TemplateIndexCreateTemplateDocument, options);
      }
export type TemplateIndexCreateTemplateMutationHookResult = ReturnType<typeof useTemplateIndexCreateTemplateMutation>;
export type TemplateIndexCreateTemplateMutationResult = Apollo.MutationResult<TemplateIndexCreateTemplateMutation>;
export type TemplateIndexCreateTemplateMutationOptions = Apollo.BaseMutationOptions<TemplateIndexCreateTemplateMutation, TemplateIndexCreateTemplateMutationVariables>;
export const TemplateFilesFilesDocument = gql`
    query TemplateFiles_Files($templateId: ID!, $listInputs: ListInput) {
  templatesById(ids: [$templateId]) {
    id
    name
  }
  files(objId: $templateId, objType: BLUEPRINT_TEMPLATE, listInputs: $listInputs) {
    pageInfo {
      ...PageInfoFragment
    }
    assets {
      deletable
      id
      ...TemplateFiles_File
    }
  }
}
    ${PageInfoFragmentDoc}
${TemplateFilesFileFragmentDoc}`;

/**
 * __useTemplateFilesFilesQuery__
 *
 * To run a query within a React component, call `useTemplateFilesFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateFilesFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateFilesFilesQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      listInputs: // value for 'listInputs'
 *   },
 * });
 */
export function useTemplateFilesFilesQuery(baseOptions: Apollo.QueryHookOptions<TemplateFilesFilesQuery, TemplateFilesFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplateFilesFilesQuery, TemplateFilesFilesQueryVariables>(TemplateFilesFilesDocument, options);
      }
export function useTemplateFilesFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplateFilesFilesQuery, TemplateFilesFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplateFilesFilesQuery, TemplateFilesFilesQueryVariables>(TemplateFilesFilesDocument, options);
        }
export type TemplateFilesFilesQueryHookResult = ReturnType<typeof useTemplateFilesFilesQuery>;
export type TemplateFilesFilesLazyQueryHookResult = ReturnType<typeof useTemplateFilesFilesLazyQuery>;
export type TemplateFilesFilesQueryResult = Apollo.QueryResult<TemplateFilesFilesQuery, TemplateFilesFilesQueryVariables>;
export const TemplateFilesDeleteFileDocument = gql`
    mutation TemplateFiles_DeleteFile($deleteFileInput: DeleteFileInput!) {
  deleteFile(input: $deleteFileInput) {
    success
  }
}
    `;
export type TemplateFilesDeleteFileMutationFn = Apollo.MutationFunction<TemplateFilesDeleteFileMutation, TemplateFilesDeleteFileMutationVariables>;

/**
 * __useTemplateFilesDeleteFileMutation__
 *
 * To run a mutation, you first call `useTemplateFilesDeleteFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTemplateFilesDeleteFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [templateFilesDeleteFileMutation, { data, loading, error }] = useTemplateFilesDeleteFileMutation({
 *   variables: {
 *      deleteFileInput: // value for 'deleteFileInput'
 *   },
 * });
 */
export function useTemplateFilesDeleteFileMutation(baseOptions?: Apollo.MutationHookOptions<TemplateFilesDeleteFileMutation, TemplateFilesDeleteFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TemplateFilesDeleteFileMutation, TemplateFilesDeleteFileMutationVariables>(TemplateFilesDeleteFileDocument, options);
      }
export type TemplateFilesDeleteFileMutationHookResult = ReturnType<typeof useTemplateFilesDeleteFileMutation>;
export type TemplateFilesDeleteFileMutationResult = Apollo.MutationResult<TemplateFilesDeleteFileMutation>;
export type TemplateFilesDeleteFileMutationOptions = Apollo.BaseMutationOptions<TemplateFilesDeleteFileMutation, TemplateFilesDeleteFileMutationVariables>;
export const TemplateFilesUpdateTemplateDocument = gql`
    mutation TemplateFiles_UpdateTemplate($input: updateTemplateInput!) {
  updateTemplate(input: $input) {
    template {
      id
      files {
        id
        ...TemplateFiles_File
      }
    }
  }
}
    ${TemplateFilesFileFragmentDoc}`;
export type TemplateFilesUpdateTemplateMutationFn = Apollo.MutationFunction<TemplateFilesUpdateTemplateMutation, TemplateFilesUpdateTemplateMutationVariables>;

/**
 * __useTemplateFilesUpdateTemplateMutation__
 *
 * To run a mutation, you first call `useTemplateFilesUpdateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTemplateFilesUpdateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [templateFilesUpdateTemplateMutation, { data, loading, error }] = useTemplateFilesUpdateTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTemplateFilesUpdateTemplateMutation(baseOptions?: Apollo.MutationHookOptions<TemplateFilesUpdateTemplateMutation, TemplateFilesUpdateTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TemplateFilesUpdateTemplateMutation, TemplateFilesUpdateTemplateMutationVariables>(TemplateFilesUpdateTemplateDocument, options);
      }
export type TemplateFilesUpdateTemplateMutationHookResult = ReturnType<typeof useTemplateFilesUpdateTemplateMutation>;
export type TemplateFilesUpdateTemplateMutationResult = Apollo.MutationResult<TemplateFilesUpdateTemplateMutation>;
export type TemplateFilesUpdateTemplateMutationOptions = Apollo.BaseMutationOptions<TemplateFilesUpdateTemplateMutation, TemplateFilesUpdateTemplateMutationVariables>;
export const AddEditTimeEntriesTaskTimeRecordsDocument = gql`
    query AddEditTimeEntries_TaskTimeRecords($taskId: ID!, $listInputs: ListInput) {
  task(id: $taskId) {
    id
    name
    estimatedHours
    totalHours
  }
  taskTimeRecords(taskId: $taskId, listInputs: $listInputs) {
    pageInfo {
      ...AddEditTimeEntryTimeRecordPageFragment
    }
    timeRecords {
      ...AddEditTimeEntryTimeRecordFragment
    }
  }
}
    ${AddEditTimeEntryTimeRecordPageFragmentDoc}
${AddEditTimeEntryTimeRecordFragmentDoc}`;

/**
 * __useAddEditTimeEntriesTaskTimeRecordsQuery__
 *
 * To run a query within a React component, call `useAddEditTimeEntriesTaskTimeRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddEditTimeEntriesTaskTimeRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddEditTimeEntriesTaskTimeRecordsQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      listInputs: // value for 'listInputs'
 *   },
 * });
 */
export function useAddEditTimeEntriesTaskTimeRecordsQuery(baseOptions: Apollo.QueryHookOptions<AddEditTimeEntriesTaskTimeRecordsQuery, AddEditTimeEntriesTaskTimeRecordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddEditTimeEntriesTaskTimeRecordsQuery, AddEditTimeEntriesTaskTimeRecordsQueryVariables>(AddEditTimeEntriesTaskTimeRecordsDocument, options);
      }
export function useAddEditTimeEntriesTaskTimeRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddEditTimeEntriesTaskTimeRecordsQuery, AddEditTimeEntriesTaskTimeRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddEditTimeEntriesTaskTimeRecordsQuery, AddEditTimeEntriesTaskTimeRecordsQueryVariables>(AddEditTimeEntriesTaskTimeRecordsDocument, options);
        }
export type AddEditTimeEntriesTaskTimeRecordsQueryHookResult = ReturnType<typeof useAddEditTimeEntriesTaskTimeRecordsQuery>;
export type AddEditTimeEntriesTaskTimeRecordsLazyQueryHookResult = ReturnType<typeof useAddEditTimeEntriesTaskTimeRecordsLazyQuery>;
export type AddEditTimeEntriesTaskTimeRecordsQueryResult = Apollo.QueryResult<AddEditTimeEntriesTaskTimeRecordsQuery, AddEditTimeEntriesTaskTimeRecordsQueryVariables>;
export const AddEditTimeEntriesGenericTimeRecordsDocument = gql`
    query AddEditTimeEntries_GenericTimeRecords($projectId: ID!, $listInputs: ListInput, $workerId: ID!, $startDate: DateType!, $endDate: DateType!) {
  project(id: $projectId) {
    id
    name
    timeReport(
      startDate: $startDate
      endDate: $endDate
      userId: $workerId
      includeGeneric: true
      filters: {}
    ) {
      allTimeUserProjectTotalHours
    }
  }
  genericTimeRecords(
    projectId: $projectId
    listInputs: $listInputs
    workerId: $workerId
  ) {
    pageInfo {
      ...AddEditTimeEntryTimeRecordPageFragment
    }
    timeRecords {
      ...AddEditTimeEntryTimeRecordFragment
    }
  }
}
    ${AddEditTimeEntryTimeRecordPageFragmentDoc}
${AddEditTimeEntryTimeRecordFragmentDoc}`;

/**
 * __useAddEditTimeEntriesGenericTimeRecordsQuery__
 *
 * To run a query within a React component, call `useAddEditTimeEntriesGenericTimeRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddEditTimeEntriesGenericTimeRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddEditTimeEntriesGenericTimeRecordsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      listInputs: // value for 'listInputs'
 *      workerId: // value for 'workerId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useAddEditTimeEntriesGenericTimeRecordsQuery(baseOptions: Apollo.QueryHookOptions<AddEditTimeEntriesGenericTimeRecordsQuery, AddEditTimeEntriesGenericTimeRecordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddEditTimeEntriesGenericTimeRecordsQuery, AddEditTimeEntriesGenericTimeRecordsQueryVariables>(AddEditTimeEntriesGenericTimeRecordsDocument, options);
      }
export function useAddEditTimeEntriesGenericTimeRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddEditTimeEntriesGenericTimeRecordsQuery, AddEditTimeEntriesGenericTimeRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddEditTimeEntriesGenericTimeRecordsQuery, AddEditTimeEntriesGenericTimeRecordsQueryVariables>(AddEditTimeEntriesGenericTimeRecordsDocument, options);
        }
export type AddEditTimeEntriesGenericTimeRecordsQueryHookResult = ReturnType<typeof useAddEditTimeEntriesGenericTimeRecordsQuery>;
export type AddEditTimeEntriesGenericTimeRecordsLazyQueryHookResult = ReturnType<typeof useAddEditTimeEntriesGenericTimeRecordsLazyQuery>;
export type AddEditTimeEntriesGenericTimeRecordsQueryResult = Apollo.QueryResult<AddEditTimeEntriesGenericTimeRecordsQuery, AddEditTimeEntriesGenericTimeRecordsQueryVariables>;
export const CategoryInfinitySelectorOrganizationDocument = gql`
    query CategoryInfinitySelector_Organization($organizationId: ID!, $listInputs: ListInput!) {
  organization(id: $organizationId) {
    id
    ...CategoryInfinitySelector_OrganizationType
  }
}
    ${CategoryInfinitySelectorOrganizationTypeFragmentDoc}`;

/**
 * __useCategoryInfinitySelectorOrganizationQuery__
 *
 * To run a query within a React component, call `useCategoryInfinitySelectorOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryInfinitySelectorOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryInfinitySelectorOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      listInputs: // value for 'listInputs'
 *   },
 * });
 */
export function useCategoryInfinitySelectorOrganizationQuery(baseOptions: Apollo.QueryHookOptions<CategoryInfinitySelectorOrganizationQuery, CategoryInfinitySelectorOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoryInfinitySelectorOrganizationQuery, CategoryInfinitySelectorOrganizationQueryVariables>(CategoryInfinitySelectorOrganizationDocument, options);
      }
export function useCategoryInfinitySelectorOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoryInfinitySelectorOrganizationQuery, CategoryInfinitySelectorOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoryInfinitySelectorOrganizationQuery, CategoryInfinitySelectorOrganizationQueryVariables>(CategoryInfinitySelectorOrganizationDocument, options);
        }
export type CategoryInfinitySelectorOrganizationQueryHookResult = ReturnType<typeof useCategoryInfinitySelectorOrganizationQuery>;
export type CategoryInfinitySelectorOrganizationLazyQueryHookResult = ReturnType<typeof useCategoryInfinitySelectorOrganizationLazyQuery>;
export type CategoryInfinitySelectorOrganizationQueryResult = Apollo.QueryResult<CategoryInfinitySelectorOrganizationQuery, CategoryInfinitySelectorOrganizationQueryVariables>;
export const ExportButtonTimeReportExportDocument = gql`
    mutation ExportButton_TimeReportExport($input: timeReportExportInput!) {
  timeReportExport(input: $input) {
    success
  }
}
    `;
export type ExportButtonTimeReportExportMutationFn = Apollo.MutationFunction<ExportButtonTimeReportExportMutation, ExportButtonTimeReportExportMutationVariables>;

/**
 * __useExportButtonTimeReportExportMutation__
 *
 * To run a mutation, you first call `useExportButtonTimeReportExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportButtonTimeReportExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportButtonTimeReportExportMutation, { data, loading, error }] = useExportButtonTimeReportExportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportButtonTimeReportExportMutation(baseOptions?: Apollo.MutationHookOptions<ExportButtonTimeReportExportMutation, ExportButtonTimeReportExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportButtonTimeReportExportMutation, ExportButtonTimeReportExportMutationVariables>(ExportButtonTimeReportExportDocument, options);
      }
export type ExportButtonTimeReportExportMutationHookResult = ReturnType<typeof useExportButtonTimeReportExportMutation>;
export type ExportButtonTimeReportExportMutationResult = Apollo.MutationResult<ExportButtonTimeReportExportMutation>;
export type ExportButtonTimeReportExportMutationOptions = Apollo.BaseMutationOptions<ExportButtonTimeReportExportMutation, ExportButtonTimeReportExportMutationVariables>;
export const GenericTimeProjectDocument = gql`
    query GenericTime_Project($id: ID!, $filters: TimeReportFiltersInput, $startDate: DateType!, $endDate: DateType!, $userId: ID) {
  project(id: $id) {
    id
    name
    genericTimeReport(
      startDate: $startDate
      endDate: $endDate
      filters: $filters
      userId: $userId
    ) {
      ...TimeReportColumns_TimeReport
    }
  }
}
    ${TimeReportColumnsTimeReportFragmentDoc}`;

/**
 * __useGenericTimeProjectQuery__
 *
 * To run a query within a React component, call `useGenericTimeProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenericTimeProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenericTimeProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *      filters: // value for 'filters'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGenericTimeProjectQuery(baseOptions: Apollo.QueryHookOptions<GenericTimeProjectQuery, GenericTimeProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenericTimeProjectQuery, GenericTimeProjectQueryVariables>(GenericTimeProjectDocument, options);
      }
export function useGenericTimeProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenericTimeProjectQuery, GenericTimeProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenericTimeProjectQuery, GenericTimeProjectQueryVariables>(GenericTimeProjectDocument, options);
        }
export type GenericTimeProjectQueryHookResult = ReturnType<typeof useGenericTimeProjectQuery>;
export type GenericTimeProjectLazyQueryHookResult = ReturnType<typeof useGenericTimeProjectLazyQuery>;
export type GenericTimeProjectQueryResult = Apollo.QueryResult<GenericTimeProjectQuery, GenericTimeProjectQueryVariables>;
export const MilestoneDetailsProjectDocument = gql`
    query MilestoneDetails_Project($id: ID!, $listInput: ListInput!, $filters: TimeReportFiltersInput, $startDate: DateType!, $endDate: DateType!, $taskResponsibilities: [TaskResponsibilityEnumType!]) {
  project(id: $id) {
    id
    paginatedMilestones(
      listInputs: $listInput
      filters: $filters
      startDate: $startDate
      endDate: $endDate
    ) {
      milestones {
        id
        ...MilestoneAccordion_Milestone
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
}
    ${MilestoneAccordionMilestoneFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useMilestoneDetailsProjectQuery__
 *
 * To run a query within a React component, call `useMilestoneDetailsProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useMilestoneDetailsProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMilestoneDetailsProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *      listInput: // value for 'listInput'
 *      filters: // value for 'filters'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      taskResponsibilities: // value for 'taskResponsibilities'
 *   },
 * });
 */
export function useMilestoneDetailsProjectQuery(baseOptions: Apollo.QueryHookOptions<MilestoneDetailsProjectQuery, MilestoneDetailsProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MilestoneDetailsProjectQuery, MilestoneDetailsProjectQueryVariables>(MilestoneDetailsProjectDocument, options);
      }
export function useMilestoneDetailsProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MilestoneDetailsProjectQuery, MilestoneDetailsProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MilestoneDetailsProjectQuery, MilestoneDetailsProjectQueryVariables>(MilestoneDetailsProjectDocument, options);
        }
export type MilestoneDetailsProjectQueryHookResult = ReturnType<typeof useMilestoneDetailsProjectQuery>;
export type MilestoneDetailsProjectLazyQueryHookResult = ReturnType<typeof useMilestoneDetailsProjectLazyQuery>;
export type MilestoneDetailsProjectQueryResult = Apollo.QueryResult<MilestoneDetailsProjectQuery, MilestoneDetailsProjectQueryVariables>;
export const MilestoneAccordionMilestoneDocument = gql`
    query MilestoneAccordion_Milestone($id: ID!, $listInput: ListInput!, $filters: TimeReportFiltersInput, $userId: ID, $startDate: DateType!, $endDate: DateType!, $includeTimeRecords: Boolean!) {
  milestone(id: $id) {
    id
    paginatedTasks(
      listInputs: $listInput
      filters: $filters
      startDate: $startDate
      endDate: $endDate
    ) {
      tasks {
        ...MilestoneAccordion_Task
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
}
    ${MilestoneAccordionTaskFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useMilestoneAccordionMilestoneQuery__
 *
 * To run a query within a React component, call `useMilestoneAccordionMilestoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useMilestoneAccordionMilestoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMilestoneAccordionMilestoneQuery({
 *   variables: {
 *      id: // value for 'id'
 *      listInput: // value for 'listInput'
 *      filters: // value for 'filters'
 *      userId: // value for 'userId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      includeTimeRecords: // value for 'includeTimeRecords'
 *   },
 * });
 */
export function useMilestoneAccordionMilestoneQuery(baseOptions: Apollo.QueryHookOptions<MilestoneAccordionMilestoneQuery, MilestoneAccordionMilestoneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MilestoneAccordionMilestoneQuery, MilestoneAccordionMilestoneQueryVariables>(MilestoneAccordionMilestoneDocument, options);
      }
export function useMilestoneAccordionMilestoneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MilestoneAccordionMilestoneQuery, MilestoneAccordionMilestoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MilestoneAccordionMilestoneQuery, MilestoneAccordionMilestoneQueryVariables>(MilestoneAccordionMilestoneDocument, options);
        }
export type MilestoneAccordionMilestoneQueryHookResult = ReturnType<typeof useMilestoneAccordionMilestoneQuery>;
export type MilestoneAccordionMilestoneLazyQueryHookResult = ReturnType<typeof useMilestoneAccordionMilestoneLazyQuery>;
export type MilestoneAccordionMilestoneQueryResult = Apollo.QueryResult<MilestoneAccordionMilestoneQuery, MilestoneAccordionMilestoneQueryVariables>;
export const ProjectScopedTableProjectsConnectionsDocument = gql`
    query ProjectScopedTable_ProjectsConnections($listInput: ListInput!, $filters: TimeReportFiltersInput!, $projectFilters: ProjectFilters, $startDate: DateType!, $endDate: DateType!, $userId: ID, $isRootView: Boolean!, $includeGeneric: Boolean!, $includeTimeRecords: Boolean!) {
  projectsConnections(
    listInputs: $listInput
    projectFilters: $projectFilters
    userId: $userId
    filters: $filters
  ) {
    pageInfo {
      ...PageInfoFragment
    }
    projects {
      id
      ...ProjectAccordion_Project
    }
  }
}
    ${PageInfoFragmentDoc}
${ProjectAccordionProjectFragmentDoc}`;

/**
 * __useProjectScopedTableProjectsConnectionsQuery__
 *
 * To run a query within a React component, call `useProjectScopedTableProjectsConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectScopedTableProjectsConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectScopedTableProjectsConnectionsQuery({
 *   variables: {
 *      listInput: // value for 'listInput'
 *      filters: // value for 'filters'
 *      projectFilters: // value for 'projectFilters'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      userId: // value for 'userId'
 *      isRootView: // value for 'isRootView'
 *      includeGeneric: // value for 'includeGeneric'
 *      includeTimeRecords: // value for 'includeTimeRecords'
 *   },
 * });
 */
export function useProjectScopedTableProjectsConnectionsQuery(baseOptions: Apollo.QueryHookOptions<ProjectScopedTableProjectsConnectionsQuery, ProjectScopedTableProjectsConnectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectScopedTableProjectsConnectionsQuery, ProjectScopedTableProjectsConnectionsQueryVariables>(ProjectScopedTableProjectsConnectionsDocument, options);
      }
export function useProjectScopedTableProjectsConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectScopedTableProjectsConnectionsQuery, ProjectScopedTableProjectsConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectScopedTableProjectsConnectionsQuery, ProjectScopedTableProjectsConnectionsQueryVariables>(ProjectScopedTableProjectsConnectionsDocument, options);
        }
export type ProjectScopedTableProjectsConnectionsQueryHookResult = ReturnType<typeof useProjectScopedTableProjectsConnectionsQuery>;
export type ProjectScopedTableProjectsConnectionsLazyQueryHookResult = ReturnType<typeof useProjectScopedTableProjectsConnectionsLazyQuery>;
export type ProjectScopedTableProjectsConnectionsQueryResult = Apollo.QueryResult<ProjectScopedTableProjectsConnectionsQuery, ProjectScopedTableProjectsConnectionsQueryVariables>;
export const TaskDetailsUserTasksDocument = gql`
    query TaskDetails_UserTasks($userId: ID, $projectId: ID, $listInput: ListInput, $filters: TimeReportFiltersInput, $startDate: DateType!, $endDate: DateType!, $includeTimeRecords: Boolean!) {
  userProjectTaskReportingList(
    userId: $userId
    projectId: $projectId
    listInputs: $listInput
    filters: $filters
    startDate: $startDate
    endDate: $endDate
  ) {
    pageInfo {
      ...PageInfoFragment
    }
    tasks {
      id
      ...TaskDetail_Task
    }
  }
}
    ${PageInfoFragmentDoc}
${TaskDetailTaskFragmentDoc}`;

/**
 * __useTaskDetailsUserTasksQuery__
 *
 * To run a query within a React component, call `useTaskDetailsUserTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskDetailsUserTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskDetailsUserTasksQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      projectId: // value for 'projectId'
 *      listInput: // value for 'listInput'
 *      filters: // value for 'filters'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      includeTimeRecords: // value for 'includeTimeRecords'
 *   },
 * });
 */
export function useTaskDetailsUserTasksQuery(baseOptions: Apollo.QueryHookOptions<TaskDetailsUserTasksQuery, TaskDetailsUserTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskDetailsUserTasksQuery, TaskDetailsUserTasksQueryVariables>(TaskDetailsUserTasksDocument, options);
      }
export function useTaskDetailsUserTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskDetailsUserTasksQuery, TaskDetailsUserTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskDetailsUserTasksQuery, TaskDetailsUserTasksQueryVariables>(TaskDetailsUserTasksDocument, options);
        }
export type TaskDetailsUserTasksQueryHookResult = ReturnType<typeof useTaskDetailsUserTasksQuery>;
export type TaskDetailsUserTasksLazyQueryHookResult = ReturnType<typeof useTaskDetailsUserTasksLazyQuery>;
export type TaskDetailsUserTasksQueryResult = Apollo.QueryResult<TaskDetailsUserTasksQuery, TaskDetailsUserTasksQueryVariables>;
export const TimeEntryDialogTaskDocument = gql`
    query TimeEntryDialog_Task($input: ID!) {
  task(id: $input) {
    id
    ...TimeEntryDialog_TaskType
  }
}
    ${TimeEntryDialogTaskTypeFragmentDoc}`;

/**
 * __useTimeEntryDialogTaskQuery__
 *
 * To run a query within a React component, call `useTimeEntryDialogTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeEntryDialogTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeEntryDialogTaskQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTimeEntryDialogTaskQuery(baseOptions: Apollo.QueryHookOptions<TimeEntryDialogTaskQuery, TimeEntryDialogTaskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeEntryDialogTaskQuery, TimeEntryDialogTaskQueryVariables>(TimeEntryDialogTaskDocument, options);
      }
export function useTimeEntryDialogTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeEntryDialogTaskQuery, TimeEntryDialogTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeEntryDialogTaskQuery, TimeEntryDialogTaskQueryVariables>(TimeEntryDialogTaskDocument, options);
        }
export type TimeEntryDialogTaskQueryHookResult = ReturnType<typeof useTimeEntryDialogTaskQuery>;
export type TimeEntryDialogTaskLazyQueryHookResult = ReturnType<typeof useTimeEntryDialogTaskLazyQuery>;
export type TimeEntryDialogTaskQueryResult = Apollo.QueryResult<TimeEntryDialogTaskQuery, TimeEntryDialogTaskQueryVariables>;
export const TimeEntryDialogProjectDocument = gql`
    query TimeEntryDialog_Project($input: ID!) {
  project(id: $input) {
    id
    ...TimeEntryDialog_ProjectType
  }
}
    ${TimeEntryDialogProjectTypeFragmentDoc}`;

/**
 * __useTimeEntryDialogProjectQuery__
 *
 * To run a query within a React component, call `useTimeEntryDialogProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeEntryDialogProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeEntryDialogProjectQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTimeEntryDialogProjectQuery(baseOptions: Apollo.QueryHookOptions<TimeEntryDialogProjectQuery, TimeEntryDialogProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeEntryDialogProjectQuery, TimeEntryDialogProjectQueryVariables>(TimeEntryDialogProjectDocument, options);
      }
export function useTimeEntryDialogProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeEntryDialogProjectQuery, TimeEntryDialogProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeEntryDialogProjectQuery, TimeEntryDialogProjectQueryVariables>(TimeEntryDialogProjectDocument, options);
        }
export type TimeEntryDialogProjectQueryHookResult = ReturnType<typeof useTimeEntryDialogProjectQuery>;
export type TimeEntryDialogProjectLazyQueryHookResult = ReturnType<typeof useTimeEntryDialogProjectLazyQuery>;
export type TimeEntryDialogProjectQueryResult = Apollo.QueryResult<TimeEntryDialogProjectQuery, TimeEntryDialogProjectQueryVariables>;
export const AutoFillButtonTaskUpdatedDocument = gql`
    subscription AutoFillButton_TaskUpdated($taskId: ID!) {
  taskUpdated(taskId: $taskId) {
    id
    ...AutoFillButton_TaskType
  }
}
    ${AutoFillButtonTaskTypeFragmentDoc}`;

/**
 * __useAutoFillButtonTaskUpdatedSubscription__
 *
 * To run a query within a React component, call `useAutoFillButtonTaskUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAutoFillButtonTaskUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutoFillButtonTaskUpdatedSubscription({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useAutoFillButtonTaskUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<AutoFillButtonTaskUpdatedSubscription, AutoFillButtonTaskUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AutoFillButtonTaskUpdatedSubscription, AutoFillButtonTaskUpdatedSubscriptionVariables>(AutoFillButtonTaskUpdatedDocument, options);
      }
export type AutoFillButtonTaskUpdatedSubscriptionHookResult = ReturnType<typeof useAutoFillButtonTaskUpdatedSubscription>;
export type AutoFillButtonTaskUpdatedSubscriptionResult = Apollo.SubscriptionResult<AutoFillButtonTaskUpdatedSubscription>;
export const UserSelectorDefaultUserDocument = gql`
    query UserSelector_DefaultUser($userId: ID!) {
  user(id: $userId) {
    id
    ...AssigneeField_User
  }
}
    ${AssigneeFieldUserFragmentDoc}`;

/**
 * __useUserSelectorDefaultUserQuery__
 *
 * To run a query within a React component, call `useUserSelectorDefaultUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSelectorDefaultUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSelectorDefaultUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserSelectorDefaultUserQuery(baseOptions: Apollo.QueryHookOptions<UserSelectorDefaultUserQuery, UserSelectorDefaultUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSelectorDefaultUserQuery, UserSelectorDefaultUserQueryVariables>(UserSelectorDefaultUserDocument, options);
      }
export function useUserSelectorDefaultUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSelectorDefaultUserQuery, UserSelectorDefaultUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSelectorDefaultUserQuery, UserSelectorDefaultUserQueryVariables>(UserSelectorDefaultUserDocument, options);
        }
export type UserSelectorDefaultUserQueryHookResult = ReturnType<typeof useUserSelectorDefaultUserQuery>;
export type UserSelectorDefaultUserLazyQueryHookResult = ReturnType<typeof useUserSelectorDefaultUserLazyQuery>;
export type UserSelectorDefaultUserQueryResult = Apollo.QueryResult<UserSelectorDefaultUserQuery, UserSelectorDefaultUserQueryVariables>;
export const UserSelectorPaginatedPotentialTimeAssigneeDocument = gql`
    query UserSelector_PaginatedPotentialTimeAssignee($projectId: ID, $milestoneId: ID, $excludeIds: [ID!], $listInput: ListInput, $responsibility: TaskResponsibilityEnumType) {
  paginatedPotentialTaskAssignees(
    projectId: $projectId
    milestoneId: $milestoneId
    excludeIds: $excludeIds
    listInputs: $listInput
    responsibility: $responsibility
  ) {
    users {
      id
      ...AssigneeField_User
    }
    pageInfo {
      ...PageInfoFragment
      __typename
    }
  }
}
    ${AssigneeFieldUserFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useUserSelectorPaginatedPotentialTimeAssigneeQuery__
 *
 * To run a query within a React component, call `useUserSelectorPaginatedPotentialTimeAssigneeQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSelectorPaginatedPotentialTimeAssigneeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSelectorPaginatedPotentialTimeAssigneeQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      milestoneId: // value for 'milestoneId'
 *      excludeIds: // value for 'excludeIds'
 *      listInput: // value for 'listInput'
 *      responsibility: // value for 'responsibility'
 *   },
 * });
 */
export function useUserSelectorPaginatedPotentialTimeAssigneeQuery(baseOptions?: Apollo.QueryHookOptions<UserSelectorPaginatedPotentialTimeAssigneeQuery, UserSelectorPaginatedPotentialTimeAssigneeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSelectorPaginatedPotentialTimeAssigneeQuery, UserSelectorPaginatedPotentialTimeAssigneeQueryVariables>(UserSelectorPaginatedPotentialTimeAssigneeDocument, options);
      }
export function useUserSelectorPaginatedPotentialTimeAssigneeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSelectorPaginatedPotentialTimeAssigneeQuery, UserSelectorPaginatedPotentialTimeAssigneeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSelectorPaginatedPotentialTimeAssigneeQuery, UserSelectorPaginatedPotentialTimeAssigneeQueryVariables>(UserSelectorPaginatedPotentialTimeAssigneeDocument, options);
        }
export type UserSelectorPaginatedPotentialTimeAssigneeQueryHookResult = ReturnType<typeof useUserSelectorPaginatedPotentialTimeAssigneeQuery>;
export type UserSelectorPaginatedPotentialTimeAssigneeLazyQueryHookResult = ReturnType<typeof useUserSelectorPaginatedPotentialTimeAssigneeLazyQuery>;
export type UserSelectorPaginatedPotentialTimeAssigneeQueryResult = Apollo.QueryResult<UserSelectorPaginatedPotentialTimeAssigneeQuery, UserSelectorPaginatedPotentialTimeAssigneeQueryVariables>;
export const TimesheetFormTimeEntrySummaryDocument = gql`
    query TimesheetForm_TimeEntrySummary($listInput: ListInput!, $userId: ID!, $startDate: DateType, $endDate: DateType, $projectId: ID, $filters: TimeEntryFiltersInput) {
  timeEntrySummary(
    userId: $userId
    startDate: $startDate
    endDate: $endDate
    projectId: $projectId
    filters: $filters
    listInputs: $listInput
  ) {
    totalBillableHours
    totalEstimatedHours
    totalNonBillableHours
    totalHours
    totalsLoggedPerTask {
      taskId
      hours
    }
    totals {
      dateWorked
      hours
      billable
    }
  }
}
    `;

/**
 * __useTimesheetFormTimeEntrySummaryQuery__
 *
 * To run a query within a React component, call `useTimesheetFormTimeEntrySummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimesheetFormTimeEntrySummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimesheetFormTimeEntrySummaryQuery({
 *   variables: {
 *      listInput: // value for 'listInput'
 *      userId: // value for 'userId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      projectId: // value for 'projectId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useTimesheetFormTimeEntrySummaryQuery(baseOptions: Apollo.QueryHookOptions<TimesheetFormTimeEntrySummaryQuery, TimesheetFormTimeEntrySummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimesheetFormTimeEntrySummaryQuery, TimesheetFormTimeEntrySummaryQueryVariables>(TimesheetFormTimeEntrySummaryDocument, options);
      }
export function useTimesheetFormTimeEntrySummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimesheetFormTimeEntrySummaryQuery, TimesheetFormTimeEntrySummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimesheetFormTimeEntrySummaryQuery, TimesheetFormTimeEntrySummaryQueryVariables>(TimesheetFormTimeEntrySummaryDocument, options);
        }
export type TimesheetFormTimeEntrySummaryQueryHookResult = ReturnType<typeof useTimesheetFormTimeEntrySummaryQuery>;
export type TimesheetFormTimeEntrySummaryLazyQueryHookResult = ReturnType<typeof useTimesheetFormTimeEntrySummaryLazyQuery>;
export type TimesheetFormTimeEntrySummaryQueryResult = Apollo.QueryResult<TimesheetFormTimeEntrySummaryQuery, TimesheetFormTimeEntrySummaryQueryVariables>;
export const TimesheetFormProjectReportingListDocument = gql`
    query TimesheetForm_ProjectReportingList($listInput: ListInput!, $filters: TimeReportFiltersInput!, $startDate: DateType!, $endDate: DateType!, $userId: ID, $projectId: ID, $isRootView: Boolean!, $includeGeneric: Boolean!, $includeTimeRecords: Boolean!) {
  projectReportingList(
    listInputs: $listInput
    projectId: $projectId
    userId: $userId
    filters: $filters
  ) {
    pageInfo {
      ...PageInfoFragment
    }
    projects {
      id
      ...ProjectAccordion_Project
    }
  }
}
    ${PageInfoFragmentDoc}
${ProjectAccordionProjectFragmentDoc}`;

/**
 * __useTimesheetFormProjectReportingListQuery__
 *
 * To run a query within a React component, call `useTimesheetFormProjectReportingListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimesheetFormProjectReportingListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimesheetFormProjectReportingListQuery({
 *   variables: {
 *      listInput: // value for 'listInput'
 *      filters: // value for 'filters'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      userId: // value for 'userId'
 *      projectId: // value for 'projectId'
 *      isRootView: // value for 'isRootView'
 *      includeGeneric: // value for 'includeGeneric'
 *      includeTimeRecords: // value for 'includeTimeRecords'
 *   },
 * });
 */
export function useTimesheetFormProjectReportingListQuery(baseOptions: Apollo.QueryHookOptions<TimesheetFormProjectReportingListQuery, TimesheetFormProjectReportingListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimesheetFormProjectReportingListQuery, TimesheetFormProjectReportingListQueryVariables>(TimesheetFormProjectReportingListDocument, options);
      }
export function useTimesheetFormProjectReportingListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimesheetFormProjectReportingListQuery, TimesheetFormProjectReportingListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimesheetFormProjectReportingListQuery, TimesheetFormProjectReportingListQueryVariables>(TimesheetFormProjectReportingListDocument, options);
        }
export type TimesheetFormProjectReportingListQueryHookResult = ReturnType<typeof useTimesheetFormProjectReportingListQuery>;
export type TimesheetFormProjectReportingListLazyQueryHookResult = ReturnType<typeof useTimesheetFormProjectReportingListLazyQuery>;
export type TimesheetFormProjectReportingListQueryResult = Apollo.QueryResult<TimesheetFormProjectReportingListQuery, TimesheetFormProjectReportingListQueryVariables>;
export const TimesheetHeaderPotentialTimeRecordUsersDocument = gql`
    query TimesheetHeader_PotentialTimeRecordUsers {
  potentialTimeRecordUsers {
    id
    firstName
    lastName
    jobRole
    projectContext
    role
    avatar {
      originalUrl
    }
    displayOrganization {
      name
    }
    organization {
      id
      name
    }
  }
}
    `;

/**
 * __useTimesheetHeaderPotentialTimeRecordUsersQuery__
 *
 * To run a query within a React component, call `useTimesheetHeaderPotentialTimeRecordUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimesheetHeaderPotentialTimeRecordUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimesheetHeaderPotentialTimeRecordUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useTimesheetHeaderPotentialTimeRecordUsersQuery(baseOptions?: Apollo.QueryHookOptions<TimesheetHeaderPotentialTimeRecordUsersQuery, TimesheetHeaderPotentialTimeRecordUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimesheetHeaderPotentialTimeRecordUsersQuery, TimesheetHeaderPotentialTimeRecordUsersQueryVariables>(TimesheetHeaderPotentialTimeRecordUsersDocument, options);
      }
export function useTimesheetHeaderPotentialTimeRecordUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimesheetHeaderPotentialTimeRecordUsersQuery, TimesheetHeaderPotentialTimeRecordUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimesheetHeaderPotentialTimeRecordUsersQuery, TimesheetHeaderPotentialTimeRecordUsersQueryVariables>(TimesheetHeaderPotentialTimeRecordUsersDocument, options);
        }
export type TimesheetHeaderPotentialTimeRecordUsersQueryHookResult = ReturnType<typeof useTimesheetHeaderPotentialTimeRecordUsersQuery>;
export type TimesheetHeaderPotentialTimeRecordUsersLazyQueryHookResult = ReturnType<typeof useTimesheetHeaderPotentialTimeRecordUsersLazyQuery>;
export type TimesheetHeaderPotentialTimeRecordUsersQueryResult = Apollo.QueryResult<TimesheetHeaderPotentialTimeRecordUsersQuery, TimesheetHeaderPotentialTimeRecordUsersQueryVariables>;
export const TimesheetHeaderProjectsConnectionsDocument = gql`
    query TimesheetHeader_ProjectsConnections($listInputs: ListInput, $userId: ID) {
  projectsConnections(userId: $userId, listInputs: $listInputs) {
    projects {
      id
      name
    }
  }
}
    `;

/**
 * __useTimesheetHeaderProjectsConnectionsQuery__
 *
 * To run a query within a React component, call `useTimesheetHeaderProjectsConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimesheetHeaderProjectsConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimesheetHeaderProjectsConnectionsQuery({
 *   variables: {
 *      listInputs: // value for 'listInputs'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useTimesheetHeaderProjectsConnectionsQuery(baseOptions?: Apollo.QueryHookOptions<TimesheetHeaderProjectsConnectionsQuery, TimesheetHeaderProjectsConnectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimesheetHeaderProjectsConnectionsQuery, TimesheetHeaderProjectsConnectionsQueryVariables>(TimesheetHeaderProjectsConnectionsDocument, options);
      }
export function useTimesheetHeaderProjectsConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimesheetHeaderProjectsConnectionsQuery, TimesheetHeaderProjectsConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimesheetHeaderProjectsConnectionsQuery, TimesheetHeaderProjectsConnectionsQueryVariables>(TimesheetHeaderProjectsConnectionsDocument, options);
        }
export type TimesheetHeaderProjectsConnectionsQueryHookResult = ReturnType<typeof useTimesheetHeaderProjectsConnectionsQuery>;
export type TimesheetHeaderProjectsConnectionsLazyQueryHookResult = ReturnType<typeof useTimesheetHeaderProjectsConnectionsLazyQuery>;
export type TimesheetHeaderProjectsConnectionsQueryResult = Apollo.QueryResult<TimesheetHeaderProjectsConnectionsQuery, TimesheetHeaderProjectsConnectionsQueryVariables>;
export const UserAccordionUserProjectReportingListDocument = gql`
    query UserAccordion_UserProjectReportingList($userId: ID, $listInput: ListInput, $filters: TimeReportFiltersInput, $startDate: DateType!, $endDate: DateType!, $isRootView: Boolean!, $includeGeneric: Boolean!, $includeTimeRecords: Boolean!) {
  userProjectReportingList(
    userId: $userId
    listInputs: $listInput
    filters: $filters
    startDate: $startDate
    endDate: $endDate
  ) {
    pageInfo {
      ...PageInfoFragment
    }
    projects {
      id
      ...ProjectAccordion_Project
    }
  }
}
    ${PageInfoFragmentDoc}
${ProjectAccordionProjectFragmentDoc}`;

/**
 * __useUserAccordionUserProjectReportingListQuery__
 *
 * To run a query within a React component, call `useUserAccordionUserProjectReportingListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAccordionUserProjectReportingListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAccordionUserProjectReportingListQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      listInput: // value for 'listInput'
 *      filters: // value for 'filters'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      isRootView: // value for 'isRootView'
 *      includeGeneric: // value for 'includeGeneric'
 *      includeTimeRecords: // value for 'includeTimeRecords'
 *   },
 * });
 */
export function useUserAccordionUserProjectReportingListQuery(baseOptions: Apollo.QueryHookOptions<UserAccordionUserProjectReportingListQuery, UserAccordionUserProjectReportingListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserAccordionUserProjectReportingListQuery, UserAccordionUserProjectReportingListQueryVariables>(UserAccordionUserProjectReportingListDocument, options);
      }
export function useUserAccordionUserProjectReportingListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserAccordionUserProjectReportingListQuery, UserAccordionUserProjectReportingListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserAccordionUserProjectReportingListQuery, UserAccordionUserProjectReportingListQueryVariables>(UserAccordionUserProjectReportingListDocument, options);
        }
export type UserAccordionUserProjectReportingListQueryHookResult = ReturnType<typeof useUserAccordionUserProjectReportingListQuery>;
export type UserAccordionUserProjectReportingListLazyQueryHookResult = ReturnType<typeof useUserAccordionUserProjectReportingListLazyQuery>;
export type UserAccordionUserProjectReportingListQueryResult = Apollo.QueryResult<UserAccordionUserProjectReportingListQuery, UserAccordionUserProjectReportingListQueryVariables>;
export const UserScopedTableUserReportingListDocument = gql`
    query UserScopedTable_UserReportingList($listInput: ListInput!, $filters: TimeReportFiltersInput!, $startDate: DateType!, $endDate: DateType!, $includeGeneric: Boolean!) {
  userReportingList(
    listInputs: $listInput
    filters: $filters
    startDate: $startDate
    endDate: $endDate
  ) {
    pageInfo {
      ...PageInfoFragment
    }
    users {
      id
      ...UserAccordion_User
    }
  }
}
    ${PageInfoFragmentDoc}
${UserAccordionUserFragmentDoc}`;

/**
 * __useUserScopedTableUserReportingListQuery__
 *
 * To run a query within a React component, call `useUserScopedTableUserReportingListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserScopedTableUserReportingListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserScopedTableUserReportingListQuery({
 *   variables: {
 *      listInput: // value for 'listInput'
 *      filters: // value for 'filters'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      includeGeneric: // value for 'includeGeneric'
 *   },
 * });
 */
export function useUserScopedTableUserReportingListQuery(baseOptions: Apollo.QueryHookOptions<UserScopedTableUserReportingListQuery, UserScopedTableUserReportingListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserScopedTableUserReportingListQuery, UserScopedTableUserReportingListQueryVariables>(UserScopedTableUserReportingListDocument, options);
      }
export function useUserScopedTableUserReportingListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserScopedTableUserReportingListQuery, UserScopedTableUserReportingListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserScopedTableUserReportingListQuery, UserScopedTableUserReportingListQueryVariables>(UserScopedTableUserReportingListDocument, options);
        }
export type UserScopedTableUserReportingListQueryHookResult = ReturnType<typeof useUserScopedTableUserReportingListQuery>;
export type UserScopedTableUserReportingListLazyQueryHookResult = ReturnType<typeof useUserScopedTableUserReportingListLazyQuery>;
export type UserScopedTableUserReportingListQueryResult = Apollo.QueryResult<UserScopedTableUserReportingListQuery, UserScopedTableUserReportingListQueryVariables>;
export const FileRowUpdateFileDocument = gql`
    mutation FileRow_UpdateFile($updateFileInput: UpdateFileInput!) {
  updateFile(input: $updateFileInput) {
    file {
      id
      ...FileRow_File
    }
  }
}
    ${FileRowFileFragmentDoc}`;
export type FileRowUpdateFileMutationFn = Apollo.MutationFunction<FileRowUpdateFileMutation, FileRowUpdateFileMutationVariables>;

/**
 * __useFileRowUpdateFileMutation__
 *
 * To run a mutation, you first call `useFileRowUpdateFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFileRowUpdateFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fileRowUpdateFileMutation, { data, loading, error }] = useFileRowUpdateFileMutation({
 *   variables: {
 *      updateFileInput: // value for 'updateFileInput'
 *   },
 * });
 */
export function useFileRowUpdateFileMutation(baseOptions?: Apollo.MutationHookOptions<FileRowUpdateFileMutation, FileRowUpdateFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FileRowUpdateFileMutation, FileRowUpdateFileMutationVariables>(FileRowUpdateFileDocument, options);
      }
export type FileRowUpdateFileMutationHookResult = ReturnType<typeof useFileRowUpdateFileMutation>;
export type FileRowUpdateFileMutationResult = Apollo.MutationResult<FileRowUpdateFileMutation>;
export type FileRowUpdateFileMutationOptions = Apollo.BaseMutationOptions<FileRowUpdateFileMutation, FileRowUpdateFileMutationVariables>;
export const MultipleFileListDeleteFileMutationDocument = gql`
    mutation MultipleFileList_DeleteFileMutation($deleteFileInput: DeleteFileFromObjectInput!) {
  deleteFileFromObject(input: $deleteFileInput) {
    files {
      id
      ...MultipleFileList_File
    }
  }
}
    ${MultipleFileListFileFragmentDoc}`;
export type MultipleFileListDeleteFileMutationMutationFn = Apollo.MutationFunction<MultipleFileListDeleteFileMutation, MultipleFileListDeleteFileMutationVariables>;

/**
 * __useMultipleFileListDeleteFileMutation__
 *
 * To run a mutation, you first call `useMultipleFileListDeleteFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMultipleFileListDeleteFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [multipleFileListDeleteFileMutation, { data, loading, error }] = useMultipleFileListDeleteFileMutation({
 *   variables: {
 *      deleteFileInput: // value for 'deleteFileInput'
 *   },
 * });
 */
export function useMultipleFileListDeleteFileMutation(baseOptions?: Apollo.MutationHookOptions<MultipleFileListDeleteFileMutation, MultipleFileListDeleteFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MultipleFileListDeleteFileMutation, MultipleFileListDeleteFileMutationVariables>(MultipleFileListDeleteFileMutationDocument, options);
      }
export type MultipleFileListDeleteFileMutationHookResult = ReturnType<typeof useMultipleFileListDeleteFileMutation>;
export type MultipleFileListDeleteFileMutationMutationResult = Apollo.MutationResult<MultipleFileListDeleteFileMutation>;
export type MultipleFileListDeleteFileMutationMutationOptions = Apollo.BaseMutationOptions<MultipleFileListDeleteFileMutation, MultipleFileListDeleteFileMutationVariables>;
export const ReactFormMultipleFileUploaderRemoveFileToS3Document = gql`
    mutation ReactFormMultipleFileUploader_RemoveFileToS3($fileKey: deleteFileS3Input!) {
  deleteFileS3(input: $fileKey) {
    success
  }
}
    `;
export type ReactFormMultipleFileUploaderRemoveFileToS3MutationFn = Apollo.MutationFunction<ReactFormMultipleFileUploaderRemoveFileToS3Mutation, ReactFormMultipleFileUploaderRemoveFileToS3MutationVariables>;

/**
 * __useReactFormMultipleFileUploaderRemoveFileToS3Mutation__
 *
 * To run a mutation, you first call `useReactFormMultipleFileUploaderRemoveFileToS3Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactFormMultipleFileUploaderRemoveFileToS3Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactFormMultipleFileUploaderRemoveFileToS3Mutation, { data, loading, error }] = useReactFormMultipleFileUploaderRemoveFileToS3Mutation({
 *   variables: {
 *      fileKey: // value for 'fileKey'
 *   },
 * });
 */
export function useReactFormMultipleFileUploaderRemoveFileToS3Mutation(baseOptions?: Apollo.MutationHookOptions<ReactFormMultipleFileUploaderRemoveFileToS3Mutation, ReactFormMultipleFileUploaderRemoveFileToS3MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReactFormMultipleFileUploaderRemoveFileToS3Mutation, ReactFormMultipleFileUploaderRemoveFileToS3MutationVariables>(ReactFormMultipleFileUploaderRemoveFileToS3Document, options);
      }
export type ReactFormMultipleFileUploaderRemoveFileToS3MutationHookResult = ReturnType<typeof useReactFormMultipleFileUploaderRemoveFileToS3Mutation>;
export type ReactFormMultipleFileUploaderRemoveFileToS3MutationResult = Apollo.MutationResult<ReactFormMultipleFileUploaderRemoveFileToS3Mutation>;
export type ReactFormMultipleFileUploaderRemoveFileToS3MutationOptions = Apollo.BaseMutationOptions<ReactFormMultipleFileUploaderRemoveFileToS3Mutation, ReactFormMultipleFileUploaderRemoveFileToS3MutationVariables>;
export const CurrentUserContextOrganizationUpdatedDocument = gql`
    subscription CurrentUserContext_OrganizationUpdated($organizationId: ID!) {
  organizationUpdated(organizationId: $organizationId) {
    id
    currencyCode
    countryCode
  }
}
    `;

/**
 * __useCurrentUserContextOrganizationUpdatedSubscription__
 *
 * To run a query within a React component, call `useCurrentUserContextOrganizationUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserContextOrganizationUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserContextOrganizationUpdatedSubscription({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useCurrentUserContextOrganizationUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<CurrentUserContextOrganizationUpdatedSubscription, CurrentUserContextOrganizationUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CurrentUserContextOrganizationUpdatedSubscription, CurrentUserContextOrganizationUpdatedSubscriptionVariables>(CurrentUserContextOrganizationUpdatedDocument, options);
      }
export type CurrentUserContextOrganizationUpdatedSubscriptionHookResult = ReturnType<typeof useCurrentUserContextOrganizationUpdatedSubscription>;
export type CurrentUserContextOrganizationUpdatedSubscriptionResult = Apollo.SubscriptionResult<CurrentUserContextOrganizationUpdatedSubscription>;
export const CurrentUserContextCurrentUserDocument = gql`
    query CurrentUserContext_CurrentUser {
  currentUser {
    id
    ...CurrentUser
  }
}
    ${CurrentUserFragmentDoc}`;

/**
 * __useCurrentUserContextCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserContextCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserContextCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserContextCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserContextCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserContextCurrentUserQuery, CurrentUserContextCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserContextCurrentUserQuery, CurrentUserContextCurrentUserQueryVariables>(CurrentUserContextCurrentUserDocument, options);
      }
export function useCurrentUserContextCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserContextCurrentUserQuery, CurrentUserContextCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserContextCurrentUserQuery, CurrentUserContextCurrentUserQueryVariables>(CurrentUserContextCurrentUserDocument, options);
        }
export type CurrentUserContextCurrentUserQueryHookResult = ReturnType<typeof useCurrentUserContextCurrentUserQuery>;
export type CurrentUserContextCurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserContextCurrentUserLazyQuery>;
export type CurrentUserContextCurrentUserQueryResult = Apollo.QueryResult<CurrentUserContextCurrentUserQuery, CurrentUserContextCurrentUserQueryVariables>;
export const DependencyConflictContextTaskDependenciesConflictDocument = gql`
    query DependencyConflictContext_TaskDependenciesConflict($id: ID!, $destinationId: ID!) {
  taskDependenciesConflict(id: $id, destinationId: $destinationId)
}
    `;

/**
 * __useDependencyConflictContextTaskDependenciesConflictQuery__
 *
 * To run a query within a React component, call `useDependencyConflictContextTaskDependenciesConflictQuery` and pass it any options that fit your needs.
 * When your component renders, `useDependencyConflictContextTaskDependenciesConflictQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDependencyConflictContextTaskDependenciesConflictQuery({
 *   variables: {
 *      id: // value for 'id'
 *      destinationId: // value for 'destinationId'
 *   },
 * });
 */
export function useDependencyConflictContextTaskDependenciesConflictQuery(baseOptions: Apollo.QueryHookOptions<DependencyConflictContextTaskDependenciesConflictQuery, DependencyConflictContextTaskDependenciesConflictQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DependencyConflictContextTaskDependenciesConflictQuery, DependencyConflictContextTaskDependenciesConflictQueryVariables>(DependencyConflictContextTaskDependenciesConflictDocument, options);
      }
export function useDependencyConflictContextTaskDependenciesConflictLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DependencyConflictContextTaskDependenciesConflictQuery, DependencyConflictContextTaskDependenciesConflictQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DependencyConflictContextTaskDependenciesConflictQuery, DependencyConflictContextTaskDependenciesConflictQueryVariables>(DependencyConflictContextTaskDependenciesConflictDocument, options);
        }
export type DependencyConflictContextTaskDependenciesConflictQueryHookResult = ReturnType<typeof useDependencyConflictContextTaskDependenciesConflictQuery>;
export type DependencyConflictContextTaskDependenciesConflictLazyQueryHookResult = ReturnType<typeof useDependencyConflictContextTaskDependenciesConflictLazyQuery>;
export type DependencyConflictContextTaskDependenciesConflictQueryResult = Apollo.QueryResult<DependencyConflictContextTaskDependenciesConflictQuery, DependencyConflictContextTaskDependenciesConflictQueryVariables>;
export const MaxAttachmentSizeProviderTaskDocument = gql`
    query MaxAttachmentSizeProvider_Task($id: ID!) {
  task(id: $id) {
    id
    template {
      organization {
        adminSettings {
          uploadLimitMb
        }
      }
    }
    __typename
  }
}
    `;

/**
 * __useMaxAttachmentSizeProviderTaskQuery__
 *
 * To run a query within a React component, call `useMaxAttachmentSizeProviderTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaxAttachmentSizeProviderTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaxAttachmentSizeProviderTaskQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMaxAttachmentSizeProviderTaskQuery(baseOptions: Apollo.QueryHookOptions<MaxAttachmentSizeProviderTaskQuery, MaxAttachmentSizeProviderTaskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MaxAttachmentSizeProviderTaskQuery, MaxAttachmentSizeProviderTaskQueryVariables>(MaxAttachmentSizeProviderTaskDocument, options);
      }
export function useMaxAttachmentSizeProviderTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MaxAttachmentSizeProviderTaskQuery, MaxAttachmentSizeProviderTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MaxAttachmentSizeProviderTaskQuery, MaxAttachmentSizeProviderTaskQueryVariables>(MaxAttachmentSizeProviderTaskDocument, options);
        }
export type MaxAttachmentSizeProviderTaskQueryHookResult = ReturnType<typeof useMaxAttachmentSizeProviderTaskQuery>;
export type MaxAttachmentSizeProviderTaskLazyQueryHookResult = ReturnType<typeof useMaxAttachmentSizeProviderTaskLazyQuery>;
export type MaxAttachmentSizeProviderTaskQueryResult = Apollo.QueryResult<MaxAttachmentSizeProviderTaskQuery, MaxAttachmentSizeProviderTaskQueryVariables>;
export const MaxAttachmentSizeProviderTemplateDocument = gql`
    query MaxAttachmentSizeProvider_Template($templateId: ID!) {
  blueprintTemplate(id: $templateId) {
    id
    organization {
      adminSettings {
        uploadLimitMb
      }
    }
    __typename
  }
}
    `;

/**
 * __useMaxAttachmentSizeProviderTemplateQuery__
 *
 * To run a query within a React component, call `useMaxAttachmentSizeProviderTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaxAttachmentSizeProviderTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaxAttachmentSizeProviderTemplateQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useMaxAttachmentSizeProviderTemplateQuery(baseOptions: Apollo.QueryHookOptions<MaxAttachmentSizeProviderTemplateQuery, MaxAttachmentSizeProviderTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MaxAttachmentSizeProviderTemplateQuery, MaxAttachmentSizeProviderTemplateQueryVariables>(MaxAttachmentSizeProviderTemplateDocument, options);
      }
export function useMaxAttachmentSizeProviderTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MaxAttachmentSizeProviderTemplateQuery, MaxAttachmentSizeProviderTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MaxAttachmentSizeProviderTemplateQuery, MaxAttachmentSizeProviderTemplateQueryVariables>(MaxAttachmentSizeProviderTemplateDocument, options);
        }
export type MaxAttachmentSizeProviderTemplateQueryHookResult = ReturnType<typeof useMaxAttachmentSizeProviderTemplateQuery>;
export type MaxAttachmentSizeProviderTemplateLazyQueryHookResult = ReturnType<typeof useMaxAttachmentSizeProviderTemplateLazyQuery>;
export type MaxAttachmentSizeProviderTemplateQueryResult = Apollo.QueryResult<MaxAttachmentSizeProviderTemplateQuery, MaxAttachmentSizeProviderTemplateQueryVariables>;
export const MaxAttachmentSizeProviderProjectDocument = gql`
    query MaxAttachmentSizeProvider_Project($projectId: ID!) {
  project(id: $projectId) {
    id
    organization {
      adminSettings {
        uploadLimitMb
      }
    }
    __typename
  }
}
    `;

/**
 * __useMaxAttachmentSizeProviderProjectQuery__
 *
 * To run a query within a React component, call `useMaxAttachmentSizeProviderProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaxAttachmentSizeProviderProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaxAttachmentSizeProviderProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useMaxAttachmentSizeProviderProjectQuery(baseOptions: Apollo.QueryHookOptions<MaxAttachmentSizeProviderProjectQuery, MaxAttachmentSizeProviderProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MaxAttachmentSizeProviderProjectQuery, MaxAttachmentSizeProviderProjectQueryVariables>(MaxAttachmentSizeProviderProjectDocument, options);
      }
export function useMaxAttachmentSizeProviderProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MaxAttachmentSizeProviderProjectQuery, MaxAttachmentSizeProviderProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MaxAttachmentSizeProviderProjectQuery, MaxAttachmentSizeProviderProjectQueryVariables>(MaxAttachmentSizeProviderProjectDocument, options);
        }
export type MaxAttachmentSizeProviderProjectQueryHookResult = ReturnType<typeof useMaxAttachmentSizeProviderProjectQuery>;
export type MaxAttachmentSizeProviderProjectLazyQueryHookResult = ReturnType<typeof useMaxAttachmentSizeProviderProjectLazyQuery>;
export type MaxAttachmentSizeProviderProjectQueryResult = Apollo.QueryResult<MaxAttachmentSizeProviderProjectQuery, MaxAttachmentSizeProviderProjectQueryVariables>;
export const PaginatedTaskFilterContextFilterAssetsDocument = gql`
    query PaginatedTaskFilterContext_FilterAssets($listInput: ListInput, $ids: [ID!]) {
  paginatedCurrentUserTags(type: "Task", listInputs: $listInput, ids: $ids) {
    tags {
      id
      name
      color
    }
    pageInfo {
      ...PageInfoFragment
      __typename
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __usePaginatedTaskFilterContextFilterAssetsQuery__
 *
 * To run a query within a React component, call `usePaginatedTaskFilterContextFilterAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedTaskFilterContextFilterAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedTaskFilterContextFilterAssetsQuery({
 *   variables: {
 *      listInput: // value for 'listInput'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function usePaginatedTaskFilterContextFilterAssetsQuery(baseOptions?: Apollo.QueryHookOptions<PaginatedTaskFilterContextFilterAssetsQuery, PaginatedTaskFilterContextFilterAssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaginatedTaskFilterContextFilterAssetsQuery, PaginatedTaskFilterContextFilterAssetsQueryVariables>(PaginatedTaskFilterContextFilterAssetsDocument, options);
      }
export function usePaginatedTaskFilterContextFilterAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedTaskFilterContextFilterAssetsQuery, PaginatedTaskFilterContextFilterAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaginatedTaskFilterContextFilterAssetsQuery, PaginatedTaskFilterContextFilterAssetsQueryVariables>(PaginatedTaskFilterContextFilterAssetsDocument, options);
        }
export type PaginatedTaskFilterContextFilterAssetsQueryHookResult = ReturnType<typeof usePaginatedTaskFilterContextFilterAssetsQuery>;
export type PaginatedTaskFilterContextFilterAssetsLazyQueryHookResult = ReturnType<typeof usePaginatedTaskFilterContextFilterAssetsLazyQuery>;
export type PaginatedTaskFilterContextFilterAssetsQueryResult = Apollo.QueryResult<PaginatedTaskFilterContextFilterAssetsQuery, PaginatedTaskFilterContextFilterAssetsQueryVariables>;
export const TaskFilterContextFilterProjectsDocument = gql`
    query TaskFilterContext_FilterProjects {
  projectsConnections(listInputs: {paginated: false}) {
    projects {
      id
      name
    }
  }
}
    `;

/**
 * __useTaskFilterContextFilterProjectsQuery__
 *
 * To run a query within a React component, call `useTaskFilterContextFilterProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskFilterContextFilterProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskFilterContextFilterProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTaskFilterContextFilterProjectsQuery(baseOptions?: Apollo.QueryHookOptions<TaskFilterContextFilterProjectsQuery, TaskFilterContextFilterProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskFilterContextFilterProjectsQuery, TaskFilterContextFilterProjectsQueryVariables>(TaskFilterContextFilterProjectsDocument, options);
      }
export function useTaskFilterContextFilterProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskFilterContextFilterProjectsQuery, TaskFilterContextFilterProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskFilterContextFilterProjectsQuery, TaskFilterContextFilterProjectsQueryVariables>(TaskFilterContextFilterProjectsDocument, options);
        }
export type TaskFilterContextFilterProjectsQueryHookResult = ReturnType<typeof useTaskFilterContextFilterProjectsQuery>;
export type TaskFilterContextFilterProjectsLazyQueryHookResult = ReturnType<typeof useTaskFilterContextFilterProjectsLazyQuery>;
export type TaskFilterContextFilterProjectsQueryResult = Apollo.QueryResult<TaskFilterContextFilterProjectsQuery, TaskFilterContextFilterProjectsQueryVariables>;
export const CustomerTaskFilterContextFilterProjectsDocument = gql`
    query CustomerTaskFilterContext_FilterProjects {
  projectsConnections(
    listInputs: {paginated: false}
    projectFilters: {context: CUSTOMER}
  ) {
    projects {
      id
      name
    }
  }
}
    `;

/**
 * __useCustomerTaskFilterContextFilterProjectsQuery__
 *
 * To run a query within a React component, call `useCustomerTaskFilterContextFilterProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerTaskFilterContextFilterProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerTaskFilterContextFilterProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerTaskFilterContextFilterProjectsQuery(baseOptions?: Apollo.QueryHookOptions<CustomerTaskFilterContextFilterProjectsQuery, CustomerTaskFilterContextFilterProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerTaskFilterContextFilterProjectsQuery, CustomerTaskFilterContextFilterProjectsQueryVariables>(CustomerTaskFilterContextFilterProjectsDocument, options);
      }
export function useCustomerTaskFilterContextFilterProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerTaskFilterContextFilterProjectsQuery, CustomerTaskFilterContextFilterProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerTaskFilterContextFilterProjectsQuery, CustomerTaskFilterContextFilterProjectsQueryVariables>(CustomerTaskFilterContextFilterProjectsDocument, options);
        }
export type CustomerTaskFilterContextFilterProjectsQueryHookResult = ReturnType<typeof useCustomerTaskFilterContextFilterProjectsQuery>;
export type CustomerTaskFilterContextFilterProjectsLazyQueryHookResult = ReturnType<typeof useCustomerTaskFilterContextFilterProjectsLazyQuery>;
export type CustomerTaskFilterContextFilterProjectsQueryResult = Apollo.QueryResult<CustomerTaskFilterContextFilterProjectsQuery, CustomerTaskFilterContextFilterProjectsQueryVariables>;
export const TaskFilterContextDefaultFilterDocument = gql`
    query TaskFilterContext_DefaultFilter {
  userDefaultFilterView(category: "task") {
    id
    jsonFilterBlob
  }
}
    `;

/**
 * __useTaskFilterContextDefaultFilterQuery__
 *
 * To run a query within a React component, call `useTaskFilterContextDefaultFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskFilterContextDefaultFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskFilterContextDefaultFilterQuery({
 *   variables: {
 *   },
 * });
 */
export function useTaskFilterContextDefaultFilterQuery(baseOptions?: Apollo.QueryHookOptions<TaskFilterContextDefaultFilterQuery, TaskFilterContextDefaultFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskFilterContextDefaultFilterQuery, TaskFilterContextDefaultFilterQueryVariables>(TaskFilterContextDefaultFilterDocument, options);
      }
export function useTaskFilterContextDefaultFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskFilterContextDefaultFilterQuery, TaskFilterContextDefaultFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskFilterContextDefaultFilterQuery, TaskFilterContextDefaultFilterQueryVariables>(TaskFilterContextDefaultFilterDocument, options);
        }
export type TaskFilterContextDefaultFilterQueryHookResult = ReturnType<typeof useTaskFilterContextDefaultFilterQuery>;
export type TaskFilterContextDefaultFilterLazyQueryHookResult = ReturnType<typeof useTaskFilterContextDefaultFilterLazyQuery>;
export type TaskFilterContextDefaultFilterQueryResult = Apollo.QueryResult<TaskFilterContextDefaultFilterQuery, TaskFilterContextDefaultFilterQueryVariables>;
export const EditTemplatesProjectTemplatesDocument = gql`
    query EditTemplates_ProjectTemplates($projectId: ID!) {
  project(id: $projectId) {
    id
    templates {
      id
    }
    __typename
  }
}
    `;

/**
 * __useEditTemplatesProjectTemplatesQuery__
 *
 * To run a query within a React component, call `useEditTemplatesProjectTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditTemplatesProjectTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditTemplatesProjectTemplatesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useEditTemplatesProjectTemplatesQuery(baseOptions: Apollo.QueryHookOptions<EditTemplatesProjectTemplatesQuery, EditTemplatesProjectTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditTemplatesProjectTemplatesQuery, EditTemplatesProjectTemplatesQueryVariables>(EditTemplatesProjectTemplatesDocument, options);
      }
export function useEditTemplatesProjectTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditTemplatesProjectTemplatesQuery, EditTemplatesProjectTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditTemplatesProjectTemplatesQuery, EditTemplatesProjectTemplatesQueryVariables>(EditTemplatesProjectTemplatesDocument, options);
        }
export type EditTemplatesProjectTemplatesQueryHookResult = ReturnType<typeof useEditTemplatesProjectTemplatesQuery>;
export type EditTemplatesProjectTemplatesLazyQueryHookResult = ReturnType<typeof useEditTemplatesProjectTemplatesLazyQuery>;
export type EditTemplatesProjectTemplatesQueryResult = Apollo.QueryResult<EditTemplatesProjectTemplatesQuery, EditTemplatesProjectTemplatesQueryVariables>;
export const UseResourcesUsersResourcesUsersDocument = gql`
    query useResourcesUsers_ResourcesUsers($listInputs: ResourcesListInput, $resourceFilters: ResourceFilters) {
  resourcesUsers(listInputs: $listInputs, resourceFilters: $resourceFilters) {
    pageInfo {
      ...PageInfoFragment
      __typename
    }
    users {
      id
      ...ResourceUser
    }
  }
}
    ${PageInfoFragmentDoc}
${ResourceUserFragmentDoc}`;

/**
 * __useUseResourcesUsersResourcesUsersQuery__
 *
 * To run a query within a React component, call `useUseResourcesUsersResourcesUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseResourcesUsersResourcesUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseResourcesUsersResourcesUsersQuery({
 *   variables: {
 *      listInputs: // value for 'listInputs'
 *      resourceFilters: // value for 'resourceFilters'
 *   },
 * });
 */
export function useUseResourcesUsersResourcesUsersQuery(baseOptions?: Apollo.QueryHookOptions<UseResourcesUsersResourcesUsersQuery, UseResourcesUsersResourcesUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseResourcesUsersResourcesUsersQuery, UseResourcesUsersResourcesUsersQueryVariables>(UseResourcesUsersResourcesUsersDocument, options);
      }
export function useUseResourcesUsersResourcesUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseResourcesUsersResourcesUsersQuery, UseResourcesUsersResourcesUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseResourcesUsersResourcesUsersQuery, UseResourcesUsersResourcesUsersQueryVariables>(UseResourcesUsersResourcesUsersDocument, options);
        }
export type UseResourcesUsersResourcesUsersQueryHookResult = ReturnType<typeof useUseResourcesUsersResourcesUsersQuery>;
export type UseResourcesUsersResourcesUsersLazyQueryHookResult = ReturnType<typeof useUseResourcesUsersResourcesUsersLazyQuery>;
export type UseResourcesUsersResourcesUsersQueryResult = Apollo.QueryResult<UseResourcesUsersResourcesUsersQuery, UseResourcesUsersResourcesUsersQueryVariables>;
export const ProjectListProjectListDocument = gql`
    query ProjectList_ProjectList($listInputs: ListInput, $filters: TimeReportFiltersInput!, $userId: ID, $projectId: ID) {
  projectReportingList(
    userId: $userId
    listInputs: $listInputs
    projectId: $projectId
    filters: $filters
  ) {
    pageInfo {
      ...PageInfoFragment
      __typename
    }
    projects {
      id
      name
      customerV2 {
        id
        logo {
          originalUrl
          __typename
        }
        __typename
      }
      __typename
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useProjectListProjectListQuery__
 *
 * To run a query within a React component, call `useProjectListProjectListQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectListProjectListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectListProjectListQuery({
 *   variables: {
 *      listInputs: // value for 'listInputs'
 *      filters: // value for 'filters'
 *      userId: // value for 'userId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectListProjectListQuery(baseOptions: Apollo.QueryHookOptions<ProjectListProjectListQuery, ProjectListProjectListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectListProjectListQuery, ProjectListProjectListQueryVariables>(ProjectListProjectListDocument, options);
      }
export function useProjectListProjectListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectListProjectListQuery, ProjectListProjectListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectListProjectListQuery, ProjectListProjectListQueryVariables>(ProjectListProjectListDocument, options);
        }
export type ProjectListProjectListQueryHookResult = ReturnType<typeof useProjectListProjectListQuery>;
export type ProjectListProjectListLazyQueryHookResult = ReturnType<typeof useProjectListProjectListLazyQuery>;
export type ProjectListProjectListQueryResult = Apollo.QueryResult<ProjectListProjectListQuery, ProjectListProjectListQueryVariables>;
export const TimeEntryDialogCreateTimeRecordDocument = gql`
    mutation TimeEntryDialog_CreateTimeRecord($input: createTimeRecordInput!) {
  createTimeRecord(input: $input) {
    timeRecord {
      id
      ...TimeEntryTable_TimeRecord
    }
  }
}
    ${TimeEntryTableTimeRecordFragmentDoc}`;
export type TimeEntryDialogCreateTimeRecordMutationFn = Apollo.MutationFunction<TimeEntryDialogCreateTimeRecordMutation, TimeEntryDialogCreateTimeRecordMutationVariables>;

/**
 * __useTimeEntryDialogCreateTimeRecordMutation__
 *
 * To run a mutation, you first call `useTimeEntryDialogCreateTimeRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTimeEntryDialogCreateTimeRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [timeEntryDialogCreateTimeRecordMutation, { data, loading, error }] = useTimeEntryDialogCreateTimeRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTimeEntryDialogCreateTimeRecordMutation(baseOptions?: Apollo.MutationHookOptions<TimeEntryDialogCreateTimeRecordMutation, TimeEntryDialogCreateTimeRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TimeEntryDialogCreateTimeRecordMutation, TimeEntryDialogCreateTimeRecordMutationVariables>(TimeEntryDialogCreateTimeRecordDocument, options);
      }
export type TimeEntryDialogCreateTimeRecordMutationHookResult = ReturnType<typeof useTimeEntryDialogCreateTimeRecordMutation>;
export type TimeEntryDialogCreateTimeRecordMutationResult = Apollo.MutationResult<TimeEntryDialogCreateTimeRecordMutation>;
export type TimeEntryDialogCreateTimeRecordMutationOptions = Apollo.BaseMutationOptions<TimeEntryDialogCreateTimeRecordMutation, TimeEntryDialogCreateTimeRecordMutationVariables>;
export const TimeEntryDialogUpdateTimeRecordDocument = gql`
    mutation TimeEntryDialog_UpdateTimeRecord($input: updateTimeRecordInput!) {
  updateTimeRecord(input: $input) {
    timeRecord {
      id
      ...TimeEntryTable_TimeRecord
    }
  }
}
    ${TimeEntryTableTimeRecordFragmentDoc}`;
export type TimeEntryDialogUpdateTimeRecordMutationFn = Apollo.MutationFunction<TimeEntryDialogUpdateTimeRecordMutation, TimeEntryDialogUpdateTimeRecordMutationVariables>;

/**
 * __useTimeEntryDialogUpdateTimeRecordMutation__
 *
 * To run a mutation, you first call `useTimeEntryDialogUpdateTimeRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTimeEntryDialogUpdateTimeRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [timeEntryDialogUpdateTimeRecordMutation, { data, loading, error }] = useTimeEntryDialogUpdateTimeRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTimeEntryDialogUpdateTimeRecordMutation(baseOptions?: Apollo.MutationHookOptions<TimeEntryDialogUpdateTimeRecordMutation, TimeEntryDialogUpdateTimeRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TimeEntryDialogUpdateTimeRecordMutation, TimeEntryDialogUpdateTimeRecordMutationVariables>(TimeEntryDialogUpdateTimeRecordDocument, options);
      }
export type TimeEntryDialogUpdateTimeRecordMutationHookResult = ReturnType<typeof useTimeEntryDialogUpdateTimeRecordMutation>;
export type TimeEntryDialogUpdateTimeRecordMutationResult = Apollo.MutationResult<TimeEntryDialogUpdateTimeRecordMutation>;
export type TimeEntryDialogUpdateTimeRecordMutationOptions = Apollo.BaseMutationOptions<TimeEntryDialogUpdateTimeRecordMutation, TimeEntryDialogUpdateTimeRecordMutationVariables>;
export const TimeEntryDialogUpdateNodeStatusDocument = gql`
    mutation TimeEntryDialog_UpdateNodeStatus($id: ID!, $status: StatusEnumType!, $objectType: StatusObjectEnumType!) {
  updateObjectStatus(input: {id: $id, status: $status, objectType: $objectType}) {
    resolveObject {
      ... on TaskType {
        id
        status
        completed
        completedAt
        project {
          id
          startOn
          endOn
          completedAt
          forecastedEndOn
          stats {
            totalTasks
            totalDoneTasks
            totalAssignedTasks
            totalTasksWithUnestimatedHoursCount
            totalActualHours
            totalInternalEstimatedHours
          }
          profitabilitySummary {
            forecastedCost
            budgetedCost
          }
        }
      }
    }
  }
}
    `;
export type TimeEntryDialogUpdateNodeStatusMutationFn = Apollo.MutationFunction<TimeEntryDialogUpdateNodeStatusMutation, TimeEntryDialogUpdateNodeStatusMutationVariables>;

/**
 * __useTimeEntryDialogUpdateNodeStatusMutation__
 *
 * To run a mutation, you first call `useTimeEntryDialogUpdateNodeStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTimeEntryDialogUpdateNodeStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [timeEntryDialogUpdateNodeStatusMutation, { data, loading, error }] = useTimeEntryDialogUpdateNodeStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      objectType: // value for 'objectType'
 *   },
 * });
 */
export function useTimeEntryDialogUpdateNodeStatusMutation(baseOptions?: Apollo.MutationHookOptions<TimeEntryDialogUpdateNodeStatusMutation, TimeEntryDialogUpdateNodeStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TimeEntryDialogUpdateNodeStatusMutation, TimeEntryDialogUpdateNodeStatusMutationVariables>(TimeEntryDialogUpdateNodeStatusDocument, options);
      }
export type TimeEntryDialogUpdateNodeStatusMutationHookResult = ReturnType<typeof useTimeEntryDialogUpdateNodeStatusMutation>;
export type TimeEntryDialogUpdateNodeStatusMutationResult = Apollo.MutationResult<TimeEntryDialogUpdateNodeStatusMutation>;
export type TimeEntryDialogUpdateNodeStatusMutationOptions = Apollo.BaseMutationOptions<TimeEntryDialogUpdateNodeStatusMutation, TimeEntryDialogUpdateNodeStatusMutationVariables>;
export const UseFileUploaderRemoveFileToS3Document = gql`
    mutation UseFileUploader_RemoveFileToS3($fileKey: deleteFileS3Input!) {
  deleteFileS3(input: $fileKey) {
    success
  }
}
    `;
export type UseFileUploaderRemoveFileToS3MutationFn = Apollo.MutationFunction<UseFileUploaderRemoveFileToS3Mutation, UseFileUploaderRemoveFileToS3MutationVariables>;

/**
 * __useUseFileUploaderRemoveFileToS3Mutation__
 *
 * To run a mutation, you first call `useUseFileUploaderRemoveFileToS3Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseFileUploaderRemoveFileToS3Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useFileUploaderRemoveFileToS3Mutation, { data, loading, error }] = useUseFileUploaderRemoveFileToS3Mutation({
 *   variables: {
 *      fileKey: // value for 'fileKey'
 *   },
 * });
 */
export function useUseFileUploaderRemoveFileToS3Mutation(baseOptions?: Apollo.MutationHookOptions<UseFileUploaderRemoveFileToS3Mutation, UseFileUploaderRemoveFileToS3MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UseFileUploaderRemoveFileToS3Mutation, UseFileUploaderRemoveFileToS3MutationVariables>(UseFileUploaderRemoveFileToS3Document, options);
      }
export type UseFileUploaderRemoveFileToS3MutationHookResult = ReturnType<typeof useUseFileUploaderRemoveFileToS3Mutation>;
export type UseFileUploaderRemoveFileToS3MutationResult = Apollo.MutationResult<UseFileUploaderRemoveFileToS3Mutation>;
export type UseFileUploaderRemoveFileToS3MutationOptions = Apollo.BaseMutationOptions<UseFileUploaderRemoveFileToS3Mutation, UseFileUploaderRemoveFileToS3MutationVariables>;
export const UseNoteAttachmentsDeleteFileDocument = gql`
    mutation UseNoteAttachments_DeleteFile($id: ID!) {
  deleteNoteAttachment(id: $id) {
    note {
      id
      attachments {
        id
        fileName
        url
        internalOnly
      }
    }
  }
}
    `;
export type UseNoteAttachmentsDeleteFileMutationFn = Apollo.MutationFunction<UseNoteAttachmentsDeleteFileMutation, UseNoteAttachmentsDeleteFileMutationVariables>;

/**
 * __useUseNoteAttachmentsDeleteFileMutation__
 *
 * To run a mutation, you first call `useUseNoteAttachmentsDeleteFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseNoteAttachmentsDeleteFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useNoteAttachmentsDeleteFileMutation, { data, loading, error }] = useUseNoteAttachmentsDeleteFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUseNoteAttachmentsDeleteFileMutation(baseOptions?: Apollo.MutationHookOptions<UseNoteAttachmentsDeleteFileMutation, UseNoteAttachmentsDeleteFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UseNoteAttachmentsDeleteFileMutation, UseNoteAttachmentsDeleteFileMutationVariables>(UseNoteAttachmentsDeleteFileDocument, options);
      }
export type UseNoteAttachmentsDeleteFileMutationHookResult = ReturnType<typeof useUseNoteAttachmentsDeleteFileMutation>;
export type UseNoteAttachmentsDeleteFileMutationResult = Apollo.MutationResult<UseNoteAttachmentsDeleteFileMutation>;
export type UseNoteAttachmentsDeleteFileMutationOptions = Apollo.BaseMutationOptions<UseNoteAttachmentsDeleteFileMutation, UseNoteAttachmentsDeleteFileMutationVariables>;
export const UseMergeTagsMergeTagsDocument = gql`
    query UseMergeTags_MergeTags($projectId: ID, $taggable: MergeTaggable!) {
  mergeTagOptions(projectId: $projectId, taggable: $taggable) {
    id
    name
    slug
    external
  }
}
    `;

/**
 * __useUseMergeTagsMergeTagsQuery__
 *
 * To run a query within a React component, call `useUseMergeTagsMergeTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseMergeTagsMergeTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseMergeTagsMergeTagsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      taggable: // value for 'taggable'
 *   },
 * });
 */
export function useUseMergeTagsMergeTagsQuery(baseOptions: Apollo.QueryHookOptions<UseMergeTagsMergeTagsQuery, UseMergeTagsMergeTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseMergeTagsMergeTagsQuery, UseMergeTagsMergeTagsQueryVariables>(UseMergeTagsMergeTagsDocument, options);
      }
export function useUseMergeTagsMergeTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseMergeTagsMergeTagsQuery, UseMergeTagsMergeTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseMergeTagsMergeTagsQuery, UseMergeTagsMergeTagsQueryVariables>(UseMergeTagsMergeTagsDocument, options);
        }
export type UseMergeTagsMergeTagsQueryHookResult = ReturnType<typeof useUseMergeTagsMergeTagsQuery>;
export type UseMergeTagsMergeTagsLazyQueryHookResult = ReturnType<typeof useUseMergeTagsMergeTagsLazyQuery>;
export type UseMergeTagsMergeTagsQueryResult = Apollo.QueryResult<UseMergeTagsMergeTagsQuery, UseMergeTagsMergeTagsQueryVariables>;
export const UseMergeTagsProjectMergeTagsDocument = gql`
    query UseMergeTags_ProjectMergeTags($projectId: ID!, $taggable: MergeTaggable!, $taggableId: ID, $customizedOnly: Boolean!) {
  mergeTagValues(
    projectId: $projectId
    taggable: $taggable
    taggableId: $taggableId
    customizedOnly: $customizedOnly
  ) {
    id
    value
    mergeTag {
      id
      slug
      name
      external
    }
  }
}
    `;

/**
 * __useUseMergeTagsProjectMergeTagsQuery__
 *
 * To run a query within a React component, call `useUseMergeTagsProjectMergeTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseMergeTagsProjectMergeTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseMergeTagsProjectMergeTagsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      taggable: // value for 'taggable'
 *      taggableId: // value for 'taggableId'
 *      customizedOnly: // value for 'customizedOnly'
 *   },
 * });
 */
export function useUseMergeTagsProjectMergeTagsQuery(baseOptions: Apollo.QueryHookOptions<UseMergeTagsProjectMergeTagsQuery, UseMergeTagsProjectMergeTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseMergeTagsProjectMergeTagsQuery, UseMergeTagsProjectMergeTagsQueryVariables>(UseMergeTagsProjectMergeTagsDocument, options);
      }
export function useUseMergeTagsProjectMergeTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseMergeTagsProjectMergeTagsQuery, UseMergeTagsProjectMergeTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseMergeTagsProjectMergeTagsQuery, UseMergeTagsProjectMergeTagsQueryVariables>(UseMergeTagsProjectMergeTagsDocument, options);
        }
export type UseMergeTagsProjectMergeTagsQueryHookResult = ReturnType<typeof useUseMergeTagsProjectMergeTagsQuery>;
export type UseMergeTagsProjectMergeTagsLazyQueryHookResult = ReturnType<typeof useUseMergeTagsProjectMergeTagsLazyQuery>;
export type UseMergeTagsProjectMergeTagsQueryResult = Apollo.QueryResult<UseMergeTagsProjectMergeTagsQuery, UseMergeTagsProjectMergeTagsQueryVariables>;
export const UseUserProjectsProjectListDocument = gql`
    query useUserProjects_ProjectList($projectFilters: ProjectFilters, $listInputs: ListInput) {
  projectsConnections(projectFilters: $projectFilters, listInputs: $listInputs) {
    pageInfo {
      ...PageInfoFragment
      __typename
    }
    projects {
      id
      ...ProjectReassignProject
    }
  }
}
    ${PageInfoFragmentDoc}
${ProjectReassignProjectFragmentDoc}`;

/**
 * __useUseUserProjectsProjectListQuery__
 *
 * To run a query within a React component, call `useUseUserProjectsProjectListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseUserProjectsProjectListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseUserProjectsProjectListQuery({
 *   variables: {
 *      projectFilters: // value for 'projectFilters'
 *      listInputs: // value for 'listInputs'
 *   },
 * });
 */
export function useUseUserProjectsProjectListQuery(baseOptions?: Apollo.QueryHookOptions<UseUserProjectsProjectListQuery, UseUserProjectsProjectListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseUserProjectsProjectListQuery, UseUserProjectsProjectListQueryVariables>(UseUserProjectsProjectListDocument, options);
      }
export function useUseUserProjectsProjectListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseUserProjectsProjectListQuery, UseUserProjectsProjectListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseUserProjectsProjectListQuery, UseUserProjectsProjectListQueryVariables>(UseUserProjectsProjectListDocument, options);
        }
export type UseUserProjectsProjectListQueryHookResult = ReturnType<typeof useUseUserProjectsProjectListQuery>;
export type UseUserProjectsProjectListLazyQueryHookResult = ReturnType<typeof useUseUserProjectsProjectListLazyQuery>;
export type UseUserProjectsProjectListQueryResult = Apollo.QueryResult<UseUserProjectsProjectListQuery, UseUserProjectsProjectListQueryVariables>;
export const UseUserTasksUserTasksConnectionsDocument = gql`
    query useUserTasks_UserTasksConnections($userId: ID!, $taskFilters: TaskFilters, $listInputs: ListInput) {
  userTasksConnections(
    userId: $userId
    taskFilters: $taskFilters
    listInputs: $listInputs
  ) {
    pageInfo {
      ...PageInfoFragment
      __typename
    }
    tasks {
      id
      ...TaskReassign
    }
  }
}
    ${PageInfoFragmentDoc}
${TaskReassignFragmentDoc}`;

/**
 * __useUseUserTasksUserTasksConnectionsQuery__
 *
 * To run a query within a React component, call `useUseUserTasksUserTasksConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseUserTasksUserTasksConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseUserTasksUserTasksConnectionsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      taskFilters: // value for 'taskFilters'
 *      listInputs: // value for 'listInputs'
 *   },
 * });
 */
export function useUseUserTasksUserTasksConnectionsQuery(baseOptions: Apollo.QueryHookOptions<UseUserTasksUserTasksConnectionsQuery, UseUserTasksUserTasksConnectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseUserTasksUserTasksConnectionsQuery, UseUserTasksUserTasksConnectionsQueryVariables>(UseUserTasksUserTasksConnectionsDocument, options);
      }
export function useUseUserTasksUserTasksConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseUserTasksUserTasksConnectionsQuery, UseUserTasksUserTasksConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseUserTasksUserTasksConnectionsQuery, UseUserTasksUserTasksConnectionsQueryVariables>(UseUserTasksUserTasksConnectionsDocument, options);
        }
export type UseUserTasksUserTasksConnectionsQueryHookResult = ReturnType<typeof useUseUserTasksUserTasksConnectionsQuery>;
export type UseUserTasksUserTasksConnectionsLazyQueryHookResult = ReturnType<typeof useUseUserTasksUserTasksConnectionsLazyQuery>;
export type UseUserTasksUserTasksConnectionsQueryResult = Apollo.QueryResult<UseUserTasksUserTasksConnectionsQuery, UseUserTasksUserTasksConnectionsQueryVariables>;
export const ProjectLayoutProjectDocument = gql`
    query ProjectLayout_Project($projectId: ID!) {
  project(id: $projectId) {
    id
    ...ProjectLayout_Project
  }
  stats(objId: $projectId, objType: PROJECT) {
    ... on ProjectStats {
      id
      totalTasks
      totalDoneTasks
      totalAssignedTasks
    }
  }
}
    ${ProjectLayoutProjectFragmentDoc}`;

/**
 * __useProjectLayoutProjectQuery__
 *
 * To run a query within a React component, call `useProjectLayoutProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectLayoutProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectLayoutProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectLayoutProjectQuery(baseOptions: Apollo.QueryHookOptions<ProjectLayoutProjectQuery, ProjectLayoutProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectLayoutProjectQuery, ProjectLayoutProjectQueryVariables>(ProjectLayoutProjectDocument, options);
      }
export function useProjectLayoutProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectLayoutProjectQuery, ProjectLayoutProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectLayoutProjectQuery, ProjectLayoutProjectQueryVariables>(ProjectLayoutProjectDocument, options);
        }
export type ProjectLayoutProjectQueryHookResult = ReturnType<typeof useProjectLayoutProjectQuery>;
export type ProjectLayoutProjectLazyQueryHookResult = ReturnType<typeof useProjectLayoutProjectLazyQuery>;
export type ProjectLayoutProjectQueryResult = Apollo.QueryResult<ProjectLayoutProjectQuery, ProjectLayoutProjectQueryVariables>;
export const ProjectLayoutUpdateProjectDocument = gql`
    mutation ProjectLayout_UpdateProject($project: updateProjectInput!) {
  updateProject(input: $project) {
    project {
      id
      ...ProjectLayout_Project
    }
  }
}
    ${ProjectLayoutProjectFragmentDoc}`;
export type ProjectLayoutUpdateProjectMutationFn = Apollo.MutationFunction<ProjectLayoutUpdateProjectMutation, ProjectLayoutUpdateProjectMutationVariables>;

/**
 * __useProjectLayoutUpdateProjectMutation__
 *
 * To run a mutation, you first call `useProjectLayoutUpdateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectLayoutUpdateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectLayoutUpdateProjectMutation, { data, loading, error }] = useProjectLayoutUpdateProjectMutation({
 *   variables: {
 *      project: // value for 'project'
 *   },
 * });
 */
export function useProjectLayoutUpdateProjectMutation(baseOptions?: Apollo.MutationHookOptions<ProjectLayoutUpdateProjectMutation, ProjectLayoutUpdateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectLayoutUpdateProjectMutation, ProjectLayoutUpdateProjectMutationVariables>(ProjectLayoutUpdateProjectDocument, options);
      }
export type ProjectLayoutUpdateProjectMutationHookResult = ReturnType<typeof useProjectLayoutUpdateProjectMutation>;
export type ProjectLayoutUpdateProjectMutationResult = Apollo.MutationResult<ProjectLayoutUpdateProjectMutation>;
export type ProjectLayoutUpdateProjectMutationOptions = Apollo.BaseMutationOptions<ProjectLayoutUpdateProjectMutation, ProjectLayoutUpdateProjectMutationVariables>;
export const ProjectUpdatedCsatDocument = gql`
    subscription ProjectUpdatedCSAT($projectId: ID!) {
  projectUpdated(projectId: $projectId) {
    project {
      id
    }
  }
}
    `;

/**
 * __useProjectUpdatedCsatSubscription__
 *
 * To run a query within a React component, call `useProjectUpdatedCsatSubscription` and pass it any options that fit your needs.
 * When your component renders, `useProjectUpdatedCsatSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectUpdatedCsatSubscription({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectUpdatedCsatSubscription(baseOptions: Apollo.SubscriptionHookOptions<ProjectUpdatedCsatSubscription, ProjectUpdatedCsatSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ProjectUpdatedCsatSubscription, ProjectUpdatedCsatSubscriptionVariables>(ProjectUpdatedCsatDocument, options);
      }
export type ProjectUpdatedCsatSubscriptionHookResult = ReturnType<typeof useProjectUpdatedCsatSubscription>;
export type ProjectUpdatedCsatSubscriptionResult = Apollo.SubscriptionResult<ProjectUpdatedCsatSubscription>;
export const TemplateLayoutTemplateUpdatedSubscriptionDocument = gql`
    subscription TemplateLayout_TemplateUpdatedSubscription($templateId: ID!) {
  templateUpdated(templateId: $templateId) {
    template {
      id
      duration
    }
    templateStats {
      id
      ...TemplateOverview_TemplateStats
    }
  }
}
    ${TemplateOverviewTemplateStatsFragmentDoc}`;

/**
 * __useTemplateLayoutTemplateUpdatedSubscription__
 *
 * To run a query within a React component, call `useTemplateLayoutTemplateUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTemplateLayoutTemplateUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateLayoutTemplateUpdatedSubscription({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useTemplateLayoutTemplateUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<TemplateLayoutTemplateUpdatedSubscription, TemplateLayoutTemplateUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<TemplateLayoutTemplateUpdatedSubscription, TemplateLayoutTemplateUpdatedSubscriptionVariables>(TemplateLayoutTemplateUpdatedSubscriptionDocument, options);
      }
export type TemplateLayoutTemplateUpdatedSubscriptionHookResult = ReturnType<typeof useTemplateLayoutTemplateUpdatedSubscription>;
export type TemplateLayoutTemplateUpdatedSubscriptionSubscriptionResult = Apollo.SubscriptionResult<TemplateLayoutTemplateUpdatedSubscription>;
export const TemplateShowLayoutTemplateDocument = gql`
    query TemplateShowLayout_Template($templateId: ID!) {
  blueprintTemplate(id: $templateId) {
    id
    ...TemplateShowLayout_Template
  }
}
    ${TemplateShowLayoutTemplateFragmentDoc}`;

/**
 * __useTemplateShowLayoutTemplateQuery__
 *
 * To run a query within a React component, call `useTemplateShowLayoutTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateShowLayoutTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateShowLayoutTemplateQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useTemplateShowLayoutTemplateQuery(baseOptions: Apollo.QueryHookOptions<TemplateShowLayoutTemplateQuery, TemplateShowLayoutTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplateShowLayoutTemplateQuery, TemplateShowLayoutTemplateQueryVariables>(TemplateShowLayoutTemplateDocument, options);
      }
export function useTemplateShowLayoutTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplateShowLayoutTemplateQuery, TemplateShowLayoutTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplateShowLayoutTemplateQuery, TemplateShowLayoutTemplateQueryVariables>(TemplateShowLayoutTemplateDocument, options);
        }
export type TemplateShowLayoutTemplateQueryHookResult = ReturnType<typeof useTemplateShowLayoutTemplateQuery>;
export type TemplateShowLayoutTemplateLazyQueryHookResult = ReturnType<typeof useTemplateShowLayoutTemplateLazyQuery>;
export type TemplateShowLayoutTemplateQueryResult = Apollo.QueryResult<TemplateShowLayoutTemplateQuery, TemplateShowLayoutTemplateQueryVariables>;